
'use strict';

function getIntervalValue(field) {
    if (!field.value || (!field.value.from && !field.value.to)) return null;
    var result = {};
    if (field.value.from) result.from = field.value.from.id;
    if (field.value.to) result.to = field.value.to.id;
    return result;
}

var app = angular.module('app', [
    // Sentry
    'ngRaven',

    // Angular modules
    'ngRoute',
    'ngAnimate',
    'ngCookies',
    'ngSanitize',

    // Translation
    'pascalprecht.translate',

    // Drag & drop
    'ngDragDrop',

    // Chosen select and multiselect
    'localytics.directives',

    // Google charts
    'googlechart',

    // Color picker
    'colorpicker.module',

    // Spinner
    'angularSpinner',

    // Slider
    'ui.bootstrap-slider',

    // Ladda
    'angular-ladda',

    // Datetime picker
    'angularjs-datetime-picker',

    // 3rd Party Modules
    'ui.bootstrap',
    'ui.calendar',
    'textAngular',
    'ui.utils',
    'ui.sortable',

    // Custom modules
    'gymsystem.routes',
    'gymsystem.directives',
    'flatify.directives',
    'gymsystem.stats',
    'gymsystem.resourcebooking',
    'gymsystem.checkout',
    'gymsystem.live',
    'gymsystem.util',
    'gymsystem.directdebit',
    'gymsystem.banks',
    'gymsystem.tabtable',
    'gymsystem.tabform',
    'gymsystem.customertable',
    'gymsystem.economy',
    'gymsystem.izettle',
    'gymsystem.multisite',
    'gymsystem.rco',
    'gymsystem.courses',
    'gymsystem.importer',
    'gymsystem.teamsportcommon',
    'gymsystem.teamsports',
    'gymsystem.dashboard',

    // QR-code
    'ja.qr'
]);

app.factory('customTranslationLoader', ['$http', '$q', function($http, $q) {
    return function(options) {
        if (window.parent?.top?.sharedData?.translations?.[options.key]) {
            let deferred = $q.defer();
            deferred.resolve(window.parent.top.sharedData.translations[options.key]);
            return deferred.promise;
        }

        return $http.get(`/api/public/translation/get?language=${options.key}`).then(response => {
            return response.data;
        })
    };
}]);

app.config(['$translateProvider', function ($translateProvider) {
    $translateProvider.preferredLanguage('sv');
    $translateProvider.useSanitizeValueStrategy(null);
    $translateProvider.useLoader('customTranslationLoader');
}]);

// Avoid unsafe urls
app.config(['$compileProvider', function($compileProvider) {
    $compileProvider.aHrefSanitizationWhitelist(/^\s*(https?|ftp|mailto|webcal|tel):/);
}]);

app.run(['$http', '$rootScope', '$translate', '$filter', '$location', '$window', '$cookies', '$q', '$modal', '$document', '$timeout', 'workoutProvider', 'confirm', 'removeworkoutdialog', 'server', 'alertProvider', 'formatter', 'live', 'util', 'currency', 'cashiers', 'fileManager', 'pubsub', 'modalUtils', '$modalStack', 'facebook', 'browser', '$injector', '$route', '$routeParams', 'ApiDataLoader',
    function ($http, $rootScope, $translate, $filter, $location, $window, $cookies, $q, $modal, $document, $timeout, workoutProvider, confirm, removeworkoutdialog, server, alertProvider, formatter, live, util, currency, cashiers, fileManager, pubsub, modalUtils, $modalStack, facebook, browser, $injector, $route, $routeParams, ApiDataLoader) {
        pubsub.inject($rootScope);
        $rootScope.isStaffApp = true;
        $rootScope.speedy = localStorage.getItem('zoezi-staff-speedup') == 'true';
        $rootScope.speedyDebug = false;
        $http.defaults.headers.common.Authorization = 'Zoezi 48390b97731921c491c40837076154e4eeb3cd19faab7ad7aa0a359333f9db64';
        $rootScope.ASYNCAPI = '/api/async';
        $rootScope.forceHideMenu = $location.search().hidemenu;

        if ($location.search().alwaysreplace) {
            $location.alwaysReplace = true;
        }

        $rootScope.getData = function(data) {
            return $rootScope[data];
        };

        $rootScope.isApp = function() {
            return window.isApp;
        };

        $rootScope.isFullscreen = function() {
            return !!document.fullscreenElement;
        };

        $rootScope.isMenuHidden = function() {
            return $rootScope.forceHideMenu;
        };

        $rootScope.isStaffnextDashboard = function() {
            let path = $location.path();
            return $rootScope.staffnext && (path.indexOf('/dashboard') === 0 || path.indexOf('/economy/dashboard') === 0);
        };

        $rootScope.getTrialDays = function() {
            return Date.today().daysUntil($rootScope.trialEnds);
        };

        $rootScope.getPath = function() {
            return $location.path();
        };

        $rootScope.getOriginalRoutePath = function() {
            return $route.current.$$route.originalPath;
        };

        $rootScope.getRouteParams = function() {
            return $routeParams;
        };

        $rootScope.showTrialDialog = function(canHide) {
            var options = {
                templateUrl: 'views/trialover.html',
                controller: 'TrialOverCtrl'
            };
            if (!canHide) {
                options.keyboard = false;
                options.backdrop = 'static';
            }
            $modal.open(options);
        };

        $rootScope.getSite = function(site_id) {
            return _.findWhere($rootScope.sites, {id: site_id});
        };

        $rootScope.setSiteOnServer = function(site, options) {
            options = options || {};
            if ($rootScope.hasModule('MultiSite')) {
                server.post('/api/memberapi/setsite', null, {id: site.id});
                var expireDate = new Date();
                expireDate = expireDate.addDays(30);
                expireDate = expireDate.toGMTString();
                document.cookie = 'selectedsite=' + site.id + '; expires=' + expireDate + ';';

                $rootScope.expoPostMessage('site', site.id);

                if (options.notifyParent !== false && $rootScope.penpalParent && $rootScope.penpalParent.setSite) {
                    $rootScope.penpalParent.setSite(site.id);
                }
            }
        };

        $rootScope.setSite = function(site_id) {
            $rootScope.waitFor(['sites']).then(function() {
                var site = $rootScope.getSite(site_id);
                if ($rootScope.selectedSite != site) {
                    $rootScope.selectedSite = site;
                    $rootScope.cashregisters.forEach($rootScope.transformCashier);
                    $rootScope.cachedCashRegister = null;

                    $rootScope.getProducts().forEach(function(card) {
                        card.updateVariants();
                    });
                    $rootScope.pubsub.publish('selectedSite', $rootScope.selectedSite);

                }
            });
        };

        $rootScope.getBackgroundStyle = function() {
            if ($rootScope.customStyling) {
                return {'background-color': $rootScope.backgroundColor, 'color': $rootScope.textColor};
            } else if ($rootScope.main.brand == 'Zoezi') {
                return {'background-color': '#fff', 'color': '#000'};
            }
        };

        $rootScope.getApiDocUrl = function() {
            return document.location.protocol + '//' + document.location.host + '/apidoc/?key=' + $rootScope.currentStaff.apikey;
        };

        $rootScope.getSubDomain = function() {
            return window.location.host.split('.')[0];
        };

        $rootScope.logout = function() {
            $http.post('/api/staff/logout');

            if (window.fcWidget) {
                window.fcWidget.destroy();
            }

            setTimeout(function() {
                live.stop();
                document.cookie = 'session=; expires=Thu, 01 Jan 1970 00:00:01 GMT;';
                $rootScope.whenLoggedOut();
            }, 50);
        };

        $rootScope.isMobile = function() {
            if ($rootScope.cachedIsMobile != undefined) {
                return $rootScope.cachedIsMobile;
            }
            var check = false;
            (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) { check = true;} } )(navigator.userAgent||navigator.vendor||window.opera);
            var isIpad = navigator.userAgent.match(/iPad/i) != null;
            check = check || isIpad;
            $rootScope.cachedIsMobile = check;
            return check;
        };

        $rootScope.isSmallScreen = function() {
            return util.isSmallScreen();
        };

        $rootScope.getMobileOperatingSystem = function() {
            return util.getMobileOperatingSystem();
        };

        $rootScope.getBrowserVersion = function() {
            return browser.version();
        };

        $rootScope.switchToMemberPage = function() {
            if ($rootScope.parentHandlesSwitchToMemberPage) {
                $rootScope.handleSwitchToMemberPage($rootScope.zoeziMyBusiness);
            } else {
                document.location.assign(document.location.protocol + '//' + document.location.host + ($rootScope.zoeziMyBusiness ? '/': '/member'));
            }
        };

        $rootScope.getHost = function() {
            return $location.host();
        };

        $rootScope.fullname = function(person) {
            return person.fullname;
        };

        $rootScope.hasModule = function(module) {
            return $rootScope.startedModules.indexOf(module) != -1;
        };

        $rootScope.hasPermission = function(task) {
            return !task || $rootScope.currentStaffPermissions.indexOf(task) != -1;
        };

        $rootScope.isActiveCategoryForSite = function(category) {
            return category.active && (!$rootScope.hasModule('MultiSite') || ($rootScope.selectedSite && category.sites.indexOf($rootScope.selectedSite.id) != -1));
        };

        $rootScope.getRegisteredTitle = function(workout) {
            var numBooked = _.filter(workout.bookings, function(booking) { return !booking.inQueue; }).length;
            var numQueue = _.filter(workout.bookings, function(booking) { return booking.inQueue; }).length;
            if (!workout.space) {
                return numBooked;
            }

            var result = Math.min(numBooked, workout.space) + ' ' + $filter('translate')('of') + " " + workout.space;
            if (numQueue > 0) {
                result += " (" + numQueue + ' ' + $filter('translate')('in queue') + ")";
            }

            return result;
        };

        $rootScope.getRealFormName = function(name) {
            var i = name.indexOf('$');
            if (i != -1) {
                name = name.substring(0, i);
            }
            return name;
        };

        $rootScope.getDisplayDate = function(date) {
            if (!date) {
                return;
            }

            var weekdays = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
            var day = date.getDay();
            return $filter('translate')(weekdays[day]) + " " + date.yyyymmdd();
        };

        $rootScope.getShortDisplayDate = function(date) {
            if (!date) {
                return;
            }

            var weekdays = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
            var day = date.getDay();
            return $filter('translate')(weekdays[day]) + " " + date.ddSlashmm();
        };

        $rootScope.canAddBooking = function(workout) {
            if ($rootScope.hasPermission('Workout booking') && workout.status != 'Cancelled') {
                if (workout.space && workout.bookings && workout.bookings.length >= workout.space) {
                    return $rootScope.hasModule('Queue');
                }
                return true;
            }
            return false;
        };

        $rootScope.getWorkoutTime = function(workout) {
            return workout.startTime.hhmm() + " - " + workout.endTime.hhmm();
        };

        $rootScope.getWorkoutDate = function(workout) {
            return workout.startTime.yyyymmdd();
        };

        $rootScope.getRBookingTime = function(rb) {
            var start = Array.mergeSort(_.pluck(rb.siblings, 'start'))[0];
            var ends = Array.mergeSort(_.pluck(rb.siblings, 'end'));
            var end = ends[ends.length-1];
            return start.hhmm() + ' - ' + end.hhmm();
        };

        $rootScope.setLanguage = function(language) {
            $http.post('/api/staff/language/set', { language: language });
        };

        $rootScope.getLanguageName = function() {
            var language = $translate.use();
            return $filter('translate')('LANGNAME_' + language);
        };

        $rootScope.getLanguages = function() {
            return ['sv', 'en'];
        };

        $rootScope.getLanguage = function() {
            return $translate.use();
        };

        $rootScope.getEmptyImage = function() {
            return 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==';
        };

        $rootScope.image = function(type, obj, size) {
            if (obj) {
                return fileManager.fileLinkByObject(obj, size, type);
            } else {
                return $rootScope.getEmptyImage();
            }
        };

        $rootScope.groupImage = function(group, size) {
            return $rootScope.image('usergroup', group, size);
        };

        $rootScope.isFacebookImage = function(obj) {
            return (obj.imageurl && obj.imageurl.indexOf('https://graph.facebook.com') == 0);
        };

        $rootScope.memberImage = function(member, size) {
            return $rootScope.image('Member', member, size);
        };

        $rootScope.smallMemberImage = function(member) {
            return $rootScope.memberImage(member, 50);
        };

        $rootScope.staffImage = function(staff, size) {
            return $rootScope.image('Staff', staff, size);
        };

        $rootScope.smallStaffImage = function(staff) {
            return $rootScope.staffImage(staff, 50);
        };

        $rootScope.getCurrentStaffImage = function(size) {
            return $rootScope.staffImage($rootScope.currentStaff, size);
        };

        $rootScope.getCurrentStaffName = function() {
            if ($rootScope.currentStaff) {
                if ($rootScope.currentStaff.realname) {
                    return 'Zoezi support (' + $rootScope.currentStaff.realname.split(' ')[0] + ')';
                }
                return $rootScope.currentStaff.firstname;
            }
        };

        $rootScope.apiDataLoaderGetMember = function(id) {
            // Get a user object immediately (might be a placeholder)
            return ApiDataLoader.getDataImmediately('user', id);
        };

        $rootScope.oldGetMember = (function() {
            var map = {};
            var removed = {};
            var lastLength = 0;
            var maxId = 0;

            live.subscribe({
                type: 'user',
                callback: function() {
                    lastLength = 0;
                }
            });

            return function(id) {
                if(id == null) {return null;}
                if(typeof id === 'string') {
                    id = Number(id);
                }
                if (_.isObject(id) && id.id) {
                    id = id.id;
                }
                if(!(id && typeof id === 'number' && isFinite(id))) {return null;}
                if($rootScope.members.length != lastLength) {
                    map = {};
                    lastLength = $rootScope.members.length;
                    $rootScope.members.forEach(function(m) {
                        map[m.id] = m;
                        if(m.id > maxId) {maxId = m.id;}
                    });
                }
                var user = map[id];
                if(user === undefined && $rootScope.members.length && id <= maxId) {
                    // removed user
                    user = removed[id];
                    if(!user) {
                        if(id == $rootScope.superUserId) {
                            user = {
                                lastname: $filter('translate')('Zoezi support')
                            };
                        } else {
                            user = {
                                lastname: $filter('translate')('Removed'),
                                isMember: true,
                                isRemoved: true
                            };
                        }
                        user.id = id;
                        user.firstname = '';
                        user.name = user.fullname = user.lastname;
                        removed[id] = user;
                    }
                }
                return user;
            };
        })();

        $rootScope.getMember = (id) => {
            if ($rootScope.speedy) {
                return $rootScope.apiDataLoaderGetMember(id)
            } else {
                return $rootScope.oldGetMember(id);
            }
        };
        $rootScope.getStaff = $rootScope.getMember;

        $rootScope.getMembersAsync = function(ids) {
            ids.forEach(id => $rootScope.getMember(id));
            let promises = ids.map(id => ApiDataLoader.getData('user', id));
            return $q.all(promises);
        };

        $rootScope.getGroup = function(id) {
            if ($rootScope.speedy) {
                return ApiDataLoader.getDataImmediately('usergroup', id);
            }

            if (_.isObject(id) && id.id) {
                id = id.id;
            }

            return _.findWhere($rootScope.usergroups, {id: id});
        };

        $rootScope.getGroupAsync = function(id) {
            if ($rootScope.speedy) {
                return ApiDataLoader.getData('usergroup', id);
            } else {
                return $q.when($rootScope.getGroup(id));
            }
        };

        $rootScope.getActiveStaffs = function() {
            return _.where($rootScope.staffs, {active: true, resource: false});
        };

        $rootScope.getActiveResources = function() {
            return _.where($rootScope.staffs, {active: true, resource: true});
        };

        $rootScope.getActiveDoors = function() {
            return _.where($rootScope.staffs, {active: true, resource: true, resourceType: 'door'});
        };

        $rootScope.getActiveDoorsWithExternalDoorId = function() {
            var doors = _.where($rootScope.staffs, {active: true, resource: true}).filter(function(door) { return door.resourceType === 'door' || door.resourceType === 'qrcode_entry'; });
            if ($rootScope.hasModule('MultiSite')) {
                doors = doors.filter(function(door) { return door.sites.indexOf($rootScope.selectedSite.id) !== -1; });
            }
            return doors;
        };

        $rootScope.getActiveDoorsAndQRCodeEntries = function() {
            return _.where($rootScope.staffs, {active: true, resource: true}).filter(function(resource) { return resource.resourceType === 'door' || resource.resourceType === 'qrcode_entry'; });
        };

        $rootScope.loadActiveResourcesForSite = function() {
            return $rootScope.waitFor(['sites']).then(function() {
                return server.get('/api/resource/get', {site_id: $rootScope.selectedSite.id, inactive: false}).then(resources => {
                    resources.forEach(resource => $rootScope.getMember(resource));
                    let promises = resources.map(resource => ApiDataLoader.getData('user', resource.id));
                    return $q.all(promises);
                });
            });
        };

        $rootScope.isUniquePersonalCodeNumber = function(type, x) {
            x = util.normalizePersonalCodeNumber(x);
            return !_.findWhere($rootScope.members, {personalCodeNumber: x});
        };

        $rootScope.formatPersonalCodeNumber = function(x) {
            return formatter.format('personalCodeNumber', x);
        };

        $rootScope.normalizeBankgiroNumber = function(x) {
            if (x) {
                x = String(x);
                return Number(x.replace('-', ''));
            }

            return x;
        };

        $rootScope.formatAmount = function(x) {
            return formatter.format('price', x);
        };

        var getAge = function(date) {
            var ageDifMs = Date.now() - date.getTime();
            var ageDate = new Date(ageDifMs);
            return Math.abs(ageDate.getUTCFullYear() - 1970);
        };

        $rootScope.getAgeFromPersonalCodeNumber = function(item) {
            if (item && item.personalCodeNumber != null && !item.company) {
                return getAge(new Date(item.personalCodeNumber.slice(0,4), Number(item.personalCodeNumber.slice(4,6))-1,item.personalCodeNumber.slice(6,8)));
            }
        };

        $rootScope.getAgeFromPerson = function(person) {
            if(person.company) {return null;}
            if(person.birthdate) {return getAge(Date.newFull(person.birthdate));}
            return $rootScope.getAgeFromPersonalCodeNumber(person);
        };

        $rootScope.getAgeStringFromPerson = function(item) {
            var age = $rootScope.getAgeFromPerson(item);
            if (age) {
                return age + ' ' + $filter('translate')("years");
            }
        };

        $rootScope.getActiveResourceBookingServices = function() {
            return $rootScope.resourcebookingservices.filter(function(service) { return service.active && service.category.active && service.sites.indexOf($rootScope.selectedSite.id) != -1; });
        };

        $rootScope.gotoCustomer = function(customer) {
            if (customer) {
                var customer_id = isNaN(customer) ? customer.id : customer;
                $location.path('/customer/show/' + customer_id);
                modalUtils.closeAllModals();
            }
        };

        $rootScope.gotoStaff = function(staff) {
            if (staff.resource) {
                $location.path('/resource/show/' + staff.id);
            } else {
                $location.path('/staff/show/' + staff.id);
            }
        };

        $rootScope.gotoCheckout = function() {
            $location.path('/checkout');
        };

        $rootScope.gotoPath = function(path) {
            $location.path(path);
        };

        $rootScope.showPayments = function(payments) {
            $modal.open({
                templateUrl: 'views/paymentlist.html',
                controller: 'PaymentListModalCtrl',
                windowClass: 'huge-modal-window',
                resolve: {
                    payments: function() {
                        return payments.map($rootScope.transformPayment);
                    },
                    eventName: function() {
                        return null;
                    },
                    invoice: function() {
                        return null;
                    }
                }
            });
        };

        $rootScope.getProductImage = function(product_id) {
            var product = _.findWhere($rootScope.trainingcardtypes, {id: product_id});
            return product.imagekey;
        };

        $rootScope.showWorkout = function(workout) {
            return $modal.open({
                    templateUrl: 'views/workout.html',
                    controller: 'WorkoutModalCtrl',
                    resolve: {
                        workout: function() {
                            return workout;
                        }
                    }
                });
        };

        $rootScope.showGroup = function(group) {
            return $modal.open({
                templateUrl: 'views/groupmodal.html',
                controller: 'GroupModalCtrl',
                resolve: {
                    group: function() {
                        // Always the full fetch: the batch endpoint returns trainingcards as ids,
                        // and the dialog needs whole card objects to list them.
                        return server.get('/api/usergroup/get', {id: group.id});
                    }
                }
            });
        };

        $rootScope.showMatch = function(match) {
            $modal.open({
                templateUrl: 'views/match.html',
                controller: 'MatchModalCtrl',
                resolve: {
                    match: function() {
                        return match;
                    }
                }
            });
        };

        $rootScope.showRBooking = function(rbooking) {
            return $injector.get('resourceBooking').openById(rbooking.id);
        };

        $rootScope.showModal = function(templateUrl, controller, options, windowClass) {
            return $modal.open({
                templateUrl: templateUrl,
                controller: controller,
                windowClass: windowClass || '',
                resolve: {
                    options: function() {
                        return options;
                    }
                }
            });
        };

        $rootScope.showCombo = function(options) {
            return $modal.open({
                templateUrl: 'views/addcombomodal.html',
                controller: 'ComboAddModalCtrl',
                resolve: {
                    options: function() {
                        return options;
                    }
                }
            });
        };

        // Returns the legacy modal when the combo dialog is used; undefined when
        // the StaffNext dialog or the cashier (both rendered outside this iframe)
        // handles it.
        $rootScope.openTrainingCardSale = function(customer, opts) {
            var canUseCheckout =
                $rootScope.hasFlag?.('flag-staffnext-checkout') &&
                $rootScope.hasModule?.('Checkout') &&
                $rootScope.hasPermission?.('Checkout handling');
            if (canUseCheckout) {
                // The new add-training-card dialog is opt-in behind its own flag.
                // When the flag is off we fall back to the pre-dialog behavior of
                // opening the cashier for the current customer.
                if ($rootScope.hasFlag?.('flag-staffnext-add-trainingcard') && $rootScope.penpalParent?.openAddTrainingCardDialog) {
                    $rootScope.penpalParent.openAddTrainingCardDialog({
                        customer_id: customer.id,
                        membership: !!opts?.membership,
                        // Dates don't survive the penpal bridge reliably — send ISO.
                        validFromDate: opts?.validFromDate?.yyyymmdd() || null
                    });

                    return;
                }

                $location.path('/checkout').search({ customer_id: customer.id });

                return;
            }

            return $rootScope.showCombo({ customer: customer, ...opts });
        };

        $rootScope.downloadElectron = function() {
            $modal.open({
                templateUrl: 'views/downloadelectron.html',
                controller: 'DownloadElectronCtrl',
                windowClass: 'modal-window'
            });
        };

        $rootScope.notBookableByCard = function(options) {
            return $modal.open({
                templateUrl: 'views/notbookablebycard.html',
                controller: 'NotBookableByCardCtrl',
                resolve: {
                    options: function() {
                        return options;
                    }
                }
            });
        };

        $rootScope.about = function() {
            $modal.open({
                templateUrl: 'views/about.html',
                controller: 'ModalCtrl',
                resolve: {
                    options: function() {
                        return {};
                    }
                }
            });
        };

        $rootScope.showHelp = function() {
            var initialSection = null;
            var path = $location.path();
            var checkout = path.indexOf('/checkout') != -1;
            initialSection = checkout ? 'checkout' : 'getstarted';
            $modal.open({
                templateUrl: 'views/documentation.html',
                windowClass: 'huge-modal-window',
                controller: 'DocumentationCtrl',
                resolve: {
                    section: function() {
                        return initialSection;
                    }
                }
            });
        };

        $rootScope.showGetCustomer = function(options) {
            return $modal.open({
                templateUrl: 'views/getcustomermodal.html',
                controller: 'GetCustomerCtrl',
                windowClass: 'huge-modal-window',
                resolve: {
                    options: function() {
                        return options || {};
                    }
                }
            }).result;
        };

        $rootScope.getCustomerForField = function(field) {
            var modalInstance = $modal.open({
                templateUrl: 'views/getcustomermodal.html',
                controller: 'GetCustomerCtrl',
                windowClass: 'huge-modal-window',
                resolve: {
                    options: function() {
                        return _.extend({ itemFilter: field.itemFilter, multiple: false, itemTypes: field.itemTypes }, field.options);
                    }
                }
            });

            modalInstance.result.then(function (customer) {
                field.value = customer;
                if(field.onChange) {
                    field.onChange(customer);
                }
                if (field.change) {
                    field.change();
                }
            });
        };

        $rootScope.getGroupForField = function(field) {
            var modalInstance = $modal.open({
                templateUrl: 'views/getgroup.html',
                controller: 'GetGroupCtrl',
                windowClass: 'huge-modal-window',
                resolve: {
                    options: function() {
                        var searchFilters = field.searchFilters && field.searchFilters();
                        return _.extend({ itemFilter: field.itemFilter, multiple: false, itemTypes: field.itemTypes, searchFilters: searchFilters }, field.options);
                    }
                }
            });

            modalInstance.result.then(function (group) {
                field.value = group;
                if(field.onChange) {
                    field.onChange(group);
                }
                if (field.change) {
                    field.change();
                }
            });
        };

        $rootScope.getGroupsForField = function(field) {
            var modalInstance = $modal.open({
                templateUrl: 'views/getgroups.html',
                controller: 'GetGroupsCtrl',
                windowClass: 'huge-modal-window',
                resolve: {
                    options: function() {
                        return _.extend({ itemFilter: field.itemFilter, multiple: true, selected: field.value, itemTypes: field.itemTypes }, field.options);
                    }
                }
            });

            modalInstance.result.then(function (groups) {
                field.value = groups;
                if(field.onChange) {
                    field.onChange(groups);
                }
                if (field.change) {
                    field.change();
                }
            });
        };

        $rootScope.getProductForField = function(field) {
            var modalInstance = $modal.open({
                templateUrl: 'views/getproducts.html',
                controller: 'GetProductsCtrl',
                windowClass: 'huge-modal-window',
                resolve: {
                    options: function() {
                        return _.extend({ itemFilter: field.itemFilter, multiple: false, itemTypes: field.itemTypes }, field.options);
                    }
                }
            });

            modalInstance.result.then(function (res) {
                field.value = res;
                if(field.onChange) {
                    field.onChange(res);
                }
                if (field.change) {
                    field.change();
                }
            });
        };

        $rootScope.getProductsForField = function(field) {
            var modalInstance = $modal.open({
                templateUrl: 'views/getproducts.html',
                controller: 'GetProductsCtrl',
                windowClass: 'huge-modal-window',
                resolve: {
                    options: function() {
                        return _.extend({ itemFilter: field.itemFilter, multiple: true, selected: field.value }, field.options);
                    }
                }
            });

            modalInstance.result.then(function (res) {
                field.value = res;
                if(field.onChange) {
                    field.onChange(res);
                }
                if (field.change) {
                    field.change();
                }
            });
        };

        $rootScope.getSupplierForField = function(field) {
            var modalInstance = $modal.open({
                templateUrl: 'views/getsuppliermodal.html',
                controller: 'GetSupplierCtrl',
                windowClass: 'huge-modal-window',
                resolve: {
                    options: function() {
                        return _.extend({ itemFilter: field.itemFilter, itemTypes: field.itemTypes }, field.options);
                    }
                }
            });

            modalInstance.result.then(function (supplier) {
                field.value = supplier;
                if(field.onChange) {
                    field.onChange(supplier);
                }
                if (field.change) {
                    field.change();
                }
            });
        };

        $rootScope.getFieldBuilderForField = function(field) {
            $modal.open({
                templateUrl: 'views/addmodal.html',
                controller: 'FieldBuilderCtrl',
                resolve: {
                    options: function() {
                        var options = field.options || {};
                        options.field = field.value;
                        return options;
                    }
                }
            }).result.then(function(resfield) {
                field.value = resfield;
            });
        };

        $rootScope.getMultiFieldBuilderForField = function(field) {
            $modal.open({
                templateUrl: 'views/addmodal.html',
                controller: 'MultiFieldBuilderCtrl',
                resolve: {
                    options: function() {
                        var options = field.options || {};
                        options.fields = field.value;
                        return options;
                    }
                }
            }).result.then(function(fields) {
                field.value = fields;
            });
        };

        $rootScope.getCustomersForField = function(field) {
            var modalInstance = $modal.open({
                templateUrl: 'views/getcustomermodal.html',
                controller: 'GetCustomerCtrl',
                windowClass: 'huge-modal-window',
                resolve: {
                    options: function() {
                        return _.extend({ itemFilter: field.itemFilter, multiple: true, selected: field.value, itemTypes: field.itemTypes }, field.options);
                    }
                }
            });

            modalInstance.result.then(function (customers) {
                field.value = customers;
                if (field.change) {
                    field.change();
                }
            });
        };

        $rootScope.getAccountsForField = function(field) {
            var modalInstance = $modal.open({
                templateUrl: 'views/getaccountsmodal.html',
                controller: 'GetAccountsCtrl',
                resolve: {
                    options: function() {
                        return { selected: field.value };
                    }
                }
            });

            modalInstance.result.then(function (accounts) {
                field.value = accounts;
            });
        };

        $rootScope.getCashierForField = function(field, useCache) {
            $rootScope.waitFor(['cashregisters']).then(function() {
                if (useCache && $rootScope.cachedCashRegister && $rootScope.cachedCashRegister.opened) {
                    field.value = $rootScope.cachedCashRegister;
                } else if ($rootScope.cashregisters.filter(function(c) { return c.canopen; }).length == 1) {
                    var c = $rootScope.cashregisters.filter(function(c) { return c.canopen; })[0];
                    if (field.open && !c.opened) {
                        var closePromise = $q.defer();

                        var cancelWatch = $rootScope.$watch(function() {
                            return c.opened;
                        }, function(opened) {
                            if(opened) {
                                field.value = c;
                                cancelWatch();
                                closePromise.resolve();
                                if (!c.selfcheckout) {
                                    $rootScope.cachedCashRegister = c;
                                }
                            }
                        });

                        var openCashier = function(amount) {
                            cancelWatch();
                            server.post('/api/checkout/cashier/open', null, {id: c.id, cash: amount}, 'Cashier opened', 'Failed to open cashier').then(function(result) {
                                if (result.success) {
                                    if (!c.selfcheckout) {
                                        $rootScope.cachedCashRegister = c;
                                    }
                                    field.value = c;
                                }
                            });
                        };

                        if (c.selfcheckout) {
                            openCashier();
                        } else {
                           cashiers.getChangeAmount(c.cash, {
                            closePromise: closePromise.promise,
                            registerCoins: c.registercoins
                            }).then(function (amount) {
                                openCashier(amount);
                            });
                        }
                    } else {
                        field.value = c;
                    }
                } else {
                    $modal.open({
                        templateUrl: 'views/getcashiermodal.html',
                        controller: 'GetCashierCtrl',
                        resolve: {
                            options: function() {
                                return {
                                    open: field.open,
                                    site: $rootScope.selectedSite
                                };
                            }
                        }
                    }).result.then(function (cashier) {
                        if (field.open && !cashier.selfcheckout) {
                            $rootScope.cachedCashRegister = cashier;
                        }
                        field.value = cashier;
                    });
                }
            });
        };

        $rootScope.getPaymentMethodForField = function(field) {
            var modalInstance = $modal.open({
                templateUrl: 'views/paychoicemodal.html',
                controller: 'ChoosePaymentMethodCtrl',
                resolve: {
                    options: function() {
                        return {
                            checkout: field.options && field.options.checkout,
                            create: field.options && field.options.create,
                            change: field.options && field.options.change,
                            refund: field.options && field.options.refund,
                            markAsPaid: field.options && field.options.markAsPaid,
                            refill: field.options && field.options.refill,
                            filter: field.options && field.options.filter,
                            saved_card: field.options && field.options.saved_card
                        };
                    }
                }
            });

            modalInstance.result.then(function (method) {
                field.value = method;
                if (field.change) {
                    field.change(field.value);
                }
            });
        };

        $rootScope.getAccountingTemplateForField = function(field) {
            var modalInstance = $modal.open({
                templateUrl: 'views/getaccountingtemplatemodal.html',
                controller: 'GetAccountingTemplateModalCtrl',
                windowClass: 'huge-modal-window',
                resolve: {
                    options: function() {
                        return { selected: field.value };
                    }
                }
            });

            modalInstance.result.then(function (template) {
                field.value = template;
                if (field.change) {
                    field.change(field.value);
                }
            });
        };

        $rootScope.previewTemplate = function(template, modalTitle, hideRecipientInfo) {
            if (!template) { return; }
            var templateUrl = null;
            var message = null;
            if (template.type == 'survey') {
                var summaryDict = {};
                angular.forEach(template.survey.questions, function(field) {
                    if (field.type == 'text' || field.type == 'textarea') {
                        summaryDict[field.name] = [];
                    } else {
                        summaryDict[field.name] = {};
                    }
                    angular.forEach(template.survey.answers, function(sa) {
                        if (sa.answers) {
                            if (field.type == 'text' || field.type == 'textarea') {
                                summaryDict[field.name].push(sa.answers[field.name]);
                            } else if (field.type == 'multiselect') {
                                angular.forEach(sa.answers[field.name], function(selection) {
                                    if (summaryDict[field.name].hasOwnProperty(selection)) {
                                        summaryDict[field.name][selection] ++;
                                    } else {
                                        summaryDict[field.name][selection] = 1;
                                    }
                                });
                            } else {
                                if (summaryDict[field.name].hasOwnProperty(sa.answers[field.name])) {
                                    summaryDict[field.name][sa.answers[field.name]] ++;
                                } else {
                                    summaryDict[field.name][sa.answers[field.name]] = 1;
                                }
                            }
                        }
                    });
                });
                templateUrl = 'views/previewtemplatewithobject.html';
                message = summaryDict;
            } else {
                templateUrl = 'views/previewtemplatewithtext.html';
                message = (template.message === undefined ? template : template.message);   // template (previewContent) is pure html instead of complete object while 'Preview' button clicked
            }
            $modal.open({
                templateUrl: templateUrl,
                windowClass: 'huge-modal-window',
                controller: ['$scope', 'previewContent', 'previewTitle', 'showRecipientInfo', 'excel', function($scope, previewContent, previewTitle, showRecipientInfo, excel) {
                    $scope.previewContent = previewContent;
                    $scope.previewTitle = previewTitle;
                    $scope.showRecipientInfo = !!showRecipientInfo;
                    $scope.message = message;
                    $scope.getExcel = function() {
                        excel.load().then(function() {
                            var data = [];
                            angular.forEach(message, function(answers, question) {
                                // Question
                                data.push([{value: question}]);
                                // Answers: (Array type) text, textarea
                                if (Array.isArray(answers)) {
                                    angular.forEach(answers, function(answer){
                                        if (answer) {
                                            data.push([{value: answer.toString()}]);
                                        }
                                    });
                                } else {
                                    angular.forEach(answers, function(number, answer){
                                        data.push([{value: answer.toString()}, {value: number.toString()}]);
                                    });
                                }
                            });
                            var title = previewContent.headline;
                            var excelData = createExcel(title, data);
                            excel.download(excelData, title + '.xlsx');
                        });
                    };
                    $scope.isArray = function (answers) {
                        return Array.isArray(answers);
                    };
                    $scope.closeAndGotoStaff = function(staff) {
                        $scope.$close();
                        $rootScope.gotoStaff($rootScope.getStaff(staff));
                    };
                    $scope.showReceivers = function() {
                        var showAnswersButton = function(customer) {
                            if (previewContent.type !== 'survey') { return false; }
                            var customerAnswer = _.findWhere(previewContent.survey.answers, {user_id: customer.id});
                            // Answer sample (anonymous is allowed): {"answers": {"How many work days?": 4, "anonymous": false}}
                            // Answer sample (anonymous is not allowed): {"answers": {"How many work days?": 4}}
                            if (customerAnswer.answers && !customerAnswer.answers.anonymous) {
                                return true;
                            } else {
                                return false;
                            }
                        };
                        var showAnswers = function(customer) {
                            $modal.open({
                                templateUrl: 'views/surveymodal.html',
                                windowClass: 'small-modal-window',
                                controller: ['$scope', function($scope){
                                    var customerAnswer = _.findWhere(previewContent.survey.answers, {user_id: customer.id}).answers;
                                    var questions = previewContent.survey.questions.filter(function(question) { return question.name != 'anonymous'; });

                                    $scope.fields = [];
                                    util.addQuestions($scope.fields, questions, '');

                                    $scope.fields.forEach(function(field) {
                                        field.readonly = true;
                                        if (field.type == 'text' || field.type == 'number') {
                                            field.type = 'label';
                                        }
                                        var value = customerAnswer[field.name];
                                        if (field.type == 'select') {
                                            if (value) {
                                                field.value = _.findWhere(field.options(), {id: value});
                                            }
                                        } else if (field.type == 'multiselect') {
                                            if (value && Array.isArray(value)) {
                                                field.value = value.map(function(item) {
                                                    return _.findWhere(field.options(), {id: item});
                                                });
                                            }
                                        } else if (field.type == 'date' || field.type == 'datetime') {
                                            field.value = Date.newFull(value);
                                        } else {
                                            field.value = value;
                                        }
                                    });
                                }]
                            });
                        };
                        $modal.open({
                            templateUrl: 'views/receivers.html',
                            windowClass: 'small-modal-window',
                            controller: ['$scope', function($scope){
                                $scope.config = {
                                    getItems: function() {
                                        return previewContent.receivers;
                                    },
                                    rowClick: $rootScope.gotoCustomer,
                                    columns: [
                                        {field: 'image', title: '' },
                                        {field: 'name', title: 'Name' },
                                    ],
                                    buttons: [
                                        {title: 'Show answers', onClick: showAnswers, visible: showAnswersButton }
                                    ]
                                };
                            }]
                        });
                    };
                    $scope.sendMoreToReceivers = function() {
                        $scope.$close();
                        pubsub.publish('newmailingdata', {
                            isNewsOrAdvertising: false,
                            sendOption: previewContent.type,
                            receivers: previewContent.receivers
                        });
                        $location.path('/mailings/new');
                    };
                }],
                resolve: {
                    previewContent: function() { return template; },
                    previewTitle: function() { return modalTitle || ''; },
                    showRecipientInfo: function() { return !hideRecipientInfo; }
                }
            });
        };

        $rootScope.removeWorkout = function(workout) {
            var deferred = $q.defer();

            var successTitle = 'Workout removed';
            var failedTitle = 'Failed to remove workout';

            function repeat(send, force) {
                send(force).then(function(response) {
                    if(response.success) {
                        alertProvider.show('success', successTitle);
                    } else {
                        if(response.data.type === 'in_use' && !force) {
                            confirm.show(response.data.message).then(function() {
                                repeat(send, true);
                            }, deferred.resolve);
                            return;
                        } else {
                            alertProvider.show('error', failedTitle);
                        }
                    }
                    deferred.resolve();
                });
            }

            $http.get('/api/schedule/workout/getSimilar?id=' + workout.id).success(function(similar) {
                if (similar.length == 0) {
                    confirm.show('Are you sure you want to remove the workout?').then(function() {
                        var args = {id: workout.id};
                        repeat(function(force) {
                            if(force) {args.force = true;}
                            return server.post('/api/schedule/workout/remove', null, args);
                        });
                    }, function() {
                        deferred.reject();
                    });
                } else {
                    removeworkoutdialog.show(similar.length).then(function(reason) {
                        var args = {id: workout.id};
                        var body = null;

                        if (reason == 'all') {
                            body = _.pluck(similar, 'id');
                            successTitle = 'Workouts removed';
                            failedTitle = 'Failed to remove workouts';
                        }

                        repeat(function(force) {
                            if(force) {args.force = true;}
                            return server.post('/api/schedule/workout/remove', body, args);
                        });
                    }, function() {
                        deferred.reject();
                    });
                }
            });

            return deferred.promise;
        };

        $rootScope.makeWorkoutBooking = function(customer, workout, memberAsPerformer, throughXentry) {
            var deferred = $q.defer();
            var data = {memberId: customer.id, workout: workout.id, memberAsPerformer: memberAsPerformer, throughXentry: throughXentry};
            server.post('/api/workoutBooking/add', data, null, 'Booking was added').then(function(result) {
                if (!result.success) {
                    if (result.data.type == 'missingtrainingcard' && !throughXentry) {
                        $rootScope.showCombo({customer: customer, missingtrainingcard: true, workout: workout});
                    } else if (result.data.type == 'notpossibletobookusingcard' && !throughXentry) {
                        $rootScope.notBookableByCard({customer: customer, workout: workout})
                    } else {
                        alertProvider.show('error', 'Failed to add booking');
                    }
                    deferred.reject();
                }
                else {
                    deferred.resolve();
                }
            });
            return deferred.promise;
        };

        $rootScope.addStaff = function(gotoStaff) {
            var res = $modal.open({
                templateUrl: 'views/addmodal.html',
                controller: 'StaffAddModalCtrl'
            }).result;

            if (gotoStaff) {
                res.then($rootScope.gotoStaff);
            }

            return res;
        };

        $rootScope.addCustomer = function() {
            $rootScope.waitFor(['paymentmethods']).then(() => {
                $rootScope.showCombo({minimal: false, callback: $rootScope.gotoCustomer});
            });
        };

        $rootScope.addTask = function() {
            $modal.open({
                templateUrl: 'views/addmodal.html',
                controller: 'ToDoModalAddCtrl',
                resolve: {
                    options: function() {
                        return {};
                    }
                }
            });
        };

        $rootScope.addWorkout = function() {
            $rootScope.waitFor(['startedModules']).then(function() {
                util.showDataDialog({ controller: 'WorkoutDataCtrl', initial: {
                    date: Date.today(),
                    startTime: Date.newTime('18:00'),
                    endTime: Date.newTime('19:00')
                } });
            });
        };

        $rootScope.addSystemTag = function(field) {
            $modal.open({
                templateUrl: 'views/addmodal.html',
                controller: ['$scope', '$controller', function($scope, $controller) {
                    $controller('AddCtrl', {$scope: $scope});
                    $scope.postUrl = '/api/systemtag/add';
                    $scope.callCloseOnSuccess = true;

                    $scope.fields = [
                        { name: 'name', title: 'Name', type: 'systemtagUnique', required: true }
                    ];
                }]
            }).result.then(function(tag) {
                if (field) {
                    field.value.push(_.findWhere($rootScope.systemtags, { id: tag.id }));
                }
            });
        };

        $rootScope.getMailingHandlerSendAsOptions = function() {
            return $rootScope.mailinghandlers.map((mh) => ({ id: mh.id, value: mh.id, addon_id: mh.addon_id, name: `${mh.addon_name} - ${mh.name}`}));
        };

        $rootScope.getCustomerProperties = function() {
            var result = [];
            angular.forEach($rootScope.fields.user, function(field) {
                if (field.show) {
                    var prefix = field.builtIn ? '' : 'xf.';
                    result.push({id: prefix + field.name, name: field.title});
                }
            });
            if ($rootScope.hasModule('Entry')) {
                result.push({ name: 'Entry card', id: 'entry_card_value' });
            }
            return result;
        };

        $rootScope.showCustomerField = function(fieldName) {
            var field = _.findWhere($rootScope.fields.user, {name: fieldName});
            return field && field.show;
        };

        $rootScope.customerFieldHasValue = function(field, value) {
            if (field.type == 'multiselect') {
                return value && value.length;
            } else {
                return value != undefined;
            }
        };

        $rootScope.setCustomerFields = function(fields, onlyRequired) {
            angular.forEach($rootScope.fields.user, function(field) {
                if (field.builtIn) {
                    var f = _.findWhere(fields, {name: field.name});
                    if (f) {
                        if($rootScope.currentStaff) {
                            f.required = field.required_for_staff;
                        } else {
                            f.required = field.required;
                        }
                        if (!field.show || (onlyRequired && !field.required)) {
                            var i = fields.indexOf(f);
                            fields.splice(i, 1);
                        }
                    }
                } else if (field.show) {
                    var f = {name: 'xf.' + field.name, title: field.title, type: field.type };
                    if($rootScope.currentStaff) {
                        f.required = field.required_for_staff;
                    } else {
                        f.required = field.required;
                    }
                    if (field.type == 'map') {
                        f.mapcontrol = {};
                    }
                    else if (field.type == 'customer' || field.type == 'customers') {
                        f.useId = true;
                    }
                    else if (field.type == 'select' || field.type == 'multiselect') {
                        var fdata = field.data;
                        if (fdata.length && fdata[0].id !== undefined) {
                            f.useId = true;
                            f.options = function() { return fdata; };
                        } else {
                            f.optionsList = [];
                            angular.forEach(fdata, function(name) {
                                var o = {name: name};
                                f.optionsList.push(o);
                            });
                            f.options = function() { return f.optionsList; };
                            if (field.type == 'select') {
                                f.getValue = function(field) { return field.value && field.value.name; };
                                f.setValue = function(field, value) { return _.findWhere(field.options(), {name: value}); };
                            } else {
                                f.getValue = function(field) { return _.pluck(field.value, 'name'); };
                                f.setValue = function(field, value) {
                                    var res = [];
                                    angular.forEach(value, function(v) {
                                        var o = _.findWhere(field.options(), {name: v});
                                        if (o) {
                                            res.push(o);
                                        }
                                    });
                                    return res;
                                };
                            }
                        }
                    }
                    fields.push(f);
                }
            });
        };


        $rootScope.getCustomerColumns = function(fields, onlyRequired) {
            angular.forEach($rootScope.fields.user, function(field) {
                if (field.builtIn) {
                    var f = _.findWhere(fields, {field: field.name});
                    if (f) {
                        f.required = field.required_for_staff;
                        if (!field.show || (onlyRequired && !field.required)) {
                            var i = fields.indexOf(f);
                            fields.splice(i, 1);
                        }
                    }
                } else if (field.show) {
                    var f = {field: 'xf.' + field.name, title: field.title, type: field.type };
                    f.required = field.required_for_staff;
                    fields.push(f);
                }
            });
        };

        $rootScope.formatCustomerField = function(field, value) {
            var data = field.data;
            var useId = (field.type == 'select' || field.type == 'multiselect') && (data && data.length && data[0].id !== undefined);
            if (useId) {
                if (field.type == 'select') {
                    value = _.findWhere(data, {id: value});
                    if (_.isObject(value) && value.name) {
                        value = $filter('translate')(value.name);
                    }
                } else {
                    value = value && value.map(function(id) {
                                return _.findWhere(data, {id: id});
                            }).filter(Boolean);
                }
            }

            if (field.type == 'multiselect') {
                value = formatter.format('commaList', value);
            }

            return value;
        };

        $rootScope.isProduct = function(product) {
            return (!product.boundTime && !product.boundType && !product.validTime && !product.validType && !product.period && (!product.priceType || product.priceType == 'OneTime') && !product.trainingsessions && product.type != 'course') || product.giftcard || product.valuecard || product.membership;
        };

        $rootScope.isTrainingCard = function(t) {
            return t.type === 'trainingcard' || t.type === 'resourcebooking';
        };

        $rootScope.getTrainingCards = function() {
            return $rootScope.trainingcardtypes.filter($rootScope.isTrainingCard);
        };

        $rootScope.productVisibleForSite = function(t) {
            return !t.visible_sites || t.visible_sites.length == 0 || t.visible_sites.indexOf($rootScope.selectedSite.id) != -1;
        };

        $rootScope.productVisibleForCashier = function(t, cashier) {
            if (!cashier || !cashier.site || !cashier.site.legal_entity_id) {
                return true;
            }
            var sites = $rootScope.isTrainingCard(t) ? (t.sites || []) : (t.visible_sites || []);
            if (sites.length == 0) {
                return true;
            }
            var cashierLegalEntityId = cashier.site.legal_entity_id;
            return sites.some(function(s) {
                var site = _.isObject(s) ? s : $rootScope.getSite(s);
                return site && site.legal_entity_id == cashierLegalEntityId;
            });
        };

        $rootScope.productsShareLegalEntity = function(a, b) {
            var aVisibleSites = a.visible_sites || [];
            var bVisibleSites = b.visible_sites || [];
            if (aVisibleSites.length == 0 || bVisibleSites.length == 0) {
                return true;
            }
            function getLegalEntityIds(siteIds) {
                return siteIds.map(function(s) {
                    var site = _.isObject(s) ? s : $rootScope.getSite(s);
                    return site.legal_entity_id;
                });
            }
            var aLegalEntities = getLegalEntityIds(aVisibleSites);
            var bLegalEntities = getLegalEntityIds(bVisibleSites);
            return _.intersection(aLegalEntities, bLegalEntities).length > 0;
        };

        $rootScope.isSpecialHiddenProduct = function(t) {
            return t.discount || t.rounding || t.misc || t.reminderFee || t.reminderRate || t.invoiceFee || t.blockFee || t.workoutBooking || t.type === 'tip';
        };

        $rootScope.isPackageProduct = function(t) {
            return t.included_products && t.included_products.length > 0;
        };

        $rootScope.getProducts = function() {
            return $rootScope.trainingcardtypes.filter(function(t) { return $rootScope.isProduct(t) && !$rootScope.isSpecialHiddenProduct(t); } );
        };

        $rootScope.getActiveTrainingCards = function() {
            return $rootScope.getTrainingCards().filter(function(t) { return t.active && (!t.resourcebookingservice || (t.resourcebookingservice.category.active && t.resourcebookingservice.active )); });
        };

        $rootScope.getActiveProducts = function() {
            return $rootScope.getProducts().filter(function(t) { return t.active; });
        };

        $rootScope.getCriminalRecordExcerpts = function() {
            server.get('/api/criminalrecordexcerpt/get').then(function(result) {
                $rootScope.uncertifiedCriminalRecordExcerpts = result.filter(cre => !cre.certified_date || new Date(cre.certified_date).addMonths(24).yyyymmdd() < Date.today().yyyymmdd());
                $rootScope.criminalRecordExcerpts = result;
            });
        };

        $rootScope.getNumberOfUncertifiedCres = function() {
            return _.filter($rootScope.criminalRecordExcerpts, function(cre) {
                if (!cre.certified_date) { return true; }
                var certified_date = new Date(cre.certified_date);
                return certified_date.addMonths(24).yyyymmdd() < new Date().yyyymmdd();
            }).length;
        };

        $rootScope.fileCategories = [{origin_type: 'product', name: 'Product', id: 'product'}, {origin_type: 'trainingcard', name: 'Training card', id: 'trainingcard'}, {origin_type: 'teamsport', name: 'Team sports', id: 'teamsport'}, {origin_type: 'mailing', name: 'News', id: 'mailing'}];

        // Transformers

        $rootScope.transformWorkout = function(w) {
            w.startTime = Date.newFull(w.startTime);
            var date = new Date(w.startTime).clearTime();
            // Cannot use the name 'date' if we want to pass it to the calendar component
            w.startDate = date;
            w.endTime = Date.newFull(w.endTime);
            w.start = w.startTime;
            w.end = w.endTime;
            w.allDay = false;

            // Update pointers
            if ($rootScope.loaded.workouttypes) {
                const resolvedWorkoutType = $rootScope.getPointer(w.workoutType, $rootScope.workouttypes);
                w.workoutType = resolvedWorkoutType || w.workoutType;
            } else if (w.workoutType?.id && !w._waitingForWorkoutType) {
                w._waitingForWorkoutType = true;
                $rootScope.waitFor(['workouttypes']).then(() => {
                    delete w._waitingForWorkoutType;
                    const resolvedWorkoutType = $rootScope.getPointerById(w.workoutType.id, $rootScope.workouttypes);
                    if (resolvedWorkoutType) {
                        w.workoutType = resolvedWorkoutType;
                        $rootScope.recalculateWorkout(w);
                    }
                });
            }
            if (w.staffs) {
                for (var i=0; i < w.staffs.length; ++i) {
                    w.staffs[i] = $rootScope.getMember(w.staffs[i]);
                }
            }
            if (w.resources) {
                for (var i=0; i < w.resources.length; ++i) {
                    w.resources[i] = $rootScope.getMember(w.resources[i]);
                }
            }

            if (!w.bookings) {
                w.bookings = [];
            }
            for (var i=0; i < w.bookings.length; ++i) {
                $rootScope.transformWorkoutBooking(w.bookings[i]);
            }
            w.site = $rootScope.getPointerById(w.site_id, $rootScope.sites);

            w.getBookingsWithSeat = function() {
                return _.filter(w.bookings, function(booking) {
                    return !booking.inQueue;
                });
            };

            $rootScope.recalculateWorkout(w);

            return w;
        };

        $rootScope.recalculateWorkout = function(workout) {
            var numBooked = workout.getBookingsWithSeat().length;
            var full = workout.space && numBooked >= workout.space;
            var almostFull = !full && workout.space && (numBooked / workout.space) >= 0.85;
            workout.className = full ? 'workout-full' : (almostFull ? 'workout-almost-full' : '');
            if (workout.workoutType) {
                workout.backgroundColor = workout.workoutType.color;
                workout.title = workout.workoutType.name;
            } else {
                workout.backgroundColor = '';
                workout.title = '';
                return;
            }
            workout.subTitle = workout.staffs.map(staff => staff.firstname ? `${staff.firstname} ${staff.lastname.charAt(0)}` : staff.fullname).join(", ");
            if(workout.extra_title) {
                workout.title += ' - ' + workout.extra_title;
            }

            if (workout.status == 'Cancelled') {
                workout.title += ' - ' + $filter('translate')('Cancelled');
                workout.backgroundColor = '#aaa';
                workout.editable = false;
            }

            // Check placeholders. Since subTitle is built from staffs, we need to recalculate it when placeholders are loaded
            const placeholders = workout.staffs.filter(staff => staff.is_placeholder).map(staff => staff.uid);
            if (placeholders.length && !workout.placeholder_deregister) {
                workout.placeholder_deregister = $rootScope.$on('ApiDataLoaded', (event, uid) => {
                    if (placeholders.includes(uid)) {
                        $rootScope.recalculateWorkout(workout);
                    }
                });
            } else if (!placeholders.length && workout.placeholder_deregister) {
                workout.placeholder_deregister();
                workout.placeholder_deregister = null;
                $rootScope.$broadcast('workoutRecalculated', workout);
            }
        };

        $rootScope.transformTrainingCard = function(card) {
            if (card.validFromDate) {
                card.validFromDate = Date.newFull(card.validFromDate);
            }
            if (card.boundToDate) {
                card.boundToDate = Date.newFull(card.boundToDate);
            }
            if (card.validToDate) {
                card.validToDate = Date.newFull(card.validToDate);
            }

            if (card.period) {
                card.periodValidFrom = Date.newFull(card.periodValidFrom);
                card.periodValidTo = Date.newFull(card.periodValidTo);
            }

            if (card.payments) {
                angular.forEach(card.payments, function(payment) {
                    $rootScope.transformPayment(payment);
                });
            }
            card.cardtype = $rootScope.getPointerById(card.cardtype_id, $rootScope.trainingcardtypes);
            if (card.freezes) {
                angular.forEach(card.freezes, function(freeze) {
                    freeze.fromDate = Date.newFull(freeze.fromDate);
                    freeze.toDate = Date.newFull(freeze.toDate);
                });
            }
            card.user = $rootScope.getMember(card.user_id);
            card.payer = $rootScope.getMember(card.payer_id);
            return card;
        };

        $rootScope.transformTrainingCardType = function(card) {
            card.uid = 'trainingcardtype.' + card.id;
            if (card.resourcebookingservice_id) {
                card.resourcebookingservice = $rootScope.getPointerById(card.resourcebookingservice_id, $rootScope.resourcebookingservices);
            }
            if (card.account) {
                var a = card.account.split(',');
                if (a.length == 1) {
                    card.account = Number(a[0]);
                } else {
                    card.account = [];
                    a.forEach(function(x) {
                        card.account.push(Number(x));
                    });
                }
            }

            if (card.entryFrom && card.entryTo) {
                card.entryFrom = Date.newTime(card.entryFrom);
                card.entryTo = Date.newTime(card.entryTo);
            }

            card.validFromDate = Date.newFull(card.validFromDate);
            card.validToDate = Date.newFull(card.validToDate);

            card.needs_to_choose_variant = function() {
                return card.variants && card.variants.length && (card.variants.length > 1 || (card.variants[0].name != 'Standard' && card.variants[0].name));
            };

            card.updateVariants = function() {
                var site_id = $rootScope.stockPerSite ? $rootScope.selectedSite.id : 1;
                (card.variants || []).forEach(function(v) {
                    var s = _.findWhere(v.stock_sites, {site_id: site_id});
                    v.stock = s ? s.stock : null;
                });
            };

            card.updateVariants();
            card.entryDoors = card.entryDoorIds.map($rootScope.getMember);

            // Set group labels for training card selectors (used in advanced search)
            var cardActive = card.resourcebookingservice ? (card.resourcebookingservice.active && card.resourcebookingservice.category && card.resourcebookingservice.category.active && card.active) : card.active;
            if (cardActive) {
                card._group = card.resourcebookingservice ? 'Resource booking' : 'Training card';
                card._groupOrder = card.resourcebookingservice ? 1 : 0;
            } else {
                card._group = card.resourcebookingservice ? 'Inactive resource booking' : 'Inactive training cards';
                card._groupOrder = card.resourcebookingservice ? 3 : 2;
            }
        };

        $rootScope.transformMember = function(member) {
            member.uid = 'user.' + member.id;
            member.isMember = true;
            member.fullname = member.firstname ? (member.firstname + " " + member.lastname) : member.lastname;
            member.quickSearchFullname = member.firstname ? (member.lastname + " " + member.firstname) : member.lastname;
            member.name = member.fullname;
            if (!member.trainingcards) {
                member.trainingcards = [];
            }
            for (var i=0; i < member.trainingcards.length; ++i) {
                $rootScope.transformTrainingCard(member.trainingcards[i]);
            }
            member.company = !!member.company;
            // For searching
            member.nicePcode = formatter.format('personalCodeNumber', member.personalCodeNumber);

            member.created = Date.newFull(member.created);
            if (member.warnedUntil) {
                member.warnedUntil = Date.newFull(member.warnedUntil);
            }

            let getBlockedDate = function() {
                if (member.warnedUntil && member.warnedUntil.yyyymmdd() == '9999-12-31') {
                    return $filter('translate')('Until further notice');
                }

                return formatter.format('date', member.warnedUntil);
            };

            member.blockedDate = getBlockedDate();
            if (member.memberNumber != undefined && member.memberNumber > 0) {
                $rootScope.hasMemberNumber = true;
            }
            if (member.status) {
                $rootScope.updatePointersById(member.status, $rootScope.memberstatuses);
            } else {
                member.status = [];
            }

            if (member.responsible_id) {
                member.responsible = $rootScope.getPointerById(member.responsible_id, $rootScope.members);
            }
            if (member.lastStatusChange) {
                member.lastStatusChange = Date.newFull(member.lastStatusChange);
            }
            if (!member.bookers) {
                member.bookers = [];
            }

            if (!member.groups) {
                member.groups = [];
            }

            if (member.connected_resources) {
                angular.forEach(member.connected_resources, function(staff, i) {
                    // Skip if already transformed (is an object, not just an ID)
                    if (typeof staff === 'object' && staff !== null) {
                        return;
                    }
                    member.connected_resources[i] = $rootScope.getPointerById(staff, $rootScope.members);
                });
            }

            member.resource = member.type == 'resource';
            if (member.roles) {
                $rootScope.updatePointers(member.roles, $rootScope.roles);
            }

            if (!member.sites) {
                member.sites = [];
            }

            member.getValueCardAmountForSelectedLegalEntity = function() {
                if (!$rootScope.selectedSite || !$rootScope.selectedSite.legal_entity_id || !member.value_card_amounts) {
                    return 0;
                }
                return member.value_card_amounts[$rootScope.selectedSite.legal_entity_id] || 0;
            };

            member.hasSavedCardForSelectedLegalEntity = function() {
                if (!$rootScope.selectedSite || !$rootScope.selectedSite.legal_entity_id || !member.savedBankCards) return false;
                return member.savedBankCards.includes($rootScope.selectedSite.legal_entity_id);
            };

            return member;
        };

        $rootScope.transformWorkoutBooking = function(b) {
            if (b.user_id) {
                var user = $rootScope.getMember(b.user_id);
                if (user) {
                    b.user = user;
                } else {
                    b.user = {id: b.user_id, name: $filter('translate')('Anonymous') };
                }
            }
            return b;
        };

        $rootScope.transformPayment = function(p) {
            p.member = $rootScope.getMember(p.user_id);
            p.user = p.member;
            p.payer = $rootScope.getMember(p.payer_id);
            if (!p.payer) {
                p.payer = { id: p.payer_id, name: $filter('translate')('Anonymous') };
            }
            p.payername = p.payer.name;
            p.created = Date.newFull(p.created);
            p.date = Date.newFull(p.date);
            p.credited = Date.newFull(p.credited);
            if (p.attempts) {
                for (var i=0; i < p.attempts.length; ++i) {
                    p.attempts[i].created = Date.newFull(p.attempts[i].created);
                    p.attempts[i].time = Date.newFull(p.attempts[i].time);
                }
            }
            if (p.transactions) {
                for (var i=0; i < p.transactions.length; ++i) {
                    p.transactions[i].created = Date.newFull(p.transactions[i].created);
                }
            } else {
                p.transactions = [];
            }
            if (p.reminders) {
                for (var i=0; i < p.reminders.length; ++i) {
                    var r = p.reminders[i];
                    r.created = Date.newFull(r.created);
                    if (r.fee_payment) {
                        r.fee_payment = $rootScope.transformPayment(r.fee_payment);
                    }
                    if (r.rate_payment) {
                        r.rate_payment = $rootScope.transformPayment(r.rate_payment);
                    }
                }
            } else {
                p.reminders = [];
            }
            if (p.claims) {
                for (var i = 0; i < p.claims.length; i++) {
                    var c = p.claims[i];
                    c.created = Date.newFull(c.created);
                }
            } else {
                p.claims = [];
            }
            return p;
        };

        $rootScope.transformResourceBookingService = function(s) {
            s.category = $rootScope.getPointerById(s.category_id, $rootScope.resourcebookingcategories);
            $rootScope.updatePointers(s.staffs, $rootScope.members);
            $rootScope.updatePointers(s.xstaffs, $rootScope.members);
            $rootScope.updatePointers(s.resources, $rootScope.members);
            return s;
        };

        $rootScope.transformResourceBooking = function(rb) {
            rb.time = Date.newFull(rb.time);
            rb.service = $rootScope.getPointerById(rb.service_id, $rootScope.resourcebookingservices);
            rb.category = rb.service.category;
            rb.category_id = rb.service.category.id;
            rb.staff = $rootScope.getMember(rb.staff_id);
            rb.xstaff = $rootScope.getMember(rb.xstaff_id);
            rb.user = $rootScope.getMember(rb.user_id);
            rb.booker = $rootScope.getMember(rb.booker_id);
            rb.created = Date.newFull(rb.created);
            if (rb.cancelled_time) {
                rb.cancelled_time = Date.newFull(rb.cancelled_time);
            }

            rb.start = rb.time;
            rb.end = rb.start.clone().addMinutes(rb.duration);
            rb.title = rb.service.name;
            rb.backgroundColor = rb.service.category.color;

            if (rb.products) {
                angular.forEach(rb.products, function(product) {
                    $rootScope.transformTrainingCard(product);
                });
            }

            if (rb.payment) {
                $rootScope.transformPayment(rb.payment);
            }

            return rb;
        };

        $rootScope.transformResourceBookings = function(rbookings) {
            angular.forEach(rbookings, function(rbooking) {
                $rootScope.transformResourceBooking(rbooking);
                if (rbooking.parent_id) {
                    rbooking.siblings = rbookings.filter(function(rb) {
                        return rb.parent_id == rbooking.parent_id && Date.dateEquals(new Date(rb.time), new Date(rbooking.time));
                    });
                    var products = [];
                    var included_products = {};
                    var paid = true;
                    angular.forEach(rbooking.siblings, function(rb) {
                        products = _.union(rb.products.filter(function(p) { return !_.findWhere(products, {id: p.id}); }), products);
                        rb.included_products?.forEach(i => included_products[i] = i);
                        paid &= rb.paid;
                    });
                    rbooking.products = products;
                    rbooking.included_products = Object.values(included_products);
                    rbooking.paid = paid;
                } else {
                    rbooking.siblings = [rbooking];
                }
            });
        };

        $rootScope.transformEntry = function(entry) {
            if (entry.Member) {
                entry.Member = $rootScope.getPointer(entry.Member, $rootScope.members);
            } else {
                entry.Member = $rootScope.getMember(entry.member_id);
            }
            entry.door = $rootScope.getMember(entry.door);
            entry.entryTime = Date.newFull(entry.entryTime);
            entry.name = entry.Member && entry.Member.name;
            entry.id = entry.Member && entry.Member.id;
        };

        $rootScope.transformTodo = function(t) {
            t.created = Date.newFull(t.created);
            t.dueDate = Date.newFull(t.dueDate);
            t.dueDateTime = Date.newFull(t.dueDate);
            t.performed = Date.newFull(t.performed);
            t.removed = Date.newFull(t.removed);
            t.responsible = $rootScope.getMember(t.responsible_id);
            t.creator = $rootScope.getMember(t.creator_id);
            t.user = $rootScope.getMember(t.user_id);
            t.group = $rootScope.getGroup(t.group_id);
            if (t.sites && $rootScope.sites) {
                t.site_names = t.sites.map(function(id) {
                    var s = $rootScope.sites.find(function(e) { return e.id === id; });
                    return s ? $filter('translate')(s.name) : '';
                }).filter(Boolean).join(', ');
            }
        };

        $rootScope.transformCashier = function(c) {
            c.opened = Date.newFull(c.opened);
            c.site = $rootScope.getPointerById(c.site_id, $rootScope.sites);
            var ips = (c.ips || '').split(',').filter(function(x) { return x.length;});
            if (ips.length == 0) {
                c.canopen = true;
            } else {
                c.canopen = false;
                for (var i = 0; i < ips.length; ++i) {
                    var rule = ips[i].trim();
                    if (new RegExp("^" + rule.split("*").join(".*") + "$").test($rootScope.myIp)) {
                        c.canopen = true;
                        break;
                    }
                }
            }

            if (c.canopen && $rootScope.hasModule('MultiSite') && c.site != $rootScope.selectedSite) {
                c.canopen = false;
            }
        };

        $rootScope.transformWarning = function(warning) {
            warning.created = Date.newFull(warning.created);
            warning.deprecated = Date.newFull(warning.deprecated);
            if (warning.workout) {
                $rootScope.transformWorkout(warning.workout);
                warning.created = warning.workout.startTime;
            }
        };

        $rootScope.transformPaymentMethod = function(pm) {
            if(pm.imagekey) {
                pm.imageSrc = fileManager.fileLinkByKey(pm.imagekey, 100);
            }
            return pm;
        };

        $rootScope.transformBudget = function(b) {
            b.fromDate = Date.newFull(b.fromDate);
            b.toDate = Date.newFull(b.toDate);
            return b;
        };

        $rootScope.transformInvitation = function(i) {
            i.user = $rootScope.getMember(i.user_id);
            return i;
        };

        $rootScope.transformRole = function(role) {
            role.translated = $filter('translate')(role.name);
            return role;
        };

        $rootScope.transformUserPushNotification = function(notification) {
            notification.sent = Date.newFull(notification.sent);
            notification.sendTime = Date.newFull(notification.sendTime);
            notification.sender = null;
            notification.hasRead = Date.newFull(notification.hasRead);
            notification.isArchived = Date.newFull(notification.isArchived);
            if (notification.senderId) {
                notification.sender = $rootScope.getMember(notification.senderId);
            }
            return notification;
        };
        $rootScope.transformCost = function(cost) {
            cost.created = Date.newFull(cost.created);
            cost.date = Date.newFull(cost.date);
            cost.invoiceDate = Date.newFull(cost.invoiceDate);
            cost.dueDate = Date.newFull(cost.dueDate);
            cost.amount = Number(cost.amount);
            return cost;
        };

        $rootScope.transformDashboard = function(d) {
            if (_.isString(d.config)) {
                d.config = JSON.parse(d.config);
                d.name = util.t(d.name);
            }
            return d;
        };

        $rootScope.transformBlock = function(b) {
            b.user = $rootScope.getMember(b.user_id);
            b.responsible = $rootScope.getMember(b.responsible_id);
            b.fromDate = Date.newFull(b.fromDate);
            b.toDate = Date.newFull(b.toDate);
            return b;
        };

        $rootScope.transformUserGroup = function(group) {
            group.uid = 'usergroup.' + group.id;
            group.responsible = group.responsible.map($rootScope.getMember);
            group.users = group.users.map($rootScope.getMember);
            group.trainingcards = group.trainingcards.map(tc => {
                if (typeof tc === 'number') {
                    return {id: tc};
                } else {
                    return $rootScope.transformTrainingCard(tc);
                }
            });
            return group;
        };

        $rootScope.showCompleteAdyenSetupModal = function() {
            if (!$rootScope.parentHandlesToast && $rootScope.hasModule('Adyen') && $rootScope.hasPermission('Settings')) {
                $modal.open({
                    templateUrl: 'views/AdyenSetupNotCompleteModal.html',
                    windowClass: 'modal-window',
                    controller: 'AdyenSetupNotCompletedCtrl',
                });
            }
        };

        $rootScope.updateMissingSettings = function(missing) {
            $rootScope.missingSettings = missing;
        };

        $rootScope.isSettingMissing = function(module) {
            return $rootScope.missingSettings && $rootScope.missingSettings.indexOf(module) != -1;
        };

        $rootScope.toastHidden = function() {
            $rootScope.lastToast = undefined;
        };

        $rootScope.showInfo = function(message) {
            var options = { closeButton: true, positionClass: "toast-bottom-right", timeOut: "10000" };

            toastr.info(message, null, options);
        };

        $rootScope.refetchCurrentStaff = function() {
            return $http.get('/api/staff/get/current').success(function(data) {
                var rbWasStarted = $rootScope.hasModule('ResourceBooking');
                var scheduleWasStarted = $rootScope.hasModule('Schedule');
                var checkoutWasStarted = $rootScope.hasModule('Checkout');
                var workoutBookingWasStarted = $rootScope.hasModule('WorkoutBooking');
                var coursesWasStarted = $rootScope.hasModule('Courses');
                $rootScope.startedModules = data.modules;
                $rootScope.currentStaffPermissions = data.permissions;
                var rbIsStarted = $rootScope.hasModule('ResourceBooking');
                var scheduleIsStarted = $rootScope.hasModule('Schedule');
                var checkoutIsStarted = $rootScope.hasModule('Checkout');
                var workoutBookingIsStarted = $rootScope.hasModule('WorkoutBooking');
                var coursesIsStarted = $rootScope.hasModule('Courses');

                if (!rbWasStarted && rbIsStarted) {
                    $rootScope.onResourceBookingStarted();
                }

                if (!scheduleWasStarted && scheduleIsStarted) {
                    $rootScope.onScheduleStarted();
                }

                if (!checkoutWasStarted && checkoutIsStarted) {
                    $rootScope.onCheckoutStarted();
                }

                if (!workoutBookingWasStarted && workoutBookingIsStarted) {
                    $rootScope.onWorkoutBookingStarted();
                }

                if (!coursesWasStarted && coursesIsStarted) {
                    $rootScope.onCoursesStarted();
                }

                $rootScope.setDataFromStaff(data);

                if (data.missingSettings?.includes('Adyen') && !$rootScope.isSettingMissing('Adyen')) {
                    $rootScope.showCompleteAdyenSetupModal();
                }

                $rootScope.updateMissingSettings(data.missingSettings);

                $rootScope.fetchPaymentMethods();
                $rootScope.fetchPaymentMethodSettings();
            });
        };

        $rootScope.systemBlocked = function(softBlocked, blocked, superUser) {
            if (!$rootScope.staffnext && (!superUser && (softBlocked && $rootScope.hasPermission('Economy') || blocked))) {
                $modal.open({
                    templateUrl: 'views/systemblockedmodal.html',
                    controller: 'SystemBlockedCtrl',
                    backdrop: 'static',
                    keyboard: false,
                    resolve: {
                        options: function() {
                            return {softBlocked: softBlocked, blocked: blocked};
                        }
                    }
                });
            }
        };

        $rootScope.handleServerMessage = function(message, messageData, options) {
            if (message.type == 'module') {
                options.sendServerChangeEvent = false;
                $rootScope.refetchCurrentStaff().success(function() {
                    $rootScope.$broadcast('serverChange', message);
                });
                return;
            } else if (message.type == 'workoutbookingsettings') {
                angular.copy(messageData, $rootScope.workoutbookingsettings);
                options.runApply = true;
            } else if (message.type == 'image') {
                if (messageData.type == 'user' || messageData.type == 'member' || messageData.type == 'staff') {
                    var user = $rootScope.getMember(messageData.id);
                    if (user) {
                        user.randomimage = Math.random().toString(36).substring(7);
                    }
                    if (messageData.id == $rootScope.currentStaffId) {
                        $rootScope.currentStaff.randomimage = Math.random().toString(36).substring(7);
                    }
                } else if (messageData.type == 'product') {
                    var product = $rootScope.getPointerById(messageData.id, $rootScope.trainingcardtypes);
                    if (product) {
                        product.randomimage = Math.random().toString(36).substring(7);
                    }
                }
                options.runApply = true;
            } else if (message.type == 'entry') {
                var member = $rootScope.getMember(messageData.Member.id);
                if (member) {
                    messageData.Member = member;
                }

                $rootScope.transformEntry(messageData);
                if(message.action === 'change') {
                    var index = _.findIndex($rootScope.entries, function(e) {return e.id === messageData.id;});
                    if(index >= 0) {$rootScope.entries[index] = messageData;}
                    else {$rootScope.entries.push(messageData);}
                } else {
                    $rootScope.entries.push(messageData);
                }
                options.runApply = true;
            } else if (message.type == 'usersession') {
                if (message.action == 'remove' && messageData.session == $rootScope.currentSession) {
                    $rootScope.whenLoggedOut();
                } else if (message.action == 'change' && messageData.session == $rootScope.currentSession) {
                    if (messageData.site_id) {
                        $rootScope.setSite(messageData.site_id);
                        options.runApply = true;
                    }
                }
            } else if (message.type == 'userstatuschange' && message.action == 'add') {
                var member = $rootScope.getMember(messageData.member_id);
                if (member) {
                    member.lastStatusChange = Date.newFull(messageData.date);
                }
            } else if (message.type == 'apifail') {
                console.log('API fail:');
                angular.forEach(message.data, function(a) {
                    console.log(JSON.stringify(a, null, 4));
                });
            } else if (message.type == 'paymentmethodsettings') {
                $rootScope.paymentMethodSettings = messageData;
                $rootScope.fetchPaymentMethods();
            } else {
                var getName = function(type) {
                    if (type.endsWith('y')) {
                        return type.substring(0, type.length-1) + 'ies';
                    } else if (type == 'userstatus') {
                        return 'memberstatuses';
                    }
                    return type + 's';
                };

                var name = getName(message.type);
                if ($rootScope[name] || message.type == 'workoutbooking' || message.type == 'trainingcard' || message.type == 'payment' || message.type == 'workout') {
                    // Special cases first
                    if (message.type == 'user' && messageData.id == $rootScope.currentStaffId) {
                        if (messageData.language) {
                            $translate.use(messageData.language);
                        }
                        var settings = Object.assign({}, $rootScope.currentStaff);
                        angular.copy(messageData, $rootScope.currentStaff);
                        $rootScope.currentStaff._settingFields = settings._settingFields;
                        settings._settingFields.forEach(function(k) {
                            $rootScope.currentStaff[k] = settings[k];
                        });
                    }

                    var array;
                    if (message.type == 'workout') {
                        array = workoutProvider.workouts;
                    } else if (message.type == 'workoutbooking') {
                        var workout = _.findWhere(workoutProvider.workouts, {id: messageData.workout});
                        if (workout) {
                            array = workout.bookings;
                        }
                        // Else: Ignore workout booking changes for workouts we don't have
                    } else if (message.type == 'field') {
                        $rootScope.fields = messageData;
                    } else {
                        array = $rootScope[name];
                    }

                    if (array) {
                        // Generic change
                        if (message.action == 'change') {
                            var match = _.findWhere(array, {id: messageData.id});
                            if (match) {
                                if (message.type == 'user' || message.type == 'trainingcardtype') {
                                    messageData.randomimage = match.randomimage;
                                    messageData.lastStatusChange = match.lastStatusChange;
                                }

                                angular.copy(messageData, match);

                                // FIXME: Generic transform function for all types?
                                if (message.type == 'workout') {
                                    $rootScope.transformWorkout(match);
                                } else if (message.type == 'trainingcard') {
                                    $rootScope.transformTrainingCard(match);
                                } else if (message.type == 'trainingcardtype') {
                                    $rootScope.transformTrainingCardType(match);
                                } else if (message.type == 'user') {
                                    $rootScope.transformMember(match);
                                } else if (message.type == 'workoutbooking') {
                                    $rootScope.transformWorkoutBooking(match);
                                } else if (message.type == 'payment') {
                                    $rootScope.transformPayment(match);
                                } else if (message.type == 'resourcebookingservice') {
                                    $rootScope.transformResourceBookingService(match);
                                } else if (message.type == 'cashregister') {
                                    $rootScope.transformCashier(match);
                                } else if (message.type == 'paymentmethod') {
                                    $rootScope.transformPaymentMethod(match);
                                } else if (message.type == 'role') {
                                    $rootScope.transformRole(match);
                                } else if (message.type == 'dashboard') {
                                    $rootScope.transformDashboard(match);
                                } else if (message.type == 'usergroup') {
                                    $rootScope.transformUserGroup(match);
                                }
                            }
                        // Generic add
                        } else if (message.action == 'add') {
                            if (message.type == 'workout') {
                                $rootScope.transformWorkout(messageData);
                            } else if (message.type == 'trainingcard') {
                                $rootScope.transformTrainingCard(messageData);
                            } else if (message.type == 'trainingcardtype') {
                                $rootScope.transformTrainingCardType(messageData);
                            } else if (message.type == 'user') {
                                $rootScope.transformMember(messageData);
                            } else if (message.type == 'workoutbooking') {
                                $rootScope.transformWorkoutBooking(messageData);
                            } else if (message.type == 'payment') {
                                $rootScope.transformPayment(messageData);
                            } else if (message.type == 'resourcebookingservice') {
                                $rootScope.transformResourceBookingService(messageData);
                            } else if (message.type == 'cashregister') {
                                $rootScope.transformCashier(messageData);
                            } else if (message.type == 'paymentmethod') {
                                $rootScope.transformPaymentMethod(messageData);
                            } else if (message.type == 'usergroup') {
                                $rootScope.transformUserGroup(messageData);
                            }
                            array.push(messageData);
                        // Generic remove
                        } else if (message.action == 'remove') {
                            for (var i=0; i < array.length; ++i) {
                                if (array[i].id == messageData.id) {
                                    array.splice(i, 1);
                                    break;
                                }
                            }
                        }

                        options.runApply = true;
                    }
                }
            }

            if (message.type == 'workoutbooking') {
                workoutProvider.updateWorkout(messageData.workout);
            } else if (message.type == 'workouttype') {
                workoutProvider.updateWorkoutType(messageData.id);
            } else if (message.type == 'user') {
                $rootScope.setStaffsFromUsers();
            } else if (message.type == 'resourcebookingcategory') {
                $rootScope.resourcebookingcategories = $rootScope.resourcebookingcategories.sort(function(a, b) {
                    return a.order - b.order;
                });
            }
        };

        $rootScope.waitFor = function(types) {
            var deferred = $q.defer();

            var loaded = _.keys($rootScope.loaded);
            var missing = _.difference(types, loaded);

            var getResultData = function() {
                if (types.length == 1) {
                    return $rootScope[types[0]];
                }
            };

            if (missing.length) {
                for (var i= 0; i < missing.length; i++) {
                    missing[i] = 'loaded.' + missing[i];
                }
                var w = missing.join(' && ');

                var watchHandle = $rootScope.$watch(w, function(newValue) {
                    if (newValue) {
                        deferred.resolve(getResultData());
                        watchHandle();
                    }
                });
            } else {
                deferred.resolve(getResultData());
            }

            return deferred.promise;
        };

        $rootScope.getPointer = function(dataItem, pointToArray) {
            if (!dataItem) {
                return dataItem;
            }

            return $rootScope.getPointerById(dataItem.id, pointToArray);
        };

        $rootScope.getPointerById = function(id, pointToArray) {
            if ($rootScope.speedy) {
                if (pointToArray == $rootScope.trainingcardtypes) {
                    return ApiDataLoader.getDataImmediately('trainingcardtype', id);
                } else if (pointToArray == $rootScope.users || pointToArray == $rootScope.members || pointToArray == $rootScope.staffs) {
                    return ApiDataLoader.getDataImmediately('user', id);
                } else if (pointToArray == $rootScope.usergroups) {
                    return ApiDataLoader.getDataImmediately('usergroup', id);
                }
            }

            return _.findWhere(pointToArray, {id: id});
        };

        $rootScope.updatePointers = function(dataArray, pointToArray) {
            for (var i=0; i < dataArray.length; ++i) {
                dataArray[i] = $rootScope.getPointer(dataArray[i], pointToArray);
                if (dataArray[i] == null || dataArray[i] == undefined) {
                    dataArray.splice(i, 1);
                    --i;
                }
            }

            return dataArray;
        };

        $rootScope.updatePointersById = function(dataArray, pointToArray) {
            for (var i=0; i < dataArray.length; ++i) {
                // Skip if already transformed (is an object, not just an ID number)
                if (typeof dataArray[i] === 'object' && dataArray[i] !== null) {
                    continue;
                }

                dataArray[i] = $rootScope.getPointerById(dataArray[i], pointToArray);
                if (dataArray[i] == null || dataArray[i] == undefined) {
                    dataArray.splice(i, 1);
                    --i;
                }
            }

            return dataArray;
        };

        $rootScope.getBodyStyle = function() {
            if ($rootScope.useTransparentBackgroundColor) {
                return {'background-color': 'transparent'};
            } else if ($location.path().indexOf('/pages/') != -1) {
                return {'background-color': $rootScope.backgroundColor, 'color': $rootScope.textColor};
            } else if ($location.path().indexOf('/settings/addons') != -1) {
                return {'background-color': 'white' };
            }
        };

        $rootScope.getItemListText = function(items, itemTypes, countLimit) {
            if (!itemTypes) {
                itemTypes = ['customer'];
            }
            var itemType = itemTypes[0];
            itemType += 's';
            if (itemTypes.length > 1) {
                itemType = 'selected';
            }

            var count = items ? items.length : 0;
            if (countLimit == null) {
                countLimit = 3;
            }
            if (count == 0 || count > countLimit) {
                return count + ' ' + $filter('translate')(itemType);
            }

            return formatter.format('commaList', items);
        };

        $rootScope.main = {};
        $rootScope.setBrand = function(brand) {
            document.title = brand;
            $rootScope.main.brand = brand;
        };

        $rootScope.setDataFromStaff = function(data) {
            $rootScope.customStyling = data.customStyling;
            $rootScope.backgroundColor = data.backgroundColor;
            $rootScope.textColor = data.textColor;
            $rootScope.confirmMemberCreate = data.confirmMemberCreate;
            $rootScope.servicebureau = data.servicebureau;
            $rootScope.accountingJournals = data.accountingJournals;
            $rootScope.autoconfirm = data.autoconfirm;
            $rootScope.setBrand(data.brand);
            $rootScope.isTestSystem = data.test;
            $rootScope.myIp = data.ip;
            $rootScope.superUserId = data.superUserId;
            $rootScope.setSite(data.site);
            $rootScope.limitStaffSiteAccess = data.limitStaffSiteAccess;
            $rootScope.longaccounts = data.longaccounts;
            $rootScope.vatexempt = data.vatexempt;
            $rootScope.termsRequired = data.termsRequired;
            $rootScope.extendedTidomatIntegration = data.extendedTidomatIntegration;
            $rootScope.auto_remove_users = data.auto_remove_users;
            $rootScope.login_options = data.login;
            $rootScope.systemBlocked(data.softBlocked, data.blocked, data.superUser);
            $rootScope.sparMode = data.sparMode;
            $rootScope.cardpaymentkey = data.cardpaymentkey;
            $rootScope.billingDay = data.billingDay;
            $rootScope.is_korpen = data.is_korpen;
            $rootScope.zoeziMyBusiness = data.zoeziMyBusiness == 'disabled' ? null : data.zoeziMyBusiness;
            $rootScope.allowAutogiroSend = data.allowAutogiroSend;
            $rootScope.advancedResourcePlanning = data.advancedResourcePlanning;
            $rootScope.warnings_enabled = data.warnings_enabled;
            $rootScope.flags = data.flags;
            $rootScope.adyen = data.adyen;
            $rootScope.onFlagsChanged();
        };

        $rootScope.onFlagsChanged = function() {
            $rootScope.speedy = $rootScope.hasFlag('flag-speedy') || localStorage.getItem('zoezi-staff-speedup') == 'true';
        };

        var initFbHash = window.location.hash;
        $rootScope.init = function() {
            $rootScope.loaded = {};
            $rootScope.startedModules = [];
            $rootScope.currentStaffPermissions = [];
            $rootScope.members = [];
            $rootScope.printers = [];
            $rootScope.staffs = [];
            $rootScope.roles = [];
            $rootScope.workouttypes = [];
            $rootScope.workoutcategories = [];
            $rootScope.coursecategories = [];
            $rootScope.trainingcardtypes = [];
            $rootScope.entries = [];
            $rootScope.workoutbookingsettings = {};
            $rootScope.resourcebookingcategories = [];
            $rootScope.resourcebookingservices = [];
            $rootScope.memberstatuses = [];
            $rootScope.unconfirmedResourceBookings = [];
            $rootScope.fields = { user: [] };
            $rootScope.cashregisters = [];
            $rootScope.usergroups = [];
            $rootScope.valueAddedTax = [ { id: '0', name: '0%' }, { id: '6', name: '6%' }, { id: '12', name: '12%' }, { id: '25', name: '25%' } ];
            $rootScope.accounts = [];
            $rootScope.systemtags = [];
            $rootScope.mailinghandlers = [];
            $rootScope.reports = [];

            util.setTextAngularOptions();

            $rootScope.hasDoneInitialUserCheck = false;
            $http.get('/api/staff/get/current').success(function(data) {
                $rootScope.whenAuthenticated(data);
                $rootScope.hasDoneInitialUserCheck = true;
            }).error(function(data) {
                $rootScope.setDataFromStaff(data);
                $rootScope.hasDoneInitialUserCheck = true;

                if ($location.path() != '/pages/signin' && $location.path() != '/pages/forgot' && $location.path().indexOf('/pages/resetpassword') != 0 && $location.path().indexOf('/pages/setpassword') != 0 && $location.path() != '/pages/newsite') {
                    var signin;
                    if($rootScope.login_options && $rootScope.login_options.facebook) {
                        facebook.setup({
                            fbzoezi: $rootScope.login_options.facebook_zoezi,
                            appId: $rootScope.login_options.facebook_appid,
                            continueLogin: function(state, access_token) {
                                signin = true;
                                server.post('/api/staff/fblogin', null, {token: access_token}).then(function(response) {
                                    signin = false;
                                    if (response.success) {
                                        $rootScope.whenAuthenticated(response.data);
                                    } else {
                                        alertProvider.show('error', response.data && response.data.message || 'Error', true);
                                        $rootScope.showLogin();
                                    }
                                });
                            }
                        });

                        if(initFbHash) {
                            facebook.checkLoginStatus(initFbHash);
                            initFbHash = null;
                        }
                    }

                    if(!signin) {
                        $rootScope.showLogin();
                    }
                }

                if(!live.isActive()) {
                    live.start({
                        url: 'wss://' + window.location.host + $rootScope.ASYNCAPI + '?type=public',
                        handleMessage: $rootScope.handleServerMessage
                    });
                }
            });

            $rootScope.setupKeypressListener();
            window.shortcut.add('ctrl+m', function() {
                if ($rootScope.parentHandlesShortcuts) {
                    $rootScope.handleShortcut('ctrl+m');
                } else {
                    $rootScope.switchToMemberPage();
                }
            });

            window.shortcut.add('ctrl+q', function() {
                if ($rootScope.hasFlag('flag-speedy')) {
                    return;
                }
                const speedy = $rootScope.speedy;
                let newSpeedy = !speedy;

                if (newSpeedy) {
                    confirm.show('Vill du aktivera en experimentell version som är tänkt att fungera snabbare mot en stor kunddatabas? Tryck Ctrl + Q för att växla tillbaka.', { yesButtonText: 'Ja, prova', noButtonText: 'No, continue' }).then(() => {
                        localStorage.setItem('zoezi-staff-speedup', newSpeedy ? 'true' : 'false');
                        window.location.reload();
                    });
                } else {
                    confirm.show('Vill du växla tillbaka till standardversionen? Tryck Ctrl + Q för att växla tillbaka till den experimentella versionen.', { yesButtonText: 'Ja, standard tack', noButtonText: 'No, continue' }).then(() => {
                        localStorage.setItem('zoezi-staff-speedup', newSpeedy ? 'true' : 'false');
                        window.location.reload();
                    });
                }
            });

            window.addEventListener("message", function(event) {
                var addoniframe = $location.path().startsWith('/settings/addons') || $location.path().startsWith('/addon/shop');
                if (addoniframe && event.data) {
                    if (event.data.type == 'addon') {
                        $location.search('addon', event.data.addon_id);
                        $rootScope.$apply();
                    } else if (event.data.type == 'shortcut') {
                        if (window.shortcut.all_shortcuts[event.data.shortcut]) {
                            window.shortcut.all_shortcuts[event.data.shortcut].realcallback();
                        }
                    }
                }
                var getStartedIframe = $location.path().startsWith('/get-started');
                if (getStartedIframe && event.data) {
                    if (event.data.type == 'guide') {
                        $rootScope.startGuide(event.data.guide);
                    } else if (event.data.type == 'reload') {
                        window.location.reload();
                    }
                }
            }, false);

            $rootScope.setupConnectionToParent();
        };

        $rootScope.setupConnectionToParent = function() {
            if (!util.isInIframe()) {
                return;
            }

            let connection = Penpal.connectToParent({
                parentOrigin: `https://${window.location.hostname}`,
                // Methods child is exposing to parent.
                methods: {
                    navigate(path) {
                        if ($location.url() === path) { return; }
                        if ($location.path() !== path.split('?')[0]) {
                            modalUtils.forceCloseAllModals();
                        }
                        $location.url(path);
                        $rootScope.$apply();
                    },
                    forceCloseAllModals() {
                        modalUtils.forceCloseAllModals();
                    },
                    addCustomer() {
                        if (!$rootScope.dialogOnlyMode) modalUtils.forceCloseAllModals();
                        $rootScope.waitFor(['paymentmethods']).then(() => {
                            $modal.open({
                                templateUrl: 'views/addcombomodal.html',
                                controller: 'ComboAddModalCtrl',
                                resolve: {
                                    options: () => ({ minimal: false })
                                }
                            }).result.then(
                                (data) => $rootScope.penpalParent?.onDialogClosed(data || {}),
                                () => $rootScope.penpalParent?.onDialogClosed({})
                            );
                        });
                    },
                    addStaff() {
                        if (!$rootScope.dialogOnlyMode) modalUtils.forceCloseAllModals();
                        $modal.open({
                            templateUrl: 'views/addmodal.html',
                            controller: 'StaffAddModalCtrl'
                        }).result.then(
                            (data) => $rootScope.penpalParent?.onDialogClosed(data || {}),
                            () => $rootScope.penpalParent?.onDialogClosed({})
                        );
                    },
                    addTodo() {
                        if (!$rootScope.dialogOnlyMode) modalUtils.forceCloseAllModals();
                        $modal.open({
                            templateUrl: 'views/addmodal.html',
                            controller: 'ToDoModalAddCtrl',
                            resolve: {
                                options: () => ({})
                            }
                        }).result.catch(() => {}).finally(() => $rootScope.penpalParent?.onDialogClosed({}));
                    },
                    addWorkout() {
                        if (!$rootScope.dialogOnlyMode) modalUtils.forceCloseAllModals();
                        $rootScope.waitFor(['startedModules']).then(() => {
                            util.showDataDialog({
                                controller: 'WorkoutDataCtrl',
                                initial: {
                                    date: Date.today(),
                                    startTime: Date.newTime('18:00'),
                                    endTime: Date.newTime('19:00')
                                }
                            }).result.catch(() => {}).finally(() => $rootScope.penpalParent?.onDialogClosed({}));
                        });
                    },
                    setTransparentBackgroundColor(value) {
                        $rootScope.useTransparentBackgroundColor = value;
                        $rootScope.$apply();
                    },
                    setSite(site_id) {
                        $rootScope.waitFor(['sites']).then(() => {
                            let site = $rootScope.sites.find(site => site.id === Number(site_id));
                            if (site && $rootScope.selectedSite?.id !== site.id) {
                                $rootScope.setSiteOnServer(site, {notifyParent: false});
                            }
                        });
                    },
                    showWorkout(workout_id) {
                        modalUtils.forceCloseAllModals();
                        workoutProvider.getWorkoutById(workout_id)
                            .then(function(workout) {
                                return $rootScope.showWorkout(workout)
                                    .result.catch(() => {});
                            })
                            .catch(() => {})
                            .finally(() => $rootScope.penpalParent?.onDialogClosed({}));
                    },
                    addService() {
                        if (!$rootScope.dialogOnlyMode) modalUtils.forceCloseAllModals();
                        util.showDataDialog({controller: 'ServiceDataCtrl', windowClass: 'large-modal-window'})
                            .result.catch(() => {}).finally(() => $rootScope.penpalParent?.onDialogClosed({}));
                    },
                    addTrainingCardType() {
                        if (!$rootScope.dialogOnlyMode) modalUtils.forceCloseAllModals();
                        $modal.open({
                            templateUrl: 'views/addmodal.html',
                            controller: 'TrainingCardTypeAddCtrl',
                            resolve: {
                                trainingCardType: () => ({
                                    vat: _.findWhere($rootScope.valueAddedTax, {id: '6'}),
                                    validTime: 1,
                                    validType: 'Year',
                                    priceType: 'Month',
                                    customerCanBuy: true,
                                    showSelfCheckout: true,
                                    workout: true,
                                    entry: true
                                })
                            }
                        }).result.catch(() => {}).finally(() => $rootScope.penpalParent?.onDialogClosed({}));
                    },
                    addDiscount() {
                        if (!$rootScope.dialogOnlyMode) modalUtils.forceCloseAllModals();
                        util.showDataDialog({controller: 'DiscountDataCtrl'})
                            .result.catch(() => {}).finally(() => $rootScope.penpalParent?.onDialogClosed({}));
                    },
                    addProduct() {
                        if (!$rootScope.dialogOnlyMode) modalUtils.forceCloseAllModals();
                        util.showDataDialog({controller: 'ProductDataCtrl'})
                            .result.catch(() => {}).finally(() => $rootScope.penpalParent?.onDialogClosed({}));
                    },
                    addPunchCard() {
                        if (!$rootScope.dialogOnlyMode) modalUtils.forceCloseAllModals();
                        util.showDataDialog({controller: 'ResourceBookingCardDataCtrl'})
                            .result.catch(() => {}).finally(() => $rootScope.penpalParent?.onDialogClosed({}));
                    },
                    addGroup() {
                        if (!$rootScope.dialogOnlyMode) modalUtils.forceCloseAllModals();
                        util.showDataDialog({controller: 'UserGroupDataCtrl'})
                            .result.catch(() => {}).finally(() => $rootScope.penpalParent?.onDialogClosed({}));
                    },
                    editGroup(group) {
                        if (!$rootScope.dialogOnlyMode) modalUtils.forceCloseAllModals();
                        $rootScope.getGroupAsync(group.id).then(fullGroup => {
                            util.showDataDialog({controller: 'UserGroupDataCtrl', item: fullGroup})
                                .result.catch(() => {}).finally(() => $rootScope.penpalParent?.onDialogClosed({}));
                        });
                        if (!$rootScope.$$phase) $rootScope.$apply();
                    },
                    addCourse() {
                        if (!$rootScope.dialogOnlyMode) modalUtils.forceCloseAllModals();
                        util.showDataDialog({controller: 'CourseDataCtrl', windowClass: 'large-modal-window'})
                            .result.catch(() => {}).finally(() => $rootScope.penpalParent?.onDialogClosed({}));
                    },
                    showResourceBooking(id) {
                        modalUtils.forceCloseAllModals();
                        $rootScope.showRBooking({id})
                            .then(modal => modal.result.catch(() => {}))
                            .catch(() => {})
                            .finally(() => $rootScope.penpalParent?.onDialogClosed({}));
                    },
                    showGroup(group) {
                        modalUtils.forceCloseAllModals();
                        Promise.resolve($rootScope.showGroup(group).result)
                            .catch(() => {})
                            .finally(() => $rootScope.penpalParent?.onDialogClosed({}));
                    },
                    addWorkoutBooking(customer_id) {
                        modalUtils.forceCloseAllModals();
                        $modal.open({
                            templateUrl: 'views/addbookingmodal.html',
                            controller: 'BookingAddModalCtrl',
                            resolve: {
                                customer: function() {
                                    return $rootScope.getMember(customer_id);
                                }
                            }
                        }).result.catch(() => {}).finally(() => $rootScope.penpalParent?.onDialogClosed({}));
                    },
                    addCourseBooking(customer_id) {
                        modalUtils.forceCloseAllModals();
                        $modal.open({
                            templateUrl: 'views/coursebookingaddmodal.html',
                            controller: 'CourseBookingAddCtrl',
                            resolve: {
                                options: function() {
                                    return {
                                        customer: $rootScope.getMember(customer_id),
                                        course: null
                                    };
                                }
                            }
                        }).result.catch(() => {}).finally(() => $rootScope.penpalParent?.onDialogClosed({}));
                    },
                    addPayment(customer_id) {
                        modalUtils.forceCloseAllModals();
                        $modal.open({
                            templateUrl: 'views/addmodal.html',
                            controller: 'PaymentAddModalCtrl',
                            resolve: {
                                customer: function() {
                                    return $rootScope.getMember(customer_id);
                                }
                            }
                        }).result.catch(() => {}).finally(() => $rootScope.penpalParent?.onDialogClosed({}));
                    },
                    addTrainingCard(customer_id) {
                        modalUtils.forceCloseAllModals();
                        // Route through openTrainingCardSale so flag-staffnext-checkout
                        // opens the StaffNext dialog here too. That path returns no
                        // modal — the StaffNext side owns the dialog lifecycle, so
                        // onDialogClosed only applies to the legacy combo modal.
                        $rootScope.openTrainingCardSale($rootScope.getMember(customer_id))
                            ?.result.catch(() => {}).finally(() => $rootScope.penpalParent?.onDialogClosed({}));
                    },
                    addResourceBooking(customer_id, service_id) {
                        modalUtils.forceCloseAllModals();
                        let category = $rootScope.resourcebookingcategories.find(category => category.id === service_id);

                        $modal.open({
                            templateUrl: category.multiBooking ? 'views/rbookingmultimodal.html' : 'views/rbookingmodal.html',
                            controller: category.multiBooking ? 'ResourceBookingMultiBookModalCtrl' : 'ResourceBookingBookModalCtrl',
                            windowClass: 'huge-modal-window',
                            resolve: {
                                category: function() {
                                    return category;
                                },
                                customer: function() {
                                    return $rootScope.getMember(customer_id);
                                }
                            }
                        }).result.catch(() => {}).finally(() => $rootScope.penpalParent?.onDialogClosed({}));
                    },
                    initExpoApp(devicePlatform) {
                        window.isApp = true;
                        window.isExpoApp = true;
                        window.expoDevicePlatform = devicePlatform;

                        // For debugging in Expo development app
                        console.log = function() {
                            $rootScope.expoPostMessage("log", arguments);
                        };
                        console.error = function() {
                            $rootScope.expoPostMessage("error", arguments);
                        };
                        console.warn = function() {
                            $rootScope.expoPostMessage("warn", arguments);
                        };
                        console.info = function() {
                            $rootScope.expoPostMessage("info", arguments);
                        };
                        console.debug = function() {
                            $rootScope.expoPostMessage("debug", arguments);
                        };
                    },
                    refreshTranslations() {
                        $translate.refresh();
                    },
                    // Dialog mode methods for Vue3 integration
                    enterDialogMode() {
                        $rootScope.dialogOnlyMode = true;
                        document.body.classList.add('dialog-only-mode');
                        $rootScope.$apply();
                    },
                    exitDialogMode() {
                        $rootScope.dialogOnlyMode = false;
                        document.body.classList.remove('dialog-only-mode');
                        $rootScope.$apply();
                    },
                    openMemberStatusAddDialog() {
                        $modal.open({
                            templateUrl: 'views/addmodal.html',
                            controller: 'MemberStatusAddModalCtrl'
                        }).result.catch(() => {}).finally(() => $rootScope.penpalParent?.onDialogClosed({}));
                    },
                    openMemberStatusChangeDialog(status) {
                        $modal.open({
                            templateUrl: 'views/changemodal.html',
                            controller: 'MemberStatusChangeModalCtrl',
                            resolve: { status: () => status }
                        }).result.catch(() => {}).finally(() => $rootScope.penpalParent?.onDialogClosed({}));
                    },
                    openInterestAddDialog() {
                        $modal.open({
                            templateUrl: 'views/addmodal.html',
                            controller: 'InterestAddModalCtrl'
                        }).result.catch(() => {}).finally(() => $rootScope.penpalParent?.onDialogClosed({}));
                    },
                    openInterestChangeDialog(item) {
                        $modal.open({
                            templateUrl: 'views/changemodal.html',
                            controller: 'InterestChangeModalCtrl',
                            resolve: { item: () => item }
                        }).result.catch(() => {}).finally(() => $rootScope.penpalParent?.onDialogClosed({}));
                    },
                    openCashRegisterChangeDialog(cashregister) {
                        if (!$rootScope.dialogOnlyMode) modalUtils.forceCloseAllModals();
                        $modal.open({
                            templateUrl: 'views/changemodal.html',
                            controller: 'CashRegisterChangeModalCtrl',
                            resolve: { cashregister: () => cashregister }
                        }).result.catch(() => {}).finally(() => $rootScope.penpalParent?.onDialogClosed({}));
                    },
                    openMoveMatchDialog(params) {
                        if (!$rootScope.dialogOnlyMode) modalUtils.forceCloseAllModals();
                        $rootScope.waitFor(['members']).then(function() {
                            server.get('/api/teamsport/match/get', {id: params.matchId}).then(function(m) {
                                var match = $injector.get('teamsportutil').transformMatch(m);
                                $modal.open({
                                    templateUrl: 'views/teamsportmovematchmodal.html',
                                    windowClass: 'huge-modal-window',
                                    controller: 'TeamSportMoveMatchModalCtrl',
                                    resolve: {
                                        match: function() { return match; },
                                        options: function() { return { matches: params.matches || [] }; }
                                    }
                                }).result.catch(() => {}).finally(() => $rootScope.penpalParent?.onDialogClosed({}));
                            });
                        });
                    },
                    openSetRefereeDialog(params) {
                        if (!$rootScope.dialogOnlyMode) modalUtils.forceCloseAllModals();
                        $rootScope.waitFor(['members']).then(function() {
                            $modal.open({
                                templateUrl: 'views/getcustomermodal.html',
                                windowClass: 'huge-modal-window',
                                controller: 'GetCustomerCtrl',
                                resolve: {
                                    options: function() {
                                        return {
                                            multiple: true,
                                            selected: params.referees || []
                                        };
                                    }
                                }
                            }).result.then(function(customers) {
                                server.post('/api/teamsport/match/setreferee', null,
                                    {id: params.matchId, referee_id: _.pluck(customers, 'id')},
                                    'Information saved', 'Failed to save information'
                                ).then(function() {
                                    $rootScope.penpalParent?.onDialogClosed({});
                                });
                            }).catch(() => $rootScope.penpalParent?.onDialogClosed({}));
                        });
                    },
                    openAddSuspensionDialog() {
                        if (!$rootScope.dialogOnlyMode) modalUtils.forceCloseAllModals();
                        $modal.open({
                            templateUrl: 'views/teamsportaddsuspension.html',
                            controller: 'TeamSportAddSuspensionCtrl',
                        }).result.catch(() => {}).finally(() => $rootScope.penpalParent?.onDialogClosed({}));
                    },
                    openTodoDialog(params) {
                        if (!$rootScope.dialogOnlyMode) modalUtils.forceCloseAllModals();
                        $rootScope.waitFor(['staffs', 'members', 'sites']).then(function() {
                            var openDialog = function(todo) {
                                $rootScope.transformTodo(todo);
                                $rootScope._todoFollowUpDialog = false;
                                $modal.open({
                                    templateUrl: 'views/todomodal.html',
                                    controller: 'ToDoModalCtrl',
                                    resolve: { todo: () => todo }
                                }).result.catch(() => {}).finally(() => {
                                    if (!$rootScope._todoFollowUpDialog) {
                                        $rootScope.penpalParent?.onDialogClosed({});
                                    }
                                });
                            };
                            if (params.todo) {
                                openDialog(params.todo);
                            } else {
                                server.get('/api/todo/getById', { id: params.id }).then(openDialog);
                            }
                        });
                    },
                    openTodoEditDialog(params) {
                        if (!$rootScope.dialogOnlyMode) modalUtils.forceCloseAllModals();
                        $rootScope.waitFor(['staffs', 'members', 'sites']).then(function() {
                            var openDialog = function(todo) {
                                $rootScope.transformTodo(todo);
                                $modal.open({
                                    templateUrl: 'views/todoeditmodal.html',
                                    controller: 'ToDoChangeModalCtrl',
                                    resolve: { todo: () => todo }
                                }).result.catch(() => {}).finally(() => $rootScope.penpalParent?.onDialogClosed({}));
                            };
                            if (params.todo) {
                                openDialog(params.todo);
                            } else {
                                server.get('/api/todo/getById', { id: params.id }).then(openDialog);
                            }
                        });
                    }
                }
            });

            connection.promise.then((parent) => {
                // Store parent reference for dialog callbacks
                $rootScope.penpalParent = parent;
                $rootScope.staffnext = true;
                $rootScope.forceHideMenu = true;
                $rootScope.parentHandlesToast = true;
                $rootScope.parentHandlesShortcuts = true;
                $rootScope.parentHandlesSwitchToMemberPage = true;

                document.addEventListener('click', () => {
                    parent.click();
                }, true); // true for capturing

                $rootScope.handleToast = (toast) => {
                    parent.toast(toast);
                };

                $rootScope.handleShortcut = (keyString) => {
                    parent.shortcut(keyString);
                };

                $rootScope.handleSwitchToMemberPage = (zoeziMyBusiness) => {
                    parent.switchToMemberPage(zoeziMyBusiness);
                };

                // Register Ctrl+S shortcut for search when connected to parent
                window.shortcut.add('ctrl+s', function() {
                    $rootScope.handleShortcut('ctrl+s');
                });

                $rootScope.$on("$locationChangeSuccess", () => {
                    // Strip iframe-internal flags injected by the parent at boot so they
                    // don't leak back out into the parent URL or copied links.
                    let search = Object.assign({}, $location.search());
                    delete search.hidemenu;
                    delete search.alwaysreplace;
                    let params = new URLSearchParams();
                    Object.keys(search).forEach(k => {
                        let v = search[k];
                        if (Array.isArray(v)) v.forEach(x => params.append(k, x));
                        else if (v === true) params.append(k, '');
                        else params.append(k, v);
                    });
                    let qs = params.toString();
                    let path = $location.path() + (qs ? '?' + qs : '');
                    parent.navigate(path);

                    // A dialog opened from a StaffNext page navigates by changing our
                    // location, which the parent otherwise ignores because it isn't on
                    // an Angular page. Tell it separately so the navigation isn't lost.
                    if ($rootScope.dialogOnlyMode) {
                        parent.navigateFromDialog?.(path);
                    }
                });

                $rootScope.waitFor(['members', 'usergroups', 'memberstatuses', 'roles', 'sites']).then(() => {
                    parent.loaded();
                });

                $rootScope.expoPostMessage = function (type, data) {
                    if (!$rootScope.isExpoApp || !$rootScope.isExpoApp()) { return; }
                    if (!type) { return; }

                    let message = JSON.stringify({type, data});
                    parent.expoPostMessage(message);
                };
            });
        };

        $rootScope.showLogin = function(mail, password) {
            return $modal.open({
                templateUrl: 'views/member/login.html',
                controller: 'LoginModalCtrl',
                keyboard: false,
                backdrop: 'static',
                resolve: {
                    options: function() {
                        return {
                            mail: mail,
                            password: password,
                            settings: $rootScope.login_options,
                            canClose: false
                        };
                    }
                }
            });
        };

        $rootScope.setupKeypressListener = function(waittime) {
            if (!waittime) {waittime = 500;}
            var waitingForMore = null;
            $document.unbind('keypress');
            $document.bind('keypress', function(e) {
                var send = true;

                if (e.which == 13) {
                    send = false;
                    waitingForMore = $timeout(function() {
                        $rootScope.$broadcast('keypress', e);
                        waitingForMore = null;
                    }, waittime);
                }
                else if (waitingForMore) {
                    $timeout.cancel(waitingForMore);
                }
                if (send) {
                    $rootScope.$broadcast('keypress', e);
                }
            });

            $document.unbind('keydown');
            $document.bind('keydown', function(e) {
                if ($rootScope.listeningForInput) {
                    if (e.which == 9 && e.preventDefault) {
                        $rootScope.$broadcast('keypress', e);
                        e.preventDefault();
                    }
                } else {
                    if (e.which == 27) {
                        var modal = $modalStack.getTop();
                        if (modal) {
                            if (modal.value.keyboard) {
                                e.preventDefault();
                                $rootScope.$apply(function() {
                                    $modalStack.dismiss(modal.key, 'escape key press');
                                });
                            }
                        }
                    }
                }
            });
        };

        $rootScope.onResourceBookingStarted = function() {
            $http.get('/api/resourcebooking/category/get/all').success(function(data) {
                $rootScope.resourcebookingcategories = data;
                $rootScope.loaded.resourcebookingcategories = true;
            });

            $http.get('/api/resourcebooking/service/get/all').success(function(data) {
                $rootScope.waitFor(['staffs', 'resourcebookingcategories']).then(function() {
                    angular.forEach(data, function(service) {
                        $rootScope.transformResourceBookingService(service);
                    });

                    $rootScope.resourcebookingservices = data;
                    $rootScope.loaded.resourcebookingservices = true;
                });
            });

            $rootScope.waitFor(['resourcebookingservices']).then(function() {
                server.get('/api/trainingcard/type/get/all', {exclude_courses: $rootScope.speedy}).then(function(data) {
                    angular.forEach(data, function(card) {
                        $rootScope.transformTrainingCardType(card);
                    });
                    $rootScope.trainingcardtypes = data;
                    $rootScope.loaded.trainingcardtypes = true;
                    if ($rootScope.speedy) {
                        // A special case for trainingcardtypes which are first loaded here and then dynamically
                        // for any missing types. So the loaded types needs to be fed into ApiDataLoader
                        ApiDataLoader.updateData('trainingcardtype');
                    }
                });
            });

            $http.get('/api/resourcebooking/unconfirmed/get').success(function(data) {
                $rootScope.waitFor(['staffs', 'resourcebookingcategories', 'resourcebookingservices', 'trainingcardtypes', 'members']).then(function() {
                    $rootScope.transformResourceBookings(data);
                    $rootScope.unconfirmedResourceBookings = data.filter(function(rb) { return rb.siblings[0] == rb; });
                });
            });
        };

        $rootScope.onScheduleStarted = function() {
            $http.get('/api/schedule/workout/type/get/all').success(function(data) {
                $rootScope.workouttypes = data;
                $rootScope.loaded.workouttypes = true;
            });

            $http.get('/api/schedule/workout/category/get').success(function(data) {
                $rootScope.workoutcategories = data;
                $rootScope.loaded.workoutcategories = true;
            });
        };

        $rootScope.onCoursesStarted = function() {
            $http.get('/api/course/category/get').success(function(data) {
                $rootScope.coursecategories = data;
                $rootScope.loaded.coursecategories = true;
            });
        };

        $rootScope.onWorkoutBookingStarted = function() {
            $http.get('/api/workoutBooking/settings/get').success(function(data) {
                $rootScope.workoutbookingsettings = data;
                $rootScope.loaded.workoutbookingsettings = true;
            });
        };

        $rootScope.onCheckoutStarted = function() {
            server.get('/api/checkout/cashier/get').then(function(data) {
                $rootScope.waitFor(['sites']).then(function() {
                    angular.forEach(data, function(c) {
                        $rootScope.transformCashier(c);
                    });
                    $rootScope.cashregisters = data;
                    $rootScope.loaded.cashregisters = true;
                });
            });
        };

        $rootScope.setStaffsFromUsers = function() {
            // Check if we have users array. We might get a websocket event very early before we have the users list
            if ($rootScope.users) {
                if (!$rootScope.staffs) {
                    $rootScope.staffs = [];
                }
                const newStaffs = $rootScope.users.filter(u => u.staff || u.type == 'resource' || u.wasStaff);

                // Remove items that are no longer staff
                for (let i = $rootScope.staffs.length - 1; i >= 0; i--) {
                    if (!newStaffs.includes($rootScope.staffs[i])) {
                        $rootScope.staffs.splice(i, 1);
                    }
                }

                // Add new staff items
                newStaffs.forEach(staff => {
                    if (!$rootScope.staffs.includes(staff)) {
                        $rootScope.staffs.push(staff);
                    }
                });
            }
        };

        $rootScope.fetchPaymentMethods = function() {
            server.get('/api/paymentmethod/getAll').then(function(data) {
                $rootScope.paymentmethods = data.map($rootScope.transformPaymentMethod);
                $rootScope.paymentmethods.push( { id: 'multi', name: 'Multiple', imageSrc: '/assets/img/multi.png' } );
                $rootScope.loaded.paymentmethods = true;
            });
        };

        $rootScope.fetchPaymentMethodSettings = function() {
            server.get('/api/settings/paymentmethod/get').then(function(settings) {
                $rootScope.paymentMethodSettings = settings;
                $rootScope.loaded.paymentmethodsettings = true;
            });
        };

        $rootScope.isOwner = function() {
            return $rootScope.currentStaff.superUser || $rootScope.currentStaff.roles.find(function(role) { return role.id == 1; });
        };

        $rootScope.siteAccessFilter = function(site) {
            if (!$rootScope.limitStaffSiteAccess || !site) {
                return true;
            }

            if (_.isNumber(site)) {
                site = $rootScope.sites.find(function(s) { return s.id == site; });
            }

            return $rootScope.isOwner() || $rootScope.currentStaff.sites.indexOf(site.id) != -1;
        };

        $rootScope.whenAuthenticated = function(staff) {
            if ($location.path() == '/pages/signin') {
                var redirect = $location.search().redirect;
                $location.path(redirect || '/');
                $location.search('redirect', null);
            }

            $rootScope.loggedIn = true;

            var loadInitialData = function() {
                var setMembers = function(members) {
                    $rootScope.members = members;
                    for (var i=0; i < members.length; ++i) {
                        $rootScope.transformMember(members[i]);
                    }
                    $rootScope.users = members;
                    $rootScope.setStaffsFromUsers();
                    $rootScope.loaded.members = true;
                    $rootScope.loaded.staffs = true;
                };

                if ($rootScope.speedy) {
                    setMembers([]);
                } else {
                    $http.get('/api/member/get/full').success(function(data) {
                        $rootScope.waitFor(['memberstatuses', 'roles', 'sites']).then(function() {
                            setMembers(data);
                        });
                    });
                }

                $http.get('/api/member/status/get/all').success(function(data) {
                    $rootScope.memberstatuses = data;
                    $rootScope.loaded.memberstatuses = true;
                });

                $http.get('/api/printer/get').success(function(data) {
                    $rootScope.printers = data;
                    $rootScope.loaded.printers = true;
                });

                $http.get('/api/staff/roles').success(function(data) {
                    data.forEach($rootScope.transformRole);
                    $rootScope.roles = data;
                    $rootScope.loaded.roles = true;
                });

                $http.get('/api/site/get/all').success(function(data) {
                    $rootScope.sites = data;
                    $rootScope.loaded.sites = true;
                });

                server.get('/api/settings/fields/get').then(function(data) {
                    $rootScope.fields = data;
                    $rootScope.loaded.fields = true;
                    $rootScope.pubsub.publish('settings.fields', data);
                });

                if ($rootScope.speedy) {
                    $rootScope.usergroups = [];
                    $rootScope.loaded.usergroups = true;
                } else {
                    server.get('/api/usergroup/get/all').then(function(data) {
                        $rootScope.usergroups = data;
                        $rootScope.loaded.usergroups = true;
                    });
                }

                server.get('/api/systemtag/get').then(function(data) {
                    $rootScope.systemtags = data;
                    $rootScope.loaded.systemtags = true;
                });

                server.get('/api/mailing/handler/get').then(function(data) {
                    $rootScope.mailinghandlers = data;
                    $rootScope.loaded.mailinghandlers = true;
                });

                server.post2('/api/trainingcard/category/get').then(function(data) {
                    $rootScope.webshopcategories = data;
                    $rootScope.loaded.webshopcategories = true;
                });

                server.get('/api/dashboard/get', {type: 'default,page'}).then(function(dashboards) {
                    dashboards.forEach($rootScope.transformDashboard);
                    $rootScope.dashboards = dashboards;
                    $rootScope.loaded.dashboards = true;
                });

                server.get('/api/stats/generic/reports/get').then(function(reports) {
                    $rootScope.reports = reports;
                    $rootScope.loaded.reports = true;
                });

                $rootScope.fetchPaymentMethods();
                $rootScope.fetchPaymentMethodSettings();

                $rootScope.lastEntry = undefined;
                $rootScope.waitFor(['startedModules']).then(function() {
                    if ($rootScope.hasPermission('Entry handling')) {
                        server.get('/api/entry/get', {fromDate: Date.today().yyyymmdd(), toDate: Date.today().yyyymmdd(), idOnly: true}).then(function(data) {
                            $rootScope.waitFor(['members', 'staffs']).then(function() {
                                angular.forEach(data, function(e) {
                                    $rootScope.transformEntry(e);
                                });
                                $rootScope.entries = data;
                                $rootScope.loaded.entries = true;
                            });
                        });
                    }

                    if ($rootScope.hasPermission('Show schedule')) {
                        $rootScope.onScheduleStarted();
                        if ($rootScope.hasModule('WorkoutBooking')) {
                            $rootScope.onWorkoutBookingStarted();
                        }

                        if ($rootScope.hasModule('Courses')) {
                            $rootScope.onCoursesStarted();
                        }
                    }

                    var hasRb = $rootScope.hasPermission('Show resource bookings');
                    if (hasRb) {
                        $rootScope.onResourceBookingStarted();
                    } else {
                        $http.get('/api/trainingcard/type/get/all').success(function(data) {
                            angular.forEach(data, function(card) {
                                $rootScope.transformTrainingCardType(card);
                            });
                            $rootScope.trainingcardtypes = data;
                            $rootScope.loaded.trainingcardtypes = true;
                        });
                    }

                    if ($rootScope.hasPermission('Checkout handling')) {
                        $rootScope.onCheckoutStarted();
                    }

                    if ($rootScope.hasPermission('Accounting')) {
                        server.get('/api/economy/costcenter/get').then(function(data) {
                            $rootScope.costcenters = data;
                            $rootScope.loaded.costcenters = true;
                        });

                        server.get('/api/economy/accounts/get').then(function(data) {
                            $rootScope.accounts = data;
                            $rootScope.loaded.accounts = true;
                        });
                    }

                    if ($rootScope.hasModule('CriminalRecordExcerpt') && $rootScope.hasPermission('Criminal record excerpt handling')) {
                        $rootScope.getCriminalRecordExcerpts();
                    }
                });
            };

            var setSessionHash = function() {
                // encode as UTF-8
                var msgBuffer = new TextEncoder().encode($rootScope.currentSession);

                // hash the message
                if(crypto.subtle) {
                    crypto.subtle.digest('SHA-256', msgBuffer).then(function(hashBuffer) {
                        // convert ArrayBuffer to Array
                        var hashArray = Array.from(new Uint8Array(hashBuffer));

                        var toHex = function(b) {
                            return ('00' + b.toString(16)).slice(-2);
                        };

                        // convert bytes to hex string
                        var hashHex = hashArray.map(toHex).join('');
                        $rootScope.currentSessionHash = hashHex;
                    });
                }
            };

            var setStaff = function(data) {
                $rootScope.currentStaff = data;
                $rootScope.trialEnds = Date.newFull(data.trialEnds);
                $rootScope.currentStaffId = data.id;
                $rootScope.startedModules = data.modules;
                $rootScope.currentStaffPermissions = data.permissions;
                $rootScope.stockPerSite = data.stockPerSite;
                $rootScope.requireMembership = data.requireMembership;
                $rootScope.zoeziMyBusiness = data.zoeziMyBusiness == 'disabled' ? null : data.zoeziMyBusiness;
                $rootScope.default_legal_entity_id = data.default_legal_entity_id;

                if (!$rootScope.hasPermission('Admin')) {
                    $rootScope.switchToMemberPage();
                    return;
                }

                $rootScope.currentSession = server.getCookie('session');
                setSessionHash();
                $rootScope.loaded.startedModules = true;

                if (data.missingSettings?.includes('Adyen') && !$rootScope.isSettingMissing('Adyen')) {
                    $rootScope.showCompleteAdyenSetupModal();
                }

                $rootScope.updateMissingSettings(data.missingSettings);

                if (data.language) {
                    $translate.use(data.language);
                }

                if (data.currency) {
                    currency.set(data.currency);
                }

                if ($rootScope.trialEnds && $rootScope.trialEnds < new Date()) {
                    $rootScope.showTrialDialog(false);
                }

                $rootScope.setDataFromStaff(data);

                if($cookies.selectedsite)
                {
                    $rootScope.waitFor(['sites']).then(function ()  {
                        var site = _.findWhere($rootScope.sites, {id: Number($cookies.selectedsite)});
                        $rootScope.setSiteOnServer(site);
                    });
                }

                loadInitialData();

                $rootScope.showNPS();
                $rootScope.showMyBusinessPopup();

                $rootScope.showKorpenMailing();

                Raven.setEnvironment(data.environment);
                if (data.developer) {
                    Raven.setRelease(data.branch);
                    Raven.setTagsContext({ developer: data.developer });
                } else {
                    Raven.setRelease(data.version);
                }
            };

            if (staff) {
                setStaff(staff);
            } else {
                $http.get('/api/staff/get/current').success(function(data) {
                    setStaff(data);
                });
            }

            if ($rootScope.hasPermission('Admin')) {
                live.start({
                    url: 'wss://' + window.location.host + $rootScope.ASYNCAPI + '?type=staff',
                    handleMessage: $rootScope.handleServerMessage
                });

                live.subscribe({
                    type: 'site',
                    action: 'remove',
                    callback: function(site) {
                        if (site.id == $rootScope.selectedSite.id) {
                            $rootScope.selectedSite = _.findWhere($rootScope.sites, {id: 1});
                        }
                    }
                });
            }

            live.subscribe({
                type: 'flag',
                callback: (_, event) => {
                    const flags = $rootScope.flags;
                    if (!flags) return;
                    const action = event.action;
                    const flag = event.data.flag;
                    if (action === 'remove') {
                        $rootScope.flags = flags.filter(f => f !== flag);
                    } else if (action === 'add' && !flags.includes(flag)) {
                        flags.push(flag);
                    }

                    $rootScope.onFlagsChanged();
                }
            });
        };

        $rootScope.whenLoggedOut = function() {
            $window.location.reload();
            $rootScope.expoPostMessage('logout');
        };

        $rootScope.hasFlag = flag => $rootScope.flags?.includes(flag);

        $rootScope.showNPS = function() {
            if ($rootScope.currentStaff && !$rootScope.currentStaff.superUser && $rootScope.hasModule('NPS') && !$location.path().startsWith('/pages/')) {
                server.get('/api/nps/show').then(function(result) {
                    if (result.show) {
                        var title = 'Kundundersökning';
                        $modal.open({
                            templateUrl: 'views/widgetdialog.html',
                            windowClass: 'very-large-modal-window',
                            controller: 'WidgetDialogCtrl',
                            resolve: {
                                options: function() {
                                    return {
                                        title: title,
                                        widget: '7b02d5d8c1f783f87fac7ff37af5f9e1e33ec5ed6c2429afcf227fd7e6e9667e',
                                        height: result.height
                                    };
                                }
                            }
                        });
                    }
                });
            }
        };

        $rootScope.showMyBusinessPopup = function() {
            if ($rootScope.currentStaff && $rootScope.currentStaff.showMemberkundPopUp && !$location.path().startsWith('/pages/')) {
                $modal.open({
                    templateUrl: 'views/mb.html',
                    windowClass: 'very-large-modal-window',
                    controller: 'MbDialogCtrl'
                });
            }
        };

        $rootScope.showKorpenMailing = function(forceShow=false) {
            if ($rootScope.currentStaff && $rootScope.hasModule('KorpenMailing') && $rootScope.is_korpen && $rootScope.hasPermission('Schedule handling') && !$location.path().startsWith('/pages/')) {
                if (!$window.localStorage.KorpenMailingLastReadDate) {
                    $window.localStorage.KorpenMailingLastReadDate = '2000-01-01 00:00'
                }
                server.get('/api/korpen/getmailing').then(function(result) {
                    if (!(result.length > 0)) {
                        return;
                    }
                    var message = result[0].value.message

                    var currentDate = new Date()
                    var fromDate = Date.newFull(result[0].value.startTime)
                    var toDate = Date.newFull(result[0].value.endTime)
                    if (!(fromDate < currentDate && currentDate < toDate)) {
                        return;
                    }

                    var lastReadDate = Date.newFull($window.localStorage.KorpenMailingLastReadDate)
                    if (!((fromDate > lastReadDate) || forceShow)) {
                        return;
                    }

                    var title = 'Viktigt meddelande från Korpen Riks';
                    $modal.open({
                        templateUrl: 'views/htmldialog.html',
                        windowClass: 'very-large-modal-window',
                        controller: 'KorpenMailingDisplayCtrl',
                        resolve: {
                            options: function() {
                                return {
                                    title: title,
                                    message: message
                                };
                            }
                        }
                    });
                });
            }
        };

        // reload page if cookie was changed
        (function() {
            var status = 0;
            function check() {
                if(!$rootScope.currentSession || $rootScope.currentSession == server.getCookie('session')) {
                    status = 0;
                    setTimeout(check, 20000);
                    return;
                }
                status++;
                if(status < 2) {
                    setTimeout(check, 2000);
                } else {
                    document.location.reload();
                }
            }

            setTimeout(check, 2000);
        })();

        $rootScope.isExpoApp = function() {
            return window.isExpoApp;
        };

        $rootScope.expoDevicePlatform = function() {
            return window.expoDevicePlatform;
        };

        $rootScope.expoSettings = function() {
            return window.expoSettings || {};
        };

        $rootScope.initExpoApp = function() {
            $rootScope.goBack = function() {
                if (modalUtils.modalsExist()) {
                    modalUtils.closeTop();
                } else {
                    window.history.back();
                }
            };
            window.goBack = function() {
                $rootScope.$apply($rootScope.goBack);
            };
            window.setSite = function(site_id) {
                $rootScope.$apply(function() {
                    var site = _.findWhere($rootScope.sites, {id: site_id});
                    $rootScope.setSiteOnServer(site);
                });
            };
            window.toggleMenu = function() {
                $('#app').toggleClass('on-canvas');
            };
            $rootScope.$on('$routeChangeStart', function () {
                $('#app').removeClass('on-canvas');
            });
            window.expoAsyncResponse = function(id, data) {
                $rootScope.$apply(function() {
                    $rootScope.pubsub.publish('expo.async.response.'+id, data);
                });
            };
            window.expoAsyncAbort = function(id) {
                $rootScope.$apply(function() {
                    $rootScope.pubsub.publish('expo.async.abort.'+id);
                });
            };
            window.navigateTo = function(path) {
               $rootScope.$apply(function() {
                    $location.path(path);
               });
            };

            if ($rootScope.expoSettings() && $rootScope.expoSettings().apikey) {
                $http.defaults.headers.common.Authorization = 'Zoezi ' + $rootScope.expoSettings().apikey;
            }
            var postMessageSet = $rootScope.$watch(function() { return window.ReactNativeWebView; }, function() {
                if (window.ReactNativeWebView) {
                    window.postMessage = window.ReactNativeWebView.postMessage;
                    postMessageSet();
                }
            });

            $rootScope.$on('$viewContentLoaded', function() {
                $rootScope.expoPostMessage('contentLoaded');
            });

            live.subscribe({
                type: 'userpushnotification',
                callback: function() {
                    $rootScope.expoPostMessage('reloadNotifications');
                }
            });

            live.subscribe({
                type: 'todo',
                callback: function() {
                    $rootScope.expoPostMessage('reloadTodos');
                }
            });
        };

        $rootScope.expoAsyncCall = function(type, data, onSuccess, onAbort) {
            var id = Math.random().toString(36).slice(2, 10);
            data = data || {};
            data.id = id;

            $rootScope.pubsub('expo.async.response.'+id, function(response) {
                if (onSuccess) {
                    onSuccess(response);
                }
                $rootScope.pubsub.unsubscribe();
            });
            $rootScope.pubsub('expo.async.abort.'+id, function() {
                if (onAbort) {
                    onAbort();
                }
                $rootScope.pubsub.unsubscribe();
            });

            $rootScope.expoPostMessage(type, data);
        };

        $rootScope.expoPostMessage = function(type, data) {
            if (!$rootScope.isExpoApp || !$rootScope.isExpoApp()) { return; }
            if (!type) { return; }

            var hasPostMessage = function() {
                return window.ReactNativeWebView || window.postMessage;
            };

            if (hasPostMessage()) {
                if (window.ReactNativeWebView) {
                    window.ReactNativeWebView.postMessage(JSON.stringify({ type: type, data: data }));
                } else {
                    window.postMessage(JSON.stringify({ type: type, data: data }), 'exp://expo.zoezi.se/');
                }
                return;
            }

            var postMessageSet = $rootScope.$watch(hasPostMessage, function() {
                if (!hasPostMessage()) { return; }

                if (window.ReactNativeWebView) {
                    window.ReactNativeWebView.postMessage(JSON.stringify({ type: type, data: data }));
                } else {
                    window.postMessage(JSON.stringify({ type: type, data: data }), 'exp://expo.zoezi.se/');
                }
                postMessageSet();
            });
        };

        $rootScope.initGuides = function() {

            $rootScope.askIfShouldExitGuide = function(driver, step) {
                confirm.show('Do you really want to exit the guide?', { yesButtonText: 'Yes, exit guide', noButtonText: 'No, continue' }).then(angular.noop, function() {
                    $timeout(function() {
                        driver.start(step);
                    }, 500);
                });
            };

            var moveNext = function() {};

            var getDriver = function() {
                var driver = null;
                var step = 0;
                moveNext = function() {
                    $timeout(driver.moveNext);
                };
                driver = new window.Driver({
                    animate: false,
                    opacity: 0,
                    doneBtnText: util.t('Next'),
                    closeBtnText: util.t('Close'),
                    nextBtnText: util.t('Next'),
                    prevBtnText: util.t('Previous'),
                    onHighlightStarted: function(e) {
                        $timeout(function() {
                            step = driver.currentStep;
                        }, 100);
                        e.node.scrollIntoView({ block: 'center' });
                        e.node.addEventListener('click', moveNext);
                    },
                    onDeselected: function(e) { e.node.removeEventListener('click', moveNext); },
                    onReset: function() {
                        if ((driver.steps.length-1) != step) {
                            $rootScope.askIfShouldExitGuide(driver, step);
                        }
                    }
                });
                return driver;
            };

            var genericGotoSettings = function(path, itemIndex, title, pageDescription, callback, options) {
                options = options || {};

                var navigate = function() {
                    $timeout(function() {
                        if ($location.path() != path) {
                            $location.path(path);
                            $rootScope.$apply();
                            $timeout(navigate, 10);
                            return;
                        }
                        callback();
                    });
                };

                var driver = getDriver();
                var steps = [{
                        element: '#nav-settings > a',
                        popover: {
                            title: util.t(title),
                            description: util.t(options.settingsDescription || 'Click to open the menu.'),
                            position: 'right'
                        },
                        onNext: function(e) {
                            var el = angular.element(e.node);
                            if (el.parent().hasClass('open')) { return; }
                            el.click();
                        }
                    }, {
                        element: '#nav-settings > ul > li:nth-child('+itemIndex||1+') > a',
                        popover: {
                            title: util.t(title),
                            description: util.t(pageDescription),
                            position: 'right'
                        },
                        onHighlighted: function(e) { e.node.addEventListener('click', navigate); },
                        onNext: navigate,
                        onDeselected: function(e) {
                            e.node.removeEventListener('click', moveNext);
                            e.node.removeEventListener('click', navigate);
                        }
                    }];
                    driver.defineSteps(steps);
                    driver.start();
            };

            var settingsGoto = {
                general: function(title, callback) {
                    genericGotoSettings('/settings/gym', 1, title, 'Click to open general settings.', callback);
                },
                sale: function(title, callback) {
                    if (!$rootScope.hasModule('Payment')) { return; }
                    genericGotoSettings('/settings/sale', 4, title, 'Click to open sales settings.', callback);
                },
                customerfields: function(title, callback) {
                    genericGotoSettings('/settings/customerfields', 9, title, 'Click to open customer information settings.', callback, { settingsDescription: 'Click to open settings for customer information' });
                }
            };


            $rootScope.guides = {
                addcustomer: function() {
                    var driver = getDriver();
                    var moveNext = function() {
                        $rootScope.pubsub.publish('startGuide', true);
                        $timeout(driver.moveNext, 500);
                    };
                    driver.options.onReset = angular.noop;
                    var steps = [{
                        element: '#nav-customers > a',
                        popover: {
                            title: util.t('Here you will find everything about your customers'),
                            description: util.t('Click to open the menu.'),
                            position: 'right'
                        },
                        onNext: function(e) {
                            var el = angular.element(e.node);
                            if (el.parent().hasClass('open')) { return; }
                            el.click();
                        }
                    }, {
                        element: '#nav-customers > ul > li:nth-child(3) > a',
                        popover: {
                            title: util.t('Add new customer'),
                            position: 'right'
                        },
                        onHighlightStarted: function(e) { e.node.addEventListener('click', moveNext); },
                        onDeselected: function(e) { e.node.removeEventListener('click', moveNext); },
                        onNext: function(e) {
                            $rootScope.pubsub.publish('startGuide', true);
                            $timeout(function() {
                                var el = angular.element(e.node);
                                el.click();
                            });
                        }
                    }];

                    driver.defineSteps(steps);
                    driver.start();
                },
                addstaff: function() {
                    var driver = getDriver();
                    var moveNext = function() {
                        $rootScope.pubsub.publish('startGuide', true);
                        $timeout(driver.moveNext, 500);
                    };
                    driver.options.onReset = angular.noop;
                    var steps = [{
                        element: '#nav-staffs > a',
                        popover: {
                            title: util.t('Add staff accounts'),
                            description: util.t('Click to open the menu.'),
                            position: 'right'
                        },
                        onNext: function(e) {
                            var el = angular.element(e.node);
                            if (el.parent().hasClass('open')) { return; }
                            el.click();
                        }
                    }, {
                        element: '#nav-staffs > ul > li:nth-child(2) > a',
                        popover: {
                            title: util.t('Click here to add a new staff account'),
                            position: 'right'
                        },
                        onHighlightStarted: function(e) { e.node.addEventListener('click', moveNext); },
                        onDeselected: function(e) { e.node.removeEventListener('click', moveNext); },
                        onNext: function(e) {
                            $rootScope.pubsub.publish('startGuide', true);
                            $timeout(function() {
                                var el = angular.element(e.node);
                                el.click();
                            });
                        }
                    }];

                    driver.defineSteps(steps);
                    driver.start();

                },
                gotoassociationinformation: function() {
                    var startNext = function() {
                        $rootScope.pubsub.publish('startGuide', 'associationinformation');
                    };
                    settingsGoto.general('Fill in your association information', startNext);
                },
                gotoboardsettings: function() {
                    var startNext = function() {
                        $rootScope.pubsub.publish('startGuide', 'gotoboardsettings2');
                    };
                    settingsGoto.general('Add the Board', startNext);
                },
                gotoaccountsettings: function() {
                    var startNext = function() {
                        $rootScope.pubsub.publish('startGuide', 'gotoaccountsettings2');
                    };
                    settingsGoto.general('Account plan', startNext);
                },
                gotopaymethodsettings: function() {
                    var startNext = function() {
                        $rootScope.pubsub.publish('startGuide', 'gotopaymethodsettings2');
                    };
                    settingsGoto.general('Add payment method', startNext);
                },
                gotoinvoicesettings: function() {
                    var startNext = function() {
                        $rootScope.pubsub.publish('startGuide', 'invoicesettings');
                    };
                    settingsGoto.general('Adjust billing settings', startNext);
                },
                gotomembershipsettings: function() {
                    var startNext = function() {
                        $rootScope.pubsub.publish('startGuide', 'gotomembershipsettings2');
                    };
                    settingsGoto.sale('Add new membership', startNext);
                },
                gotocustomerfieldsettings: function() {
                    var startNext = function() {
                        $rootScope.pubsub.publish('startGuide', 'customerfieldsettings');
                    };
                    settingsGoto.customerfields('Customer information', startNext);
                },
                showmemberregister: function() {
                    var driver = getDriver();
                    var steps = [{
                        element: '#nav-customers > a',
                        popover: {
                            title: util.t('The member register'),
                            description: util.t('In this menu you will find your member register. You can also add an account and review groups and teams.'),
                            position: 'right'
                        },
                        onNext: function(e) {
                            var el = angular.element(e.node);
                            if (el.parent().hasClass('open')) { return; }
                            el.click();
                        }
                    }];

                    if ($rootScope.hasModule('Membership')) {
                        steps.push({
                            element: '#nav-customers .nav-customers-membership > a',
                            popover: {
                                title: util.t('Your members'),
                                description: util.t('If you click here, you will directly find out who your members are.'),
                                position: 'right'
                            }
                        });
                    }
                    steps = steps.concat([{
                        element: '#nav-customers .nav-customers-search > a',
                        popover: {
                            title: util.t('Are you looking for something particular?'),
                            description: util.t('With Search, you get a number of tabs with different search criteria - for example active training cards and members, people with debt, and company accounts. You can also create your own searches for specific criteria.'),
                            position: 'right'
                        }
                    }, {
                        element: '#nav-customers .nav-customers-add > a',
                        popover: {
                            title: util.t('Will there be more of you?'),
                            description: util.t('Here you easily add a new account to the system - enter the information you need, and then there is a new profile.'),
                            position: 'right'
                        }
                    }, {
                        element: '#nav-customers .nav-customers-groups > a',
                        popover: {
                            title: util.t('Do you do things together?'),
                            description: util.t('Here you will find the system\'s different groups - teams, family groups or people you want to connect with and get a little extra control over.'),
                            position: 'right'
                        }
                    }, {
                        element: '#quicksearchmenu',
                        popover: {
                            title: util.t('Are you looking for a specific person?'),
                            description: util.t('Here you can enter a personal information and get results directly - search for example by name, e-mail or social security number and the system will retrieve the person.')
                        },
                        onNext: function() {
                            $timeout($rootScope.guides.showmemberregister2);
                        }
                    }]);

                    driver.defineSteps(steps);
                    driver.start();
                },
                showmemberregister2: function() {
                    var path = '/customer/show/'+$rootScope.currentStaff.id;
                    if ($location.path() != path) {
                        $location.path(path);
                        $rootScope.$apply();
                        $timeout($rootScope.guides.showmemberregister2, 250);
                        return;
                    }

                    var driver = getDriver();
                    driver.options.doneBtnText = util.t('Finish');
                    driver.options.onReset = $rootScope.possiblyGoToGetStarted;
                    var steps = [{
                        element: '.page .row',
                        popover: {
                            title: util.t('The member profile'),
                            description: util.t('This is what a member profile looks like in the system when you are logged in as an administrator'),
                            position: 'bottom-center'
                        },
                    }, {
                        element: '#customercardinfopanel',
                        popover: {
                            title: util.t('Information about the member'),
                            description: util.t('Here all the information you have about the member is listed. You can change the information about the member yourself by clicking Change.')
                        }
                    }, {
                        element: '.page .row:nth-child(2)',
                        popover: {
                            title: util.t('Active training cards'),
                            description: util.t('Here you see the member\'s active training card. You can also see upcoming training cards with future start dates. Here you can change, freeze or remove training cards. You can also see older expired training cards.')
                        }
                    }, {
                        element: '.page .row:nth-child(3)',
                        popover: {
                            title: util.t('Active membership'),
                            description: util.t('Here you see the member\'s active membership. If the membership is extended automatically, you can end the automatic renewal here.')
                        }
                    }, {
                        element: '.page .row:nth-child(4)',
                        popover: {
                            title: util.t('MEMBERREGISTER_PAYMENTS'),
                            description: util.t('Here you see the all of the member\'s payments - unpaid, incoming, sent and paid. You can both change and delete a payment, receipts are of course available to receive for everything that is paid.')
                        }
                    }, {
                        element: '.page .row:nth-child(5)',
                        popover: {
                            title: util.t('Additional information'),
                            description: util.t('Further down you will find the member\'s current and previous bookings, training history and entries if these parts are active in your system.')
                        }
                    }];

                    driver.defineSteps(steps);
                    driver.start();
                },
                membershipinvoicingtour: function() {
                    var driver = getDriver();
                    driver.options.closeBtnText = util.t('Next');
                    driver.options.onReset = function() {
                        $timeout($rootScope.guides.membershipinvoicingtour2, 100);
                    };
                    driver.highlight({
                        element: '#quicksearchmenu',
                        popover: {
                            title: ' ',
                            description: util.t('When you as an administrator add a new membership, the easiest way to get to the member\'s profile is to search for them here. You can, among other things, search by name, personal code number and e-mail.')
                        }
                    });
                },
                membershipinvoicingtour2: function() {
                    var path = '/customer/show/'+$rootScope.currentStaff.id;
                    if ($location.path() != path) {
                        $location.path(path);
                        $rootScope.$apply();
                        $timeout($rootScope.guides.membershipinvoicingtour2, 500);
                        return;
                    }

                    var driver = getDriver();
                    driver.options.closeBtnText = util.t('Next');
                    driver.options.onReset = _.throttle(function() {
                        $rootScope.pubsub.publish('startGuide', true);
                        $('.page .row:nth-child(3) .buttonAfterTab button').click();
                    }, 5000, {trailing:false});
                    driver.highlight({
                        element: '.page .row:nth-child(3) .buttonAfterTab button',
                        popover: {
                            title: ' ',
                            description: util.t('Here you can add a membership to the profile.')
                        }
                    });
                },
                membershipinvoicingtour3: function() {
                    modalUtils.closeAllModals();
                    var path = '/economy/invoices';
                    if ($location.path() != path) {
                        $location.path(path);
                        $rootScope.$apply();
                        $timeout($rootScope.guides.membershipinvoicingtour3, 500);
                        return;
                    }

                    $timeout(function() {
                        $rootScope.pubsub.publish('startGuide', 'economyinvoicinggetstartedtour');
                    }, 500);
                },
                membershipinvoicingtour4: function() {
                    var path = '/economy/dashboard';
                    if ($location.path() != path) {
                        $location.path(path);
                        $rootScope.$apply();
                        $timeout($rootScope.guides.membershipinvoicingtour4, 500);
                        return;
                    }

                    var scope = angular.element('.page > #dscreen').scope();
                    var economyDashboard = _.findWhere(scope.dashboards, {name: 'Ekonomi'});
                    if (!angular.equals(scope.state.dashboard, economyDashboard)) {
                        scope.state.dashboard = economyDashboard;
                        scope.loadDashboard();
                    }

                    var driver = getDriver();
                    driver.options.closeBtnText = util.t('Finish');
                    driver.options.onReset = $rootScope.possiblyGoToGetStarted;
                    $timeout(function() {
                        driver.highlight({
                            element: '#dscreen economyoverview .ui-tab > ul',
                            popover: {
                                title: ' ',
                                description: util.t('Here you will find several tabs that gives you a good overview of all payments in your system; unpaid, incoming, sent, and paid. On each tab, you can click on a specific payment to get more information, and change information if necessary.')
                            }
                        });
                    });
                }
            };

            $rootScope.startGuide = function(name) {
                if (!$rootScope.guides[name]) { return; }
                $rootScope.guides[name]();
            };

            $rootScope.possiblyGoToGetStarted = function() {
                if (!$rootScope.currentStaff || !$rootScope.currentStaff.show_getstarted) {
                    return;
                }
                confirm.show('Do you want to stay here or continue with the Get Started steps?', { yesButtonText: 'Back to Get started', noButtonText: 'Stay' }).then(function() {
                    $location.path('/get-started/getstarted');
                    modalUtils.closeAllModals();
                });
            };
        };

        if (browser.isIE()) {
            $rootScope.browserNotSupported = true;
        } else {
            $rootScope.init();
            $rootScope.initGuides();

            var waitForExpo = $rootScope.$watch(function() { return window.isExpoApp; }, function() {
                if (!window.isExpoApp) { return; }
                $rootScope.initExpoApp();
                waitForExpo();
            });
        }

        var Data = {};
        return Data;
    }
]);

app.service('ApiDataLoader', ['server', '$timeout', '$q', '$rootScope', 'util', function(server, $timeout, $q, $rootScope, util) {
    const dataCaches = {};
    const batchQueues = {};
    const pendingRequestsPerType = {};
    const batchDelay = 50; // delay in ms to wait for batching

    const dataTypes = {
        user: {
            apiEndpoint: '/api/member/get/some',
            transformMethod: x => $rootScope.transformMember(x),
            init: x => {
                x.name = x.fullname = util.t('Loading...')
                x.firstname = '';
                x.getValueCardAmountForSelectedLegalEntity = () => 0;
                x.hasSavedCardForSelectedLegalEntity = () => false;
            },
            removed: x => {
                if (x.id == $rootScope.superUserId) {
                    x.name = x.lastname = x.fullname = util.t('Zoezi support');
                } else {
                    x.name = x.fullname = util.t('Removed');
                    x.isMember = true;
                    x.isRemoved = true;
                }
                x.firstname = '';
            },
            loaded: _ => {
                $rootScope.setStaffsFromUsers();
            },
            getArray: () => $rootScope.members
        },
        trainingcardtype: {
            apiEndpoint: '/api/trainingcard/type/get/some',
            transformMethod: x => $rootScope.transformTrainingCardType(x),
            init: x => {
                x.name = util.t('Loading...');
                x.updateVariants = () => {};
            },
            removed: x => {
                x.name = util.t('Removed');
            },
            getArray: () => $rootScope.trainingcardtypes
        },
        usergroup: {
            apiEndpoint: '/api/usergroup/get/some',
            transformMethod: x => $rootScope.transformUserGroup(x),
            init: x => {
                x.name = util.t('Loading...');
            },
            removed: x => {
                x.name = util.t('Removed');
            },
            getArray: () => $rootScope.usergroups
        }
    };

    // Initialize caches for all data types
    Object.keys(dataTypes).forEach(function(type) {
        dataCaches[type] = {};
        batchQueues[type] = [];
        pendingRequestsPerType[type] = {};
    });

    const fetchData = (type, ids) => {
        if ($rootScope.speedyDebug) {
            console.log('ApiDataLoader, fetching ', type + ', ' + ids.join(', '));
        }

        var apiEndpoint = dataTypes[type].apiEndpoint;
        return server.post(apiEndpoint, {ids}).then(function(response) {
            response.data.forEach(function(data) {
                var transformMethod = dataTypes[type].transformMethod;
                if (transformMethod) {
                    transformMethod(data);
                }
                if (dataCaches[type][data.id]) {
                    Object.assign(dataCaches[type][data.id], data, { is_placeholder: false });
                } else {
                    dataCaches[type][data.id] = data;
                }
                let dt = dataTypes[type];
                if (dt.getArray) {
                    if (!dt.getArray().find(x => x.id == data.id)) {
                        dt.getArray().push(dataCaches[type][data.id]);
                    }
                }
            });
            return response.data;
        });
    };

    const processBatchQueue = (type) => {
        if (batchQueues[type].length > 0) {
            var idsToFetch = batchQueues[type];
            batchQueues[type] = [];
            fetchData(type, idsToFetch).then(function(dataItems) {
                idsToFetch.forEach(id => {
                    const promise = pendingRequestsPerType[type][id];
                    const item = dataItems.find(x => x.id == id);
                    if (item) {
                        promise.resolve(item);
                    } else {
                        // User not found - mark placeholder as removed and resolve with it
                        let dt = dataTypes[type];
                        if (dt.removed) {
                            dt.removed(dataCaches[type][id]);
                        }
                        promise.resolve(dataCaches[type][id]);
                    }
                    delete pendingRequestsPerType[type][id];
                });
            });
        }
    };

    this.getData = function(type, id) {
        var dataCache = dataCaches[type];
        var pendingRequests = pendingRequestsPerType[type];

        if (dataCache[id] && !dataCache[id].is_placeholder) {
            return $q.when(dataCache[id]);
        } else if (pendingRequests[id]) {
            return pendingRequests[id].promise;
        } else {
            let dt = dataTypes[type]
            if (!dataCache[id]) {
                var placeholder = {
                    id: id,
                    uid: type + '.' + id,
                    is_placeholder: true,
                };
                dt.init(placeholder);
                dataCache[id] = placeholder;

                if (dt.getArray) {
                    if (!dt.getArray().find(x => x.id == id)) {
                        dt.getArray().push(placeholder);
                    }
                }
            }
            var request = pendingRequests[id] = $q.defer();
            batchQueues[type].push(id);
            if (!pendingRequests.timeoutPending) {
                pendingRequests.timeoutPending = true;
                $timeout(() => {
                    processBatchQueue(type);
                    pendingRequests.timeoutPending = false;
                }, batchDelay);
            }

            request.promise.catch(() => {
                // Remove the placeholder if the data was not found
                if (dt.removed) {
                    dt.removed(dataCache[id]);
                }
            }).finally(() => {
                var loaded = dt.loaded;
                if (loaded) {
                    loaded(dataCache[id]);
                }

                if ($rootScope.speedyDebug) {
                    console.log('ApiDataLoader, loaded ', type + ', ' + id);
                }

                $rootScope.$broadcast('ApiDataLoaded', type + '.' + id);
            });

            return request.promise;
        }
    };

    this.getDataImmediately = function(type, id) {
        if (id == null) {
            return null;
        }
        if(typeof id === 'string') {
            id = Number(id);
        }
        if (_.isObject(id) && id.id) {
            id = id.id;
        }
        if (!(id && typeof id === 'number' && isFinite(id))) {
            return null;
        }

        var dataCache = dataCaches[type];

        if (dataCache[id]) {
            return dataCache[id];
        } else {
            // Fetch the actual data
            this.getData(type, id);

            // Return the placeholder created by getData
            return dataCache[id];
        }
    };

    this.updateData = function(type) {
        var dataCache = dataCaches[type];
        var array = dataTypes[type].getArray();
        if (array) {
            array.forEach(data => {
                if (!dataCache[data.id]) {
                    dataCache[data.id] = data;
                }
            });
        }
    };
}]);

app.controller('AdyenSetupNotCompletedCtrl', ['$rootScope', '$scope', '$location', 'server', function($rootScope, $scope, $location, server) {
    $scope.setupNeeded = false;
    server.get('/api/adyen/onboarding/status/get', { legal_entity_id: $rootScope.selectedSite?.legal_entity_id }).then((response) => {
        if (['not_started', 'not_finished', 'start_onboarding'].includes(response.status)){
            $scope.setupNeeded = true;
        }
        else if (response.status == 'tos_updated') {
            $scope.bodyTitle = 'Zoezi Pay setup needs attention';
            $scope.bodyText = 'ADYEN_ONBOARDING_TOS_UPDATED_MESSAGE';
        }
        else if (response.status == 'invalid') {
            $scope.bodyTitle = 'Zoezi Pay setup needs attention';
            $scope.bodyText = 'ADYEN_ONBOARDING_INVALID_MESSAGE';
        }
    });
    $scope.redirect = () => {
        $location.path('/settings/gym');
        $location.search('tab', 'adyen');
        $scope.$close();
    };

    $scope.daysleft = new Date().daysUntil(Date.newFull('2023-11-25'));
}]);

app.controller('WidgetDialogCtrl', ['$scope', 'server', 'options', function($scope, server, options) {
    $scope.title = options.title;
    $scope.height = options.height || 400;

    server.get('/api/addon/widget/get').then(function(addons) {
        var widget = _.findWhere(addons, {id: options.widget});
        if (widget) {
            $scope.widget_settings = {
                url: widget.url
            };
        }
    });
}]);

app.controller('MbDialogCtrl', ['$scope', 'server', function($scope, server) {
    $scope.step = 1;
    $scope.choice = null;
    $scope.info = '';
    $scope.loadingStatus = {loading: false};

    $scope.setChoice = function(choice) {
        $scope.choice = choice;
        $scope.step = 2;
    };

    $scope.submitChoice = function(choice, info) {
        $scope.loadingStatus.loading = true;
        server.post('/api/mybusiness/select', {choice: choice, info: info}).then(function() {
            $scope.$dismiss();
        });
    };
}]);


app.directive('staffRedirect', ['$rootScope', '$location', function($rootScope, $location) {
    return {
        restrict: 'E',
        template: '<div />',
        link: function() {
            if ($rootScope.currentStaff && $rootScope.currentStaff.show_getstarted) {
                $location.path('/get-started').replace();
            } else {
                $location.path('/dashboard').replace();
            }
        }
    };
}]);

app.factory('browser', ['$window', function($window) {
    var browser = {};

    browser.version = function() {
        var userAgent = $window.navigator.userAgent;

        var browsers = {edge: /edge/i, chrome: /chrome/i, safari: /safari/i, firefox: /firefox/i, ie: /internet explorer/i, ie10: /MSIE/i, ie11: /Trident\//i,  webkit: /AppleWebKit/i};

        for(var key in browsers) {
            if (browsers[key].test(userAgent)) {
                return key;
            }
        }

        return 'unknown';
    };

    browser.isIE = function() {
        var version = browser.version();
        return version === 'ie10' || version === 'ie11';
    };

    return browser;
}]);

// Since popover directive collides with popover attribute in Chrome
// this own directive tries to do more or less the same
app.directive('zoeziPopover', ['$compile', '$timeout', function($compile, $timeout) {
    return {
        restrict: 'A',
        link: function(scope, element, attrs) {
            var popoverScope;
            var popoverElement;

            attrs.$observe('zoeziPopover', function(newVal) {
                scope.dynamicPopoverContent = newVal;
            });

            var showPopover = function() {
                popoverScope = scope.$new();
                var template = `
<div class="zoezi-popover invisible">
    <div class="zoezi-popover-content" ng-bind="dynamicPopoverContent"></div>
</div>`;

                popoverElement = $compile(template)(popoverScope);
                angular.element(document.body).append(popoverElement);

                $timeout(() => {
                    var position = element[0].getBoundingClientRect();
                    var popoverHeight = popoverElement[0].offsetHeight;

                    var popoverWidth = popoverElement[0].offsetWidth;

                    // Determine placement
                    var placement = attrs.popoverPlacement || 'top';
                    var top, left;

                    switch(placement) {
                        case 'bottom':
                            top = position.top + position.height + 10;
                            left = position.left + (position.width / 2) - (popoverWidth / 2);
                            break;
                        case 'left':
                            top = position.top + (position.height / 2) - (popoverHeight / 2);
                            left = position.left - popoverWidth - 10;
                            break;
                        case 'right':
                            top = position.top + (position.height / 2) - (popoverHeight / 2);
                            left = position.left + position.width + 10;
                            break;
                        case 'top':
                        default:
                            top = position.top - popoverHeight - 10;
                            left = position.left + (position.width / 2) - (popoverWidth / 2);
                            break;
                    }

                    popoverElement.css({
                        top: top + 'px',
                        left: left + 'px'
                    });
                    popoverElement.removeClass('invisible');

                    popoverScope.$apply();
                });

                popoverScope.$apply();
            };

            var hidePopover = function() {
                popoverScope && popoverScope.$destroy();
                popoverElement && popoverElement.remove();
                popoverElement = null;
            };

            element.on('mouseenter', function() {
                showPopover();
            });

            element.on('mouseleave', function() {
                hidePopover();
            });
        }
    };
}]);

app.factory('workoutProvider', ['$http', '$rootScope', '$q', 'pubsub',
    function ($http, $rootScope, $q, pubsub) {
        var workoutProvider = {};

        workoutProvider.hasRange = {};
        workoutProvider.workouts = [];
        workoutProvider.getting = {};

        workoutProvider.get = function(fromDate, toDate) {
            var deferred = $q.defer();

            if (fromDate.yyyymmdd) {
                fromDate = fromDate.yyyymmdd();
            }

            if (toDate.yyyymmdd) {
                toDate = toDate.yyyymmdd();
            }

            var key = fromDate + toDate;

            var dateRange = function(workout) {
                var sd = workout.startDate.yyyymmdd();
                return sd >= fromDate && sd <= toDate;
            };

            var siteFilter = function(workout) {
                return workout.site == $rootScope.selectedSite;
            };

            var returnResult = function() {
                var result = workoutProvider.workouts.filter(dateRange);
                if ($rootScope.hasModule('MultiSite')) {
                    result = result.filter(siteFilter);
                }
                deferred.resolve(result);
            };

            if (workoutProvider.hasRange[key]) {
                returnResult();
            } else {
                var key = fromDate + toDate;
                if (!workoutProvider.getting[key]) {
                    var g = $q.defer();

                    workoutProvider.getting[key] = g.promise;
                    $http.get('/api/schedule/workout/get/all?fromDate=' + fromDate + '&toDate=' + toDate + "&bookings=true&site_id=" + ($rootScope.selectedSite ? $rootScope.selectedSite.id : '')).success(function(data) {
                        $rootScope.waitFor(['staffs', 'workouttypes', 'members', 'sites']).then(function() {
                            var toPush = [];
                            angular.forEach(data, function(workout) {
                                $rootScope.transformWorkout(workout);
                                if (!_.findWhere(workoutProvider.workouts, {id: workout.id})) {
                                    toPush.push(workout);
                                }
                            });

                            Array.prototype.push.apply(workoutProvider.workouts, toPush);

                            workoutProvider.hasRange[key] = true;

                            g.resolve();
                        });
                    });
                }

                workoutProvider.getting[key].then(returnResult);
            }

            return deferred.promise;
        };

        workoutProvider.getAttendance = function(date) {
            var deferred = $q.defer();

            $http.get('/api/attendance/get?oldstyle=true&date=' + date.yyyymmdd()).success(function(aWorkouts) {
                $rootScope.waitFor(['staffs', 'workouttypes', 'members']).then(function() {
                    var workouts = workoutProvider.addAndTransform(aWorkouts);
                    deferred.resolve(workouts);
                });
            });

            return deferred.promise;
        };

        workoutProvider.addAndTransform = function(workouts) {
            var result = [];
            angular.forEach(workouts, function(workout) {
                var rootWorkout = $rootScope.getPointer(workout, workoutProvider.workouts);
                if (rootWorkout) {
                    result.push(rootWorkout);
                } else {
                    $rootScope.transformWorkout(workout);
                    workoutProvider.workouts.push(workout);
                    result.push(workout);
                }
            });
            return result;
        };

        workoutProvider.updateWorkout = function(workout) {
            var w = _.findWhere(workoutProvider.workouts, {id: workout});
            if (w) {
                $rootScope.recalculateWorkout(w);
            }
        };

        workoutProvider.updateWorkoutType = function(workoutType) {
            var workouts = workoutProvider.workouts.filter(function(w) { return w.workoutType.id == workoutType; });
            angular.forEach(workouts, function(w) {
                $rootScope.recalculateWorkout(w);
            });
        };

        workoutProvider.getWorkoutById = function(workoutId, refresh) {
            var deferred = $q.defer();
            var w = _.findWhere(workoutProvider.workouts, {id: workoutId});
            if(w) {
                if(refresh)
                {
                    workoutProvider.workouts.splice(workoutProvider.workouts.indexOf(w), 1);
                } else {
                    deferred.resolve(w);
                    return deferred.promise;
                }
            }

            $http.get('/api/schedule/workout/get?bookings=true&id=' + workoutId).success(function(workout) {
                var w = _.findWhere(workoutProvider.workouts, {id: workout.id});
                if (w) {
                    if(refresh)
                    {
                        workoutProvider.workouts.splice(workoutProvider.workouts.indexOf(w), 1);
                    } else {
                        deferred.resolve(w);
                        return;
                    }
                }
                $rootScope.waitFor(['staffs', 'workouttypes', 'members', 'sites']).then(function() {
                    $rootScope.transformWorkout(workout);
                    workoutProvider.workouts.push(workout);
                    deferred.resolve(workout);
                });
            });

            return deferred.promise;
        };

        pubsub.subscribe('selectedSite', function() {
            workoutProvider.hasRange = {};
            workoutProvider.workouts = [];
            workoutProvider.getting = {};
        });

        return workoutProvider;
    }
]);

app.factory('removeworkoutdialog', ['$modal', '$q', '$filter', function($modal, $q, $filter) {
    var removeworkoutdialog = {};

    removeworkoutdialog.show = function(numSimilar) {
        var deferred = $q.defer();
        var title = 'Confirm';
        var content = $filter('translate')('There are {0} similar workouts. Would you like to remove all of them or only this one?').format(numSimilar);

        var modalInstance = $modal.open({
            templateUrl: 'views/removeworkout.html',
            controller: 'ModalCtrl',
            resolve: {
                options: function() {
                    return {title: title, content: content};
                }
            }
        });

        modalInstance.result.then(function (reason) {
            deferred.resolve(reason);
        }, function() {
            deferred.reject();
        });

        return deferred.promise;
    };

    return removeworkoutdialog;
}]);

app.factory('image', ['server', function (server) {
    var image = {};

    // options: { type, id, file, imageSelection, remove_old }
    image.set = function(options) {
        var s = options.imageSelection;
        var url = '/api/image/set?type=' + options.type + '&id=' + options.id + '&x=' + s.x1 + '&y=' + s.y1 + '&w=' + s.width + '&h=' + s.height + '&remove_old=' + options.remove_old;
        return server.postFile(url, options.file, options.successTitle, options.failedTitle);
    };

    // options: { type, id, file, imageSelection }
    image.remove = function(options) {
        var url = '/api/image/set?type=' + options.type + '&id=' + options.id;
        return server.postFile(url, null, options.successTitle, options.failedTitle);
    };

    return image;
}]);

app.factory('modal', ['$modal', '$filter', 'server', 'alertProvider', function($modal, $filter, server, alertProvider) {
    var modal = {};

    modal.remove = function(options) {
        var modalInstance = $modal.open({
            templateUrl: 'views/remove.html',
            controller: options.controller || 'ModalCtrl',
            resolve: {
                options: function() {
                    return options;
                }
            }
        });

        modalInstance.result.then(function (reason) {
            var permanent = (reason == 'remove');
            var itemTitle = $filter('translate')(options.itemTitle);
            server.post(options.postUrl, null, {id: options.item.id, permanent: permanent}).then(function(result) {
                var msg;
                if (result.success) {
                    msg = $filter('translate')(permanent ? '{0} was removed' : '{0} was inactivated');
                    msg = msg.format(itemTitle);
                } else {
                    msg = $filter('translate')(permanent ? 'Failed to remove {0}' : 'Failed to inactivate {0}');
                    msg = msg.format(itemTitle.toLowerCase());
                }
                alertProvider.show(result.success ? 'success' : 'error', msg, true);
            });
        });
    };

    modal.activate = function(options) {
        var modalInstance = $modal.open({
            templateUrl: 'views/activate.html',
            controller: 'ModalCtrl',
            resolve: {
                options: function() {
                    return {title: options.title, content: options.content};
                }
            }
        });

        modalInstance.result.then(function () {
            var data = {id: options.item.id, active: true};
            server.post(options.postUrl, data, null, '{0} was activated', 'Failed to activate {0}', options.itemTitle);
        });
    };

    return modal;
}]);

app.factory('paymentMethods', ['$rootScope', function($rootScope) {
    var paymentMethods = {};
    var filters = {
        checkout: function(m) { return m.active && m.checkout && !m.external; },
        create: function(m) { return m.active && m.create; },
        change: function(m) { return m.active && m.change; },
        webshop: function(m) { return m.active && m.webshop; },
        refund: function(m) { return m.active && m.refund; },
        markAsPaid: function(m) { return m.active && m.markAsPaid; },
        refill: function(m) { return m.active && m.refill; }
    };

    paymentMethods.getAll = function() {
        return $rootScope.paymentmethods;
    };

    paymentMethods.get = function() {
        const activeLegalEntityId = $rootScope.selectedSite?.legal_entity_id;
        return ($rootScope.paymentmethods || []).filter(function(m) {
            if (m.id == 'stripe' && $rootScope.adyen?.is_ready_for_card_payment) return false;
            if (m.id == 'adyen-card' && !$rootScope.adyen?.is_ready_for_card_payment) return false;
            if (m.entityAvailability && activeLegalEntityId) {
                const availability = m.entityAvailability[String(activeLegalEntityId)];
                if (!availability || availability.active === false) {
                    return false;
                }
            }
            return _.every(m.modules ? m.modules.split(',') : [], $rootScope.hasModule);
        });
    };

    paymentMethods.getFilter = function(filter) {
        return filters[filter];
    };

    paymentMethods.getCheckout = function() {
        return paymentMethods.get().filter(filters.checkout);
    };

    paymentMethods.getCreate = function() {
        return paymentMethods.get().filter(filters.create);
    };

    paymentMethods.getChange = function() {
        return paymentMethods.get().filter(filters.change);
    };

    paymentMethods.getWebShop = function() {
        return paymentMethods.get().filter(filters.webshop);
    };

    paymentMethods.getRefund = function() {
        return paymentMethods.get().filter(filters.refund);
    };

    paymentMethods.getMarkAsPaid = function() {
        return paymentMethods.get().filter(filters.markAsPaid);
    };

    paymentMethods.getRefillValueCard = function() {
        return paymentMethods.get().filter(filters.refill);
    };

    // Possible to limit Webshop to these. getWeShop() is the default ones for webshop. Which means that Autogiro can be disabled by default but enabled for one product.
    // Return all active methods, but not those which are explicitly for checkout
    paymentMethods.getPossibleForWebshop = function() {
        return paymentMethods.get().filter(function(m) { return m.active && ['xcard', 'cash', 'swish', 'bank', 'izettle', 'giftcard'].indexOf(m.id) == -1; });
    };

    paymentMethods.getDefaultForCustomer = function(customer, ignoreConsent) {
        var methods = paymentMethods.getCreate();
        const legal_entity_id = $rootScope.selectedSite && $rootScope.selectedSite.legal_entity_id;

        const hasConsent = function() {
            if (customer && legal_entity_id && customer.consents) {
                return customer.consents[legal_entity_id];
            }

            return false;
        };

        var method = $rootScope.paymentMethodSettings && $rootScope.paymentMethodSettings.defaultMethod;
        if (method == 'directdebit' && !ignoreConsent && (!customer || !hasConsent())) {
            method = null;
        }

        if (!method && hasConsent()) {
            method = _.findWhere(methods, { id: 'directdebit' });
            if (method) { return method; }
        }
        if (!method) {
            method = _.findWhere(methods, { id: 'invoice' });
            if (method) { return method; }
        }
        return _.findWhere(methods, { id: method || 'unknown' });
    };


    return paymentMethods;
}]);

app.factory('accounts', ['$rootScope', 'server', '$modal', '$q', '$filter', function($rootScope, server, $modal, $q, $filter) {
    var accounts = {};

    accounts.getAll = function() {
        var deferred = $q.defer();
        $rootScope.waitFor(['accounts']).then(function() {
            deferred.resolve($rootScope.accounts);
        });
        return deferred.promise;
    };

    accounts.isSale = function(a) {
        return $rootScope.longaccounts || accounts.isDebt(a) || (a.id >= 3000 && a.id <= 3999) || (a.id >= 8000 && a.id <= 8999);
    };

    accounts.isAsset = function(a) {
        return a.id >= 1000 && a.id <= 1999;
    };

    accounts.isDebt = function(a) {
        return (a.id >= 2000 && a.id <= 2999 || (a.id >= 6000 && a.id <= 6999)) && !accounts.isVAT(a);
    };

    accounts.isAssetOrDebt = function(a) {
        return accounts.isAsset(a) || accounts.isDebt(a) || accounts.isRounding(a);
    };

    accounts.isRounding = function(a) {
        return a.id == 3740;
    };

    accounts.isDiscount = function(a) {
        return a.id >= 3730 && a.id <= 3739;
    };

    accounts.isVAT = function(a) {
        return a.id >= 2600 && a.id <= 2699;
    };

    accounts.getFieldsRow = function(scope, visible, values, account_filter, dont_set_initial, name, title, beforeSetAccount, hint, accountsKey, setValue, helpText) {
        if (!name) {
            name = 'account';
        }
        if (!title) {
            title = 'Bookkeeping account';
        }

        if (!setValue) {
            setValue = function(value) {
                _.findWhere(scope.fields, {name: name}).value = value;
            };
        }

        if (!helpText) {
            helpText = '';
        }

        function getAccounts() {
            return accounts.getAll().then(function(a) {
                var filteredAccounts = [];
                if (account_filter == 'debts') {
                    a = a.filter(accounts.isDebt);
                } else if (account_filter == 'assets') {
                    a = a.filter(accounts.isAsset);
                } else if (account_filter == 'discount') {
                    a = a.filter(accounts.isSale).filter(function(ac) { return !accounts.isRounding(ac); });
                } else if (account_filter == 'assetsdebts') {
                    a = a.filter(accounts.isAssetOrDebt).filter(function(ac) { return !accounts.isVAT(ac); });
                } else if (account_filter == 'discount') {
                    a = a.filter(accounts.isDiscount);
                } else if (account_filter == 'vat') {
                    a = a.filter(accounts.isVAT);
                } else if (account_filter == 'cost') {
                    a.push({ id: 'auto', name: $filter('translate')('Automatically selected by cost type') });
                } else {
                    a = a.filter(accounts.isSale);
                }
                filteredAccounts = a;

                if (values && values.account) {
                    if (typeof beforeSetAccount === 'function') {
                        beforeSetAccount().then(function() {
                            setValue(_.findWhere(filteredAccounts, {id: values.account}));
                        });
                    } else {
                        setValue(_.findWhere(filteredAccounts, {id: values.account}));
                    }
                }

                if (!dont_set_initial && !values && filteredAccounts.length == 1) {
                    setValue(filteredAccounts[0]);
                }

                let targetAccountsKey = accountsKey || 'accounts';
                let existingAccounts = scope[targetAccountsKey] || [];

                let existingAccountIds = existingAccounts.reduce((map, account) => {
                    map[account.id] = true;
                    return map;
                }, {});

                let newAccounts = filteredAccounts.filter(account => !existingAccountIds[account.id]);
                scope[targetAccountsKey] = existingAccounts.concat(newAccounts);
            });
        }

        function setFieldValue(field, value) {
            if (accountsKey) {
                return _.findWhere(scope[accountsKey], {id: value});
            } else if (scope.accounts) {
                return _.findWhere(scope.accounts, {id: value});
            } else {
                values = {account: value};
            }
        }

        function addAccount() {
            var modalInstance = $modal.open({
                templateUrl: 'views/addmodal.html',
                controller: 'SettingsAccountAddModalCtrl',
                resolve: {
                    options: function() {
                        if ($rootScope.longaccounts) {
                            return { min: 1, max: 99999};
                        }

                        if (account_filter == 'assetsdebts') {
                            return { min: 1000, max: 2999 };
                        } else if (account_filter == 'assets') {
                            return { min: 1000, max: 1999 };
                        } else if (account_filter == 'debts') {
                            return { min: 2000, max: 2999 };
                        } else if (account_filter == 'vat') {
                            return { min: 2600, max: 2699 };
                        } else if (account_filter == 'cost') {
                            return { min: 1000, max: 9999 };
                        } else {
                            return {min: 2000, max: 3999 };
                        }
                    }
                }
            });
            modalInstance.result.then(function(addedAccount) {
                values = {account: addedAccount.id };
                getAccounts();
            });
        }

        var promise = getAccounts();

        return {name: name, title: title, required: true, type: 'select', hint: hint, visible: visible, options: function() {return accountsKey ? scope[accountsKey] : scope.accounts; }, useId: true, orderPredicate: 'id', addButtonClicked: addAccount, addButtonTitle: 'Add account', setValue: setFieldValue, helpText: helpText, promise: promise, getName: ac => `${ac.name} (${ac.id})` };
    };

    return accounts;
}]);

app.factory('propertyhelper', ['$filter', 'server', '$q', '$rootScope', 'live', function($filter, server, $q, $rootScope, live) {
    var propertyhelper = {};

    var getFullPropertyName = function(p) {
        if (angular.isArray(p.name)) {
            return p.name;
        }

        if (p.parent) {
            var r = angular.copy(getFullPropertyName(p.parent));
            r.push(p.name);
            return r;
        } else {
            return [p.name];
        }
    };

    propertyhelper.expandJoin = function(info, f) {
        if (f.joinedproperty) {
            var newrows = [];
            var joinedprops = info.properties[_.findWhere(info.datatypes, {id: f.joinedproperty.id}).id];

            newrows.push({
                id: f.id + '.id',
                name: getFullPropertyName(f),
                primary: true
            });

            joinedprops.forEach(function(p) {
                p = angular.copy(p);
                p.parent = f;
                p.id = f.id + '.' + p.id;
                p.name = getFullPropertyName(p);
                if (p.name.length == _.uniq(p.name).length) {
                    Array.prototype.push.apply(newrows, propertyhelper.expandJoin(info, p));
                }
            });
            return newrows;
        } else {
            return [f];
        }
    };

    propertyhelper.getExpandedProperties = function(info, datatype) {
        var result = [];
        var properties = info.properties[datatype];
        properties.forEach(function(p) {
            Array.prototype.push.apply(result, propertyhelper.expandJoin(info, p));
        });

        return result;
    };

    propertyhelper.getPropertyName = function(p) {
        var res = '';
        if (Array.isArray(p.name)) {
            p.name.forEach(function(name) {
                if (res.length) {
                    res += ' > ';
                }
                res += $filter('translate')(name);
            });
        } else {
            res = $filter('translate')(p.name);
        }
        return res;
    };

    var info;
    $rootScope.$on('$translateChangeStart', function() {
        info = null;
    });

    live.subscribe({
        type: 'module',
        action: 'change',
        callback: function() {
            info = null;
        }
    });

    propertyhelper.getInfo = function() {
        return $q.promise(function(resolve, reject) {
            if(info) {
                return resolve(info);
            }
            server.get('/api/stats/generic/info').then(function(result) {
                _.keys(result.properties).forEach(function(dt) {
                    var tlists = [result.reporttypes, result.datatypes];
                    tlists.forEach(function(t) {
                        t.forEach(function(i) {
                            i.translated = $filter('translate')(i.name);
                        });
                    });
                    var props = result.properties[dt];
                    props.forEach(function(p) {
                        if (p.datatype) {
                            p.datatype = _.findWhere(result.datatypes, {id: p.datatype});
                        }
                        if (p.joinedproperty) {
                            p.joinedproperty = _.findWhere(result.datatypes, {id: p.joinedproperty});
                        }
                    });
                });
                info = result;
                resolve(result);
            }, reject);
        });
    };

    return propertyhelper;
}]);

app.factory('scheme', ['$rootScope', '$filter', 'formatter', function($rootScope, $filter, formatter) {
    var scheme = {};
    var schemes;

    var setSchemes = function() {
        schemes = {
            staff: [
                { field: 'image', src: $rootScope.smallStaffImage },
                { field: 'firstname', title: 'First name' },
                { field: 'lastname', title: 'Last name' },
                { field: 'mail', title: 'E-mail' },
                { field: 'personalCodeNumber', title: 'Personal code number', format: 'personalCodeNumber' },
                { field: 'roles',  title: 'Roles', format: 'translatedCommaList' },
                { field: 'active', title: 'Active', format: 'bool' },
                { field: 'phone', title: 'Phone' },
                { field: 'oldphone', title: 'Old phone' },
                { field: 'address', title: 'Address', type: 'textarea' },
                { field: 'zipCode', title: 'Zip code' },
                { field: 'city', title: 'City' },
                { field: 'extraInfo', title: 'Extra info' }
            ],
            member: [
                { field: 'image', src: $rootScope.smallMemberImage },
                { field: 'firstname', title: 'First name' },
                { field: 'lastname', title: 'Last name' },
                { field: 'name', title: 'Name' },
                { field: 'mail', title: 'E-mail' },
                { field: 'created', title: 'Account created', format: 'datetime' },
                { field: 'memberNumber', title: 'Member number' },
                { field: 'personalCodeNumber', title: 'Personal code number', format: 'personalCodeNumber' },
                { field: 'age', title: 'Age', getValue: $rootScope.getAgeStringFromPerson },
                { field: 'phone', title: 'Phone' },
                { field: 'oldphone', title: 'Old phone' },
                { field: 'address', title: 'Address', type: 'textarea' },
                { field: 'zipCode', title: 'Zip code' },
                { field: 'city', title: 'City' },
                { field: 'extraInfo', title: 'Extra info' },
                { field: 'company', title: 'Company', format: 'bool' },
                { field: 'warnedUntil', title: 'Warned until', format: 'date' },
                { field: 'paidBy', title: 'Paid by', getValue: function(x) { return x.paidBy && $rootScope.getMember(x.paidBy).name; } },
                { field: 'paysFor', title: 'Pays for', getValue: function(x) { if (!x.paysFor) { return; } var x = angular.copy(x.paysFor); $rootScope.updatePointersById(x, $rootScope.members); return formatter.format('commaList', x); } },
                { field: 'consent', title: 'Direct debit consent', format: 'bool' },
                { field: 'status', title: 'Status', format: 'translatedCommaList' },
                { field: 'money', title: 'Value card', format: 'price' }
            ]
        };

        $rootScope.waitFor(['fields']).then(function() {
            $rootScope.getCustomerColumns(schemes.member);
        });
    };

    scheme.get = function(type, props) {
        var s = schemes[type];
        if (!props) {
            return s;
        }

        var res = s.filter(function(prop) {
            return props.indexOf(prop.field) != -1;
        });

        return Array.mergeSort(res, function(a, b) {
            var ai = props.indexOf(a.field);
            var bi = props.indexOf(b.field);
            return ai < bi ? -1 : (ai > bi? 1 : 0);
        });
    };

    $rootScope.$on('serverChange', function (event, message) {
        if (message.type == 'field') {
            setSchemes();
        }
    });

    setSchemes();

    return scheme;
}]);

app.controller('LoginCtrl', ['$rootScope', function($rootScope) {
    $rootScope.showLogin();
}]);

app.controller('ResetPasswordCtrl', ['$rootScope', '$scope', '$location', '$routeParams', 'server', 'focus', function($rootScope, $scope, $location, $routeParams, server, focus) {
    $scope.message = "";
    $scope.messageType = "alert-danger";
    $scope.postUrl = '/api/memberapi/resetPassword';
    $scope.showMessage = function() {
        return ($scope.message != "");
    };
    $scope.save = function(password) {
        var hash = $routeParams.hash;
        server.post($scope.postUrl, null, {hash: hash, newPassword: password}).then(function(result) {
            if (result.success) {
                $rootScope.showLogin(result.data.mail, password).result.then(function() {
                    $location.path('/');
                });
            } else {
                $scope.messageType = "alert-danger";
                $scope.message = result.data.message;
            }

            $("#form").scope().form.$setPristine();
            $scope.password = undefined;
        });
    };

    focus('focus_password');
}]);

app.controller('SetPasswordCtrl', ['$scope', '$controller', function($scope, $controller) {
    $controller('ResetPasswordCtrl', {$scope:$scope});
    $scope.postUrl = '/api/memberapi/setPassword';

    $scope.formInvalid = function(password, passwordRepeat) {
        return password !== passwordRepeat;
    };

    var oldSave = $scope.save;
    $scope.save = function(password) {
        oldSave(password);
        $scope.passwordRepeat = undefined;
    };
}]);


app.controller('ForgotPasswordCtrl', ['$rootScope', '$scope', '$http', '$location', 'focus', function($rootScope, $scope, $http, $location, focus) {
    $scope.message = "";
    $scope.messageType = "alert-danger";
    $scope.showMessage = function() {
        return ($scope.message != "");
    };
    $scope.successMessage = function() {
        return $scope.showMessage() && $scope.messageType == 'alert-success';
    };
    $scope.reset = function(mail) {
        $http.post('/api/memberapi/requestResetPassword?staff=true&mail=' + encodeURIComponent(mail)).success(function () {
            $scope.messageType = "alert-success";
            $scope.message = "An email with info has been sent";
        }).error(function(data) {
            $scope.messageType = "alert-danger";
            $scope.message = data.message;
        });
    };

    focus('focus_mail');
}]);

app.controller('TableCtrl', ['$scope', '$modal', '$http', '$filter', 'alertProvider', function($scope, $modal, $http, $filter, alertProvider) {
    $scope.showCount = function() {
        return false;
    };

    $scope.headerVisible = function() {
        return true;
    };

    $scope.setOrder = function(column) {
        if ($scope.orderColumn == column) {
            $scope.orderColumn = '-' + column;
        } else {
            $scope.orderColumn = column;
        }
    };

    $scope.thButtonStyle = function() {
        var pixels = $scope.buttons.length * 30;
        return {"width": pixels + "px"};
    };

    $scope.getValue = function(column, item) {
        if (typeof column.getValue == 'function') {
            return column.getValue(item);
        }

        return item[column.field];
    };

    $scope.removeModal = function(options) {
        var modalInstance = $modal.open({
            templateUrl: 'views/remove.html',
            controller: options.controller || 'ModalCtrl',
            resolve: {
                options: function() {
                    return options;
                }
            }
        });

        modalInstance.result.then(function (reason) {
            var permanent = (reason == 'remove');
            var itemTitle = $filter('translate')(options.itemTitle);
            $http.post(options.postUrl + '?id=' + options.item.id + '&permanent=' + permanent).success(function () {
                var msg = permanent ? '{0} was removed' : '{0} was inactivated';
                msg = $filter('translate')(msg);
                msg = msg.format(itemTitle);
                alertProvider.show('success', msg, true);
            }).error(function () {
                var msg = permanent ? 'Failed to remove {0}' : 'Failed to inactivate {0}';
                msg = $filter('translate')(msg);
                msg = msg.format(itemTitle.toLowerCase());
                alertProvider.show('error', msg, true);
            });
        });
    };
}]);

app.controller('ActiveTableCtrl', ['$scope', '$controller', '$modal', 'server', function($scope, $controller, $modal, server) {
    $controller('TableCtrl', {$scope: $scope});

    $scope.itemFilter = function(item) {
        return item.active;
    };

    $scope.inactivateModal = function(item, title, content, postUrl) {
        var modalInstance = $modal.open({
            templateUrl: 'views/inactivate.html',
            controller: 'ModalCtrl',
            resolve: {
                options: function() {
                    return {title: title, content: content};
                }
            }
        });

        modalInstance.result.then(function () {
            var data = {id: item.id, active: false};
            server.post(postUrl, data, null, '{0} was inactivated', 'Failed to inactivate {0}', title);
        });
    };
}]);

app.controller('InactiveTableCtrl', ['$scope', '$controller', '$modal', 'server', function($scope, $controller, $modal, server) {
    $controller('TableCtrl', {$scope: $scope});

    $scope.itemFilter = function(item) {
        return !item.active;
    };

    $scope.activateModal = function(item, title, content, postUrl) {
        var modalInstance = $modal.open({
            templateUrl: 'views/activate.html',
            controller: 'ModalCtrl',
            resolve: {
                options: function() {
                    return {title: title, content: content};
                }
            }
        });

        modalInstance.result.then(function () {
            var data = {id: item.id, active: true};
            server.post(postUrl, data, null, '{0} was activated', 'Failed to activate {0}', title);
        });
    };
}]);

app.controller('StaffListCtrl', ['$rootScope', '$scope', '$modal', '$filter', 'scheme', 'util', function($rootScope, $scope, $modal, $filter, scheme, util) {

    function getSelectedItems() {
        return $scope.staffsConfig.control.getActiveTab().config.control.getFilteredItems();
    }

    var sendMailing = function() {
        var items = getSelectedItems();
        $scope.pubsub.publish('newmailingdata', {
            isNewsOrAdvertising: false,
            sendOption: 'mail',
            receivers: items,
            options: { 'callCloseOnSuccess': true, 'modalMode': false }
        });
        $modal.open({
            templateUrl: 'views/mailingnew.html',
            windowClass: 'huge-modal-window',
            controller: 'NewMailingCtrl'
        });
    };

    var getExcel = function(config) {
        config.control.exportTo('excel').then(function(blob) {
            util.download($filter('translate')('Staff') + '.xlsx', null, null, blob);
        });
    };

    var getColumns = function() {
        var props = ['image', 'firstname', 'lastname', 'roles'];
        return scheme.get('staff', props);
    };

    var syncMailChimp = function(config) {
        $modal.open({
            templateUrl: 'views/mailchimp.html',
            controller: 'MailChimpCtrl',
            resolve: {
                items: function() {
                    return config.control.getFilteredItems();
                }
            }
        });
    };

    function isForCurrentSite(s) {
        return !$rootScope.hasModule('MultiSite') || ($rootScope.selectedSite && s.sites.indexOf($rootScope.selectedSite.id) != -1);
    }

    var activeOnEmpty = {
        title: 'Right now, it\'s just you here.',
        text: 'Invite a colleague! They will receive an email with a link to follow.',
        button: { title: 'Add new staff', onClick: $rootScope.addStaff },
        visible: function() { var tab = $scope.staffsConfig.control && $scope.staffsConfig.control.getActiveTab(); return $rootScope.hasPermission('Staff handling') && tab && tab.config.control.getNumberOfItems() <= 1; }
    };
    var inActiveOnEmpty = {
        getTitle: function() {
            return getSelectedItems().length ?
                'Disabled staff accounts are collected here. They are saved and can be activated again at a later time' :
                'Disabled staff accounts will be collected here. They are then saved and can be activated again at a later time.';
        },
        getText: function() {
            return getSelectedItems().length ?
                'To activate an account, click on the person and scroll to the bottom of their page to the \"Activate\" button.' :
                'To deactivate an account, go to the person in the "Active" tab and scroll to the bottom of their page.';
        },
        visible: function() { return true; }
    };

    $scope.staffsConfig = {
        getItems: function() {
            return $rootScope.staffs.filter(function(s) { return s.type == 'user' && isForCurrentSite(s); } );
        },
        triggers: ['user', 'image'],
        countSuffixList: ['staff', 'staffs'],
        getTitle: function() {
            return 'Staff';
        },
        orderColumn: 'lastname',
        tabs: [
            { name: 'Active', badgeClass: 'badge-success', itemFilter: function(staff) { return staff.active; }, empty: activeOnEmpty },
            { name: 'Inactive', itemFilter: function(staff) { return !staff.active; }, empty: inActiveOnEmpty }
        ],
        searchBarVisible: function() { return $scope.staffsConfig.control.getActiveTab().name == 'Active' ? $scope.staffsConfig.control.getActiveTab().config.control.getNumberOfItems() > 1 : true; },
        rowClick: $rootScope.gotoStaff,
        columns: getColumns(),
        getColumns: function() {
            return scheme.get('staff');
        },
        searchButtons: [
            {title: 'Send mailing', onClick: function() { sendMailing();}, visible: function() {return $rootScope.hasPermission('Mailing handling');} },
            {title: 'Download as Excel', onClick: getExcel, visible: function() { return true; } },
            {title: 'Sync with MailChimp', onClick: syncMailChimp, visible: function() { return $rootScope.hasPermission('Sync with MailChimp');} },
            {title: 'Add new staff', onClick: $rootScope.addStaff, visible: function() { return $rootScope.hasPermission('Staff handling'); } }
        ]
    };

    if ($rootScope.speedy) {
        $scope.staffsConfig.api = {
            url: '/api/staff/get',
            args: {
                site_id: () => $rootScope.hasModule('MultiSite') ? $rootScope.selectedSite.id : null,
                inactive: true,
                compact: true,
                fields: 'id,imagekey,imageurl,firstname,lastname,roles,inuse'
            },
            triggers: [{type: 'user'}, {type: 'image'}, {type: 'selectedSite'}],
            transform: i => {
                i.active = i.inuse;
            }
        };
        delete $scope.staffsConfig.getItems;
        delete $scope.staffsConfig.triggers;
    } else {
        $scope.pubsub('selectedSite', function() {
            if ($scope.staffsConfig.control) {
                $scope.staffsConfig.control.rebuild();
            }
        });
    }
}]);

app.controller('CustomerListCtrl', ['$rootScope', '$scope', '$controller', '$modal', '$location', '$filter', 'scheme', 'util', function($rootScope, $scope, $controller, $modal, $location, $filter, scheme, util) {
    var getColumns = function() {
        var props = ['image', 'name', 'memberNumber', 'age'];
        var columns = angular.copy(scheme.get('member', props));
        var mn = _.findWhere(columns, {field: 'memberNumber'});
        if (mn) {
            mn.visible = function() { return $rootScope.hasMemberNumber; };
        }
        return columns;
    };

    $scope.config = {
        getItems: function() {
            return $rootScope.members;
        },
        showCount: function() {
            return true;
        },
        rowClick: function(customer) {
            $rootScope.gotoCustomer(customer);
        },
        countSuffix: function() {
            return $filter('translate')($scope.config.control.getNumberOfFilteredItems() == 1 ? 'customer' : 'customers');
        },
        columns: getColumns(),
        getColumns: function() {
            return scheme.get('member');
        },
        getTitle: function() {
            return 'Customers';
        }
    };

    $scope.change = function(customer) {
        util.showDataDialog({controller: 'CustomerDataCtrl', item: customer});
    };

    $scope.book = function(customer) {
        $modal.open({
            templateUrl: 'views/addbookingmodal.html',
            controller: 'BookingAddModalCtrl',
            resolve: {
                customer: function() {
                    return customer;
                }
            }
        });
    };

    $scope.sms = function(customer) {
        $modal.open({
            templateUrl: 'views/sms.html',
            controller: 'SMSModalCtrl',
            resolve: {
                recipient: function() {
                    return customer;
                }
            }
        });
    };

    $scope.addTrainingCard = function(customer) {
        $rootScope.openTrainingCardSale(customer);
    };
}]);

app.controller('BookingAddModalCtrl', ['$rootScope', '$scope', '$http', '$timeout','workoutProvider', 'alertProvider', 'server', 'customer', function($rootScope, $scope, $http, $timeout, workoutProvider, alertProvider, server, customer) {
    $scope.customer = customer;
    $scope.data = {};
    $scope.titleSuffix = function() {
        return $scope.customer.name;
    };

    $scope.displayWorkout = function(workout) {
        return workout.workoutType.name + ", " + workout.startTime.yyyymmdd() + ", " + workout.startTime.hhmm() + " - " + workout.endTime.hhmm();
    };

    $scope.workoutFilter = function(item) {
        var now = new Date();
        var full = item.space && item.bookings.length >= item.space;
        return item.startTime > now && item.status != 'Cancelled' && !$scope.isBooked(item, $scope.customer) && (!full || $rootScope.hasModule('Queue'));
    };

    $scope.isBooked = function(workout, customer) {
        return _.findWhere(workout.bookings, {member:customer});
    };

    $scope.submit = function() {
        $rootScope.makeWorkoutBooking($scope.customer, $scope.data.selectedWorkout);
    };

    var toDate = new Date();
    toDate.setYear(toDate.getFullYear() + 10);
    $scope.workouts = [];
    workoutProvider.get(new Date().yyyymmdd(), toDate.yyyymmdd()).then(function(workouts) {
        $scope.workouts = workouts;
        $scope.workoutsLoaded = true;
    });
}]);

app.controller('CustomerAdvancedSearchSpeedyCtrl', ['$rootScope', '$scope', '$controller', '$filter', '$timeout', '$http', '$modal', 'usSpinnerService', 'genders', 'util', 'Setting', 'pubsub', '$location', 'server', 'propertyhelper', function($rootScope, $scope, $controller, $filter, $timeout, $http, $modal, usSpinnerService, genders, util, Setting, pubsub, $location, server, propertyhelper) {
    $controller('CustomerListCtrl', {$scope: $scope});

    function loadStaffs() {
        return $rootScope.waitFor(['sites']).then(() => {
            return server.get('/api/staff/get', {site_id: $rootScope.selectedSite.id, inactive: false, compact: true, fields: 'id'}).then(staffs => {
                staffs.forEach($rootScope.getMember);
            })
        });
    }
    loadStaffs();

    $scope.ages = [];
    for (var i=0; i < 100; ++i) {
        $scope.ages.push(i);
    }
    $scope.genders = genders.getList();

    $scope.reportconfig = {
        option: {hideHeader: false, keyvaluecenter: true, showMailing: true, showReload: false, hideSearchWhenFewerThan: 1000000}
    };

    $scope.search = {}; // genders, ages, workouttypes, cardtypes, currentcardtypes, expire, text
    $scope.search.genders = $scope.genders;
    $scope.search.ages = {from: 0, to: 99};

    var translateGenders = function() {
        $scope.genders.forEach(function(g) {
            g.translated = $filter('translate')(g.name);
        });
    };
    translateGenders();

    var removeTranslateChangeSuccess = $rootScope.$on('$translateChangeSuccess', function () {
        translateGenders();
    });

    propertyhelper.getInfo().then(function(result) {
        $scope.info = result;
    });

    $rootScope.waitFor(['fields']).then(function() {
        $scope.config.searchFields = $rootScope.getCustomerProperties();

        $scope.visibleInterest = false;
        $rootScope.fields.user.forEach(function(f) {
            if(f.name !== 'interest') {return;}
            $scope.visibleInterest = f.register || f.show;
        });
    });

    function search() {
        let searchThings = [];
        if ($scope.search.text) {
            searchThings.push({
                "type": "or",
                "content": [
                    {
                        "type": "expression",
                        "lhs": "user.name",
                        "operation": "contains",
                        "rhs": $scope.search.text
                    },
                    {
                        "type": "expression",
                        "lhs": "user.mail",
                        "operation": "contains",
                        "rhs": $scope.search.text
                    },
                    {
                        "type": "expression",
                        "lhs": "user.personalCodeNumber",
                        "operation": "contains",
                        "rhs": $scope.search.text
                    },
                    {
                        "type": "expression",
                        "lhs": "user.phone",
                        "operation": "contains",
                        "rhs": $scope.search.text
                    },
                    {
                        "type": "expression",
                        "lhs": "user.extraInfo",
                        "operation": "contains",
                        "rhs": $scope.search.text
                    },
                    {
                        "type": "expression",
                        "lhs": "user.city",
                        "operation": "contains",
                        "rhs": $scope.search.text
                    },
                    {
                        "type": "expression",
                        "lhs": "user.address",
                        "operation": "contains",
                        "rhs": $scope.search.text
                    },
                    {
                        "type": "expression",
                        "lhs": "user.zipCode",
                        "operation": "contains",
                        "rhs": $scope.search.text
                    }
                ]
            });
        }

        if ($scope.search.genders && ($scope.search.genders.length > 0 && $scope.search.genders.length < 3)) {
            const genderIds = $scope.search.genders.map(x => x.id)
            searchThings.push({
                "type": "or",
                "content": genderIds.map(genderId => {
                    return {
                        "type": "expression",
                        "lhs": "user.gender",
                        "operation": "eq",
                        "rhs": genderId
                    }
                })
            });
        }

        if ($scope.search.ages.from != 0 || $scope.search.ages.to != 99) {
            searchThings.push({
                "type": "and",
                "content": [
                    {
                        "type": "expression",
                        "lhs": "user.age",
                        "operation": "gte",
                        "rhs": $scope.search.ages.from
                    },
                    {
                        "type": "expression",
                        "lhs": "user.age",
                        "operation": "lte",
                        "rhs": $scope.search.ages.to
                    }
                ]
            });
        }

        if ($scope.search.validTrainingCard) {
            searchThings.push({
                "type": "expression",
                "lhs": "user.active",
                "operation": "eq",
                "rhs": $scope.search.validTrainingCard == 'Yes'
            });
        }

        if ($scope.search.consent) {
            searchThings.push({
                "type": "expression",
                "lhs": "user.consent",
                "operation": "eq",
                "rhs": $scope.search.consent == 'Yes'
            });
        }

        if ($scope.search.card) {
            searchThings.push({
                "type": "expression",
                "lhs": "user.card",
                "operation": $scope.search.card == 'Yes' ? "neq" : "eq",
                "rhs": '{null}'
            });
        }

        if ($scope.search.responsible) {
            searchThings.push({
                "type": "expression",
                "lhs": "user.responsible.id",
                "operation": "eq",
                "rhs": $scope.search.responsible.id
            });
        }

        if ($scope.search.cardtypes && $scope.search.cardtypes.length) {
            searchThings.push({
                "type": "expression",
                "lhs": "user.trainingcards.cardtype_id",
                "operation": "in",
                "rhs": $scope.search.cardtypes.map(x => x.id)
            });
        }

        if ($scope.search.currentcardtypes && $scope.search.currentcardtypes.length) {
            searchThings.push({
                "type": "expression",
                "lhs": "user.activetrainingcards.cardtype_id",
                "operation": "in",
                "rhs": $scope.search.currentcardtypes.map(x => x.id)
            });
        }

        if ($scope.search.status && $scope.search.status.length) {
            searchThings.push({
                "type": "expression",
                "lhs": "user.status.id",
                "operation": "in",
                "rhs": $scope.search.status.map(x => x.id)
            });
        }

        if ($scope.search.interest && $scope.search.interest.length) {
            searchThings.push({
                "type": "expression",
                "lhs": "user.interest.id",
                "operation": "in",
                "rhs": $scope.search.interest
            });
        }

        const searchPostData = {
            "reporttype": "list",
            "datatype": "user",
            "usetime": false,
            "filter": {
                "type": "and",
                "content": [
                    {
                        "type": "expression",
                        "lhs": "user.removed",
                        "operation": "eq",
                        "rhs": "{null}"
                    }
                ].concat(searchThings)
            },
            "properties": [
              "image",
              "name",
              "age"
            ]
        };

        $scope.searching = true;
        server.post('/api/stats/generic', searchPostData, null).then(function(result) {
            if (result.success) {
                $scope.data = result.data;
            } else {
                $scope.error = true;
            }

            $scope.searching = false;
        });
    }

    $scope.applyFilter = function() {
        search();
    };

    $scope.$watchGroup(['search.cardtypes', 'search.currentcardtypes', 'search.workouttypes', 'search.lastvisit', 'search.validTrainingCard', 'search.text', 'search.interest'], function() {
        search();
    });

    $scope.$on('$destroy', function () {
        removeTranslateChangeSuccess();
    });
}]);

app.controller('CustomerAdvancedSearchBaseCtrl', ['$rootScope', '$scope', '$controller', '$filter', '$timeout', '$http', '$modal', 'usSpinnerService', 'genders', 'util', 'Setting', 'pubsub', '$location', function($rootScope, $scope, $controller, $filter, $timeout, $http, $modal, usSpinnerService, genders, util, Setting, pubsub, $location) {
    $controller('CustomerListCtrl', {$scope: $scope});

    Setting.get('Entry').then(function(data) {
        $scope.showEntryCard = data.show_card;
    });

    $scope.ages = [];
    for (var i=0; i < 100; ++i) {
        $scope.ages.push(i);
    }
    $scope.genders = genders.getList();

   var translateGenders = function() {
        $scope.genders.forEach(function(g) {
            g.translated = $filter('translate')(g.name);
        });
    };
    translateGenders();

    $scope.tableapi = {};
    $scope.mapcontrol = {};
    $scope.search = {}; // genders, ages, workouttypes, cardtypes, currentcardtypes, expire
    $scope.search.genders = $scope.genders;
    $scope.search.ages = {from: 0, to: 99};
    var initialized = {};
    $scope.searching = false;
    $scope.filtersearching = $rootScope.hasPermission('Download customer register');

    $scope.serverSearchResult = null;
    $scope.config.itemFilter = function(customer) {
        if ($scope.search.genders.length && $scope.search.genders.length < 3) {
            var gender = customer.gender;
            if(!gender) {
                if (util.isValidPersonalCode(customer.personalCodeNumber) && !customer.company) {
                    gender = (customer.personalCodeNumber[10] % 2 == 0)?'female':'male';
                } else {
                    return false;
                }
            }
            var match = false;
            for(var i=0; i<$scope.search.genders.length; i++) {
                if(gender === $scope.search.genders[i].id) {
                    match = true;
                    break;
                }
            }
            if(!match) {return false;}
        }

        if ($scope.search.ages.from != 0 || $scope.search.ages.to != 99) {
            if (!customer.company && (customer.birthdate || util.isValidPersonalCode(customer.personalCodeNumber))) {
                var age = $rootScope.getAgeFromPerson(customer);
                if (age < $scope.search.ages.from || age > $scope.search.ages.to) {
                    return false;
                }
            } else {
                return false;
            }
        }

        if ($scope.search.card) {
            if (($scope.search.card == 'Yes') != customer.hasCard) {
                return false;
            }
        }

        if ($scope.search.entry_card_value) {
            if(!customer.entry_card_value) {return false;}
            if(customer.entry_card_value.toLowerCase().indexOf($scope.search.entry_card_value.toLowerCase()) < 0) {return false;}
        }

        if ($scope.search.consent) {
            if (($scope.search.consent == 'Yes') != customer.consent) {
                return false;
            }
        }

        if ($scope.search.status && $scope.search.status.length) {
            var hasAny = false;
            for (var i=0; i < $scope.search.status.length; ++i) {
                var s = $scope.search.status[i];
                if (customer.status.indexOf(s) != -1) {
                    hasAny = true;
                }
            }

            if (!hasAny) {
                return false;
            }
        }

        if ($scope.search.responsible) {
            if (customer.responsible != $scope.search.responsible) {
                return false;
            }
        }

        if (!$rootScope.siteAccessFilter(customer.homesite_id)) {
            return false;
        }

        if ($scope.searching) {
            return false;
        }

        var s = $scope.serverSearchResult;
        if (s) {
            if (s.workouts) {
                if (s.workouts.indexOf(customer.id) == -1) {
                    return false;
                }
            }

            if (s.visits) {
                if (s.visits.indexOf(customer.id) != -1) {
                    return false;
                }
            }

            if (s.cardtypes) {
                if (s.cardtypes.indexOf(customer.id) == -1) {
                    return false;
                }
            }

            if (s.currentcardtypes) {
                if (s.currentcardtypes.indexOf(customer.id) == -1) {
                    return false;
                }
            }

            if (s.expire) {
                if (!s.expire[customer.id]) {
                    return false;
                }
            }

            if (s.interest) {
                if (s.interest.indexOf(customer.id) == -1) {
                    return false;
                }
            }

            if ($scope.search.validTrainingCard == 'Yes') {
                if (s.validTrainingCards.indexOf(customer.id) == -1) {
                    return false;
                }
            } else if ($scope.search.validTrainingCard == 'No') {
                if (s.validTrainingCards.indexOf(customer.id) != -1) {
                    return false;
                }
            }
        }

        return true;
    };

    $scope.formatTooltip = function(x) {
        return x + ' år';
    };

    $scope.applyFilter = function() {
        if ($scope.tableapi.update) {
            $scope.tableapi.update();
        }
    };

    $scope.serverSearch = function() {
        var workouts = _.pluck($scope.search.workouttypes, 'id');
        var cardtypes = _.pluck($scope.search.cardtypes, 'id');
        var currentcardtypes = _.pluck($scope.search.currentcardtypes, 'id');

        if (workouts.length > 0 || $scope.search.lastvisit || cardtypes.length > 0 || currentcardtypes.length > 0 || $scope.search.expire || $scope.search.validTrainingCard || $scope.search.interest && $scope.search.interest.length) {
            $scope.searching = true;
            var expire;
            if ($scope.search.expire) {
                expire = {};
                expire.fromDate = $scope.search.expire.fromDate.yyyymmdd();
                expire.toDate = $scope.search.expire.toDate.yyyymmdd();
            }
            var searchquery = {
                workouts: workouts,
                lastvisit: $scope.search.lastvisit && $scope.search.lastvisit.yyyymmdd(),
                cardtypes: cardtypes,
                currentcardtypes: currentcardtypes,
                expire: expire,
                validTrainingCard: $scope.search.validTrainingCard != null,
                interest: $scope.search.interest
            };
            $http.post('/api/user/old_search', searchquery).success(function(result) {
                if (result.expire) {
                    angular.forEach(result.expire, function(e) {
                        e.expires = Date.newFull(e.expires);
                    });
                }
                $scope.serverSearchResult = result;
                $scope.searching = false;
                $scope.applyFilter();
            });
        } else {
            $scope.serverSearchResult = null;
            $scope.applyFilter();
        }
    };

    $scope.getNumberOfMatches = function() { // FIXME: Remove
        return $scope.tableapi.getNumberOfFilteredItems && $scope.tableapi.getNumberOfFilteredItems();
    };

    var waitingForMore = null;
    $scope.$watchCollection('search.ages', function() {
        if (initialized.ages) {
            if (waitingForMore) {
                $timeout.cancel(waitingForMore);
            }

            waitingForMore = $timeout(function() {
                $scope.applyFilter();
            }, 500);
        } else {
           $timeout(function() {
                initialized.ages = true;
            });
        }
    });

    $scope.$watch('search.entry_card_value', $scope.applyFilter);

    $rootScope.waitFor(['fields']).then(function() {
        $scope.config.searchFields = $rootScope.getCustomerProperties();

        $scope.visibleInterest = false;
        $rootScope.fields.user.forEach(function(f) {
            if(f.name !== 'interest') {return;}
            $scope.visibleInterest = f.register || f.show;
        });
    });

    $scope.sendMail = function() {
        var items = $scope.tableapi.getFilteredItems();
        var peopleWithMail = _.filter(items, function(item) { return item.mail; });
        pubsub.publish('newmailingdata', {
            isNewsOrAdvertising: false,
            sendOption: 'mail',
            receivers: peopleWithMail
        });
        $location.path('/mailings/new');
    };

    $scope.sendMailing = function() {
        var items = $scope.tableapi.getFilteredItems();
        pubsub.publish('newmailingdata', {
            isNewsOrAdvertising: false,
            sendOption: 'mail',
            receivers: items,
            options: { 'callCloseOnSuccess': true, 'modalMode': false, noRedirect: true }
        });
        $modal.open({
            templateUrl: 'views/mailingnew.html',
            windowClass: 'huge-modal-window',
            controller: 'NewMailingCtrl'
        }).result.then($scope.$close);
    };

    $scope.sendSMS = function() {
        var items = $scope.tableapi.getFilteredItems();
        var peopleWithPhone = _.filter(items, function(item) { return item.phone; });
        pubsub.publish('newmailingdata', {
            isNewsOrAdvertising: false,
            sendOption: 'sms',
            receivers: peopleWithPhone
        });
        $location.path('/mailings/new');
    };

    $scope.sendLetter = function() {
        var items = $scope.tableapi.getFilteredItems();
        $modal.open({
            templateUrl: 'views/letter.html',
            controller: 'LetterModalCtrl',
            resolve: {
                sendlist: function() {
                    return items;
                }
            }
        });
    };

    $scope.getExcel = function() {
        $scope.config.control.exportTo('excel').then(function(blob) {
            util.download($filter('translate')('Customers') + '.xlsx', null, null, blob);
        });
    };

    var isCardActive = function(card) {
        if (card.resourcebookingservice) {
            return (card.resourcebookingservice.active && card.resourcebookingservice.category.active && card.active);
        }

        return card.active;
    };

    $scope.getTrainingCardGroup = function(card) {
        if (isCardActive(card)) {
            return card.resourcebookingservice ? 'Resource booking' : 'Training card';
        } else {
            return card.resourcebookingservice ? 'Inactive resource booking' : 'Inactive training cards';
        }
    };

    $scope.getGroupOrder = function(card) {
        if (isCardActive(card)) {
            return card.resourcebookingservice ? 1 : 0;
        } else {
            return card.resourcebookingservice ? 3 : 2;
        }
    };

    $scope.syncMailChimp = function(config) {
        $modal.open({
            templateUrl: 'views/mailchimp.html',
            controller: 'MailChimpCtrl',
            resolve: {
                items: function() {
                    return config.control.getFilteredItems();
                }
            }
        });
    };

    $scope.config.searchButtons = [
        {title: 'Send mailing', onClick: $scope.sendMailing, visible: function() { return $rootScope.hasPermission('Mailing handling'); } },
        {title: 'Download as Excel', onClick: $scope.getExcel, visible: function() { return $rootScope.hasPermission('Download customer register'); } },
        {title: 'Sync with MailChimp', onClick: $scope.syncMailChimp, visible: function() { return $rootScope.hasPermission('Sync with MailChimp');} }
    ];

    var removeTranslateChangeSuccess = $rootScope.$on('$translateChangeSuccess', function () {
        translateGenders();
    });

    $scope.$watchGroup(['search.cardtypes', 'search.currentcardtypes', 'search.workouttypes', 'search.lastvisit', 'search.validTrainingCard'], function() {
        $scope.serverSearch();
    });

    $scope.$on('$destroy', function () {
        removeTranslateChangeSuccess();
    });
}]);

app.controller('CustomerAdvancedSearchCtrl', ['$rootScope', '$scope', '$controller', function($rootScope, $scope, $controller) {
    $rootScope.waitFor(['staffs']).then(function() {
        if ($rootScope.speedy) {
            $controller('CustomerAdvancedSearchSpeedyCtrl', {$scope: $scope});
        } else {
            $controller('CustomerAdvancedSearchBaseCtrl', {$scope: $scope});
            $scope.config.hideSearch = true;
        }
    });
}]);

app.controller('EntryListCtrl', ['$rootScope', '$location', '$scope', '$filter', 'util', function($rootScope, $location, $scope, $filter, util) {
    $scope.imageSrc = function(entry, size) {
        return $rootScope.memberImage(entry.Member, size);
    };

    function gotoStats() {
        $location.path('/statistics/entrylist').search('date', Date.today().yyyymmdd());
    }

    $scope.getExcel = function(config) {
        config.control.exportTo('excel').then(function(blob) {
            util.download($filter('translate')(config.getTitle()) + '.xlsx', null, null, blob);
        });
    };

    $scope.tableConfig = {
        getItems: function() {
            return $rootScope.entries && $rootScope.entries.filter(function(e) { return ($rootScope.hasModule('MultiSite') && e.sites && e.sites.length) ? e.sites.indexOf($rootScope.selectedSite.id) !== -1 : true; });
        },
        itemFilter: function(entry) {
            return Date.dateEquals(entry.entryTime, Date.today());
        },
        countSuffix: function() {
            return $filter('translate')($scope.tableConfig.control.getNumberOfFilteredItems() == 1 ? 'customer' : 'customers');
        },
        rowClick: function(entry) {
            $rootScope.gotoCustomer(entry.Member);
        },
        rowClass: function(entry) {
            if (!entry.success) {
                return 'danger';
            }

            return 'success';
        },
        giveFocus: function() {
            return false;
        },
        getTitle: function() {
            return 'Entries';
        },
        hideSearch: true,
        orderColumn: '-entryTime',
        columns: [
            {field: 'image', src: $scope.imageSrc },
            {field: 'Member.name', title: 'Name' },
            {field: 'entryTime', title: 'Arrived at', format: 'time' },
            {field: 'door.name', title: 'Door' },
            {field: 'reason', title: 'Reason', format: 'translated' }
        ],
        searchButtons: [
            {title: 'Download as Excel', onClick: $scope.getExcel },
            {title: 'Show for other days', onClick: gotoStats, visible: function() { return $location.path().indexOf('/entry/show') == 0; } }
        ]
    };
}]);

app.controller('FailedEntryListCtrl', ['$rootScope', '$scope', '$http', '$modal', '$filter', 'resourceTypes', 'server', function($rootScope, $scope, $http, $modal, $filter, resourceTypes, server) {

    $scope.linkToCustomer = function(failedEntry) {
        $modal.open({
            templateUrl: 'views/getcustomermodal.html',
            windowClass: 'huge-modal-window',
            controller: 'GetCustomerCtrl',
            resolve: {
                options: function() {
                    return { };
                }
            }
        }).result.then(function (customer) {
            server.post('/api/card/set', null, {user_id: customer.id, cardId: failedEntry.cardId}, 'Card/tag registered', 'Failed to register card/tag');
        });
    };

    var addDoor = function(failedentry) {
        $modal.open({
            templateUrl: 'views/addmodal.html',
            controller: 'ResourceBookingResourceAddModalCtrl',
            resolve: {
                options: function() {
                    return {
                        resourceType: _.findWhere(resourceTypes.get(), {id: 'door'}),
                        externaldoorid: failedentry.externaldoorid
                    };
                }
            }
        });
    };

    var canAddDoor = function(failedentry) {
        return (!failedentry.door_id && failedentry.externaldoorid && $rootScope.hasPermission('Settings') );
    };

    $scope.tableConfig = {
        triggers: ['failedentry'],
        getItems: function() {
            return $scope.failedEntries && $scope.failedEntries.filter(function(e) { return ($rootScope.hasModule('MultiSite') && e.sites && e.sites.length) ? e.sites.indexOf($rootScope.selectedSite.id) !== -1 : true; });
        },
        itemFilter: function(entry) {
            return Date.dateEquals(entry.date, Date.today());
        },
        hideSearch: true,
        countSuffix: function() {
            return $filter('translate')('entries');
        },
        columns: [
            {field: 'date', title: 'Arrived at', format: 'time' },
            {field: 'cardId', title: 'Card id' },
            {field: 'door.name', title: 'Door' },
            {field: 'externaldoorid', title: 'External door id'}

        ],
        orderColumn: '-date',
        buttons: [
            { title: 'Link card to customer', onClick: $scope.linkToCustomer },
            { title: 'Add door', visible: canAddDoor, onClick: addDoor }
        ]
    };

    var transformFailedEntries = function(entries) {
        angular.forEach(entries, function(e) {
            e.date = Date.newFull(e.date);
            e.door = $rootScope.getMember(e.door_id);
        });
    };

    var date = new Date().yyyymmdd();
    $http.get('/api/entry/failed/get?fromDate=' + date + '&toDate=' + date).success(function(data) {
        transformFailedEntries(data);
        $scope.failedEntries = data;
    });

    var removeServerChange = $rootScope.$on('serverChange', function (event, message) {
        if (message.type == 'failedentry' && message.action == 'add') {
            transformFailedEntries(message.data);
            $scope.failedEntries.push.apply($scope.failedEntries, message.data);
            $scope.$apply();
        }
    });

    $scope.$on('$destroy', function () {
        removeServerChange();
    });
}]);

app.controller('TrainingCardTypeAddCtrl', ['$rootScope', '$scope', '$controller', '$filter', 'trainingCardType', function($rootScope, $scope, $controller, $filter, trainingCardType) {
    $controller('TrainingCardTypeChangeModalCtrl', {$scope: $scope, trainingCardType: trainingCardType });
    $scope.postUrl = '/api/trainingcard/type/add';
    $scope.title = 'Add';
    $scope.skipPriceCheck = true;
    $scope.titleSuffix = function() {
        return $filter('translate')('training card');
    };
}]);

app.controller('DownloadElectronCtrl', ['$scope', '$window', function($scope, $window) {

    $scope.basePath = 'autoupdate.zoezi.se/installers/';
    $scope.showThankyouMessage = false;
    $scope.installers = [
        { name: 'windows', installer: 'gswin32installer.exe' },
        { name: 'mac', installer: 'gsmacinstaller.dmg' }
    ];

    $scope.getLinkForOS = function(os) {
        var osObj = (_.findWhere($scope.installers, { name: os }) || {});
        return $scope.basePath + (osObj.installer || '');
    };

    $scope.toggleView = function() {
        $scope.showThankyouMessage = true;
    };

    $scope.download = function(link) {
        $window.open('//'+link, '_blank');
        $scope.toggleView();
    };

    $scope.fields = [
        {name: 'windows', title: 'Windows', type: 'button', buttonClass: 'btn-success', buttonTitle: 'Download', click: function() { $scope.download($scope.getLinkForOS('windows')); } },
        {name: 'mac', title: 'Mac', type: 'button', buttonClass: 'btn-success', buttonTitle: 'Download', click: function() { $scope.download($scope.getLinkForOS('mac')); } }
    ];
}]);

app.controller('NotBookableByCardCtrl', ['$rootScope', '$scope', 'options', '$modal', 'util', 'server', function($rootScope, $scope, options, $modal, util, server) {

    $scope.options = options;
    $scope.fields = [];

    $scope.availableViaCourses = function() {
        return $scope.options.workout.courses.length > 0;
    }

    var bookCustomerOnCourse = function(course_id) {
        server.get('/api/course/get').then(function(courses) {

            let courseObj = courses.find(c => c.id === course_id)
            courseObj.name = courseObj.product.name;

            $modal.open({
                templateUrl: 'views/coursebookingaddmodal.html',
                controller: 'CourseBookingAddCtrl',
                resolve: {
                    options: function() {
                        return {
                            customer: $scope.options.customer,
                            course: courseObj
                        };
                    }
                }
            });
        });
    }

    options.workout.courses.forEach(course => {
        $scope.fields.push({name: 'course', title: course.name, type: 'button', buttonClass: 'btn-success', buttonTitle: 'Book', click: function() { bookCustomerOnCourse(course.id) } })
    })

    $scope.openActivityTypeSettings = function() {
        // Open settings for activity
        util.showDataDialog({controller: 'WorkoutTypeDataCtrl', item: $scope.options.workout.workoutType});
    };
}]);

app.controller('ComboAddModalCtrl', ['$rootScope', '$scope', '$location', '$controller', '$http', '$filter', '$timeout', 'alertProvider', 'server', 'options', 'paymentMethods', 'util', 'image', 'genders', 'confirm', 'modalUtils', function($rootScope, $scope, $location, $controller, $http, $filter, $timeout, alertProvider, server, options, paymentMethods, util, image, genders, confirm, modalUtils) {
    $controller('AddCtrl', {$scope: $scope});

    $scope.options = options;

    var addingCustomer = function() {
        return !options.customer;
    };

    var showTrainingCard = function() {
        return (options.customer || options.workout);
    };

    var onlyAddingCustomer = function() {
        return !showTrainingCard() && !options.rbslot;
    };

    $scope.data = {payments: null};
    if (addingCustomer()) {
        $scope.fieldSettings = {minimal: options.minimal === undefined ? true : options.minimal};
        $scope.title = 'Add new customer';
    } else {
        $scope.title = options.membership ? 'Add new membership' : 'Add training card';
    }

    $scope.getPayments = function(payMethod, trainingcard_id, customer_id, payer_id) {
        var payments = [];
        for (var i=0; i < $scope.data.payments.length; ++i) {
            var p = $scope.data.payments[i];
            var pay = {};
            pay.date = p.date.yyyymmdd();
            pay.amount = p.amount;
            pay.trainingcard_id = trainingcard_id;
            pay.member_id = customer_id;
            pay.method = payMethod;
            if (customer_id) {
                var paidBy = $rootScope.getMember(customer_id).paidBy;
                pay.payer_id = payer_id || (paidBy ? paidBy : customer_id);
            }
            if(p.from_date) {
                pay.from_date = p.from_date.yyyymmdd();
            }
            if(p.to_date) {
                pay.to_date = p.to_date.yyyymmdd();
            }
            pay.site_id = _.findWhere($scope.fields, {name: 'site_id'}).value.id;

            let discount_id = _.findWhere($scope.fields, {name: 'discount'}).value?.id;
            if (p.discount && discount_id) {
                pay.discounts = [{id: discount_id, amount: p.discount}];
                pay.discount = p.discount;
            }

            if (p.discount) {
                pay.amount = Number(p.amount) - Number(p.discount);
            }

            payments.push(pay);
        }

        return payments;
    };

    function loadInstallations() {
        if ($rootScope.hasModule('Admin') && $rootScope.hasPermission('Zoezi admin')) {
            return server.get('/api/admin/domain/get').then(data => {
                $scope.installations = data.map(i => ({id: i.name, name: `${i.gymName} (${i.name})`}));
            });
        }
    }
    loadInstallations();

    $scope.addWorkoutBooking = function() {
        server.post('/api/workoutBooking/add', {workout: options.workout.id, memberId: options.customer.id}, null, 'Booking was added', 'Failed to add booking').then(function() {
            $scope.$close();
        });
    };

    $scope.postUrl = '/api/user/add';

    $scope.addTrainingCard = function(item) {
        var customer = options.customer;
        var vat;
        var workout;
        if (options.workout && item.trainingcard.workoutBooking) {
            vat = options.workout.workoutType.vat;
            workout = options.workout.id;
        }
        var days;
        if (item.otherTermsOfPayment) {
            days = item.termsOfPayment;
        }

        item.cardtype_id = item.trainingcard.id;
        delete item.trainingcard;
        var onetimeFeeField = _.findWhere($scope.fields, {name: 'onetime_fee'});
        var hasOnetimeFeeOverride = onetimeFeeField?.visible?.();
        if (hasOnetimeFeeOverride) item.onetime_fee_product_id = item.onetime_fee;
        delete item.onetime_fee;
        item.member_id = customer.id;

        var payMethod = item.payMethod;

        var doAddTrainingCard = function() {
            var payer_id = $scope.useOtherPayer() ? _.findWhere($scope.fields, {name: 'payer_id'}).value.id : null;
            var payments = $scope.getPayments(payMethod, null, customer.id, payer_id);
            if (payments.length) {
                angular.forEach(payments, function(payment) {
                    if (payment.amount === '') {
                        payment.amount = 0;
                    }
                    if (payment.amount == 0) {
                        payment.paid = true;
                    }
                    if (vat) {
                        payment.vat = vat;
                    }
                    if (workout) {
                        payment.workout_id = workout;
                    }
                    if (days) {
                        payment.days = days;
                    }
                });
                item._add_payments = payments;
            }

            $http.post('/api/trainingcard/add', item).success(function() {
                if (options.workout) {
                    $scope.addWorkoutBooking();
                } else {
                    alertProvider.show('success', 'Training card added');
                    $scope.$close();
                }
                if ($scope.$finishGuide) {
                    $scope.$finishGuide();
                }
                $scope.loadingStatus.loading = false;
            }).error(function (data) {
                var message = data && data.message ? data.message : 'Failed to add training card';
                alertProvider.show('error', message);
                $scope.loadingStatus.loading = false;
            });
        };

        if (payMethod == 'stripe') {
            confirm.show('CHARGENOWCONFIRM').then(doAddTrainingCard, function() {
                $scope.loadingStatus.loading = false;
            });
        } else {
            doAddTrainingCard();
        }
    };

    var hasMembership;
    function setShowRequireMembershipWarning(required) {
        if (required) {
            if (hasMembership === undefined && options.customer) {
                server.get('/api/membership/get', {member_id: options.customer.id}).then(function(ms) {
                    hasMembership = !!_.find(ms, function(m) { return !Date.newFull(m.validToDate).isPastDate(); });
                    $scope.membershipWarning = !hasMembership;
                });
            } else {
                $scope.membershipWarning = !hasMembership;
            }
        } else {
            $scope.membershipWarning = false;
        }
    }

    function getStartDateFromWorkout(workout) {
        if (!workout) return null;
        if (workout.startTime) return workout.startTime;
        if (workout.startDate) return workout.startDate;
        if (workout.start) return workout.start;
    }

    var showTrainingCardAndHasTrainingCard = function() {
        var tc = _.findWhere($scope.fields, {name: 'trainingcard'}).value;
        return tc && showTrainingCard();
    };

    $scope.updatePriceAndPayments = function() {
        var tc = _.findWhere($scope.fields, {name: 'trainingcard'}).value;
        var price = tc ? tc.price : undefined;
        if (tc.workoutBooking) {
            price = options.workout.workoutType.price;
        }
        _.findWhere($scope.fields, {name: 'price'}).value = util.normalizeDecimal(price);
        var onetimeFeeField = _.findWhere($scope.fields, {name: 'onetime_fee'});
        if (onetimeFeeField) {
            var feeProduct = tc && tc.onetime_fee_product;
            if (!feeProduct) {
                onetimeFeeField.value = null;
            } else {
                var feeOption = _.findWhere(onetimeFeeField.options(), {id: feeProduct.id});
                onetimeFeeField.value = feeOption || feeProduct;
            }
        }

        var paymentMethod = _.findWhere($scope.fields, {name: 'payMethod'}).value;
        if(paymentMethod) {
            if(!tc.priceType || tc.priceType === 'OneTime') {
                if(!paymentMethod.create) {
                    _.findWhere($scope.fields, {name: 'payMethod'}).value = null;
                }
            } else {
                if(!paymentMethod.periodic) {
                    _.findWhere($scope.fields, {name: 'payMethod'}).value = null;
                }
            }
        }
        var today = new Date();
        var validFromDateField = _.findWhere($scope.fields, {name: 'validFromDate'});
        validFromDateField.value = (tc && tc.period) ? Date.newFull(tc.periodValidFrom) : (getStartDateFromWorkout(options.workout) ?? today);

        if (options.membership) {
            if (options.validFromDate) {
                _.findWhere($scope.fields, {name: 'validFromDate'}).value = options.validFromDate;
            }

            if (tc.validFromDate) {
                var d = _.findWhere($scope.fields, {name: 'validFromDate'}).value.clone();
                d.setMonth(tc.validFromDate.getMonth());
                d.setDate(tc.validFromDate.getDate());
                if (!options.validFromDate) {
                    d.setYear(new Date().getFullYear() - 1);
                }
                if (d.clone().addMonths(12) < new Date()) {
                    d.setYear(d.getFullYear() + 1);
                }
                _.findWhere($scope.fields, {name: 'validFromDate'}).value = d;
            }

            _.findWhere($scope.fields, {name: 'validFromDate'}).readonly = tc && !!tc.validFromDate;
        }

        if (tc.fixed_start_date && tc.earliest_start_date) {
            validFromDateField.value = Date.newFull(tc.earliest_start_date);
            if (validFromDateField.value.isPastDate()) {
                validFromDateField.value = today;
            }
        }

        setShowRequireMembershipWarning(tc.requireMembership);

        // Remove previously added included-product variant fields
        $scope.fields = $scope.fields.filter((f) => !f.isIncludedProductVariant);

        // Add variant fields for included products that need variant selection
        if (tc && tc.included_products && tc.included_products.length && $rootScope.hasFlag('flag-package-trainingcard')) {
            var trainingcardFieldIndex = _.findIndex($scope.fields, (f) => f.name === 'trainingcard');
            var insertIndex = trainingcardFieldIndex + 1;
            tc.included_products.forEach((productId) => {
                var product = _.findWhere($rootScope.trainingcardtypes, {id: productId});
                if (product && product.needs_to_choose_variant && product.needs_to_choose_variant()) {
                    var field = {
                        name: 'variants_for_included_products.' + product.id,
                        title: product.name,
                        required: true,
                        type: 'select',
                        options: () => product.variants,
                        getName: (v) => v.name,
                        getValue: (f) => f.value && f.value.name,
                        visible: () => showTrainingCardAndHasTrainingCard(),
                        isIncludedProductVariant: true
                    };
                    if (product.variants.length === 1) {
                        field.value = product.variants[0];
                    }
                    $scope.fields.splice(insertIndex, 0, field);
                    insertIndex++;
                }
            });
        }

        $scope.setValidToDate();
        $scope.updatePayments();

        _.findWhere($scope.fields, {name: 'validFromDate'}).readonly = tc && tc.period;
    };

    $scope.updatePayments = function() {
        var tc = _.findWhere($scope.fields, {name: 'trainingcard'}).value;
        var validFromDateField = _.findWhere($scope.fields, {name: 'validFromDate'});
        var validToDateField = _.findWhere($scope.fields, {name: 'validToDate'});
        if (tc && tc.period)
        {
            var periodValidFrom = Date.newFull(tc.periodValidFrom);
            var periodValidTo = Date.newFull(tc.periodValidTo);
            if (validFromDateField.value < periodValidFrom || validFromDateField.value > periodValidTo)
            {
                validFromDateField.value = periodValidFrom;
            }
        }
        var date = _.findWhere($scope.fields, {name: 'validFromDate'}).value;
        var toDate = validToDateField.value;
        var price = _.findWhere($scope.fields, {name: 'price'}).value;
        var paymentMethod = _.findWhere($scope.fields, {name: 'payMethod'}).value;
        var join_payments = _.findWhere($scope.fields, {name: 'join_payments'}).value;
        var method = paymentMethod?paymentMethod.id:null;
        let discount = _.findWhere($scope.fields, {name: 'discount'}).value;
        var onetimeFeeField = _.findWhere($scope.fields, {name: 'onetime_fee'});
        var onetimeFee = onetimeFeeField ? onetimeFeeField.value : undefined;
        var onetimeFeeOverride = onetimeFeeField && onetimeFeeField.visible && onetimeFeeField.visible();
        $rootScope.$broadcast('selectedTrainingCardChanged', {card: tc, date: date, to_date: toDate, price: price, method: method, join_payments: join_payments, discount, customer: options.customer, onetime_fee: onetimeFee, onetime_fee_override: onetimeFeeOverride});
    };

    $scope.setInitialValues = function() {
        var payer = $rootScope.getMember(options.customer && (options.customer.paidBy || options.customer.id));
        var group = options.group;

        _.findWhere($scope.fields, {name: 'payMethod'}).value = paymentMethods.getDefaultForCustomer(payer, true);

        _.findWhere($scope.fields, {name: 'homesite_id'}).value = $rootScope.selectedSite;
        _.findWhere($scope.fields, {name: 'site_id'}).value = $rootScope.selectedSite;

        if (group) {
            _.findWhere($scope.fields, {name: 'connectCardToGroups'}).value = true;
            _.findWhere($scope.fields, {name: 'groups'}).value = [_.findWhere($rootScope.usergroups, { id: group.id })];
        }
    };

    $scope.setInitialValuesDelayed = function() {
        var tc = _.findWhere($scope.fields, {name: 'trainingcard'});
        if (options.trainingcard) {
            tc.value = options.trainingcard;
            tc.change();
        } else if (tc.visible() && tc.options().length == 1) {
            tc.value = tc.options()[0];
            tc.change();
        }

        if (tc && tc.period) {
            _.findWhere($scope.fields, {name: 'validFromDate'}).value = tc.periodValidFrom;
        }
    };

    $scope.submit = function() {
        $scope.loadingStatus.loading = true;
        var item = $scope.getSubmitItem();

        if (options.cardId) {
            item.cardId = options.cardId;
        }

        if (options.supplier) {
            item.supplier = options.supplier;
        }

        if (onlyAddingCustomer()) {
            var f = _.findWhere($scope.fields, {name: 'image'});
            var s = f && f.selection;
            var file = f && f.value;
            delete item.image;

            var card = item.card;

            $("#form").scope().form.$setPristine();

            server.post($scope.postUrl, item, null, 'Customer added', 'Failed to add customer').then(function(result) {
                $scope.loadingStatus.loading = false;
                if (result.success) {
                    var data = result.data;


                    if (card) {
                        server.post('/api/card/set', null, {user_id: data.id, cardId: card}, 'Card/tag registered', 'Failed to register card/tag');
                    }

                    if (file) {
                        image.set({type: 'Member', id: data.id, file: file, imageSelection: s, successTitle: 'The image was uploaded correctly', failedTitle: 'The image could not be uploaded'});
                    }
                    if ($scope.unsavedCheck) {
                        $scope.unsavedCheck();
                    }
                    if (options.callback) {
                        options.callback(data.id);
                    }
                    $scope.$close(data);
                }
            });
        } else if (addingCustomer()) {
            if (options.workout) {
                var onetimeFeeField = _.findWhere($scope.fields, {name: 'onetime_fee'});
                var trainingcard = { cardtype_id: item.trainingcard.id, validFromDate: item.validFromDate, price: item.price };
                var hasOnetimeFeeOverride = onetimeFeeField?.visible?.();
                if (hasOnetimeFeeOverride) trainingcard.onetime_fee_product_id = item.onetime_fee;
                delete item.onetime_fee;
                var payments = $scope.getPayments(item.payMethod, null, null);
                var data = {member: item, trainingcard: trainingcard, payments: payments, workout: {id: options.workout.id} };

                server.post('/api/member/addAndBook', data, null, 'Customer added and booked on workout', 'Failed to add customer').then(function(result) {
                    if (result.success) {
                        $scope.$close();

                        if (options.callback) {
                           options.callback();
                        }
                    } else {
                        $scope.loadingStatus.loading = false;
                    }

                    if (result.data.type == 'user') { // The user was added but could not be booked
                        $rootScope.notBookableByCard({customer: result.data, workout: options.workout})
                    }
                });
            } else {
                var data = {member: item, rbslot: {type: options.rbslot.service.id, staff: options.staff.id, time: options.rbslot.start.dateTime() }};
                server.post('/api/member/addAndBook', data, null, 'Customer added and booked', 'Failed to add customer').then(function(result) {
                    if (result.success) {
                        $scope.$close();

                        if (options.callback) {
                           options.callback();
                        }
                    } else {
                        $scope.loadingStatus.loading = false;
                    }
                });
            }
        } else {
            $scope.addTrainingCard(item);
        }
    };

    var showJoinPayment = function() {
        if(!showTrainingCard()) {return;}
        var tc = _.findWhere($scope.fields, {name: 'trainingcard'}).value;
        if(!tc) {return;}
        if(tc.priceType !== 'Month') {return;}
        var validFromDate = _.findWhere($scope.fields, {name: 'validFromDate'}).value;
        return validFromDate && (validFromDate < (new Date()).nextMonth());
    };

    var getMemberships = function() {
        return $rootScope.trainingcardtypes.filter(function(c) { return c.active && c.membership; });
    };

    function isValidDateRange(cardtype, workoutStart) {
        if (!cardtype.period) return true;
        let validFrom = Date.newFull(cardtype.periodValidFrom);
        let validTo = Date.newFull(cardtype.periodValidTo);
        return validFrom <= workoutStart && workoutStart <= validTo;
    }

    function isValidCardType(cardtype, workoutType) {
        if (!workoutType.cardtypes || workoutType.cardtypes.length === 0) return true;
        return workoutType.cardtypes.includes(cardtype.id);
    }

    function isRelevantCardType(cardtype, options) {
        if (!cardtype.active) return false;
        if (cardtype.type === 'workoutbooking' && options.workout?.workoutType.onetime) return true;
        if (!options.workout) return cardtype.type === 'trainingcard' || cardtype.type === 'resourcebooking';
        if (cardtype.type === 'trainingcard' && options.workout.workoutType.allowBooking) {
            var workoutStart = options.workout.startDate ?? Date.newFull(options.workout.startTime.yyyymmdd());
            return isValidDateRange(cardtype, workoutStart) && isValidCardType(cardtype, options.workout.workoutType);
        }
        return false;
    }

    var getTrainingCards = function() {
        if (options.membership) return getMemberships();
        return $rootScope.trainingcardtypes.filter(cardtype => isRelevantCardType(cardtype, options));
    };

    var getTrainingCardGroup = function(card) {
        if (options.membership) {
            return null;
        }
        return card.resourcebookingservice ? 'Resource booking' : (card.workoutBooking ?  'One time card' : 'Training card');
    };

    var getMethod = function() {
        return _.findWhere($scope.fields, {name: 'payMethod'}).value;
    };

    var hasMoney = function() {
        if (options.customer && showTrainingCardAndHasTrainingCard()) {
            var price = _.findWhere($scope.fields, {name: 'price'}).value;
            var count = $scope.data.payments?$scope.data.payments.length:0;
            var feeField = _.findWhere($scope.fields, {name: 'onetime_fee'});
            var feeAmount = (feeField && feeField.value && feeField.value.price) ? feeField.value.price : 0;
            return options.customer.getValueCardAmountForSelectedLegalEntity() >= price * count + feeAmount;
        }
    };

    var hasSavedCard = function() {
        if (options.customer && showTrainingCardAndHasTrainingCard()) {
            return options.customer.hasSavedCardForSelectedLegalEntity();
        }
    };

    var getInstallation = function(field) {
        return field.value && field.value.id;
    };

    function paymentMethodFilter(paymentMethod) {
        if(!showTrainingCard()) {return false;}
        if(!paymentMethod.active) {return false;}
        if(!paymentMethod.create) {return false;}
        var tc = _.findWhere($scope.fields, {name: 'trainingcard'}).value;
        if(!tc) {return false;}
        if(!tc.priceType || tc.priceType === 'OneTime') {return true;}
        return !!paymentMethod.periodic;
    }

    var getFromAddress = function() {
        _.findWhere($scope.fields, {name: 'position'}).mapcontrol.getFromAddress(_.findWhere($scope.fields, {name: 'address'}).value, _.findWhere($scope.fields, {name: 'city'}).value);
    };

    function getCompany() {
        return _.findWhere($scope.fields, {name: 'company'}).value;
    }

    function noCompany() {
        return !getCompany();
    }

    function addingIndividual() {
        return noCompany() && addingCustomer();
    }

    function addingCompany() {
        return getCompany() && addingCustomer();
    }

    var updateBirthdate = function(personalCodeNumber) {
        var b = _.findWhere($scope.fields, { name: 'birthdate' });
        if (b) {
            b.value = Date.newFromCompact(personalCodeNumber.substring(0,8));
        }
    };

    var updateGender = function(personalCodeNumber) {
        var genderRow = _.findWhere($scope.fields, { name: 'gender' });
        if (genderRow && !genderRow.value) {
            genderRow.value = _.findWhere(genderRow.options(), {id: genders.getGender(personalCodeNumber)});
        }
    };

    var onPersonalCodeChange = function() {
        var personalCodeNumber = util.normalizePersonalCodeNumber((_.findWhere($scope.fields, { name: 'personalCodeNumber' }) || {}).value);
        if (!personalCodeNumber) { return; }
        updateBirthdate(personalCodeNumber);
        updateGender(personalCodeNumber);
    };

    var shouldDisplayGroups = function() {
        var groupsActivated = _.findWhere($scope.fields, { name: 'connectCardToGroups' }).value;
        return groupsActivated && !options.membership && ($rootScope.usergroups.length || $rootScope.speedy) && showTrainingCardAndHasTrainingCard();
    };

    var paymentMethodIsInvoice = function() {
        var currentMethod = (_.findWhere($scope.fields, { name: 'payMethod' }) || {}).value;
        return currentMethod && (currentMethod.id == 'invoice' || currentMethod.id == 'einvoice');
    };

    var useOtherTermsOfPayment = function() {
        var optionCheckbox = _.findWhere($scope.fields, { name: 'otherTermsOfPayment'});
        return optionCheckbox && optionCheckbox.visible() && !!optionCheckbox.value;
    };

    $scope.useOtherPayer = function() {
        var optionCheckbox = _.findWhere($scope.fields, { name: 'otherPayer'});
        return optionCheckbox && optionCheckbox.visible() && !!optionCheckbox.value;
    };

    function updateLoginKey() {
        _.findWhere($scope.fields, {name: 'login_key'}).value = _.findWhere($scope.fields, {name: 'mail'}).value;
        $('input[name=login_key]').val(_.findWhere($scope.fields, {name: 'mail'}).value).trigger('change');
    }

    function pcodeVisible() {
        return addingIndividual() && !_.findWhere($scope.fields, {name: 'noPcode'}).value;
    }

    function showInvoiceFreeText() {
        var payMethod = _.findWhere($scope.fields, {name: 'payMethod'}).value;
        return payMethod && payMethod.id === 'invoice';
    }

    function showValidToDate() {
        var tc = _.findWhere($scope.fields, { name: 'trainingcard' }).value;
        return showTrainingCardAndHasTrainingCard() && !tc.auto && !tc.period;
    }

    function hasOnetimeFee() {
        return $rootScope.hasFlag('flag-one-time-fee') && showTrainingCardAndHasTrainingCard();
    }

    function getOnetimeFeeProducts() {
        var products = $rootScope.getActiveProducts().filter(function(p) { return !p.giftcard && !p.membership && !p.valuecard; });
        var tc = _.findWhere($scope.fields, {name: 'trainingcard'}).value;
        var linked = tc && tc.onetime_fee_product;
        if (linked && !_.findWhere(products, {id: linked.id})) {
            products.unshift(linked);
        }
        return products;
    }

    $scope.setValidToDate = function() {
        var tc = _.findWhere($scope.fields, {name: 'trainingcard'}).value;
        var validFromDateField = _.findWhere($scope.fields, {name: 'validFromDate'});
        var validToDateField = _.findWhere($scope.fields, {name: 'validToDate'});
        if (!tc.auto && !tc.period) {
            var validFromDate = validFromDateField.value;
            if (!validFromDate) { return; }

            var validToDate = validFromDate.clone();
            var monthMultiplier = { Month: 1, Quarter: 3, HalfYear: 6, Year: 12 };
            if (tc.validType == 'Day' || tc.validType == 'Week') {
                validToDate.addDays(tc.validTime * (tc.validType == 'Week' ? 7 : 1));
            } else if (Object.keys(monthMultiplier).indexOf(tc.validType) != -1) {
                validToDate.addMonths(tc.validTime * monthMultiplier[tc.validType]);
            }
            validToDateField.value = validToDate.addDays(-1);
        }
    };
    function onValidFromDateChange() {
        $scope.setValidToDate();
        $scope.updatePayments();
    }
    function onValidToDateChange() {
        var validFromDateField = _.findWhere($scope.fields, { name: 'validFromDate' });
        var validToDateField = _.findWhere($scope.fields, { name: 'validToDate' });
        if (validFromDateField.value && validToDateField.value) {
            if (validToDateField.value < validFromDateField.value) {
                validToDateField.value = validFromDateField.value.clone();
            }
        }
        $scope.updatePayments();
    }

    $scope.fields = [
        {name: 'company', title: 'Company', required: true, type: 'checkbox', value: addingCustomer() && !!options.company, visible: addingCustomer },
        {name: 'firstname', title: 'First name', required: true, type: 'text', focus: true, visible: addingIndividual },
        {name: 'lastname', title: 'Last name', required: true, type: 'text', visible: addingIndividual},
        {name: 'lastname', title: 'Companyname', required: true, type: 'text', visible: addingCompany},
        {name: 'homesite_id', title: 'Site the person primarily uses', type: 'select', options: function() { return $rootScope.sites; }, required: true, visible: function() { return addingCustomer() && $rootScope.hasModule('MultiSite'); }, useId: true },
        {name: 'groups', title: 'Add to group/team', type: 'groups', visible: addingIndividual, useId: true},
        {name: 'mail', title: 'E-mail', required: false, type: 'email', ptype: 'member', visible: addingCustomer, change: updateLoginKey},
        {name: 'login_key', title: 'Username', required: true, type: 'loginkey', visible: addingCustomer, helpText: 'HELPTEXT_USERNAME' },
        {name: 'personalCodeNumber', title: 'Personal code number', required: false, type: 'personalCodeNumber', ptype: 'member', visible: pcodeVisible, change: onPersonalCodeChange},
        {name: 'personalCodeNumber', title: 'Corporate identity', required: false, type: 'corporateIdentity', visible: addingCompany},
        {name: 'noPcode', title: 'Missing personal code number', type: 'checkbox', visible: addingIndividual, helpText: 'HELPTEXT_PERSONAL_NUMBER'},
        {name: 'memberNumber', title: 'Member number', required: false, type: 'memberNumber', visible: addingIndividual},
        {name: 'birthdate', title: 'Birthdate', required: false, type: 'date', visible: addingIndividual},
        {name: 'gender', title: 'Gender', required: false, type: 'select', options: genders.getList, useId: true, visible: addingIndividual},
        {name: 'phone', title: 'Mobile phone number', required: false, type: 'phone', visible: addingCustomer},
        {name: 'oldphone', title: 'Phone number', required: false, type: 'phone', visible: addingCustomer},
        {name: 'address', title: 'Address', required: false, type: 'textarea', visible: addingCustomer, placeholder: 'Ex: Storgatan 123', helpText: 'HELPTEXT_REQUIRED_FOR_INVOICE'},
        {name: 'zipCode', title: 'Zip code', required: false, type: 'zipCode', visible: addingCustomer, helpText: 'HELPTEXT_REQUIRED_FOR_INVOICE'},
        {name: 'city', title: 'City', required: false, type: 'text', visible: addingCustomer, helpText: 'HELPTEXT_REQUIRED_FOR_INVOICE'},
        {name: 'extraInfo', title: 'Extra information', required: false, type: 'textarea', visible: addingCustomer, helpText: 'HELPTEXT_EXTRA_INFO'},
        {name: 'responsible', title: 'Responsible', required: false, helpText:'Responsible helptext', placement:'top', type: 'customer', useId: true, visible: addingCustomer, itemTypes: ['staff'] },
        {name: 'image', title: 'Image_title', required: false, type: 'image' , visible: addingCustomer},
        {name: 'card', title: 'Card', required: false, type: 'card', visible: function() {return $rootScope.hasModule('Entry') && addingIndividual(); }, helpText: 'HELPTEXT_CARD'},
        {name: 'position', title: 'Position', type: 'map', mapcontrol: {}, getFromAddress: getFromAddress , visible: addingCustomer},
        {name: 'welcomeMail', title: 'Send welcome mail', type: 'checkbox', value: options.supplier ? false : true , visible: addingCustomer},
        {name: 'terms', title: 'Terms and conditions', type: 'checkbox', required: true, extrahtml: 'ACCEPTTERMSLINK', visible: function() { return $rootScope.termsRequired && addingCustomer(); } },

        {name: 'trainingcard', title: options.membership ? 'Membership' : 'Training card', required: true, visible: showTrainingCard, type: 'select', options: getTrainingCards, change: $scope.updatePriceAndPayments, group: getTrainingCardGroup, orderPredicate: ['-workoutBooking', 'name'] },
        {name: 'site_id', title: 'Site', required: true, type: 'select', options: () => $rootScope.sites, useId: true, visible: () => $rootScope.hasModule('MultiSite') && showTrainingCardAndHasTrainingCard() },
        {name: 'validFromDate', title: 'Valid from', required: true, visible: showTrainingCardAndHasTrainingCard, type: 'date', value: new Date(), change: onValidFromDateChange },
        {name: 'validToDate', title: 'Valid to', required: true, visible: showValidToDate, type: 'date', setValue: $scope.setValidToDate, change: onValidToDateChange },
        {name: 'price', title: 'Price', required: true, visible: showTrainingCardAndHasTrainingCard, type: 'price', change: $scope.updatePayments },
        {name: 'onetime_fee', title: 'One-time fee', type: 'select', options: getOnetimeFeeProducts, visible: hasOnetimeFee, change: $scope.updatePayments, useId: true, placeholder: 'None'},
        {name: 'payMethod', title: 'Payment method', visible: function() {return $rootScope.hasModule('Payment') && showTrainingCardAndHasTrainingCard(); }, required: true, type: 'paymentmethod', hasMoney: hasMoney, hasSavedCard: hasSavedCard, options: {filter: paymentMethodFilter, saved_card: true} },
        {name: 'otherPayer', title: 'Other payer', type: 'checkbox', visible: function() { return $rootScope.hasModule('Payment') && showTrainingCardAndHasTrainingCard(); }, value: false },
        {name: 'payer_id', title: 'Payer', visible: function() {return $scope.useOtherPayer(); }, type: 'customer', required: true, useId: true },
        {name: 'otherTermsOfPayment', title: 'Other terms of payment than standard', type: 'checkbox', visible: function() { return showTrainingCardAndHasTrainingCard() && paymentMethodIsInvoice(); }, value: false },
        {name: 'termsOfPayment', title: 'Terms of payment', type: 'infoNumber', info: 'days', visible: function() { return showTrainingCardAndHasTrainingCard() && useOtherTermsOfPayment(); }, required: true, min: 1},
        {name: 'connectCardToGroups', title: 'Connect card to groups', required: false, type: 'checkbox', visible: function() { return ($rootScope.usergroups.length || $rootScope.speedy) && showTrainingCardAndHasTrainingCard(); }, helpText: 'CONNECT_CARD_TO_GROUP' },
        {name: 'groups', title: 'Groups', required: false, type: 'groups', useId: true, visible: shouldDisplayGroups },
        {name: 'installation', title: 'Installation', required: false, type: 'select', options: function() {return $scope.installations;}, visible: function() { return showTrainingCardAndHasTrainingCard() && $rootScope.hasModule('Admin'); }, getValue: getInstallation },
        {name: 'join_payments', title: 'Merge first payments', required: false, visible: showJoinPayment, type: 'checkbox', change: $scope.updatePayments },
        {
            name: 'discount',
            title: 'Discount',
            required: false,
            type: 'select',
            visible:  () => {
                let tc = _.findWhere($scope.fields, {name: 'trainingcard'}).value;
                return tc && showTrainingCard();
            },
            options: () => {
                // Checking punchcard_list since some trainingcards count as punchcards.
                let tc = _.findWhere($scope.fields, {name: 'trainingcard'}).value;
                return $rootScope.trainingcardtypes.filter(t => t.active && t.discount && t.discount_condition && (t.discount_condition.trainingcards || (t.discount_condition.punchcards && (t.discount_condition.punchcard_list.includes(tc.id) || (tc.trainingsessions && t.discount_condition.punchcard_list.length === 0)))));
            },
            useId: true,
            placeholder: 'No discount',
            change: $scope.updatePayments
        },
        {hint: 'MEMBERSHIP_REQUIRED2', hintClass: 'alert-danger', visible: function() { return $scope.membershipWarning; } }
    ];

    if (addingCustomer()) {
        $rootScope.setCustomerFields($scope.fields, false);
    }

    var getInformationFromSPAR = function() {
        var items = $scope.getSubmitItem();
        var personalCodeNumber = util.normalizePersonalCodeNumber(items.personalCodeNumber);
        if (!util.isValidPersonalCode(personalCodeNumber)) {
            return;
        }
        var pcnRow = _.findWhere($scope.fields, { name: 'personalCodeNumber' });
        pcnRow.loading = true;
        server.post('/api/spar/information/get', null, { personalCodeNumber: personalCodeNumber }).then(function(response) {
            pcnRow.loading = false;
            if (response.data && response.data.error) {
                if (response.data.error == 'NO_INFORMATION_FOUND') {
                    alertProvider.show('error', 'SPAR_NO_INFORMATION_FOUND');
                }
                return;
            }

            angular.forEach(response.data, function(value, key) {
                if (!value) { return; }
                var inputRow = _.findWhere($scope.fields, { name: key });
                if (!inputRow || inputRow.value) { return; }
                inputRow.value = value;
            });
        }).catch(function() {
            pcnRow.loading = false;
        });
    };

    var getSparMode = function() {

        function handleSparOption(sparMode) {
            var pcnRow = _.findWhere($scope.fields, { name: 'personalCodeNumber' });
            if (!pcnRow) { return; }
            switch (sparMode) {
                case 'staff':
                    _.extend(pcnRow, {
                        type: 'personalCodeNumberWithButton',
                        change: function(personalCodeNumber) {
                            $scope.personalCodeButtonDisabled = personalCodeNumber ? false : true;
                            onPersonalCodeChange(personalCodeNumber);
                        },
                        buttonTitle: $filter('translate')('Get information'),
                        click: getInformationFromSPAR,
                        buttonVisible: function() { return true; }
                    });
                    $scope.personalCodeButtonDisabled = true; // default state
                    break;

                case 'automatic':
                    // add automatic spar-call to field personalCodeNumber
                    pcnRow.change = function(personalCodeNumber) {
                        onPersonalCodeChange(personalCodeNumber);
                        getInformationFromSPAR();
                    };
                    break;
            }

            if (sparMode && sparMode !== 'off') {
                $scope.fields.splice(_.findIndex($scope.fields, function(f) { return f.name === 'personalCodeNumber'; }), 1);
                $scope.fields.splice(1, 0, pcnRow);
            }
        }

        handleSparOption($rootScope.sparMode);
    };

    $scope.formInvalid = function() {
        var pm = _.findWhere($scope.fields, {name: 'payMethod'});
        var invalid = pm.visible() && pm.value && pm.value.id == 'valuecard' && !hasMoney();
        if (invalid) {
            return true;
        }

        if (pm.visible() && pm.value && pm.value.id == 'stripe' && !hasSavedCard()) {
            return true;
        }

        var tc = _.findWhere($scope.fields, {name: 'trainingcard'})?.value;
        if(tc && $scope.data.payments === null) {
            return true;
        }

        var terms = _.findWhere($scope.fields, {name: 'terms'});
        return terms.visible() && !terms.value;
    };

    $scope.$watch(getMethod, function() {
        $scope.updatePayments();
    });

    var getCustomerGuide = function() {
        var gf = function(name) { return _.findWhere($scope.fields, { name: name }) || {}; };
        var steps = [
            { element: gf('company').element, popover: { title: 'Is it a company or an individual?', description: 'Check the box if it is a company.' } },
            { element: gf('firstname').element, popover: { title: 'Enter the person\'s first name' }, visible: addingIndividual },
            { element: gf('lastname').element, popover: { title: 'Enter the person\'s last name' }, visible: addingIndividual },
            { element: _.findWhere($scope.fields, { name: 'lastname', title: 'Companyname' }).element, popover: { title: 'Enter the company name' }, visible: addingCompany },
            { element: gf('homesite_id').element, popover: { title: 'Which site does the customer primarily use?', description: 'The primary site is automatically displayed at login.' }, visible: gf('homesite_id').visible },
            { element: gf('groups').element, popover: { title: 'Does the customer belong to a group or a team?', description: 'Groups are created under Customers > Groups > Add New Group. Tip! Used with advantage when arranging children and their guardians.' }, visible: addingIndividual },
            { element: gf('mail').element, popover: { title: 'Enter the customers mail', description: 'Several people can have the same e-mail. In that case enter a username as well.' } },
            { element: gf('login_key').element, popover: { title: 'Are there multiple people with the same e-mail?', description: 'Enter a unique login username. For example. "firstnamelastname".' } },
            { element: gf('personalCodeNumber').element, popover: { title: 'Enter the customers personal code number', description: 'Written with 10 or 12 digits.' }, visible: pcodeVisible },
            { element: gf('noPcode').element, popover: { title: 'Check if the customer does not have a personal code number', description: 'For example, if they instead have a coordination number.' }, visible: addingIndividual },
            { element: _.findWhere($scope.fields, { name: 'personalCodeNumber', title: 'Corporate identity' }).element, popover: { title: 'Enter the companies corporate identity' }, visible: addingCompany },
            { element: gf('birthdate').element, popover: { title: 'Enter date of birth if full personal code number is missing' }, visible: addingIndividual },
            { element: gf('gender').element, popover: { title: 'Enter the person\'s gender' }, visible: addingIndividual },
            { element: gf('phone').element, popover: { title: 'Enter a mobile number to easily reach the customer', description: 'If you want to be able to send a mailing by SMS, it is important to enter the customer\'s mobile number.' } },
            { element: gf('oldphone').element, popover: { title: 'Enter phone number' } },
            { element: gf('address').element, popover: { title: 'Enter the customer\'s street address', description: 'Address, zip code and city are required if they are to make invoice purchases' } },
            { element: gf('zipCode').element, popover: { title: 'Enter the customer\'s zip code', description: 'Address, zip code and city are required if they are to make invoice purchases' } },
            { element: gf('city').element, popover: { title: 'Enter the customer\'s city', description: 'Address, zip code and city are required if they are to make invoice purchases' } },
            { element: gf('extraInfo').element, popover: { title: 'Save information that only staff will see.', description: 'Information about the customer that is displayed on their profile. Only authorized staff will have access to the information.' } },
            { element: gf('responsible').element, popover: { title: 'Is anyone in the staff extra responsible?', description: 'Enter any responsible staff to easily look up those you are responsible for. Otherwise, leave the field empty.' } },
            { element: gf('image').element, popover: { title: 'Add picture of the customer', description: 'Tip! Good to see who checks in and reduces the risk of cheating.' } },
            { element: gf('card').element, popover: { title: 'Register card or tag', description: 'Place the physical card or tag against the reader for registration.' }, visible: gf('card').visible },
            { element: gf('welcomeMail').element, popover: { title: 'Send welcome mail to the new customer', description: 'Check the box if you want to send a welcome email. Tip! If you want to change content, go to Mailings > Administration > System mailings where you select \"New customer account - To customer\"' } },
            { element: modalUtils.getModalElement('.modal-footer > button:first-of-type'), popover: { title: 'Save' }, skipStartOnClick: true }
        ];
        return { steps: steps, onFinish: $rootScope.possiblyGoToGetStarted };
    };

    var getMembershipGuide = function() {
        var steps = [{
            element: _.findWhere($scope.fields, { name: 'trainingcard' }).element,
            popover: {
                description: 'Here a membership is pre-selected; you can adjust the start date, price and payment method if necessary. Then click Add and the person has officially become one of your members!',
                closeBtnText: 'Next'
            }
        }];
        return { steps: steps, allowClose: false, onFinish: $rootScope.guides.membershipinvoicingtour3 };
    };

    $scope.setInitialValues();
    $timeout(function() {
        $scope.setInitialValuesDelayed();
        if (addingCustomer()) {
            $scope.$getGuide = getCustomerGuide;
        } else if (options.membership) {
            $scope.$getGuide = getMembershipGuide;
        }
    });
    getSparMode();
}]);

app.controller('RoleAddModalCtrl', ['$rootScope', '$scope', '$controller', '$filter', 'server', 'role', function($rootScope, $scope, $controller, $filter, server, role) {
    $controller('AddCtrl', {$scope: $scope});

    $scope.title = 'Add role';
    $scope.postUrl = '/api/staff/roles/add';
    $scope.callCloseOnSuccess = true;
    $scope.successTitle = '{0} was added';
    $scope.failedTitle = 'Failed to add {0}';
    $scope.itemTitle = 'Role';

    function getPermissions() {
        return server.get('/api/staff/permissions/get').then(function(permissions) {
            permissions.forEach(function(p) {
                p.name = $filter('translate')(p.id);
            });
            $scope.permissions = permissions;
        });
    }

    var showGlobalOption = function() {
        return $rootScope.currentStaff.exportObjects && $rootScope.hasPermission('Chain settings');
    };

    getPermissions().then(function() {
        $scope.fields = [
            {name: 'name', title: 'Name', required: true, type: 'text' },
            {name: 'tasks', title: 'Access right', required: true, type: 'multiselect', options: function() { return $scope.permissions; }, useId: true },
            {name: 'is_global', title: 'Chain', type: 'checkbox', visible: showGlobalOption}
        ];

        if (role) {
            _.findWhere($scope.fields, {name: 'tasks'}).value = role.tasks.map(function(id) {
                return _.findWhere($scope.permissions, {id: id});
            }).filter(Boolean);
        }
    });
}]);

app.controller('WorkoutTypesListCtrl', ['$rootScope', '$scope', '$controller', '$filter', '$modal', 'modalUtils', 'live', '$timeout', 'util', function($rootScope, $scope, $controller, $filter, $modal, modalUtils, live, $timeout, util) {

    $scope.show = function() {
        return _.filter($rootScope.workoutcategories, function(c) { return c.active; }).length;
    };

    $scope.change = function(workoutType) {
        util.showDataDialog({controller: 'WorkoutTypeDataCtrl', item: workoutType});
    };

    $scope.statistics = function(workoutType) {
        $modal.open({
            templateUrl: 'views/workouttypestats.html',
            controller: 'WorkoutTypeStatisticsCtrl',
            resolve: {
                workoutType: function() {
                    return workoutType;
                }
            }
        });
    };

    $scope.add = function() {
        let category = $scope.workouttypesConfig.control.getActiveTab().context;
        util.showDataDialog({controller: 'WorkoutTypeDataCtrl', initial: {category}})
    };

    // Fresh objects per tab: customertable stores a DOM node on config.empty, which breaks angular.copy if shared across rebuilds
    function activeOnEmpty() {
        return {
            title: 'You currently have no active workout types in this category',
            button: { title: 'Add workout type', onClick: $scope.add }
        };
    }

    function inActiveOnEmpty() {
        return {
            title: 'Disabled workout types will be collected here. They are then saved and can be activated again at a later time.',
            text: 'To deactivate a workout type, go to a category above and press "Disable" on the workout type.'
        };
    }

    function buildTabs() {
        var categories = $filter('orderBy')($rootScope.workoutcategories.filter(function(c) { return c.active; }), 'order');
        var tabs = categories.map(function(c) {
            return { name: c.name, badgeClass: 'badge-success', itemFilter: function(wt) { return wt.active && wt.category_id == c.id; }, context: c, bannerDirective: 'workouttypeslistbanner', empty: activeOnEmpty() };
        });
        tabs.push(
            {name: 'Inactive', itemFilter: function(wt) { return !wt.active; }, empty: inActiveOnEmpty() }
        );
        return tabs;
    }

    function createConfig() {
        $scope.workouttypesConfig = {
            getItems: function() {
                return $rootScope.workouttypes;
            },
            triggers: ['workouttype'],
            empty: {
                title: 'The next step is to create Workout types',
                text: 'WORKOUTTYPE_EMPTY_STATE',
                button: { title: 'Add a workout type', onClick: $scope.add }
            },
            tabs: buildTabs(),
            countSuffix: function() {
                var num = this.control.getFilteredItems().length;
                return $filter('translate')(num == 1 ? 'workout type' : 'workout types');
            },
            rowClick: $scope.change,
            giveFocus: function() {
                return false;
            },
            columns: [
                {field: 'name', title: 'Workout type', color: function(item) {return item.color;}},
                {field: 'show', title: 'Show for customers', format: 'bool', getValue: function(f) { return f.show && $rootScope.getPointerById(f.category_id, $rootScope.workoutcategories).show; } },
                {field: 'category', title: 'Category', visible: function(item) { return item.name === 'Inactive'; }, getValue: function(w) { return _.findWhere($rootScope.workoutcategories, {id: w.category_id}).name; } }
            ],
            orderColumn: 'name',
            buttons: [
                { title: 'Change', buttonClass: 'btn-warning', visible: function() {return $rootScope.hasPermission('Schedule handling'); }, onClick: $scope.change },
                { title: 'Statistics', buttonClass: 'btn-info', visible: function() {return $rootScope.hasPermission('Show statistics') && $rootScope.hasModule('WorkoutBooking'); }, onClick: $scope.statistics },
                { title: 'Inactivate', buttonClass: 'btn-danger', visible: function(wt) {return wt.active && $rootScope.hasPermission('Schedule handling'); }, onClick: function(t) { modalUtils.inactivateModal(t, t.name, 'REMOVE_WORKOUTTYPE_MESSAGE', '/api/schedule/workout/type/change'); } },
                { title: 'Activate', buttonClass: 'btn-success', visible: function(wt) {return !wt.active && $rootScope.hasPermission('Schedule handling'); }, onClick: function(t) { modalUtils.activateModal(t, t.name, 'ACTIVATE_WORKOUTTYPE_MESSAGE', '/api/schedule/workout/type/change'); } }
            ],
            searchButtons: [
                { title: 'Add workout type', showOnEmpty: true, onClick: $scope.add, visible: function() {return $rootScope.currentStaff.allowCreateWorkoutType;}}
            ],
            searchAlert: function() {
                if(!$rootScope.currentStaff.allowCreateWorkoutType) {
                    return 'Workout types can be imported from main system';
                }
            }
        };
    }

    $rootScope.waitFor(['workoutcategories']).then(function() {
        createConfig();
    });

    live.subscribe( {
        type: 'workoutcategory',
        scope: $scope,
        callback: function() {
            $timeout(function() {
                createConfig();
            });
        }
    });

}]);

app.controller('WorkoutCategoriesCtrl', ['$rootScope', '$scope', '$modal', 'confirm', 'server', function($rootScope, $scope, $modal, confirm, server) {
    $scope.add = function() {
        $modal.open({
            templateUrl: 'views/addmodal.html',
            controller: 'WorkoutCategoryAddCtrl'
        });
    };

    $scope.change = function(workoutcategory) {
        $modal.open({
            templateUrl: 'views/changemodal.html',
            controller: 'WorkoutCategoryChangeCtrl',
            resolve: {
                workoutcategory: function() {
                    return workoutcategory;
                }
            }
        });
    };

    $scope.canMoveUp = function(workoutcategory) {
        var items = $scope.workoutCategoriesConfig.tabs[0].config.control.getItems();
        var index = items.indexOf(workoutcategory);
        return index > 0;
    };

    $scope.canMoveDown = function(workoutcategory) {
        var items = $scope.workoutCategoriesConfig.tabs[0].config.control.getItems();
        var index = items.indexOf(workoutcategory);
        return index < items.length - 1;
    };

    $scope.up = function(workoutcategory) {
        if ($scope.canMoveUp(workoutcategory)) {
            var items = $scope.workoutCategoriesConfig.tabs[0].config.control.getItems();
            var index = items.indexOf(workoutcategory);
            var one = workoutcategory.order;
            var two = items[index-1].order;
            server.post('/api/schedule/workout/category/reorder', null, {one: one, two: two});
        }
    };

    $scope.down = function(workoutcategory) {
        if ($scope.canMoveDown(workoutcategory)) {
            var items = $scope.workoutCategoriesConfig.tabs[0].config.control.getItems();
            var index = items.indexOf(workoutcategory);
            var one = workoutcategory.order;
            var two = items[index+1].order;
            server.post('/api/schedule/workout/category/reorder', null, {one: one, two: two});
        }
    };

    $scope.inactivateModal = function(item, title, content, postUrl) {
        var modalInstance = $modal.open({
            templateUrl: 'views/inactivate.html',
            controller: 'ModalCtrl',
            resolve: {
                options: function() {
                    return {title: title, content: content};
                }
            }
        });

        modalInstance.result.then(function () {
            var data = {id: item.id, active: false};
            server.post(postUrl, data, null, '{0} was inactivated', 'Failed to inactivate {0}', title);
        });
    };

    $scope.activateModal = function(item, title, content, postUrl) {
        var modalInstance = $modal.open({
            templateUrl: 'views/activate.html',
            controller: 'ModalCtrl',
            resolve: {
                options: function() {
                    return {title: title, content: content};
                }
            }
        });

        modalInstance.result.then(function () {
            var data = {id: item.id, active: true};
            server.post(postUrl, data, null, '{0} was activated', 'Failed to activate {0}', title);
        });
    };

    function inactivate(r) {
        $scope.inactivateModal(r, r.name, 'REMOVE_CATEGORY_MESSAGE', '/api/schedule/workout/category/change');
    }

    function activate(r) {
        $scope.activateModal(r, r.name, 'ACTIVATE_CATEGORY_MESSAGE', '/api/schedule/workout/category/change');
    }

    var inActiveOnEmpty = {
        title: 'Disabled categories will be collected here. They are then saved and can be activated again at a later time.',
        text: 'To deactivate a category, go to the "Active" tab above and press "Disable" on the category.'
    };

    $scope.workoutCategoriesConfig = {
        api: {
            url: '/api/schedule/workout/category/get',
            triggers: [{type: 'workoutcategory'}]
        },
        countSuffixList: ['category', 'categories'],
        giveFocus: function() { return false; },
        empty: {
            title: 'Here you create the foundation for your scheduled activities and workouts',
            text: 'Start by creating a category!',
            button: { title: 'Create category', onClick: $scope.add }
        },
        tabs: [
            { name: 'Active', badgeClass: 'badge-success', itemFilter: function(c) { return c.active; } },
            { name: 'Inactive', itemFilter: function(c) { return !c.active; }, empty: inActiveOnEmpty }
        ],
        columns: [
            {field: 'name', title: 'Name'}
        ],
        buttons: [
            {title: 'Change', buttonClass: 'btn-warning', onClick: $scope.change},
            {title: 'Move up', buttonClass: 'btn-warning', onClick: $scope.up, visible: function(c) { return c.active && $scope.canMoveUp(c); } },
            {title: 'Move down', buttonClass: 'btn-warning', onClick: $scope.down, visible: function(c) { return c.active && $scope.canMoveDown(c); }},
            {title: 'Activate', onClick: activate, buttonClass: 'btn-success', visible: function(c) {return !c.active; }},
            {title: 'Inactivate', onClick: inactivate, buttonClass: 'btn-danger', visible: function(c) {return c.active; }}
        ],
        searchButtons: [
            {title: 'Add category', onClick: $scope.add, showOnEmpty: true, visible: function() {return $rootScope.currentStaff.allowCreateWorkoutType;}}
        ]
    };
}]);

app.controller('WorkoutCategoryAddCtrl', ['$rootScope', '$scope', '$controller', '$filter', 'server', function($rootScope, $scope, $controller, $filter, server) {
    $controller('AddCtrl', {$scope: $scope});

    $scope.titleSuffix = function() {
        return $filter('translate')('activity category');
    };

    $scope.postUrl = '/api/schedule/workout/category/add';

    $scope.callCloseOnSuccess = true;

    $scope.setInitialValues = function() {
        _.findWhere($scope.fields, {name: 'sites'}).value = [$rootScope.selectedSite];
        _.findWhere($scope.fields, {name: 'permission'}).value = _.findWhere($scope.permissions, {id: 'Schedule handling'});
        _.findWhere($scope.fields, {name: 'registerDaysBefore'}).value = 365;
        _.findWhere($scope.fields, {name: 'registerHoursBefore'}).value = 0;
        _.findWhere($scope.fields, {name: 'unregisterHoursBefore'}).value = 0;
    };

    function getPermissions() {
        return server.get('/api/staff/permissions/get').then(function(permissions) {
            permissions.forEach(function(p) {
                p.name = $filter('translate')(p.id);
            });
            $scope.permissions = permissions;
        });
    }

    $scope.fields = [
        {name: 'name', title: 'Category name', type: 'text', required: true, placeholder: 'E.g Group workout' },
        {name: 'sites', title: 'Sites', required: true, type: 'multiselect', visible: function() { return $rootScope.hasModule('MultiSite'); }, options: function() { return $rootScope.sites; }, useId: true},
        {name: 'show', title: 'Show for customers', type: 'checkbox', value: true, helpText: 'If not checked, then only staff will see the category and the activities in the category.' },
        {name: 'registerDaysBefore', title: 'The workout opened for booking', info: 'days before', required: true, type: 'infoText'},
        {name: 'allowBookingAfterStarted', title: 'Bookable after activity starts', type: 'checkbox', value: false },
        {name: 'registerHoursBefore', title: 'Must register at least', info: 'hours before', required: true, type: 'infoNumber', min: 0, visible: function() { return !_.findWhere($scope.fields, {name: 'allowBookingAfterStarted'}).value; } },
        {name: 'unregisterHoursBefore', title: 'Must unregister at least', info: 'hours before', required: true, type: 'infoNumber'},
        {name: 'dropin', title: 'Drop in', info: 'minutes before', required: false, type: 'infoNumber', helpText: 'DROPINHINT', min: 0, max: 60},
        {name: 'showMembers', title: 'Let customers see participants', type: 'checkbox', helpText: 'Allows all customers to see other activity participants when booking.' },
        {name: 'discussion', title: 'Let participants discuss', type: 'checkbox', helpText: 'Allows participants to chat with others who are booked on the same workout.' },
        {name: 'send_reminder_hours', title: 'Send reminder', type: 'infoNumber', info: 'hours before'},
        {name: 'send_video_link_mins', title: 'Send video link', info: 'minutes before', required: false, type: 'infoNumber'},
        {name: 'for_group', title: 'Group leader can add activity', type: 'checkbox', helpText: 'Allows member responsible for group to create activities of this category for only their group. No other customer sees the activity.' },
        {name: 'permission', title: 'Permission to handle activities', type: 'select', options: function() { return $scope.permissions; }, useId: true, helpText: 'Those with the permission can add and adjust activities in this category.' },
        {name: 'is_global', title: 'Chain', type: 'checkbox', visible: function() {return $rootScope.currentStaff.exportObjects;}},
        {name: 'firstCome', title: 'First come first served', type: 'checkbox', helpText: 'FIRST_COME_INFO' }
    ];

    $rootScope.waitFor(['sites']).then(function() {
        getPermissions().then(function() {
            if ($scope.setInitialValues) {
                $scope.setInitialValues();
            }
        });
    });
}]);

app.controller('WorkoutCategoryChangeCtrl', ['$rootScope', '$scope', '$controller', 'workoutcategory', function($rootScope, $scope, $controller, workoutcategory) {
    $controller('WorkoutCategoryAddCtrl', {$scope: $scope});
    $controller('ChangeModalCtrl', {$scope: $scope});

    $scope.titleSuffix = function() {
        return workoutcategory.name;
    };

    $scope.item = workoutcategory;
    $scope.postUrl = '/api/schedule/workout/category/change';
    $scope.setInitialValues = undefined;

    $scope.$watch(function() { return $scope.permissions && $rootScope.sites; }, function(value) {
        if (value) {
            var sync = $rootScope.currentStaff.sync || {};
            if(sync.active && $scope.item.is_global && !$rootScope.hasPermission('Chain settings')) {
                if(sync.fields && sync.fields.workoutcategory) {
                    $scope.fields.forEach(function(field) {
                        if(sync.fields.workoutcategory.indexOf(field.name) >= 0) {field.readonly=true;}
                    });
                }
                _.findWhere($scope.fields, {name: 'is_global'}).readonly = true;
            }
            $scope.setValues($scope.item);
        }
    });
}]);

app.controller('WorkoutTypeDataCtrl', ['$rootScope', '$scope', 'accounts', 'genders', 'util', '$filter', 'server', 'options', function($rootScope, $scope, accounts, genders, util, $filter, server, options) {
    function onetime() {
        return $scope.config.control.getField('onetime').value;
    }

    function showCostCenter() {
        return onetime() && $rootScope.hasPermission('Accounting') && $scope.config.data.costcenters?.length;
    }

    $scope.ages = [];
    for (let i = 1; i <= 100; ++i) {
        $scope.ages.push({'id': i, 'name': i});
    }

    function accessGlobalOption() {
        if ($rootScope.currentStaff.exportObjects && $rootScope.hasPermission('Chain settings')) {
            let category = $scope.config.control.getField('category_id');
            return category.value?.is_global;
        }
    }

    var bookingGroupsRow;
    if ($rootScope.speedy) {
        bookingGroupsRow = {name: 'booking_groups', title: 'Bookable for groups', required: false, type: 'groups', useId: true, visible: () => $rootScope.hasModule('WorkoutBookingRules'), placeholder: 'No group required' };
    } else {
        bookingGroupsRow = {name: 'booking_groups', title: 'Bookable for groups', required: false, type: 'multiselect', options: () => $rootScope.usergroups, useId: true, visible: () => $rootScope.hasModule('WorkoutBookingRules') && $rootScope.usergroups.length, placeholder: 'No group required' };
    }

    var setAge = function(field, value) {
        if (value) {
            return {from: _.findWhere($scope.ages, {id: value.from}), to: _.findWhere($scope.ages, {id: value.to})};
        }
    };

    $scope.config = _.deep_extend(options.config, {
        datatype: 'workouttype',
        url: {
            add: '/api/schedule/workout/type/add',
            change: '/api/schedule/workout/type/change'
        },
        data: {
            costcenters: $rootScope.hasPermission('Accounting') && $rootScope.waitFor(['costcenters']),
            interests: server.get('/api/memberapi/interest/get'),
            apn: $rootScope.hasPermission('Apn') && server.get('/api/apn/get_activity_types'),
            lok_type: $rootScope.hasPermission('Lok') && server.get('/api/lok/get_activity_types'),
            lok_sport: $rootScope.hasPermission('Lok') && server.get('/api/lok/get_sport')
        },
        tabs: [
            {
                name: 'General',
                fields: [
                    {name: 'category_id', title: 'Category', required: true, type: 'select', options: () => $rootScope.workoutcategories, optionsFilter: {active: true}, useId: true },
                    {name: 'subcategory', title: 'Sub category', required: false, type: 'text', visible: () => $rootScope.is_korpen },
                    {name: 'name', title: 'ACTIVITYNAME', required: true, type: 'text'},
                    {name: 'sites', title: 'Sites', required: true, type: 'multiselect', visible: () => $rootScope.hasModule('MultiSite'), options: () => $rootScope.sites, useId: true, addButtonClicked: field => field.value = field.options(), addButtonTitle: 'Select all'},
                    {name: 'description', title: 'Activity description (shown when booking)', required: false, type: 'htmleditor'},
                    {name: 'color', title: 'Schedule color', required: false, type: 'color'},
                    {name: 'show', title: 'Show for customers', required: false, type: 'checkbox', helpText: 'Determine if customers can see scheduled workouts of this activity type.' },
                    {name: 'printTicket', title: 'Print ticket', required: false, type: 'checkbox', helpText: 'Prints a ticket to the customer upon entry. Requires the addon Entry and a receipt printer.' },
                    {name: 'is_global', title: 'Chain', type: 'checkbox', visible: accessGlobalOption},
                    {name: 'imagekey', title: 'Image', type: 'field', field: 'image-storage', option: {originType: 'workouttype', imageOnly: true, squareThumbnail: false}, visible: function() { return $rootScope.zoeziMyBusiness; } },
                    {name: 'tags', title: 'Tags', required: false, type: 'systemtag'}
                ]
            },
            {
                name: 'Booking',
                fields: [
                    {name: 'allowBooking', title: 'Booking with training card', required: false, type: 'checkbox' },
                    {name: 'cardtypes', title: 'Bookable with', required: false, type: 'multiselect', options: () => $rootScope.trainingcardtypes, optionsFilter: card => card.workout && !card.resourcebookingservice_id && !card.workoutBooking, placeholder: 'All training cards', visible: 'allowBooking', useId: true, group: card => card.active ? 'Training cards' : 'Inactive training cards', orderPredicate: ['-active', 'name'], addButtonClicked: field => field.value = field.options(), addButtonTitle: 'Select all' },

                    // Bookable conditions
                    bookingGroupsRow,
                    {name: 'booking_interests', title: 'Bookable for interests', required: false, type: 'multiselect', options: () => $scope.config.data.interests, useId: true, visible: () => $rootScope.hasModule('WorkoutBookingRules') && $scope.config.data.interests?.length, placeholder: 'For all interests' },
                    {name: 'booking_age', title: 'Age for booking', required: false, type: 'interval', options: () => { return $scope.ages;}, getValue: getIntervalValue, setValue: setAge, visible: function() { return $rootScope.hasModule('WorkoutBookingRules'); } },
                    {name: 'booking_gender', title: 'Gender for booking', required: false, type: 'select', options: genders.getList, useId: true,  placeholder: 'For all', visible: function() { return $rootScope.hasModule('WorkoutBookingRules'); }}
                ]
            },
            {
                name: 'One time card',
                fields: [
                    {name: 'onetime', title: 'Sell one time cards', required: true, type: 'checkbox', helpText: 'Allows customers to buy one time tickets for this activity type without a training card.' },
                    {name: 'price', title: 'Price incl. VAT', required: true, type: 'price', visible: 'onetime' },
                    {name: 'vat', title: 'VAT', required: true, type: 'select', options: () => $rootScope.valueAddedTax, useId: true, visible: () => onetime() && !$rootScope.vatexempt },
                    accounts.getFieldsRow($scope, () => onetime() && $rootScope.hasPermission('Accounting')),
                    {name: 'costcenter_id', title: 'Cost center', type: 'select', options: () => $scope.config.data.costcenters, visible: showCostCenter, useId: true}
                ]
            },
            {
                name: 'Grant',
                visible: () => $rootScope.hasModule('SISU') || $rootScope.hasPermission('Lok') || $rootScope.hasPermission('Apn'),
                fields: [
                    {name: 'sisu', title: 'SISU learning hour', required: false, type: 'checkbox', visible: function() { return $rootScope.hasModule('SISU'); }, helpText: 'Sets that activities of this type are SISU learning hours. The activities can then easily be obtained in a report as a basis for reporting to SISU.' },
                    {name: 'lok_type', title: 'Type of activity (for contributions)', required: false, type: 'select', options: () => $scope.config.data.lok_type, useId: true, visible: () => $rootScope.hasPermission('Lok'), helpText: 'Required for the governmental LOK grant' },
                    {name: 'lok_sport_ref', title: 'Sport (for contributions)', required: false, type: 'select', options: () => $scope.config.data.lok_sport, useId: true, visible: () => $rootScope.hasPermission('Lok'), helpText: 'Required for the governmental LOK grant' },
                    {name: 'apn_type', title: 'Type of activity (for contributions)', required: false, type: 'select', options: () => $scope.config.data.apn, useId: true, visible: () => $rootScope.hasPermission('Apn'), helpText: 'Required for the municipal APN grant' }
                ]
            },
            {
                name: 'Preset values',
                fields: [
                    {name: 'preset_duration', title: 'Duration', type: 'infoNumber', info: 'minutes', min: 1 },
                    {name: 'preset_space', title: 'Num places', type: 'number', min: 1 },
                    {name: 'preset_staffs', title: 'Instructor', type: 'customers', itemTypes: ['staff'], useId: true },
                    {name: 'preset_resources', title: 'Resources', type: 'customers', itemTypes: ['resource'], useId: true },
                    {name: 'preset_extra_title', title: 'Type - complement', type: 'text'}
                ]
            }
        ],
        init() {
            let res = {
                sites: [$rootScope.selectedSite],
                color: util.getRandomColor(),
                show: true,
                vat: $rootScope.valueAddedTax.find(x => x.id == '6'),
                allowBooking: true
            };

            if (!options.category_id) {
                res.category_id = $filter('orderBy')($rootScope.workoutcategories.filter(c => c.active), 'order')[0];
            }

            return res;
        }
    });
}]);

app.controller('WorkoutTypeAddCtrl', ['$rootScope', '$scope', '$controller', 'paymentMethods', 'accounts', 'util', 'server', 'options', '$filter', '$q', 'genders', function($rootScope, $scope, $controller, paymentMethods, accounts, util, server, options, $filter, $q, genders) {
    $controller('AddCtrl', {$scope: $scope});

    $scope.title = "Add workout type";
    $scope.postUrl = '/api/schedule/workout/type/add';
    $scope.successTitle = 'Workout type added';
    $scope.failedTitle = 'Failed to add workout type';
    $scope.callCloseOnSuccess = true;

    $scope.setInitialValues = function() {
        _.findWhere($scope.fields, {name: 'category_id'}).value = options.category || $filter('orderBy')($rootScope.workoutcategories.filter(function(c){ return c.active;}), 'order')[0];
        _.findWhere($scope.fields, {name: 'sites'}).value = [$rootScope.selectedSite];
        _.findWhere($scope.fields, {name: 'color'}).value = util.getRandomColor();
        _.findWhere($scope.fields, {name: 'show'}).value = true;
        _.findWhere($scope.fields, {name: 'vat'}).value = _.findWhere($rootScope.valueAddedTax, {id: '6'});
        _.findWhere($scope.fields, {name: 'allowBooking'}).value = true;
    };

    var onetime = function() {
        return _.findWhere($scope.fields, {name: 'onetime'}).value;
    };

    var getTrainingCards = function() {
        return $rootScope.getTrainingCards().filter(function(card) {
            return card.workout && !card.resourcebookingservice_id && !card.workoutBooking;
        });
    };

    var getAllowBooking = function() {
        return _.findWhere($scope.fields, {name: 'allowBooking'}).value;
    };

    var accessGlobalOption = function() {
        if($rootScope.currentStaff.exportObjects && $rootScope.hasPermission('Chain settings')) {
            var category = _.findWhere($scope.fields, {name: 'category_id'});
            return category.value && category.value.is_global;
        }
    };

    function showCostCenter() {
        return onetime() && $rootScope.hasPermission('Accounting') && $scope.costcenters && $scope.costcenters.length;
    }

    var getTrainingCardGroup = function(card) {
        return card.active ? 'Training cards' : 'Inactive training cards';
    };

    var lok_type = [], lok_sport = [], apn_type = [];

    $scope.ages = [];
    for (var i = 1; i <= 100; ++i) {
        $scope.ages.push({'id': i, 'name': i});
    }

    $scope.interests = [];
    var getInterests = function() {
        server.get('/api/memberapi/interest/get').then(function(interests) {
            $scope.interests = interests;
        });
    };
    getInterests();

    $scope.fields = [
        {name: 'category_id', title: 'Category', required: true, type: 'select', options: function() { return $rootScope.workoutcategories; }, optionsFilter: {active: true}, useId: true },
        {name: 'subcategory', title: 'Sub category', required: false, type: 'text', visible: function() { return $rootScope.is_korpen; } },
        {name: 'name', title: 'ACTIVITYNAME', required: true, type: 'text'},
        {name: 'sites', title: 'Sites', required: true, type: 'multiselect', visible: function() { return $rootScope.hasModule('MultiSite'); }, options: function() { return $rootScope.sites; }, useId: true},
        {name: 'description', title: 'Activity description (shown when booking)', required: false, type: 'htmleditor'},
        {name: 'color', title: 'Schedule color', required: false, type: 'color'},
        {name: 'show', title: 'Show for customers', required: false, type: 'checkbox', helpText: 'Determine if customers can see scheduled workouts of this activity type.' },
        {name: 'onetime', title: 'Sell one time cards', required: true, type: 'checkbox', helpText: 'Allows customers to buy one time tickets for this activity type without a training card.' },
        {name: 'price', title: 'Price incl. VAT', required: true, type: 'price', visible: onetime },
        {name: 'vat', title: 'VAT', required: true, type: 'select', options: function() { return $rootScope.valueAddedTax; }, useId: true, visible: function() { return onetime() && !$rootScope.vatexempt; } },
        accounts.getFieldsRow($scope, function() { return onetime() && $rootScope.hasPermission('Accounting'); }),
        {name: 'costcenter_id', title: 'Cost center', type: 'select', options: function() { return $scope.costcenters; }, visible: showCostCenter, useId: true},
        {name: 'allowBooking', title: 'Booking with training card', required: false, type: 'checkbox' },
        {name: 'cardtypes', title: 'Bookable with', required: false, type: 'multiselect', options: getTrainingCards, placeholder: 'All training cards', visible: getAllowBooking, useId: true, group: getTrainingCardGroup, orderPredicate: ['-active', 'name'], addButtonClicked: function(field) { field.value = field.options(); }, addButtonTitle: 'Select all' },

        // Bookable conditions
        {name: 'booking_groups', title: 'Bookable for groups', required: false, type: 'multiselect', options: function() { return $rootScope.usergroups; }, useId: true, visible: function() { return $rootScope.hasModule('WorkoutBookingRules') && ($rootScope.usergroups.length || $rootScope.speedy); }, placeholder: 'No group required' },
        {name: 'booking_interests', title: 'Bookable for interests', required: false, type: 'multiselect', options: function() { return $scope.interests; }, useId: true, visible: function() { return $rootScope.hasModule('WorkoutBookingRules') && $scope.interests.length; }, placeholder: 'For all interests' },
        {name: 'booking_age', title: 'Age for booking', required: false, type: 'interval', options: function() { return $scope.ages;}, getValue: getIntervalValue, visible: function() { return $rootScope.hasModule('WorkoutBookingRules'); } },
        {name: 'booking_gender', title: 'Gender for booking', required: false, type: 'select', options: genders.getList, useId: true,  placeholder: 'For all', visible: function() { return $rootScope.hasModule('WorkoutBookingRules'); }},

        {name: 'printTicket', title: 'Print ticket', required: false, type: 'checkbox', helpText: 'Prints a ticket to the customer upon entry. Requires the addon Entry and a receipt printer.' },
        {name: 'sisu', title: 'SISU learning hour', required: false, type: 'checkbox', visible: function() { return $rootScope.hasModule('SISU'); }, helpText: 'Sets that activities of this type are SISU learning hours. The activities can then easily be obtained in a report as a basis for reporting to SISU.' },
        {name: 'lok_type', title: 'Type of activity (for contributions)', required: false, type: 'select', options: function() {return lok_type; }, useId: true, visible: function() { return $rootScope.hasPermission('Lok'); }, helpText: 'Required for the governmental LOK grant' },
        {name: 'lok_sport', title: 'Sport (for contributions)', required: false, type: 'select', options: function() {return lok_sport; }, useId: true, visible: function() { return $rootScope.hasPermission('Lok'); }, helpText: 'Required for the governmental LOK grant' },
        {name: 'apn_type', title: 'Type of activity (for contributions)', required: false, type: 'select', options: function() {return apn_type; }, useId: true, visible: function() { return $rootScope.hasPermission('Apn'); }, helpText: 'Required for the municipal APN grant' },
        {name: 'is_global', title: 'Chain', type: 'checkbox', visible: accessGlobalOption},
        {name: 'imagekey', title: 'Image', type: 'field', field: 'image-storage', option: {originType: 'workouttype', imageOnly: true, squareThumbnail: false}, visible: function() { return $rootScope.zoeziMyBusiness; } },
        {name: 'tags', title: 'Tags', required: false, type: 'systemtag'}
    ];

    var wait = [];
    if($rootScope.hasPermission('Lok')) {
        wait.push(server.get('/api/lok/get_activity_types').then(function(result) {lok_type = result;}));
        wait.push(server.get('/api/lok/get_sport').then(function(result) {lok_sport = result;}));
    }

    if($rootScope.hasPermission('Apn')) {
        wait.push(server.get('/api/apn/get_activity_types').then(function(result) {apn_type = result;}));
    }

    if ($rootScope.hasPermission('Accounting')) {
        wait.push(server.get('/api/economy/costcenter/get').then(function(data) {$scope.costcenters = data;}));
    }

    wait.push($rootScope.waitFor(['trainingcardtypes']));

    $q.allSettled(wait).then(function() {
        $scope.setInitialValues();
    });
}]);

app.controller('BaseTabsetController', ['$scope', function($scope) {
    $scope.init = function(defaultTab) {
        $scope.data = {};

        if (defaultTab) {
            $scope.data[defaultTab] = true;
        }
    };

    $scope.setTab = function(name) {
        $scope.data[name] = true;
        $scope.pubsub.publish('tabChanged', name);
    };
}]);

app.controller('CustomerTabsetController', ['$rootScope', '$scope', '$controller', function($rootScope, $scope, $controller) {
    $controller('BaseTabsetController', {$scope: $scope});

    $scope.hasOwnCustomers = function() {
        for (var i=0; i < $rootScope.members.length; ++i) {
            var m = $rootScope.members[i];
            if (m.responsible && m.responsible.id ==$rootScope.currentStaff.id) {
                return true;
            }
        }

        return false;
    };

    $scope.init($scope.hasOwnCustomers() ? 'my' : 'active');
}]);

app.controller('ScheduleTabsetController', ['$rootScope', '$scope', '$controller', function($rootScope, $scope, $controller) {
    $controller('BaseTabsetController', {$scope: $scope});

    $scope.init('calendar');
}]);

app.controller('WorkScheduleTabsetController', ['$rootScope', '$scope', '$controller', function($rootScope, $scope, $controller) {
    $controller('BaseTabsetController', {$scope: $scope});

    $scope.tabNames = {
        my: function() { return $scope.scheduleTitle; },
        myServiceHours: function() { return 'My service hours'; },
        all: function() { return 'All staff'; },
        resources: function() { return 'All resources'; },
        list: function() { return 'List view'; },
        custom: function() { return 'Custom schedule'; },
        weeklyScheduleResource: function() { return 'Weekly schedule'; },
    };

    $scope.init();
}]);

app.controller('SettingsTabsetController', ['$rootScope', '$scope', '$controller', '$timeout', '$location', 'modalUtils', '$routeParams', function($rootScope, $scope, $controller, $timeout, $location, modalUtils, $routeParams) {
    $controller('BaseTabsetController', {$scope: $scope});
    var tab = $routeParams.tab || 'general';
    $scope.init(tab);

    $scope.pubsub('tabChanged', function(newTab) {
        if (newTab == 'general') {
            $location.path('/settings/gym');
        } else {
            $location.path('/settings/gym/' + newTab);
        }
    }, true);

    var getPanelScope = function(panel) {
        panel = panel || 1;
        return angular.element('.tab-content > div.active > div > div.ng-scope:nth-child('+panel+')').scope();
    };

    $scope.associationinformation = function() {
        var scope = getPanelScope(1);
        var gf = function(name) { return _.findWhere(scope.fields, { name: name }); };
        return [{
            element: gf('companyname').element,
            popover: {
                title: 'Enter the full name of the association',
                description: 'This must correspond with the name registered with the Swedish Tax Agency.'
            },
            tab: 'general'
        }, {
            element: gf('companynumber').element,
            popover: {
                title: 'Enter the association\'s corporate identity number'
            }
        }, {
            element: gf('mail').element,
            popover: {
                title: 'What e-mail address could you be reached on?',
                description: 'The e-mail address will be displayed on invoices, among other things.'
            }
        }, {
            element: gf('homepage').element,
            popover: {
                title: 'Do you have a website?',
                description: 'Enter the address of your website'
            }
        }, {
            element: gf('phone').element,
            popover: {
                title: 'Which phone number could you be reached on?',
                description: 'The phone number will appear on invoices that you send out.'
            }
        }, {
            element: gf('address').element,
            popover: {
                title: 'Where is your facility located?',
                description: 'The address will appear on invoices that you send out.'
            }
        }, {
            element: gf('zipCode').element,
            popover: {
                title: 'Where is your facility located?',
                description: 'The address will appear on invoices that you send out.'
            }
        }, {
            element: gf('city').element,
            popover: {
                title: 'Where is your facility located?',
                description: 'The address will appear on invoices that you send out.'
            }
        }, {
            element: '#gymsettings-general #form > .form-group:last-of-type button',
            popover: {
                title: 'Save'
            }
        }];
    };

    $scope.boardsettings = function() {
        var scope = getPanelScope();

        var steps = [{
            element: '#gymsettings-association-content',
            popover: {
                title: 'Add the Board',
                description: 'Indicate who holds which position within the association',
                position: 'mid-center'
            },
            tab: 'association',
            skipStartOnClick: true
        }, {
            element: angular.element('div.active .form-group:last-of-type .btn')[0],
            popover: {
                title: 'Choose which role to add to the association',
                description: 'The roles of chairman and treasurer are mandatory.'
            },
            closeOnClick: true
        }];

        var role = _.find(scope.fields, function(f) { return f.type == 'customer' && !!f.element && f.visible(); });
        if (!role) { return []; }

        steps.push({
            element: role.element.querySelector('.btn'),
            popover: {
                title: 'Choose which ones who will hold the role'
            },
            closeOnClick: true
        });

        return steps;
    };

    $scope.accountintroduction = function() {
        return [{
            element: '#gymsettings-accounting .panel-body .form-horizontal > div:first-of-type',
            popover: {
                title: 'Be sure to turn off VAT for transactions'
            }
        }, {
            element: '#gymsettings-accounts .panel-heading',
            popover: {
                title: 'Add the accounts you use to your external accounting software'
            }
        }, {
            element: '#gymsettings-accounts customertable .searchFieldRow span.ng-scope > button',
            popover: {
                title: 'Add account',
                doneBtnText: 'Next'
            },
            closeOnClick: true
        }];
    };

    $scope.gotoaccountsettings2 = function() {
        var id = 'accountintroduction';
        var tab = 'economy';

        var startNext = function() {
            $scope.pubsub.publish('startGuide', true);
            if (!modalUtils.modalsExist()) {
                angular.element('#gymsettings-accounts customertable .searchFieldRow span.ng-scope > button')[0].click();
            }
        };

        var guide = $scope.$getGuide(id);
        guide.onFinish = startNext;

        $rootScope.waitFor(['accounts']).then(function() {
            $timeout(function() {
                $scope.setTab(tab);
                $scope.pubsub('tabChanged', function(newTab) {
                    $scope.pubsub.unsubscribe();
                    if (tab != newTab) { return; }
                    $scope.$startGuide(id);
                }, true);
            }, 10);
        });
    };

    $scope.addpaymentmethod = function() {
        return [{
            element: '#gymsettings-paymentmethod .tab-pane:first-of-type .table-dynamic > div:first-of-type button',
            popover: {
                title: 'Add payment method',
                closeBtnText: 'Next'
            },
            closeOnClick: true
        }];
    };

    $scope.gotopaymethodsettings2 = function() {
        var id = 'addpaymentmethod';
        var tab = 'economy';

        var startNext = function() {
            $scope.pubsub.publish('startGuide', true);
            if (!modalUtils.modalsExist()) {
                angular.element('#gymsettings-paymentmethod .tab-pane:first-of-type .table-dynamic > div:first-of-type button')[0].click();
            }
        };

        var guide = $scope.$getGuide(id);
        guide.onFinish = startNext;

        $scope.setTab(tab);
        $scope.pubsub('tabChanged', function(newTab) {
            $scope.pubsub.unsubscribe();
            if (tab != newTab) { return; }
            $timeout(function() {
                $scope.$startGuide(id);
            });
        }, true);
    };

    $scope.invoicesettings = function() {
        var scope = getPanelScope();
        var gfe = function(name) { return _.findWhere(scope.fields, { name: name }).element; };
        return [{
            element: gfe('days'),
            popover: {
                title: 'How many days do you have to pay?',
                description: 'Select the number of days that customers have to pay the received invoice.'
            }
        }, {
            element: gfe('bankgiroNumber'),
            popover: {
                title: 'Enter the bankgiro number to which payments are made',
                description: 'Note that Plusgiro is not supported'
            }
        }, {
            element: gfe('fee'),
            popover: {
                title: 'Should customers pay an invoicing fee?',
                description: 'Enter any amount to add to invoices - of course 0 is also ok'
            }
        }, {
            element: gfe('minAmount'),
            popover: {
                title: 'Enter the minimum amount limit on invoices'
            }
        }, {
            element: gfe('sendSmsOrMail'),
            popover: {
                title: 'Choose how invoices are sent to the customer'
            }
        }, {
            element: gfe('mailtext'),
            popover: {
                title: 'Do you want to write something particular in the mailing?',
                description: 'When the customer receives an invoice, you can also add a text to the mailing that is made'
            }
        }, {
            element: gfe('smstext'),
            popover: {
                title: 'Do you want to write something particular in the mailing?',
                description: 'When the customer receives an invoice, you can also add a text to the mailing that is made'
            }
        }, {
            element: gfe('autosend_webshop_invoice'),
            popover: {
                title: 'Do you want to avoid manually confirming these invoices?',
                description: 'With this setting, invoice purchases made by customers directly through the webshop can be confirmed and sent automatically'
            }
        }, {
            element: '#form div.form-group:last-of-type button',
            popover: {
                title: 'Save'
            }
        }];
    };

    var ensureTab = function(id) {
        var guide = $scope.$getGuide(id);
        if (guide.tab) {
            $scope.setTab(guide.tab);
        }
        $timeout(function() {
            $scope.pubsub.publish('startGuide', id);
        }, 250);
    };

    var cancelGuideWatch = $scope.$watch('$registerGuide', function() {
        if (!$scope.$registerGuide) { return; }
        cancelGuideWatch();
        $scope.$registerGuide({ id: 'associationinformation', title: 'Association information', tab: 'general', steps: $scope.associationinformation, onFinish: $rootScope.possiblyGoToGetStarted });

        $scope.$registerGuide({ id: 'boardsettings', title: 'Add the Board', tab: 'association', steps: $scope.boardsettings, hidden: true, onFinish: $rootScope.possiblyGoToGetStarted });
        $scope.$registerGuide({ id: 'gotoboardsettings2', title: 'Add the Board', tab: 'association', redirect: function() { ensureTab('boardsettings'); } });

        $scope.$registerGuide({ id: 'accountintroduction', title: 'Manage accounts', tab: 'economy', steps: $scope.accountintroduction, hidden: true });
        $scope.$registerGuide({ id: 'gotoaccountsettings2', title: 'Manage accounts', tab: 'economy', redirect: $scope.gotoaccountsettings2 });

        $scope.$registerGuide({ id: 'addpaymentmethod', title: 'Add payment method', tab: 'economy', steps: $scope.addpaymentmethod, hidden: true });
        $scope.$registerGuide({ id: 'gotopaymethodsettings2', title: 'Add payment method', tab: 'economy', redirect: $scope.gotopaymethodsettings2 });

        $scope.$registerGuide({ id: 'invoicesettings', title: 'Adjust billing settings', tab: 'invoice', steps: $scope.invoicesettings, onFinish: $rootScope.possiblyGoToGetStarted });
    });

    $scope.currentStaffHasRole = function(roleId) {
        return $rootScope.currentStaff.roles.some(function(r) { return r.id == roleId; });
    };
}]);

app.controller('EntryAddCtrl', ['$rootScope', '$scope', '$controller', '$filter', '$modal', '$timeout', 'modalUtils', 'server', 'Setting', 'live', function($rootScope, $scope, $controller, $filter, $modal, $timeout, modalUtils, server, Setting, live) {
    $scope.postUrl = '/api/entry/add';
    $rootScope.listeningForInput = true;
    $rootScope.setupKeypressListener();

    if ($rootScope.speedy) {
        $rootScope.loadActiveResourcesForSite();
    }

    $scope.audio = {};
    var waitingWatch = $scope.$watch('audio.div', function(div) {
        if(!div) {return;}
        waitingWatch();

        Setting.get('Entry').then(function(data) {
            ['welcome', 'denied', 'birthday'].forEach(function(key) {
                var name = key + '_sound';
                if(!data[name]){return;}
                var e = document.createElement('audio');
                e.src = '/api/utils/file/download?key=' + data[name];
                div.appendChild(e);
                $scope.audio[key] = e;
            });
        });
    });

    $scope.getButtonText = function() {
        return 'Add';
    };

    function hasBirthday(member) {
        if(!member) {return false;}
        if(!member.birthdate) {return false;}
        var d = new Date();
        var parts = member.birthdate.split('-'); // year-month-date
        if (parts.length < 2) {return false;}

        return Number(parts[1]) == (d.getMonth()+1) && Number(parts[2]) == d.getDate();
    }

    $scope.playSound = _.debounce(function() {
        var success = ($rootScope.lastEntry.Member && $rootScope.lastEntry.success && !$rootScope.lastEntry.Member.hasDebt && !$rootScope.lastEntry.missingMembership);
        if(success) {
            var audio = $scope.audio.welcome;
            if(hasBirthday(($rootScope.lastEntry || {}).Member)) {
                audio = $scope.audio.birthday || document.getElementById('birthday');
            }

            if(audio) {
                audio.play();
            } else {
                document.getElementById('welcome').play();
            }
        } else {
            if($scope.audio.denied) {
                $scope.audio.denied.play();
            } else {
                document.getElementById('contactStaff').play();
            }
        }
    }, 100);

    var getCustomer = function() {
        return _.findWhere($scope.fields, {name: 'customer'}).value;
    };

    $scope.updateLastEntry = function(entry) {
        $rootScope.lastEntry = entry;
        $rootScope.lastEntry.errorLink = null;
        if (!entry.card && !entry.success) {
            if (entry.entryNotAllowed) {
                $rootScope.lastEntry.errorMessage = $filter('translate')("{0} is not allowed to enter").format(entry.Member.name);
            } else if (entry.cardNotValidForDoor) {
                $rootScope.lastEntry.errorMessage = $filter('translate')("{0} has no valid training card for this door.").format(entry.Member.name);
            } else if (entry.cardValidOtherHours) {
                var card = $rootScope.transformTrainingCard(entry.cardValidOtherHours);
                $rootScope.lastEntry.errorMessage = $filter('translate')('{0} has a valid training card for hours {1}-{2}').format(entry.Member.name, card.cardtype.entryFrom.hhmm(), card.cardtype.entryTo.hhmm());
            } else if (entry.entryFailed) {
                $rootScope.lastEntry.errorMessage = $filter('translate')('Wrong PIN-code: {0}').format(entry.Member.name);
            } else if (entry.reason === 'noValidCard') {
                $rootScope.lastEntry.errorMessage = $filter('translate')("{0} has no valid training card.").format(entry.Member.name);
            } else {
                $rootScope.lastEntry.errorMessage = $filter('translate')("Error, please contact staff.");
            }
            $rootScope.lastEntry.errorLink = `/customer/show/${entry.Member.id}`;
        }
    };

    $scope.$on('ApiDataLoaded', function(event, uid) {
        if (uid == 'user.' + $rootScope.lastEntry?.Member?.id) {
            $scope.updateLastEntry($rootScope.lastEntry);
        }
    });

    $scope.submitId = function(id, customer) {
        $scope.clearForm();

        var args = {manual: true};
        if (id) {
            args.id = id;
        }
        if (customer) {
            args.customer = customer;
        }

        var door = _.findWhere($scope.fields, {name: 'door'}).value;
        if (door) {
            args.door = door.id;
        }

        server.post($scope.postUrl, args, null).then(function(result) {
            var data = result.data;
            if (result.success) {
                data.Member = $rootScope.getMember(data.Member.id);
                $scope.updateLastEntry(data);
                if ($scope.onEntry && data.success) {
                    $scope.onEntry(data);
                }
                else if ($scope.onFailed) {
                    $scope.onFailed();
                }
            } else {
                $rootScope.lastEntry = data;
                if ($rootScope.hasModule('Entry') && $rootScope.lastEntry.cardId) {
                    $rootScope.lastEntry.unknownCard = true;
                }
                $rootScope.lastEntry.errorMessage = data.message;
                if ($scope.onFailed) {
                    $scope.onFailed();
                }
            }
        });
    };

    var keypress = '';
    var idleTimer = null;

    $scope.clearForm = function() {
        keypress = '';
        _.findWhere($scope.fields, {name: 'customer'}).value = undefined;
        var form = $("#form");
        if (form.scope()) {
            form.scope().form.$setPristine();
        }
    };

    $scope.$on('keypress', function(onEvent, keypressEvent) {
        if (!modalUtils.modalsExist() && $rootScope.listeningForInput) {
            $timeout.cancel(idleTimer);
            idleTimer = $timeout(function() {
                keypress = '';
            }, 2000);
            if (keypressEvent.keyCode == 13 || keypressEvent.keyCode == 9) {
                if (keypress.length) {
                    $scope.submitId(keypress);
                }
            } else {
                var charCode = (typeof keypressEvent.which == "number") ? keypressEvent.which : keypressEvent.keyCode;
                keypress += String.fromCharCode(charCode);
            }
        }
    });

    $scope.imageSrc = function(entry, size) {
        return $rootScope.memberImage(entry.Member, size);
    };

    $scope.getTrainingCardInfo = function(entry) {
        if (!entry || !entry.card) {
            return;
        }
        var info = entry.card.cardtype_name;
        if (entry.card.trainingsLeft !== null) {
            info += ', ' + entry.card.trainingsLeft + ' ' + $filter('translate')('times left');
        }
        if(entry.card.validToDate !== null) {
            info += ', ' + $filter('translate')('valid to') + ': ' + entry.card.validToDate;
        }

        return info;
    };

    $scope.linkLastToCustomer = function() {
        $modal.open({
            templateUrl: 'views/getcustomermodal.html',
            windowClass: 'huge-modal-window',
            controller: 'GetCustomerCtrl',
            resolve: {
                options: function() {
                    return { };
                }
            }
        }).result.then(function (customer) {
            server.post('/api/card/set', null, {user_id: customer.id, cardId: $rootScope.lastEntry.cardId}, 'Card/tag registered', 'Failed to register card/tag');
        });
    };

    var isActiveDoor = function(s) {
        var sameSite = true;
        if ($rootScope.hasModule('MultiSite') && (s.sites && s.sites.length)) {
            sameSite = s.sites.indexOf($rootScope.selectedSite.id) !== -1;
        }
        return s.active && s.type == 'resource' && (s.resourceType == 'door' || s.resourceType == 'qrcode_entry') && sameSite;
    };

    var hasDoors = function() {
        return $rootScope.staffs.filter(isActiveDoor).length > 0;
    };

    $scope.fields = [
        {name: 'door', title: 'Door', required: false, type: 'select', visible: hasDoors, options: function() { return $rootScope.staffs;}, optionsFilter: isActiveDoor, placeholder: 'No door choosen' },
        {name: 'customer', title: 'Choose customer', required: false, type: 'customer' }
    ];
    $scope.hideSubmitButton = true;

    $scope.$watch(getCustomer, function(newValue) {
        if (newValue) {
            $scope.submitId(null, getCustomer().id);
        }
    });

    $scope.$on('$destroy', function () {
        $rootScope.listeningForInput = false;
    });

    live.subscribe( {
        type: 'entry',
        scope: $scope,
        callback: function(entry) {
            if ($rootScope.hasModule('MultiSite') && (entry.sites && entry.sites.length) && entry.sites.indexOf($rootScope.selectedSite.id) === -1) {
                return;
            }
            $scope.updateLastEntry(entry);
            $scope.playSound();
        }
    });
}]);

app.controller('ExternalEntryCtrl', ['$rootScope', '$scope', '$controller', '$timeout', '$routeParams', '$filter', 'server', 'live', 'formatter', 'confirm', 'Setting', function($rootScope, $scope, $controller, $timeout, $routeParams, $filter, server, live, formatter, confirm, Setting) {
    $controller('EntryAddCtrl', {$scope: $scope});
    // Disable keyboard input until a door is explicitly selected.
    $rootScope.listeningForInput = false;

    var currentTimeout = null;

    $scope.wbBookingEnabled = false;
    function getWbBookingSettings() {
        Setting.get('Entry').then(function(data) {
            $scope.wbBookingEnabled = !!data.xentry_wb;
        });
    }
    getWbBookingSettings();

    var transformWorkout = function(workout) {
        workout = $rootScope.transformWorkout(workout);
        workout.name = workout.workoutType.name;
        workout.time = workout.startTime.hhmm();
        workout.customerBooked = !!_.findWhere(workout.bookings, { user_id: $scope.entry.Member.id });
        return workout;
    };

    $scope.availableWorkouts = [];
    function updateAvailableWorkouts() {
        server.get('/api/entry/external/workout/get', { id: $scope.entry.Member.id }).then(function(workouts) {
            angular.forEach(workouts, transformWorkout);
            $scope.availableWorkouts = workouts;
        });
    }

    var isVisible = function(workout) { return !workout.customerBooked && (workout.space ? workout.numBooked < workout.space : true); }

    var confirmBooking = function(workout) {
        if (!$scope.entry || !$scope.entry.card) { return; }
        if (!isVisible(workout)) { return; }

        var message = $filter('translate')('Confirm booking of workout "{0}" at {1}').format(workout.name, workout.time);
        confirm.show(message).then(function() {
            var customer = $scope.entry.Member;
            $rootScope.makeWorkoutBooking(customer, workout, true, true)
            .then(function() {
                workout.customerBooked = true;
                updateAvailableWorkouts();
            });
        });
    };

    $scope.tableConfig = {
        getItems: function() {
            return $scope.availableWorkouts;
        },
        tableLimit: 7,
        tableNumPages: 1,
        hideSearchCount: true,
        style: { color: '#767676' }, // Uses default colors to ensure that text is always visible
        rowClick: confirmBooking,
        orderColumn: 'time',
        columns: [
            { field: 'name', title: 'Name' },
            { field: 'time', title: 'Time' },
            { field: 'customerBooked', title: 'Booked', format: 'bool' }
        ],
        buttons: [
            { title: 'Book', onClick: confirmBooking, visible: isVisible }
        ]
    };

    $rootScope.waitFor(['startedModules']).then(function() {
        if ($rootScope.hasModule('FreeTraining')) {
            server.get('/api/freetraining/settings/get').then(function(settings) {
                $scope.freetraining = settings;
            });
        }
    });

    $scope.animateToMiddle = function() {
        var width = $(window).width();
        var height = $(window).height();

        var left = (width - $scope.imgWidth) / 2;
        var top = (height - $scope.imgHeight) / 2;

        $('#logo').animate({ left: left + 'px', top: top + 'px', width: $scope.imgWidth, height: $scope.imgHeight });
    };

    $scope.fadeToMiddle = function() {
        var imgWidth = $('#entry').width();
        var imgHeight = $('#entry').height();
        var width = $(window).width();
        var height = $(window).height();

        var left = (width - imgWidth) / 2;
        var top = (height - imgHeight) / 2;

        $('#entry').animate({ left: left + 'px', top: top + 'px', opacity: '1' });
    };

    var calculateAspectRatioFit = function(srcWidth, srcHeight, maxWidth, maxHeight) {
        var ratio = Math.min(maxWidth / srcWidth, maxHeight / srcHeight);
        return { width: srcWidth*ratio, height: srcHeight*ratio };
    };

    $scope.cardCanBook = function() {
        if (!$scope.entry || !$scope.entry.card) { return false; }
        return !!(_.findWhere($rootScope.trainingcardtypes, { id: $scope.entry.card.cardtype_id }) || {}).workout;
    };

    $scope.onEntry = function(entry) {
        if (currentTimeout) {
            $timeout.cancel(currentTimeout);
        }
        if (entry.card) {
            $rootScope.transformTrainingCard(entry.card);
        }
        $scope.entry = entry;
        $scope.fadeToMiddle();

        updateAvailableWorkouts();

        var ar = calculateAspectRatioFit($scope.imgWidth, $scope.imgHeight, $(window).width() / 4, $(window).height() / 4);

        $('#logo').animate({ left: '10px', top: '10px', width: ar.width, height: ar.height });

        currentTimeout = $timeout($scope.exitEntryScreen, 30000);
    };

    $scope.onFailed = function() {
        if (currentTimeout) {
            $timeout.cancel(currentTimeout);
        }
        $scope.fadeToMiddle();

        var ar = calculateAspectRatioFit($scope.imgWidth, $scope.imgHeight, $(window).width() / 4, $(window).height() / 4);
        $('#logo').animate({ left: '10px', top: '10px', width: ar.width, height: ar.height });

        currentTimeout = $timeout($scope.exitEntryScreen, 10000);
    };

    $scope.exitEntryScreen = function() {
        if (currentTimeout) {
            $timeout.cancel(currentTimeout);
        }
        currentTimeout = null;
        $scope.animateToMiddle();
        $('#entry').animate({ opacity: '0' });
    };

    $scope.getFreeMessage = function() {
        if ($scope.freetraining && $scope.entry) {
            if ($scope.entry.free) {
                return $scope.freetraining.message;
            } else {
                var g = $scope.entry.entries == 1 ? 'gång' : 'gånger';
                return 'Du har tränat {0} {1} denna månad'.format($scope.entry.entries, g);
            }
        }
    };

    $scope.getExtraMessage = function() {
        if ($scope.entry) {
            var card = $scope.entry.card;
            if (!card) {
                // Only shown on successful check-ins; cardless-but-valid check-ins
                // (Bruce/partner, free training, resource booking) shouldn't be warned.
                return '';
            } else {
                if ($scope.entry.missingMembership) {
                    return $filter('translate')('ENTRY_MEMBERSHIPERROR');
                } else if (card.trainingsLeft != null) {
                    return $filter('translate')('You have a punch card {0} with {1} trainings left').format(card.cardtype.name, card.trainingsLeft);
                } else if (card.validToDate != null) {
                    return $filter('translate')('You have training card {0} valid until {1}').format(card.cardtype.name, formatter.format('date', card.validToDate));
                } else {
                    return $filter('translate')('You have an ongoing training card {0}').format(card.cardtype.name);
                }
            }
        }
    };

    $scope.activeDoor = null;

    $scope.availableDoors = function() {
        var doorField = _.findWhere($scope.fields, {name: 'door'});
        if (!doorField) { return []; }
        var options = (doorField.options ? doorField.options() : null) || [];
        return doorField.optionsFilter ? options.filter(doorField.optionsFilter) : options;
    };

    var recentEntryIds = {};

    // Wrap onEntry to track handled entries and prevent double animation
    // when both REST response and WebSocket fire for the same entry.
    var origOnEntry = $scope.onEntry;
    $scope.onEntry = function(entry) {
        if (entry.id) {
            if (recentEntryIds[entry.id]) { return; }
            recentEntryIds[entry.id] = true;
            $timeout(function() { delete recentEntryIds[entry.id]; }, 3000);
        }
        origOnEntry(entry);
    };

    // Single WebSocket subscription — checks activeDoor dynamically so it
    // works correctly even if the user switches door without a page reload.
    live.subscribe({
        type: 'entry',
        action: 'add',
        scope: $scope,
        callback: function(entry) {
            if ($scope.activeDoor && String(entry.door) === String($scope.activeDoor.id) && !recentEntryIds[entry.id]) {
                $scope.updateLastEntry(entry);
                $scope.onEntry(entry);
            }
        }
    });

    function activateDoor(door) {
        $scope.activeDoor = door;

        var doorField = _.findWhere($scope.fields, {name: 'door'});
        doorField.value = door;

        $rootScope.listeningForInput = true;
    }

    $scope.selectDoor = function(door) {
        activateDoor(door);
    };

    $scope.changeDoor = function() {
        $scope.exitEntryScreen();
        $scope.activeDoor = null;
        $rootScope.listeningForInput = false;
        var doorField = _.findWhere($scope.fields, {name: 'door'});
        doorField.value = undefined;
    };

    // Init: auto-select from URL param (:doorId).
    var urlDoorId = $routeParams.doorId;

    if (urlDoorId) {
        $rootScope.waitFor(['staffs']).then(function() {
            var door = _.find($scope.availableDoors(), function(d) {
                return String(d.id) === String(urlDoorId);
            });
            if (door) {
                activateDoor(door);
            }
        });
    }
}]);

app.controller('StaffAddCtrl', ['$rootScope', '$scope', '$controller', '$filter', '$modal', '$http', '$location', 'server', 'image', 'modalUtils', function($rootScope, $scope, $controller, $filter, $modal, $http, $location, server, image, modalUtils) {
    $controller('AddCtrl', {$scope: $scope});

    $scope.title = "Add staff";
    $scope.postUrl = '/api/user/add';

    $scope.submit = function() {
        var f = _.findWhere($scope.fields, {name: 'image'});
        var s = f.selection;
        var file = f.value;
        var item = $scope.getSubmitItem();
        delete item.image;
        delete item.passwordRepeat;
        item.roles = angular.copy(item.roles);

        $("#form").scope().form.$setPristine();

        $scope.loadingStatus.loading = true;
        server.post($scope.postUrl, item, null, 'Staff added', 'Failed to add staff').then(function(result) {
            if (result.success) {
                var data = result.data;
                if (!$scope.callCloseOnSuccess) {
                    $location.path('/staff/show/' + data.id);
                }

               if (file ) {
                    image.set({type: 'Staff', id: data.id, file: file, imageSelection: s, successTitle: 'The image was uploaded correctly', failedTitle: 'The image could not be uploaded'});
                }

                $scope.possiblyClose(data);
            }

            $scope.loadingStatus.loading = false;
        });
    };

    $scope.fields = [
        {name: 'firstname', title: 'First name', required: true, type: 'text', focus: true},
        {name: 'lastname', title: 'Last name', required: true, type: 'text'},
        {name: 'personalCodeNumber', title: 'Personal code number', required: false, type: 'personalCodeNumber', ptype: 'staff', visible: function() {return true; }},
        {name: 'mail', title: 'E-mail', required: true, type: 'email', ptype: 'staff'},
        {name: 'phone', title: 'Phone', required: false, type: 'phone', visible: function() {return true; }},
        {name: 'oldphone', title: 'Old phone', required: false, type: 'phone', visible: function() {return true; }},
        {name: 'address', title: 'Address', required: false, type: 'text', visible: function() {return true; }},
        {name: 'zipCode', title: 'Zip code', required: false, type: 'zipCode', visible: function() {return true; }},
        {name: 'city', title: 'City', required: false, type: 'text', visible: function() {return true; }},
        {name: 'roles', title: 'Roles', required: true, type: 'multiselect', options: function() { return $rootScope.roles; }, useId: true },
        {name: 'responsible_id', title: 'Responsible', required: false, helpText:'Responsible helptext', placement:'top', type: 'select', options: function() { return $rootScope.getActiveStaffs(); }, useId: true },
        {name: 'image', title: 'Image_title', required: false, type: 'image' },
        {name: 'sites', title: 'Sites', required: true, type: 'multiselect', options: function() { return $rootScope.sites; }, placeholder: 'Choose site', visible: function() { return $rootScope.hasModule('MultiSite'); }, useId: true },
        {name: 'welcomeMail', title: 'Send welcome mail', type: 'checkbox', value: true },
        {name: 'tags', title: 'Tags', required: false, type: 'systemtag'}
    ];


    $scope.$getGuide = function() {
        var steps = [{
            element: modalUtils.getModalElement('.modal-content'),
            popover: {
                title: 'Add staff',
                description: 'Here you enter information for the staff account you\'re creating. Fill in the information required below and link a role to the account. The role determines what permissions the staff will have in the system. Finally, you can choose to send a welcome email - an email with a login link will then be sent to the person you are adding.',
                position: 'left-center'
            }
        }];

        return { steps: steps, onFinish: $rootScope.possiblyGoToGetStarted };
    };

}]);

app.controller('WorkoutDataCtrl', ['$rootScope', '$scope', '$filter', '$modal', 'server', 'util', 'teamsportutil', 'formatter', 'alertProvider', 'confirm', 'options', function($rootScope, $scope, $filter, $modal, server, util, teamsportutil, formatter, alertProvider, confirm, options) {
    function filterWorkoutTypes(wt) {
        if (!wt.sites || wt.sites.length == 0) {
            return true;
        }

        var site = $scope.config.control.getField('site_id');
        if (site.visible()) {
            var site_id = site.value.id;
            return wt.sites.indexOf(site_id) != -1;
        }

        return true;
    }

    function getWorkoutTypes() {
        var category = $scope.config.control.getField('category_id').value;
        if (!category) {
            return;
        }
        return $rootScope.workouttypes.filter(function(wt) { return wt.category_id == category.id && wt.active; });
    }

    function showWorkout() {
        var category = $scope.config.control.getField('category_id').value;
        if (!category || !category.show) {
            return false;
        }

        var wt = $scope.config.control.getField('WorkoutType').value;
        return wt && wt.show;
    }

    function getRepeatDates() {
        var dates = [];
        var start = $scope.config.control.getField('date').value;
        var end = $scope.config.control.getField('until').value;
        var interval = $scope.config.control.getField('interval').value.id;
        var weekdays = $scope.config.control.getField('weekdays').value.map(function(x) { return x.id; });
        var breaks = $scope.config.control.getTab('Repetition').fields.filter(function(f) { return f.name == 'break'; }).map(function(f) { return {from: Date.newFull(f.value.from), to: Date.newFull(f.value.to)}; });

        var isWithinBreak = function(date) {
            return !!breaks.find(function(b) {
                return date.withinRange(b.from, b.to);
            });
        };

        if (!start || !end || end < start) {
            return dates;
        }

        var d = start.clone();
        var week_nr = 0;
        while (true) {
            var daynr = d.getDay();
            if (daynr == 0) {
                daynr = 7;
            }
            if ((week_nr % interval) == 0 && weekdays.indexOf(daynr) != -1 && !isWithinBreak(d)) {
                dates.push(d.yyyymmdd());
            }

            if (d.isSameDateAs(end)) {
                return dates;
            }
            d = d.addDays(1);
            if (d.getDay() == 1) {
                ++week_nr;
            }
        }
    }

    function calcRepeat() {
        $scope.config.control.getField('count').value = getRepeatDates().length;
    }

    function calcCollectionTime() {
        if ($scope.duration) {
            var collection_time = $scope.config.control.getField('collection_time');
            collection_time.value = ($scope.duration > 0 && $scope.duration < 45)?45 - $scope.duration:0;
        }
    }

    function calcDuration(start, end) {
        var startTime = start || $scope.config.control.getField('startTime').value;
        var endTime = end || $scope.config.control.getField('endTime').value;
        if(startTime && endTime) {
            $scope.duration = endTime.getHours() * 60 + endTime.getMinutes() - startTime.getHours() * 60 - startTime.getMinutes();
        }
    }

    function startTimeChanged() {
        var start = $scope.config.control.getField('startTime');
        var end = $scope.config.control.getField('endTime');
        if (start.value && $scope.duration) {
            end.value = start.value.clone().addMinutes($scope.duration);
            calcCollectionTime();
        }
    }

    function endTimeChanged() {
        calcDuration();
        calcCollectionTime();
    }

    function changeBreak(field, initial) {
        $modal.open({
            templateUrl: 'views/addmodal.html',
            controller: 'BreakTimeCtrl',
            resolve: {
                options: function() {
                    var options = {value: field.value, type: 'date'};
                    if (initial) {
                        options.initial = initial;
                    }
                    return options;
                }
            }
        }).result.then(function(result) {
            field.value = result;
            if (field.change) {
                field.change();
            }
        }, function() {
            if (field.value == null) {
                var fields = $scope.config.control.getTab('Repetition').fields;
                fields.splice(fields.indexOf(field), 1);
            }
        });
    }

    function setWorkoutTypeDescriptionInfo() {
        var workoutType = _.findWhere($scope.config.control.getTab('General').fields, {name: 'WorkoutType'});
        var description = _.findWhere($scope.config.control.getTab('Booking').fields, {name: 'description'});
        if (workoutType && workoutType.value && workoutType.value.description) {
            description.hint = $filter('translate')('CURRENT_WORKOUTTYPE_DESCRIPTION_HINT').format(workoutType.value.description);
        } else {
            description.hint = '';
        }
    }

    function workoutTypeChanged() {
        setWorkoutTypeDescriptionInfo();
        let workoutType = $scope.config.control.getField('WorkoutType').value;
        if (workoutType) {
            let tags = $scope.config.control.getField('tags');
            tags.value = _.map(workoutType.tags, function(tag) { return _.findWhere($rootScope.systemtags, { id: tag.id }); });
        }

        if (workoutType.preset_duration && $scope.config.control.getField('startTime').value) {
            let value = $scope.config.control.getField('startTime').value.clone().addMinutes(workoutType.preset_duration);
            util.setValues([$scope.config.control.getField('endTime')], {endTime: value}, {callChange: true});
        }

        if (workoutType.preset_space) {
            util.setValues([$scope.config.control.getField('space')], {space: workoutType.preset_space}, {callChange: true});
        }

        if (workoutType.preset_staffs && workoutType.preset_staffs.length > 0) {
            util.setValues([$scope.config.control.getField('Staffs')], {Staffs: workoutType.preset_staffs}, {callChange: true});
        }

        if (workoutType.preset_resources && workoutType.preset_resources.length > 0) {
            util.setValues([$scope.config.control.getField('resources')], {resources: workoutType.preset_resources}, {callChange: true});
        }

        if (workoutType.preset_extra_title) {
            util.setValues([$scope.config.control.getField('extra_title')], {extra_title: workoutType.preset_extra_title}, {callChange: true});
        }
    }

    $scope.addBreak = function(value) {
        var fields = $scope.config.control.getTab('Repetition').fields;
        var changed = function() {
            var breaks = fields.filter(function(field) { return field.name == 'break'; });

            return !angular.equals(breaks.map(function(field) { return field.value; }), $scope.config.item.breaks);
        };
        var row = { name: 'break', title: $filter('translate')('BREAK').capitalize(), type: 'customobject', required: false, buttonTitle: 'Change', buttonClass: 'btn-warning', value: value, setValue: function() { return row.value; }, changed: changed };
        row.buttonClick = function() { changeBreak(row); };
        row.getName = function() {
            return formatter.format('datetimeshort', Date.newFull(row.value.from)) + ' - ' + formatter.format('datetimeshort', Date.newFull(row.value.to));
        };
        row.change = function() {
            if (row.value == null) {
                fields.splice(fields.indexOf(row), 1);
            }

            calcRepeat();
        };
        row.visible = function() {
            return $scope.config.control.getField('repeat').value;
        };

        var gp = _.findWhere(fields, {name: 'break_add'});
        var i = fields.indexOf(gp);
        fields.splice(i, 0, row);

        if (!value) {
            changeBreak(row, {from: $scope.config.control.getField('date').value, to: $scope.config.control.getField('until').value });
        }
    };

    $scope.addWorkoutCategory = function() {
        $modal.open({
            templateUrl: 'views/addmodal.html',
            controller: 'WorkoutCategoryAddCtrl'
        });
    };

    $scope.addWorkoutType = function() {
        util.showDataDialog({controller: 'WorkoutTypeDataCtrl', initial: {category_id: $scope.config.control.getField('category_id').value }}).result.then(addedWorkoutType => {
            let wt = $scope.config.control.getField('WorkoutType');
            util.waitForNewObject(addedWorkoutType.id, function(id) { return _.findWhere(wt.options(), {id: id}); }, 'workouttype').then(function(workouttype) {
                wt.value = workouttype;
            });
        });
    };

    var hasWorkoutCategory = function() {
        return !!$scope.config.control.getField('category_id').value;
    };

    $scope.config = _.deep_extend(options.config, {
        datatype: 'workout',
        url: {
            add: '/api/schedule/workout/add',
            change: '/api/schedule/workout/change'
        },
        tabs: [
            {
                name: 'General',
                fields: [
                    {name: 'category_id', title: 'Activity category', required: true, type: 'select', options: function() {return $rootScope.workoutcategories; }, optionsFilter: {active: true}, helpText: 'HELPTEXT_ACTIVITY_CATEGORY', placement:'bottom', noResultsText: 'Start by creating a category', addButtonClicked: $rootScope.currentStaff.allowCreateWorkoutType && $scope.addWorkoutCategory, addButtonTitle: 'New category' },
                    {name: 'site_id', title: 'Site', type: 'select', options: function() { return $rootScope.sites; }, required: true, visible: function() { return $rootScope.hasModule('MultiSite'); }, useId: true },
                    {name: 'WorkoutType', title: 'Workout type', required: true, type: 'select', options: getWorkoutTypes, addButtonClicked: $rootScope.currentStaff.allowCreateWorkoutType && $scope.addWorkoutType, visible: hasWorkoutCategory, addButtonTitle: 'New workout type', optionsFilter: filterWorkoutTypes, change: workoutTypeChanged, noResultsText: 'Add a new workout type', skipTranslation: true },
                    {name: 'extra_title', title: 'Type - complement', type: 'text', helpText: 'HELPTEXT_ACTIVITY_EXTRA_TITLE'},
                    {name: 'date', title: 'Date', required: true, type: 'date' },
                    {name: 'startTime', title: 'Start time', required: true, type: 'time', change: startTimeChanged },
                    {name: 'endTime', title: 'End time', required: true, type: 'time', change: endTimeChanged },
                    {name: 'collection_time', title: 'Collection time', required: false, type: 'infoNumber', info: 'minutes', visible: function() { return $rootScope.hasModule('LOK'); }, helpText: 'HELPTEXT_COLLECTION_TIME' },
                    {name: 'Staffs', title: 'Instructor', required: false, type: 'customers', itemTypes: ['staff'], useId: true },
                    {name: 'resources', title: 'Resources', required: false, type: 'customers', itemTypes: ['resource'], useId: true, helpText: 'HELPTEXT_RESOURCES' },
                    {name: 'note', title: 'Internal note', required: false, type: 'textarea' },
                    {name: 'video', title: 'Video activity', type: 'checkbox', helpText: 'HELPTEXT_VIDEO_WORKOUT' },
                    {name: 'video_url', title: 'Video link', type: 'url', visible: 'video' },
                    {name: 'auto_attendance', title: 'Auto attendance', type: 'checkbox', visible: function() { return $rootScope.hasModule('Attendance') && $scope.config.control.getField('video').value; } },
                    {name: 'tags', title: 'Tags', required: false, type: 'systemtag'}
                ]
            },
            {
                name: 'Booking',
                visible: function() { return $rootScope.hasModule('WorkoutBooking'); },
                fields: [
                    {name: 'space', title: 'Num places', required: false, type: 'number', min: 1, visible: function() { return $rootScope.hasModule('WorkoutBooking'); }, helpText: 'HELPTEXT_SPACE' },
                    {name: 'bookableForCustomer', title: 'Bookable for customer', type: 'checkbox', visible: function() { return $rootScope.hasModule('WorkoutBooking'); }, helpText: 'HELPTEXT_BOOKABLE_FOR_CUSTOMER', placement: 'bottom' },
                    {name: 'bookable_for_groups', title: 'Free booking for group(s)', required: false, type: 'groups', useId: true, visible: function() { return $rootScope.hasModule('WorkoutBooking') }, helpText: 'HELPTEXT_BOOKABLE_FOR_GROUPS' },
                    {name: 'description', title: 'Description', required: false, type: 'htmleditor', visible: showWorkout, hintClass: 'alert-info', hintCompact: true }
                ]
            },
            {
                name: 'Repetition',
                fields: [
                    { name: 'repeat', title: 'Repeat the activity', type: 'checkbox', change: calcRepeat},
                    { name: 'weekdays', title: 'Week days', type: 'multiselect', options: function() { return teamsportutil.weekdays_plural; }, useId: true, orderPredicate: 'id', visible: 'repeat', change: calcRepeat },
                    { name: 'interval', title: 'When', required: true, type: 'select', options: function(){return teamsportutil.intervals;}, useId: true, orderPredicate: 'id', visible: 'repeat', change: calcRepeat},
                    { name: 'until', title: 'Until2', required: true, type: 'date', visible: 'repeat', change: calcRepeat },
                    { name: 'break_add', type: 'button', buttonClass: 'btn-success', buttonTitle: $filter('translate')('Add') + ' ' + $filter('translate')('BREAK').toLowerCase(), click: function() { $scope.addBreak(); }, visible: 'repeat' },
                    { name: 'count', title: 'Number of workouts', readonly: true, type: 'label', visible: 'repeat'}
                ]
            }
        ],
        canSubmit: function() {
            if ($scope.config.control.getField('startTime').value.hhmm() >= $scope.config.control.getField('endTime').value.hhmm()) {
                return false;
            }
            var repeat = $scope.config.control.getField('repeat').value;
            if (repeat) {
                return $scope.config.control.getField('count').value > 0;
            }
            return true;
        },
        getSubmitItem: function(item) {
            var item = $scope.config.control.getSubmitItem();
            item.startTime = item.date + ' ' + item.startTime;
            item.endTime = item.date + ' ' + item.endTime;

            if (item.repeat) {
                item.dates = getRepeatDates();
            }

            if ($scope.force) {
                item.force = true;
            }

            return item;
        },
        init() {
            calcDuration(options.initial.startTime, options.initial.endTime);
            var date = options.initial.date;
            var initial_category = options.initial.category_id ||
                (options.initial.WorkoutType && _.findWhere($rootScope.workoutcategories, {id: options.initial.WorkoutType.category_id})) ||
                $filter('orderBy')($rootScope.workoutcategories.filter(function(c) { return c.active;}), 'order')[0];
            var daynr = date.getDay();
            if (daynr == 0) {
                daynr = 7;
            }
            if (!options.item) {
                return {
                    site_id: $rootScope.selectedSite,
                    category_id: initial_category,
                    bookableForCustomer: true,
                    weekdays: [daynr],
                    interval: 1,
                    until : options.initial.date.clone().addDays(7*10 - 1)
                };
            }
        },
        afterInit() {
            if ($scope.config.control.getField('WorkoutType').value) {
                // Make sure preset values are set
                workoutTypeChanged();
            }
        },
        submitFailed: function(data) {
            $scope.force = false;
            if (data.type == 'collision') {
                $rootScope.updatePointersById(data.staffs, $rootScope.staffs);
                var staffs = _.pluck(data.staffs, 'name').join(', ');
                var message = $filter('translate')(data.staffs.length == 1 ? 'ONEBUSY' : 'MANYBUSY').format(staffs);
                confirm.show(message).then(function() {
                    $scope.force = true;
                    $scope.config.control.submit();
                });
            } else {
                alertProvider.modal('Failed', 'Failed to add workout');
            }
        }
    });
}]);

app.controller('AddScheduleFromTemplateDataCtrl', ['$rootScope', '$scope', 'server', 'alertProvider', 'util', 'workoutProvider', 'options', function($rootScope, $scope, server, alertProvider, util, workoutProvider, options) {
    let loading = {
        from: null,
        to: null
    }

    let workoutsInPeriod;

    function workoutsEqual(x, w) {
        let wStartTime = Date.newFull(w.startTime);
        let wEndTime =  Date.newFull(w.endTime);
        let wStaffs = w.staffs || [];
        let wResources = w.resources || [];

        return Date.timeEquals(wStartTime, x.startTime) &&
            Date.timeEquals(wEndTime, x.endTime) &&
            wStartTime.getDay() == x.startTime.getDay() &&
            w.WorkoutType == x.workoutType.id &&
            util.arraysEqual(wStaffs, x.staffs.map(x => x.id)) &&
            util.arraysEqual(wResources, x.resources.map(x => x.id)) &&
            w.extra_title == x.extra_title &&
            w.space == x.space &&
            w.description == x.description &&
            w.note == x.note;
    }

    function hasNoDuplicate(w) {
        return !workoutsInPeriod.find(x => workoutsEqual(x, w));
    }

    function getWorkouts(item) {
        let result = [];

        let d = Date.newFull(item.from);
        const to = Date.newFull(item.to).clone().addDays(1);
        const base = Date.newFull('2024-01-01'); // This date is used because 1st of january is a monday

        // Calculate starting week offset based on how many complete weeks have passed since start
        let weeksSinceStart = 0;

        while (d < to) {
            const currentWeekday = d.getDay() || 7; // Convert getDay() (0=Sunday) to 1-7 where 1=Monday, 7=Sunday

            // Calculate which week in the template cycle we're in
            const templateWeekIndex = weeksSinceStart % item.template.weeks;

            // Calculate the template date: start of template week + current weekday - 1
            // This matches the same weekday in the corresponding template week
            const templateDayOffset = templateWeekIndex * 7 + (currentWeekday - 1);
            const wdate = base.clone().addDays(templateDayOffset);

            let workoutsForTemplateDay = item.template.workouts.filter(w => Date.dateEquals(Date.newFull(w.startTime), wdate));

            /* jshint loopfunc: true */
            workoutsForTemplateDay.forEach(w => {
                w = Object.assign({}, w);
                w.startTime = Date.newFull(w.startTime).changeDay(d).dateTime();
                w.endTime = Date.newFull(w.endTime).changeDay(d).dateTime();
                w.WorkoutType = w.workoutType.id;
                delete w.workoutType;
                w.Staffs = w.staffs;
                delete w.staffs;
                result.push(w);
            });

            // Move to next day, and check if we've completed a week (Sunday -> Monday)
            const wasOnSunday = currentWeekday === 7;
            d.addDays(1);
            if (wasOnSunday) {
                weeksSinceStart++;
            }
        }

        return result;
    }

    function fetchWorkoutsInPeriod() {
        let from = $scope.config.control.getField('from').value
        let to = $scope.config.control.getField('to').value
        if (!from || !to) {
            return;
        }

        loading.from = from;
        loading.to = to;
        workoutProvider.get(from, to).then(workouts => {
            if (loading.from != from || loading.to != to) {
                return;
            }
            loading.from = loading.to = null;
            workoutsInPeriod = workouts;
        })
    }

    $scope.config = _.deep_extend(options.config, {
        data: {
            templates: server.get('/api/schedule/template/get')
        },
        tabs: [
            {
                name: 'General',
                fields: [
                    {name: 'template', title: 'Template', type: 'select', required: true, options: () => $scope.config.data.templates},
                    {name: 'from', title: 'From date', type: 'date', required: true, change: fetchWorkoutsInPeriod},
                    {name: 'to', title: 'To date', type: 'date', required: true, change: fetchWorkoutsInPeriod},
                    {name: 'force', title: 'Ignore collisions', type: 'checkbox', helpText: 'Forcefully add schedule, ignoring scheduling collisions.'}
                ]
            }
        ],
        initCallChange: true,
        canSubmit() {
            return loading.from == null && loading.to == null;
        },
        beforeSubmit(item) {
            const force = $scope.config.control.getField('force').value;
            let toCreateWorkouts = getWorkouts(item).filter(hasNoDuplicate);

            let data = {
                api: '/api/schedule/workout/add',
                data: toCreateWorkouts.map(workout => ({workout, force}))
            }

            return server.post('/api/multi/call', data).then(result => {
                if (!result.success) {
                    alertProvider.modal('Add schedule from template', 'Failed to add workouts');
                    return;
                }

                let values = result.data;
                let success = values.filter(x => x.success).length;
                let failed = values.filter(x => !x.success).length;
                if (failed) {

                    let failedWorkouts = [];
                    for (let i=0; i < values.length; ++i) {
                        if (!values[i].success) {
                            const w = toCreateWorkouts[i];
                            const wtname = $rootScope.workouttypes.find(x => x.id == w.WorkoutType).name;
                            const time = w.startTime;
                            failedWorkouts.push(`${wtname} ${time}`);
                        }
                    }

                    alertProvider.modal('Add schedule from template', success + ' ' + util.t('activities were created') + '. ' + util.t('Failed to create') + ' ' + failed + ' ' + util.t('Activities').toLowerCase() + '<br><br>' + failedWorkouts.join('<br>'));
                } else {
                    alertProvider.modal('Add schedule from template', success + ' ' + util.t('activities were created'));
                }
            })
        }
    })
    $scope.config.title = 'Add schedule from template'
}]);

app.controller('CopyScheduleDataCtrl', ['$rootScope', '$scope', 'workoutProvider', 'util', 'server', 'alertProvider', 'options', function($rootScope, $scope, workoutProvider, util, server, alertProvider, options) {

    let loading = {
        from: null,
        to: null
    }

    let workoutsFrom;
    let workoutsFromFiltered;
    let toCopy;
    let workoutsTo;
    let toCreate;
    let toCreateWorkouts;

    function getNumWeeks() {
        return $scope.config.control.getField('repeat').value ? $scope.config.control.getField('num_weeks').value : 1;
    }

    function updateToCreate() {
        if (!workoutsTo || !workoutsFrom) {
            return;
        }
        const num_weeks = getNumWeeks();
        const to = $scope.config.control.getField('to').value;
        const allow_duplicates = $scope.config.control.getField('allow_duplicates').value;

        toCreate = 0
        toCreateWorkouts = []

        for (let i=0; i < num_weeks; ++i) {
            const monday = to.clone().monday().addDays(7*i);
            const week_nr = monday.getWeekNumber();

            /* jshint loopfunc: true */
            let canBeCopied = workoutsFromFiltered.filter(w => {
                let duplicate = workoutsTo.find(x => {
                    return x.startTime.getWeekNumber() == week_nr &&
                        Date.timeEquals(w.startTime, x.startTime) &&
                        Date.timeEquals(w.endTime, x.endTime) &&
                        w.startTime.getDay() == x.startTime.getDay() &&
                        w.workoutType.id == x.workoutType.id &&
                        util.arraysEqual(w.staffs.map(x => x.id), x.staffs.map(x => x.id)) &&
                        util.arraysEqual(w.resources.map(x => x.id), x.resources.map(x => x.id)) &&
                        w.extra_title == x.extra_title &&
                        w.bookableForCustomer == x.bookableForCustomer &&
                        w.space == x.space &&
                        w.description == x.description &&
                        w.note == x.note;
                })
                return allow_duplicates || !duplicate;
            })

            let newWorkouts = canBeCopied.map(w => {
                let day = w.startTime.getDay();
                day = day == 0 ? 6 : (day -1);
                let startTime = monday.clone().addDays(day);
                startTime.setHours(w.startTime.getHours(), w.startTime.getMinutes(),0,0);
                let endTime = monday.clone().addDays(day);
                endTime.setHours(w.endTime.getHours(), w.endTime.getMinutes(),0,0);

                return {
                    startTime: startTime.dateTime(),
                    endTime: endTime.dateTime(),
                    WorkoutType: w.workoutType.id,
                    bookable_for_groups: w.bookable_for_groups,
                    Staffs: w.staffs.map(x => x.id),
                    resources: w.resources.map(x => x.id),
                    space: w.space,
                    note: w.note,
                    description: w.description,
                    extra_title: w.extra_title,
                    video: w.video,
                    site_id: w.site_id,
                    tags: w.tags.map(x => x.id),
                    collection_time: w.collection_time,
                    auto_attendance: w.auto_attendance,
                    bookableForCustomer: w.bookableForCustomer
                };
            })
            toCreateWorkouts = toCreateWorkouts.concat(newWorkouts);

            toCreate += canBeCopied.length;
        }
    }

    function updateToCopy() {
        if (!workoutsFrom) {
            return;
        }
        let cats = $scope.config.control.getField('categories').value.map(x => x.id);
        let wtypes = $scope.config.control.getField('workoutTypes').value?.map(x => x.id);
        workoutsFromFiltered = workoutsFrom.filter(w => {
            return cats.includes(w.workoutType.category_id) && (!wtypes || !wtypes.length || wtypes.includes(w.workoutType.id));
        })
        toCopy = workoutsFromFiltered.length;
        updateToCreate();
    }

    function fetchFromWorkouts() {
        toCopy = '-';
        let from = $scope.config.control.getField('from').value
        if (!from || isNaN(from)) {
            return;
        }
        from = from.monday();
        let to = from.clone().addDays(6);

        toCopy = util.t('Loading') + '...';
        loading.from = from;
        workoutsFrom = null;
        workoutProvider.get(from, to).then(workouts => {
            if (loading.from != from) {
                return;
            }
            workoutsFrom = workouts;
            updateToCopy();
        })
    }

    function fetchToWorkouts() {
        toCreate = '-';
        let to = $scope.config.control.getField('to').value
        if (!to || isNaN(to)) {
            return;
        }

        let from = to.monday();
        const num_weeks = getNumWeeks();
        if (!num_weeks) {
            return;
        }
        to = from.clone().addDays((7 * num_weeks)  - 1);

        toCreate = util.t('Loading') + '...';
        loading.to = from;
        workoutsTo = null;
        workoutProvider.get(from, to).then(workouts => {
            if (loading.to != from) {
                return;
            }
            workoutsTo = workouts;
            updateToCreate();
        })
    }

    $scope.config = _.deep_extend(options.config, {
        tabs: [
            {
                name: 'General',
                fields: [
                    {name: 'from', title: 'Copy week', required: true, type: 'week', change: fetchFromWorkouts},
                    {name: 'to', title: 'To week', type: 'week', change: fetchToWorkouts},
                    {type: 'label', title: 'Activities to copy', getValue: () => toCopy},
                    {type: 'label', title: 'Activities to create', getValue: () => toCreate}
                ]
            },
            {
                name: 'Settings',
                fields: [
                    {name: 'repeat', title: 'Repeat', type: 'checkbox', change: fetchToWorkouts},
                    {name: 'num_weeks', type: 'infoNumber', min: 2, info: 'weeks', change: fetchToWorkouts, visible: 'repeat'},
                    {name: 'categories', title: 'Categories', type: 'multiselect', options: () => $rootScope.workoutcategories, optionsFilter: x => x.active, useId: true, change: updateToCopy },
                    {name: 'workoutTypes', title: 'Workout types', type: 'multiselect', options: () => $rootScope.workouttypes, optionsFilter: wt => {
                        let cats = $scope.config.control.getField('categories').value.map(cat => cat.id);
                        return wt.active && cats.includes(wt.category_id);
                    }, useId: true, placeholder: 'All', change: updateToCopy},
                    {name: 'allow_duplicates', title: 'Allow duplicates', type: 'checkbox', change: updateToCreate},
                    {name: 'force', title: 'If resource busy, add anyway', type: 'checkbox'},
                    {type: 'label', title: 'Activities to copy', getValue: () => toCopy},
                    {type: 'label', title: 'Activities to create', getValue: () => toCreate}
                ]
            }
        ],
        initCallChange: true,
        init() {
            return {
                repeat: false,
                num_weeks: 2,
                allow_duplicates: false,
                force: false,
                from: Date.today(),
                to: Date.today().addDays(7)
            }
        },
        canSubmit() {
            return !isNaN(toCreate) && toCreate > 0;
        },
        beforeSubmit() {
            let force = $scope.config.control.getField('force').value;

            let data = {
                api: '/api/schedule/workout/add',
                data: toCreateWorkouts.map(x => ({workout: x, force}))
            }

            return server.post('/api/multi/call', data).then(result => {
                if (!result.success) {
                    alertProvider.modal('Copy schedule', 'Failed to copy schedule');
                    return;
                }

                let values = result.data;
                let success = values.filter(x => x.success).length;
                let failed = values.filter(x => !x.success).length;
                if (failed) {

                    let failedWorkouts = [];
                    for (let i=0; i < values.length; ++i) {
                        if (!values[i].success) {
                            const w = toCreateWorkouts[i];
                            const wtname = $rootScope.workouttypes.find(x => x.id == w.WorkoutType).name;
                            const time = w.startTime;
                            failedWorkouts.push(`${wtname} ${time}`);
                        }
                    }

                    alertProvider.modal('Copy schedule', success + ' ' + util.t('activities were created') + '. ' + util.t('Failed to create') + ' ' + failed + ' ' + util.t('Activities').toLowerCase() + '<br><br>' + failedWorkouts.join('<br>'));
                } else {
                    alertProvider.modal('Copy schedule', success + ' ' + util.t('activities were created'));
                }
            })
        }
    });
    $scope.config.title = 'Copy schedule'
}]);

app.controller('CopyScheduleToTemplateDataCtrl', ['$rootScope', '$scope', 'workoutProvider', 'util', '$location', 'options', function($rootScope, $scope, workoutProvider, util, $location, options) {

    let loading = {
        from: null,
        to: null
    }

    let workoutsFrom;
    let workoutsFromFiltered;
    let toCopy;

    function updateToCopy() {
        if (!workoutsFrom) {
            return;
        }
        let cats = $scope.config.control.getField('categories').value.map(x => x.id);
        let wtypes = $scope.config.control.getField('workoutTypes').value?.map(x => x.id);
        workoutsFromFiltered = workoutsFrom.filter(w => {
            return cats.includes(w.workoutType.category_id) && (!wtypes || !wtypes.length || wtypes.includes(w.workoutType.id));
        })
        toCopy = workoutsFromFiltered.length;
    }

    function fetchFromWorkouts() {
        toCopy = '-';
        let from = $scope.config.control.getField('from').value
        if (!from || isNaN(from)) {
            return;
        }
        let to = $scope.config.control.getField('to').value
        if (!to || isNaN(to)) {
            return;
        }

        toCopy = util.t('Loading') + '...';
        loading.from = from;
        workoutsFrom = null;
        workoutProvider.get(from, to).then(workouts => {
            if (loading.from != from) {
                return;
            }
            workoutsFrom = workouts;
            updateToCopy();
        })
    }

    $scope.config = _.deep_extend(options.config, {
        url: {
            add: '/api/schedule/template/add'
        },
        tabs: [
            {
                name: 'General',
                fields: [
                    {name: 'from', title: 'From date', required: true, type: 'date', change: fetchFromWorkouts},
                    {name: 'to', title: 'To date', type: 'date', change: fetchFromWorkouts},
                    {name: 'name', title: 'To new template', type: 'text'},
                    {type: 'label', title: 'Activities to copy', getValue: () => toCopy},
                ]
            },
            {
                name: 'Settings',
                fields: [
                    {name: 'categories', title: 'Categories', type: 'multiselect', options: () => $rootScope.workoutcategories, optionsFilter: x => x.active, useId: true, change: updateToCopy },
                    {name: 'workoutTypes', title: 'Workout types', type: 'multiselect', options: () => $rootScope.workouttypes, optionsFilter: wt => {
                        let cats = $scope.config.control.getField('categories').value.map(cat => cat.id);
                        return wt.active && cats.includes(wt.category_id);
                    }, useId: true, placeholder: 'All', change: updateToCopy},
                    {type: 'label', title: 'Activities to copy', getValue: () => toCopy},
                ]
            }
        ],
        initCallChange: true,
        init() {
            return {
                from: Date.today(),
                to: Date.today().addDays(7)
            }
        },
        canSubmit() {
            return workoutsFromFiltered && workoutsFromFiltered.length;
        },
        getSubmitItem() {
            let item = $scope.config.control.getSubmitItem();
            let from = $scope.config.control.getField('from').value
            let firstMonday = from.clone().monday().clearTime();
            let base = Date.newFull('2024-01-01'); // This date is used because 1st of january is a monday
            item.weeks = Math.ceil(firstMonday.daysUntil($scope.config.control.getField('to').value) / 7);
            item.workouts = workoutsFromFiltered.map(w => {
                let days = firstMonday.daysUntil(Date.newFull(w.startTime).clearTime());
                let d = base.clone().addDays(days);
                let startTime = Date.newFull(w.startTime).changeDay(d)
                let endTime = Date.newFull(w.endTime).changeDay(d)
                return {
                    startTime: startTime.dateTime(),
                    endTime: endTime.dateTime(),
                    workoutType: {id: w.workoutType.id},
                    bookable_for_groups: w.bookable_for_groups,
                    staffs: w.staffs.map(x => x.id),
                    resources: w.resources.map(x => x.id),
                    space: w.space,
                    note: w.note,
                    description: w.description,
                    extra_title: w.extra_title,
                    video: w.video,
                    site_id: w.site_id,
                    tags: w.tags.map(x => x.id),
                    collection_time: w.collection_time,
                    auto_attendance: w.auto_attendance,
                    bookableForCustomer: w.bookableForCustomer
                }
            })

            return {
                name: item.name,
                weeks: item.weeks,
                workouts: item.workouts
            }
        }
    });
    $scope.config.title = 'Copy to template'

    let closeModal = $scope.config.afterSubmit;
    $scope.config.afterSubmit = function(template) {
        $location.path('/schedule/template/' + template.id);
        closeModal();
    }
}]);

app.controller('ScheduleCtrl', ['$rootScope', '$scope', '$filter', '$http', '$modal', '$controller', 'workoutProvider', 'alertProvider', 'confirm', 'server', 'calendar', '$routeParams', '$location', 'util', function($rootScope, $scope, $filter, $http, $modal, $controller, workoutProvider, alertProvider, confirm, server, calendar, $routeParams, $location, util) {
    $scope.title = 'Schedule';
    $scope.calendarConfig = calendar.getDefaultConfig();
    $scope.calendarConfig.eventClick = function(calEvent) {
        if (calEvent.isAnnotation) {
            return;
        }
        $rootScope.showWorkout(calEvent);
    };

    $scope.form = {};

    $scope.pubsub('tabChanged', function(tab) {
        if (tab == 'calendar') {
            util.waitFor($scope, () => $scope.calendarConfig?.calendarObject).then(function() {
                util.waitForVisible($scope.calendarConfig.calendarObject).then(function() {
                    calendar.render($scope.calendarConfig);
                });
            });
        }
    }, true);

    function setSelectedCategory() {
        $rootScope.waitFor(['workoutcategories', 'sites']).then(function() {
            var active = $filter('orderBy')($rootScope.workoutcategories.filter(function(c) { return c.active && c.sites.indexOf($rootScope.selectedSite.id) != -1; }), 'order');
            if (active.length) {
                var activeCategory = _.findWhere(active, {id: Number($routeParams.categoryId)});
                $scope.form.selectcategory = activeCategory || active[0];
                $scope.setCategory();
            }
        });
    }
    setSelectedCategory();

    $scope.calendarConfig.viewRender = function(view) {
        if (calendar.viewChanged($scope, view, $scope.calendarConfig)) {
            $scope.getWorkouts();
        }
    };

    var lastClickTime = new Date().getTime();
    $scope.calendarConfig.dayClick = function(date) {
        var thisClickTime = new Date().getTime();
        var timeSinceLastClick = thisClickTime - lastClickTime;
        lastClickTime = thisClickTime;

        if (timeSinceLastClick < 300) {
            // Double click
            var endTime = date.clone().addMinutes(60);
            util.showDataDialog({controller: 'WorkoutDataCtrl', initial: {date: date, startTime: date, endTime: endTime, category_id: $scope.selectcategory}});
        }
    };

    function sendMessage(workout) {
        var doSend = function() {
            $modal.open({
                templateUrl: 'views/message.html',
                controller: 'WorkoutChangeMessageCtrl',
                resolve: {
                    workout: function() {
                        return workout;
                    }
                }
            });
        };

        if (workout.bookings.length) {
            doSend();
        } else {
            server.get('/api/workoutBooking/invites/get', {workout_id: workout.id}).then(function(invited) {
                if (invited.length) {
                    doSend();
                }
            });
        }
    }

    $scope.calendarConfigEditable = {};
    angular.extend($scope.calendarConfigEditable, $scope.calendarConfig);
    $scope.calendarConfigEditable.editable = true;
    $scope.calendarConfigEditable.droppable = true;
    $scope.calendarConfigEditable.minTime = undefined;
    $scope.calendarConfigEditable.maxTime = undefined;
    $scope.calendarConfigEditable.defaultEventMinutes = 60;
    $scope.calendarConfigEditable.eventDrop = function(event) {
        var data = {id: event.id, startTime: event.start.dateTime(), endTime: event.end.dateTime()};
        $http.post('/api/schedule/workout/change', data).success(function () {
            alertProvider.show('success', 'Workout moved');
            sendMessage(event);
        }).error(function () {
            alertProvider.show('error', 'Failed to move workout');
            // FIXME... Don't update model
        });
    };

    $scope.calendarConfigEditable.eventResize = function(event) {
        var data = {id: event.id, startTime: event.start.dateTime(), endTime: event.end.dateTime()};
        $http.post('/api/schedule/workout/change', data).success(function () {
            alertProvider.show('success', 'Workout changed length');
            sendMessage(event);
        }).error(function () {
            alertProvider.show('error', 'Failed to change length of workout');
            // FIXME... Don't update model
        });
    };

    $scope.calendarConfigEditable.drop = function(date, allDay, jsEvent) {
        var workoutType = angular.element(jsEvent.target).scope().workoutType;
        var endTime = date.clone().addMinutes(60);
        util.showDataDialog({controller: 'WorkoutDataCtrl', initial: {date: date, startTime: date, endTime: endTime, WorkoutType: workoutType}});
    };

    $scope.calendarConfigEditable.zoom = () => $scope.calendarConfigEditable.slotMinutes = $scope.calendarConfigEditable.slotMinutes == 30 ? 10 : 30;

    $scope.applyCategoryFilter = function(workouts) {
        if(!$scope.selectcategory) {return [];}
        return workouts.filter(function(w) { return w.workoutType.category_id == $scope.selectcategory.id; });
    };

    $scope.getWorkouts = function() {
        if(!$scope.visStart || !$scope.visEnd) {return;}

        if ($scope.selectcategory && $rootScope.hasModule('MultiSite') && $scope.selectcategory.sites.indexOf($rootScope.selectedSite.id) == -1) {
            $location.path('/');
            return;
        }

        $rootScope.waitFor(['sites']).then(function() {
            workoutProvider.get($scope.visStart.yyyymmdd(), $scope.visEnd.clone().addDays(-1).yyyymmdd()).then(function(workouts) {
                workouts = $scope.applyCategoryFilter(workouts);
                calendar.adjustMinMax($scope.calendarConfig, workouts);
                $scope.eventSources[0] = workouts;
            });
        });
    };

    $scope.setCategory = function() {
        $scope.selectcategory = $scope.form.selectcategory;
        $scope.getWorkouts();
        $scope.pubsub.publish('selectedWorkoutCategory', $scope.selectcategory);
        $scope.title = util.t('Schedule') + ' - ' + $scope.selectcategory.name;
    };

    $scope.eventSources = [[]];

    var removeWorkoutsChange = $rootScope.$on('workoutsChanged', function () {
        $scope.getWorkouts();
    });

    // TODO:  duplicated
    $scope.change = function(workout) {
        $modal.open({
            templateUrl: 'views/changemodal.html',
            controller: 'WorkoutChangeModalCtrl',
            resolve: {
                workout: function() {
                    return workout;
                }
            }
        });
    };

    $scope.cancel = function(workout) {
        $modal.open({
            templateUrl: 'views/cancelworkout.html',
            controller: 'CancelWorkoutCtrl',
            resolve: {
                workout: function() {
                    return workout;
                }
            }
        });
    };

    $scope.remove = function(workout) {
        $rootScope.removeWorkout(workout);
    };

    $scope.add = function(workout) {
        $modal.open({
            templateUrl: 'views/bookingadd.html',
            controller: 'WorkoutBookingAddModalCtrl',
            windowClass: 'huge-modal-window',
            resolve: {
                workout: function() {
                    return workout;
                }
            }
        });
    };

    $scope.addFromTemplate = function() {
        util.showDataDialog({
            controller: 'AddScheduleFromTemplateDataCtrl',
            initial: {
                from: $scope.visStart,
                to: $scope.visEnd.clone().addDays(-1)
            }
        })
    };

    $scope.copy = function() {
        util.showDataDialog({controller: 'CopyScheduleDataCtrl', initial: {
            categories: [$scope.selectcategory.id],
            from: $scope.visStart,
            to: $scope.visStart.clone().addDays(7)
        } });
    };

    $scope.copyToTemplate = function() {
        util.showDataDialog({controller: 'CopyScheduleToTemplateDataCtrl', initial: {
            categories: [$scope.selectcategory.id],
            from: $scope.visStart,
            to: $scope.visEnd.clone().addDays(-1),
            name: util.t('Copy of') + ' ' + util.t('week') + ' ' + $scope.visStart.getWeekNumber()
        } });
    };

    $scope.clearSchedule = function() {
        let ids = $scope.eventSources[0].filter(w => w.start.withinRange($scope.visStart, $scope.visEnd) && w.bookings.length == 0 && !w.courses
        .length).map(w => w.id);
        if (ids.length) {
            confirm.show(util.t('Are you sure you want to remove {0} workouts?').format(ids.length)).then(() => {
                let id = ids[0];
                let similar = ids.slice(1);
                server.post('/api/schedule/workout/remove', similar, {id});
            })
        } else {
            alertProvider.modal('Clear schedule', 'There are no workouts which can be removed')
        }
    };

    $scope.workoutTypeForCurrentSite = function(wt) {
        return !$rootScope.hasModule('MultiSite') || ($rootScope.selectedSite && wt.sites && wt.sites.indexOf($rootScope.selectedSite.id) != -1);
    };

    $scope.categoryForCurrentSite = function(category) {
        return category.active && (!$rootScope.hasModule('MultiSite') || ($rootScope.selectedSite && category.sites.indexOf($rootScope.selectedSite.id) != -1));
    };

    $scope.buttons = [
        {visible: function() {return $rootScope.hasPermission('Schedule handling');}, imageSrc: function() { return '/assets/img/change.png'; }, onClick: $scope.change, tooltip: 'Change details' },
        {visible: function(workout) {return $rootScope.hasPermission('Schedule handling') && workout.status != 'Cancelled';}, imageSrc: function() { return '/assets/img/cancel.png'; }, onClick: $scope.cancel, tooltip: 'Cancel workout' },
        {visible: $rootScope.canAddBooking, imageSrc: function() { return '/assets/img/activate.png'; }, onClick: $scope.add, tooltip: 'Add booking' },
        {visible: function(workout) {return $rootScope.hasPermission('Schedule handling') && workout.bookings.length == 0;}, imageSrc: function() { return '/assets/img/remove.png'; }, onClick: $scope.remove, tooltip: 'Remove' }
    ];

    var removeTranslateChangeSuccess = $rootScope.$on('$translateChangeSuccess', function () {
        calendar.updateTranslation([$scope.calendarConfig, $scope.calendarConfigEditable]);
    });

    $scope.$on('$destroy', function () {
        removeTranslateChangeSuccess();
        removeWorkoutsChange();
    });

    $scope.pubsub('selectedSite', function() {
        setSelectedCategory();
    });

    var debouncedRenderCalendar = _.debounce(function() {
        calendar.render($scope.calendarConfig);
        calendar.render($scope.calendarConfigEditable);
    }, 50);

    $scope.$on('workoutRecalculated', (_, workout) => {
        if ($scope.eventSources[0].find(x => x.id == workout.id)) {
            debouncedRenderCalendar();
        }
    })

    calendar.updateTranslation([$scope.calendarConfig, $scope.calendarConfigEditable]);
}]);

app.controller('ScheduleTemplateListCtrl', ['$rootScope', '$scope', '$location', 'server', 'confirm', function($rootScope, $scope, $location, server, confirm) {

    function remove(t) {
        confirm.show('Are you sure you want to remove the template?').then(() => {
            server.post('/api/schedule/template/remove', null, {id: t.id}, 'Schedule template removed', 'Failed to remove schedule template');
        })
    }

    function gotoTemplate(t) {
        $location.path('/schedule/template/' + t.id )
    }

    $scope.config = {
        api: {
            url: '/api/schedule/template/get',
            triggers: [
                {type: 'scheduletemplate'}
            ]
        },
        countSuffixList: ['template', 'templates'],
        columns: [
            {field: 'name', title: 'Name'},
            {field: 'weeks', title: 'Num weeks', showSum: false },
            {field: 'workouts', title: 'Number of workouts', getValue: w => w.workouts.length, showSum: false }
        ],
        buttons: [
            { title: 'Change', buttonClass: 'btn-warning', onClick: gotoTemplate, visible: () => $rootScope.hasPermission('Schedule handling') },
            { title: 'Remove', buttonClass: 'btn-danger', onClick: remove, visible: () => $rootScope.hasPermission('Schedule handling') }
        ],
        rowClick: gotoTemplate,
        searchButtons: [
            { title: 'Create new template', onClick: () => $location.path('/schedule/template/new'), visible: () => $rootScope.hasPermission('Schedule handling'), showOnEmpty: true }
        ]
    }

}]);

app.controller('ScheduleTemplateCtrl', ['$rootScope', '$scope', 'calendar', '$filter', '$modal', 'util', 'server', 'confirm', '$routeParams', '$location', function($rootScope, $scope, calendar, $filter, $modal, util, server, confirm, $routeParams, $location) {

    $scope.week = 1;
    $scope.form = {
        defaultWorkoutType: null
    };
    $scope.loadingStatus = {
        initial: false
    };
    $scope.selectedTemplate = {
        name: '',
        weeks: 1,
        workouts: []
    };

    $scope.canChange = ()  => $rootScope.hasPermission('Schedule handling');

    const base = Date.newFull('2024-01-01'); // This date is used because 1st of january is a monday

    $scope.fields = [
        {name: 'name', title: 'Name', type: 'text', required: true, placeholder: 'Enter template name', readonly: !$scope.canChange() },
        {name: 'weeks', title: 'Num weeks', type: 'number', required: true, min: 1, max: 10, change: () => $scope.weeksChanged(), value: 1, readonly: !$scope.canChange() }
    ];
    $scope.hideRequired = true;
    $scope.hideSubmitButton = true;

    $scope.clearSchedule = () => {
        let events = $scope.eventSources[0];
        if (events.length) {
            confirm.show(util.t('Are you sure you want to remove {0} workouts?').format(events.length)).then(() => {
                $scope.eventSources[0] = [];
            })
        }
    };

    $scope.getTitle = function(name) {
        if (name) {
            var fields = $scope.getFields ? $scope.getFields() : $scope.fields;
            var field = _.findWhere(fields.filter(function(f) { return !f.visible || f.visible(); }), {name: util.getRealFormName(name)});
            return field && field.title;
        }
    };

    $scope.weeksChanged = function() {
        let days = $scope.fields.find(x => x.name == 'weeks').value * 7;
        let limitDate = base.clone().addDays(days);
        $scope.eventSources[0] = $scope.eventSources[0].filter(x => x.start < limitDate);
        if ($scope.week > $scope.getNumWeeks()) {
            $scope.week = $scope.getNumWeeks();
        }
    };

    $scope.getNumWeeks = function() {
        return $scope.fields.find(x => x.name == 'weeks').value;
    }

    function setDate() {
        let date = base.clone().addDays(7 * ($scope.week - 1));
        $('.calendar').fullCalendar('gotoDate', date);
    }

    $scope.next = function() {
        $scope.week += 1;
        setDate()
    }
    $scope.prev = function() {
        $scope.week -= 1;
        setDate()
    }

    function workoutToEvent(w) {
        let wt = $rootScope.workouttypes.find(x => x.id == w.workoutType.id);
        // Handle both staffs (lowercase) and Staffs (capital, from modal)
        let staffs = w.staffs || w.Staffs || [];
        return {
            start: Date.newFull(w.startTime),
            end: Date.newFull(w.endTime),
            backgroundColor: wt.color,
            canRemove: $scope.canChange(),
            title: wt.name + (w.extra_title ? (' - ' + w.extra_title) : ''),
            subTitle: staffs.map(s => {
                if (s?.name) return s.name;
                let id = s?.id ?? s;
                if (id) return $rootScope.getMember(id)?.name;
                return null;
            }).filter(Boolean).join(", ") || '',
            workout: Object.assign({}, w)
        };
    }

    $scope.submit = function() {
        let data = Object.assign({}, util.getSubmitItem($scope.fields));
        data.id = $scope.selectedTemplate.id;
        data.workouts = $scope.eventSources[0].map(x => x.workout)
        $scope.loadingStatus.loading = true;
        server.post($scope.selectedTemplate.id ? '/api/schedule/template/change' : '/api/schedule/template/add', data).then(result => {
            $scope.loadingStatus.loading = false;
            if (result.success) {
                $scope.selectedTemplate = result.data;
                $scope.setTemplate();
            }
        })
    };

    $scope.saveCopy = function() {
        if ($scope.selectedTemplate.name == $scope.fields.find(x => x.name == 'name').value) {
            $scope.fields.find(x => x.name == 'name').value = util.t('Copy of') + ' ' + $scope.selectedTemplate.name;
        }
        $scope.selectedTemplate.id = null;
        $scope.submit();
    };

    $scope.setTemplate = function() {
        // Transform staff IDs to objects (like transformWorkout does)
        ($scope.selectedTemplate.workouts || []).forEach(w => {
            if (w.staffs) {
                for (let i = 0; i < w.staffs.length; ++i) {
                    w.staffs[i] = $rootScope.getMember(w.staffs[i]);
                }
            }
        });
        $scope.eventSources[0] = ($scope.selectedTemplate.workouts || []).map(workoutToEvent)
        $scope.week = 1;
        util.setValues($scope.fields, $scope.selectedTemplate, {callChange: true});
        if ($scope.selectedTemplate.id) {
            $location.path('/schedule/template/' + $scope.selectedTemplate.id)
        }
    }

    // Re-render events when ApiDataLoader loads data (for staff names in speedy mode)
    let deregisterApiDataLoaded = $rootScope.$on('ApiDataLoaded', () => {
        if ($scope.eventSources[0]?.length) {
            $scope.eventSources[0] = $scope.eventSources[0].map(e => {
                // Refresh staff objects from getMember to get updated names
                if (e.workout.staffs) {
                    e.workout.staffs = e.workout.staffs.map(s =>
                        $rootScope.getMember(s?.id ?? s)
                    );
                }
                return workoutToEvent(e.workout);
            });
        }
    });
    $scope.$on('$destroy', deregisterApiDataLoaded);

    $scope.valuesChanged = function() {
        let e = $scope.eventSources[0].map(x => x.workout)
        return !$scope.selectedTemplate.id || $scope.fields.some(f => util.valueChanged(f, $scope.selectedTemplate)) || !util.arraysEqual(e, $scope.selectedTemplate.workouts);
    }

    $scope.setCategory = function() {
        $scope.selectcategory = $scope.form.selectcategory;
        $scope.pubsub.publish('selectedWorkoutCategory', $scope.selectcategory);
        $scope.title = util.t('Schedule') + ' - ' + $scope.selectcategory.name;
        if (!$scope.form.defaultWorkoutType || $scope.form.defaultWorkoutType.category_id != $scope.selectcategory.id) {
            let types = $rootScope.workouttypes.filter(x => x.active && x.category_id == $scope.selectcategory.id);
            $scope.form.defaultWorkoutType = types[0];
        }
    };

    function setSelectedCategory() {
        $rootScope.waitFor(['workoutcategories', 'sites']).then(function() {
            var active = $filter('orderBy')($rootScope.workoutcategories.filter(function(c) { return c.active && c.sites.indexOf($rootScope.selectedSite.id) != -1; }), 'order');
            if (active.length) {
                $scope.form.selectcategory = active[0];
                $scope.setCategory();
            }
        });
    }
    setSelectedCategory();

    $scope.calendarConfig = calendar.getDefaultConfig();
    $scope.calendarConfigEditable = {};
    angular.extend($scope.calendarConfigEditable, $scope.calendarConfig);
    $scope.calendarConfigEditable.editable = $scope.canChange();
    $scope.calendarConfigEditable.droppable = $scope.canChange();
    $scope.calendarConfigEditable.minTime = undefined;
    $scope.calendarConfigEditable.maxTime = undefined;
    $scope.calendarConfigEditable.header = null;
    $scope.calendarConfigEditable.columnFormat.week = 'dddd';
    $scope.calendarConfigEditable.year = 2024; // This date is used because 1st of january is a monday
    $scope.calendarConfigEditable.month = 0;
    $scope.calendarConfigEditable.date = 1;
    $scope.calendarConfigEditable.defaultEventMinutes = 60;
    $scope.calendarConfigEditable.slotMinutes = 30;

    $scope.zoom = function () {
        $scope.calendarConfigEditable.slotMinutes = $scope.calendarConfigEditable.slotMinutes === 30 ? 5 : 30;
    };

    $scope.calendarConfigEditable.eventClick = function(calEvent) {
        let workout = Object.assign({}, calEvent.workout);
        $rootScope.transformWorkout(workout);
        if (workout.bookableForCustomer === undefined) {
            workout.bookableForCustomer = true;
        }
        $modal.open({
            templateUrl: 'views/changemodal.html',
            controller: 'WorkoutChangeModalCtrl',
            resolve: {
                workout: () => workout,
                options: () => ({returnResult: true, hideDate: true, canRemove: $scope.canChange(), canChange: $scope.canChange()})
            }
        }).result.then(changed => {
            if ($scope.canChange()) {
                if (changed.removed) {
                    $scope.eventSources[0] = $scope.eventSources[0].filter(x => x != calEvent);
                } else {
                    Object.assign(calEvent, workoutToEvent(changed));
                    calendar.render($scope.calendarConfigEditable);
                }
            }
        })
    };

    $scope.eventSources = [[]];

    $scope.calendarConfigEditable.eventDrop = function(event) {
        event.workout.startTime = event.start.dateTime();
        event.workout.endTime = event.end.dateTime();
    };

    $scope.calendarConfigEditable.eventAfterRender = function(event, element) {
        $(element).find('.fc-event-remove').click(clickEvent => {
            clickEvent.stopPropagation();
            $rootScope.$apply(() => {
                $scope.eventSources[0] = $scope.eventSources[0].filter(x => x != event);
            });
        })
    }

    function addWorkout(date, workoutType) {
        let endTime = date.clone().addMinutes(workoutType.preset_duration || $scope.calendarConfigEditable.defaultEventMinutes);
        let workout = {
            startTime: date.dateTime(),
            endTime: endTime.dateTime(),
            workoutType: {
                id: workoutType?.id
            },
            staffs: (workoutType?.preset_staffs || []).map(s => $rootScope.getMember(s) || s),
            resources: (workoutType?.preset_resources || []).map(s => $rootScope.getMember(s)),
            tags: [],
            space: workoutType.preset_space,
            extra_title: workoutType.preset_extra_title
        };
        let event = workoutToEvent(workout);

        $scope.eventSources[0].push(event);
        // This is to prevent render bug. Change is not detected when adding single event
        $scope.eventSources[0] = $scope.eventSources[0].concat();
        $scope.form.defaultWorkoutType = workoutType;
    }

    $scope.calendarConfigEditable.drop = function(date, allDay, jsEvent) {
        let workoutType = angular.element(jsEvent.target).scope().workoutType;
        addWorkout(date, workoutType);
    };

    $scope.calendarConfigEditable.dayClick = function(date) {
        if ($scope.canChange()) {
            addWorkout(date, $scope.form.defaultWorkoutType);
        }
    };

    $scope.calendarConfigEditable.eventResize = function(event) {
        event.workout.startTime = event.start.dateTime();
        event.workout.endTime = event.end.dateTime();
    };

    var removeTranslateChangeSuccess = $rootScope.$on('$translateChangeSuccess', function () {
        calendar.updateTranslation([$scope.calendarConfig, $scope.calendarConfigEditable]);
    });

    $scope.$on('$destroy', function () {
        removeTranslateChangeSuccess();
    });

    calendar.updateTranslation([$scope.calendarConfig, $scope.calendarConfigEditable]);

    if (!isNaN($routeParams.templateId)) {
        $scope.loadingStatus.initial = true;
        server.get('/api/schedule/template/get', {id: $routeParams.templateId}).then(t => {
            $scope.selectedTemplate = t;
            $scope.setTemplate();
            $scope.loadingStatus.initial = false;
        })
    }
}]);

app.controller('CancelWorkoutCtrl', ['$rootScope', '$scope', '$filter', 'workout', 'server', function($rootScope, $scope, $filter, workout, server) {
    $scope.loadingStatus = {};

    $scope.getDefaultMessage = function() {
        return $filter('translate')('SMSCANCEL').format(workout.workoutType.name, workout.startTime.dateTime());
    };

    $scope.showMessage = function() {
        return workout.bookings.length && workout.startTime > new Date();
    };

    $scope.getBookingsWithSeat = function() {
        return _.filter(workout.bookings, function(booking) {
            return !booking.inQueue;
        });
    };

    $scope.getInfoText = function() {
        return $filter('translate')('WORKOUT_CANCEL').format($scope.getBookingsWithSeat().length);
    };

    $scope.fields = [
        {name: 'message', title: 'Message', type: 'textarea', visible: $scope.showMessage, value: $scope.getDefaultMessage() }
    ];

    $scope.submit = function() {
        $scope.loadingStatus.loading = true;
        var data = { id: workout.id, status: 'Cancelled' };
        if ($scope.showMessage()) {
            data.cancelmessage = _.findWhere($scope.fields, {name: 'message'}).value;
        }
        server.post('/api/schedule/workout/change', data, null, 'Workout was cancelled', 'Failed to cancel workout').then(function(result) {
            if (result.success) {
                $scope.$close();
                return;
            }
            $scope.loadingStatus.loading = false;
        });
    };

}]);

app.controller('SMSModalCtrl', ['$rootScope', '$scope', 'recipient', 'server', function($rootScope, $scope, recipient, server) {
    $scope.title = 'Send SMS';

    $scope.loadingStatus = {};

    $scope.submit = function(message) {
        $scope.loadingStatus.loading = true;
        var message = _.findWhere($scope.fields, {name: 'message'}).value;
        var member_id = (recipient.isMember && recipient.id) || null;
        var staff_id = (!recipient.isMember && recipient.id) || null;
        var recipients = [ { phone: recipient.phone, member_id: member_id, staff_id: staff_id } ];
        server.post('/api/sms/send', {recipients: recipients, text: message}, null, 'SMS sent', 'Failed to send SMS').then(function() {
            $scope.$close();
            $scope.loadingStatus.loading = false;
        });
    };

    $scope.fields = [
        {name: 'phone', title: 'Phone', required: true, type: 'text', readonly: true, value: recipient.phone },
        {name: 'message', title: 'Message', required: true, type: 'textarea' }
    ];
}]);

app.controller('SMSMultiModalCtrl', ['$rootScope', '$scope', '$filter', 'sendlist', 'server', 'formatter', 'util', function($rootScope, $scope, $filter, sendlist, server, formatter, util) {
    $scope.title = 'Send SMS';

    var peopleWithPhone = _.filter(sendlist, function(item) { return item.phone && item.phone.length > 0; });

    $scope.loadingStatus = {};

    $scope.submit = function(message) {
        $scope.loadingStatus.loading = true;
        var message = _.findWhere($scope.fields, {name: 'message'}).value;
        var recipients = [];
        angular.forEach(peopleWithPhone, function(item) {
            var r = { phone: item.phone };
            if (item.isMember) {
                r.member_id = item.id;
            } else {
                r.staff_id = item.id;
            }
            recipients.push(r);
        });
        server.post('/api/sms/send', {recipients: recipients, text: message}, null, 'SMS sent', 'Failed to send SMS').then(function() {
            $scope.$close();
            $scope.loadingStatus.loading = false;
        });
    };

    $scope.getTitle = function(name) {
        if (name) {
            return _.findWhere($scope.fields, {name: $rootScope.getRealFormName(name)}).title;
        }
    };

    $scope.getRecipientsValue = function() {
        var res = peopleWithPhone.length  + ' ' + $filter('translate')('recipients');
        if (peopleWithPhone.length < sendlist.length) {
            res += ' (' + $filter('translate')('of') + ' ' + sendlist.length + ' )';
        }
        return res;
    };

    $scope.sendDisabled = function() {
        return peopleWithPhone.length == 0;
    };

    $scope.fields = [
        {name: 'phone', title: 'Recipients', required: true, type: 'text', readonly: true, value: $scope.getRecipientsValue() },
        {name: 'message', title: 'Message', required: true, type: 'textarea', maxlength: 304 }
    ];

    // calc sms
    function price(x) {
        return formatter.format('price', x);
    }

    $scope.smscalc = {};
    var recalcSms = _.debounce(function(text) {
        var smsCapacity = util.calcSmsCapacity(text);
        if (smsCapacity) {
            _.findWhere($scope.fields, { name: 'message', type: 'textarea' }).maxlength = smsCapacity * 2;
        }
        var numberPeople = peopleWithPhone.length;
        if(!text || !numberPeople) {
            $scope.smscalc = {};
            return;
        }
        server.post2('/api/sms/calc', {text: text}).then(function(response) {
            var totalSmsCount = response.count * numberPeople;
            var totalSmsCost = price(response.total * numberPeople);

            $scope.smscalc.result = $filter('translate')('Number of SMS: {count}, cost: {cost}').replace('{count}', totalSmsCount).replace('{cost}', totalSmsCost);
            $scope.smscalc.title = $filter('translate')('{symbols} symbols ({capacity} symbols per sms), {smsPerPerson} sms x {person} customers x {cost} = {totalAmount}').
                replace('{symbols}', text.length).
                replace('{capacity}', response.capacity).
                replace('{smsPerPerson}', response.count).
                replace('{person}', numberPeople).
                replace('{cost}', price(response.cost)).
                replace('{totalAmount}', totalSmsCost);
        });
    }, 1000);

    $scope.$watch(function() {return _.findWhere($scope.fields, {name: 'message'}).value;}, function(text) {
        if(text) {
            recalcSms(text);
        } else {
            $scope.smscalc = {};
        }
    });

}]);

app.controller('MailMultiModalCtrl', ['$rootScope', '$scope', '$filter', '$http', 'sendlist', 'server', function($rootScope, $scope, $filter, $http, sendlist, server) {
    $scope.title = 'Send mail';
    var peopleWithMail = _.filter(sendlist, function(item) { return item.mail && item.mail.length > 0; });
    $scope.loadingStatus = {};

    $scope.submit = function(message) {
        $scope.loadingStatus.loading = true;
        var members = _.pluck(peopleWithMail.filter(function(item) { return item.isMember; }), 'id');
        var staffs = _.pluck(peopleWithMail.filter(function(item) { return !item.isMember; }), 'id');
        var others = [];

        var message = _.findWhere($scope.fields, {name: 'message'}).value;
        var from = _.findWhere($scope.fields, {name: 'from'}).value;
        var subject = _.findWhere($scope.fields, {name: 'subject'}).value;
        var replyTo = _.findWhere($scope.fields, {name: 'replyTo'}).value;
        var mail = {members: members, staffs: staffs, others: others, message: message, from: from, subject: subject, replyTo: replyTo};

        server.post('/api/mail/send', mail, null, 'Mail sent', 'Failed to send mail').then(function() {
            $scope.$close();
            $scope.loadingStatus.loading = false;
        });
    };

    $scope.getRecipientsValue = function() {
        var res = peopleWithMail.length  + ' ' + $filter('translate')('recipients');
        if (peopleWithMail.length < sendlist.length) {
            res += ' (' + $filter('translate')('of') + ' ' + sendlist.length + ' )';
        }
        return res;
    };

    $scope.sendDisabled = function() {
        return peopleWithMail.length == 0;
    };

    $http.get('/api/settings/get').success(function(settings) {
        if (settings.mail) {
            var field = _.findWhere($scope.fields, {name: 'replyTo'});
            if (!field.value) {
                field.value = settings.mail;
            }
        }
    });

    $scope.getTitle = function(name) {
        if (name) {
            return _.findWhere($scope.fields, {name: $rootScope.getRealFormName(name)}).title;
        }
    };

    $scope.fields = [
        {name: 'mails', title: 'Recipients', required: true, type: 'text', readonly: true, value: $scope.getRecipientsValue() },
        {name: 'from', title: 'From', required: true, type: 'text' },
        {name: 'replyTo', title: 'Reply to address', required: true, type: 'email' },
        {name: 'subject', title: 'Subject', required: true, type: 'text' },
        {name: 'message', title: 'Message', required: true, type: 'htmleditor' }
    ];

    $scope.sendDisabled = function() {
        var message = _.findWhere($scope.fields, {name: 'message'}).value;
        return message === undefined;
    };

    _.findWhere($scope.fields, {name: 'from'}).value = $rootScope.currentStaff.firstname + ' ' + $rootScope.currentStaff.lastname;
}]);

app.controller('MemberMessageHistoryModalCtrl', ['$rootScope', '$scope', '$location', '$modal', 'util', 'member', function($rootScope, $scope, $location, $modal, util, member) {
    $scope.member = member;

    function gotoJournal() {
        $location.path('/customer/journal/' + $scope.member.id);
        $scope.$close();
    }

    function sendMailing() {
        $scope.pubsub.publish('newmailingdata', {
            isNewsOrAdvertising: false,
            sendOption: 'mail',
            receivers: [$scope.member],
            options: { 'callCloseOnSuccess': true, 'modalMode': false, noRedirect: true }
        });
        $modal.open({
            templateUrl: 'views/mailingnew.html',
            windowClass: 'huge-modal-window',
            controller: 'NewMailingCtrl'
        }).result.then($scope.$close);
    }

    function formatType(message) {
        switch(message.type) {
            case 'mail':
                return util.t('Mail');
            case 'sms':
                return util.t('SMS');
            case 'push':
                return util.t('Push notification');
            default:
                return util.t('Other');
        }
    }

    $scope.config = {
        api: {
            url: '/api/member/messages/get',
            args: {
                id: $scope.member.id,
                fromDate: new Date().addMonths(-36).dateTime(),
                triggers: [
                    {type: 'mail'},
                    {type: 'sms'},
                    {type: 'userpushnotification'},
                    {type: 'mailing'}
                ]
            },
            transform: function(message) {
                message.sent = Date.newFull(message.sent);
                return message;
            }
        },
        countSuffixList: ['message', 'messages'],
        searchButtons: [
            { title: 'Show customer journal', buttonClass: 'btn-success', onClick: gotoJournal },
            { title: 'Send mailing', buttonClass: 'btn-primary', onClick: sendMailing }
        ],
        columns: [
            {field: 'sent', title: 'Sent', format: 'datetime'},
            {field: 'type', title: 'Type', getValue: formatType},
            {field: 'subject', title: 'Subject'},
            {field: 'message', title: 'Message', getValue: function(m) { return m.message.length > 100 ? (m.message.substring(0, 100) + '...') : m.message; }, showHtml: false}
        ],
        buttons: [
            {title: 'Preview', buttonClass: 'btn-info', onClick: function(message) { $rootScope.previewTemplate(message.message, formatType(message.type), true); } }
        ]
    };
}]);

app.controller('WorkoutChangeMessageCtrl', ['$rootScope', '$scope', '$filter', '$http', 'workout', 'server', function($rootScope, $scope, $filter, $http, workout, server) {
    $scope.title = 'Send message';
    $scope.loadingStatus = {};

    var sendlist = [];
    var peopleWithMail;
    var peopleWithPhone;

    $scope.submit = function() {
        if (_.findWhere($scope.fields, {name: 'sms'}).value) {
            var message = _.findWhere($scope.fields, {name: 'message_sms'}).value;
            var recipients = [];
            angular.forEach(peopleWithPhone, function(item) {
                var r = { phone: item.phone };
                if (item.isMember) {
                    r.member_id = item.id;
                } else {
                    r.staff_id = item.id;
                }
                recipients.push(r);
            });
            server.post('/api/sms/send', {recipients: recipients, text: message}, null, 'SMS sent', 'Failed to send SMS').then(function(result) {
                if (result.success) {
                    $scope.$close();
                } else {
                    $scope.loadingStatus.loading = false;
                }
            });
        } else {
            var members = _.pluck(peopleWithMail.filter(function(item) { return item.isMember; }), 'id');
            var staffs = _.pluck(peopleWithMail.filter(function(item) { return !item.isMember; }), 'id');
            var others = [];

            var message = _.findWhere($scope.fields, {name: 'message_mail'}).value;
            var from = _.findWhere($scope.fields, {name: 'from'}).value;
            var subject = _.findWhere($scope.fields, {name: 'subject'}).value;
            var replyTo = _.findWhere($scope.fields, {name: 'replyTo'}).value;
            var mail = {members: members, staffs: staffs, others: others, message: message, from: from, subject: subject, replyTo: replyTo};

            server.post('/api/mail/send', mail, null, 'Mail sent', 'Failed to send mail').then(function(result) {
                if (result.success) {
                    $scope.$close();
                } else {
                    $scope.loadingStatus.loading = false;
                }
            });
        }
    };

    $scope.getRecipientsValue = function() {
        var sms = _.findWhere($scope.fields, {name: 'sms'});
        if (!sms) {
            return;
        }
        if (sms.value) {
            var res = peopleWithPhone.length  + ' ' + $filter('translate')('recipients');
            if (peopleWithPhone.length < sendlist.length) {
                res += ' (' + $filter('translate')('of') + ' ' + sendlist.length + ' )';
            }
            return res;
        } else {
            var res = peopleWithMail.length  + ' ' + $filter('translate')('recipients');
            if (peopleWithMail.length < sendlist.length) {
                res += ' (' + $filter('translate')('of') + ' ' + sendlist.length + ' )';
            }
            return res;
        }
    };

    $scope.sendDisabled = function() {
        return peopleWithMail.length == 0;
    };

    $http.get('/api/settings/get').success(function(settings) {
        if (settings.mail) {
            var field = _.findWhere($scope.fields, {name: 'replyTo'});
            if (!field.value) {
                field.value = settings.mail;
            }
        }
    });

    $scope.getTitle = function(name) {
        if (name) {
            return _.findWhere($scope.fields, {name: $rootScope.getRealFormName(name)}).title;
        }
    };

    function isSms() {
        return _.findWhere($scope.fields, {name: 'sms'}).value;
    }

    function isMail() {
        return !isSms();
    }

    function getBookingsWithSeat() {
        var limit = workout.space ? workout.space : workout.bookings.length;
        return workout.bookings.slice(0, limit);
    }

    function getQueue() {
        var limit = workout.space ? workout.space : workout.bookings.length;
        return workout.bookings.slice(limit);
    }

    $scope.invited = [];
    server.get('/api/workoutBooking/invites/get', {workout_id: workout.id}).then(function(invited) {
        invited.forEach($rootScope.transformInvitation);
        $scope.invited = invited;
    });

    function getInvited() {
        return $scope.invited;
    }

    function setSendList() {
        var list = _.pluck(getBookingsWithSeat(), 'user');
        if (_.findWhere($scope.fields, {name: 'queue'}).value) {
            list.push.apply(list, _.pluck(getQueue(), 'user'));
        }
        if (_.findWhere($scope.fields, {name: 'invited'}).value) {
            list.push.apply(list, _.pluck(getInvited(), 'user').filter(function(iu) { return !_.findWhere(list, {id: iu.id}); }) );
        }
        sendlist = list;
        peopleWithMail = _.filter(sendlist, function(item) { return item.mail && item.mail.length > 0; });
        peopleWithPhone = _.filter(sendlist, function(item) { return item.phone && item.phone.length > 0; });
        _.findWhere($scope.fields, {name: 'recipients'}).value = $scope.getRecipientsValue();
    }

    $scope.fields = [
        {name: 'sms', title: 'SMS', required: true, type: 'checkbox', value: false, visible: function() { return $rootScope.hasPermission('Send SMS'); } },
        {name: 'queue', title: 'Include persons in queue', required: true, type: 'checkbox', change: setSendList, visible: function() { return getQueue().length; }  },
        {name: 'invited', title: 'Include invited persons', required: true, type: 'checkbox', change: setSendList, visible: function() { return getInvited().length; } },
        {name: 'recipients', title: 'Recipients', required: true, type: 'text', readonly: true },
        {name: 'from', title: 'From', required: true, type: 'text', visible: isMail },
        {name: 'replyTo', title: 'Reply to address', required: true, type: 'email', visible: isMail },
        {name: 'subject', title: 'Subject', required: true, type: 'text', visible: isMail },
        {name: 'message_mail', title: 'Message', required: true, type: 'htmleditor', visible: isMail },
        {name: 'message_sms', title: 'Message', required: true, type: 'textarea', visible: isSms }
    ];

    _.findWhere($scope.fields, {name: 'from'}).value = $rootScope.currentStaff.firstname + ' ' + $rootScope.currentStaff.lastname;
    setSendList();
}]);

app.controller('WorkoutModalCtrl', ['$rootScope', '$scope', 'workout', '$modal','$controller', '$http', '$filter', 'pdf', 'workoutProvider', 'server', 'confirm', '$location', 'eventlog', 'Link',
    function($rootScope, $scope, workout, $modal, $controller, $http, $filter, pdf, workoutProvider, server, confirm, $location, eventlog, Link) {
    $scope.workout = workout;
    $scope.loadingStatus = {};

    workoutProvider.getWorkoutById(workout.id).then(function(w) {
        $scope.workout = workout = w;
    });

    $scope.getDateTitle = function() {
        var workout = $scope.workout;
        if (workout.startTime) {
            return workout.startTime.yyyymmdd() + ", " + workout.startTime.hhmm() + " - " + workout.endTime.hhmm();
        }
    };

    $scope.getTitle = function() {
        if(!workout || !workout.workoutType) {return;}
        var title = workout.workoutType.name;
        if(workout.extra_title) {
            title += ' - ' + workout.extra_title;
        }
        return title;
    };

    $scope.getBookingsWithSeat = function() {
        return _.filter($scope.workout.bookings, function(booking) {
            return !booking.inQueue;
        });
    };

    $scope.getQueue = function() {
        return _.filter($scope.workout.bookings, function(booking) {
            return booking.inQueue;
        });
    };

    $scope.showQueue = function() {
        var bookingsInQueue = _.filter($scope.workout.bookings, function(booking) {
            return booking.inQueue;
        });
        return $rootScope.hasModule('Queue') && bookingsInQueue.length > 0;
    };

    // TODO: duplicated
    $scope.change = function() {
        $modal.open({
            templateUrl: 'views/changemodal.html',
            controller: 'WorkoutChangeModalCtrl',
            resolve: {
                workout: function() {
                    return workout;
                }
            }
        });
    };

    $scope.cancel = function() {
        $modal.open({
            templateUrl: 'views/cancelworkout.html',
            controller: 'CancelWorkoutCtrl',
            resolve: {
                workout: function() {
                    return $scope.workout;
                }
            }
        });
    };

    $scope.showAttendance = function() {
        var workoutId = $scope.workout && $scope.workout.id || '';
        $location.path('/attendance/show/' + workoutId);
        $scope.$dismiss();
    };

    $scope.remove = function() {
        $scope.loadingStatus.removing = true;
        $rootScope.removeWorkout(workout).then(function() {
            $scope.loadingStatus.removing = false;
            $scope.$close();
        }, function() {
            $scope.loadingStatus.removing = false;
        });
    };

    $scope.print = function() {
        pdf.load().then(function() {
            var doc = new PDFDocument();
            var stream = doc.pipe(blobStream());

            doc.fontSize(28);
            doc.text(workout.workoutType.name + ' ' + $rootScope.getWorkoutDate(workout) + ' ' + $rootScope.getWorkoutTime(workout), 20, 20);

            doc.moveDown();
            doc.fontSize(10);

            var y;
            for (var i=0; i < workout.bookings.length; ++i) {
                var b = workout.bookings[i];

                y = doc.y;
                if (y > 700) {
                    doc.addPage();
                    y = 20;
                }

                doc.text(b.user.name, 20, y);
            }

            doc.end();

            stream.on('finish', function() {
                var filename = workout.workoutType.name + '_' + workout.startTime.dateTime() + '.pdf';
                pdf.download(stream, filename);
            });
        });
    };

    $scope.removeBooking = function(customerOrWb) {
        var customer = customerOrWb.user || customerOrWb;
        var workoutBooking = _.findWhere(workout.bookings, {user: customer});
        confirm.show('Are you sure you want to remove the booking?', {ladda: true}).then(function(resolve) {
            server.post('/api/workoutBooking/remove', null, {workoutBooking: workoutBooking.id}, 'Booking removed', 'Failed to remove booking').then(resolve);
        });
    };

    $scope.add = function() {
        $modal.open({
            templateUrl: 'views/bookingadd.html',
            controller: 'WorkoutBookingAddModalCtrl',
            windowClass: 'huge-modal-window',
            resolve: {
                workout: function() {
                    return workout;
                }
            }
        });
    };

    $scope.openLogs = function() {
        eventlog.openDialog({
            filter: new Link('workout', Number($scope.workout.id)),
            noPeriod: true,
            hideFilter: true
        });
    };

    $scope.closeAndGotoCustomer = function(customer) {
        $scope.$close();
        $rootScope.gotoCustomer(customer);
    };

    $scope.showExtraInfo = function(resource) {
        $modal.open({
            templateUrl: 'views/infomodal.html',
            controller: 'ModalCtrl',
            resolve: {
                options: function() {
                    return {title: 'Extra information', content: resource.extraInfo};
                }
            }
        });
    }

    $scope.closeAndGotoStaff = function(staff) {
        $scope.$close();
        $rootScope.gotoStaff(staff);
    };

    $scope.debts = [];
    var getDebts = function() {
        if (!$scope.workout || !$scope.workout.bookings.length) { return; }
        var ids = _.pluck($scope.workout.bookings, 'user_id');
        server.get('/api/member/debt/details', { ids: ids }).then(function(debts) {
            $scope.debts = debts;
            $scope.bookedConfig.control.update();
        });
    };
    $scope.$watch('workout.bookings.length', getDebts);

    $scope.getRowClass = function(wb) {
        if (!wb || !wb.user) {
            return '';
        }

        var debt = _.findWhere($scope.debts, { id: wb.user_id });
        return (debt && debt.amount > 0) ? 'danger' : 'success';
    };

    $scope.sendMailing = function(items) {
        $scope.pubsub.publish('newmailingdata', {
            isNewsOrAdvertising: false,
            sendOption: 'mail',
            receivers: items,
            options: { 'callCloseOnSuccess': true, 'modalMode': false }
        });
        $modal.open({
            templateUrl: 'views/mailingnew.html',
            windowClass: 'huge-modal-window',
            controller: 'NewMailingCtrl'
        });
    };

    $scope.isBooked = function(wbi) {
        return !!_.find($scope.workout.bookings, function(wb) {
            return wbi.user ? wb.user_id == wbi.user.id : wb.user.mail == wbi.mail;
        });
    };

    $scope.bookedConfig = {
        getItems: $scope.getBookingsWithSeat,
        triggers: ['workout', 'workoutbooking', 'user'],
        countSuffixList: ['booking', 'GENERAL_BOOKINGS'],
        searchDepth: 2,
        rowClick: function(wb) {
            $scope.closeAndGotoCustomer(wb.user);
        },
        rowClass: $scope.getRowClass,
        getCustomer: function(row) {
            return row && row.user;
        },
        columns: [
            {field: 'image', src: function(wb) { return $rootScope.smallMemberImage(wb.user); } },
            {field: 'user.name', title: 'Name', getValue: function(wb) { return wb.reserved ? $filter('translate')('Reservation') : wb.user?.name;  } },
            {field: 'present', title: 'Present', format: 'bool' }
        ],
        buttons: [
            {title: 'CANCEL_BOOKING', buttonClass: 'btn-danger', visible: function(wb) { return $rootScope.hasPermission('Workout booking') && !wb.reserved; }, onClick: $scope.removeBooking }
        ],
        searchButtons: [
            {title: 'Send mailing', onClick: function() { $scope.sendMailing(_.pluck($scope.bookedConfig.getItems(), 'user'), 'mail'); }, visible: function() {return $rootScope.hasPermission('Mailing handling');} },
        ]
    };

    $scope.queueConfig = {
        getItems: function() {
            return _.pluck($scope.getQueue(), 'user');
        },
        countSuffixList: ['booking', 'GENERAL_BOOKINGS'],
        searchDepth: 2,
        rowClick: $scope.closeAndGotoCustomer,
        columns: [
            {field: 'image', src: $rootScope.smallMemberImage },
            {field: 'name', title: 'Name' }
        ],
        buttons: [
            {title: 'Remove booking', buttonClass: 'btn-danger', visible: function() { return $rootScope.hasPermission('Workout booking'); }, onClick: $scope.removeBooking }
        ],
        searchButtons: [
            {title: 'Send mailing', onClick: function() { $scope.sendMailing($scope.queueConfig.getItems(), 'mail'); }, visible: function() {return $rootScope.hasPermission('Mailing handling');} },
        ]
    };

    function getStatusText(wbi) {
        var status = $scope.isBooked(wbi) ? 'accepted' : wbi.status;
        var s = {'declined': 'Declined', 'accepted': 'Accepted', 'opened': 'Read invitation'}[status];
        if (s) {
            return $filter('translate')(s);
        }
    }

    function invite() {
        $modal.open({
            templateUrl: 'views/addmodal.html',
            controller: 'InviteAddModalCtrl',
            resolve: {
                workout: function() {
                    return workout;
                },
                invites: function() {
                    return $scope.inviteConfig.control.getItems();
                }
            }
        });
    }

    $scope.inviteConfig = {
        api: {
            url: '/api/workoutBooking/invites/get',
            args: {
                workout_id: workout.id
            },
            triggers: [
                {
                    type: 'workoutbookinginvite',
                    condition: function(wbi) {
                        return wbi.workout_id == workout.id; }
                },
                {
                    type: 'workoutbooking',
                    condition: function(wb) {
                        return wb.workout == workout.id; }
                }
            ],
            transform: $rootScope.transformInvitation
        },
        countSuffixList: ['invite', 'invites'],
        columns: [
            {field: 'image', src: function(wbi) { return $rootScope.smallMemberImage(wbi.user); } } ,
            {field: 'user.name', title: 'Name', getValue: function(x) { return x.user ? x.user.name : x.mail;  } },
            {field: 'status', title: 'Status', getValue: getStatusText}
        ],
        searchDepth: 2,
        searchButtons: [
            {title: 'Send invitation', buttonClass: 'btn-success', onClick: invite}
        ],
        buttons: [
           {title: 'Book', buttonClass: 'btn-success', visible: function(invite) { return invite.user && !$scope.isBooked(invite) && $rootScope.hasPermission('Workout booking'); }, onClick: function(invite) { $rootScope.makeWorkoutBooking(invite.user, $scope.workout); } }
        ]
    };
}]);

app.controller('WorkoutBookingAddModalCtrl', ['$rootScope', '$scope', '$filter', '$modal', 'workout', 'server', 'alertProvider', 'util', 'confirm', function($rootScope, $scope, $filter, $modal, workout, server, alertProvider, util, confirm) {
    $scope.workout = workout;
    var loadingStatus = { booking: {}};

    $scope.getDateTitle = function() {
        var workout = $scope.workout;
        return workout.startTime.yyyymmdd() + ", " + workout.startTime.hhmm() + " - " + workout.endTime.hhmm();
    };

    $scope.notBooked = function(customer) {
        return !_.findWhere($scope.workout.bookings, {user_id: customer.id});
    };

    $scope.book = function(customer) {
        $rootScope.makeWorkoutBooking(customer, $scope.workout);
        $scope.tableConfig.searchText = '';
    };

    $scope.$watch('workout.bookings.length', () => {
        $scope.tableConfig?.control?.update?.();
    });

    $scope.showInitialSearchHelp = function() {
        return $rootScope.speedy && !$scope.tableConfig.filter.find(x => x.name == 'query').value;
    };

    function bookGroup(bookingData, report) {
        var data;
        var loadingId;
        if (bookingData.constructor === Array) {
            data = {workout: workout.id, member_list: bookingData};
            loadingId = report.id;
            loadingStatus.booking[loadingId] = true;
        } else {
            data = {group_id: bookingData.id, workout: workout.id};
            loadingId = bookingData.id;
            loadingStatus.booking[loadingId] = true;
        }
        server.post('/api/workoutBooking/add', data).then(function(result) {
            loadingStatus.booking[loadingId] = false;
            if (!result.success) {
                alertProvider.show('error', 'Failed to add booking');
                return;
            }
            var success;
            if (result.data.success.length) {
                success = $filter('translate')('{0} persons booked').format(result.data.success.length);
            }
            var failed;
            var failedUsers;
            if (result.data.failed.length) {
                failed = $filter('translate')('Failed to add booking for the following {0} persons').format(result.data.failed.length);
                failedUsers = [];
                result.data.failed.forEach(function(u) {
                    var user = $rootScope.getMember(u);
                    failedUsers.push(user || {name: $filter('translate')('Anonymous'), id: u});
                });
            }

            var alreadybooked;
            if (result.data.alreadybooked.length) {
                alreadybooked = $filter('translate')('{0} persons were already booked').format(result.data.alreadybooked.length);
            }

            $modal.open({
                templateUrl: 'views/groupbookingdone.html',
                controller: 'ModalCtrl',
                resolve: {
                    options: function() {
                        return {title: 'Booking completed', success: success, failed: failed, failedUsers: failedUsers, alreadybooked: alreadybooked };
                    }
                }
            });
        });
    }

    function getReport(report) {
        server.post('/api/stats/generic', {report_id: report.id, include_id: false }).then((res) => {
            if (!workout.space || (res?.data?.row_count && res?.data?.row_count < workout.space - workout.bookings.length)) {
                var message = $filter('translate')('Do you want to book {0} customers?').format(res.data.row_count);
                confirm.show(message).then(function() {
                    const userIds = res?.data?.data?.map((r) => r.id);
                    bookGroup(userIds, report);
                });
            } else if (!res?.data?.row_count) {
                alertProvider.show('error', 'Report contains no customers');
            } else {
                alertProvider.show('error', 'Report contains more customers than the workout has available space for');
            }
        })
    }

    function changeGroup(group) {
        util.showDataDialog({controller: 'UserGroupDataCtrl', item: group });
    }

    $scope.groupConfig = {
        getItems: function() {
            return $rootScope.usergroups;
        },
        triggers: ['usergroup'],
        countSuffixList: ['group', 'groups'],
        rowClick: bookGroup,
        orderColumn: 'name',
        columns: [
            {field: 'name', title: 'Name'},
            {field: 'users', title: 'Number of persons', getValue: function(g) { return g.users.length; }, visible: () => !$rootScope.speedy},
            {field: 'user_count', title: 'Number of persons', visible: () => $rootScope.speedy},
        ],
        buttons: [
            {title: 'Book', onClick: bookGroup, loading: function(group) { return loadingStatus.booking[group.id]; } },
            {title: 'Change', buttonClass: 'btn-warning', onClick: changeGroup}
        ]
    };

    if ($rootScope.speedy) {
        $scope.tableConfig = {
            tableLimit: 10,
            tableNumPages: 5,
            filter: [
                {name: 'sites', title: 'Sites', required: false, type: 'multiselect', visible: function() { return $rootScope.hasModule('MultiSite'); }, options: function() { return $rootScope.sites; }, useId: true, placeholder: 'All', value: $rootScope.limitStaffSiteAccess && $rootScope.selectedSite ? [$rootScope.selectedSite] : [] },
                {name: 'query', title: 'Search', required: true, type: 'text'},
            ],
            filterButtons: [
                { title: 'Add new customer', onClick: () => $rootScope.showCombo({workout}) }
            ],
            hideSearch: true,
            api: {
                url: '/api/search',
                post: true,
                args: {
                    types: [{type: 'user', searchFields: ['name', 'mail', 'phone', 'firstname', 'lastname', 'personalCodeNumber', 'memberNumber', 'card.cardId', 'oldphone', 'city', 'address', 'zipCode'], resultFields: ['id', 'name', 'imageurl', 'imagekey', 'mail', 'phone']}],
                    limit: 20
                },
                getItemsFromResponse: response => response.data.find(x => x.type == 'user').items
            },
            hideSearchCount: true,
            countSuffixList: ['customer', 'customers'],
            showSum: false,
            columns: [
                { field: 'image', title: '' },
                { field: 'name', title: 'Name' },
                { field: 'mail', title: 'E-mail', visible: function(config) { return config.name != 'Choose resource' && !$rootScope.isSmallScreen(); } },
                { field: 'phone', title: 'Phone', visible: function(config) { return config.name != 'Choose resource' && $(window).width() >= 1200; } },
                { field: 'memberNumber', title: 'Member number', visible: function(config) { return $rootScope.hasMemberNumber && config.name != 'Choose resource'; } }
            ],
            orderColumn: 'name',
            buttons: [
                { title: 'Book', onClick: $scope.book },
            ],
            searchButtons: [
                { title: 'Add new customer', onClick: function() { $rootScope.showCombo({workout: workout}); } }
            ],
            itemFilters: [
                $scope.notBooked
            ],
            onSearchFieldEnter: function(config) {
                var filtered = config.control.getFilteredItems();
                if (filtered.length == 1) {
                    $scope.book(filtered[0]);
                }
            }
        };

        delete $scope.groupConfig.triggers;
        delete $scope.groupConfig.getItems;
        $scope.groupConfig.api = {
            url: '/api/search',
            post: true,
            args: {
                types: [{type: 'usergroup', searchFields: ['name'], resultFields: ['id', 'name', 'imagekey', 'change_permission', 'user_count']}],
                limit: 20
            },
            getItemsFromResponse: response => response.data.find(x => x.type == 'usergroup').items
        };
        $scope.groupConfig.filter = [
            {name: 'query', title: 'Search', required: false, type: 'text', hint: 'A selection is shown below, search to find among multiple results' }
        ];
        $scope.groupConfig.hideSearch = true;
    } else {
        $scope.tableConfig = {
            tableLimit: 5,
            tableNumPages: 5,
            triggers: ['user', 'image', 'workoutbooking'],
            getItems: function() {
                return $rootScope.members;
            },
            columns: [
                {field: 'image', title: '' },
                {field: 'name', title: 'Name'},
                {field: 'mail', title: 'E-mail', visible: function() { return !$rootScope.isSmallScreen(); } },
                {field: 'phone', title: 'Phone', visible: function() { return !$rootScope.isSmallScreen(); } },
                {field: 'memberNumber', title: 'Member number', visible: function() { return $rootScope.hasMemberNumber; } }
            ],
            buttons: [
                { title: 'Book', onClick: $scope.book }
            ],
            searchButtons: [
                { title: 'Add new customer', onClick: function() { $rootScope.showCombo({workout: workout}); } }
            ],
            searchFields: $rootScope.getCustomerProperties(),
            hideSearchCount: true,
            itemFilters: [
                function(u) { return u.type == 'user'; },
                $scope.notBooked
            ],
            onSearchFieldEnter: function(config) {
                var filtered = config.control.getFilteredItems();
                if (filtered.length == 1) {
                    $scope.book(filtered[0]);
                }
            }
        };
        if($rootScope.hasModule('MultiSite') && $rootScope.sites.length > 1) {
            $scope.tableConfig.filterSite = {
                list: $rootScope.sites,
                value: $rootScope.selectedSite,
                onChange: function() {
                    $scope.tableConfig.control.update();
                }
            };
            $scope.tableConfig.itemFilters.push(function(u) {
                var sites = u.sites.concat(u.homesite_id).filter(function(x) { return !!x; });
                return !$scope.tableConfig.filterSite.value || sites.indexOf($scope.tableConfig.filterSite.value.id) !== -1;
            });
        }
    }

    $scope.reportConfig = {
        getItems: function() {
            return $rootScope.reports.filter((r) => r.data?.reporttype == 'list' && r.data?.datatype == 'user');
        },
        countSuffixList: ['report', 'reports'],
        showSum: false,
        columns: [
            {field: 'name', title: 'Report', getValue(r) { return $filter('translate')(r.data.name); }},
        ],
        rowClick: getReport,
        orderColumn: 'name',
        buttons: [
            { title: 'Book', onClick: getReport, loading: function(report) { return loadingStatus.booking[report.id]; } },
        ]
    }
}]);

app.controller('WorkoutChangeModalCtrl', ['$rootScope', '$scope', 'workout', '$modal', '$controller', '$http', '$filter', '$timeout', 'server', 'confirm', 'alertProvider', 'options', function($rootScope, $scope, workout, $modal, $controller, $http, $filter, $timeout, server, confirm, alertProvider, options) {
    $controller('ChangeModalCtrl', {$scope: $scope});

    $scope.workout = workout;
    $scope.item = $scope.workout;
    $scope.postUrl = '/api/schedule/workout/change';
    options = options || {};

    if (options.canRemove) {
        $scope.showRemoveButton = () => true;
        $scope.removeButtonClicked = () => {
            if (options.returnResult) {
                $scope.$close({removed: true});
            }
        }
    }


    $scope.titleSuffix = function() {
        if (options.hideDate) {
            return $scope.workout.workoutType.name + ", " + $scope.workout.startTime.hhmm() + " - " + $scope.workout.endTime.hhmm();
        } else {
            return $scope.workout.workoutType.name + ", " + $scope.workout.startTime.yyyymmdd() + ", " + $scope.workout.startTime.hhmm() + " - " + $scope.workout.endTime.hhmm();
        }
    };

    $scope.canSubmit = function() {
        if (options && options.canChange === false) {
            return false;
        }
        return _.findWhere($scope.fields, {name: 'startTime'}).value.hhmm() < _.findWhere($scope.fields, {name: 'endTime'}).value.hhmm();
    };

    function sendMessage(workout) {
        var doSend = function() {
            $modal.open({
                templateUrl: 'views/message.html',
                controller: 'WorkoutChangeMessageCtrl',
                resolve: {
                    workout: function() {
                        return workout;
                    }
                }
            });
        };
        if (workout.startTime >= Date.now()) {
            if (workout.bookings.length) {
                doSend();
            } else {
                server.get('/api/workoutBooking/invites/get', {workout_id: workout.id}).then(function(invited) {
                    if (invited.length) {
                        doSend();
                    }
                });
            }
        }
    }

    var setLoadingDone = function() {
        $scope.loadingStatus.loading = false;
    };

    $scope.submit = function() {
        $scope.loadingStatus.loading = true;
        var item = $scope.getSubmitItem();
        if (options.hideDate) {
            item.startDate = $scope.workout.startTime.yyyymmdd();
        }
        item.startTime = item.startDate + ' ' + item.startTime;
        item.endTime = item.startDate + ' ' + item.endTime;
        delete item.startDate;

        if (options.returnResult) {
            item.workoutType = {id: item.workoutType.id};
            $scope.$close(item);
            return;
        }

        item.WorkoutType = item.workoutType;
        delete item.workoutType;

        item.Staffs = item.staffs;
        // FIXME: For some reason a null is added to the Staffs list
        if (item.Staffs.length > 0 && item.Staffs[item.Staffs.length-1] == null) {
            item.Staffs.splice(item.Staffs.length-1, 1);
        }
        delete item.staffs;

        var params = {};
        if (item.alsoChange) {
            if (item.alsoChange.indexOf($scope.all) != -1) {
                item.alsoChange = $scope.similar.slice(1);
            }

            item.alsoChange = _.pluck(item.alsoChange, 'id');
        }

        server.post($scope.postUrl, item, params).then(function(result) {
            if (result.success) {
                alertProvider.show('success', 'Workout changed');
                $scope.$close();
                sendMessage($scope.workout);
            } else if (result.data.type === 'collision') {
                $rootScope.updatePointersById(result.data.staffs, $rootScope.staffs);
                var staffs = _.pluck(result.data.staffs, 'name').join(', ');
                var message = $filter('translate')(result.data.staffs.length == 1 ? 'ONEBUSY' : 'MANYBUSY').format(staffs);
                confirm.show(message, {ladda: true}).then(function(resolve) {
                    params.force = true;
                    server.post($scope.postUrl, item, params, 'Workout changed', 'Failed to change workout').then(function(result) {
                        resolve();
                        if (result.success) {
                            $scope.$close();
                            sendMessage($scope.workout);
                        } else {
                            setLoadingDone();
                        }
                    });
                }, setLoadingDone);
            } else {
                setLoadingDone();
                alertProvider.show('error', 'Failed to change workout');
            }
        });
    };

    $scope.all = { startDate: new Date(0) };

    $scope.onChangeSimilar = function(newNames, oldNames) {
        if (newNames && newNames.indexOf($scope.all) != -1 && (!oldNames || oldNames.indexOf($scope.all) == -1)) {
            var field = _.findWhere($scope.fields, {name: 'alsoChange'});
            $timeout(function() {
                field.value = [$scope.all];
            });
        }
    };

    function showWorkout() {
        var wt = _.findWhere($scope.fields, {name: 'workoutType'}).value;
        if (!wt || !wt.show) {
            return false;
        }

        var category = _.findWhere($rootScope.workoutcategories, {id: wt.category_id});
        return category && category.show;
    }

    function calcDuration() {
        var startTime = _.findWhere($scope.fields, {name: 'startTime'}).value;
        var endTime = _.findWhere($scope.fields, {name: 'endTime'}).value;
        if(startTime && endTime) {
            $scope.duration = endTime.getHours() * 60 + endTime.getMinutes() - startTime.getHours() * 60 - startTime.getMinutes();
        }
    }

    function startTimeChanged() {
        var start = _.findWhere($scope.fields, {name: 'startTime'});
        var end = _.findWhere($scope.fields, {name: 'endTime'});
        if (start.value && $scope.duration) {
            end.value = start.value.clone().addMinutes($scope.duration);
        }
    }

    function endTimeChanged() {
        calcDuration();
    }

    function setWorkoutTypeDescriptionInfo() {
        var workoutType = _.findWhere($scope.fields, {name: 'workoutType'});
        var description = _.findWhere($scope.fields, {name: 'description'});
        if (workoutType && workoutType.value && workoutType.value.description) {
            description.hint = $filter('translate')('CURRENT_WORKOUTTYPE_DESCRIPTION_HINT').format(workoutType.value.description);
        } else {
            description.hint = '';
        }
    }

    function workoutTypeChanged() {
        setWorkoutTypeDescriptionInfo();
        var workoutType = _.findWhere($scope.fields, {name: 'workoutType'});
        if (workoutType.value) {
            var tags = _.findWhere($scope.fields, {name: 'tags'});
            tags.value = _.map(workoutType.value.tags, function(tag) { return _.findWhere($rootScope.systemtags, { id: tag.id }); });
        }
    }

    $scope.fields = [
        {name: 'site_id', title: 'Site', type: 'select', options: function() { return $rootScope.sites; }, required: true, visible: function() { return $rootScope.hasModule('MultiSite'); }, useId: true },
        {name: 'workoutType', title: 'Workout type', required: true, type: 'select', options: function() {return $rootScope.workouttypes; }, optionsFilter: {active: true}, change: workoutTypeChanged },
        {name: 'extra_title', title: 'Type - complement', type: 'text'},
        {name: 'startDate', title: 'Date', required: true, type: 'date', visible: () => !options.hideDate },
        {name: 'startTime', title: 'Start time', required: true, type: 'time', change: startTimeChanged },
        {name: 'endTime', title: 'End time', required: true, type: 'time', change: endTimeChanged },
        {name: 'collection_time', title: 'Collection time', required: false, type: 'infoNumber', info: 'minutes', visible: function() { return $rootScope.hasModule('LOK'); } },
        {name: 'staffs', title: 'Instructor', required: false, type: 'customers', itemTypes: ['staff', 'customer'], useId: true },
        {name: 'resources', title: 'Resources', required: false, type: 'customers', itemTypes: ['resource'], useId: true },
        {name: 'space', title: 'Num places', required: false, type: 'number', min: 1, visible: function() { return $rootScope.hasModule('WorkoutBooking');} },
        {name: 'bookableForCustomer', title: 'Bookable for customer', required: true, type: 'checkbox', visible: function() { return $rootScope.hasModule('WorkoutBooking'); } },
        {name: 'note', title: 'Internal note', required: false, type: 'textarea' },
        {name: 'video', title: 'Video activity', type: 'checkbox' },
        {name: 'video_url', title: 'Video link', type: 'url', visible: function() { return _.findWhere($scope.fields, {name: 'video'}).value; } },
        {name: 'auto_attendance', title: 'Auto attendance', type: 'checkbox', visible: function() { return $rootScope.hasModule('Attendance') && _.findWhere($scope.fields, {name: 'video'}).value; } },
        {name: 'description', title: 'Description', required: false, type: 'htmleditor', visible: showWorkout, hintClass: 'alert-info', hintCompact: true },
        {name: 'bookable_for_groups', title: 'Free booking for group(s)', required: false, type: 'groups', useId: true, visible: function() { return $rootScope.hasModule('WorkoutBooking'); }},
        {name: 'alsoChange', title: 'Also change', required: false, type: 'multiselect', options: function() { return $scope.similar; }, getName: function(w) { return w == $scope.all ? $filter('translate')('All') : w.startDate.yyyymmdd(); }, orderPredicate: ['startDate'], skipChangedCheck: true, visible: function() { return $scope.similar && $scope.similar.length > 1; } },
        {name: 'tags', title: 'Tags', required: false, type: 'systemtag'}
    ];

    if ($scope.workout.id) {
        $http.get('/api/schedule/workout/getSimilar?id=' + $scope.workout.id).success(function(similar) {
            // FIXME: Point to workouts in $rootScope.workouts
            angular.forEach(similar, function(workout) {
                $rootScope.transformWorkout(workout);
            });
            $scope.similar = similar;
            $scope.similar.unshift($scope.all);
        });
    }

    $scope.alsoChange = _.findWhere($scope.fields, {name: 'alsoChange' });
    $scope.$watchCollection('alsoChange.value', function(newNames, oldNames) {
        $scope.onChangeSimilar(newNames, oldNames);
    });

    $scope.setInitialValues = function() {
        setWorkoutTypeDescriptionInfo();
    };

    $scope.setValues($scope.workout);
    calcDuration();
    $scope.setInitialValues();
}]);

app.controller('WorkoutTypeChangeModalCtrl', ['$rootScope', '$scope', 'workoutType', '$controller', '$filter', 'paymentMethods', 'accounts', 'server', '$q', 'genders', function($rootScope, $scope, workoutType, $controller, $filter, paymentMethods, accounts, server, $q, genders) {
    $controller('ChangeModalCtrl', {$scope: $scope});

    $scope.workoutType = workoutType;
    $scope.item = workoutType;
    $scope.postUrl = '/api/schedule/workout/type/change';

    $scope.titleSuffix = function() {
        return $scope.workoutType.name;
    };

    var onetime = function() {
        return _.findWhere($scope.fields, {name: 'onetime'}).value;
    };

    var getTrainingCards = function() {
        return $rootScope.getTrainingCards().filter(function(card) {
            return card.workout && !card.resourcebookingservice_id && !card.workoutBooking;
        });
    };

    var getTrainingCardGroup = function(card) {
        return card.active ? 'Training cards' : 'Inactive training cards';
    };

    var getAllowBooking = function() {
        return _.findWhere($scope.fields, {name: 'allowBooking'}).value;
    };

    var accessGlobalOption = function() {
        return $rootScope.currentStaff.sync.active && $rootScope.hasPermission('Chain settings');
    };

    var visibleGlobalOption = function(field) {
        var category = _.findWhere($scope.fields, {name: 'category_id'}).value;
        if(category && category.is_global) {
            return (field && field.value) || accessGlobalOption();
        }
    };

    var lok_type = [], lok_sport = [], apn_type = [];
    function showCostCenter() {
        return onetime() && $rootScope.hasPermission('Accounting') && $scope.costcenters && $scope.costcenters.length;
    }

    $scope.ages = [];
    for (var i=0; i < 100; ++i) {
        $scope.ages.push({'id': i, 'name': i});
    }

    $scope.interests = [];
    var getInterests = function() {
        server.get('/api/memberapi/interest/get').then(function(interests) {
            $scope.interests = interests;
        });
    };
    getInterests();

    var setAge = function(field, value) {
        if (value) {
            return {from: _.findWhere($scope.ages, {id: value.from}), to: _.findWhere($scope.ages, {id: value.to})};
        }
    };

    $scope.fields = [
        {name: 'name', title: 'Name', required: true, type: 'text' },
        {name: 'category_id', title: 'Category', required: true, type: 'select', options: function() {return $rootScope.workoutcategories; }, optionsFilter: {active: true}, useId: true },
        {name: 'subcategory', title: 'Sub category', required: false, type: 'text', visible: function() { return $rootScope.is_korpen; } },
        {name: 'sites', title: 'Sites', required: true, type: 'multiselect', visible: function() { return $rootScope.hasModule('MultiSite'); }, options: function() { return $rootScope.sites; }, useId: true},
        {name: 'description', title: 'Description', required: false, type: 'htmleditor' },
        {name: 'color', title: 'Color', required: false, type: 'color'},
        {name: 'show', title: 'Show for customers', required: false, type: 'checkbox', visible: function() { var c =_.findWhere($scope.fields, {name: 'category_id'}).value; return c && c.show; }},
        {name: 'onetime', title: 'Sell one time cards', required: true, type: 'checkbox' },
        {name: 'price', title: 'Price incl. VAT', required: true, type: 'price', visible: onetime },
        {name: 'vat', title: 'VAT', required: true, type: 'select', options: function() { return $rootScope.valueAddedTax; }, useId: true, visible: function() { return onetime() && !$rootScope.vatexempt; } },
        accounts.getFieldsRow($scope, function() { return onetime() && $rootScope.hasPermission('Accounting'); }, $scope.workoutType),
        {name: 'costcenter_id', title: 'Cost center', type: 'select', options: function() { return $scope.costcenters; }, visible: showCostCenter, useId: true},
        {name: 'allowBooking', title: 'Booking with training card', required: false, type: 'checkbox' },
        {name: 'cardtypes', title: 'Bookable with', required: false, type: 'multiselect', options: getTrainingCards, placeholder: 'All training cards', visible: getAllowBooking, useId: true, group: getTrainingCardGroup, orderPredicate: ['-active', 'name'], addButtonClicked: function(field) { field.value = field.options().filter(function(c) { return c.active; }); }, addButtonTitle: 'Select all' },

        // Bookable conditions
        {name: 'booking_groups', title: 'Bookable for groups', required: false, type: 'multiselect', options: function() { return $rootScope.usergroups; }, useId: true, visible: function() { return $rootScope.hasModule('WorkoutBookingRules') && ($rootScope.usergroups.length || $rootScope.speedy); }, placeholder: 'No group required' },
        {name: 'booking_interests', title: 'Bookable for interests', required: false, type: 'multiselect', options: function() { return $scope.interests; }, useId: true, visible: function() { return $rootScope.hasModule('WorkoutBookingRules') && $scope.interests.length; }, placeholder: 'For all interests' },
        {name: 'booking_age', title: 'Age for booking', required: false, type: 'interval', options: function() { return $scope.ages;}, getValue: getIntervalValue, setValue: setAge, changed: function(field) { return !angular.equals(field.getValue(field), $scope.item.booking_age); }, visible: function() { return $rootScope.hasModule('WorkoutBookingRules'); } },
        {name: 'booking_gender', title: 'Gender for booking', required: false, type: 'select', options: genders.getList, useId: true, placeholder: 'For all', visible: function() { return $rootScope.hasModule('WorkoutBookingRules'); }},

        {name: 'printTicket', title: 'Print ticket', required: false, type: 'checkbox'},
        {name: 'sisu', title: 'SISU learning hour', required: false, type: 'checkbox', visible: function() { return $rootScope.hasModule('SISU'); }},
        {name: 'lok_type', title: 'Type of activity (for contributions)', required: false, type: 'select', options: function() {return lok_type; }, useId: true, visible: function() { return $rootScope.hasPermission('Lok'); }},
        {name: 'lok_sport', title: 'Sport (for contributions)', required: false, type: 'select', options: function() {return lok_sport; }, useId: true, visible: function() { return $rootScope.hasPermission('Lok'); }},
        {name: 'apn_type', title: 'Type of activity (for contributions)', required: false, type: 'select', options: function() {return apn_type; }, useId: true, visible: function() { return $rootScope.hasPermission('Apn'); }},
        {name: 'is_global', title: 'Chain', type: 'checkbox', visible: visibleGlobalOption },
        {name: 'imagekey', title: 'Image', type: 'field', field: 'image-storage', option: {originType: 'workouttype', imageOnly: true, squareThumbnail: false}, visible: function() { return $rootScope.zoeziMyBusiness; } },
        {name: 'tags', title: 'Tags', required: false, type: 'systemtag'}
    ];

    if($scope.workoutType.is_global && !accessGlobalOption()) {
        if($rootScope.currentStaff.sync.fields && $rootScope.currentStaff.sync.fields.workouttype) {
            $scope.fields.forEach(function(field) {
                if($rootScope.currentStaff.sync.fields.workouttype.indexOf(field.name) >= 0) {field.readonly=true;}
            });
        }
        _.findWhere($scope.fields, {name: 'category_id'}).readonly = true;
        _.findWhere($scope.fields, {name: 'is_global'}).readonly = true;
    }

    var wait = [];
    if($rootScope.hasPermission('Lok')) {
        wait.push(server.get('/api/lok/get_activity_types').then(function(result) {lok_type = result;}));
        wait.push(server.get('/api/lok/get_sport').then(function(result) {lok_sport = result;}));
    }

    if($rootScope.hasPermission('Apn')) {
        wait.push(server.get('/api/apn/get_activity_types').then(function(result) {apn_type = result;}));
    }

    if ($rootScope.hasPermission('Accounting')) {
        wait.push(server.get('/api/economy/costcenter/get').then(function(data) {$scope.costcenters = data;}));
    }

    $q.allSettled(wait).then(function() {
        $scope.setValues($scope.item);
    });
}]);

app.controller('ProductDataCtrl', ['$rootScope', '$scope', '$modal', 'util', 'server', 'accounts', 'productCategoryService', 'paymentMethods', 'options', function($rootScope, $scope, $modal, util, server, accounts, productCategoryService, paymentMethods, options) {

    function showVAT() {
        if ($rootScope.vatexempt) {
            return false;
        }

        if (options.item) {
            var product = options.item;
            return !product.giftcard && !product.valuecard && !product.misc && !product.reminderFee && !product.reminderRate && !product.invoiceFee && !product.rounding;
        }

        return true;
    }

    function showCostCenter() {
        return $rootScope.hasPermission('Accounting') && $scope.config.data.costcenters && $scope.config.data.costcenters.length;
    }

    function setAccountValue(value) {
        $scope.config.control.getField('account').value = value;
    }

    function showWebshopCategory() {
        if ($rootScope.hasFlag('flag-unified-sales-category')) {
            // Sales category is shown and required for all sellable products,
            // not only those shown in the web shop. Internal pseudo-products
            // (fees, rounding, misc) are never sold, so they stay exempt.
            var product = options.item;
            if (!product) { return true; }
            return !product.misc && !product.reminderFee && !product.reminderRate && !product.invoiceFee && !product.rounding;
        } else {
            var customerCanBuy = $scope.config.control.getField('customerCanBuy');
            return customerCanBuy && customerCanBuy.visible() && customerCanBuy.value;
        }
    }

    function showBuyWithPoints() {
        return $rootScope.hasModule('LoyaltyPoints');
    }

    function getWebShopMethodName(method) {
        return method.id == 'unknown' ? 'Pay on site' : method.name;
    }

    function showDirectLink() {
        var ccb = $scope.config.control.getField('customerCanBuy');
        return options.item && ccb.visible() && ccb.value && options.item.variants.length <= 1;
    }

    function getDirectLink() {
        if (options.item?.id) {
            server.get('/api/homepage/product/link/get', {id: options.item.id}).then((link) => {
                $scope.config.control.getField('_directlink').hint = link;
            });
        }
    }

    var isValueCard = function() {
        return options.item && options.item.valuecard;
    };

    function barcodeDuplicate() {
        var variants = $scope.config.control.getField('variants').value;
        if (!variants) {
            return {duplicate: false};
        }
        var barcodes = _.pluck(variants, 'barcode').filter(function(bc) { return !!bc;});
        if (barcodes.length == 0) {
            return {duplicate: false};
        }
        if (_.uniq(barcodes).length != barcodes.length) {
            return {duplicate: true};
        }

        var currentProduct = $scope.config.item || {};
        var visibleSitesField = $scope.config.control && $scope.config.control.getField('visible_sites');
        var currentWithSites = {
            id: currentProduct.id,
            visible_sites: visibleSitesField ? visibleSitesField.value : currentProduct.visible_sites
        };
        var same = $rootScope.trainingcardtypes.find(function(tc) {
            if (currentWithSites.id == tc.id) {
                return false;
            }

            if (_.intersection(barcodes, _.pluck(tc.variants, 'barcode')).length) {
                return $rootScope.productsShareLegalEntity(currentWithSites, tc);
            }
        });

        return {duplicate: !!same, product: same};
    }

    function variantNamesInvalid() {
        var variants = $scope.config.control.getField('variants').value;

        return variants && variants.length > 1 && variants.find(function(x) {
            return !x.name;
        });
    }

    function setAccountValue(value) {
        $scope.config.control.getField('account').value = value;
    }

    var accountField = accounts.getFieldsRow($scope, function() { return $rootScope.hasPermission('Accounting'); }, null, null, null, null, null, null, null, null, setAccountValue);

    $scope.config = _.deep_extend(options.config, {
        datatype: 'product',
        url: {
            add: '/api/trainingcard/type/add',
            change: '/api/trainingcard/type/change',
            copy: '/api/trainingcard/type/add'
        },
        data: {
            costcenters: $rootScope.hasPermission('Accounting') && $rootScope.waitFor(['costcenters']),
            accounts: $rootScope.hasPermission('Accounting') && accountField.promise
        },
        initCallChange: true,
        tabs: [
            {
                name: 'General',
                fields: [
                    {name: 'name', title: 'Name', required: true, type: 'text' },
                    {name: 'payWhatYouWant', title: 'Pay What You Want', type: 'checkbox'},
                    {name: 'price', title: 'Price incl. VAT', required: true, type: 'price', visible: '!payWhatYouWant' },
                    {name: 'validTime', title: 'Valid for', required: true, type: 'infoNumber', value: 120, visible: isValueCard, info: 'months', min: 1 },
                    {name: 'separate_invoice', title: 'Separate invoice', required: false, type: 'checkbox' },
                    {name: 'imagekey', title: 'Image', type: 'field', field: 'image-storage', option: {originType: 'product', imageOnly: true, squareThumbnail: true}},
                    {name: 'description', title: 'Description', required: false, type: 'htmleditor' },
                    {name: 'visible_sites', title: 'Sites', required: false, type: 'multiselect', visible: function() { return $rootScope.hasModule('MultiSite'); }, options: function() { return $rootScope.sites; }, useId: true, placeholder: 'All sites'},
                    {name: 'tags', title: 'Tags', required: false, type: 'systemtag'}
                ]
            },
            {
                name: 'Stock and variants',
                visible: function() {
                    var t = options.item;
                    if (!t) {
                        return true;
                    }

                    return !t.discount && !t.rounding && !t.misc && !t.reminderFee && !t.reminderRate && !t.invoiceFee && !t.blockFee && !t.valuecard;
                },
                fields: [
                    {
                        name: 'variants',
                        type: 'customertable',
                        getValue: function(f) {
                            var items = f.config.control && f.config.control.getItems();
                            if (items) {
                                items.forEach(function(variant) {
                                    delete variant._id;
                                });
                            }

                            return items;
                        },
                        config: {
                            getItems: function() {
                                var value = $scope.config.control.getField('variants').value;
                                if (value) {
                                    for (var i=0; i < value.length; ++i) {
                                        value[i]._id = i+1;
                                    }
                                }
                                return value;
                            },
                            idKey: '_id',
                            countSuffixList: ['product variant', 'product variants'],
                            orderColumn: 'name',
                            columns: [
                                {field: 'name', title: 'Name', format: 'editable', editablePlaceholder: 'Standard' },
                                {field: 'stock', title: 'Units in stock', format: 'editable', editableType: 'number', editablePlaceholder: util.t('Unlimited') },
                                {field: 'barcode', title: 'Barcode', format: 'editable', editableType: 'text', showSum: false}
                            ],
                            searchButtons: [
                                {
                                    title: 'Add',
                                    onClick: function() {
                                        $scope.config.control.getField('variants').value.push({name: 'Ny variant', stock: null, barcode: null});
                                    }
                                }
                            ],
                            buttons: [
                                {
                                    title: 'Remove',
                                    buttonClass: 'btn-danger',
                                    visible: function() {
                                        return $scope.config.control.getField('variants').value.length > 1;
                                    },
                                    onClick: function(variant) {
                                        var value = $scope.config.control.getField('variants').value;
                                        var i = value.indexOf(variant);
                                        value.splice(i, 1);
                                        $scope.config.control.getField('variants').config.control.update();
                                    }
                                }
                            ]
                        }
                    },
                    {
                        type: 'label', getClass: function() { return 'text-danger'; }, value: 'All variants must have names', format: 'translated', visible: variantNamesInvalid
                    },
                    {
                        type: 'label', getClass: function() { return 'text-danger'; },
                        getValue: function() {
                            var dup = barcodeDuplicate();
                            var name = $scope.config.control.getField('name').value;
                            if (dup.product) {
                                name = dup.product.name;
                            }

                            return name + ' ' + util.t('already has the given barcode');
                        },
                        visible: function() {
                            var dup = barcodeDuplicate();
                            return dup.duplicate;
                        }
                    }
                ]
            },
            {
                name: 'Accounting',
                fields: [
                    {name: 'vat', title: 'VAT', required: true, type: 'select', options: function() { return $rootScope.valueAddedTax; }, useId: true, visible: showVAT },
                    accountField,
                    {name: 'costcenter_id', title: 'Cost center', type: 'select', options: function() { return $scope.config.data.costcenters; }, visible: showCostCenter, useId: true},
                    {name: 'receiptComment', title: 'Comment on receipt', type: 'textarea' }
                ]
            },
            {
                name: 'Checkout',
                fields: [
                    {name: 'customerCanBuy', title: 'Show in web shop', required: true, type: 'checkbox', visible: function() { return $rootScope.hasModule('WebShop'); } },
                    {name: '_directlink', title: 'Direct link', hint: 'Available after saving', visible: showDirectLink },
                    productCategoryService.makeWebshopSelectField({ visible: showWebshopCategory }),
                    {name: 'methods', title: 'Payment methods', type: 'multiselect', options: paymentMethods.getPossibleForWebshop, placeholder: 'All payment methods', hint: 'LIMITED_PAYMENTMETHODS', getName: getWebShopMethodName, useId: true },
                    {name: 'showSelfCheckout', title: 'Show in self checkout', type: 'checkbox', visible: function() { return $rootScope.hasModule('Checkout');} },
                    productCategoryService.makeSelectField(),
                    {name: 'buyWithPoints', title: 'Can be bought with points', type: 'checkbox', value: false, visible: showBuyWithPoints },
                    {name: 'pointsPrice', title: 'Points', required: true, type: 'number', visible: 'buyWithPoints' }
                ]
            },
            {
                name: 'Supplier',
                fields: [
                    {name: 'supplier', title: 'Supplier', required: false, type: 'text' },
                    {name: 'purchase_price', title: 'Purchase price', required: false, type: 'price', helpText: 'Amount excluding VAT' }
                ]
            }

        ],
        init: function() {
            getDirectLink();
            if (!options.item) {
                return {
                    vat: '25',
                    variants: [{name: null}]
                };
            } else if (!options.item.variants) {
                $scope.config.initial = {
                    variants: [{name: null, stock: options.item.stock}]
                };
            } else {
                var variants = angular.copy(options.item.variants);
                if (variants.length == 0) {
                    variants.push({name: null});
                }
                $scope.config.initial = {
                    variants: variants
                };
            }
        },
        canSubmit: function() {
            return !variantNamesInvalid() && !barcodeDuplicate().duplicate;
        }
    });
}]);

app.controller('TrainingCardTypeChangeModalCtrl', ['$rootScope', '$scope', 'trainingCardType', '$controller', '$filter', 'paymentMethods', 'server', 'image', 'live', 'confirm', 'productCategoryService', 'accounts', 'util', function($rootScope, $scope, trainingCardType, $controller, $filter, paymentMethods, server, image, live, confirm, productCategoryService, accounts, util) {
    $controller('ChangeModalCtrl', {$scope: $scope});

    $scope.trainingCardType = trainingCardType;
    $scope.item = trainingCardType;
    $scope.postUrl = '/api/trainingcard/type/change';
    $scope.successTitle = trainingCardType.resourcebookingservice_id ? 'Punch card changed' : 'Training card type changed';
    $scope.failedTitle = trainingCardType.resourcebookingservice_id ? 'Failed to change punch card' : 'Failed to change training card type';

    $scope.titleSuffix = function() {
        return $scope.trainingCardType.name;
    };

    if ($rootScope.speedy) {
        $rootScope.loadActiveResourcesForSite();
    }

    $scope.priceTypes = [ {name: 'OneTime'}, {name: 'Day'}, {name: 'Week'}, {name: 'Month'}, {name: 'Quarter'}, {name: 'HalfYear'}, {name: 'Year'} ];
    $scope.dateTypes = [ {name: 'Day'}, {name: 'Week'}, {name: 'Month'}, {name: 'Quarter'}, {name: 'HalfYear'}, {name: 'Year'} ];

    $scope.submit = function() {
        var item = $scope.getSubmitItem();
        if(!item.stockB) {item.stock = null;}
        delete item.stockB;

        var priceChanged = item.price != $scope.item.price && !angular.equals($scope.item, {});

        var doPost = function(resolve) {
            server.post($scope.postUrl, item, null, '{0} changed', 'Failed to change {0}', 'Training card').then(function(result) {
                if (resolve) {
                    resolve();
                }
                $scope.loadingStatus.loading = false;
                if (result.success) {
                    $scope.$close();
                }
            });
        };

        $scope.loadingStatus.loading = true;
        if (priceChanged && trainingCardType.auto && !$scope.skipPriceCheck) {
            confirm.show('CHANGE_PRICE', {ladda: true}).then(function(resolve) {
                item.updatePrice = true;
                doPost(resolve);
            }, doPost);
        } else {
            doPost();
        }
    };

    $scope.getPriceTypes = function() {
        return $scope.priceTypes;
    };

    $scope.getDateTypes = function() {
        return $scope.dateTypes;
    };

    $scope.setDateType = function(field) {
        return _.findWhere($scope.dateTypes, {name: $scope.item[field.name]});
    };

    $scope.setPriceType = function(field) {
        return _.findWhere($scope.priceTypes, {name: $scope.item[field.name]});
    };

    $scope.getType = function(field) {
        return field.value ? field.value.name : null;
    };

    $scope.getServiceName = function() {
        return $scope.item.resourcebookingservice.name;
    };

    var setStock = function() {
        return $scope.item.stock != null;
    };

    var isStock = function() {
        return _.findWhere($scope.fields, {name: 'stockB'}).value;
    };

    var getStock = function() {
        if (isStock()) {
            return _.findWhere($scope.fields, {name: 'stock'}).value;
        } else {
            return null;
        }
    };

    $scope.ages = [];
    for (var i = 0; i < 100; ++i) {
        $scope.ages.push({'id': i, 'name': i});
    }

    var setAge = function(field, value) {
        if (value) {
            return {from: _.findWhere($scope.ages, {id: value.from}), to: _.findWhere($scope.ages, {id: value.to})};
        }
    };

    var isFixedStartDate = function() {
        return _.findWhere($scope.fields, {name: 'fixed_start_date'}).value;
    };

    var customerCanSelectStartDate = function() {
        return _.findWhere($scope.fields, {name: 'customer_can_select_start_date'}).value;
    };

    var rcotemplates = [];
    var setCardTemplate = function(field, value) {
        return _.findWhere(rcotemplates, {name: value});
    };

    var isAuto = function() {
        return _.findWhere($scope.fields, {name: 'auto'}).value;
    };

    var notAuto = function() {
        return !isAuto();
    };

    var isPeriod = function() {
        var p = _.findWhere($scope.fields, {name: 'period'});
        return p && p.value;
    };

    var notPeriod = function() {
        return !isPeriod();
    };

    // Conflict: priceType == OneTime and auto == true
    // Conflict: priceType == Month and method == (valueCard or payson)
    function getFilteredPriceTypes() {
        var auto = isAuto();

        return $scope.getPriceTypes().filter(function(t) {
            return !(t.name === 'OneTime' && auto);
        });
    }

    // watch priceType
    $scope.$watch(function() {
        var field = _.findWhere($scope.fields, {name: 'priceType'});
        return field && field.value && field.value.name === 'OneTime';
    }, function(value) {
        _.findWhere($scope.fields, {name: 'auto'}).readonly = value;
    });

    var showMethods = function() {
        if(trainingCardType.resourcebookingservice_id != null)
        {
            return $rootScope.hasModule('WebShop');
        }
        return $rootScope.hasModule('WebShop') && _.findWhere($scope.fields, {name: 'customerCanBuy'}).value;
    };

    var showDirectLink = function() {
        if (trainingCardType.resourcebookingservice_id != null) {return false;}
        return $rootScope.hasModule('WebShop') && _.findWhere($scope.fields, {name: 'customerCanBuy'}).value;
    };

    var getWebShopMethodName = function(method) {
        return method.id == 'unknown' ? 'Pay on site' : method.name;
    };

    function showCostCenter() {
        return $rootScope.hasPermission('Accounting') && $scope.costcenters && $scope.costcenters.length;
    }

    var showBuyWithPoints = function() {
        var priceType = _.findWhere($scope.fields, {name: 'priceType'});
        return $rootScope.hasModule('LoyaltyPoints') && notAuto() && priceType.value && priceType.value.name == 'OneTime';
    };

    var pointsPriceVisible = function() {
        return showBuyWithPoints() && _.findWhere($scope.fields, {name: 'buyWithPoints'}).value;
    };

    function barcodeAlreadyInUse() {
        var barcode = _.findWhere($scope.fields, {name: 'barcode'}).value;
        if (!barcode) {
            return false;
        }
        var items = $rootScope.trainingcardtypes.filter(t => t.barcode == barcode);
        var visibleSitesField = _.findWhere($scope.fields, {name: 'visible_sites'});
        var currentProduct = {
            id: $scope.item.id,
            visible_sites: visibleSitesField ? visibleSitesField.value : ($scope.item.visible_sites || [])
        };
        items = items.filter(function(t) {
            if (currentProduct.id && t.id == currentProduct.id) {
                return false;
            }
            return $rootScope.productsShareLegalEntity(currentProduct, t);
        });
        return items.length > 0;
    }

    $scope.canSubmit = function() {
        if (isPeriod()) {
            var fromDate = _.findWhere($scope.fields, {name: 'periodValidFrom'}).value;
            var toDate = _.findWhere($scope.fields, {name: 'periodValidTo'}).value;

            return fromDate && toDate && (toDate > fromDate || toDate.isSameDateAs(fromDate)) && !barcodeAlreadyInUse();
        }

        return !barcodeAlreadyInUse();
    };

    var getResourceGroup = function(resource) {
        return resource.resourceType === 'door' ? 'Doors' : 'QR-codes';
    };

    var bookingsLimitIntervalTypes = [ { name: 'Per day', id: 'day' }, { name: 'Per week', id: 'week' } ];
    var bookingsLimitIntervalVisible = function(type) {
        var field = _.findWhere($scope.fields, { name: 'bookingsLimitIntervalType' });
        return field && field.value && field.value.id == type;
    };
    var allowsWorkoutBooking = function() {
        return _.findWhere($scope.fields, { name: 'workout' }).value;
    };

    var showWebshopCategory = function() {
        if ($rootScope.hasFlag('flag-unified-sales-category')) {
            return !$scope.trainingCardType.service_base_product;
        } else {
            var customerCanBuy = _.findWhere($scope.fields, { name: 'customerCanBuy' });
            return customerCanBuy && customerCanBuy.visible() && customerCanBuy.value;
        }
    };

    var hasSessionsLimit = function() {
        return _.findWhere($scope.fields, { name: 'trainingsessions' }).value;
    };

    const entryOptions = [{id: 'booking', name: 'Only when booked'}, {id: 'fixed', name: 'According to fixed times'}, {id: 'schedule', name: 'According to schedule'}];
    const fieldEntryOption = {
        name: 'entryOption',
        title: 'Allows entry',
        type: 'select',
        useId: true,
        required: false,
        value: null,
        options() { return entryOptions; },
        changed() { return this.setValue() != this.value; },
        setValue() {
            if (!$scope.item.entry) return null;
            if ($scope.item.entryWhenBooked) return entryOptions[0];
            return $scope.item.schedule_id ? entryOptions[2] : entryOptions[1];
        },
        visible() { return $rootScope.hasModule('Entry'); }
    };
    const entryOption = (...option) => {
        return () => {
            return $rootScope.hasModule('Entry') && option.includes(fieldEntryOption.value?.id);
        };
    };
    const isEntryCard = () => !!fieldEntryOption.value;

    var autoRenewSessionsOptions = [
        { id: 'reset', name: 'Reset number of training sessions' },
        { id: 'add', name: 'Add to existing training sessions' }
    ];
    var isRenewTypeAdd = function() {
        var value = _.findWhere($scope.fields, { name: 'autoRenewSessions' }).value;
        return value && value.id === 'add';
    };
    var getProductCategory = function(t) {
        return t.type ? t.type.charAt(0).toUpperCase() + t.type.slice(1) : 'Product';
    };

    var includedProductFilter = function(t) {
        if ($scope.item && $scope.item.included_products && $scope.item.included_products.indexOf(t.id) >= 0) return true;
        return t.active && t.id !== $scope.item.id && t.stock == null && !t.membership && !t.valuecard && !t.giftcard && !$rootScope.isSpecialHiddenProduct(t) && !$rootScope.isPackageProduct(t);
    };

    var getOnetimeFeeProductOptions = function() {
        return $rootScope.getActiveProducts().filter(function(t) { return !t.giftcard && !t.membership && !t.valuecard && t.id !== $scope.item.id; });
    };

    if (trainingCardType.resourcebookingservice_id == null) {
        $scope.fields = [
            {name: 'name', title: 'Name', required: true, type: 'text' },
            {name: 'trainingsessions', title: 'Training sessions', required: false, type: 'number', placeholder: 'Unlimited' },
            {name: 'auto', title: 'Auto renewal', required: false, type: 'checkbox', visible: function() { return (isAuto() && notPeriod()) || (notAuto() && notPeriod()); } },
            {name: 'period', title: 'Period card', required: false, type: 'checkbox', visible: function() { return (notAuto() && isPeriod()) || (notAuto() && notPeriod()); } },
            {name: 'fixed_start_date', title: 'Fixed start date', required: false, type: 'checkbox', visible: notPeriod },
            {name: 'earliest_start_date', title: 'Earliest start date', required: true, type: 'date', visible: () => isFixedStartDate() && notPeriod() },
            {name: 'customer_can_select_start_date', title: 'Customer can select start date', required: true, type: 'checkbox', visible: notPeriod },
            {name: 'customer_select_start_date_within', title: 'Customer selects start date within', required: true, type: 'infoNumber', info: 'days', visible: () => customerCanSelectStartDate() && notPeriod() },
            {name: 'boundTime', title: 'Bound for', required: true, type: 'number', visible: function() { return isAuto() && notPeriod(); }, min: 1, max: 1000 },
            {name: 'boundType', title: '', required: true, type: 'select', options: $scope.getDateTypes, setValue: $scope.setDateType, getValue: $scope.getType, visible: function() { return isAuto() && notPeriod(); } },
            {name: 'validTime', title: 'Valid for', required: true, type: 'number', visible: function() { return notAuto() && notPeriod(); }, min: 1, max: 1000 },
            {name: 'validType', title: '', required: true, type: 'select', options: $scope.getDateTypes, setValue: $scope.setDateType, getValue: $scope.getType, visible: function() { return notAuto() && notPeriod(); } },
            {name: 'periodValidFrom', title: 'Valid from', required: true, type: 'date', visible: function() { return notAuto() && isPeriod(); } },
            {name: 'periodValidTo', title: 'Valid to', required: true, type: 'date', visible: function() { return notAuto() && isPeriod(); } },
            {name: 'price', title: 'Price incl. VAT', required: true, type: 'price' },
            {name: 'priceType', title: '', required: true, type: 'select', options: getFilteredPriceTypes, setValue: $scope.setPriceType, getValue: $scope.getType },
            {name: 'autoRenewSessions', title: 'Renew training sessions automatically', required: false, helpText: 'AUTOMATICALLY_RENEW_SESSIONS_HELPTEXT', placement: 'right', placeholder: 'Do not renew', useId: true, type: 'select', options: function() { return autoRenewSessionsOptions; }, visible: function() { return isAuto() && hasSessionsLimit(); } },
            {name: 'autoRenewSessionsMax', title: 'Maximum number of saved training sessions', required: false, placeholder: 'No limit', type: 'number', visible: function() { return isAuto() && hasSessionsLimit() && isRenewTypeAdd(); } },
            {name: 'vat', title: 'VAT', required: true, type: 'select', options: function() { return $rootScope.valueAddedTax; }, visible: function() { return !$rootScope.vatexempt; }, useId: true },
            accounts.getFieldsRow($scope, function() { return $rootScope.hasPermission('Accounting'); }, $scope.trainingCardType),
            {name: 'costcenter_id', title: 'Cost center', type: 'select', options: function() { return $scope.costcenters; }, visible: showCostCenter, useId: true},
            {name: 'receiptComment', title: 'Comment on receipt', type: 'textarea' },
            {name: 'onetime_fee_product_id', title: 'One-time fee', type: 'select', options: getOnetimeFeeProductOptions, visible: function() { return $rootScope.hasFlag('flag-one-time-fee'); }, useId: true, placeholder: 'None'},
            {name: 'trial', title: 'Trial card', required: false, type: 'checkbox' },
            {name: 'workout', title: 'Allows workout booking', required: false, type: 'checkbox', visible: function() { return $rootScope.hasModule('WorkoutBooking'); } },
            {name: 'bookingsLimitIntervalType', title: 'Limit bookings by interval', type: 'select', required: false, placeholder: 'No limit', visible: allowsWorkoutBooking, options: function() { return bookingsLimitIntervalTypes; }, useId: true },
            {name: 'bookingsLimitInterval', title: 'Max number of bookings per day', type: 'number', required: true, visible: function() { return allowsWorkoutBooking() && bookingsLimitIntervalVisible('day'); }, min: 1 },
            {name: 'bookingsLimitInterval', title: 'Max number of bookings per week', type: 'number', required: true, visible: function() { return allowsWorkoutBooking() && bookingsLimitIntervalVisible('week'); }, min: 1 },
            // Entry options
            fieldEntryOption,
            {name: 'entryWhenBookedBefore', title: 'Time before booking start', type: 'infoNumber', info: 'minutes', required: true, visible: entryOption('booking') },
            {name: 'entryFrom', title: 'Entry from', required: false, type: 'time', visible: entryOption('fixed') },
            {name: 'entryTo', title: 'Entry to', required: false, type: 'time', visible: entryOption('fixed') },
            {name: 'schedule_id', title: '', required: true, useId: true, type: 'customer', itemTypes: ['schedule'], visible: entryOption('schedule')},
            {name: 'limitBookingToEntryTimes', title: '', type: 'checkbox', extrahtml: $filter('translate')('LIMIT_BOOKING_TO_CARD_AVAILABILITY'), visible: entryOption('fixed', 'schedule') },
            {name: 'entryDoors', title: 'Doors and QR-code', required: false, type: 'multiselect', options: $rootScope.getActiveDoorsAndQRCodeEntries, placeholder: 'All', group: getResourceGroup, useId: true, visible: function() { return $rootScope.hasModule('Entry') && isEntryCard(); } },
            // ~Entry options
            {name: 'lockerRental', title: 'Allow locker rental', required: false , type: 'checkbox', visible: function(){ return $rootScope.hasModule('Metra'); } },
            {name: 'requireMembership', title: 'Require membership', required: false, type: 'checkbox', visible: function() { return $rootScope.hasModule('Membership'); } },
            {name: 'showSelfCheckout', title: 'Show in self checkout', reqruired: false, type: 'checkbox', visible: function() { return $rootScope.hasModule('Checkout');} },
            {name: 'customerCanBuy', title: 'Show in web shop', required: false, type: 'checkbox', visible: function() { return $rootScope.hasModule('WebShop'); } },
            productCategoryService.makeWebshopSelectField({ visible: showWebshopCategory }),
            {name: '_directlink', title: 'Direct link', visible: showDirectLink },
            {name: 'methods', title: 'Payment methods', type: 'multiselect', visible: showMethods, options: paymentMethods.getPossibleForWebshop, placeholder: 'All payment methods', hint: 'LIMITED_PAYMENTMETHODS', getName: getWebShopMethodName, useId: true },
            {name: 'purchase_age', title: 'Age for purchase', required: false, type: 'interval', options: function() { return $scope.ages; }, getValue: getIntervalValue, setValue: setAge, changed: function(field) { return !angular.equals(field.getValue(field), $scope.item.purchase_age); }, visible: function() { return $rootScope.hasModule('WorkoutBookingRules'); } },
            {name: 'stockB', title: 'Limited amount', required: false, type: 'checkbox', setValue: setStock, skipChangedCheck: true },
            {name: 'stock', title: 'Units in stock', required: false, type: 'number', getValue: getStock, visible: isStock, invisibleValue: null, nullIsValue: true },
            {name: 'cardTemplate', title: 'Card template', required: true, type: 'select', visible: function() { return $rootScope.hasModule('Rco'); }, options: function() { return rcotemplates; }, getValue: function(field) { return field.value && field.value.name; }, setValue: setCardTemplate },
            {name: 'payWhatYouWant', title: 'Pay What You Want', required: false, type: 'checkbox', visible: function() { return $rootScope.hasModule('Admin'); } },
            {name: 'separate_invoice', title: 'Separate invoice', required: false, type: 'checkbox' },
            productCategoryService.makeSelectField(),
            {name: 'barcode', title: 'Barcode', type: 'text', visible: function() { return $rootScope.hasModule('Checkout');} },
            {name: 'barcodeHint', hintClass: 'alert-danger', hint:'The barcode is already in use', visible: barcodeAlreadyInUse },
            {name: 'imagekey', title: 'Image', type: 'field', field: 'image-storage', option: {originType: 'trainingcard', imageOnly: true, squareThumbnail: true}},
            {name: 'description', title: 'Description', required: false, type: 'htmleditor' },
            {name: 'included_products', title: 'Included products', type: 'multiselect', options: function() { return $rootScope.trainingcardtypes; }, optionsFilter: includedProductFilter, placeholder: 'Choose products', useId: true, group: getProductCategory, visible: function() { return $rootScope.hasFlag('flag-package-trainingcard'); } },
            {name: 'included_products_amount'},
            {name: 'sites', title: 'Sites', required: true, type: 'multiselect', visible: function() { return $rootScope.hasModule('MultiSite'); }, options: function() { return $rootScope.sites; }, useId: true},
            {name: 'tags', title: 'Tags', required: false, type: 'systemtag'}
        ];
    } else {
        $scope.fields = [
            {name: 'service', title: 'Service', required: true, type: 'label', getValue: $scope.getServiceName },
            {name: 'name', title: 'Name', required: true, type: 'text' },
            {name: 'hint', hint: 'RB_NOT_CHECKOUT', visible: function() { return $scope.trainingCardType.service_base_product; } },
            {name: 'trainingsessions', title: 'Sessions', required: true, type: 'number', readonly: ($scope.item.service_base_product) },
            {name: 'auto', title: 'Auto renewal', required: false, type: 'checkbox' },
            {name: 'boundTime', title: 'Bound for', required: false, type: 'number', visible: isAuto, min: 1, max: 1000 },
            {name: 'boundType', title: '', required: false, type: 'select', options: $scope.getDateTypes, setValue: $scope.setDateType, getValue: $scope.getType, visible: isAuto },
            {name: 'validTime', title: 'Valid for', required: false, type: 'number', visible: notAuto, min: 1, max: 1000 },
            {name: 'validType', title: '', required: false, type: 'select', options: $scope.getDateTypes, setValue: $scope.setDateType, getValue: $scope.getType, visible: notAuto },
            {name: 'price', title: 'Price incl. VAT', required: true, type: 'price' },
            {name: 'priceType', title: '', required: true, type: 'select', options: getFilteredPriceTypes, setValue: $scope.setPriceType, getValue: $scope.getType },
            {name: 'autoRenewSessions', title: 'Renew training sessions automatically', required: false, helpText: 'AUTOMATICALLY_RENEW_SESSIONS_HELPTEXT', placement: 'right', placeholder: 'Do not renew', useId: true, type: 'select', options: function() { return autoRenewSessionsOptions; }, visible: function() { return isAuto() && hasSessionsLimit(); } },
            {name: 'autoRenewSessionsMax', title: 'Maximum number of saved training sessions', required: false, placeholder: 'No limit', type: 'number', visible: function() { return isAuto() && hasSessionsLimit() && isRenewTypeAdd(); } },
            {name: 'vat', title: 'VAT', required: true, type: 'select', options: function() { return $rootScope.valueAddedTax; }, visible: function() { return !$rootScope.vatexempt; }, useId: true },
            accounts.getFieldsRow($scope, function() { return $rootScope.hasPermission('Accounting'); }, $scope.trainingCardType),
            {name: 'costcenter_id', title: 'Cost center', type: 'select', options: function() { return $scope.costcenters; }, visible: showCostCenter, useId: true},
            {name: 'receiptComment', title: 'Comment on receipt', type: 'textarea' },
            {name: 'onetime_fee_product_id', title: 'One-time fee', type: 'select', options: getOnetimeFeeProductOptions, visible: function() { return $rootScope.hasFlag('flag-one-time-fee'); }, useId: true, placeholder: 'None'},
            {name: 'bookingsLimitIntervalType', title: 'Limit bookings by interval', type: 'select', required: false, placeholder: 'No limit', options: function() { return bookingsLimitIntervalTypes; }, useId: true },
            {name: 'bookingsLimitInterval', title: 'Max number of bookings per day', type: 'number', required: true, visible: function() { return bookingsLimitIntervalVisible('day'); }, min: 1 },
            {name: 'bookingsLimitInterval', title: 'Max number of bookings per week', type: 'number', required: true, visible: function() { return bookingsLimitIntervalVisible('week'); }, min: 1 },
            {name: 'requireMembership', title: 'Require membership', required: false, type: 'checkbox', visible: function() { return $rootScope.hasModule('Membership'); } },
            {name: 'showSelfCheckout', title: 'Show in self checkout', reqruired: false, type: 'checkbox', visible: function() { return $rootScope.hasModule('Checkout');} },
            {name: 'customerCanBuy', title: 'Show in web shop', required: false, type: 'checkbox', visible: function() { return $rootScope.hasModule('WebShop'); } },
            productCategoryService.makeWebshopSelectField({visible: showWebshopCategory }),
            {name: 'buyWithPoints', title: 'Can be bought with points', type: 'checkbox', visible: showBuyWithPoints },
            {name: 'pointsPrice', title: 'Points', required: true, type: 'number', visible: pointsPriceVisible, min: 1 },
            {name: 'methods', title: 'Payment methods', type: 'multiselect', visible: showMethods, options: paymentMethods.getPossibleForWebshop, placeholder: 'All payment methods', hint: 'LIMITED_PAYMENTMETHODS', getName: getWebShopMethodName, useId: true },
            {name: 'purchase_age', title: 'Age for purchase', required: false, type: 'interval', options: function() { return $scope.ages; }, getValue: getIntervalValue, setValue: setAge, changed: function(field) { return !angular.equals(field.getValue(field), $scope.item.purchase_age); }, visible: function() { return $rootScope.hasModule('WorkoutBookingRules'); } },
            {name: 'stockB', title: 'Limited amount', required: false, type: 'checkbox', setValue: setStock, skipChangedCheck: true },
            {name: 'stock', title: 'Units in stock', required: false, type: 'number', getValue: getStock, visible: isStock, invisibleValue: null, nullIsValue: true },
            productCategoryService.makeSelectField({visible: function() { return !$scope.trainingCardType.service_base_product; } }),
            {name: 'barcode', title: 'Barcode', type: 'text', visible: function() { return $rootScope.hasModule('Checkout') && !$scope.trainingCardType.service_base_product ;} },
            {name: 'barcodeHint', hintClass: 'alert-danger', hint:'The barcode is already in use', visible: barcodeAlreadyInUse },
            {name: 'imagekey', title: 'Image', type: 'field', field: 'image-storage', option: {originType: 'trainingcard', imageOnly: true, squareThumbnail: true}},
            {name: 'description', title: 'Description', required: false, type: 'htmleditor' },
            {name: 'included_products', title: 'Included products', type: 'multiselect', options: function() { return $rootScope.trainingcardtypes; }, optionsFilter: includedProductFilter, placeholder: 'Choose products', useId: true, group: getProductCategory, visible: function() { return $rootScope.hasFlag('flag-package-trainingcard'); } },
            {name: 'included_products_amount'},
            {name: 'sites', title: 'Sites', required: true, type: 'multiselect', visible: function() { return $scope.trainingCardType.service_base_product && $rootScope.hasModule('MultiSite'); }, options: function() { return $rootScope.sites; }, useId: true},
            {name: 'tags', title: 'Tags', required: false, type: 'systemtag'}
        ];
    }

    // Included products customMap wiring
    (function() {
        var fieldIncludedProducts = _.findWhere($scope.fields, {name: 'included_products'});
        var fieldProductMap = _.findWhere($scope.fields, {name: 'included_products_amount'});
        if (!fieldIncludedProducts || !fieldProductMap) return;

        util.setupCustomMapField($scope, fieldIncludedProducts, fieldProductMap, {
            title: 'Price for product',
            visible: function() {
                return fieldIncludedProducts.value && fieldIncludedProducts.value.length;
            },
            getNameByKey: function(key) {
                var product = _.findWhere($rootScope.trainingcardtypes, {id: Number(key)});
                return product ? product.name : key;
            }
        });
    })();

    function getDirectLink() {
        let directLineField = _.findWhere($scope.fields, {name: '_directlink'});
        if (directLineField) {
            if ($scope.item?.id) {
                server.get('/api/homepage/product/link/get', {id: $scope.item.id}).then(function(link) {
                    directLineField.hint = link;
                });
            } else {
                directLineField.hint = 'Available after saving';
            }
        }
    }
    getDirectLink();

    function getEntryStuffAndSetValues() {
        var doSetValues = function() {
            productCategoryService.getAsList({active: true}).then(function() {
                $scope.setValues($scope.trainingCardType);
            });
        };

        if ($rootScope.hasModule('Rco')) {
            live.pluginCommand('Rco', 'GetTemplates', null, 5000).then(function(templates) {
                rcotemplates = templates;
                doSetValues();
            }, function() {
                if ($scope.trainingCardType.cardTemplate) {
                    rcotemplates = [{name: $scope.trainingCardType.cardTemplate}];
                }
                doSetValues();
            });
        } else {
            doSetValues();
        }
    }

    if ($rootScope.hasPermission('Accounting')) {
        server.get('/api/economy/costcenter/get').then(function(data) {
            $scope.costcenters = data;
            getEntryStuffAndSetValues();
        });
    } else {
        getEntryStuffAndSetValues();
    }

    const getItem = $scope.getSubmitItem;
    $scope.getSubmitItem = () => {
        let item = getItem();
        let entryOption = item.entryOption;
        delete item.entryOption;

        if (entryOption == null) {
            // entry, entryWhenBooked, entryWhenBookedBefore, entryFrom, entryTo, schedule_id
            item.entry = false;
            item.entryWhenBooked = false;
            item.entryWhenBookedBefore = 0;
            item.entryFrom = null;
            item.entryTo = null;
            item.schedule_id = null;
            item.limitBookingToEntryTimes = false;
        } else if (entryOption == 'booking') {
            item.entry = true;
            item.entryWhenBooked = true;
            item.entryFrom = null;
            item.entryTo = null;
            item.schedule_id = null;
            item.limitBookingToEntryTimes = false;
        } else if (entryOption == 'fixed') {
            item.entry = true;
            item.entryWhenBooked = false;
            item.entryWhenBookedBefore = 0;
            item.schedule_id = null;
        } else if (entryOption == 'schedule') {
            item.entry = true;
            item.entryWhenBooked = false;
            item.entryWhenBookedBefore = 0;
            item.entryFrom = null;
            item.entryTo = null;
        }
        return item;
    };
}]);

app.controller('ProductChangeModalCtrl', ['$rootScope', '$scope', 'product', '$controller', '$filter', 'server', 'image', 'paymentMethods', 'productCategoryService', 'accounts', 'util',
    function($rootScope, $scope, product, $controller, $filter, server, image, paymentMethods, productCategoryService, accounts, util) {
    $controller('ChangeModalCtrl', {$scope: $scope});

    $scope.item = product;
    $scope.postUrl = '/api/trainingcard/type/change';

    $scope.titleSuffix = function() {
        return $filter('translate')($scope.item.name);
    };

    $scope.submit = function() {
        var item = $scope.getSubmitItem();
        if(!item.stockB) {item.stock = null;}
        delete item.stockB;

        if(item.service){
            item.resourcebookingservice_id = item.service.id;
            delete item.service;
        }
        item.giftcard = product.giftcard;
        if (item.giftcard) {
            item.validType = 'Month';
        }
        item.membership = product.membership;
        if (item.membership) {
            if (item.fixedTime || item.validFromMonth &&  item.validFromDay) {
                item.validFromDate = new Date(2018, item.validFromMonth-1, item.validFromDay).yyyymmdd();
                delete item.validFromMonth;
                delete item.validFromDay;
            } else {
                item.validTime = 1;
                item.validType = 'Year';
            }
            delete item.fixedTime;
        }
        var successMessage = $scope.successMessage ? $scope.successMessage : '{0} changed';
        var failMessage = $scope.failMessage ? $scope.failMessage : 'Failed to change {0}';
        var itemType = $scope.itemType ? $scope.itemType : 'product';
        $scope.loadingStatus.loading = true;
        server.post($scope.postUrl, item, null, successMessage, failMessage, itemType).then(function(result) {
            $scope.loadingStatus.loading = false;
            if (result.success) {
                $scope.$close();
            }
        });
    };

    var setStock = function() {
        return $scope.item.stock != null;
    };

    var isStock = function() {
        return _.findWhere($scope.fields, {name: 'stockB'}).value;
    };

    var getStock = function() {
        if (isStock()) {
            return _.findWhere($scope.fields, {name: 'stock'}).value;
        } else {
            return null;
        }
    };

    $scope.ages = [];
    for (var i = 0; i < 100; ++i) {
        $scope.ages.push({'id': i, 'name': i});
    }

    var setAge = function(field, value) {
        if (value) {
            return {from: _.findWhere($scope.ages, {id: value.from}), to: _.findWhere($scope.ages, {id: value.to})};
        }
    };

    var isProduct = function() {
        return $rootScope.isProduct(product);
    };

    var vatVisible = function() {
        return isProduct() && !product.giftcard && !product.valuecard && !product.misc && !product.reminderFee && !product.reminderRate && !product.invoiceFee && !product.rounding && !$rootScope.vatexempt;
    };

    var payWhatYouWantVisible = function() {
        return isProduct() && !product.valuecard && !product.misc && !product.reminderFee && !product.reminderRate && !product.invoiceFee && !product.rounding && !product.membership;
    };

    var priceVisible = function() {
        return isProduct() && !product.valuecard && !_.findWhere($scope.fields, {name: 'payWhatYouWant'}).value && !product.misc && !product.reminderRate && !product.rounding;
    };

    var showStock = function() {
        return isProduct() && !product.valuecard && !product.misc && !product.reminderFee && !product.reminderRate && !product.invoiceFee && !product.rounding;
    };

    var isGiftCard = function() {
        return product.giftcard;
    };

    var showDescription = function() {
        return isProduct() && !product.misc && !product.reminderFee && !product.reminderRate && !product.invoiceFee && !product.rounding;
    };

    var showProductCategory = function() {
        return !product.misc && !product.reminderFee && !product.reminderRate && !product.invoiceFee && !product.rounding;
    };

    var showCustomerCanBuy = function() {
        return isProduct() && !product.misc && !product.reminderFee && !product.reminderRate && !product.invoiceFee && !product.rounding;
    };

    var isGiftCardOrValueCard = function() {
        return product.valuecard || product.giftcard;
    };

    var canChangeName = function() {
        return isProduct() && !product.misc && !product.reminderFee && !product.reminderRate && !product.invoiceFee && !product.rounding;
    };

    var showMethods = function() {
        return showCustomerCanBuy();
    };

    var getWebShopMethodName = function(method) {
        return method.id == 'unknown' ? 'Pay on site' : method.name;
    };

    var account_filter = ((product.valuecard || product.giftcard) ? 'debts' : (product.discount ? 'discount' : 'sale'));

    var isMembership = function() {
        return product.membership;
    };

    var showFixedTime = function() {
        return $scope.item.name ? isMembership() && product.validFromDate : isMembership() && _.findWhere($scope.fields, {name: 'fixedTime'}).value;
    };

    var showMembershipValidTime = function() {
        return $scope.item.name ? isMembership() && !product.validFromDate : isMembership() && !_.findWhere($scope.fields, {name: 'fixedTime'}).value;
    };

    var isInvoiceFee = function() {
        return isProduct() && product.invoiceFee;
    };

    function setMonth() {
        return $scope.item.validFromDate ? $scope.item.validFromDate.getMonth()+1 : 1;
    }

    function setDay() {
        return $scope.item.validFromDate ? $scope.item.validFromDate.getDate() : 1;
    }

    var showBuyWithPoints = function() {
        return $rootScope.hasModule('LoyaltyPoints') && showCustomerCanBuy() && !isGiftCardOrValueCard() && !isMembership();
    };

    var pointsPriceVisible = function() {
        return showBuyWithPoints() && _.findWhere($scope.fields, {name: 'buyWithPoints'}).value;
    };

    function barcodeAlreadyInUse() {
        var barcode = _.findWhere($scope.fields, {name: 'barcode'}).value;
        if (!barcode) {
            return false;
        }
        var items = $rootScope.trainingcardtypes.filter(t => t.barcode == barcode);
        var visibleSitesField = _.findWhere($scope.fields, {name: 'visible_sites'});
        var currentProduct = {
            id: $scope.item.id,
            visible_sites: visibleSitesField ? visibleSitesField.value : ($scope.item.visible_sites || [])
        };
        items = items.filter(function(t) {
            if (currentProduct.id && t.id == currentProduct.id) {
                return false;
            }
            return $rootScope.productsShareLegalEntity(currentProduct, t);
        });
        return items.length > 0;
    }

    $scope.canSubmit = function() {
        if(barcodeAlreadyInUse()){
            return false;
        }
        if (showFixedTime()) {
            var month = _.findWhere($scope.fields, {name: 'validFromMonth'}).value;
            var day = _.findWhere($scope.fields, {name: 'validFromDay'}).value;
            if (month == 2) {
                return day <= 28;
            }

            if ([4, 6, 9, 11].indexOf(month) != -1) {
                return day <= 30;
            }
        }

        return true;
    };

    function showCostCenter() {
        return $rootScope.hasPermission('Accounting') && $scope.costcenters && $scope.costcenters.length;
    }

    var showDirectLink = function() {
        if($scope.item.type === 'valuecard') {return false;}
        return $rootScope.hasModule('WebShop') && showCustomerCanBuy() && _.findWhere($scope.fields, {name: 'customerCanBuy'}).value;
    };

    var showWebshopCategory = function() {
        if ($rootScope.hasFlag('flag-unified-sales-category')) {
            return true;
        } else {
            var customerCanBuy = _.findWhere($scope.fields, { name: 'customerCanBuy' });
            return customerCanBuy && customerCanBuy.visible() && customerCanBuy.value;
        }
    };

    var fixedTimeReadOnly = function() {
        return $scope.item.mode != 'add';
    };

    var fixedTimeSetValue = function() {
        return $scope.item.mode == 'copy' && $scope.item.validFromDate ? true : false;
    };

    var productGetProductCategory = function(t) {
        return t.type ? t.type.charAt(0).toUpperCase() + t.type.slice(1) : 'Product';
    };

    var productIncludedProductFilter = function(t) {
        if ($scope.item && $scope.item.included_products && $scope.item.included_products.indexOf(t.id) >= 0) return true;
        return t.active && t.id !== $scope.item.id && t.stock == null && !t.membership && !t.valuecard && !t.giftcard && !$rootScope.isSpecialHiddenProduct(t) && !$rootScope.isPackageProduct(t);
    };

    $scope.fields = [
        {name: 'name', title: 'Name', required: true, type: 'text', visible: canChangeName },
        {name: 'giftcard', title: 'Gift card', type: 'checkbox', visible: isGiftCard, readonly: true },
        {name: 'membership', title: 'Membership', type: 'checkbox', visible: isMembership, readonly: true },
        {name: 'payWhatYouWant', title: 'Pay What You Want', required: false, type: 'checkbox', visible: payWhatYouWantVisible },
        {name: 'price', title: 'Price incl. VAT', required: true, type: 'price', visible: priceVisible },
        {name: 'vat', title: 'VAT', required: true, type: 'select', options: function() { return $rootScope.valueAddedTax; }, useId: true, visible: vatVisible },
        {name: 'validTime', title: 'Valid for', required: true, type: 'infoNumber', value: 120, visible: isGiftCardOrValueCard, info: 'months', min: 1 },
        {name: 'fixedTime', title: 'Fixed time period',  setValue: fixedTimeSetValue , type: 'checkbox', visible: function(){ return isMembership && $scope.item.mode == 'copy' || $scope.item.mode == 'add' },readonly: fixedTimeReadOnly()},
        {name: 'membershiphint', hint: 'MEMBERSHIP_DATES', visible: showFixedTime},
        {name: 'membershiphint', hint: 'MEMBERSHIP_DATES2', visible: showMembershipValidTime},
        {name: 'validFromMonth', title: 'Valid from month', required: true, type: 'number', visible: showFixedTime, setValue: setMonth, min: 1, max: 12},
        {name: 'validFromDay', title: 'Valid from day', required: true, type: 'number', visible: showFixedTime, setValue: setDay, min: 1, max: 31},
        {name: 'auto', title: 'Auto renewal', required: false, type: 'checkbox', visible: isMembership },
        {name: 'account', title: 'Bookkeeping account', type: 'accounts', required: true, visible: function() { return $rootScope.hasPermission('Accounting') && isInvoiceFee(); }},
        accounts.getFieldsRow($scope, function() { return $rootScope.hasPermission('Accounting') && !isInvoiceFee(); }, $scope.item, account_filter),
        {name: 'costcenter_id', title: 'Cost center', type: 'select', options: function() { return $scope.costcenters; }, visible: showCostCenter, useId: true},
        {name: 'receiptComment', title: 'Comment on receipt', type: 'textarea' },
        {name: 'showSelfCheckout', title: 'Show in self checkout', required: false, type: 'checkbox', visible: showCustomerCanBuy },
        {name: 'customerCanBuy', title: 'Show in web shop', required: false, type: 'checkbox', visible: showCustomerCanBuy },
        productCategoryService.makeWebshopSelectField({visible: function() { return showProductCategory() && showWebshopCategory(); }}),
        {name: '_directlink', title: 'Direct link', visible: showDirectLink },
        {name: 'methods', title: 'Payment methods', type: 'multiselect', visible: showMethods, options: paymentMethods.getPossibleForWebshop, placeholder: 'All payment methods', hint: 'LIMITED_PAYMENTMETHODS', getName: getWebShopMethodName, useId: true },
        {name: 'purchase_age', title: 'Age for purchase', required: false, type: 'interval', options: function() { return $scope.ages; }, getValue: getIntervalValue, setValue: setAge, changed: function(field) { return !angular.equals(field.getValue(field), $scope.item.purchase_age); }, visible: function() { return $rootScope.hasModule('WorkoutBookingRules') && (product.membership || $rootScope.isTrainingCard(product)); } },
        {name: 'buyWithPoints', title: 'Can be bought with points', type: 'checkbox', visible: showBuyWithPoints },
        {name: 'pointsPrice', title: 'Points', required: true, type: 'number', visible: pointsPriceVisible, min: 1 },
        {name: 'stockB', title: 'Limited amount', required: false, type: 'checkbox', setValue: setStock, skipChangedCheck: true, visible: showStock },
        {name: 'stock', title: 'Units in stock', required: false, type: 'number', getValue: getStock, visible: isStock, invisibleValue: null, nullIsValue: true },
        {name: 'supplier', title: 'Supplier', required: false, type: 'text', visible: isStock },
        {name: 'purchase_price', title: 'Purchase price', required: false, type: 'price', helpText: 'Amount excluding VAT', visible: isStock },
        {name: 'barcode', title: 'Barcode', type: 'text', visible: function() { return $rootScope.hasModule('Checkout');} },
        {name: 'barcodeHint', hintClass: 'alert-danger', visible: function() {return barcodeAlreadyInUse()}, hint:  'The barcode is already in use'},
        {name: 'separate_invoice', title: 'Separate invoice', required: false, type: 'checkbox' },
        productCategoryService.makeSelectField({visible: showProductCategory}),
        {name: 'imagekey', title: 'Image', type: 'field', field: 'image-storage', option: {originType: 'product', imageOnly: true, squareThumbnail: true}},
        {name: 'description', title: 'Description', required: false, type: 'htmleditor', visible: showDescription },
        {name: 'included_products', title: 'Included products', type: 'multiselect', options: function() { return $rootScope.trainingcardtypes; }, optionsFilter: productIncludedProductFilter, placeholder: 'Choose products', useId: true, group: productGetProductCategory, visible: () => showCustomerCanBuy() && $rootScope.hasFlag('flag-package-trainingcard') },
        {name: 'included_products_amount'},
        {name: 'visible_sites', title: 'Sites', required: false, type: 'multiselect', visible: function() { return $rootScope.hasModule('MultiSite'); }, options: function() { return $rootScope.sites; }, useId: true, placeholder: 'All sites'}
    ];

    // Included products customMap wiring
    (function() {
        var fieldIncludedProducts = _.findWhere($scope.fields, {name: 'included_products'});
        var fieldProductMap = _.findWhere($scope.fields, {name: 'included_products_amount'});
        if (!fieldIncludedProducts || !fieldProductMap) return;

        util.setupCustomMapField($scope, fieldIncludedProducts, fieldProductMap, {
            title: 'Price for product',
            visible: function() {
                return fieldIncludedProducts.value && fieldIncludedProducts.value.length;
            },
            getNameByKey: function(key) {
                var product = _.findWhere($rootScope.trainingcardtypes, {id: Number(key)});
                return product ? product.name : key;
            }
        });
    })();

    function getDirectLink() {
        let directLineField = _.findWhere($scope.fields, {name: '_directlink'});
        if ($scope.item?.id) {
            server.get('/api/homepage/product/link/get', {id: $scope.item.id}).then(function(link) {
                directLineField.hint = link;
            });
        } else {
            directLineField.hint = 'Available after saving';
        }
    }
    getDirectLink();

    var doSetValues = function() {
        productCategoryService.getAsList({active: true}).then(function() {
            $scope.setValues($scope.item);
        });
    };

    if ($rootScope.hasPermission('Accounting')) {
        server.get('/api/economy/costcenter/get').then(function(data) {
            $scope.costcenters = data;
            doSetValues();
        });
    } else {
        doSetValues();
    }
}]);

app.controller('CustomerDataCtrl', ['$rootScope', '$scope', 'server', 'options', 'confirm', '$q', 'util', 'genders', function($rootScope, $scope, server, options, confirm, $q, util, genders) {
    function isCompany() {
        return options.item && options.item.company;
    }
    function isPerson () {
        return !isCompany();
    }
    function isNotMe(item) {
        return item.type == 'user' && (!options.item || options.item.id != item.id);
    }
    function hasRole() {
        var roles = _.findWhere($scope.config.control.getTab('Roles and groups').fields, {name: 'roles'}).value;
        return roles && roles.length > 0;
    }
    function hasNoPCode() {
        return !!_.findWhere($scope.config.control.getTab('General').fields, { name: 'noPcode' }).value;
    }

    var possiblyUpdateUsername = function(item) {
        var deferred = $q.defer();

        if (options.item.mail == options.item.login_key && options.item.login_key == item.login_key && item.mail != options.item.mail) {
            confirm.show('UPDATE_USERNAME_QUESTION').then(function() {
                item.login_key = item.mail;
                deferred.resolve();
            }, deferred.resolve);
        } else {
            deferred.resolve();
        }

        return deferred.promise;
    };

    $scope.config = _.deep_extend(options.config, {
        url: {
            add: '/api/user/add',
            change: '/api/member/change'
        },
        tabs: [
            {
                name: 'General',
                fields: [],
                private: {
                    keys: ['firstname', 'lastname', 'name', 'homesite_id', 'responsible', 'login_key', 'personalCodeNumber', 'noPcode', 'birthdate', 'gender', 'memberNumber', 'interest'],
                    visible: {
                        name: isCompany,
                        firstname: isPerson,
                        lastname: isPerson,
                        birthdate: isPerson,
                        gender: isPerson
                    }
                }
            },
            {
                name: 'Contacts',
                fields: [],
                private: {
                    keys: ['mail', 'phone', 'oldphone', 'address', 'zipCode', 'city', 'position']
                }
            },
            {
                name: 'Economy',
                fields: [
                    {name: 'paidBy', title: 'Paid by', required: false, type: 'customer', useId: true, itemFilter: isNotMe },
                ],
                private: {
                    keys: ['invoiceMail', 'allowInvoiceAt16'],
                    visible: {
                        allowInvoiceAt16: function() { return isPerson() && !hasNoPCode(); },
                    }
                }
            },
            {
                name: 'Roles and groups',
                fields: [
                    {name: 'roles', title: 'Roles', required: false, type: 'multiselect', options: function() { return $rootScope.roles; } },
                    {name: 'sites', title: 'Sites', required: true, type: 'multiselect', options: function() { return $rootScope.sites; }, placeholder: 'Choose site', visible: function() { return hasRole() && $rootScope.hasModule('MultiSite'); }, useId: true },
                    {name: 'groups', title: 'Groups', required: false, type: 'groups', useId: true }
                ],
                private: {
                    keys: ['roles', 'sites', 'groups']
                }
            },
            {
                name: 'Family',
                fields: [
                    {name: 'canBookFor', title: 'Can book for', type: 'customers', useId: true },
                    {name: 'bookers', title: 'Bookable by', type: 'customers', useId: true },
                    {name: 'canManage', title: 'Is responsible for', type: 'customers', useId: true },
                    {name: 'managers', title: 'Has responsible', type: 'customers', useId: true },
                ],
                private: {
                    keys: ['canBookFor', 'bookers', 'canManage', 'managers']
                }
            },
            {
                name: 'Other',
                fields: [],
                private: {
                    keys: ['extraInfo'],
                    xf: true
                }
            }
        ],
        beforeSubmit: function(item) {
            var deferred = $q.defer();

            possiblyUpdateUsername(item).then(function() {
                if (item.paidBy != options.item.paidBy) {
                    confirm.show('Payer changed. Do you want to change payer for existing payments?').then(function() {
                        item.changePaidByPayments = true;
                        deferred.resolve(item);
                    }, function() {
                        deferred.resolve(item);
                    });
                } else {
                    deferred.resolve(item);
                }
            });

            return deferred.promise;
        },
        afterInit: function() {
            if (options.options && options.options.tab) {
                var tab = _.findWhere($scope.config.tabs, {name: options.options.tab});
                $scope.config.control.setActiveTab(tab);
            }
        }
    });

    var updateBirthdate = function(personalCodeNumber) {
        var field =  $scope.config.control.getField('birthdate');
        if(field) {
            field.value = Date.newFromCompact(personalCodeNumber.substring(0,8));
        }
    };

    var updateGender = function(personalCodeNumber) {
        var genderRow = $scope.config.control.getField('gender');
        if (genderRow && !genderRow.value) {
            genderRow.value = _.findWhere(genderRow.options(), {id: genders.getGender(personalCodeNumber)});
        }
    };

    var updateInvoiceAgeRestriction = function(personalCodeNumber) {
        var field = $scope.config.control.getField('allowInvoiceAt16');
        if (!field) { return; }

        var active = true;
        if (!personalCodeNumber) {
            active = false;
            field.checkboxtext = 'Personal code number must be entered';
        } else {
            var age = $rootScope.getAgeFromPersonalCodeNumber({ personalCodeNumber: personalCodeNumber });
            if (age < 16) {
                active = false;
                field.checkboxtext = 'The member has not turned 16';
            } else if (age > 18) {
                active = false;
                field.checkboxtext = 'The member is over 18 years old';
            }
        }

        if (active) {
            field.type = 'checkbox';
        } else {
            field.type = 'immutablecheckbox';
            field.value = false;
        }
        return active;
    };


    var fields = angular.copy($rootScope.fields.user);

    fields.unshift({ show: true, name: 'name', title: 'Name', required_for_staff: true, type: 'text', builtIn: true });
    fields.unshift({ show: true, name: 'noPcode', title: 'Missing personal code number', type: 'checkbox', builtIn: true, visible: isPerson});

    fields.filter(function(f) {return f.show && f.type != 'password' && !(f.builtIn && f.name == 'groups');}).forEach(function(f) {
        f = angular.copy(f);
        if (f.builtIn && f.name == 'personalCodeNumber') {
            if (isCompany()) {
                f.title = 'Corporate identity';
                f.type = 'corporateIdentity';
            }
            f.original = options.item && options.item.personalCodeNumber;
            f.setValue = function() {
                return $rootScope.formatPersonalCodeNumber(options.item.personalCodeNumber);
            };
            f.change = function() {
                var personalCodeNumber = util.normalizePersonalCodeNumber(f.value);
                updateInvoiceAgeRestriction(personalCodeNumber);
                if (!personalCodeNumber) { return; }
                updateBirthdate(personalCodeNumber);
                updateGender(personalCodeNumber);
            };
            f.visible = function() {
                return !$scope.config.control.getField('noPcode').value;
            };
        } else if (f.builtIn && f.name == 'interest') {
            f.type = 'field';
            f.field = 'interest';
        } else if (f.builtIn && f.name == 'login_key') {
            f.type = 'loginkey';
            f.original = options.item.login_key;
        } else if (f.builtIn && f.name == 'responsible') {
            f.itemTypes = ['staff'];
        } else if (f.type == 'site') {
            f.type = 'select';
            f.options = function() { return $rootScope.sites; };
            f.useId = true;
        }

        if (!f.builtIn) {
            f.splitted_name = ['xf', f.name];
            f.name = 'xf.' + f.name;
        }

        if (f.builtIn && f.type == 'map') {
            f.mapcontrol = {};
            f.getFromAddress = function() {
                var fields = $scope.config.control.getTab('Contacts').fields;
                f.mapcontrol.getFromAddress(_.findWhere(fields, {name: 'address'}).value, _.findWhere(fields, {name: 'city'}).value);
            };
        }
        if (f.type == 'customers' || f.type == 'customer') {
            f.useId = true;
        }

        if (f.builtIn && f.name == 'allowInvoiceAt16') {
            f.checked = false;
            f.cursive = true;
            f.setValue = function() {
                return updateInvoiceAgeRestriction(options.item.personalCodeNumber) && !!options.item.allowInvoiceAt16;
            };
        }

        f.required = f.required_for_staff;
        if (f.type == 'corporateIdentity') {
            f.required = false;
        }
        if (!f.options && (f.type == 'select' || f.type == 'multiselect')) {
            var fdata = f.data;
            if (fdata.length && fdata[0].id !== undefined) {
                f.useId = true;
                f.options = function() { return fdata; };
            } else {
                f.optionsList = [];
                angular.forEach(fdata, function(name) {
                    var o = {name: name};
                    f.optionsList.push(o);
                });
                f.options = function() { return f.optionsList; };
                if (f.type == 'select') {
                    f.getValue = function(field) { return field.value && field.value.name; };
                    f.setValue = function(field, value) { return _.findWhere(field.options(), {name: value}); };
                } else {
                    f.getValue = function(field) { return _.pluck(field.value, 'name'); };
                    f.setValue = function(field, value) {
                        var res = [];
                        angular.forEach(value, function(v) {
                            var o = _.findWhere(field.options(), {name: v});
                            if (o) {
                                res.push(o);
                            }
                        });
                        return res;
                    };
                }
            }
        }

        $scope.config.tabs.forEach(function(tab) {
            if ((f.builtIn && tab.private.keys.indexOf(f.name) != -1) || (!f.builtIn && tab.private.xf)) {
                if (tab.private.visible && tab.private.visible[f.name]) {
                    f.visible = tab.private.visible[f.name];
                }
                tab.fields.push(f);
            }
        });
    });

    $scope.config.tabs.forEach(function(tab) {
        tab.fields = Array.mergeSort(tab.fields, function(a, b) {
            var ai = tab.private.keys.indexOf(a.name);
            var bi = tab.private.keys.indexOf(b.name);
            return ai < bi ? -1 : (ai > bi ? 1 : 0);
        });
    });
}]);

app.controller('TrainingCardChangeModalCtrl', ['$rootScope', '$scope', '$q', 'card', 'parentCardName', 'includedCardNames', '$controller', 'confirm', 'server', 'paymentMethods', '$modal', function($rootScope, $scope, $q, card, parentCardName, includedCardNames, $controller, confirm, server, paymentMethods, $modal) {
    $controller('ChangeModalCtrl', {$scope: $scope});

    $scope.item = card;
    $scope.postUrl = '/api/trainingcard/change';
    $scope.parentCardName = parentCardName;
    $scope.includedCardNames = includedCardNames;

    $scope.titleSuffix = function() {
        return card.cardtype_name;
    };

    function loadRequiredData() {
        if ($rootScope.hasModule('Admin') && $rootScope.hasPermission('Zoezi admin')) {
            return server.get('/api/admin/domain/get').then(data => {
                $scope.installations = data.map(i => ({id: i.name, name: `${i.gymName} (${i.name})`}));
            });
        } else {
            var deferred = $q.defer();
            deferred.resolve();
            return deferred.promise;
        }
    }

    var setInstallation = function() {
        return _.findWhere($scope.installations, {id: $scope.item.installation});
    };

    var getInstallation = function(field) {
        return field.value && field.value.id;
    };

    $scope.trainingcardRemove = function() {
        var question, success, fail;
        if($scope.item.cardtype.type === 'membership') {
            question = 'Are you sure you want to remove the membership?';
            success = 'Membership removed';
            fail = 'Failed to remove membership';
        } else {
            question = 'Are you sure you want to remove the training card?';
            success = 'Training card removed';
            fail = 'Failed to remove training card';
        }

        confirm.show(question, {ladda: true}).then(function(resolve) {
            server.post('/api/trainingcard/remove', null, {id: card.id}, success, fail).then(function(result) {
                resolve();
                if (result.success) {
                    $scope.$close();
                }
            });
        });
    };

    $scope.canRemove = function() {
        if (card.payments) {
            for (var i=0; i < card.payments.length; ++i) {
                if (card.payments[i].status != 'pending' && card.payments[i].status != 'credited') {
                    return false;
                }
            }
        }

        return true;
    };

    $scope.trainingcardConvert = function() {
        $modal.open({
            templateUrl: 'views/convertcard.html',
            controller: 'TrainingCardConvertModalCtrl',
            resolve: {
                card: function() {
                    return card;
                }
            }
        });
    };

    $scope.canConvert = function() {
        return (!card.validToDate || Date.newFull(card.validToDate).isFutureDate()) && (card.cardtype && card.cardtype.type != 'membership' && card.trainingsLeft == null);
    };

    $scope.canSubmit = function() {
        var f = _.findWhere($scope.fields, {name: 'validFromDate'}).value;
        var t = _.findWhere($scope.fields, {name: 'validToDate'}).value;
        if (f && t) {
            return f.yyyymmdd() <= t.yyyymmdd();
        }

        return true;
    };

    var hasMoney = function() {
        var customer = $rootScope.getMember(card.user_id);
        if (customer) {
            var price = _.findWhere($scope.fields, {name: 'price'}).value;
            var count = card.payments ? card.payments.length : 0;
            return customer.getValueCardAmountForSelectedLegalEntity() >= price * count;
        }
    };

    var paymentMethodFilter = function(paymentMethod) {
        if(!paymentMethod.active) { return false; }
        if(!paymentMethod.create) { return false; }
        if(!card) { return false; }
        if(!card.priceType || card.priceType === 'OneTime') { return true; }
        return !!paymentMethod.periodic;
    };

    var shouldDisplayGroups = function() {
        var groupsActivated = _.findWhere($scope.fields, { name: 'connectCardToGroups' }).value;
        return groupsActivated && card.type != 'membership' && ($rootScope.usergroups.length || $rootScope.speedy);
    };

    // Set only when the user unchecks the box. The group field is also hidden for
    // memberships, for groups that no longer resolve, and before the group list has
    // loaded — none of which mean the card should lose its groups.
    var groupsCleared = false;

    // Hidden for any other reason must leave the key out of the payload entirely, so
    // the backend neither clears the groups nor rejects ids it can no longer resolve.
    var setGroupsCleared = function(cleared) {
        groupsCleared = cleared;
        _.findWhere($scope.fields, { name: 'groups' }).includeInvisible = cleared;
    };

    var onConnectCardToGroupsChange = function() {
        setGroupsCleared(!_.findWhere($scope.fields, { name: 'connectCardToGroups' }).value);
    };

    var groupsWereCleared = function() {
        return groupsCleared && (card.groups || []).length > 0;
    };

    var getGroupsValue = function(field) {
        return groupsCleared ? [] : _.pluck(field.value || [], 'id');
    };

    var paymentMethodIsInvoice = function() {
        var currentMethod = (_.findWhere($scope.fields, { name: 'payMethod' }) || {}).value;
        return currentMethod && (currentMethod.id === 'invoice' || currentMethod.id == 'einvoice');
    };

    var useOtherTermsOfPayment = function() {
        var optionCheckbox = _.findWhere($scope.fields, { name: 'otherTermsOfPayment' });
        return optionCheckbox && optionCheckbox.visible() && !!optionCheckbox.value;
    };

    $scope.useOtherPayer = function() {
        var optionCheckbox = _.findWhere($scope.fields, { name: 'otherPayer' });
        return optionCheckbox && optionCheckbox.visible() && !!optionCheckbox.value;
    };

    // Included product in a package — its inherited/bundle-controlled fields are locked below.
    var isIncludedCard = !!card.parent_trainingcard_id && $rootScope.hasFlag('flag-package-trainingcard');
    
    // Main product in a package (has included products).
    var isMainPackageCard = includedCardNames.length > 0 && $rootScope.hasFlag('flag-package-trainingcard');

    $scope.fields = [
        {name: 'trainingsLeft', title: 'Trainings left', required: card.trainingsLeft != null, type: 'number', visible: function() { return card.trainingsLeft != null; } },
        {name: 'validFromDate', title: 'Valid from', required: true, type: 'date' },
        {name: 'boundToDate', title: 'Bound to', required: true, type: 'date', visible: function() { return card.cardtype.auto && card.cardtype.type != 'membership'; } },
        {name: 'validToDate', title: 'Valid to', required: true, readonly: (card.cardtype.auto && !card.generatedUntil), type: 'date', visible: function() { return card.validToDate != null; } },
        {name: 'price', title: 'Price', require: true, type: 'price', readonly: isIncludedCard, visible: function() { return (card.cardtype.auto && card.validToDate == null); } },
        {
            name: 'discount_id',
            title: 'Discount',
            required: false,
            type: 'select',
            readonly: isIncludedCard,
            options: () => $rootScope.trainingcardtypes.filter(t => t.active && t.discount && t.discount_condition && (($scope.item.cardtype.type == 'trainingcard' && t.discount_condition.trainingcards) || (($scope.item.cardtype.type == 'membership' && t.discount_condition.memberships)))),
            useId: true,
            placeholder: 'No discount',
            change: () => {
                // Calculate new end date
                let discount = _.findWhere($scope.fields, {name: 'discount_id'}).value;
                if (discount) {
                    let date;
                    if (discount.discount_condition.period_limit == 'months' && discount.discount_condition.period_months) {
                        date = card.validFromDate.clone().addMonths(discount.discount_condition.period_months);
                    } else if (discount.discount_condition.period_limit == 'date' && discount.discount_condition.period_date) {
                        date = Date.newFull(discount.discount_condition.period_date);
                    }
                    _.findWhere($scope.fields, {name: 'discount_to_date'}).value = date;
                } else {
                    _.findWhere($scope.fields, {name: 'discount_to_date'}).value = null;
                }

                _.findWhere($scope.fields, {name: 'discount_fixed'}).value = discount?.discount_fixed;
                _.findWhere($scope.fields, {name: 'discount_percent'}).value = discount?.discount_percent;
            }
        },
        {
            name: 'discount_to_date',
            title: 'Discount to',
            required: false,
            type: 'date',
            readonly: isIncludedCard,
            visible: () => _.findWhere($scope.fields, {name: 'discount_id'}).value?.id
        },
        {
            name: 'discount_fixed',
            title: 'Discount',
            readonly: isIncludedCard,
            type: 'price',
            visible: () => _.findWhere($scope.fields, {name: 'discount_id'}).value?.id
        },
        {
            name: 'discount_percent',
            title: 'Discount',
            readonly: isIncludedCard,
            type: 'percent',
            visible: () => _.findWhere($scope.fields, {name: 'discount_id'}).value?.id
        },
        {
            name: 'discounted_price',
            title: 'Discounted price',
            readonly: true,
            type: 'label',
            format: 'price',
            visible: () => _.findWhere($scope.fields, {name: 'discount_id'}).value?.id,
            getValue: () => {
                let fixed = Number(_.findWhere($scope.fields, {name: 'discount_fixed'}).value) || 0;
                let percent = Number(_.findWhere($scope.fields, {name: 'discount_percent'}).value) || 0;
                let price = Number(_.findWhere($scope.fields, {name: 'price'}).value) || 0;
                // Round the discount rather than the price, so this agrees with the Price
                // column. This field only shows for discount products, which keep the öre.
                let discount = Number((price * (percent / 100) + fixed).toFixed(2));
                return Math.max(0, price - discount);
            }
        },

        {name: 'installation', title: 'Installation', require: false, type: 'select', options: function() {return $scope.installations;}, visible: function() { return $rootScope.hasModule('Admin'); }, setValue: setInstallation, getValue: getInstallation },
        {name: 'payMethod', title: 'Payment method', visible: function() { return ($rootScope.hasModule('Payment') && card.cardtype.auto && card.validToDate == null); }, required: true, type: 'paymentmethod', readonly: isIncludedCard, hasMoney: hasMoney, options: { filter: paymentMethodFilter }/*, setValue: setPaymentMethod*/ },
        {name: 'otherPayer', title: 'Other payer', type: 'checkbox', readonly: isIncludedCard, visible: function() { return $rootScope.hasModule('Payment'); }, skipChangedCheck: true },
        {name: 'payer_id', title: 'Payer', visible: function() {return $scope.useOtherPayer(); }, type: 'customer', required: true, readonly: isIncludedCard, useId: true },
        {name: 'otherTermsOfPayment', title: 'Other terms of payment than standard', type: 'checkbox', readonly: isIncludedCard, visible: function() { return (paymentMethodIsInvoice && card.cardtype.auto && card.validToDate == null);} },
        {name: 'termsOfPayment', title: 'Terms of payment', type: 'infoNumber', info: 'days', readonly: isIncludedCard, visible: useOtherTermsOfPayment, required: true, min: 1},
        // The checkbox carries the change check because it stays visible; unchecking it
        // is the only thing that clears the card's groups.
        {name: 'connectCardToGroups', title: 'Connect card to groups', required: false, type: 'checkbox', readonly: isIncludedCard, visible: function() { return $rootScope.usergroups.length || $rootScope.speedy; }, helpText: 'CONNECT_CARD_TO_GROUP', change: onConnectCardToGroupsChange, changed: groupsWereCleared },
        {name: 'groups', title: 'Groups', required: false, type: 'groups', readonly: isIncludedCard, visible: shouldDisplayGroups, useId: true, getValue: getGroupsValue },
        {name: 'user_id', title: 'Used by', required: true, type: 'customer', readonly: isIncludedCard || isMainPackageCard, useId: true, visible: function() { return !$rootScope.is_korpen; } },
        {name: 'disconnectFromParent', title: 'Disconnect from parent card', type: 'checkbox', visible: function() { return !!card.parent_trainingcard_id && $rootScope.hasFlag('flag-package-trainingcard'); }, skipChangedCheck: true }
    ];

    var oldSetValues = $scope.setValues;
    $scope.setValues = function(card) {
        card.otherTermsOfPayment = !!$scope.item.termsOfPayment;
        oldSetValues(card);
        var groupsValue = _.findWhere($scope.fields, { name: 'groups'}).value;
        if (groupsValue) {
            _.findWhere($scope.fields, { name: 'connectCardToGroups' }).value = groupsValue.length > 0;
        }
        // Filling the form is not the user clearing the box, even if a caller ever
        // asks setValues to fire the change hooks.
        setGroupsCleared(false);
        var payMethod = _.findWhere($scope.fields, { name: 'payMethod' });
        if (payMethod && !payMethod.value) {
            payMethod.value = _.findWhere(paymentMethods.get(), { id: 'unknown' });
        }

        if(card.cardtype.type == 'resourcebooking' && card.cardtype.service_base_product) {
            _.findWhere($scope.fields, { name: 'trainingsLeft' }).readonly = true;
        }

        if (card.payer_id) {
            _.findWhere($scope.fields, { name: 'otherPayer' }).value = true;
        }
    };
    loadRequiredData().then(function() {
        $scope.setValues(card);
    });

    var oldValuesChanged = $scope.valuesChanged;
    $scope.valuesChanged = function() {
        var termsOfPaymentIntitiallySet = !!$scope.item.termsOfPayment;
        var otherTermsOfPaymentChanged = _.findWhere($scope.fields, { name: 'otherTermsOfPayment' }).value != termsOfPaymentIntitiallySet;
        var otherPayerSet = !!$scope.item.payer_id;
        var otherPayerChanged = _.findWhere($scope.fields, { name: 'otherPayer' }).value != otherPayerSet;
        var disconnectChanged = !!(_.findWhere($scope.fields, { name: 'disconnectFromParent' }) || {}).value;
        return otherTermsOfPaymentChanged || otherPayerChanged || disconnectChanged || oldValuesChanged();
    };

    var confirmChangeTermsOfPayment = function(item) {
        var termsOfPaymentChanged = $scope.item.termsOfPayment != item.termsOfPayment;

        var deferred = $q.defer();
        if (termsOfPaymentChanged) {
            confirm.show('Terms of payment has changed. Do you want to change terms for existing payments?').then(function() {
                item.changeTermsOfPayment = true;
                deferred.resolve();
            }, function() {
                deferred.resolve();
            });
        } else {
            deferred.resolve();
        }
        return deferred.promise;
    };

    var confirmChangeValidDateOrPayment = function(item) {
        var validToDate1 = $scope.item.validToDate && $scope.item.validToDate.getTime();
        var validToDate2 = item.validToDate && Date.newFull(item.validToDate).getTime();
        var validDateAndPaymentChanged = (validToDate1 != validToDate2) || ($scope.item.price != item.price);

        var deferred = $q.defer();
        if (validDateAndPaymentChanged) {
            confirm.show('CHANGE_TRAININGCARD_VALIDATEORPAYMENT_MESSAGE', {yesButtonText: 'Save and continue', noButtonText: 'Close'}).then(function() {
                deferred.resolve();
            }, function() {
                deferred.reject();
            });
        } else {
            deferred.resolve();
        }
        return deferred.promise;
    };

    var confirmChangePayer = function(item) {
        var payerChanged = $scope.item.payer_id != item.payer_id;

        var deferred = $q.defer();
        if (payerChanged) {
            confirm.show('Payer changed. Do you want to change payer for existing payments?').then(function() {
                item.changePayerOfPayments = true;
                deferred.resolve();
            }, function() {
                deferred.resolve();
            });
        } else {
            deferred.resolve();
        }
        return deferred.promise;
    };

    var changeCtrlDoSubmit = $scope.doSubmit;
    $scope.doSubmit = function(item) {
        if (!_.findWhere($scope.fields, { name: 'otherPayer' }).value) {
            item.payer_id = null;
        }

        var disconnectField = _.findWhere($scope.fields, { name: 'disconnectFromParent' });
        if (disconnectField && disconnectField.value) {
            item.parent_trainingcard_id = null;
        }

        confirmChangeValidDateOrPayment(item).then(function() {
            confirmChangeTermsOfPayment(item).then(function() {
                confirmChangePayer(item).then(function() {
                    changeCtrlDoSubmit(item);
                });
            });
        });
    };
}]);

app.controller('TrainingCardConvertModalCtrl', ['$rootScope', '$scope', 'card', '$controller', 'server', 'modalUtils', 'util', 'paymentMethods', function($rootScope, $scope, card, $controller, server, modalUtils, util, paymentMethods) {
    $controller('AddCtrl', {$scope: $scope});

    var validFromDate = new Date();
    $scope.data = {payments: []};

    var getTrainingCards = function() {
        return $rootScope.trainingcardtypes.filter(function(cardtype) {
            if (!cardtype.active || cardtype.id == card.cardtype.id || cardtype.auto != card.cardtype.auto) {
                return false;
            }
            return (cardtype.type === 'trainingcard' || cardtype.type === 'resourcebooking') && cardtype.type == card.cardtype.type;
        });
    };

    function getAlreadyPaid() {
        // Get all paid payments for future periods
        var paid = card.payments.filter(function(p) {
            return p.status == 'paid' && Date.newFull(p.to_date) > validFromDate;
        });

        var totalPaidAmount = 0;

        paid.forEach(function(p) {
            var pfrom = Date.newFull(p.from_date);
            var pto = Date.newFull(p.to_date);
            var pdays = Date.newFull(pfrom).daysUntil(pto) + 1;
            var d = validFromDate.clone();
            var days = 0;
            while (true) {
                if (d.withinRange(pfrom, pto)) {
                    days += 1;
                }
                if (Date.dateEqualsObjects(pto,d)) {
                    break;
                }
                d.addDays(1);
            }
            totalPaidAmount += Number(p.amount) * (days / pdays);
        });

        return Math.round(totalPaidAmount);
    }

    function getDaysFromType(t) {
        if (t == 'Month') {
            return 30;
        } else if (t == 'Year') {
            return 365;
        } else if (t == 'HalfYear') {
            return 182;
        } else if (t == 'Quarter') {
            return 91;
        } else if (t == 'Week') {
            return 7;
        } else if (t == 'Day') {
            return 1;
        }
    }

    function getCostPerDay(cardtype, price) {
        var perday = 0;
        if ([null, 'OneTime'].includes(cardtype.priceType)) {
            var days = card.validTime * getDaysFromType(cardtype.validType);
            perday = Number(price) / days;
        } else {
            var days = getDaysFromType(cardtype.priceType);
            perday = Number(price) / days;
        }
        return perday;
    }

    var hasSavedCard = function() {
        var user = $rootScope.getMember(card.user_id);
        var payer = $rootScope.getMember(user.paidBy || user.id);
        return payer.hasSavedCardForSelectedLegalEntity();
    };

    function updatePayments() {
        var tc = _.findWhere($scope.fields, {name: 'cardtype_id'}).value;
        var date = Date.newFull(validFromDate);
        var price = _.findWhere($scope.fields, {name: 'price'}).value;
        var paymentMethod = _.findWhere($scope.fields, {name: 'payMethod'}).value;
        var to_date;
        if (card.cardtype.auto) {
            if (_.findWhere($scope.fields, {name: 'keepBoundToDate'}).value) {
                // Max of boundToDate and calculated date for generation of payments
                var paidUntil = validFromDate.clone().addDays(Math.floor(getAlreadyPaid() / getCostPerDay(tc, price)));
                paidUntil.setDate(paidUntil.getDaysInMonth());
                to_date = new Date(Math.max(paidUntil, card.boundToDate));

                // Generate payments at least to the end of this month
                var endOfThisMonth = Date.today();
                endOfThisMonth.setDate(endOfThisMonth.getDaysInMonth());
                to_date = new Date(Math.max(endOfThisMonth, to_date));
            } else {
                to_date = date.clone().addDays(Math.floor(getAlreadyPaid() / getCostPerDay(tc, price))).addMonths(1);
                to_date.setDate(to_date.getDaysInMonth());
            }
        } else {
            if (_.findWhere($scope.fields, {name: 'keepValidToDate'}).value) {
                to_date = card.validToDate;
            }
        }
       // var join_payments = _.findWhere($scope.fields, {name: 'join_payments'}).value;
        var method = paymentMethod?paymentMethod.id:card.payMethod;
        $rootScope.$broadcast('selectedTrainingCardChanged', {card: tc, date: date, price: price, method: method, join_payments: false, to_date: to_date, already_paid: getAlreadyPaid()});
    }

    function cardChanged() {
        var tc = _.findWhere($scope.fields, {name: 'cardtype_id'}).value;
        _.findWhere($scope.fields, {name: 'price'}).value = tc.price;
        updatePayments();
    }

    $scope.getPayments = function(payMethod, trainingcard_id, customer_id, payer_id) {
        var payments = [];
        for (var i=0; i < $scope.data.payments.length; ++i) {
            var p = $scope.data.payments[i];
            var pay = {};
            pay.date = p.date.yyyymmdd();
            pay.amount = p.amount;
            pay.trainingcard_id = trainingcard_id;
            pay.member_id = customer_id;
            pay.method = payMethod;
            if (customer_id) {
                var paidBy = $rootScope.getMember(customer_id).paidBy;
                pay.payer_id = payer_id || (paidBy ? paidBy : customer_id);
            }
            if(p.from_date) {
                pay.from_date = p.from_date.yyyymmdd();
            }
            if(p.to_date) {
                pay.to_date = p.to_date.yyyymmdd();
            }
            pay.site_id = $rootScope.selectedSite.id;

            payments.push(pay);
        }

        return payments;
    };

    $scope.fields = [
        {name: 'current_card', type: 'label', title: 'Current training card' },
        {name: 'alreadyPaid', type: 'label', title: 'ALREADY_PAID_ONE', format: 'price'},
        {name: 'cardtype_id', type: 'select', title: 'New training card', options: getTrainingCards, useId: true, required: true, change: cardChanged },
        {name: 'validFromDate', type: 'label', title: 'Valid from' },

        {name: 'keepValidToDate', type: 'checkbox', title: 'Keep validity period', change: updatePayments, visible: function() { return !card.cardtype.auto; } },
        {name: 'keepBoundToDate', type: 'checkbox', title: 'Keep bound period', change: updatePayments, visible: function() { return card.cardtype.auto; } },
        {name: 'price', title: 'Price', required: true, type: 'price', change: updatePayments },
        {name: 'payMethod', title: 'Payment method', required: true, type: 'paymentmethod', readonly: false, hasSavedCard: hasSavedCard, options: {change: true}, visible: function() { return true; }, change: updatePayments }
    ];

    util.setValues($scope.fields, {
        current_card: card.cardtype.name,
        alreadyPaid: getAlreadyPaid(),
        validFromDate: validFromDate.yyyymmdd(),
        payMethod: _.findWhere(paymentMethods.get(), {id: (card.payMethod && card.payMethod.id && card.payMethod.id) || 'unknown'})
    });

    $scope.canSubmit = function() {
        if ($scope.data.payments === null) {
            return false;
        }
        return true;
    };

    $scope.submit = function() {
        $scope.loadingStatus.loading = true;
        var newcard = $scope.getSubmitItem();
        if (newcard.keepBoundToDate) {
            delete newcard.keepBoundToDate;
            newcard.boundToDate = card.boundToDate.yyyymmdd();
        }
        if (newcard.keepValidToDate) {
            delete newcard.keepValidToDate;
            newcard.validToDate = card.validToDate.yyyymmdd();
        }
        var payments = $scope.getPayments(newcard.payMethod, null, card.user_id, card.payer_id);
        newcard.member_id = card.user_id;
        newcard.payer_id = card.payer_id;
        newcard._add_payments = payments;
        server.post('/api/trainingcard/cancel', [], {trainingcard_id: card.id, expiryDate: validFromDate.clone().addDays(-1).yyyymmdd(), sendCancelMail: false}, 'Card cancelled', 'Failed to cancel card').then(function(result) {
            if (result.success) {
                server.post('/api/trainingcard/add', newcard, null, 'Training card added', 'Failed to add training card').then(function() {
                    $scope.$close();
                    modalUtils.forceCloseAllModals();
                });
            } else {
                $scope.loadingStatus.loading = false;
            }
        });
    };
}]);

app.controller('StaffChangeModalCtrl', ['$rootScope', '$scope', 'staff', '$controller', function($rootScope, $scope, staff, $controller) {
    $controller('ChangeModalCtrl', {$scope: $scope});

    $scope.item = staff;
    $scope.staff = staff;
    $scope.postUrl = '/api/member/change';

    $scope.titleSuffix = function() {
        return staff.firstname + " " + staff.lastname;
    };

    $scope.getNicePersonalCodeNumber = function() {
        return $rootScope.formatPersonalCodeNumber($scope.staff.personalCodeNumber);
    };

/*    var getFields = function() {
        var skip = ['image', 'extraInfo', 'active'];
        var s = scheme.get('staff');
        var fields = [];
        angular.forEach(s, function(prop) {
            if (skip.indexOf(prop.field) == -1) {
                var p = angular.copy(prop);
                p.name = p.field;
                p.type = 'text';
                fields.push(p);
            }
        });
        $scope.fields = fields;
    };
    getFields();

    // required
    // type
    // password: writeOnly
    // options
*/
    $scope.fields = [
        {name: 'firstname', title: 'First name', required: true, type: 'text'},
        {name: 'lastname', title: 'Last name', required: true, type: 'text'},
        {name: 'personalCodeNumber', title: 'Personal code number', required: false, type: 'personalCodeNumber', ptype: 'staff', original: $scope.staff.personalCodeNumber, setValue: $scope.getNicePersonalCodeNumber },
        {name: 'login_key', title: 'Username', required: true, type: 'loginkey', allow: $scope.staff.id },
        {name: 'mail', title: 'E-mail', required: false, type: 'email'},
        {name: 'phone', title: 'Phone', required: false, type: 'phone'},
        {name: 'oldphone', title: 'Old phone', required: false, type: 'phone'},
        {name: 'address', title: 'Address', required: false, type: 'text'},
        {name: 'zipCode', title: 'Zip code', required: false, type: 'zipCode'},
        {name: 'city', title: 'City', required: false, type: 'text'},
        {name: 'roles', title: 'Roles', required: false, type: 'multiselect', options: function() { return $rootScope.roles; } },
        {name: 'groups', title: 'Groups', required: false, type: 'multiselect', options: function() { return $rootScope.usergroups; }, useId: true },
        {name: 'responsible_id', title: 'Responsible', required: false, helpText:'Responsible helptext', placement:'top', type: 'customer', itemTypes: ['staff'], useId: true, itemFilter: function(s){return s != $scope.staff;}},
        {name: 'sites', title: 'Sites', required: true, type: 'multiselect', options: function() { return $rootScope.sites; }, placeholder: 'Choose site', visible: function() { return $rootScope.hasModule('MultiSite'); }, useId: true },
        {name: 'bookableForCustomer', title: 'Bookable for customer', required: true, type: 'checkbox'},
        {name: 'allowPush', title: 'Allow push notifications', required: true, type: 'checkbox', visible: function() { return $rootScope.hasModule('PushNotification'); }},
        {name: 'description', title: 'Description', required: false, type: 'textarea'},
        {name: 'tags', title: 'Tags', required: false, type: 'systemtag'}
    ];

    $scope.setValues($scope.staff);
}]);

app.controller('RoleChangeModalCtrl', ['$scope', 'role', '$controller', '$filter', 'server', '$rootScope', function($scope, role, $controller, $filter, server, $rootScope) {
    $controller('ChangeModalCtrl', {$scope: $scope});

    $scope.item = role;
    $scope.role = role;
    $scope.postUrl = '/api/staff/roles/change';

    $scope.titleSuffix = function() {
        return $filter('translate')(role.name);
    };

    function getPermissions() {
        return server.get('/api/staff/permissions/get').then(function(permissions) {
            permissions.forEach(function(p) {
                p.name = $filter('translate')(p.id);
            });
            $scope.permissions = permissions;
        });
    }

    var accessGlobalOption = function() {
        return $rootScope.currentStaff.exportObjects && $rootScope.hasPermission('Chain settings');
    };

    getPermissions().then(function() {
        $scope.fields = [
            {name: 'name', title: 'Name', required: true, type: 'text' },
            {name: 'tasks', title: 'Access right', required: true, type: 'multiselect', options: function() { return $scope.permissions; }, useId: true },
            {name: 'is_global', title: 'Chain', type: 'checkbox', visible: function(field) { return field.value || accessGlobalOption();}}
        ];

        if($scope.role.is_global && !accessGlobalOption()) {
            $scope.fields.forEach(function(field) {field.readonly = true;});
        }

        $scope.setValues($scope.role);
    });
}]);

app.directive('customernamelist', ['$rootScope', function($rootScope) {
    return {
        restrict: 'E',
        scope: {
            members: '=',
            canChange: '=',
            onChangeClick: '&'
        },
        template: `
            <span>
                <a ng-repeat="p in mappedMembers track by p.id" ng-href="#/customer/show/{{p.id}}">
                    {{p.name}}{{$last ? "" : ", "}}
                </a>
            </span>
            <span ng-if="canChange">&nbsp;<a href ng-click="change(true)" style="color: #0000EE">Ändra</a></span>
        `,
        link: function(scope) {
            // Function to map members using getMember
            function mapMembers() {
                scope.mappedMembers = scope.members?.map($rootScope.getMember);
            }

            // Initial mapping
            mapMembers();

            // Watcher for changes to members
            scope.$watch('members', function() {
                mapMembers();
            });

            scope.$on('ApiDataLoaded', function(event, uid) {
                // Check if the loaded user is in the members list and update mapping if needed
                if (scope.members?.some(member => member.uid === uid)) {
                    mapMembers();
                }
            });

            scope.change = function() {
                scope.onChangeClick();
            };
        }
    };
}]);

app.directive('groupnamelist', ['$rootScope', function($rootScope) {
    return {
        restrict: 'E',
        scope: {
            groups: '='
        },
        template: `
            <span>
                <a href ng-repeat="p in mappedGroups track by p.id" ng-click="showGroup(p)">
                    {{p.name}}{{$last ? "" : ", "}}
                </a>
            </span>
        `,
        link: function(scope) {
            scope.showGroup = $rootScope.showGroup;
            // Function to map members using getMember
            function mapGroups() {
                scope.mappedGroups = scope.groups?.map($rootScope.getGroup);
            }

            // Initial mapping
            mapGroups();

            // Watcher for changes to members
            scope.$watch('usergroups', function() {
                mapGroups();
            });

            scope.$on('ApiDataLoaded', function(event, uid) {
                // Check if the loaded user is in the members list and update mapping if needed
                if (scope.groups?.some(group => group.uid === uid)) {
                    mapGroups();
                }
            });
        }
    };
}]);

app.directive('userConsent', ['$rootScope', 'server', '$filter', 'live', function($rootScope, server, $filter, live) {
    // Shared cache for consent requests across all directive instances
    let consentCache = {};
    let cachedLegalEntityId = null;

    return {
        restrict: 'E',
        scope: {
            user: '='
        },
        template: `
            <span>
                {{ consentDisplayValue }}
            </span>
        `,
        link: function(scope) {
            let currentLegalEntityId = null;

            function fetchConsent(forceRefresh) {
                if (!$rootScope.selectedSite) return;

                const legalEntityId = $rootScope.selectedSite.legal_entity_id;

                if (!forceRefresh && legalEntityId == currentLegalEntityId) return;
                currentLegalEntityId = legalEntityId;

                // Clear cache if legal entity changed
                if (cachedLegalEntityId !== legalEntityId) {
                    consentCache = {};
                    cachedLegalEntityId = legalEntityId;
                }

                const cacheKey = scope.user.id + '_' + legalEntityId;

                // Clear cache entry if forcing refresh
                if (forceRefresh) {
                    delete consentCache[cacheKey];
                }

                scope.consentDisplayValue = $filter('translate')('Loading...');

                // Use cached promise if available
                if (!consentCache[cacheKey]) {
                    consentCache[cacheKey] = server.get('/api/directdebit/consent/get', {user_id: scope.user.id, legal_entity_id: legalEntityId});
                }

                consentCache[cacheKey].then(function(result) {
                    const hasConsent = result && result.user_id == scope.user.id;

                    if (hasConsent) {
                        scope.consentDisplayValue = $filter('translate')(result.consent_sent ? 'Request sent' : 'Approved for direct debit') + '. ' + $filter('translate')('Payer number') + ': ' + result.payer_number;
                    } else {
                        scope.consentDisplayValue = $filter('translate')('Consent missing');
                    }
                }).catch(function() {
                    delete consentCache[cacheKey];
                    scope.consentDisplayValue = $filter('translate')('Error');
                });
            }

            scope.pubsub('selectedSite', function() {
                fetchConsent();
            });

            live.subscribe({
                type: 'user',
                scope: scope,
                callback: function(user) {
                    if (user.id === scope.user.id) {
                        fetchConsent(true);
                    }
                }
            });

            fetchConsent();
        }
    };
}]);

app.controller('CustomerCtrl', ['$rootScope', '$scope', '$routeParams', '$http', '$modal', '$location', '$filter', '$q', 'usSpinnerService', 'alertProvider', 'server', 'confirm', 'workoutProvider', 'formatter', 'image', 'paymentMethods', 'util', 'fileManager', 'Setting', 'EntryService', '$injector', 'contractManager', 'courseutil', 'Data', 'eventlog', 'Link', 'recent', 'resourceBooking', 'BankAccount', 'CreditPaymentDialog', 'legalEntity',
    function($rootScope, $scope, $routeParams, $http, $modal, $location, $filter, $q, usSpinnerService, alertProvider, server, confirm, workoutProvider, formatter, image, paymentMethods, util, fileManager, Setting, EntryService, $injector, contractManager, courseutil, Data, eventlog, Link, recent, $resourceBooking, BankAccount, CreditPaymentDialog, legalEntity) {
    $scope.data = {};

    // Check if account was created with apples private relay and is therefore missing required information
    $scope.missingRequiredMemberFields = () => {
        return $rootScope.fields.user.find(f => f.type != 'password' && f.required && f.show && !$scope.customer[f.name] && $scope.customer.mail?.endsWith('privaterelay.appleid.com'));
    }

    $scope.buildInfoPanel = function() {
        var hasAddress = function() {
            var f = _.findWhere($rootScope.fields.user, {name: 'address'});
            return f && f.show;
        };
        var showField = function(field) {
            var bf = function(name) {
                return field.name == name && field.builtIn;
            };
            var show = field.show && !bf('firstname') && !bf('lastname') && field.type != 'password' && field.type != 'map';
            if (show) {
                if (field.name == 'zipCode' || field.name == 'city') {
                    show = !hasAddress();
                }
            }
            return show;
        };
        var hasValue = function(field) {
            var v = field.getFieldValue();
            return v !== undefined && v !== null && v.length != 0;
        };
        var getTitle = function(field) {
            if (field.builtIn && field.name == 'personalCodeNumber' && $scope.customer.company) {
                return 'Corporate identity';
            }
            return field.title;
        };
        var getFieldValue = function(field) {
            if (field.builtIn && field.name == 'address') {
                var res = $scope.customer.address || '';
                if (res.length && ($scope.customer.zipCode || $scope.customer.city)) {
                    res += ', ';
                }
                if ($scope.customer.zipCode) {
                    res += $scope.customer.zipCode + ' ';
                }
                if ($scope.customer.city) {
                    res += $scope.customer.city;
                }
                return res;
            }
            return field.builtIn ? $scope.customer[field.name] : $scope.customer.xf?.[field.name];
        };

        var red = function() {
            return {color: 'red'};
        };

        $scope.infoFields = $rootScope.fields.user.filter(showField).map(function(field) {
            return {sort: field.builtIn ? 0 : 1, icon: field.icon, name: field.name, data: field.data, title: getTitle(field), type: field.type, getFieldValue: function() { return getFieldValue(field); } };
        }).filter(hasValue);

        // Show value card field only if there's value card amount for current legal entity
        if ($scope.customer.getValueCardAmountForSelectedLegalEntity?.()) {
            $scope.infoFields.push({sort: 2, icon: 'icon glyphicon glyphicon-usd', name: 'money', type: 'price', title: 'Value card', getFieldValue: () => $scope.customer.getValueCardAmountForSelectedLegalEntity(), getStyle: function() { return {color: 'green'}; } });
        }

        if ($rootScope.hasModule('LoyaltyPoints')) {
            $scope.infoFields.push({sort: 2, icon: 'icon glyphicon glyphicon-usd', name: 'points', type: 'loyaltypoints', title: 'Points', getFieldValue: function() { return $scope.customer.points; }, getStyle: function() { return {color: 'green'}; } });
        }

        if ($rootScope.hasPermission('Bank account') && $scope.customer.bankaccount && $scope.customer.bankaccount.length) {
            var bankAccountName = {
                bankgiro: 'Bankgiro',
                /* plusgiro: 'Plusgiro', not implemented */
                bankaccount: 'Bank account'
            };
            $scope.infoFields.push({
                sort: 2,
                icon: 'icon glyphicon glyphicon-info-sign',
                name: 'points',
                type: 'text',
                title: 'Account for payment',
                getFieldValue: function() {
                    return $scope.customer.bankaccount.map(function(ba) {return bankAccountName[ba.type] || ba.type;}).join(', ');
                }
            });
        }

        if ($rootScope.hasPermission('Consent handling')) {
            $scope.infoFields.push({sort: 2, icon: 'icon fa fa-retweet', name: 'consent', type: 'consent', title: 'Direct debit', getFieldValue: () => $scope.customer});
        }

        if ($rootScope.hasPermission('Show payments') && ($rootScope.hasModule('CardPayment') || $rootScope.hasModule('Adyen')) && $scope.customer.hasSavedCardForSelectedLegalEntity()) {
            $scope.infoFields.push({sort: 2, icon: 'icon fa fa-retweet', name: 'savedCard', type: 'text', title: 'Card payment', getFieldValue: function() { return $filter('translate')('Has saved card information'); }});
        }

        if ($scope.debts && $scope.debts.length) {
            $scope.debts.forEach(function(debt) {
                $scope.infoFields.push({sort: 2, icon: 'icon glyphicon glyphicon-usd', name: 'debt', title: 'Debt', type: 'debt', getFieldValue: function() { return debt; }, getStyle: red });
            });
        }

        if ($scope.customer.paidBy) {
            $scope.infoFields.push({sort: 2, icon: 'icon glyphicon glyphicon-usd', name: 'paidBy', title: 'Paid by', type: 'customer', getFieldValue: function() { return $rootScope.getMember($scope.customer.paidBy); } });
        }

        if ($scope.customer.paysFor && $scope.customer.paysFor.length) {
            $scope.infoFields.push({sort: 2, icon: 'icon glyphicon glyphicon-usd', name: 'paysFor', title: 'Pays for', type: 'customers', getFieldValue: function() { return $scope.customer.paysFor.map($rootScope.getMember); } });
        }

        if ($scope.getFamily().length) {
            $scope.infoFields.push({sort: 2, icon: 'icon fa fa-users', name: 'family', type: 'family', title: 'Family', getFieldValue: function() { return $scope.getFamily($rootScope.getMember); } });
        }

        if ($rootScope.hasModule('Warning') && $scope.customer.warnings) {
            $scope.infoFields.push({sort: 2, icon: 'icon glyphicon glyphicon-warning-sign', name: 'warnings', type: 'number', title: 'Warnings', getFieldValue: function() { return $scope.customer.warnings; }, getStyle: red });
        }

        if ($rootScope.hasModule('Warning') && $scope.customer.blockedDate) {
            $scope.infoFields.push({sort: 2, icon: 'icon glyphicon glyphicon-ban-circle', name: 'warnedUntil', type: 'date', title: 'Warned until', getFieldValue: function() { return $scope.customer.blockedDate; }, getStyle: red });
        }

        if ($rootScope.hasModule('Entry') && $scope.showEntryCard && $scope.customer.entry_card_value) {
            $scope.infoFields.push({sort: 0, icon: 'icon glyphicon glyphicon-credit-card', name: 'entry_card', type: 'text', title: 'Entry card', getFieldValue: function() { return $scope.customer.entry_card_value; } });
        }

        if ($rootScope.memberstatuses.length) {
            $scope.infoFields.push({sort: 3, icon: 'icon glyphicon glyphicon-thumbs-up', name: 'status', title: 'Status', type: 'status', getFieldValue: function() { return $scope.customer.status; } });
        }

        $scope.infoColumns = {};

        var props = {
            0: ['homesite_id', 'responsible', 'mail', 'login_key', 'personalCodeNumber', 'birthdate', 'gender', 'phone', 'oldphone', 'address', 'memberNumber', 'interest', 'entry_card', 'bookers', 'canBookFor'],
            1: [],
            2: [],
            3: []
        };

        $scope.infoFields = Array.mergeSort($scope.infoFields, function(a, b) {
            if (a.sort == b.sort) {
                var ai = props[a.sort].indexOf(a.name);
                var bi = props[b.sort].indexOf(b.name);
                if (ai != -1 && bi != -1) {
                    return ai < bi ? -1 : (ai > bi ? 1 : 0);
                } else {
                    var atitle = $filter('translate')(a.title);
                    var btitle = $filter('translate')(b.title);
                    return Array.defaultCompare(atitle, btitle);
                }
            } else if (a.sort < b.sort) {
                return -1;
            } else if (b.sort < a.sort) {
                return 1;
            }
        });

        $scope.numInfoColumns = $scope.infoFields.length < 5 ? 1 : 2;
        if ($(window).width() < 1000) {
            $scope.numInfoColumns = 1;
        }
        var perColumn = Math.floor($scope.infoFields.length / $scope.numInfoColumns);
        var extra_for_first =  $scope.infoFields.length - ($scope.numInfoColumns * perColumn);
        for(var i=0; i < $scope.numInfoColumns; ++i) {
            var from = i*perColumn + (i > 0 ? extra_for_first : 0);
            var to = from+perColumn + extra_for_first;
            $scope.infoColumns[i] = $scope.infoFields.slice(from, to);
        }
    };
    $scope.$watchGroup([
            function() { return $scope.customer && $rootScope.fields.user && $rootScope.fields.user.length; },
            function() { return $scope.debts; },
            function() { return $scope.showEntryCard; }],
        function() {
            if ($scope.customer && $rootScope.fields.user.length) {
                $rootScope.waitFor(['memberstatuses']).then($scope.buildInfoPanel);
        }
    });

    $scope.calcHeightOfMap = function() {
        var ci = $('#customerimage').height();
        var cp = $('#customercardinfopanel').height();
        var val = (15 + cp - ci);
        if (!ci || !cp || ci < 50 || !$scope.customer || !$scope.fields.user || !$scope.fields.user.length) {
            val = 0;
        }
        val = Math.min(ci, val);
        return {height: val + 'px' };
    };

    $scope.showImage = function() {
        $modal.open({
            templateUrl: '/views/image.html',
            controller: 'ImageModalCtrl',
            resolve: {
                customer: function() {
                    return $scope.customer;
                }
            }
        });
    };

    $scope.getFamily = function() {
        var lists = ['canBookFor', 'canManage', 'managers', 'bookers'];
        var family = [];
        lists.forEach(function(list) {
            family.push.apply(family, $scope.customer[list]);
        });
        return _.uniq(family);
    };

    Setting.get('Entry').then(function(data) {
        $scope.showEntryCard = data.show_card;
    });

    function getUserRemoveDate() {
        server.get('/api/user/get_remove_date', {user_id: $routeParams.customerId}).then(function(result) {
            $scope.remove_date = result.date;
        });
    }

    $scope.registerCard = function() {
        EntryService.entyCardDialog($scope.customer).then(function(result) {
            if (result.remove) {
                server.post('/api/card/remove', null, {user_id: $scope.customer.id}, '{0} was removed', 'Failed to remove {0}', 'Card');
            } else {
                server.post(
                    '/api/card/set', null,
                    {
                        user_id: $scope.customer.id,
                        cardId: result.value,
                        pin:    result.pin,
                        manual: result.manual
                    },
                    'Card/tag registered', 'Failed to register card/tag'
                );
            }
        });
    };

    $scope.originalImageSrc = function(size) {
        return $rootScope.memberImage($scope.customer, size);
    };

    $scope.change = function(family) {
        util.showDataDialog({controller: 'CustomerDataCtrl', item: $scope.customer, options: {tab: family ? 'Family' : null}});
    };

    $scope.openFileManager = function() {
        fileManager.open({
            originId: $scope.customer.id,
            originType: 'user',
            visibleTabs: 'files'
        });
    };

    $scope.openContractManager = function() {
        contractManager.open({
            originId: $scope.customer.id,
            originType: 'contract'
        });
    };

    $scope.showWarnings = function() {
        $modal.open({
            templateUrl: '/views/warnings.html',
            controller: 'WarningsCtrl',
            windowClass: 'huge-modal-window',
            resolve: {
                customer: function() {
                    return $scope.customer;
                }
            }
        });
    };

    $scope.showBlocks = function() {
        $modal.open({
            templateUrl: '/views/blocks.html',
            controller: 'BlocksCtrl',
            windowClass: 'very-large-modal-window',
            resolve: {
                customer: () => $scope.customer
            }
        });
    };

    $scope.journal = function() {
        $location.path('/customer/journal/' + $scope.customer.id);
    };

    $scope.sendSms = function() {
        $modal.open({
            templateUrl: 'views/sms.html',
            controller: 'SMSMultiModalCtrl',
            resolve: {
                sendlist: function() {
                    return [$scope.customer];
                }
            }
        });
    };

    $scope.sendMail = function() {
        $modal.open({
            templateUrl: 'views/mail.html',
            controller: 'MailMultiModalCtrl',
            resolve: {
                sendlist: function() {
                    return [$scope.customer];
                }
            }
        });
    };
    $scope.sendMailing = function() {
        $scope.pubsub.publish('newmailingdata', {
            isNewsOrAdvertising: false,
            sendOption: 'mail',
            receivers: [$scope.customer],
            options: { 'callCloseOnSuccess': true, 'modalMode': false, noRedirect: true}
        });
        $modal.open({
            templateUrl: 'views/mailingnew.html',
            windowClass: 'huge-modal-window',
            controller: 'NewMailingCtrl'
        }).result.then($scope.$close);
    }

    $scope.showMessageHistory = function() {
        $modal.open({
            templateUrl: 'views/membermessagehistorymodallist.html',
            controller: 'MemberMessageHistoryModalCtrl',
            windowClass: 'very-large-modal-window',
            resolve: {
                member: function() {
                    return $scope.customer;
                }
            }
        });
    };

    $scope.showPointsHistory = function() {
        $modal.open({
            templateUrl: 'views/loyaltypointshistory.html',
            controller: 'LoyaltyPointsHistoryCtrl',
            resolve: {
                customer: function() {
                    return $scope.customer;
                }
            }
        });
    };

    $scope.cancelRBooking = function(rbooking) {
        confirm.show('Are you sure you want to remove the booking?', {ladda: true}).then(function(resolve) {
            var args = {booking: rbooking.id};
            if (rbooking.parent_id) {
                args.all = true;
                args.sameDateOnly = true;
            }
            server.post('/api/resourcebooking/cancel', null, args, 'Booking removed', 'Failed to remove booking').then(function(result) {
                resolve();
                if(result.success && result.data.alert) {
                    alertProvider.modal('Booking removed', result.data.alert);
                }
            });
        });
    };

    var confirmBooking = function(rb) {
        server.post('/api/resourcebooking/confirm', null, {booking: rb.id}, 'Booking confirmed', 'Failed to confirm booking');
    };

    $scope.rebookRBooking = function(rbooking) {
        $resourceBooking.get(rbooking.id).then(function(rbooking) {
            $modal.open({
                templateUrl: 'views/rebookrbookingmodal.html',
                controller: rbooking.service.category.multiBooking ? 'RebookResourceMultiBookingModalCtrl' : 'RebookResourceBookingModalCtrl',
                windowClass: 'huge-modal-window',
                resolve: {
                    rbooking: function() {
                        return rbooking;
                    }
                }
            });
        });
    };

    $scope.rbbook = function(category) {
        $modal.open({
            templateUrl: category.multiBooking ? 'views/rbookingmultimodal.html' : 'views/rbookingmodal.html',
            controller: category.multiBooking ? 'ResourceBookingMultiBookModalCtrl' : 'ResourceBookingBookModalCtrl',
            windowClass: 'huge-modal-window',
            resolve: {
                category: function() {
                    return category;
                },
                customer: function() {
                    return $scope.customer;
                }
            }
        });
    };

    $scope.trainingcardChange = function(card) {
        $modal.open({
            templateUrl: 'views/changetrainingcard.html',
            controller: 'TrainingCardChangeModalCtrl',
            resolve: {
                card: function() {
                    return card;
                },
                parentCardName: function() {
                    if (!card.parent_trainingcard_id || !$scope.trainingcards) return null;
                    var parent = _.findWhere($scope.trainingcards, {id: card.parent_trainingcard_id});
                    return parent ? parent.cardtype_name : null;
                },
                includedCardNames: function() {
                    if (!$scope.trainingcards) return [];
                    return $scope.trainingcards.filter(function(tc) { return tc.parent_trainingcard_id === card.id; }).map(function(tc) { return tc.cardtype_name; });
                }
            }
        });
    };

    $scope.addTrainingCard = function(membership, validFromDate) {
        $rootScope.openTrainingCardSale($scope.customer, {
            membership: membership,
            validFromDate: validFromDate
        });
    };

    $scope.book = function() {
        $modal.open({
            templateUrl: 'views/addbookingmodal.html',
            controller: 'BookingAddModalCtrl',
            resolve: {
                customer: function() {
                    return $scope.customer;
                }
            }
        });
    };

    var showCannotRemoveModal = function() {
        $modal.open({
            templateUrl: 'views/infomodal.html',
            controller: 'ModalCtrl',
            resolve: {
                options: function() {
                    return {title: 'Cannot remove customer', content: 'CANNOT_REMOVE_CUSTOMER_MESSAGE'};
                }
            }
        });
    };

    var showRemoveDialog = function() {
        $modal.open({
            templateUrl: 'views/removecustomer.html',
            controller: 'RemoveCustomerCtrl',
            resolve: {
                customer: function() {
                    return $scope.customer;
                }
            }
        });
    };

    $scope.remove = function() {
        $http.get('/api/member/canBeRemoved?id=' + $scope.customer.id).success(function(data) {
            if (!data.result) {
                showCannotRemoveModal();
            } else {
                showRemoveDialog();
            }
        });
    };

    $scope.undoRemove = function() {
        server.post('/api/user/undo_remove', null, {id: $scope.customer.id});
    };

    $scope.makeProtected = function() {
        var message = $filter('translate')('PROTECTEDINFO').format($scope.customer.name);
        confirm.show(message, { ladda:true }).then(function(done) {
            server.post('/api/member/makeprotected', null, {user_id: $scope.customer.id}, 'Successfully marked person as protected', 'Failed to mark person as protected').then(done);
        });
     };

    $scope.merge = function() {
        $modal.open({
            templateUrl: 'views/merge.html',
            controller: 'MergeModalCtrl',
            windowClass: 'huge-modal-window',
            resolve: {
                customer: function() {
                    return $scope.customer;

                }
            }
        });
    };

    $scope.resendWelcomeMail = function() {
        $scope.resendingWelcomeMail = true;
        server.post('/api/member/resendWelcomeMail', null, {member: $scope.customer.id}, 'Mail sent', 'Failed to send mail').then(function() {
            $scope.resendingWelcomeMail = false;
        });
    };

    $scope.requestPasswordReset = function() {
        $modal.open({
            templateUrl: 'views/addmodal.html',
            controller: 'ResetPasswordModalCtrl',
            resolve: {
                customer: function() {
                    return $scope.customer;

                },
                isStaff: function() {
                    return false;
                }
            }
        });
    };

    $scope.getUserData = function() {
        $scope.gettingUserData = true;
        server.post('/api/user/get_user_data', null, {user_id: $scope.customer.id}, null, null, null, {responseType: 'blob'}).then(function(result) {
            $scope.gettingUserData = false;
            if (result.success) {
                util.download($filter('translate')('User data') + '_' + $scope.customer.id + '.zip', null, null, result.data);
            }
        });
    };

    $scope.updateCard = function() {
        var deferred = $q.defer();
        server.post('/api/card/set', null, {user_id: $scope.customer.id, cardId: $scope.data.card}, 'Card/tag registered', 'Failed to register card/tag').then(function() {
            deferred.resolve();
        });
        return deferred.promise;
    };

    $scope.changeConsent = function() {
        const legal_entity_id = $rootScope.selectedSite.legal_entity_id;
        server.get('/api/directdebit/consent/get', {user_id: $scope.customer.id, legal_entity_id}).then(function(result) {
            const hasConsent = result && result.user_id == $scope.customer.id;
            $modal.open({
                templateUrl: hasConsent ? 'views/removeconsent.html' : 'views/directdebitaddmodal.html',
                controller: hasConsent ? 'DirectDebitChangeModalCtrl' : 'DirectDebitAddModalCtrl',
                resolve: {
                    customer: function() {
                        return $scope.customer;
                    },
                    consent: hasConsent ? function() {
                        return result;
                    } : undefined
                }
            });
        });
    };

    $scope.changeEInvoice = function() {
        $modal.open({
            templateUrl: 'components/einvoice/einvoice.html',
            controller: 'EInvoiceAddCtrl',
            resolve: {
                options: function() {
                    return {customer: $scope.customer};
                }
            }
        });
    };

    $scope.lockerRent = function() {
        $modal.open({
            templateUrl: '/views/lockerrentalmodal.html',
            controller: 'LockerRentalModalCtrl',
            resolve: {
                customer: function() {
                    return $scope.customer;
                },
                trainingcards: function() {
                    return $scope.trainingcards;
                }
            }
        });
    };

    var getDebts = () => $injector.get('payment').getDebtsList($scope.payments, $scope.customer);

    var updatePaymentTables = function() {
        $scope.debts = getDebts();
    };

    $scope.addPayment = function() {
        $modal.open({
            templateUrl: 'views/addmodal.html',
            controller: 'PaymentAddModalCtrl',
            resolve: {
                customer: function() {
                    return $scope.customer;
                }
            }
        });
    };

    $scope.changePaymentMethod = function() {
        $modal.open({
            templateUrl: 'views/changepaymentmethod.html',
            controller: 'PaymentMethodChangeModalCtrl',
            resolve: {
                customer: function() {
                    return $scope.customer;
                }
            }
        });
    };

    $scope.refillValueCard = function() {
        $modal.open({
            templateUrl: 'views/refillvaluecard.html',
            controller: 'RefillValueCardCtrl',
            resolve: {
                customer: function() {
                    return $scope.customer;
                }
            }
        });
    };

    $scope.repayValueCard = function() {
        $modal.open({
            templateUrl: 'views/repayvaluecard.html',
            controller: 'RepayValueCardCtrl',
            resolve: {
                customer: function() {
                    return $scope.customer;
                }
            }
        });
    };

    var isProduct = function(card) {
        if (card.cardtype_id) {
            var product = $rootScope.getPointerById(card.cardtype_id, $rootScope.trainingcardtypes);
            if (product) {
                return $rootScope.isProduct(product);
            }
        }
    };

    var cancelTrainingCard = function(card) {
        $modal.open({
            templateUrl: 'views/cancelcard.html',
            controller: 'CancelCardCtrl',
            resolve: {
                card: function() {
                    return card;
                },
                allTrainingCards: function() {
                    return $scope.trainingcards || [];
                }
            }
        });
    };

    var resumeTrainingCard = function(card) {
        server.post('/api/trainingcard/change', {id: card.id, validToDate: null}, null, 'Card resumed', 'Failed to resume card');
    }

    var resumeCardConfirmaton = function(card) {
        confirm.show('CHANGE_TRAININGCARD_VALIDATEORPAYMENT_MESSAGE', {yesButtonText: 'Save and continue', noButtonText: 'Close'}).then(function() {
            resumeTrainingCard(card);
        });
    }

    var freezeTrainingCard = function(card) {
        $modal.open({
            templateUrl: 'views/freezecard.html',
            controller: 'FreezeCardCtrl',
            resolve: {
                card: function() {
                    return card;
                },
                allTrainingCards: function() {
                    return $scope.trainingcards || [];
                }
            }
        });
    };

    var unfreezeTrainingCard = function(card) {
        $modal.open({
            templateUrl: 'views/unfreezecard.html',
            controller: 'UnfreezeCardCtrl',
            resolve: {
                card: function() {
                    return card;
                },
                allTrainingCards: function() {
                    return $scope.trainingcards || [];
                }
            }
        });
    };

    var getActiveFreeze = function(card) {
        var today = Date.today();
        var activeFreezes = card.freezes.filter(function(freeze) {
                return (freeze.toDate >= today && freeze.fromDate <= today);
            });
        if (activeFreezes.length) {
            return activeFreezes[0];
        }
    };

    var getFreezing = function(card) {
        var today = Date.today();
        if (card.freezes && card.freezes.length) {
            var activeFreeze = getActiveFreeze(card);
            if (activeFreeze) {
                return activeFreeze.fromDate.yyyymmdd() + ' - ' + activeFreeze.toDate.yyyymmdd();
            }

            var comingFreezes = card.freezes.filter(function(freeze) {
                return freeze.toDate > today;
            });
            var freezes = _.map(comingFreezes, function(card) {
                return card.fromDate.yyyymmdd() + ' - ' + card.toDate.yyyymmdd();
            });
            return freezes.join(', ');
        }
    };

    var hasPendingFreezes = function(card) {
        var today = Date.today();
        if (card.freezes && card.freezes.length) {
            var freezes = card.freezes.filter(function(freeze) {
                return freeze.toDate >= today;
            });
            return freezes.length > 0;
        }
    };

    function isMyCard(card) {
        return card.user_id == $scope.customer.id;
    }

    function isGroupCard(card) {
        return card.groups.length > 0;
    }

    function isIncludedCard(card) {
        return !!card.parent_trainingcard_id && $rootScope.hasFlag('flag-package-trainingcard');
    }

    function changeOwner(card) {
        $modal.open({
            templateUrl: 'views/getcustomermodal.html',
            windowClass: 'huge-modal-window',
            controller: 'GetCustomerCtrl',
            resolve: {
                options: function() {
                    return {
                        itemFilter: function(item) {
                            return item.type == 'user' && item != $scope.customer;
                        }
                     };
                }
            }
        }).result.then(function(customer) {
            confirm.show($filter('translate')('Do you want to change owner of this card to {0}?', {ladda: true}).format(customer.name)).then(function() {
                var o = angular.copy(card);
                o.user_id = customer.id;
                server.post('/api/trainingcard/change', o, null, 'Information saved', 'Failed to save information');
            });
        });
    }

    function getCurrentDiscount(card) {
        let price = Number(card.price || 0);

        // First try card's own discount properties
        let fixed = Number(card.discount_fixed || 0);
        let percent = Number(card.discount_percent || 0);
        let date_valid = !card.discount_to_date || Date.newFull(card.discount_to_date).isFutureDate(true);

        if ((fixed || percent) && date_valid) {
            // Price rules persist the discount rounded to a whole krona; legacy discount
            // products keep the öre. Mirror the source so the price matches what is charged.
            // A lingering pricerule_id must not win over a discount product that replaced it.
            let fromPriceRule = card.pricerule_id && !card.discount_id;
            let amount = price * (percent / 100) + fixed;
            amount = fromPriceRule ? Math.round(amount) : Number(amount.toFixed(2));
            // Return the discount AMOUNT (not the discounted price), clamped to [0, price]
            return Math.min(amount, price);
        }

        // Fallback: Sum up discounts from all payments for the current period
        let today = Date.today();
        let periodPayments = (card.payments || []).filter(x => today.withinRange(x.from_date, x.to_date));
        let totalAmount = periodPayments.reduce((sum, p) => sum + Number(p.amount || 0), 0);
        let totalDiscount = periodPayments.reduce((sum, p) => sum + Number(p.discount || 0), 0);
        if (totalDiscount > 0 && (totalAmount + totalDiscount) > 0) {
            return Math.round((totalDiscount / (totalAmount + totalDiscount)) * price);
        }

        return 0;
    }

    $scope.validTrainingCardsControl = {};
    var getParentCardName = function(card) {
        if (!card.parent_trainingcard_id || !$scope.trainingcards) return null;
        var parent = _.findWhere($scope.trainingcards, {id: card.parent_trainingcard_id});
        return parent ? parent.cardtype_name : null;
    };

    $scope.validTrainingCardsConfig = {
        getItems: function() {
            return $scope.trainingcards;
        },
        itemFilter: function(card) {
            return !isProduct(card) && card.type != 'course' && (card.trainingsLeft == null || (card.trainingsLeft > 0 || card.boundToDate)) && (card.validToDate == null || card.validToDate >= Date.today()) && (card.validFromDate.isPastDate(true));
        },
        rowClick: function(card) {
            if (isMyCard(card)) {
                $scope.trainingcardChange(card);
            }
        },
        rowClass: function() {
            return 'success';
        },
        headerClass: 'glyphicon glyphicon-credit-card',
        hideSearch: true,
        showSum: false,
        columns: [
            {field: 'cardtype_name', title: 'Training card', showHtml: true, getValue: function(card) {
                var name = util.escapeHtml(card.cardtype_name);
                if ($rootScope.hasFlag('flag-package-trainingcard')) {
                    var parentName = getParentCardName(card);
                    if (parentName) {
                        name += ' <span style="color: #888; font-style: italic">(' + $filter('translate')('included in') + ' ' + util.escapeHtml(parentName) + ')</span>';
                    }
                }
                return name;
            }},
            {field: 'trainingsLeft', title: 'Trainings left', getValue: function(card) { return card.trainingsLeft == null ? $filter('translate')('Unlimited') : card.trainingsLeft; } },
            {field: 'validFromDate', title: 'Valid from', format: 'date' },
            {field: 'boundToDate', title: 'Bound to', getValue: function(card) { return formatter.format('date', card.boundToDate) || $filter('translate')('Not bound'); } },
            {field: 'validToDate', title: 'Valid to', getValue: function(card) { return formatter.format('date', card.validToDate) || $filter('translate')('ongoing'); } },
            {
                field: 'price',
                title: 'Price',
                format: 'discountedprice',
                getValue: (card) => {
                    return Number(card.price) - getCurrentDiscount(card);
                },
                getExtraValue: (card) => {
                    return getCurrentDiscount(card);
                }
            },
            {field: 'freezing', title: 'Freezing', getValue: getFreezing },
            legalEntity.column()
        ],
        buttons: [
            { title: 'Change', buttonClass: 'btn-warning', visible: function(card) {return isMyCard(card) && $rootScope.hasPermission('Training card handling');}, onClick: $scope.trainingcardChange },
            { title: 'Cancel card', buttonClass: 'btn-danger', visible: function(card) {return isMyCard(card) && $rootScope.hasPermission('Training card handling') && card.cardtype.auto && !card.validToDate; }, onClick: cancelTrainingCard },
            { title: 'Resume card', buttonClass: 'btn-success', visible: function(card) {return isMyCard(card) && $rootScope.hasPermission('Training card handling') && card.cardtype.auto && !!card.validToDate; }, onClick: resumeCardConfirmaton },
            { title: 'Freeze card', buttonClass: 'btn-info', visible: function(card) {return isMyCard(card) && $rootScope.hasPermission('Training card handling') && !isIncludedCard(card) && !hasPendingFreezes(card); }, onClick: freezeTrainingCard },
            { title: 'Extend freezing', buttonClass: 'btn-info', visible: function(card) {return isMyCard(card) && $rootScope.hasPermission('Training card handling') && !isIncludedCard(card) && hasPendingFreezes(card); }, onClick: freezeTrainingCard },
            { title: 'Unfreeze card', buttonClass: 'btn-info', visible: function(card) {return isMyCard(card) && $rootScope.hasPermission('Training card handling') && !isIncludedCard(card) && hasPendingFreezes(card); }, onClick: unfreezeTrainingCard },
            { title: 'Show payments', buttonClass: 'btn-info', visible: function(card) {return isMyCard(card) && $rootScope.hasPermission('Show payments');}, onClick: function(card) {var payment = $injector.get('payment'); payment.showTrainingCardPayments(card);} },
            { title: 'Group card. Go to owner', buttonClass: 'btn-info', visible: function(card) {return !isMyCard(card); }, onClick: function(card) { $rootScope.gotoCustomer(card.user_id); } },
            { title: 'Change owner', buttonClass: 'btn-warning', visible: function(card) {return isMyCard(card) && isGroupCard(card) && $rootScope.hasPermission('Training card handling'); }, onClick: changeOwner }
        ]
    };

    $scope.futureTrainingCardsControl = {};
    $scope.futureTrainingCardsConfig = angular.copy($scope.validTrainingCardsConfig);
    angular.extend($scope.futureTrainingCardsConfig, {
        itemFilter: function(card) {
            return !isProduct(card) && card.type != 'course' && (card.trainingsLeft == null || card.trainingsLeft > 0) && (card.validToDate == null || card.validToDate.isFutureDate()) && card.validFromDate.isFutureDate();
        },
        rowClass: function() {
            return null;
        }
    });

    $scope.oldTrainingCardsControl = {};
    $scope.oldTrainingCardsConfig = angular.copy($scope.validTrainingCardsConfig);
    angular.extend($scope.oldTrainingCardsConfig, {
        itemFilter: function(card) {
            return !isProduct(card) && (!card.cardtype.resourcebookingservice_id || !card.cardtype.service_base_product) && !((card.trainingsLeft == null || (card.trainingsLeft > 0 || card.boundToDate)) && (card.validToDate == null || card.validToDate >= Date.today()));
        },
        rowClass: function() {
            return null;
        }
    });

    var getCustomerData = function() {
        $scope.getPayments();
        $scope.getRBookings();
        $scope.getTrainingCards();
        if ($scope.customer.marked_for_removal) {
            getUserRemoveDate();
        }
    };

    $scope.waitingWatch = $rootScope.$watch('members', function() {
        var reloadUser = function() {
            reloadUser = angular.noop;
            Data.load('user', Number($routeParams.customerId));
        };
        $scope.customer = $rootScope.getMember(Number($routeParams.customerId));
        if ($scope.customer) {
            $scope.waitingWatch();
            recent.visit($scope.customer);
            getCustomerData();
            $scope.pubsub('settings.fields', function(fields) {
                if(fields.user.filter(function(f) {return f.name === 'interest' && f.show;}).length) {
                    reloadUser();
                }
            }, true);
            if ($rootScope.hasModule('LoyaltyPoints') || $rootScope.hasPermission('Bank account')) {
                reloadUser();
            }
        }
    });

    $scope.$on('ApiDataLoaded', function(event, uid) {
        if ($scope.customer && uid == 'user.' + $scope.customer.id) {
            $scope.buildInfoPanel();
            if ($scope.customer.marked_for_removal && !$scope.remove_date) {
                getUserRemoveDate();
            }
        }
        // Update training cards tables when training card types are loaded (for Speedy mode)
        if ($scope.trainingcards && uid.startsWith('trainingcardtype.')) {
            $scope.validTrainingCardsControl.update?.();
            $scope.futureTrainingCardsControl.update?.();
            $scope.oldTrainingCardsControl.update?.();
        }
    });

    $scope.changeBankAccount = function() {
        BankAccount.changeDialog($scope.customer);
    };

    var getResources = function(rb) {
        var staffs = Array.mergeSort(_.uniq(_.pluck(rb.siblings, 'staff'))).filter(Boolean);
        return formatter.format('commaList', staffs);
    };

    var rbookingsconfigs = {};
    $scope.rbookingsconfig = {
        getItems: function() {
            return $scope.rbookings;
        },
        itemFilter: function(rb) {
            return this.category == rb.category && !rb.cancelled && rb.end.isFuture();
        },
        rowClick: function(rb) {
            $scope.showRBooking(rb);
        },
        hideSearch: true,
        orderColumn: 'start',
        columns: [
            {field: 'start', title: 'Date', format: 'date' },
            {field: 'start', title: 'Time', getValue: $rootScope.getRBookingTime },
            {field: 'service.name', title: 'Service' },
            {field: 'staff.name', title: 'Resource', getValue: getResources },
            {field: 'booker.name', title: 'Booker' }
        ],
        buttons: [
            {title: 'Confirm', buttonClass: 'btn-success', onClick: confirmBooking, visible: function(rb) { return $rootScope.hasPermission('Resource booking') && !rb.confirmed; } },
            {title: 'CANCEL_BOOKING', buttonClass: 'btn-danger', onClick: $scope.cancelRBooking, visible: function(rb) { return $rootScope.hasPermission('Resource booking') && !rb.cancelled; } },
            {title: 'Rebook', buttonClass: 'btn-warning', onClick: $scope.rebookRBooking, visible: function(rb) { return $rootScope.hasPermission('Resource booking') && !rb.cancelled; } }
        ]
    };

    var oldrbookingsconfigs = {};
    $scope.oldrbookingsconfig = {
        getItems: function() {
            return $scope.rbookings;
        },
        itemFilter: function(rb) {
            return this.category == rb.category && !rb.cancelled && !rb.end.isFuture();
        },
        rowClick: function(rb) {
            $scope.showRBooking(rb);
        },
        hideSearch: true,
        orderColumn: '-start',
        tableLimit: 10,
        columns: [
            {field: 'start', title: 'Date', format: 'date' },
            {field: 'start', title: 'Time', getValue: $rootScope.getRBookingTime },
            {field: 'service.name', title: 'Service' },
            {field: 'staff.name', title: 'Resource', getValue: getResources },
            {field: 'booker.name', title: 'Booker' }
        ]
    };

    var cancelledbookingsconfigs = {};
    $scope.cancelledbookingsconfig = {
        getItems: function() {
            return $scope.rbookings;
        },
        itemFilter: function(rb) {
            return this.category == rb.category && rb.cancelled;
        },
        rowClick: function(rb) {
            $scope.showRBooking(rb);
        },
        hideSearch: true,
        orderColumn: '-start',
        tableLimit: 10,
        columns: [
            {field: 'start', title: 'Date', format: 'date' },
            {field: 'start', title: 'Time', getValue: $rootScope.getRBookingTime },
            {field: 'service.name', title: 'Service' },
            {field: 'staff.name', title: 'Resource', getValue: getResources },
            {field: 'booker.name', title: 'Booker' }
        ]
    };
    var rbconfigs = {old:       {configs: oldrbookingsconfigs, template: $scope.oldrbookingsconfig},
                     current:   {configs: rbookingsconfigs, template: $scope.rbookingsconfig},
                     cancelled: {configs: cancelledbookingsconfigs, template: $scope.cancelledbookingsconfig} };

    $scope.getRBookingsConfig = function(category, type) {
        var table = rbconfigs[type];
        if (!table.configs[category.id]) {
            var c = angular.copy(table.template);
            c.category = category;
            table.configs[category.id] = c;
        }
        return table.configs[category.id];
    };

    $scope.getNumBookingsForCategory = function(category) {
        var a = $scope.getRBookingsConfig(category, 'old');
        var b = $scope.getRBookingsConfig(category, 'current');
        var c = $scope.getRBookingsConfig(category, 'cancelled');
        return (a.control ? a.control.getNumberOfItems() : 0) + (b.control ? b.control.getNumberOfItems() : 0) + (c.control ? c.control.getNumberOfItems() : 0);
    };

    var isActiveDoor = function(s) {
        return s.active && s.type == 'resource' && (s.resourceType == 'door' || s.resourceType == 'qrcode_entry');
    };

    var hasDoors = function() {
        return $rootScope.staffs.filter(isActiveDoor).length > 0;
    };

    $scope.entryConfig = {
        filter: [
            {name: 'fromDate', title: 'From', required: false, type: 'date' },
            {name: 'toDate', title: 'To', required: false, type: 'date' },
            {name: 'door', title: 'Door', required: false, type: 'select', visible: hasDoors, useId: true, options: function() { return $rootScope.staffs;}, optionsFilter: isActiveDoor, placeholder: 'No door choosen' }
        ],
        api: {
            url: '/api/entry/get',
            args: {
                member: Number($routeParams.customerId),
                idOnly: true
            },
            transform: $rootScope.transformEntry,
            triggers: [
                {
                    type: 'entry',
                    condition: function(entry) {
                        return entry.user_id == Number($routeParams.customerId) || entry.Member.id == Number($routeParams.customerId);
                    }
                 }
            ]
        },
        countSuffixList: ['entry', 'entries'],
        hideSearch: false,
        giveFocus: function() { return false; },
        orderColumn: '-entryTime',
        tableLimit: 10,
        columns: [
            {field: 'entryTime', title: 'Date', format: 'datetime' },
            {field: 'door.name', title: 'Door' }
        ]
    };

    var addNewMembership = {
        title: 'Add new membership',
        onClick: function() {
            var validFromDate;
            var memberships = $scope.membershipsConfig.tabs[0].config.control.getItems();
            if (memberships.length) {
                var lastexpires = _.max(memberships, function(m) { return m.validToDate.getTime(); });
                validFromDate = lastexpires.validToDate.clone().addDays(1);
            }
            $scope.addTrainingCard(true, validFromDate);
        }
    };

    var addCourseBooking = {
        title: 'Add booking',
        onClick: function() {
            $modal.open({
                templateUrl: 'views/coursebookingaddmodal.html',
                controller: 'CourseBookingAddCtrl',
                resolve: {
                    options: function() {
                        return {
                            customer: $scope.customer,
                            course: null
                        };
                    }
                }
            });
        }
    };

    function stopProlonging(membership) {
        server.post('/api/membership/check_before_stop', null, {id: membership.id}).then(function(result) {
            if (result.data.success) {
                confirm.show('Are you sure you want to stop prolonging this membership?', {ladda: true}).then(function(resolve) {
                    server.post('/api/membership/stop', null, {id: membership.id}, 'Membership prolonging stopped', 'Failed to stop prolonging of membership').then(resolve);
                });
            } else {
                confirm.show('The customer has training card, resource booking or course requires membership. Do you still want to continue?', {ladda: true}).then(function(resolve) {
                    server.post('/api/membership/stop', null, {id: membership.id}, 'Membership prolonging stopped', 'Failed to stop prolonging of membership').then(resolve);
                });
            }
        });
    }

    function changeMembership(membership) {
        $modal.open({
            templateUrl: 'views/changetrainingcard.html',
            controller: 'TrainingCardChangeModalCtrl',
            resolve: {
                card: function() {
                    return membership;
                },
                parentCardName: function() {
                    return null;
                },
                includedCardNames: function() {
                    return [];
                }
            }
        });
    }

    function showEventLog(card) {
        eventlog.openDialog({
            filter: new Link('trainingcard', Number(card.id)),
            noPeriod: true,
            hideFilter: true
        });
    }

    $rootScope.waitFor(['trainingcardtypes']).then(function() {
        $scope.membershipsConfig = {
            api: {
                url: '/api/membership/get',
                args: {
                    member_id: Number($routeParams.customerId)
                },
                transform: function(c) {
                    c = $rootScope.transformTrainingCard(c);
                    if (c.chain) {
                        c.cardtype_name = $filter('translate')('Membership in another association');
                    }
                },
                triggers: [
                    {
                        type: 'trainingcard',
                        condition: function(t) {
                            return t.type == 'membership';
                        }
                    },
                    {
                        type: 'payment',
                        condition: function(p) {
                            return p.user_id == Number($routeParams.customerId) || p.payer_id == Number($routeParams.customerId);
                        }
                    }
                ]
            },
            countSuffixList: ['membership', 'memberships'],
            giveFocus: function() { return false; },
            hideSearch: true,
            tabs: [
                {name: 'Memberships', badgeClass: 'badge-success', itemFilter: function(t) { return t.validToDate >= Date.today(); } },
                {name: 'History', badgeClass: 'badge-warning', itemFilter: function(t) { return t.validToDate < Date.today(); } }

            ],
            columns: [
                {field: 'cardtype_name', title: 'Name'},
                {field: 'validFromDate', title: 'Valid from', format: 'date'},
                {field: 'validToDate', title: 'Valid to', format: 'date'}
            ],
            buttons: [
                {title: 'Change', buttonClass: 'btn-warning', onClick: changeMembership, visible: function(card) {return !card.chain;}},
                {title: 'Stop prolonging', buttonClass: 'btn-warning', onClick: stopProlonging, visible: function(c) { return !c.chain && c.cardtype && c.cardtype.auto && !c.generatedUntil; }},
                {title: 'Event log', buttonClass: 'btn-info', visible: function(card) {return !card.chain && $rootScope.hasPermission('Show event log'); }, onClick: showEventLog}
            ],
            buttonBelow: function() {
                return addNewMembership;
            }
        };
    });

    $scope.getPayments = function() {
        $http.get('/api/payment/get?member=' + $scope.customer.id).success(function(payments) {
            var waitingWatch = $scope.$watch('trainingcards', function() {
                if ($scope.trainingcards) {
                    angular.forEach(payments, function(payment) {
                        $rootScope.transformPayment(payment);
                    });
                    $scope.payments = payments;
                    $scope.debts = getDebts();
                    waitingWatch();
                }
            });
        });
    };

    $scope.getRBookings = function() {
        if ($rootScope.hasModule('ResourceBooking')) {
            $rootScope.waitFor(['staffs', 'resourcebookingcategories', 'resourcebookingservices', 'trainingcardtypes', 'members']).then(function() {
                $http.get('/api/member/resourcebooking/get?member=' + $routeParams.customerId).success(function(rbookings) {
                    $rootScope.transformResourceBookings(rbookings);
                    $scope.rbookings = rbookings.filter(function(rb) { return rb.siblings[0] == rb; });
                });
            });
        }
    };

    $scope.getTrainingCards = function() {
         server.get('/api/trainingcard/get/all', {member_id: $routeParams.customerId}).then(function(trainingcards) {
            $rootScope.waitFor(['trainingcardtypes']).then(function() {
                angular.forEach(trainingcards, function(trainingcard) {
                    $rootScope.transformTrainingCard(trainingcard);
                });
                $scope.trainingcards = trainingcards;
            });
        });
    };

    $scope.cancelCourseBooking = function(booking) {
        CreditPaymentDialog.open({
            courseBookingId: booking.id
        });
    };

    $scope.coursesConfig = {
        api: {
            url: '/api/course/booking/get',
            args: {
                user_id: Number($routeParams.customerId)
            },
            transform: function(c) {
                c.startTime = Date.newFull(c.startTime);
                c.endTime = Date.newFull(c.endTime);
                return c;
            },
            triggers: [
                {
                    type: 'coursebooking',
                    condition: function(cb) {
                        return cb.user_id == Number($routeParams.customerId);
                    }
                }
            ],
            onItemsUpdated: function(items) {
                $scope.hasBookedByOther = items.find(course => course.booker.id != $routeParams.customerId);
                $scope.coursesConfig.control.rebuild();
            },
        },
        tabs: [
            {name: 'Course bookings', badgeClass: 'badge-success', itemFilter: function(c) { return c.endTime.isFutureDate() && c.user_id && c.user_id==Number($routeParams.customerId); } },
            {name: 'Booked for another', badgeClass: 'badge-success', itemFilter: function(c) { return c.endTime.isFutureDate() && c.user_id && c.user_id!=Number($routeParams.customerId); } },
            {name: 'History', itemFilter: function(c) { return !c.endTime.isFutureDate(); } }
        ],
        countSuffixList: ['course booking', 'course bookings'],
        giveFocus: function() {
            return false;
        },
        hideSearch: true,
        rowClick: function(b) { courseutil.show(b.course_id); },
        columns: [
            {field: 'startTime', title: 'Start time', format: 'datetime'},
            {field: 'course_name', title: 'Course'},
            {field: 'booker.name', title: 'Booker', visible: function(config) { return config.name != 'Booked for another' && $scope.hasBookedByOther; }},
            {field: 'user.name', title: 'Participant', visible: function(config) { return config.name != 'Course bookings'; }}
        ],
        buttons: [
            {title: 'CANCEL_BOOKING', buttonClass: 'btn-danger', onClick: $scope.cancelCourseBooking, visible: function() { return $rootScope.hasPermission('Workout booking'); } },
        ],
        buttonBelow: function() {
          return addCourseBooking;
        }
    };

    $scope.isNew = function(rbooking) {
        return rbooking.start.clone().clearTime() >= Date.today();
    };

    $scope.changeStatus = function() {
        var ids = _.pluck($scope.customer.status, 'id');
        var data = {id: $routeParams.customerId, status: ids};
        server.post('/api/member/change', data, null, 'Status changed', 'Failed to change status');
    };

    function isInListOfCards(id) {
        return _.findWhere($scope.trainingcards, {id: id});
    }

    var removeServerChange = $rootScope.$on('serverChange', function (event, message) {
        if (!$scope.customer) {
            return;
        }

        var updatePayments = false;
        var getRb = false;

        angular.forEach(message.data, function(messageData) {
            // Manually update stuff for this particular customer
            if (message.type == 'user' && messageData.id == $scope.customer.id) {
                $scope.$apply();
            } else if (message.type == 'trainingcard' && (messageData.user_id == $scope.customer.id || isInListOfCards(messageData.id))) {
                // For now, refetch trainingcards
                $scope.getTrainingCards();
            } else if (message.type == 'payment' && messageData.user_id == $scope.customer.id) {
                if (message.action == 'add') {
                    if ($scope.payments) {
                        var p = $rootScope.transformPayment(messageData);
                        $scope.payments.push(p);
                    }
                    updatePayments = true;
                } else if (message.action == 'change') {
                    var array = $scope.payments;
                    var match = _.findWhere(array, {id: messageData.id});
                    if (match) {
                        angular.copy(messageData, match);

                        $rootScope.transformPayment(match);
                        updatePayments = true;
                    } else {
                        if (messageData.user_id == $scope.customer.id && $scope.payments) {
                            var p = $rootScope.transformPayment(messageData);
                            $scope.payments.push(p);
                            updatePayments = true;
                        }
                    }
                } else if (message.action == 'remove') {
                    var array = $scope.payments || [];
                    for (var i=0; i < array.length; ++i) {
                        if (array[i].id == messageData.id) {
                            array.splice(i, 1);
                            updatePayments = true;
                            break;
                        }
                    }
                }

                // For now, refetch trainingcards
                $scope.getTrainingCards();
            } else if (message.type == 'resourcebooking' && messageData.user_id == $routeParams.customerId) {
                // FIXME: For now, refetch resource bookings
                getRb = true;
            }
        });

        if (getRb || updatePayments) {
            $scope.getRBookings();
        }

        if (updatePayments) {
            $scope.$apply();
            $scope.getPayments();
            updatePaymentTables();
        }

        $scope.buildInfoPanel();
    });

    $scope.pubsub('selectedSite', function() {
        $scope.buildInfoPanel();
    });

    $scope.$on('$destroy', function () {
        removeServerChange();
    });

    $scope.getEconomyConfig = function() {
        return {
            unpaid: {},
            pending: { days: 364 },
            sent: {},
            giftcard: {},
            debtcollection: {},
            history: {}
        };
    };

    $scope.addon_widgets = [];
    $scope.getAddonWidgets = function() {
        server.get('/api/addon/widget/get').then(function(addons) {
            addons.forEach(function(addon) {
                addon.settings = {
                    url: addon.url,
                    zoezi_customer_id: $routeParams.customerId,
                    pass_zoezi_user_id: true
                };
            });

            $scope.addon_widgets = addons.filter(function(addon) {
                return addon.type == 'customercard';
            });
        });
    };
    $scope.getAddonWidgets();

    $scope.getContractBtnName = function() { return $rootScope.hasModule('OfferSupport') ? 'Offers/Contracts' : 'Contracts'; };
}]);

app.controller('LockerRentalModalCtrl', ['$rootScope', '$scope', '$controller', 'server', 'customer', 'trainingcards', function($rootScope, $scope, $controller, server, customer, trainingcards) {
    $controller('AddCtrl', {$scope: $scope});
    $scope.customer = customer;
    $scope.trainingcards = trainingcards;

    var loadLockers = function() {
        $scope.resetForm($scope);
        server.get('/api/locker/get', {onlyFreeLockers: true}).then((res) => {
            server.get('/api/locker/get/occupied', {memberId: $scope.customer.id}).then(userLocker => {
                $scope.currentLocker = null;
                $scope.lockers = [...res];
                if(userLocker[0]?.occupiedby == $scope.customer.id){
                    $scope.currentLocker = userLocker[0];
                }
                $scope.locations = _.uniq(res, false, (item) => { return item.location.id}).map(item => item.location);
                if ($scope.currentLocker) {
                    $scope.lockers.push($scope.currentLocker);
                    $scope.fields[2].value = $scope.currentLocker;
                    $scope.fields[1].value = _.findWhere($scope.locations, {id: $scope.currentLocker.location.id});
                }
            });
        });
    };
    loadLockers();

    var lockerOptions = function() {
        var lockers = $scope.lockers;
        var locationField = _.find($scope.fields, x => x.name == 'location');
        if (locationField && locationField.value) {
            lockers = lockers.filter(l => l.location.id == locationField.value?.id);
        }
        return lockers;
    };

    var getSelectedLocker = function() {
        return $scope.fields[2].value;
    };

    var getValidTrainingcards = () => {
        var validTrainingcards = $scope.trainingcards.filter(card => { return (card.type != 'course' && (card.trainingsLeft == null || card.trainingsLeft > 0) && (card.validToDate == null || card.validToDate >= Date.today()) && (card.validFromDate.isPastDate(true)) && card.cardtype.lockerRental) });
        return validTrainingcards;
    }

    $scope.canSubmit = function () {
        return (getValidTrainingcards().length > 0 && getSelectedLocker() && getSelectedLocker() != $scope.currentLocker);
    };

    $scope.submit = function() {
        $scope.loadingStatus.loading = true;
        server.post('/api/locker/set', {locker: getSelectedLocker(), userId: $scope.customer.id}, null, $scope.successTitle || 'Item added', $scope.failedTitle || 'Failed to add item', $scope.itemTitle).then(function(result) {
            $scope.loadingStatus.loading = false;
            if (result.success) {
                loadLockers();
            }
        });
    };

    $scope.removeAccess = function() {
        server.post('/api/locker/removeaccess', $scope.customer.id, null, $scope.successTitle || 'Locker access removed', $scope.failedTitle || 'Failed to remove locker access').then(() => {
            loadLockers();
        });
    };

    $scope.unlockLocker = function() {
        server.post('/api/locker/unlock', {locker: $scope.currentLocker.locker, location: $scope.currentLocker.location.id}, null, 'Locker unlocked', 'Failed to unlock locker');
    };

    var getLockerName = function (locker) {
        return `${locker.location.name} - ${locker.locker}`;
    }

    $scope.fields = [
        { name: '_', type: 'alert', value: 'Not able to rent locker', class: 'alert-danger', visible: () => !(getValidTrainingcards()?.length > 0) },
        { name: 'location', title: 'Location', type: 'select', options: () => $scope.locations, clearable: false },
        { name: 'locker', title: 'Locker', type: 'select', options: lockerOptions, getName: getLockerName, clearable: false},
    ];
}]);

app.controller('CurrentWorkoutBookingsCtrl', ['$rootScope', '$scope', 'confirm', 'server', '$filter', function($rootScope, $scope, confirm, server, $filter) {
    $scope.removeBooking = function(workout) {
        confirm.show('Are you sure you want to remove the booking?', {ladda: true}).then(function(resolve) {
            var booking = _.findWhere(workout.bookings, {user: $scope.customer});
            server.post('/api/workoutBooking/remove', null, {workoutBooking: booking.id}, 'Booking removed', 'Failed to remove booking').then(resolve);
        });
    };

    $scope.config = {
        tableLimit: 10,
        filter: [],
        api: {
            url: '/api/workoutBooking/getForMember',
            args: {
                member: $scope.customer.id
            },
            transform: $rootScope.transformWorkout,
            triggers: [
                {
                    type: 'workoutbooking',
                    condition: function(wb) {
                        return wb.user_id == $scope.customer.id;
                    }
                 }
            ]
        },
        hideSearch: true,
        countSuffixList: ['booking', 'GENERAL_BOOKINGS'],
        rowClick: $scope.showWorkout,
        giveFocus: function() { return false; },
        rowClass: function(workout) {
            return workout.status == 'Cancelled' ? 'cancelledWorkout' : '';
        },
        columns: [
            {field: 'startTime', title: 'Date', getValue: function(w) { return $rootScope.getDisplayDate(w.startTime); } },
            {field: 'startTime', title: 'Time', getValue: $rootScope.getWorkoutTime },
            {field: 'workoutType.name', title: 'Workout type' },
            {field: 'staffs', title: 'Instructor', format: 'commaList' },
            {field: 'location.name', title: 'Location' },
            {field: 'bookedslots', title: 'Booked slots', getValue: $rootScope.getRegisteredTitle },
            {field: 'info', title: 'Info', getValue: function(w) {
                var userBooking = _.findWhere(w.bookings, {user_id: $scope.customer.id});
                return userBooking && userBooking.inQueue ? $filter('translate')('In queue') : '';
            }, visible: function() { return $rootScope.hasModule('Queue'); } }
        ],
        buttons: [
            {title: 'CANCEL_BOOKING', buttonClass: 'btn-danger', visible: function() { return $rootScope.hasPermission('Workout booking'); }, onClick: $scope.removeBooking  }
        ]
    };
}]);

app.controller('RemoveCustomerCtrl', ['$scope', 'server', '$location', 'customer', function($scope, server, $location, customer) {
    $scope.loadingStatus = {};

    function getUserRemoveDate() {
        server.get('/api/user/get_remove_date', {user_id: customer.id}).then(function(result) {
            $scope.remove_date = Date.newFull(result.date);
            $scope.remove_date_is_future = $scope.remove_date.isFutureDate();
        });
    }
    getUserRemoveDate();

    $scope.remove = function() {
        $scope.loadingStatus.loading = true;
        server.post('/api/member/remove', null, {id: customer.id, permanent: true}, '{0} was removed', 'Failed to remove {0}', 'Customer').then(function(result) {
            if (result.success) {
                $scope.$close();
                $location.path('/');
            } else {
                $scope.loadingStatus.loading = false;
            }
        });
    };

    $scope.markForRemoval = function() {
        $scope.loadingStatus.loading = true;
        server.post('/api/user/mark_for_removal', null, {id: customer.id}, 'Customer was marked for removal', 'Failed to perform operation').then(function(result) {
            if (result.success) {
                $scope.$close();
            } else {
                $scope.loadingStatus.loading = false;
            }
        });
    };

}]);

app.controller('PreviousWorkoutBookingsCtrl', ['$rootScope', '$scope', function($rootScope, $scope) {
    $scope.config = {
        tableLimit: 10,
        filter: [
            {name: 'fromDate', title: 'From', required: false, type: 'date', value: Date.today().addMonths(-1) },
            {name: 'toDate', title: 'To', required: false, type: 'date' }
        ],
        api: {
            url: '/api/workoutBooking/getEarlierForMember',
            args: {
                member: $scope.customer.id
            },
            transform: $rootScope.transformWorkout,
            triggers: [
                {
                    type: 'workoutbooking',
                    condition: function(wb) {
                        return wb.user_id == $scope.customer.id;
                    }
                 }
            ]
        },
        countSuffixList: ['booking', 'GENERAL_BOOKINGS'],
        rowClick: $scope.showWorkout,
        giveFocus: function() { return false; },
        rowClass: function(workout) {
            return workout.status == 'Cancelled' ? 'cancelledWorkout' : '';
        },
        columns: [
            {field: 'startTime', title: 'Date', format: 'date' },
            {field: 'workoutType.name', title: 'Workout type' },
            {field: 'staffs', title: 'Instructor', format: 'commaList' },
            {field: 'location.name', title: 'Location' },
            {field: 'bookedslots', title: 'Booked slots', getValue: $rootScope.getRegisteredTitle }
        ]
    };
}]);

app.controller('MergeModalCtrl', ['$rootScope', '$scope', 'customer', 'server', function($rootScope, $scope, customer, server) {
    $scope.titleSuffix = customer.name;
    $scope.primary = customer;
    $scope.loadingStatus = {};

    $scope.chooseSecondary = function(secondary) {
        $scope.secondary = secondary;
    };

    $scope.merge = function(primary, secondary) {
        $scope.loadingStatus.loading = true;
        server.post('/api/member/merge', null, {primary: primary.id, secondary: secondary.id}, 'Customers merged', 'Failed to merge customers').then(function(result) {
            if (result.success) {
                $scope.$close();
                $rootScope.gotoCustomer(primary);
            } else {
                $scope.loadingStatus.loading = false;
            }
        });
    };

    if ($rootScope.speedy) {
        $scope.tableConfig = {
            tableLimit: 5,
            tableNumPages: 10,
            triggers: ['user', 'image'],
            hideSearch: true,
            filter: [
                {name: 'query', title: 'Search', required: true, type: 'text'}
            ],
            api: {
                url: '/api/search',
                post: true,
                args: {
                    types: [{
                        type: 'user',
                        searchFields: ['name', 'mail', 'phone', 'firstname', 'lastname', 'personalCodeNumber'],
                        resultFields: ['id', 'name', 'imageurl', 'imagekey', 'phone', 'mail', 'firstname', 'lastname', 'personalCodeNumber']
                    }],
                    limit: 20
                },
                getItemsFromResponse: response => response.data.find(x => x.type == 'user').items
            },
            itemFilter: customer => {
                if ($scope.primary && $scope.primary.id == customer.id) {
                    return false;
                }

                if ($scope.primary.personalCodeNumber && customer.personalCodeNumber) {
                    return false;
                }

                return true;
            },
            columns: [
                {field: 'image', title: '' },
                {field: 'firstname', title: 'First name' },
                {field: 'lastname', title: 'Last name' },
                {field: 'mail', title: 'E-mail' }
            ],
            buttons: [
                { title: 'Merge', buttonClass: 'btn-warning', onClick: $scope.chooseSecondary }
            ],
            searchFields: $rootScope.getCustomerProperties(),
            hideSearchCount: true,
            showSum: false,
            countSuffixList: ['customer', 'customers']
        };
    } else {
        $scope.tableConfig = {
            tableLimit: 5,
            tableNumPages: 10,
            triggers: ['user', 'image'],
            getItems: function() {
                return $rootScope.members;
            },
            itemFilter: function(customer) {
                if (customer.type != 'user') {
                    return false;
                }

                if ($scope.primary == customer) {
                    return false;
                }

                if ($scope.primary.personalCodeNumber && customer.personalCodeNumber) {
                    return false;
                }

                return true;
            },
            columns: [
                {field: 'image', title: '' },
                {field: 'firstname', title: 'First name' },
                {field: 'lastname', title: 'Last name' },
                {field: 'mail', title: 'E-mail' }
            ],
            buttons: [
                { title: 'Merge', buttonClass: 'btn-warning', onClick: $scope.chooseSecondary }
            ],
            searchFields: $rootScope.getCustomerProperties(),
            hideSearchCount: true
        };
    }
}]);

app.controller('StaffCtrl', ['$rootScope', '$scope', '$routeParams', '$http', '$modal', '$filter', 'usSpinnerService', 'alertProvider', 'workoutProvider', 'calendar', 'server', 'fileManager', 'EntryService',
    function($rootScope, $scope, $routeParams, $http, $modal, $filter, usSpinnerService, alertProvider, workoutProvider, calendar, server, fileManager, EntryService) {

    $scope.data = {};

    $scope.showImage = function() {
        $modal.open({
            templateUrl: '/views/image.html',
            controller: 'ImageModalCtrl',
            resolve: {
                customer: function() {
                    return $scope.staff;
                }
            }
        });
    };

    $scope.registerCard = function() {
        EntryService.entyCardDialog($scope.staff).then(function(result) {
            if (result.remove) {
                server.post('/api/card/remove', null, {user_id: $scope.staff.id}, '{0} was removed', 'Failed to remove {0}', 'Card');
            } else {
                server.post(
                    '/api/card/set', null,
                    {
                        user_id: $scope.staff.id,
                        cardId: result.value,
                        pin:    result.pin,
                        manual: result.manual
                    },
                    'Card/tag registered', 'Failed to register card/tag'
                );
            }
        });
    };

    $scope.gotoCustomer = function() {
        $rootScope.gotoCustomer($scope.staff);
    };

    $scope.openFileManager = function() {
        fileManager.open({
            originId: $scope.staff.id,
            originType: 'user',
            visibleTabs: 'files'
        });
    };

    $scope.originalImageSrc = function(size) {
        return $rootScope.staffImage($scope.staff, size);
    };

    $scope.change = function() {
        $modal.open({
            templateUrl: 'views/changemodal.html',
            controller: 'StaffChangeModalCtrl',
            resolve: {
                staff: function() {
                    return $scope.staff;
                }
            }
        });
    };

    $scope.changeStatus = function() {
        var ids = _.pluck($scope.staff.status, 'id');
        var data = {id: $scope.staff.id, status: ids};
        server.post('/api/member/change', data, null, 'Status changed', 'Failed to change status');
    };

    $scope.canChangeStaff = function() {
        return $scope.staff && $rootScope.hasPermission($scope.staff.id == $rootScope.currentStaff.id ? 'Staff change self' : 'Staff handling');
    };

    $scope.sendSms = function() {
        $modal.open({
            templateUrl: 'views/sms.html',
            controller: 'SMSMultiModalCtrl',
            resolve: {
                sendlist: function() {
                    return [$scope.staff];
                }
            }
        });
    };

    $scope.inactivate = function() {
        var item = $scope.staff;
        var title = item.name;
        var content = 'REMOVE_STAFF_MESSAGE';
        $modal.open({
            templateUrl: 'views/inactivatestaff.html',
            controller: 'InactivateStaffCtrl',
            resolve: {
                options: function() {
                    return { title: title, content: content };
                },
                staff: function() {
                    return $scope.staff;
                }
            }
        });
    };

    $scope.activate = function() {
        var item = $scope.staff;
        var title = item.name;
        var content = 'ACTIVATE_STAFF_MESSAGE';
        var postUrl = '/api/staff/activate';
        var modalInstance = $modal.open({
            templateUrl: 'views/activate.html',
            controller: 'ModalCtrl',
            resolve: {
                options: function() {
                    return {title: title, content: content};
                }
            }
        });

        modalInstance.result.then(function () {
            var data = {id: item.id};
            server.post(postUrl, null, data, '{0} was activated', 'Failed to activate {0}', title);
        });
    };

    $scope.requestPasswordReset = function() {
        $modal.open({
            templateUrl: 'views/addmodal.html',
            controller: 'ResetPasswordModalCtrl',
            resolve: {
                customer: function() {
                    return $scope.staff;

                },
                isStaff: function() {
                    return true;
                }
            }
        });
    };

    $rootScope.waitFor(['staffs']).then(function() {
        $scope.staff = $rootScope.getStaff($routeParams.staffId);
    });

    $scope.addon_widgets = [];
    $scope.getAddonWidgets = function() {
        server.get('/api/addon/widget/get').then(function(addons) {
            addons.forEach(function(addon) {
                addon.settings = {
                    url: addon.url,
                    zoezi_staff_id: $routeParams.staffId,
                    pass_zoezi_user_id: true
                };
            });

            $scope.addon_widgets = addons.filter(function(addon) {
                return addon.type == 'staffcard';
            });
        });
    };
    $scope.getAddonWidgets();
}]);

app.controller('InactivateStaffCtrl', ['$rootScope', '$scope', 'options', 'staff', 'server', 'workoutProvider', 'util',
    function($rootScope, $scope, options, staff, server, workoutProvider, util) {
    $scope.titleSuffix = options.title;
    $scope.content = options.content;
    $scope.staff = staff;
    $scope.loadingStatus = {};
    $scope.loadingStatus.loading = false;

    $scope.postUrl = '/api/staff/inactivate';
    $scope.wbBooked = false;
    $scope.rbBooked = false;

    $scope.loadStaffBookings = function() {
        var toDate = new Date();
        toDate.setYear(toDate.getFullYear() + 10);
        $scope.staffRBs = [];
        $scope.staffWBs = [];
        server.get('/api/schedule/workout/get/all', { fromDate: new Date().yyyymmdd(), toDate: toDate.yyyymmdd(), type: 'Staff', id: $scope.staff.id }).then(function() {
            server.get('/api/resourcebooking/get', { staff: $scope.staff.id }).then(function(resourceBookings) {
                $scope.staffRBs = resourceBookings;
                $scope.isWbBooked();
                $scope.isRbBooked();
            });
        });

    };
    $scope.loadStaffBookings();


    $scope.isWbBooked = function() {
        $scope.wbBooked = $scope.staffWBs && $scope.staffWBs.length > 0;
    };
    $scope.isRbBooked = function() {
        $scope.rbBooked = $scope.staffRBs && $scope.staffRBs.length > 0;
    };

    $scope.fields = [
        { hint: 'INACTIVATE_STAFF_BOOKED'},
        { name: 'cancelWb', title: 'Workout bookings', type: 'checkbox', value: true },
        { name: 'cancelRb', title: 'Resource bookings', type: 'checkbox', value: true }
    ];

    $scope.doInactivate = function() {
        $scope.loadingStatus.loading = true;
        server.post($scope.postUrl, null, util.getSubmitItem($scope.fields, $scope.staff.id), '{0} was inactivated', 'Failed to inactivate {0}', $scope.titleSuffix).then(function(response) {
            $scope.loadingStatus.loading = false;
            if (response.success) {
                $scope.$close('inactivate');
            }
        });
    };

}]);

app.factory('todofactory', ['$rootScope', '$interval', 'live', 'server', function($rootScope, $interval, live, server) {
    var todo = {items: [], active: []};

    function getToDos() {
        $rootScope.waitFor(['staffs']).then(function() {
            var args = { staff: $rootScope.currentStaffId, fromDate: Date.today().yyyymmdd(), toDate: Date.today().yyyymmdd(), delayed: true };
            server.get('/api/todo/get', args).then(function(todos) {
                $rootScope.waitFor(['staffs', 'members']).then(function() {
                    angular.forEach(todos, function(t) {
                        $rootScope.transformTodo(t);
                    });
                });
                todo.items = todos;
                todo.active = todos.filter(function(todo) { return !todo.performed && todo.dueDate; });
            });
        });
    }

    live.subscribe({
        type: 'todo',
        callback: getToDos
    });

    getToDos();

    todo.getAll = function() {
        return todo.items;
    };

    todo.getActive = function() {
        return todo.active;
    };

    // To be sure we are fairly updated - when new day arrives - update every 4 hour
    $interval(getToDos, 1000*60*60*4);

    return todo;
}]);

app.controller('ToDoHeaderCtrl', ['$rootScope', '$scope', '$location', 'todofactory', '$filter', '$modal', function($rootScope, $scope, $location, todofactory, $filter, $modal) {
    $scope.getActiveItems = function() {
        return $filter('orderBy')(todofactory.getAll().filter(function(todo) { return !todo.performed && ((todo.responsible_id == $rootScope.currentStaff.id) || todo.responsible_id == null); }), 'dueDate');
    };

    $scope.showList = function() {
        $location.path('/todo/mylist');
    };

    $scope.getCreatorImage = function(t) {
        if (!t.creator_id) { return $rootScope.getEmptyImage(); }
        return $rootScope.staffImage(t.creator);
    };

    $scope.getCreator = function(t) {
        if (!t.creator_id) { return 'Not specified'; }
        return t.creator_id === $rootScope.currentStaffId ? 'You' : t.creator.name;
    };

    $scope.open = function(todo) {
        $modal.open({
            templateUrl: 'views/todomodal.html',
            controller: 'ToDoModalCtrl',
            resolve: {
                todo: function() {
                    return todo;
                }
            }
        });
    };

    var todolistDropdown = angular.element(document.querySelector('#todolist-dropdown'));
    todolistDropdown.on('click', function() {
        if (!$(this).parent().hasClass('open')) {
            $(this).next().on('click', function(e){ e.stopPropagation(); });
        }
    });
}]);

app.controller('ToDoModalCtrl', ['$rootScope', '$scope','$modal', '$location', 'server', 'confirm', 'todo', function($rootScope, $scope, $modal, $location, server, confirm, todo) {
    $scope.todo = todo;
    $scope.buttons = [];

    if(todo.user && $rootScope.hasPermission('Show customer journal')) {
        $scope.buttons.push({
            name: 'Go to customer journal',
            fn: function() {
                $scope.closeAndGotoCustomerJournal($scope.todo.user);
            }
        });
    }

    if(todo.buttons && todo.buttons.length) {
        todo.buttons.forEach(function(btn) {
            if(btn.code === 'bankgiro_find_invoice') {
                $scope.buttons.push({
                    name: 'Find matching invoice',
                    fn: function() {
                        var modalInstance = $modal.open({
                            templateUrl: 'views/findinvoice2.html',
                            controller: 'FindInvoiceModalCtrl2',
                            windowClass: 'huge-modal-window',
                            resolve: {
                                transaction: function() {
                                    return {
                                        id: todo.transaction_id,
                                        invoice_reference: btn.reference_number,
                                        date: Date.newFull(btn.date),
                                        amount: btn.amount
                                    };
                                },
                                paid: function() {
                                    return btn.status === true;
                                }
                            }
                        });
                        modalInstance.result.then(function () {
                            $scope.$close();
                        });
                    }
                });
            } else if (btn.code === 'bgc_reprocess_file') {
                $scope.buttons.push({
                    name: 'Reprocess file',
                    fn: function() {
                        confirm.show('Are you sure you want to reprocess this file?', {ladda: true}).then(function(resolve) {
                            server.post('/api/admin/bankgiro/reprocess_inbox_file', {filename: btn.filename}, null, 'File was queued for reprocessing', 'Failed to reprocess file').then(function() {
                                resolve();
                                $scope.$close();
                            });
                        });
                    }
                });
            } else if (btn.code == 'create_accounting_post' && !todo.transaction_readonly) {
                $scope.buttons.push({
                    name: 'Create accounting post',
                    fn: function() {
                        var modalInstance = $modal.open({
                            templateUrl: 'views/economyaddincomemodal.html',
                            controller: 'EconomyAddIncomeModalCtrl',
                            windowClass: 'huge-modal-window',
                            resolve: {
                                options: function() {
                                    return { origin: todo.transaction_id, comment: btn.reference_number, date: Date.newFull(btn.date), amount: btn.amount };
                                }
                            }
                        });
                        modalInstance.result.then(function () {
                            todo.transaction_readonly = true;
                            $scope.$close();
                        });
                    }
                });
                $scope.buttons.push({
                    name: 'Remove from accounting',
                    class: 'btn-danger',
                    fn: function() {
                        confirm.show('Are you sure you want to remove this transaction from accounting?', {ladda: true}).then(function(resolve) {
                            server.post('/api/economy/transaction/remove', null, {id: $scope.todo.transaction_id}, 'Transaction was removed', 'Failed to remove transaction').then(function() {
                                resolve();
                            });
                        });
                    },
                })
            }
        });
    }

    $scope.change = function(todo) {
        $rootScope._todoFollowUpDialog = true;
        $scope.$dismiss();
        $modal.open({
            templateUrl: 'views/todoeditmodal.html',
            controller: 'ToDoChangeModalCtrl',
            resolve: {
                todo: function() {
                    return todo;
                }
            }
        }).result.catch(() => {}).finally(() => $rootScope.penpalParent?.onDialogClosed({}));
    };

    $scope.completed = function(todo) {
        $rootScope._todoFollowUpDialog = true;
        $scope.$dismiss();
        $modal.open({
            templateUrl: 'views/todoeditmodal.html',
            controller: 'ToDoCompletedModalCtrl',
            resolve: {
                todo: function() {
                    return todo;
                }
            }
        }).result.catch(() => {}).finally(() => $rootScope.penpalParent?.onDialogClosed({}));
    };

    $scope.closeAndGotoStaff = function(staff) {
        $scope.$close();
        if ($rootScope.penpalParent) {
            var path = staff.resource ? '/resource/show/' + staff.id : '/staff/show/' + staff.id;
            $rootScope.penpalParent.onDialogClosed({ navigate: path });
        } else {
            $rootScope.gotoStaff(staff);
        }
    };

    $scope.closeAndGotoCustomer = function(customer) {
        $scope.$close();
        if ($rootScope.penpalParent && customer) {
            var customer_id = isNaN(customer) ? customer.id : customer;
            $rootScope.penpalParent.onDialogClosed({ navigate: '/customer/show/' + customer_id });
        } else {
            $rootScope.gotoCustomer(customer);
        }
    };

    $scope.closeAndGotoCustomerJournal = function(customer) {
        $scope.$close();
        if (customer) {
            var path = '/customer/journal/' + customer.id;
            if ($rootScope.penpalParent) {
                $rootScope.penpalParent.onDialogClosed({ navigate: path });
            } else {
                $location.path(path);
            }
        }
    };

    $scope.remove = function(todo) {
         confirm.show('Are you sure you want to remove the task?', {ladda: true}).then(function(resolve) {
            server.post('/api/todo/remove', null, {todoId: todo.id }, '{0} was removed', 'Failed to remove {0}', 'Todo').then(resolve);
            $scope.$dismiss();
        });
    };
}]);

app.controller('ToDoCompletedModalCtrl', ['$rootScope', '$scope', '$filter', 'server', 'confirm', 'todo', function($rootScope, $scope, $filter, server, confirm, todo) {
    $scope.todo = todo;
    $scope.postUrl = '/api/todo/completed';
    $scope.loadingStatus = {};

    $scope.getTitle = function() {
        return $filter('translate')('Complete') + ' ' + $filter('translate')('todo');
    };

    $scope.valuesChanged = function() {
        return true;
    };

    $scope.change = function() {
        $scope.loadingStatus.loading = true;

        var performed = _.findWhere($scope.fields, {name: 'performed'}).value;
        var performedTime = _.findWhere($scope.fields, {name: 'performedTime'}).value;

        if(performedTime != null) {
            performed = performed.yyyymmdd() + " " + performedTime.hhmm();
        }

        if ($scope.todo.id) {
            var workedTime = _.findWhere($scope.fields, {name: 'workedTime'}).value;
            var item = {id: $scope.todo.id, performed: performed, workedTime: workedTime};

            server.post($scope.postUrl, item, null, 'ToDo item is completed', 'Failed to completed ToDo item').then(function(result) {
                if (result.success) {
                    $scope.$dismiss();
                }

                $scope.loadingStatus.loading = false;
            });
        } else {
            $scope.postUrl = 'api/todo/completedmultiple';
            var workedTime = 0;

            var todos = [];
            for (var todo=0; todo < Object.keys($scope.todo).length; ++ todo) {
                todos.push({id: $scope.todo[todo].id, performed: performed, workedTime: workedTime});
            }

            server.post($scope.postUrl, todos, null, 'ToDo items are completed', 'Failed to complete ToDo items').then(function(result) {
                    if (result.success) {
                        $scope.$close();
                    }
            $scope.loadingStatus.loading = false;
            });
        }
    };
    $scope.fields = [
        {name: 'performed', title: 'Performed', required: false, type: 'date', value: new Date() },
        {name: 'performedTime', title: 'Clock', required: false, type: 'time', value: new Date() },
        {name: 'workedTime', title: 'Worked time', required: false, info: 'minutes', type: 'infoNumber', visible: function() { return $scope.todo.id ;} }   ];
}]);

app.controller('ToDoChangeMultipleModalCtrl', ['$rootScope', '$scope', '$controller', '$filter', 'server', 'confirm', 'todo', function($rootScope, $scope,$controller, $filter, server, confirm, todo) {
    $controller('ChangeCtrl', {$scope: $scope});
    $scope.todo = todo;
    $scope.postUrl = '/api/todo/changemultiple';
    $scope.loadingStatus = {};
    $scope.unchangedFieldsWarning = 'Fields which are left unchanged will stay the same';

    $scope.getTitle = function() {
        return $filter('translate')('Change marked') + ' ' + $filter('translate')('todos');
    };

    $scope.change = function() {
        $scope.loadingStatus.loading = true;
        var item = $scope.getSubmitItem();
        item.todoIds = _.pluck($scope.todo, 'id').join(',');

        server.post($scope.postUrl, item, null, 'Tasks were changed', 'Failed to change tasks').then(function(result) {
            if (result.success) {
                $scope.$dismiss();
            }

            $scope.loadingStatus.loading = false;
        });
    };

    $scope.fields = [
        {name: 'responsible_id', title: 'Responsible', required: false, type: 'customer', useId: true, itemTypes: ['staff']},
        {name: 'group_id', title: 'Group', required: false, type: 'group', useId: true, visible: function() { return $rootScope.usergroups.length || $rootScope.speedy; } },
        {name: 'dueDate', title: 'Performed before', required: false, type: 'date', focus: true},
        {name: 'dueDateTime', title: 'Clock', required: false, type: 'time'},
        {name: 'timeEstimation', title: 'Time estimation', required: false, info: 'minutes', type: 'infoNumber' },
        {name: 'workedTime', title: 'Worked time', required: false, info: 'minutes', type: 'infoNumber' },
        {name: 'user_id', title: 'Customer', required: false, type: 'customer', useId: true }
    ];

    $scope.item = $scope.getSubmitItem();
}]);

app.controller('ToDoChangeModalCtrl', ['$rootScope', '$scope', '$controller', '$filter', 'server', 'confirm', 'todo', function($rootScope, $scope,$controller, $filter, server, confirm, todo) {
    $controller('ChangeCtrl', {$scope: $scope});
    $scope.todo = todo;
    $scope.item = todo;
    $scope.postUrl = '/api/todo/change';
    $scope.loadingStatus = {};

    $scope.getTitle = function() {
        return $filter('translate')('Change') + ' ' + $filter('translate')('todo');
    };

    $scope.change = function() {
        $scope.loadingStatus.loading = true;
        var item = $scope.getSubmitItem();
        if (item.dueDateTime != null) {
            var dueDate = item.dueDate + " " + item.dueDateTime;
            item.dueDate = dueDate;
        }
        delete item.dueDateTime;

        server.post($scope.postUrl, item, null, 'Task was changed', 'Failed to change task').then(function(result) {
            if (result.success) {
                $scope.$dismiss();
            }

            $scope.loadingStatus.loading = false;
        });
    };

    var setUser = function(field, value) {
        return value && $rootScope.getMember(value);
    };

    $scope.fields = [
        {name: 'todo', title: 'ToDo', required: true, type: 'text', focus: true},
        {name: 'responsible_id', title: 'Responsible', required: false, type: 'customer', useId: true, itemTypes: ['staff'] },
        {name: 'group_id', title: 'Group', required: false, type: 'group', useId: true, visible: function() { return $rootScope.usergroups.length || $rootScope.speedy; } },
        {name: 'dueDate', title: 'Performed before', required: false, type: 'date' },
        {name: 'dueDateTime', title: 'Clock', required: false, type: 'time' },
        {name: 'timeEstimation', title: 'Time estimation', required: false, info: 'minutes', type: 'infoNumber' },
        {name: 'workedTime', title: 'Worked time', required: false, info: 'minutes', type: 'infoNumber'},
        {name: 'user_id', title: 'Customer', required: false, type: 'customer', useId: true, setValue: setUser },
        {name: 'description', title: 'Description', required: false, type: 'textarea' },
        {name: 'sites', title: 'Sites', required: true, type: 'multiselect', visible: function() { return $rootScope.hasFlag('flag-todo-sites') && $rootScope.hasModule('MultiSite'); }, options: function() { return $rootScope.sites; }, useId: true }
    ];

    $scope.setValues($scope.todo);
}]);

app.controller('ToDoCtrl', ['$rootScope', '$scope', '$filter', '$routeParams','$modal', '$interval', 'server', function($rootScope, $scope, $filter, $routeParams, $modal, $interval, server) {
    $scope.title = 'All tasks';
    $scope.todoList = [];

    $scope.open = function(todo) {
        $modal.open({
            templateUrl: 'views/todomodal.html',
            controller: 'ToDoModalCtrl',
            resolve: {
                todo: function() {
                    return todo;
                }
            }
        });
    };

    $scope.change = function(todo) {
        $modal.open({
            templateUrl: 'views/todoeditmodal.html',
            controller: 'ToDoChangeModalCtrl',
            resolve: {
                todo: function() {
                    return todo;
                }
            }
        });
    };

    $scope.completed = function(todo) {
        $modal.open({
            templateUrl: 'views/todoeditmodal.html',
            controller: 'ToDoCompletedModalCtrl',
            resolve: {
                todo: function() {
                    return todo;
                }
            }
        });
    };

    $scope.completeMultiple = function(config) {
        // Filter the checked ToDos to find the checked items.
        var multipleTodos = config.control.getFilteredItems().filter(function(todo) {
            return todo.checked;
        });

        $modal.open({
            templateUrl: 'views/todoeditmodal.html',
            controller: 'ToDoCompletedModalCtrl',
            resolve: {
                todo: function() {
                    return multipleTodos;
                }
            }
        }).result.then(function(){
                $scope.clearMarked(config);
        });
    };

    $scope.changeMultiple = function(config) {
        // Filter the checked ToDos to find the checked items.
        var multipleTodos = config.control.getFilteredItems().filter(function(todo) {
            return todo.checked;
        });

        $modal.open({
            templateUrl: 'views/todoeditmodal.html',
            controller: 'ToDoChangeMultipleModalCtrl',
            resolve: {
                todo: function() {
                    return multipleTodos;
                }
            }
        }).result.then(function(){
                $scope.clearMarked(config);
        });
    };

    $scope.add = function() {
        $modal.open({
            templateUrl: 'views/addmodal.html',
            controller: 'ToDoModalAddCtrl',
            resolve: {
                options: function() {
                    return {
                        customer: null
                    };
                }
            }
        });
    };

    $scope.getToDos = function() {
        $rootScope.waitFor(['staffs', 'members']).then(function() {
            var to = _.findWhere($scope.fields, {name: 'toDate'}).value;
            if (!to || to.getFullYear() < 1900) {
                return;
            }
            var delayed = _.findWhere($scope.fields, {name: 'delayed'}).value;

            var args = { fromDate: to.yyyymmdd(), toDate: to.yyyymmdd(), delayed: delayed };

            if ($scope.forStaff) {
                args.staff = $rootScope.currentStaffId;

                server.get('/api/todo/get', args).then(function(todos) {
                    angular.forEach(todos, function(t) {
                        $rootScope.transformTodo(t);
                    });
                    $scope.todoList = todos;
                });

            } else if($scope.forAllStaff) {
                server.get('/api/todo/getAll', args).then(function(todos) {
                    angular.forEach(todos, $rootScope.transformTodo);
                    $scope.todoList = todos;
                });
            }


        });
    };

    function visibleColumn(config, column) {
        if (config.context && config.context.columns) {
            return config.context.columns.indexOf(column.field) != -1;
        }
    }

    $scope.isCheckedTodo = function(config) {
        var isCheckedBoxes = false;
        var items = config.control.getFilteredItems();
        for (var todo=0; todo < items.length ; ++todo) {
            if (items[todo].checked) {
                isCheckedBoxes = true;
                break;
            }
        }
        return isCheckedBoxes;
    };

    $scope.allTodosChecked = function(config) {
        var allChecked = true;
        var items = config.control.getFilteredItems();

        for (var todo=0; todo < items.length ; ++todo) {
            if (!items[todo].checked) {
                allChecked = false;
                break;
            }
        }
        return allChecked;
    };

    function checkboxChecker(config, value) {
        var items = config.control.getFilteredItems();

        // Checking/unchecking all checkboxes
        for (var i=0; i< items.length; ++i) {
            items[i].checked = value;
        }
    }

    $scope.markAll = function(config) {
        checkboxChecker(config, true);
    };

    $scope.clearMarked = function(config) {
        checkboxChecker(config, false);
    };

    $scope.ToDoConfig = {
        getItems: function() {
            return $scope.todoList;
        },
        triggers: ['todo'],
        tabs: [
            {name: $scope.forAllStaff ? 'All ToDos' : 'My Todos', badgeClass: 'badge-success', context: { columns: ['checked', 'todo', 'dueDate', 'group.name'] }, itemFilter: function(todo) { return !todo.performed && todo.dueDate && (todo.responsible_id == $rootScope.currentStaff.id || ($scope.forAllStaff && todo.group_id == null)); }, showCheckBox: true },
            {name: 'Group ToDos', badgeClass: 'badge-success', context: { columns: ['checked', 'todo', 'dueDate', 'group.name'] }, itemFilter: function(todo) { return !todo.performed && todo.dueDate && todo.responsible_id != $rootScope.currentStaff.id && todo.group_id; }, showCheckBox: true },
            {name: 'Unknown date', badgeClass: 'badge-warning',context: { columns: ['checked', 'todo', 'group.name'] }, itemFilter: function(todo) { return !todo.performed && !todo.dueDate ; }, showCheckBox: true },
            {name: 'History', context: { columns: ['todo', 'dueDate', 'group.name'] }, itemFilter: function(todo) { return todo.performed; } }
        ],
        searchFields: [
            { name: 'Description', id: 'description' },
            { name: 'Customer', id: 'user.name' },
            { name: 'Group', id: 'group.name' },
            { name: 'Responsible', id: 'responsible.name' },
            { name: 'ToDo', id: 'todo' }
        ],
        countSuffix: function(config) {
            return $filter('translate')(config.control.getNumberOfItems() == 1 ? 'todo' : 'todos');
        },
        hideEmptyTabs: true,
        rowClick: $scope.open,
        giveFocus: function() {
            return false;
        },
        searchButtons: [
            { title: 'Mark all', buttonClass: 'btn-success', onClick: $scope.markAll, visible: function(config) { var tab = $scope.ToDoConfig.control && $scope.ToDoConfig.control.getActiveTab(); return config && (!$scope.allTodosChecked(config) && tab && tab.showCheckBox); } },
            { title: 'Clear checkboxes', buttonClass: 'btn-danger', onClick: $scope.clearMarked, visible: function(config) { var tab = $scope.ToDoConfig.control && $scope.ToDoConfig.control.getActiveTab(); return config && ($scope.allTodosChecked(config) && tab && tab.showCheckBox); } },
            { title: 'Change marked', buttonClass: 'btn-warning', onClick: $scope.changeMultiple, visible: function(config) { var tab = $scope.ToDoConfig.control && $scope.ToDoConfig.control.getActiveTab(); return config && ($scope.isCheckedTodo(config) && tab && tab.showCheckBox); } },
            { title: 'Finish all marked', buttonClass: 'btn-success', onClick: $scope.completeMultiple, visible: function(config) { var tab = $scope.ToDoConfig.control && $scope.ToDoConfig.control.getActiveTab(); return config && ($scope.isCheckedTodo(config) && tab && tab.showCheckBox); } },
            { title: 'Add', buttonClass: 'btn-success', onClick: $scope.add, showOnEmpty: true }
        ],
        columns: [
            {field: 'checked', format: 'checkbox', visible: visibleColumn },
            {field: 'todo', title: 'ToDo', visible: visibleColumn},
            {field: 'dueDate', title: 'Due date', format: 'datetimeshort', style: function(todo) { if(todo.dueDate && todo.dueDate.yyyymmdd() < Date.today().yyyymmdd() && !todo.performed) { return {color: "red"};} }, visible: visibleColumn },
            {field: 'responsible.name', title: 'Responsible' },
            {field: 'user.name', title: 'Customer'},
            {field: 'group.name', title: 'Group', visible: visibleColumn},
        ],
        buttons: [
            { title: 'Change', buttonClass: 'btn-warning', onClick: $scope.change, visible: function(t) { return !t.performed; } },
            { title: 'Complete', buttonClass: 'btn-success', onClick: $scope.completed, visible: function(t) { return !t.performed; } },
        ],
        orderColumn: 'dueDate'
    };

    $scope.fields = [
        {name: 'toDate', title: 'To', required: true, type: 'date', value: Date.today(), change: $scope.getToDos },
        {name: 'delayed', title: 'Show delayed tasks', type: 'checkbox', value: true, change: $scope.getToDos}
    ];

    $scope.hideSubmitButton = true;
    $scope.noFormValidation = true;

    $scope.getToDos();

    var removeServerChange = $rootScope.$on('serverChange', function (event, message) {
        if (message.type == 'todo') {
            $scope.getToDos();
        }
    });

    // To be sure we are fairly updated - when new day arrives - update every 4 hour
    $interval($scope.getToDos, 1000*60*60*4);

    $scope.$on('$destroy', function () {
        removeServerChange();
    });
}]);

app.controller('MyToDoCtrl', ['$scope', '$controller', function($scope, $controller) {
    $controller('ToDoCtrl', {$scope: $scope});
    $scope.title = 'My ToDo list';
    $scope.forStaff = true;
}]);

app.controller('AllToDoCtrl', ['$scope', '$controller', function($scope, $controller) {
    $scope.forAllStaff = true;
    $controller('ToDoCtrl', { $scope: $scope});
    $scope.title = 'All ToDos';
}]);

app.controller('ToDoAddCtrl', ['$rootScope', '$scope', '$controller', 'server', function($rootScope, $scope,$controller, server) {
    $controller('AddCtrl', {$scope: $scope});

    $scope.title = "Add new Todo";
    $scope.postUrl = '/api/todo/add';

    $scope.submit = function() {
        $scope.loadingStatus.loading = true;
        $("#form").scope().form.$setPristine();
        var item = $scope.getSubmitItem();
        if(item.dueDateTime != null) {
            item.dueDate = item.dueDate + " " + item.dueDateTime;
        }
        delete item.dueDateTime;

        server.post($scope.postUrl, item, null, 'ToDo item added', 'Failed to add ToDo item').then(function(result) {
            if (result.success) {
                for (var i=0; i < $scope.fields.length; ++i) {
                    var field = $scope.fields[i];
                    if(field.name != 'responsible_id' && field.name != 'dueDate') {
                        delete field.value;
                    }
                }
                if ($scope.afterSubmit) {
                    $scope.afterSubmit();
                }
            }

            $scope.loadingStatus.loading = false;
        });
    };

    let groupRow;
    if ($rootScope.speedy) {
        groupRow = {name: 'group_id', title: 'Group', required: false, type: 'group', useId: true};
    } else {
        groupRow = {name: 'group_id', title: 'Group', required: false, type: 'select', options: function() { return $rootScope.usergroups; }, useId: true, visible: function() { return $rootScope.usergroups.length; } };
    }

    $scope.fields = [
        {name: 'todo', title: 'ToDo', required: true, type: 'text', focus: true},
        {name: 'responsible_id', title: 'Responsible', required: false, type: 'customer', useId: true, itemTypes: ['staff'] },
        groupRow,
        {name: 'dueDate', title: 'Performed before', required: false, type: 'date', value: Date.today() },
        {name: 'dueDateTime', title: 'Clock', required: false, type: 'time'},
        {name: 'timeEstimation', title: 'Time estimation', required: false, info: 'minutes', type: 'infoNumber'},
        {name: 'user_id', title: 'Customer', required: false, type: 'customer', useId: true },
        {name: 'description', title: 'Description', required: false, type: 'textarea' },
        {name: 'sites', title: 'Sites', required: true, type: 'multiselect', visible: function() { return $rootScope.hasFlag('flag-todo-sites') && $rootScope.hasModule('MultiSite'); }, options: function() { return $rootScope.sites; }, useId: true, value: [$rootScope.selectedSite] }
    ];

    $rootScope.waitFor(['staffs']).then(function() {
        _.findWhere($scope.fields, {name: 'responsible_id'}).value = $rootScope.getStaff($rootScope.currentStaffId);
    });
}]);

app.controller('ToDoModalAddCtrl', ['$rootScope', '$scope', '$controller', 'options', function($rootScope, $scope, $controller, options) {
    $controller('ToDoAddCtrl', {$scope: $scope});

    $scope.afterSubmit = function() {
        $scope.$close();
    };

    $scope.setInitialValues = function() {
        _.findWhere($scope.fields, {name: 'user_id'}).value = options && options.customer;
    };
    $scope.setInitialValues();
}]);


app.controller('WorkScheduleCtrl', ['$rootScope', '$scope', '$routeParams', '$http', '$modal', '$filter', 'alertProvider', 'workoutProvider', 'calendar', '$q', 'server', 'resourceBooking', 'util', function($rootScope, $scope, $routeParams, $http, $modal, $filter, alertProvider, workoutProvider, calendar, $q, server, $resourceBooking, util) {
    $scope.changeWorkSchedule = function() {
        $modal.open({
            templateUrl: $scope.staff.resource ? 'views/setavailibility.html' : 'views/addworkschedule.html',
            controller: 'WorkScheduleAddModalCtrl',
            resolve: {
                options: function() {
                    return {
                        staffs: $scope.staff.resource ? $rootScope.getActiveResources() : $rootScope.getActiveStaffs(),
                        selected: [$scope.staff],
                        successTitle: $scope.staff.resource ? 'Availibility changed' : null,
                        failedTitle: $scope.staff.resource ? 'Failed to change availibility' : null,
                        type: $scope.staff.resource ? 'resource' : 'staff'
                    };
                }
            }
        });
    };

    $scope.changeWorkScheduleForDay = function(day) {
        $modal.open({
            templateUrl: $scope.staff.resource ? 'views/changeavailibility.html' : 'views/changeworkschedule.html',
            controller: 'WorkScheduleChangeModalCtrl',
            resolve: {
                options: function() {
                    return {
                        staffs: $scope.staff.resource ? $rootScope.getActiveResources() : $rootScope.getActiveStaffs(),
                        selected: [$scope.staff],
                        fromDate: day,
                        successTitle: $scope.staff.resource ? 'Availibility changed' : null,
                        failedTitle: $scope.staff.resource ? 'Failed to change availibility' : null,
                        type: $scope.staff.resource ? 'resource' : 'staff'
                    };
                }
            }
        });
    };

    $scope.getCalendar = function() {
        location.href = $scope.staff.icalendar;
    };

    $scope.getGoogleCalendar = function() {
        window.open('https://www.google.com/calendar/render?cid=' + $scope.staff.icalendar);
    };

    var getting = {};
    var updateCalendar = function() {
        if (!_.some(getting)) {
            calendar.adjustMinMax($scope.calendarConfig, $scope.calendarSources);
        }
    };

    var loadResourceAllocation = _.debounce(function() {
        if (!$scope.visStart || !$scope.visEnd) {
            return;
        }

        server.post2('/api/resourcebooking/resource/get_resource_allocation', {
            resource_ids: [$scope.staffId],
            start: $scope.visStart,
            end: $scope.visEnd,
            mode: 'slots'
        }).then(function(response) {
            var dependencies = ['staffs', 'members'];
            if($rootScope.hasPermission('Show resource bookings')) {
                dependencies.push('resourcebookingservices');
            }

            $rootScope.waitFor(dependencies).then(function() {
                var rbookings = $scope.calendarSources[1] = [];
                var workouts = $scope.calendarSources[2] = [];
                var allocations = $scope.calendarSources[3] = [];
                response.forEach(function(data) {
                    if (data.slot) {
                        rbookings.push($resourceBooking.slotForCalendar(data));
                    } else if (data.origin_type == 'Workout') {
                        var workout = data.origin;
                        $rootScope.transformWorkout(workout);
                        workout.allresources = [$rootScope.getPointerById(data.resource_id, $rootScope.users)];
                        workouts.push(workout);
                    } else if (data.origin_type == 'linked_resources') {
                        var secondResourceId = data.origin_id.filter(i => i != $scope.staffId)[0];
                        if(!secondResourceId) return;
                        var name = $rootScope.getMember(secondResourceId)?.name;
                        if (name) {
                            let a = {
                                start: data.start,
                                end: data.end,
                                backgroundColor: 'rgba(40, 176, 255, 0.75)',
                                title: '',
                                isAnnotation: true,
                                showPointer: true
                            }
                            // Use getter to get name of member. Allows us to dynamically update the name (Speedy)
                            Object.defineProperty(a, 'name', {
                                get: function() {
                                    return $rootScope.getMember(secondResourceId)?.name;
                                }
                            });

                            allocations.push(a);
                        }
                    }
                });
                updateCalendar();
            });
        });
    }, 50);

    var debouncedRenderCalendar = _.debounce(function() {
        calendar.render($scope.calendarConfig);
    }, 50);

    $scope.$on('ApiDataLoaded', function() {
        debouncedRenderCalendar();
    });

    $scope.getWorkSchedule = _.debounce(function() {
        if(!$scope.visStart || !$scope.visEnd || !$scope.staffId) {return;}
        getting.workschedule = true;
        $http.get('/api/staff/workschedule/get?staffs=' + $scope.staffId + '&fromDate=' + $scope.visStart.yyyymmdd() + '&toDate=' + $scope.visEnd.yyyymmdd() + '&site_id=' + $rootScope.selectedSite.id).success(function(workschedule) {
            angular.forEach(workschedule, function(t) {
                t.start = Date.newFull(t.start);
                t.end = Date.newFull(t.end);
                t.backgroundColor = ($scope.tabid === 'myServiceHours' ? 'rgba(255, 255, 255, 0)' : 'rgba(99, 166, 99, 0.5)');
                t.title = '';
                t.isAnnotation = true;
                t.showPointer = true;
            });
            $scope.calendarSources[0] = workschedule;
            getting.workschedule = false;
            updateCalendar();
        });
    }, 50);

    $scope.getWorkouts = function() {
        return $scope.calendarSources[2];
    };

    $scope.isMyWorkout = function(workout) {
        return _.findWhere(workout.staffs, {id: $scope.staffId}) || _.findWhere(workout.resources, {id: $scope.staffId});
    };

    $scope.calendarConfig = calendar.getDefaultConfig($scope.smallCalendar);
    $scope.calendarConfig.showBottomWorkSchedule = true;
    $scope.calendarConfig.viewRender = function(view) {
        if (calendar.viewChanged($scope, view, $scope.calendarConfig)) {
            var watch = $scope.$watch('staff', function() {
                if ($scope.staff) {
                    if (view.name == "month"){
                        $scope.calendarSources[0] = [];
                    } else {
                        $scope.getWorkSchedule();
                    }
                    loadResourceAllocation();
                    watch();
                }
            });
        }
    };

    $scope.calendarConfig.changeWorkScheduleForDay = function(date) {
        $scope.changeWorkScheduleForDay(date);
    };

    $scope.calendarConfig.eventClick = function(calEvent) {
        if (calEvent.isAnnotation) {
            var date = calEvent.start;
            var endTime = date.clone().addMinutes(60);
            util.showDataDialog({controller: 'WorkoutDataCtrl', initial: {date: date, startTime: date, endTime: endTime, Staffs: [$scope.staff] }});
        } else if (calEvent.workoutType) {
            $rootScope.showWorkout(calEvent);
        } else {
            if(calEvent.enableCapacity || (calEvent.resource_booking && calEvent.resource_booking.length != 1)) {
                $resourceBooking.showBookingList(calEvent);
            } else {
                $resourceBooking.openById(calEvent.resource_booking_id[0]);
            }
        }
    };

    $scope.$watch($scope.isSmallCalendar, function(isSmall, wasSmall) {
        if (isSmall != wasSmall) {
            $scope.calendarConfig.header.right =  isSmall ? '' : 'month,agendaWeek,agendaDay';
        }
    });

    $scope.calendarConfig.dayClick = function(date) {
        var endTime = date.clone().addMinutes(60);
        util.showDataDialog({controller: 'WorkoutDataCtrl', initial: {date: date, startTime: date, endTime: endTime, Staffs: [$scope.staff] }});
    };

    $scope.updateSchedule = function() {
        $scope.getWorkSchedule();
        loadResourceAllocation();
    };

    $scope.calendarSources = [[], [], []];

    calendar.updateTranslation([$scope.calendarConfig]);

    $rootScope.waitFor(['staffs']).then(function() {
        if ($routeParams.staffId) {
            $scope.staffId = Number($routeParams.staffId);
        } else {
            $scope.staffId = $rootScope.currentStaffId;
        }

        $scope.staff = $rootScope.getStaff($scope.staffId);
    });

    var removeTranslateChangeSuccess = $rootScope.$on('$translateChangeSuccess', function () {
        calendar.updateTranslation([$scope.calendarConfig]);
    });

    var removeWorkoutsChange = $rootScope.$on('workoutsChanged', function () {
        //$scope.getWorkScheduleWorkouts();
        if ($scope.tabid !== 'myServiceHours') { loadResourceAllocation(); }
    });

    var removeServerChange = $rootScope.$on('serverChange', function (event, message) {
        if (!$scope.staff) {
            // FIXME: These changes gets lost
            return;
        }

        // Manually update stuff for this particular staff
        var fetchResourceBooking = false;
        var fetchWorkSchedule = false;
        var fetchWorkouts = false;
        angular.forEach(message.data, function(messageData) {
            if (message.type == 'resourcebooking' || message.type == 'resourceallocation') {
                fetchResourceBooking = true;
            } else if (message.type == 'workschedule' && messageData.staff == $scope.staffId) {
                fetchWorkSchedule = true;
            } else if (message.type == 'workout' && message.action == 'change') {
                if (_.findWhere($scope.getWorkouts(), {id: messageData.id}) || $scope.isMyWorkout(messageData)) {
                    fetchWorkouts = true;
                }
            }
        });

        if (fetchResourceBooking || fetchWorkouts) {
            if ($scope.tabid !== 'myServiceHours') { loadResourceAllocation(); }
        }

        if (fetchWorkSchedule) {
            $scope.getWorkSchedule();
        }
    });

    $scope.pubsub('selectedSite', function() {
        $scope.getWorkSchedule();
    });

    $scope.$on('$destroy', function () {
        removeWorkoutsChange();
        removeTranslateChangeSuccess();
        removeServerChange();
    });

    $scope.pubsub('tabChanged', function(tab) {
        if (tab == 'my' || tab == 'weeklyScheduleResource') {
            util.waitFor($scope, 'calendarObject').then(function() {
                util.waitForVisible($scope.calendarObject).then(function() {
                    var small = $scope.calendarObject.width() <= 768;

                    $scope.calendarConfig.header.right = small ? '' : 'month,agendaWeek,agendaDay';
                    $scope.calendarConfig.defaultView = small ? 'agendaDay' : 'agendaWeek';

                    $scope.calendarObject.fullCalendar('render');
                });
            });
        }
    }, true);

    var addWorkout = function() {
        var date = new Date();
        var endTime = date.clone().addMinutes(60);
        util.showDataDialog({controller: 'WorkoutDataCtrl', initial: {date: date, startTime: date, endTime: endTime, Staffs: [$scope.staff]}});
    };

    $scope.buttonConfig = {
        title: 'Calendar actions',
        individualButtons: function() { return !$scope.isSmallCalendar || !$scope.isSmallCalendar(); },
        actions: [
            {title: 'Add work schedule', visible: function() { return $rootScope.hasPermission($scope.staff && $scope.staff.id ? 'Staff change self' : 'Staff handling'); }, onClick: $scope.changeWorkSchedule },
            {title: 'Get calendar', onClick: $scope.getCalendar},
            {title: 'Get Google calendar', onClick: $scope.getGoogleCalendar},
            {title: 'Add new activity', onClick: addWorkout, visible: function() { return $rootScope.hasPermission('Schedule handling');} }
        ]
    };
}]);

app.controller('AllStaffWorkScheduleCtrl', ['$rootScope', '$scope', '$routeParams', '$http', '$filter', '$modal', 'calendar', 'workoutProvider', '$q', 'server', 'resourceBooking', 'util', 'ApiDataLoader',
    function($rootScope, $scope, $routeParams, $http, $filter, $modal, calendar, workoutProvider, $q, server, $resourceBooking, util, ApiDataLoader) {
    $scope.allBookedTimes = [];
    $scope.allWorkouts = [];
    $scope.allWorkSchedules = [];
    $scope.allAllocations = [];
    var getting = {};

    if (!$scope.loadStaffs) {
        $scope.loadStaffs = function() {
            return $rootScope.waitFor(['sites']).then(() => {
                return server.get('/api/staff/get', {site_id: $rootScope.selectedSite.id, inactive: false, compact: true, fields: 'id'}).then(staffs => {
                    staffs.forEach($rootScope.getMember);
                    let promises = staffs.map(staff => ApiDataLoader.getData('user', staff.id));
                    return $q.all(promises);
                });
            });
        }
    }
    if ($rootScope.speedy) {
        $scope.loadStaffsPromise = $scope.loadStaffs();
        $scope.loadStaffsPromise.then(() => $scope.updateStaffList());
    }

    $scope.getAllStaffs = function() {
        return $rootScope.users;
    };

    $scope.getBookedTimes = _.debounce(function() {
        var start = $scope.visStart;
        var end = $scope.visEnd;
        if (!start || !end) {
            return;
        }

        var dependencies = ['staffs'];
        if($rootScope.hasModule('ResourceBooking')) {
            dependencies.push('resourcebookingservices');
        }
        let promises = [$rootScope.waitFor(dependencies)];
        if ($scope.loadStaffsPromise) {
            promises.push($scope.loadStaffsPromise);
        }

        $scope.calendarConfig.loading += 1;
        $q.all(promises).then(function() {
            const resource_ids = $scope.getAllStaffs().filter($scope.itemFilter).map(u => u.id);
            server.post2('/api/resourcebooking/resource/get_resource_allocation', {
                resource_ids,
                start: $scope.visStart,
                end: $scope.visEnd,
                mode: 'slots'
            }).then(function(response) {
                var workouts = $scope.allWorkouts = [];
                var bookings = $scope.allBookedTimes = [];
                var allocations = $scope.allAllocations = [];

                response.forEach(function(data) {
                    if(data.slot) {
                        bookings.push($resourceBooking.slotForCalendar(data));
                    } else if(data.origin_type == 'Workout') {
                        var workout = data.origin;
                        $rootScope.transformWorkout(workout);
                        workout.allresources = [$rootScope.getStaff(data.resource_id)];
                        workouts.push(workout);
                    } else if(data.origin_type == 'linked_resources') {
                        allocations.push({
                            staff: $rootScope.getStaff(data.resource_id),
                            start: data.start,
                            end: data.end,
                            backgroundColor: 'rgba(40, 176, 255, 0.75)',
                            title: '',
                            isAnnotation: true,
                            showPointer: true,
                            allresources: data.origin_id.map($rootScope.getStaff)
                        });
                    }
                });

                $scope.updateStaffFilter();
                $scope.calendarConfig.loading -= 1;
            });

            $scope.getWorkSchedules();
        });
    }, 50);

    $scope.itemFilter = function(u) {
        return u && u.active && u.staff;
    };

    $scope.getWorkSchedules = _.debounce(function() {
        let staffs = $scope.getAllStaffs();
        if (!staffs || !staffs.length) return;
        staffs = staffs.filter($scope.itemFilter);
        if (staffs.length > 0) {
            var ids = _.pluck(staffs, 'id').filter(id => id).join(',');
            if (!ids) return;
            getting.workschedule = true;
            $scope.calendarConfig.loading += 1;
            $http.get('/api/staff/workschedule/get?staffs=' + ids + '&fromDate=' + $scope.visStart.yyyymmdd() + '&toDate=' + $scope.visEnd.yyyymmdd() + '&site_id=' + $rootScope.selectedSite.id).success(function(workschedule) {
                angular.forEach(workschedule, function(t) {
                    t.staff = $rootScope.getStaff(t.staff);
                    t.start = Date.newFull(t.start);
                    t.end = Date.newFull(t.end);
                    t.backgroundColor = 'rgba(99, 166, 99, 0.5)';
                    t.title = '';
                    t.isAnnotation = true;
                    t.allresources = [t.staff];
                    t.staffs = [t.staff];
                });

                $scope.allWorkSchedules = workschedule;
                getting.workschedule = false;
                $scope.updateStaffFilter();
                $scope.calendarConfig.loading -= 1;
            });
        }
    }, 50);

    $scope.updateStaffFilter = function() {
        if (!_.some(getting)) {
            $scope.calendarSources[0] = $scope.allWorkSchedules.filter($scope.isSelectedStaff);
            $scope.calendarSources[1] = $scope.allWorkouts.filter($scope.isSelectedStaff);
            $scope.calendarSources[2] = $scope.allBookedTimes.filter($scope.isSelectedStaff);
            $scope.calendarSources[3] = $scope.allAllocations.filter($scope.isSelectedStaff);
            calendar.adjustMinMax($scope.calendarConfig, $scope.calendarSources);

            var all = $scope.calendarSources[0].concat($scope.calendarSources[1], $scope.calendarSources[2]);
            var allToday = all.filter(function(e) {
                return e.start >= $scope.visStart && e.end <= $scope.visEnd;
            });

            let workingResources = $scope.selectedStaffs.filter(res => {
                return allToday.find(e => e.allresources.find(x => x.id == res.id));
            });

            if (workingResources.length == 0) {
                workingResources = [{ id: 0, name: '' }];
            }

            $scope.calendarConfig.resources = workingResources;
            $scope.calendarObject.fullCalendar('render');
        }
    };

    $scope.pubsub('tabChanged', function(tab) {
        if (tab == 'all' || tab == 'resources') {
            util.waitFor($scope, 'calendarObject').then(function() {
                util.waitForVisible($scope.calendarObject).then(function() {
                    $scope.calendarObject.fullCalendar('render');
                });
            });
        }
    }, true);

    $scope.staffsChanged = function() {
        $scope.selectedStaffs = _.findWhere($scope.fields, {name: 'staffs'}).value;
        $scope.updateStaffFilter();
    };

    $scope.isSelectedStaff = function(slot) {
        return $scope.selectedStaffs.find(staff => slot.allresources.find(x => x.id === staff.id));
    };

    $scope.calendarConfig = calendar.getDefaultConfig();
    $scope.calendarConfig.loading = 0;
    $scope.calendarConfig.header.right = null;
    $scope.calendarConfig.defaultView = 'agendaDay';
    $scope.calendarConfig.showBottomWorkSchedule = true;
    $scope.calendarConfig.resources = $scope.selectedStaffs;
    $scope.calendarConfig.viewRender = function(view) {
        if (calendar.viewChanged($scope, view, $scope.calendarConfig)) {
            $scope.getBookedTimes();
        }
    };
    $scope.calendarConfig.changeWorkScheduleForDay = function(day) {
        var index = Math.round((day - $scope.visStart) / (1000 * 3600 * 24));
        var resource = $scope.calendarConfig.resources[index];
        $modal.open({
            templateUrl: resource.resource ? 'views/changeavailibility.html' : 'views/changeworkschedule.html',
            controller: 'WorkScheduleChangeModalCtrl',
            resolve: {
                options: function() {
                    return {
                        staffs: resource.resource ? $rootScope.getActiveResources() : $rootScope.getActiveStaffs(),
                        selected: [resource],
                        fromDate: $scope.visStart,
                        successTitle: resource.resource ? 'Availibility changed' : null,
                        failedTitle: resource.resource ? 'Failed to change availibility' : null,
                        type: resource.resource ? 'resource' : 'staff'
                    };
                }
            }
        });
    };

    $scope.$watch($scope.isSmallCalendar, function(isSmall, wasSmall) {
        if (isSmall != wasSmall) {
            if ($scope.calendarObject) {
                $scope.calendarObject.fullCalendar('render');
            }
        }
    });

    var addWorkout = function(startTime, staff) {
        var endTime = startTime.clone().addMinutes(60);
        util.showDataDialog({controller: 'WorkoutDataCtrl', initial: {date: startTime.clone().clearTime(), startTime: startTime, endTime: endTime, Staffs: [staff]}});
    };

    var lastAnnotationClickTime = new Date().getTime();
    $scope.calendarConfig.eventClick = function(calEvent) {
        if (calEvent.isAnnotation) {
            var thisClickTime = new Date().getTime();
            var timeSinceLastClick = thisClickTime - lastAnnotationClickTime;
            lastAnnotationClickTime = thisClickTime;
            if (timeSinceLastClick < 300) {
                addWorkout(calEvent.clickedSlotTime, calEvent.clickedResource || calEvent.staff);
            }
            return;
        }
        if (calEvent.workoutType) {
            $rootScope.showWorkout(calEvent);
        } else {
            if(calEvent.enableCapacity || (calEvent.resource_booking && calEvent.resource_booking.length != 1)) {
                $resourceBooking.showBookingList(calEvent);
            } else {
                $resourceBooking.openById(calEvent.resource_booking_id[0]);
            }
        }
    };

    var lastClickTime = new Date().getTime();
    $scope.calendarConfig.dayClick = function(date) {
        var thisClickTime = new Date().getTime();
        var timeSinceLastClick = thisClickTime - lastClickTime;
        lastClickTime = thisClickTime;

        if (timeSinceLastClick < 300) {
            // Double click
            var resource_index = $scope.visStart.daysUntil(date);
            var staff = $scope.calendarConfig.resources[resource_index];
            var startTime = $scope.visStart.clone();
            startTime.setHours(date.getHours(), date.getMinutes(),0,0);
            addWorkout(startTime, staff);
        }
    };

    $scope.calendarSources = [[], [], [], []];

    calendar.updateTranslation([$scope.calendarConfig]);

    $scope.updateStaffList = function() {
        let staffs = $scope.getAllStaffs();
        if (!staffs || !staffs.length) return;
        staffs = staffs.filter($scope.itemFilter);
        staffs = $filter('orderBy')(staffs, 'name');
        $scope.selectedStaffs = staffs;
        $scope.calendarConfig.resources = $scope.selectedStaffs;
        _.findWhere($scope.fields, {name: 'staffs'}).value = staffs;
        if ($scope.calendarObject) {
            $scope.calendarObject.fullCalendar('render');
        }
    };

    $scope.fields = [
        {name: 'staffs', title: 'Staff', required: false, type: 'customers', itemTypes: ['staff'], change: $scope.staffsChanged }
    ];
    $scope.noFormValidation = true;
    $scope.hideSubmitButton = true;

    $rootScope.waitFor(['staffs']).then(function() {
        $scope.updateStaffList();
    });

    var removeServerChange = $rootScope.$on('serverChange', function (event, message) {
        if (message.type == 'resourcebooking' || message.type == 'workout' || message.type == 'workschedule' || message.type == 'resourceallocation') {
            $scope.getBookedTimes();
        } else if (message.type == 'user' && (message.action == 'add' || message.action == 'remove')) {
            $scope.updateStaffList();
        }
    });

    var removeTranslateChangeSuccess = $rootScope.$on('$translateChangeSuccess', function () {
        calendar.updateTranslation([$scope.calendarConfig]);
    });

    $scope.pubsub('selectedSite', function() {
        $scope.getBookedTimes();
    });

    setTimeout(function() { // wait a calendar is rendered
        $scope.updateStaffList();
    }, 10);

    $scope.$on('$destroy', function () {
        removeServerChange();
        removeTranslateChangeSuccess();
    });

    var debouncedUpdate = _.debounce(function() {
        $scope.updateStaffList();
        $scope.updateStaffFilter();
    }, 50);

    $scope.$on('ApiDataLoaded', () => {
        debouncedUpdate();
    });
}]);

app.controller('AllResourcesWorkScheduleCtrl', ['$rootScope', '$scope', '$controller', 'server', 'ApiDataLoader', '$q', function($rootScope, $scope, $controller, server, ApiDataLoader, $q) {
    // Define loadStaffs. Will be called in Speedy mode in AllStaffWorkScheduleCtrl
    $scope.loadStaffs = function() {
        return $rootScope.waitFor(['sites']).then(() => {
            return server.get('/api/resource/get', {site_id: $rootScope.selectedSite.id, inactive: false}).then(resources => {
                resources.forEach(resource => $rootScope.getMember(resource));
                let promises = resources.map(resource => ApiDataLoader.getData('user', resource.id));
                return $q.all(promises);
            });
        });
    }
    $controller('AllStaffWorkScheduleCtrl', {$scope: $scope});

    $scope.itemFilter = function(u) {
        return u.active && u.resource;
    };

    $scope.fields = [
        {name: 'staffs', title: 'Resources', required: false, type: 'customers', itemTypes: ['resource'], change: $scope.staffsChanged }
    ];
}]);

app.controller('WeeklyScheduleResourceCtrl', ['$rootScope', '$scope', '$controller', '$filter', 'ApiDataLoader', 'server', '$q', function($rootScope, $scope, $controller,$filter, ApiDataLoader, server, $q) {
    $controller('WorkScheduleCtrl', {$scope: $scope});

    if(typeof $scope.data == 'undefined') {
        $scope.data = {};
    }

    $scope.isSelectedStaff = function(resource) {
        return $scope.settings.resources.includes(resource.id);
    };

    $scope.staffsChanged = function() {
        $scope.staff = $scope.data.selectedResource;
        $scope.staffId = $scope.staff.id;
        $scope.updateSchedule();
    };

    $scope.allStaffs = null;
    $scope.loadStaffs = function() {
        return $rootScope.waitFor(['sites']).then(() => {
            let siteParams = {site_id: $rootScope.selectedSite.id, inactive: false};
            return $q.all([
                server.get('/api/staff/get', Object.assign({compact: true, fields: 'id'}, siteParams)),
                server.get('/api/resource/get', siteParams)
            ]).then(([staffs, resources]) => {
                let all = staffs.concat(resources);
                $scope.allStaffs = all.map($rootScope.getMember);
                let promises = all.map(item => ApiDataLoader.getData('user', item.id));
                return $q.all(promises);
            });
        });
    }

    let promises = [$rootScope.waitFor(['staffs'])];
    if ($rootScope.speedy) {
        promises.push($scope.loadStaffs());
    } else {
        $scope.allStaffs = $rootScope.staffs;
    }

    $q.all(promises).then(function() {
        if(typeof $scope.settings.resources == 'undefined') {
            // Widget: Schedule
            $scope.data.selectedResources = $scope.allStaffs;
        } else {
            // Widget: Customschedule and Weeklyschedule
            $scope.data.selectedResources = $filter('filter')($scope.allStaffs, $scope.isSelectedStaff);
            if(!(!!_.findWhere($scope.data.selectedResources, { id: $rootScope.currentStaffId }))) {
                $scope.data.selectedResources.push($rootScope.currentStaff);
            }
        }

        if(typeof $scope.data.selectedResource == 'undefined') {
            $scope.staff = $scope.data.selectedResources.find(staff => staff.id == $rootScope.currentStaffId);
            $scope.data.selectedResource = $scope.staff;
            $scope.staffId = $scope.staff?.id;
        }
    });
}]);

app.controller('CustomScheduleCtrl', ['$rootScope', '$scope', '$controller', '$modal', 'resourceBooking', 'calendar', 'util', function($rootScope, $scope, $controller, $modal, $resourceBooking, calendar, util) {
    $controller('AllStaffWorkScheduleCtrl', {$scope: $scope});

    $scope.getAllStaffs = function() {
        return $scope.settings.resources.map($rootScope.getStaff);
    };

    $scope.itemFilter = function(u) {
        return u?.active;
    };

    // Override to preserve the resource order from widget settings
    // instead of sorting alphabetically by name
    $scope.updateStaffList = function() {
        var staffs = $scope.settings.resources.map($rootScope.getStaff).filter($scope.itemFilter);
        if (!staffs.length) return;
        $scope.selectedStaffs = staffs;
        $scope.calendarConfig.resources = staffs;
        if ($scope.calendarObject) {
            $scope.calendarObject.fullCalendar('render');
        }
    };

    $scope.isSelectedStaff = function(slot) {
        return !!_.find($scope.settings.resources, function(resource_id) {
            return _.findWhere(slot.allresources, { id: resource_id });
        });
    };

    $scope.updateStaffFilter = function() {
        $scope.calendarSources[0] = $scope.allWorkSchedules.filter($scope.isSelectedStaff);
        $scope.calendarSources[1] = $scope.allWorkouts.filter($scope.isSelectedStaff);
        $scope.calendarSources[2] = $scope.allBookedTimes.filter($scope.isSelectedStaff);
        $scope.calendarSources[3] = $scope.allAllocations ? $scope.allAllocations.filter($scope.isSelectedStaff) : [];
        calendar.adjustMinMax($scope.calendarConfig, $scope.calendarSources);

        var all = $scope.calendarSources[0].concat($scope.calendarSources[1], $scope.calendarSources[2]);
        var allToday = all.filter(function(e) {
            return e.start >= $scope.visStart && e.end <= $scope.visEnd;
        });
        if ($scope.settings.hideEmpty && allToday.length) {
            var resources = $scope.settings.resources.map($rootScope.getStaff);
            var workingResources = resources.filter(function(res) {
                return allToday.filter(function(e) { return e.allresources.indexOf(res) != -1; }).length > 0;
            });

            if (workingResources.length == 0) {
                workingResources = [{ id: 0, name: '' }];
            }

            $scope.calendarConfig.resources = workingResources;
        } else if($scope.settings?.resources?.length) {
            $scope.calendarConfig.resources = $scope.settings.resources.map($rootScope.getStaff);
        }

        $scope.calendarObject.fullCalendar('render');
    };

    var addWorkout = function(startTime, staff) {
        var endTime = startTime.clone().addMinutes(60);
        util.showDataDialog({controller: 'WorkoutDataCtrl', initial: {date: startTime.clone().clearTime(), startTime: startTime, endTime: endTime, Staffs: [staff]}});
    };

    var addResourceBooking = function(slot) {
        var staff = slot.clickedResource || slot.staff;
        $modal.open({
            templateUrl: 'views/rbbookingadd.html',
            controller: 'ResourceBookingAddModalCtrl',
            resolve: {
                options: function() {
                    return { bookingParts: [{slot: slot, staff: staff}], customer: null };
                }
            }
        });
    };

    var addWorkoutOrResourceBooking = function(calEvent) {
        return $modal.open({
            template: '<div class="modal-header"><h4>{{\'Add booking\'|translate}}</h4></div><div ng-include src="\'views/member/multibuttonanswermodal.html\'"/>',
            controller: 'MultiButtonAnswerModalCtrl',
            resolve: {
                options: function() {
                    return {
                        buttons: [
                            { title: 'Add workout', answer: 'workout', style: { 'margin-bottom': '1ex' } },
                            { title: 'Add resource booking', answer: 'resourcebooking', style: { 'margin-bottom': '1ex' } },
                        ]
                    };
                }
            }
        }).result.then(function(answer) {
            if (answer == 'resourcebooking') {
                addResourceBooking(calEvent);
            } else if (answer == 'workout') {
                addWorkout(calEvent.clickedSlotTime, calEvent.clickedResource || calEvent.staff);
            }
        });
    };

    var lastAnnotationClickTime = new Date().getTime();
    $scope.calendarConfig.eventClick = function(calEvent) {
        if (calEvent.isAnnotation) {
            var thisClickTime = new Date().getTime();
            var timeSinceLastClick = thisClickTime - lastAnnotationClickTime;
            lastAnnotationClickTime = thisClickTime;
            if (timeSinceLastClick < 300) {
                addWorkoutOrResourceBooking(calEvent);
            }
        } else if (calEvent.workoutType) {
            $rootScope.showWorkout(calEvent);
        } else {
            if(calEvent.enableCapacity || (calEvent.resource_booking && calEvent.resource_booking.length != 1)) {
                $resourceBooking.showBookingList(calEvent);
            } else {
                $resourceBooking.openById(calEvent.resource_booking_id[0]);
            }
        }
    };

    $rootScope.waitFor(['staffs']).then(function() {
        $scope.calendarConfig.resources = $scope.settings.resources.map($rootScope.getStaff);
    });

}]);

app.controller('AttendanceListCtrl', ['$rootScope', '$routeParams', '$scope', '$http', 'workoutProvider', '$location', function($rootScope,$routeParams, $scope, $http, workoutProvider, $location) {
    var allAttendanceWorkouts = [];
    $scope.getWorkouts = function() {
        $scope.data.date = _.findWhere($scope.fields, {name: 'date'}).value;
        if (!$scope.data.date || $scope.data.date.getFullYear() < 1900) {
            return;
        }
        $location.search('date', $scope.data.date.yyyymmdd());
        workoutProvider.getAttendance($scope.data.date).then(function(workouts) {
            angular.forEach(workouts, function(workout) {
                if (workout.is_match && workout.bookable_for_groups.length > 0) {
                    workout.match_team_title = workout.title + ' (' + $rootScope.getGroup(workout.bookable_for_groups[0]).name + ')';
                }
            });
            allAttendanceWorkouts = workouts;
            $rootScope.attendanceWorkouts = workouts;
            $scope.updateList();
        });
    };

    $scope.updateList = function() {
        var wtFilter = _.findWhere($scope.fields, {name: 'workoutCategory'}).value;
        if (!wtFilter) {
            $rootScope.attendanceWorkouts = allAttendanceWorkouts.filter(function(w) { return w.site_id == $rootScope.selectedSite.id; });
            $location.search('category', 0);
        } else {
            $rootScope.attendanceWorkouts = allAttendanceWorkouts.filter(function(w) { return w.workoutType.category_id == wtFilter.id && w.site_id == $rootScope.selectedSite.id; });
            $location.search('category', wtFilter.id);
        }
    };

    $scope.categoryForCurrentSite = function(category) {
        return category.active && (!$rootScope.hasModule('MultiSite') || ($rootScope.selectedSite && category.sites.indexOf($rootScope.selectedSite.id) != -1));
    };

    var getWorkoutCategories = function() {
        return $rootScope.workoutcategories.filter(function(wc) { return $scope.categoryForCurrentSite(wc); });
    };

    $scope.fields = [
        { name: 'date', title: 'Date', required: true, type: 'date', change: _.debounce($scope.getWorkouts, 300) },
        { name: 'workoutCategory', title: 'Category', required: false, type: 'select', visible: function() { return getWorkoutCategories().length > 1; }, options: getWorkoutCategories, placeholder: 'No workout category choosen', change: $scope.updateList }
    ];
    $scope.hideSubmitButton = true;

    $scope.setInitialValues = function() {
        $scope.data = { date : '', category: '' };
        $scope.data.date = $routeParams.date ? Date.newFull($routeParams.date) : new Date();
        $rootScope.waitFor(['workoutcategories']).then(function() {
            $scope.data.category = $routeParams.category !== undefined ? $routeParams.category : _.min(getWorkoutCategories(), function(wc) { return wc.order; }).id;
            _.findWhere($scope.fields, {name: 'date'}).value = $scope.data.date ? $scope.data.date : new Date();
            _.findWhere($scope.fields, {name: 'workoutCategory'}).value = $scope.data.category ? _.findWhere($rootScope.workoutcategories, {id: Number($scope.data.category)}) : undefined;
            $scope.getWorkouts();
        });
    };
    $scope.setInitialValues();

    $scope.go = function(workout) {
        $location.path('/attendance/show/' + workout.id);
    };

    $scope.pubsub('selectedSite', function() {
        _.findWhere($scope.fields, {name: 'workoutCategory'}).value = null;
        $scope.updateList();
    });
}]);

app.controller('AttendanceCtrl', ['$rootScope', '$scope', '$routeParams', 'server', '$location', '$modal', 'workoutProvider', 'alertProvider', 'options', '$interval', function($rootScope, $scope, $routeParams, server, $location, $modal, workoutProvider, alertProvider, options, $interval) {
    if(options.workoutId) {
        $scope.workoutId = options.workoutId;
        $scope.isModal = true;
    } else {
        $scope.workoutId = Number($routeParams.workoutId);
    }

    $scope.setWorkout = function() {
        workoutProvider.getWorkoutById($scope.workoutId).then(function(w) {
            $scope.workout = w;
        });
    };

    $scope.setPresent = function(id, present) {
        var old = _.findWhere($scope.workout.bookings, {id: id}).present;
        if (old.reserved) {
            return;
        }
        _.findWhere($scope.workout.bookings, {id: id}).present = present;
        server.post('/api/attendance/set', null, {id: id, present: present}).then(function(result) {
            if (!result.success) {
                _.findWhere($scope.workout.bookings, {id: id}).present = old;
                alertProvider.show('error', 'Failed to change attendance. Check internet connection.');
            }
        });
    };

    $scope.addBooking = function() {
        $modal.open({
            templateUrl: 'views/bookingadd.html',
            controller: 'WorkoutBookingAddModalCtrl',
            windowClass: 'huge-modal-window',
            resolve: {
                workout: function() {
                    return $scope.workout;
                }
            }
        });
    };

    $scope.getUsername = function(user) {
        if(options.showPersonalCodeNumber && user.personalCodeNumber) {
            return user.name + ' [' + user.personalCodeNumber + ']';
        }
        return user.name;
    };

    $scope.gotoCustomer = function(user) {
        if($scope.isModal) {
            $scope.$dismiss();
        }
        $rootScope.gotoCustomer(user);
    };

    $scope.addCustomer = function() {
        $rootScope.showCombo({workout: $scope.workout});
    };

    var disabledFilter = function(customer) {
        return _.findWhere($scope.workout.getBookingsWithSeat().filter(function(wb) {
            return wb.present;
        }), {user_id: customer.id});
    };

    $scope.chooseDisabled = function() {
        server.get('/api/attendance/disabled/get', {workout_id: $scope.workout.id}).then(function(customers) {
            var selected = customers.map($rootScope.getMember);
            var modalInstance = $modal.open({
                templateUrl: 'views/getcustomermodal.html',
                controller: 'GetCustomerCtrl',
                windowClass: 'huge-modal-window',
                resolve: {
                    options: function() {
                        return { itemFilter: disabledFilter , multiple: true, itemTypes: null, selected: selected };
                    }
                }
            });

            modalInstance.result.then(function (customers) {
                server.post('/api/attendance/disabled/set', {workout_id: $scope.workout.id, users: _.pluck(customers, 'id')}, null, 'Information saved', 'Failed to save information');
            });
        });
    };

    $scope.debts = [];
    $scope.getRowClass = function(booking) {
        var debt = _.findWhere($scope.debts, { id: booking.user_id });
        return (debt && debt.amount > 0 && $rootScope.hasPermission('Show payments')) ? 'danger' : 'success';
    };
    $scope.getDebtAmount = function(user) {
        var debt = _.findWhere($scope.debts, { id: user.id });
        return (debt && debt.amount > 0 && $rootScope.hasPermission('Show payments')) ? debt.amount : '';
    };

    var getDebts = function() {
        if (!$scope.workout || !$scope.workout.bookings.length) { return; }
        var ids = _.pluck($scope.workout.bookings, 'user_id');
        server.get('/api/member/debt/details', { ids: ids }).then(function(debts) {
            $scope.debts = debts;
        });
    };
    $scope.$watch('workout.bookings.length', getDebts);

    var lastInterval = (new Date()).getTime();

    var refreshWorkoutInterval = $interval(function() {
        var now = (new Date()).getTime();
        var diff = now - lastInterval;
        var offBy = diff - 1000;
        lastInterval = now;
        if(offBy > 100) { // do not trigger under 100ms
            workoutProvider.getWorkoutById($scope.workoutId, true).then(function(w) {
                $scope.workout = w;
            });
        }
    }, 1000);

    $scope.$on('$destroy', function () {
        $interval.cancel(refreshWorkoutInterval);
    });

    $scope.setWorkout();
}]);

app.controller('WorkoutListViewCtrl', ['$rootScope', '$scope', '$controller', '$filter', '$modal', '$http', 'workoutProvider', '$routeParams', function($rootScope, $scope, $controller, $filter, $modal, $http, workoutProvider, $routeParams) {
    $controller('TableCtrl', {$scope: $scope});

    var date = new Date();
    var tenDays = new Date();
    tenDays.setDate(date.getDate() + 10);

    $scope.updateList = function() {
        var fromDate = _.findWhere($scope.fields, {name: 'fromDate'}).value;
        var toDate = _.findWhere($scope.fields, {name: 'toDate'}).value;
        if (!fromDate || !toDate || fromDate.getFullYear() < 1900 || toDate.getFullYear() < 1900) {
            return;
        }

        workoutProvider.get(fromDate.yyyymmdd(), toDate.yyyymmdd()).then(function(workouts) {
            if ($scope.applyCategoryFilter) {
                workouts = $scope.applyCategoryFilter(workouts);
            }
            var wcFilter = _.findWhere($scope.fields, {name: 'workoutCategory'}).value;
            if (wcFilter) {
                workouts = workouts.filter(function(w) {
                    return w.workoutType.category_id == wcFilter.id;
                });
            }
            var wtFilter = _.findWhere($scope.fields, {name: 'workoutType'}).value;
            if (wtFilter) {
                if (wcFilter && wtFilter.category_id != wcFilter.id) {
                    _.findWhere($scope.fields, {name: 'workoutType'}).value = undefined;
                } else {
                    workouts = workouts.filter(function(w) {
                        return w.workoutType.id == wtFilter.id;
                    });
                }
            }
            $scope.workouts = workouts;
        });
    };

    var removeWorkoutsChange = $rootScope.$on('workoutsChanged', function () {
        $scope.updateList();
    });

    $scope.$on('$destroy', function () {
        removeWorkoutsChange();
    });

    $scope.add = function(workout) {
        $modal.open({
            templateUrl: 'views/bookingadd.html',
            controller: 'WorkoutBookingAddModalCtrl',
            windowClass: 'huge-modal-window',
            resolve: {
                workout: function() {
                    return workout;
                }
            }
        });
    };

    $scope.categoryForCurrentSite = function(category) {
        return category.active && (!$rootScope.hasModule('MultiSite') || ($rootScope.selectedSite && category.sites.indexOf($rootScope.selectedSite.id) != -1));
    };

    var getWorkoutCategories = function() {
        return $rootScope.workoutcategories.filter(function(wc) { return $scope.categoryForCurrentSite(wc); });
    };

    var getWorkoutTypes = function() {
        var workoutCategorySelected = _.findWhere($scope.fields, {name: 'workoutCategory'}).value;
        if (workoutCategorySelected) {
            return $rootScope.workouttypes.filter(function(wt) { return wt.category_id == workoutCategorySelected.id; });
        } else {
            return $rootScope.workouttypes;
        }
    };

    $scope.fields = [
        {name: 'fromDate', title: 'From', required: true, type: 'date', value: date, change: $scope.updateList },
        {name: 'toDate', title: 'To', required: true, type: 'date', value: tenDays, change: $scope.updateList },
        {name: 'workoutCategory', title: 'Category', required: false, type: 'select', visible: function() { return !$scope.selectcategory && getWorkoutCategories().length > 1; }, options: getWorkoutCategories, placeholder: 'No category choosen', change: $scope.updateList },
        {name: 'workoutType', title: 'Workout type', required: false, type: 'select', options: getWorkoutTypes, optionsFilter: function(wt) { return (wt.active && (!$scope.applyCategoryFilter || wt.category_id == Number($routeParams.categoryId))); }, placeholder: 'No workout type choosen', change: $scope.updateList }
    ];
    $scope.hideSubmitButton = true;

    $scope.setInitialValues = function() {
        $rootScope.waitFor(['workoutcategories']).then(function() {
            _.findWhere($scope.fields, {name: 'workoutCategory'}).value = $scope.selectcategory ? $scope.selectcategory : _.min(getWorkoutCategories(), function(wc) { return wc.order; });
        });
    };
    $scope.setInitialValues();

    $scope.updateList();
}]);

app.controller('MyWorkoutsCtrl', ['$rootScope', '$scope', '$controller', '$location', function($rootScope, $scope, $controller, $location) {
    $controller('WorkoutListViewCtrl', {$scope: $scope});

    $scope.dates = {
        from: Date.today(),
        to: Date.tomorrow()
    };

    $scope.staffFilter = function(workout) {
        return _.findWhere(workout.staffs, {id: $rootScope.currentStaff.id});
    };

    $scope.dateRange = function(workout) {
        return workout.startTime.isToday();
    };

    $scope.notCancelled = function(workout) {
        return workout.status != 'Cancelled';
    };

    $scope.rowClick = function(workout) {
        $location.path('/attendance/show/' + workout.id);
    };

    $scope.updateList();
}]);

app.controller('MailingsCtrl', ['$rootScope', '$scope', '$location', '$modal', '$filter', 'server', 'confirm', function($rootScope, $scope, $location, $modal, $filter, server, confirm) {
    var removeMailing = function(mailing) {
        confirm.show('Are you sure you want to remove the mailing?').then(function() {
            server.post('/api/mailing/remove', null, {mailingId: mailing.id}, 'Removed', 'Failed to remove mailing');
        });
    };
    var openMailingForChange = function(mailing) {
        server.get('/api/mailing/get', {id: mailing.id}).then(function(result) {
            $modal.open({
                templateUrl: 'views/mailingschange.html',
                windowClass: 'huge-modal-window',
                controller: 'MailingChangeCtrl',
                resolve: {
                    mailing: function() {
                        return result;
                    }
                }
            });
        });
    };

    function showMailing(mailing) {
        server.get('/api/mailing/get', {id: mailing.id}).then(function(mailing) {
            $rootScope.previewTemplate(mailing, 'Mailing');
        });
    }

    var formatTypeName = function(mailingType) {
        if (mailingType === 'push') { return 'Push notification'; }
        return mailingType.charAt(0).toUpperCase() + mailingType.slice(1);
    };

    var updateMailings = function() {
        var fromDate = _.findWhere($scope.fields, {name: 'fromDate'}).value.yyyymmdd();
        var toDate = _.findWhere($scope.fields, {name: 'toDate'}).value.yyyymmdd();
        $scope.existingMailingsConfig.api.args.fromDate = fromDate;
        $scope.existingMailingsConfig.api.args.toDate = toDate;
        $scope.existingMailingsConfig.control.updateApi();
    };

    $scope.fields = [
        { name: 'fromDate', title: 'From', required: true, type: 'date', value: Date.today().addDays(-30), change: updateMailings },
        { name: 'toDate', title: 'To', required: true, type: 'date', value: Date.today(), change: updateMailings }
    ];

    $scope.hideSubmitButton = true;

    $scope.existingMailingsConfig = {
        rowClick: function(mailing) {
            server.get('/api/mailing/get', {id: mailing.id}).then(function(result) {
                result.day = $rootScope.getDisplayDate(Date.newFull(result.sendTime)).split(" ")[0];
                result.visibleUntil = Date.newFull(result.visibleUntil);
                $rootScope.previewTemplate(result, 'Mailing');
            });
        },
        api: {
            url: '/api/mailing/get/all',
            args: {
                fromDate: _.findWhere($scope.fields, {name: 'fromDate'}).value.yyyymmdd(),
                toDate: _.findWhere($scope.fields, {name: 'toDate'}).value.yyyymmdd()
            },
            transform: function(m) {
                m.created = Date.newFull(m.created);
                m.sendTime = Date.newFull(m.sendTime);
            },
            triggers: [{
                type: 'mailing'
            }]
        },
        tableLimit: 10,
        orderColumn: '-created',
        countSuffixList: ['mailing', 'mailings'],
        hideSearch: true,
        columns: [
            { field: 'created', title: 'Created', format: 'date' },
            { field: 'sendTime', title: 'Date of sending out', format: 'date' },
            { field: 'headline', title: 'Headline' },
            { field: 'category', title: 'Category', getValue: function(mailing) { return $filter('translate')(formatTypeName(mailing.type)); } }
        ],
        buttons: [
            { title: 'Show', buttonClass: 'btn-success', onClick: showMailing, visible: function(mailing) { return mailing.type == 'mail' || mailing.type == 'news' || mailing.type == 'sms' || mailing.type == 'survey' || mailing.type == 'push'; } },
            { title: 'Change', buttonClass: 'btn-warning', onClick: openMailingForChange, visible: function(mailing) { return mailing.type == 'news' || mailing.type == 'survey' || mailing.sent == null; } },
            { title: 'Remove', buttonClass: 'btn-danger', onClick: removeMailing, visible: function(mailing) { return (mailing.sent == null && mailing.type != 'survey') || mailing.type == 'news'; } }
        ]
    };

    $scope.existingMailingsConfig.placeholder = $filter('translate')('No mailing category chosen');
    $scope.existingMailingsConfig.getButtonTitle = function() {
        return 'Send new';
    };

    $scope.existingMailingsConfig.buttonClicked = function() {
        $location.path('/mailings/new');
    };
}]);

app.controller('NewMailingCtrl', ['$rootScope', '$scope', '$controller', '$modal', '$filter', '$q', 'server', 'formatter', '$location', 'confirm', 'util',
    function($rootScope, $scope, $controller, $modal, $filter, $q, server, formatter, $location, confirm, util) {
    $controller('AddCtrl', { $scope: $scope });
    $scope.wideForm = true;
    // Send new mailings
    $scope.postUrl = '/api/mailing/add';
    $scope.successTitle = 'MAILING_SEND_SUCCESS';
    $scope.failedTitle = 'MAILING_SEND_FAILED';

    $scope.getButtonText = function() {
        return 'Send';
    };

    $scope.currentSelection = '';
    $scope.sendOptions = [
        { name: 'Mail', value: 'mail'},
        { name: 'SMS', value: 'sms'},
        { name: 'News', value: 'news'},
        { name: 'Survey', value: 'survey'},
        { name: 'Push notification', value: 'push'}
    ];

    var showReservedNamesInfo = function() {
        if ($scope.currentSelection === 'news') {
            _.findWhere($scope.fields, {name: '_'}).hint = 'RESERVED_NAME_INFO_NEWS';
        } else {
            _.findWhere($scope.fields, {name: '_'}).hint = 'RESERVED_NAME_INFO';
        }
    };

    $scope.templates = '';              // Save all templates from db directly
    $scope.templateAllOptions = '';     // Save all shaped templates
    $scope.templateOptions = '';        // Save templates which match sendOption
    var getMailingTemplates = function() {
        var deferred = $q.defer();
        server.get('/api/mailing/template/get/all').then(function(templates) {
            $scope.templates = templates;
            $scope.templateAllOptions = templates.map(function(t) { return {id: t.id, name: t.name, type: t.type, value: t.name.toLowerCase(), questions: t.questions, isAutoMailing: t.isAutoMailing}; });
            deferred.resolve();
        });
        return deferred.promise;
    };

    $scope.currentTemplateSelection = '';
    $scope.templateOptionSelected = function() {
        var templateOption = $scope.getSubmitItem && $scope.getSubmitItem().mailingTemplate;
        $scope.currentTemplateSelection = templateOption;
        if ($scope.currentTemplateSelection === null) {
            _.findWhere($scope.fields, { type: 'htmleditor' }).template = '';
            _.findWhere($scope.fields, { type: 'textarea' }).template = '';
        } else {
            var template = _.findWhere($scope.templates, { id: $scope.currentTemplateSelection.id }).templateText;
            _.findWhere($scope.fields, { type: 'htmleditor' }).template = template;
            _.findWhere($scope.fields, { type: 'textarea' }).template = template;
            if ($scope.currentSelection === 'survey') {
                _.findWhere($scope.fields, {name: 'question'}).value = $scope.currentTemplateSelection.questions;
            }
        }
        showReservedNamesInfo();
    };

    var defaultMessageValue = function() {
        if ($scope.currentSelection == 'survey') {
            return '{linktosurvey}';
        } else {
            return '';
        }
    };

    $scope.sendOptionSelected = function() {
        var sendOption = $scope.getSubmitItem && $scope.getSubmitItem().sendAs;
        if (!_.findWhere($scope.sendOptions, { value: sendOption })) { return; }
        $scope.currentSelection = sendOption;
        $scope.templateOptions = $scope.templateAllOptions.filter(function(t) {
            if(t.isAutoMailing) {return false;}
            return sendOption == 'push' ? (t.type == 'push' || t.type == 'sms') : sendOption == t.type;
        });
        _.findWhere($scope.fields, { name: 'mailingTemplate' }).value = '';
        $scope.currentTemplateSelection = '';
        (_.findWhere($scope.fields, { type: 'htmleditor' }) || {}).value = defaultMessageValue();
        showReservedNamesInfo();
    };

    var getSendOptionValue = function(opt) {
        return opt.value && opt.value.value;
    };

    var isSms = function() { return $scope.currentSelection == 'sms'; };
    var isPush = function() { return $scope.currentSelection == 'push'; };

    var getTemplatePreviewButtonText = function() {
        return 'Preview';
    };

    var getTemplateWithTextValue = function(field) {
        var value = field.value || '';
        if (!$scope.currentTemplateSelection) { return value; }
        var template = (_.findWhere($scope.templates, { id: $scope.currentTemplateSelection.id })).templateText;
        return template.replace('{content}', value);
    };

    function price(x) {
        return formatter.format('price', x);
    }

    var smsTotals;
    var smsTotalAmount = 0;
    var onSmsChanged = (function() {
        return _.debounce(function() {
            var text = _.findWhere($scope.fields, { name: 'message', type: 'textarea' }).value;
            var smsCapacity = util.calcSmsCapacity(text);
            if (smsCapacity) {
                _.findWhere($scope.fields, { name: 'message', type: 'textarea' }).maxlength = smsCapacity * 2;
            }
            var receivers = _.findWhere($scope.fields, { name: 'receivers' }).value;
            if(!text || !receivers || !receivers.length || !isSms()) {
                smsTotals = '';
                smsTotalAmount = 0;
                $scope.$digest();
                return;
            }
            server.post2('/api/sms/calc', {
                text: text,
                receivers: _.pluck(receivers, 'id')
            }).then(function(response) {
                smsTotalAmount = response.total_amount;
                smsTotals = $filter('translate')('{symbols} symbols ({capacity} symbols per sms), {smsPerPerson} sms x {person} customers x {cost} = {totalAmount}').
                    replace('{symbols}', text.length).
                    replace('{capacity}', response.capacity).
                    replace('{smsPerPerson}', response.count).
                    replace('{person}', response.receiver_count).
                    replace('{cost}', price(response.cost)).
                    replace('{totalAmount}', price(response.total_amount));
            });
        }, 300);
    })();

    var previewTemplate = function() {
        var field;
        if ($scope.currentSelection === 'sms' || $scope.currentSelection === 'push') {
            field = _.findWhere($scope.fields, {type: 'textarea'});
        } else {
            field = _.findWhere($scope.fields, {type: 'htmleditor'});
        }
        if (field.template) {
            var previewContent = field.template.replace('{content}', field.value || '');
            var title = field.getTitle ? field.getTitle() : '';
            $rootScope.previewTemplate(previewContent, title);
        }
    };

    var enablePreviewButton = function() {
        if (isSms() || isPush()) {
            _.findWhere($scope.fields, {type: 'button'}).disabled = _.find($scope.fields, function(f) { return f.type == 'textarea' && f.visible(); }).value ? false : true;
        } else {
            _.findWhere($scope.fields, {type: 'button'}).disabled = _.findWhere($scope.fields, {type: 'htmleditor'}).value ? false : true;
        }
    };

    var receiversFilter = function(item) {
        if ($scope.currentSelection == 'push') {
            return item.allowPush;
        }
        return true;
    };

    $scope.fields = [
        { name: 'sendAs', title: 'Send as', type: 'select', required: true, options: function() { return $scope.sendOptions; }, change: $scope.sendOptionSelected, getValue: getSendOptionValue },
        { name: 'isNewsOrAdvertising', title: 'News or advertising', type: 'checkbox', value: true, 'helpText': 'ADVERTISINGINFO', visible: function() { return $scope.currentSelection == 'sms' || $scope.currentSelection == 'mail' || isPush(); }, placement: 'bottom'},
        { name: 'showAsNews', title: 'Show as news', type: 'checkbox', visible: function() { return $scope.currentSelection == 'mail'; } },
        { name: 'canBeAnonymous', title: 'Can be anonymous', type: 'checkbox', required: false, visible: function() {return $scope.currentSelection == 'survey'; } },
        { name: 'lastDayAnswering', title: 'Last day answering', type: 'date', value: Date.today().addMonths(1), required: true, visible: function() {return $scope.currentSelection == 'survey'; } },
        { name: 'receivers', title: 'Receivers', type: 'customers', required: true, useId: true, itemFilter: receiversFilter, visible: function() { return $scope.currentSelection == 'sms' || $scope.currentSelection == 'mail' || $scope.currentSelection == 'survey' || isPush(); } },
        { name: 'sender', title: 'Sender', type: 'customer', required: true, itemTypes: ['staff'], visible: function() { return $scope.currentSelection == 'mail' || $scope.currentSelection == 'news' || $scope.currentSelection == 'survey' || isPush(); } },
        { name: 'question', title: 'Questions', type: 'multifields', required: false, options: { itemTitle: 'question' }, visible: function() { return $scope.currentSelection == 'survey'; } },
        { name: 'sendTime', title: 'Send at time', type: 'datetime', value: new Date(), required: true, visible: function() { return $scope.currentSelection == 'sms' || $scope.currentSelection == 'mail' || $scope.currentSelection == 'news' || $scope.currentSelection == 'survey' || isPush(); } },
        { name: 'visibleUntil', title: 'Visible until', type: 'datetime', value: new Date().addDays(30), required: false, visible: function() { return $scope.currentSelection == 'news'; } },
        { name: 'mailingTemplate', title: 'Mailing template', type: 'select', required: false, options: function() { return $scope.templateOptions; }, change: $scope.templateOptionSelected, visible: function() { return $scope.currentSelection == 'mail' || $scope.currentSelection == 'news' || $scope.currentSelection == 'survey' || $scope.currentSelection == 'sms' || isPush(); }, placeholder: 'No template' },
        { name: 'headline', title: 'Headline', type: 'text', required: true, visible: function() { return $scope.currentSelection == 'mail' || $scope.currentSelection == 'news' || $scope.currentSelection == 'survey'; } },
        { name: 'headline', title: 'Headline (Internal)', type: 'text', required: true, visible: function() { return $scope.currentSelection == 'sms' || isPush(); } },
        { name: 'hintCheckBox', title:'Show format', type: 'checkbox', visible: function(){ return $scope.currentSelection == 'sms' || $scope.currentSelection == 'survey' || $scope.currentSelection == 'mail' || $scope.currentSelection == 'news' || $scope.currentSelection == 'push'}},
        { name: '_', hint: '', hintClass: 'alert-info', visible: function(){ return _.findWhere($scope.fields, { name: 'hintCheckBox' }).value } },
        { name: 'imagekey', title: 'Image', type: 'field', field: 'image-storage', option: {imageOnly: true, squareThumbnail: false, originType: 'mailing'}, visible: function() { return $scope.currentSelection == 'news'; } },
        { name: 'message', title: 'Message', type: 'textarea', required: true, counter: function() {return smsTotals;}, visible: isSms, onChange: onSmsChanged, template: $scope.currentTemplateSelection, getButtonText: getTemplatePreviewButtonText, getValue: getTemplateWithTextValue, getTitle: getTemplatePreviewButtonText, bindingHint: 'SMS_LENGTH_LONG_HINT', maxlength: 304 },
        { name: 'message', title: 'Message', type: 'htmleditor', required: true, visible: function() { return $scope.currentSelection == 'mail' || $scope.currentSelection == 'news' || $scope.currentSelection == 'survey'; }, template: $scope.currentTemplateSelection, getButtonText: getTemplatePreviewButtonText, getValue: getTemplateWithTextValue, getTitle: getTemplatePreviewButtonText},
        { name: 'message', title: 'Message', type: 'textarea', required: true, visible: isPush, template: $scope.currentTemplateSelection, getButtonText: getTemplatePreviewButtonText, getValue: getTemplateWithTextValue, getTitle: getTemplatePreviewButtonText },
        { type: 'button', buttonTitle: 'Preview', buttonClass: 'btn btn-primary', disabled: true, click: previewTemplate, visible: function() { return $scope.currentTemplateSelection; } }
    ];

    $scope.$watchCollection(function() {
        return _.findWhere($scope.fields, { name: 'receivers' }).value;
    }, onSmsChanged);

    $scope.$watch(function() {
        if ($scope.currentTemplateSelection && $scope.currentSelection !== 'sms') {
            return _.findWhere($scope.fields, { type: 'htmleditor' }).value;
        } else if ($scope.currentTemplateSelection) {
            return _.findWhere($scope.fields, { type: 'textarea' }).value;
        }
    }, enablePreviewButton);

    $scope.canSubmit = function() {
        if ($scope.currentSelection == 'survey') {
            return (_.findWhere($scope.fields, {name: 'message', type: 'htmleditor'}).value || '').indexOf('{linktosurvey}') != -1;
        } else if ($scope.currentSelection == 'sms') {
            return _.find($scope.fields, function(f) { return f.name == 'message' && f.visible(); });
        } else if (isPush()) {
            return _.find($scope.fields, function(f) { return f.name == 'message' && f.visible(); });
        } else {
            return _.findWhere($scope.fields, {name: 'message', type: 'htmleditor'}).value;
        }
    };

    $scope.submit = (function() {
        var origSubmit = $scope.submit;
        return function() {
            if(isSms() && smsTotalAmount >= 1000) {
                var msg = $filter('translate')('Approximate amount for sending these sms is {amount}, Continue?');
                confirm.show(msg.replace('{amount}', price(smsTotalAmount))).then(origSubmit);
            } else {
                origSubmit();
            }
        };
    })();

    var setDefaultSendOption = function(option) {
        var sendOptionObj = _.findWhere($scope.fields, { name: 'sendAs' });
        $scope.currentSelection = option || 'news'; // default option
        sendOptionObj.value = _.findWhere($scope.sendOptions, { value: $scope.currentSelection });
    };

    var setReceivers = function(receivers) {
        if (!receivers || receivers.length === 0) { return; }
        _.findWhere($scope.fields, { name: 'receivers' }).value = receivers;
    };

    var setMessage = function(subject, message) {
        var headline = _.findWhere($scope.fields, {name: 'headline', title: 'Headline'});
        var notifyHeadline = _.findWhere($scope.fields, {name: 'headline', title: 'Headline (Internal)'});
        var textareaMessage = _.findWhere($scope.fields, {name: 'message', type: 'textarea'});
        var htmleditorMessage = _.findWhere($scope.fields, {name: 'message', type: 'htmleditor'});
        if (headline) { headline.value = subject; }
        if (notifyHeadline) { notifyHeadline.value = subject; }
        if (textareaMessage) { textareaMessage.value = message; }
        if (htmleditorMessage) { htmleditorMessage.value = message; }
    };

    $scope.setInitialValues = function() {
        if (!$rootScope.hasModule('SMS')) {
            $scope.sendOptions.splice(1, 1);
        }
        _.findWhere($scope.fields, { name: 'sender' }).value = $rootScope.getMember($rootScope.currentStaffId);
        _.findWhere($scope.fields, { name: 'isNewsOrAdvertising' }).value = true;
        _.findWhere($scope.fields, { name: 'sendTime' }).value = new Date();

        $scope.pubsub('newmailingdata', function(data) {
            if (data) {
                setDefaultSendOption(data.sendOption);
                setReceivers(data.receivers.map(function(r) {return $rootScope.getMember(r.id);}));
                $scope.sendOptionSelected();
                _.findWhere($scope.fields, {name: 'isNewsOrAdvertising'}).value = data.hasOwnProperty('isNewsOrAdvertising') ? data.isNewsOrAdvertising : true;
                setMessage(data.subject, data.message);
                $scope.pubsub.publish('newmailingdata', null);
                if (data.options) {
                    $scope.callCloseOnSuccess = data.options.callCloseOnSuccess;
                    _.findWhere($scope.fields, { name: 'sendAs'}).readonly = data.options.modalMode;
                    _.findWhere($scope.fields, { name: 'receivers'}).readonly = data.options.modalMode;
                    $scope.noRedirect = data.options.noRedirect;
                }
            }
        }, true);
    };

    $scope.possiblyClose = function() {
        if (!$scope.noRedirect) {
            $location.path('/mailings/all');
        } else {
            $scope.$close();
        }
    };

    $rootScope.waitFor(['staffs']).then(function() {
        var promise = getMailingTemplates();
        promise.then(function() {
            $scope.setInitialValues();
        });
    });
}]);

app.controller('MailingChangeCtrl', ['$scope', '$controller', 'mailing', function($scope, $controller, mailing) {
    $controller('ChangeCtrl', { $scope: $scope });
    $scope.wideForm = true;
    $scope.item = mailing;

    function isNews() {
        return mailing.type == 'news';
    }

    $scope.fields = [
        { name: 'survey.lastDayAnswering', title: 'Last day answering', type: 'date', counter: false, visible: function() { return mailing.type == 'survey'; } },
        { name: 'sender.id', title: 'Sender', type: 'customer', required: true, itemTypes: ['staff'], visible: isNews, useId: true },
        { name: 'sendTime', title: 'Send at time', type: 'datetime', required: true, visible: isNews },
        { name: 'visibleUntil', title: 'Visible until', type: 'datetime', required: false, visible: isNews },
        { name: 'headline', title: 'Headline', type: 'text', visible: function() { return mailing.type != 'survey'; } },
        { name: 'imagekey', title: 'Image', type: 'field', field: 'image-storage', option: {imageOnly: true, squareThumbnail: false, originType: 'mailing'}, visible: isNews },
        { name: 'message', title: 'Message', type: mailing.type === 'sms' ? 'textarea' : 'htmleditor', counter: true, visible: function() { return mailing.type != 'survey'; } }
    ];
    $scope.setValues($scope.item);
    $scope.postUrl = '/api/mailing/change';
    $scope.callCloseOnSuccess = true;
    $scope.successTitle = 'Saved changes';
    $scope.failedTitle = 'Failed to save changes';
}]);

app.controller('MailingTemplatesCtrl', ['$rootScope', '$scope', '$location', '$modal', '$filter', 'server', 'confirm', function($rootScope, $scope, $location, $modal, $filter, server, confirm) {
    var openTemplate = function(template) {
        $modal.open({
            templateUrl: 'views/templatespreview.html',
            windowClass: 'huge-modal-window',
            controller: 'TemplatePreviewCtrl',
            resolve: {
                template: function() {
                    return template;
                }
            }
        });
    };

    var openTemplateForChange = function(template) {
        $modal.open({
            templateUrl: 'views/templateschange.html',
            windowClass: 'huge-modal-window',
            controller: 'TemplateChangeCtrl',
            resolve: {
                template: function() {
                    return template;
                }
            }
        });
    };

    var removeTemplate = function(template) {
        confirm.show('Are you sure you want to remove the template?', {ladda: true}).then(function(resolve) {
            server.post('/api/mailing/template/remove', null, { id: template.id }, 'Success', 'Failed to remove template').then(resolve);
        });
    };

    var formatTypeName = function(templateType) {
        return templateType.capitalize();
    };

    $scope.existingTemplatesConfig = {
        api: {
            url: '/api/mailing/template/get/all',
            triggers: [{
                type: 'mailingtemplate'
            }],
            transform: function(t) {
                t.translated = $filter('translate')(t.name);
                return t;
            },
        },
        rowClick: openTemplate,
        hideSearch: true,
        tableLimit: 50,
        orderColumn: 'name',
        countSuffixList: ['template', 'templates'],
        activeButtons: 'TEMPLATES_ADD_NEW',
        columns: [
            { field: 'name', title: 'Name', format: 'translated' },
            { field: 'type', title: 'Mailing type', getValue: function(template) { return $filter('translate')(formatTypeName(template.type)); } }
        ],
        buttons: [
            { title: 'Show', buttonClass: 'btn-success', onClick: openTemplate },
            { title: 'Change', buttonClass: 'btn-warning', onClick: openTemplateForChange },
            { title: 'Remove', buttonClass: 'btn-danger', onClick: removeTemplate, visible: function(t) { return !t.isAutoMailing; } }
        ]
    };

    $scope.existingTemplatesConfig.placeholder = $filter('translate')('No mailing type chosen');
    $scope.existingTemplatesConfig.openNewMailingTemplate = function() {
        $location.path('/mailings/templates/new');
    };
}]);

app.controller('TemplatePreviewCtrl', ['$scope', '$filter', 'template', function($scope, $filter, template) {
    $scope.template = template;
    var formatTypeName = function(templateType) {
        return templateType.capitalize();
    };
    var getOptions = function(row) {
        if (row.type === 'select' || row.type === 'multiselect') {
            return row.data.join(' / ');
        }
    };

    var columns = [
        { field: 'name', title: 'Name', format: 'translated' },
        { field: 'type', title: 'Type', format: 'translated', getValue: function(q) { return formatTypeName(q.type); } }
    ];
    if ($scope.template.questions && _.find($scope.template.questions, function(q) { return q.type === 'select' || q.type === 'multiselect'; })) {
        columns.push({ field: 'choice', title: 'Choice', format: 'translated', getValue: getOptions });
    }

    $scope.config = {
        getItems: function() { return $scope.template.questions; },
        tableLimit: 50,
        orderColumn: 'name',
        hideSearchCount: true,
        columns: columns
    };

    $scope.fields = [
        { name: 'type', title: 'Mailing type', type: 'label', readonly: true, value: $filter('translate')(formatTypeName(template.type)) },
        { name: 'name', title: 'Name', type: 'label', readonly: true, value: $filter('translate')(template.name) },
        { name: 'templateText', title: 'Mailing template', type: 'htmleditor', readonly: true, value: $filter('translate')(template.templateText) }
    ];
}]);

app.controller('NewTemplateCtrl', ['$rootScope', '$scope', '$controller', '$modal', '$filter', 'server', 'formatter',
    function($rootScope, $scope, $controller, $modal, $filter, server, formatter) {
    $controller('AddCtrl', { $scope: $scope });
    $scope.wideForm = true;
    $scope.postUrl = '/api/mailing/template/add';
    $scope.successTitle = 'TEMPLATE_ADD_SUCCESS';
    $scope.failedTitle = 'TEMPLATE_ADD_FAILED';

    $scope.getButtonText = function() {
        return 'Save';
    };

    var showReservedNamesInfo = function() {
        if ($scope.currentSelection === 'news') {
            _.findWhere($scope.fields, {name: '_'}).hint = 'TEMPLATE_RESERVED_NAME_INFO_NEWS';
        } else if ($scope.currentSelection === 'offer') {
            _.findWhere($scope.fields, {name: '_'}).hint = 'TEMPLATE_RESERVED_NAME_INFO_OFFER';
        } else {
            _.findWhere($scope.fields, {name: '_'}).hint = 'TEMPLATE_RESERVED_NAME_INFO';
        }
    };

    $scope.currentSelection = '';
    $scope.sendOptions = [
        { id: 'mail', name: 'Mail' },
        { id: 'sms', name: 'SMS' },
        { id: 'news', name: 'News' },
        { id: 'survey', name: 'Survey' },
        { id: 'push', name: 'Push notification'},
        { id: 'offer', name: 'Offer'}
    ];

    $scope.sendOptionSelected = function() {
        var sendOption = $scope.getSubmitItem && $scope.getSubmitItem().type;
        if (!_.findWhere($scope.sendOptions, { id: sendOption })) { return; }
        $scope.currentSelection = sendOption;
        showReservedNamesInfo();
    };

    var isSms = function() { return $scope.currentSelection === 'sms'; };
    var isPush = function() { return $scope.currentSelection === 'push'; };
    var isOffer = function() { return $scope.currentSelection === 'offer'; };

    var bindingWarning = "The length may vary as the text within '{}' will be replaced";
    var smsTotals;
    var onSmsChanged = (function() {
        function price(x) {
            return formatter.format('price', x);
        }

        return _.debounce(function() {
            var text = _.findWhere($scope.fields, { name: 'templateText', type: 'textarea' }).value;

            if(!text || !isSms()) {
                smsTotals = '';
                $scope.$digest();
                return;
            }
            server.post2('/api/sms/calc', {text: text}).then(function(response) {
                var totalSmsCost = price(response.total * 1);
                smsTotals = $filter('translate')('{symbols} symbols ({capacity} symbols per sms), {smsPerPerson} sms x {cost} = {totalAmount}').
                    replace('{symbols}', text.length).
                    replace('{capacity}', response.capacity).
                    replace('{smsPerPerson}', response.count).
                    replace('{cost}', price(response.cost)).
                    replace('{totalAmount}', totalSmsCost);
            });
        }, 300);
    })();

    var getToolTip = function() {
        return $filter('translate')('GS_NOTIFICATIONS_INFO').format($rootScope.main.brand);
    };

    $scope.fields = [
        { name: 'type', title: 'Mailing type', type: 'select', required: true, options: function() { return $scope.sendOptions; }, change: $scope.sendOptionSelected, useId: true },
        { name: 'name', title: 'Name', type: 'text', required: true },
        { name: 'subject', title: 'Subject', type: 'text', required: true, visible: function() { return $scope.currentSelection === 'mail'; } },
        { name: 'notificationsinfo', title: 'Displayed as notification in', type: 'immutablecheckbox', checked: true, tooltip: getToolTip, checkboxtext: $rootScope.main.brand },
        { name: '_', hint: '', hintClass: 'alert-info' },
        { name: 'questions', title: 'Questions', type: 'multifields', required: false, options: { itemTitle: 'question' }, visible: function() { return $scope.currentSelection == 'survey'; } },
        { name: 'templateText', title: 'Mailing template', value: '{content}', type: 'textarea', required: true, counter: function() {return smsTotals;}, visible: function() { return $scope.currentSelection === 'sms'; }, onChange: onSmsChanged, bindingHint: bindingWarning, _category: 'sms' },
        { name: 'templateText', title: 'Mailing template', value: '{content}', type: 'textarea', required: true, visible: isPush, _category: 'push' },
        { name: 'templateText', title: 'Mailing template', value: '{content}', type: 'htmleditor', required: true, visible: function() { return !isSms() && !isPush() && !isOffer(); }, _category: 'others' },
        { name: 'templateText', title: 'Mailing template', value: '{signbutton}', type: 'htmleditor', required: true, visible: isOffer, _category: 'offer' }
    ];

    $scope.setInitialValues = function() {
        if ($scope.item && $scope.item.type) {
            var templateType = _.findWhere($scope.sendOptions, {id: $scope.item.type});
            _.findWhere($scope.fields, { name: 'type'} ).value = templateType ? templateType : $scope.sendOptions[0];
        } else {
            _.findWhere($scope.fields, { name: 'type'} ).value = $scope.sendOptions[0];
        }
        $scope.sendOptionSelected();
    };
    $scope.setInitialValues();

    $scope.incompleteFields = [];
    $scope.canSubmit = function() {
        $scope.incompleteFields.length = 0;
        if(!isOffer()) {return true;}
        var requiredValue = isOffer() ? '{signbutton}' : '{content}';
        var f;
        if (isSms() || isPush()) {
            f = _.findWhere($scope.fields, {name: 'templateText', type: 'textarea', _category: $scope.currentSelection});
        } else if (isOffer()) {
            f = _.findWhere($scope.fields, {name: 'templateText', type: 'htmleditor', _category: 'offer'});
        } else {
            f = _.findWhere($scope.fields, {name: 'templateText', type: 'htmleditor', _category: 'others'});
        }
        if (f && (f.value || '').indexOf(requiredValue) == -1) {
            $scope.incompleteFields.push(f.title);
            return false;
        }
        return true;
    };

}]);

app.controller('TemplateChangeCtrl', ['$scope', '$controller', '$filter', 'template', 'formatter', 'server', function($scope, $controller, $filter, template, formatter, server) {
    $controller('ChangeModalCtrl', { $scope: $scope });
    $scope.wideForm = true;
    $scope.item = template;

    var showReservedNamesInfo = function() {
        if ($scope.currentSelection === 'news') {
            _.findWhere($scope.fields, {name: '_'}).hint = 'TEMPLATE_RESERVED_NAME_INFO_NEWS';
        } else if ($scope.currentSelection === 'offer') {
            _.findWhere($scope.fields, {name: '_'}).hint = 'TEMPLATE_RESERVED_NAME_INFO_OFFER';
        } else {
            _.findWhere($scope.fields, {name: '_'}).hint = 'TEMPLATE_RESERVED_NAME_INFO';
        }
    };

    $scope.sendOptionSelected = function() {
        var sendOption = $scope.getSubmitItem && $scope.getSubmitItem().type;
        if (!_.findWhere($scope.sendOptions, { id: sendOption })) { return; }
        $scope.currentSelection = sendOption;
        showReservedNamesInfo();
    };

    var isSms = function() {
        if (!$scope.currentSelection) {
            return template.type === 'sms';
        } else {
            return $scope.currentSelection === 'sms';
        }
    };

    var isOffer = function() {
        if (!$scope.currentSelection) { return template.type === 'offer'; }
        return $scope.currentSelection === 'offer';
    };

    var bindingWarning = "The length may vary as the text within '{}' will be replaced";
    var smsTotals;
    var onSmsChanged = (function() {
        function price(x) {
            return formatter.format('price', x);
        }

        return _.debounce(function() {
            var text = _.findWhere($scope.fields, { name: 'templateText', type: 'textarea' }).value;

            if(!text || !isSms()) {
                smsTotals = '';
                $scope.$digest();
                return;
            }
            server.post2('/api/sms/calc', {text: text}).then(function(response) {
                var totalSmsCost = price(response.total * 1);
                smsTotals = $filter('translate')('{symbols} symbols ({capacity} symbols per sms), {smsPerPerson} sms x {cost} = {totalAmount}').
                    replace('{symbols}', text.length).
                    replace('{capacity}', response.capacity).
                    replace('{smsPerPerson}', response.count).
                    replace('{cost}', price(response.cost)).
                    replace('{totalAmount}', totalSmsCost);
            });
        }, 300);
    })();

    $scope.sendOptions = [
        { id: 'mail', name: 'Mail' },
        { id: 'sms', name: 'SMS' },
        { id: 'news', name: 'News' },
        { id: 'survey', name: 'Survey' },
        { id: 'push', name: 'Push notification'},
        { id: 'offer', name: 'Offer'}
    ];

    $scope.fields = [
        { name: 'type', title: 'Mailing type', type: 'select', required: true, options: function() { return $scope.sendOptions; }, change: $scope.sendOptionSelected, useId: true },
        { name: 'name', title: 'Name', type: 'text', required: true, setValue: function() { return $filter('translate')($scope.item.name); } },
        { name: 'subject', title: 'Subject', type: 'text', required: true, visible: function() { return $scope.currentSelection === 'mail'; } },
        { name: '_', hint: '', hintClass: 'alert-info' },
        { name: 'questions', title: 'Questions', type: 'multifields', required: false, options: { itemTitle: 'question' }, visible: function() { return $scope.currentSelection === 'survey'; } },
        { name: 'templateText', title: 'Mailing template', type: 'textarea', required: true, counter: function() {return smsTotals;}, visible: function() { return isSms(); }, onChange: onSmsChanged, setValue: function() { return $filter('translate')($scope.item.templateText); }, bindingHint: bindingWarning , _category: 'sms'},
        { name: 'templateText', title: 'Mailing template', type: 'htmleditor', required: true, visible: function() { return !isSms() && !isOffer(); }, setValue: function() { return $filter('translate')($scope.item.templateText); }, _category: 'others' },
        { name: 'templateText', title: 'Mailing template', type: 'htmleditor', required: true, visible: function() { return isOffer(); }, setValue: function() { return $filter('translate')($scope.item.templateText); }, _category: 'offer' }
    ];

    $scope.incompleteFields = [];
    $scope.canSubmit = function() {
        $scope.incompleteFields.length = 0;
        if(!isOffer()) {return true;}
        var requiredValue = isOffer() ? '{signbutton}' : '{content}';
        var f;
        if (isSms()) {
            f = _.findWhere($scope.fields, {name: 'templateText', type: 'textarea', _category: 'sms'});
        } else if (isOffer()) {
            f = _.findWhere($scope.fields, {name: 'templateText', type: 'htmleditor', _category: 'offer'});
        } else {
            f = _.findWhere($scope.fields, {name: 'templateText', type: 'htmleditor', _category: 'others'});
        }
        if (f && (f.value || '').indexOf(requiredValue) == -1) {
            $scope.incompleteFields.push(f.title);
            return false;
        }
        return true;
    };

    $scope.setInitialValues = function() {
        var initailSendOption = $scope.item.type;
        $scope.currentSelection = initailSendOption;
        showReservedNamesInfo();
    };
    $scope.setInitialValues();

    $scope.setValues($scope.item);
    $scope.postUrl = '/api/mailing/template/change';
    $scope.callCloseOnSuccess = true;
    $scope.successTitle = 'Saved changes';
    $scope.failedTitle = 'Failed to save changes';
}]);

app.controller('AutomaticMailingsCtrl', ['$rootScope', '$scope', '$location', '$modal', '$filter', 'confirm', 'server', function($rootScope, $scope, $location, $modal, $filter, confirm, server) {
    var openAutoMailing = function(autoMailing) {
        $modal.open({
            templateUrl: 'views/automailingspreview.html',
            windowClass: 'huge-modal-window',
            controller: 'AutomaticMailingPreviewCtrl',
            resolve: {
                autoMailing: function() {
                    return autoMailing;
                }
            }
        });
    };

    var openAutoMailingForChange = function(autoMailing) {
        $modal.open({
            templateUrl: 'views/automailingschange.html',
            windowClass: 'huge-modal-window',
            controller: 'AutomaticMailingChangeCtrl',
            resolve: {
                autoMailing: function() {
                    return autoMailing;
                }
            }
        });
    };

    var changeGenericAutomaticMailing = function(autoMailing) {
        $modal.open({
            templateUrl: 'views/changemodal.html',
            windowClass: 'huge-modal-window',
            controller: 'GenericAutomaticMailingChangeCtrl',
            resolve: {
                autoMailing: function() {
                    return autoMailing;
                }
            }
        });
    };

    var removeAutomaticMailing = function(autoMailing) {
        confirm.show('Are you sure to remove?').then(function() {
            server.post('/api/automaticmailing/generic/remove', null, {id: autoMailing.id}, 'Automatic mailing removed', 'Failed to remove');
        });
    };

    $rootScope.waitFor(['mailinghandlers']).then(function() {
        $scope.sendOptions = [
            {id: 'emailAndSMS', name: 'Both mail and SMS'},
            {id: 'emailOnly', name: 'Only email'},
            {id: 'SMSOnly', name: 'Only SMS'},
            {id: 'emailFirst', name: 'First email and second SMS'},
            {id: 'SMSFirst', name: 'First SMS and second email' },
            {id: 'noMailing', name: 'No mailing'},
            {id: 'pushOnly', name: 'Only push'},
            ...$rootScope.getMailingHandlerSendAsOptions()
        ];
    });

    var getSendOptionName = function(autoMailing) {
        return $filter('translate')(_.findWhere($scope.sendOptions, {id: autoMailing.sendAs}).name);
    };

    $scope.existingAutoMailingsConfig = {
        api: {
            url: '/api/mailing/automailing/get/all',
            triggers: [{
                type: 'automaticmailing'
            }],
            transform: function(a) {
                a.translated = $filter('translate')(a.name);
                return a;
            },
        },
        countSuffixList: ['mailing', 'mailings'],
        rowClick: openAutoMailing,
        hideSearch: true,
        tableLimit: 20,
        orderColumn: 'name',
        columns: [
            { field: 'name', title: 'Name', format: 'translated' },
            { field: 'sendAs', title: 'Send as', getValue: getSendOptionName }
        ],
        buttons: [
            { title: 'Change', buttonClass: 'btn-warning', onClick: openAutoMailingForChange }
        ]
    };

    $scope.genericAutoMailingsConfig = {
        api: {
            url: '/api/mailing/automailing/generic/get/all',
            triggers: [{
                type: 'genericautomaticmailing'
            }],
            transform: function(a) {
                a.translated = $filter('translate')(a.name);
                return a;
            },
        },
        countSuffixList: ['mailing', 'mailings'],
        rowClick: openAutoMailing,
        hideSearch: true,
        tableLimit: 20,
        orderColumn: 'name',
        columns: [
            { field: 'name', title: 'Name', format: 'translated' },
            { field: 'sendAs', title: 'Send as', getValue: getSendOptionName }
        ],
        buttons: [
            { title: 'Change', buttonClass: 'btn-warning', onClick: changeGenericAutomaticMailing },
            { title: 'Remove', buttonClass: 'btn-danger', onClick: removeAutomaticMailing }
        ]
    };

    $scope.existingAutoMailingsConfig.placeholder = $scope.genericAutoMailingsConfig.placeholder = $filter('translate')('No sending option chosen');
    $scope.existingAutoMailingsConfig.isMailingAdminPage = $scope.genericAutoMailingsConfig.isMailingAdminPage = true;
    $scope.existingAutoMailingsConfig.getButtonTitle = $scope.genericAutoMailingsConfig.getButtonTitle = function() {
        return 'Order special mailing';
    };

    $scope.existingAutoMailingsConfig.createNewRules = $scope.genericAutoMailingsConfig.createNewRules = function() {
        $location.path('/mailings/automailings/new');
    };

    $scope.genericAutoMailingsConfig.buttonClicked = $scope.existingAutoMailingsConfig.buttonClicked = function() {
        $modal.open({
            templateUrl: 'views/addmodal.html',
            controller: 'orderSpecialAutomaticMailingCtrl',
            windowClass: 'huge-modal-window'
        });
    };
}]);

app.controller('AutomaticMailingPreviewCtrl', ['$rootScope', '$scope', '$filter', 'autoMailing', 'server', '$modal', function($rootScope, $scope, $filter, autoMailing, server, $modal) {

    $scope.getToolTip = function() {
        return $filter('translate')('GS_NOTIFICATIONS_INFO').format($rootScope.main.brand);
    };

    var isMailingHandler = function(autoMailingSendAs) {
        return !!_.findWhere($rootScope.getMailingHandlerSendAsOptions(), { id: autoMailingSendAs });
    };

    var formatSendAsName = function(autoMailingSendAs) {
        var sendOptions = {
            'emailAndSMS': 'Both mail and SMS',
            'emailOnly': 'Only email',
            'SMSOnly': 'Only SMS',
            'emailFirst': 'First email and second SMS',
            'SMSFirst': 'First SMS and second email',
            'noMailing': 'No mailing',
            'pushOnly': 'Only push',
        };
        $rootScope.getMailingHandlerSendAsOptions().forEach((mh) => (sendOptions[mh.id] = mh.name));
        return $filter('translate')(sendOptions[autoMailingSendAs]);
    };

    var emailTemplate = '';
    var SMSTemplate = '';
    var pushTemplate = '';
    (function translateTemplateName() {
        if (autoMailing.emailTemplate) {
            emailTemplate = angular.copy(autoMailing.emailTemplate);
            emailTemplate.name = $filter('translate')(autoMailing.emailTemplate.name);
        }
        if (autoMailing.SMSTemplate) {
            SMSTemplate = angular.copy(autoMailing.SMSTemplate);
            SMSTemplate.name = $filter('translate')(autoMailing.SMSTemplate.name);
        }
        if (autoMailing.pushTemplate) {
            pushTemplate = angular.copy(autoMailing.pushTemplate);
            pushTemplate.name = $filter('translate')(autoMailing.pushTemplate.name);
        }
    })();

    var showTemplate = function(autoMailing) {
        server.get('/api/mailing/template/get', {templateId: autoMailing.value.id}, null).then(function(result) {
            $modal.open({
                templateUrl: 'views/templatespreview.html',
                windowClass: 'huge-modal-window',
                controller: 'TemplatePreviewCtrl',
                resolve: {
                    template: function() {
                        return result;
                    }
                }
            });
        });
    };

    $rootScope.waitFor(['mailinghandlers']).then(function() {
        $scope.fields = [
            { name: 'name', title: 'Name', type: 'label', value: $filter('translate')(autoMailing.name) },
            { name: 'filter', title: 'Filter', type: 'label', value: $filter('translate')(autoMailing.name) },
            { name: 'sendAs', title: 'Send as', type: 'label', value: formatSendAsName(autoMailing.sendAs) },
            { name: 'emailTemplate', title: 'Mailing template email', type: 'select', required: false, readonly: true, value: emailTemplate, visible: function() { return autoMailing.sendAs && (autoMailing.sendAs !== 'SMSOnly' && autoMailing.sendAs !== 'noMailing' && autoMailing.sendAs !== 'pushOnly'); }, extraButtonTitle: 'Show template', extraButtonClicked: showTemplate, extraButtonClass: 'btn-success' },
            { name: 'SMSTemplate', title: 'Mailing template SMS', type: 'select', required: false, readonly: true, value: SMSTemplate, visible: function() { return autoMailing.sendAs && (autoMailing.sendAs !== 'emailOnly' && autoMailing.sendAs !== 'noMailing' && autoMailing.sendAs !== 'pushOnly' && !isMailingHandler(autoMailing.sendAs)); }, extraButtonTitle: 'Show template', extraButtonClicked: showTemplate, extraButtonClass: 'btn-success' },
            { name: 'pushTemplate', title: 'Mailing template Push notifications', type: 'select', required: false, readonly: true, value: pushTemplate, visible: function() { return autoMailing.sendAs && autoMailing.sendAs == 'pushOnly'; }, extraButtonTitle: 'Show template', extraButtonClicked: showTemplate, extraButtonClass: 'btn-success' }
        ];
    });
}]);

app.controller('NewGenericAutomaticMailingCtrl', ['$rootScope', '$scope', '$controller', '$modal', 'propertyhelper', 'server', '$filter', '$q', function($rootScope, $scope, $controller, $modal, propertyhelper, server, $filter, $q) {
    $controller('AddCtrl', { $scope: $scope });
    $scope.wideForm = true;
    $scope.postUrl = '/api/automaticmailing/generic/add';
    $scope.successTitle = 'Rule added';
    $scope.failedTitle = 'Failed to add rule';

    propertyhelper.getInfo().then(function(result) {
        $scope.info = result;
        $scope.setFields();
    });

    var getMailingTemplates = function() {
        var deferred = $q.defer();
        server.get('/api/mailing/template/get/all').then(function(templates) {
            $scope.mailTemplates = templates.filter(function(t) { return t.type === 'mail'; });
            $scope.smsTemplates = templates.filter(function(t) { return t.type === 'sms'; });
            if ($scope.item) {
                if ($scope.item.emailTemplate) {
                    _.findWhere($scope.fields, {name: 'emailTemplate'}).value = _.findWhere($scope.mailTemplates, {id: $scope.item.emailTemplate});
                }
                if ($scope.item.SMSTemplate) {
                    _.findWhere($scope.fields, {name: 'SMSTemplate'}).value = _.findWhere($scope.smsTemplates, {id: $scope.item.SMSTemplate});
                }
                if ($scope.item.pushTemplate) {
                    _.findWhere($scope.fields, {name: 'pushTemplate'}).value = _.findWhere($scope.smsTemplates, {id: $scope.item.pushTemplate});
                }
            }
            deferred.resolve();
        });
        return deferred.promise;
    };
    getMailingTemplates();

    $rootScope.waitFor(['mailinghandlers']).then(function() {
        $scope.sendOptions = [
            { id: 'emailAndSMS', name: 'Both mail and SMS' },
            { id: 'emailOnly', name: 'Only email' },
            { id: 'SMSOnly', name: 'Only SMS' },
            { id: 'emailFirst', name: 'First email and second SMS' },
            { id: 'SMSFirst', name: 'First SMS and second email' },
            { id: 'pushOnly', name: 'Only push' },
            ...$rootScope.getMailingHandlerSendAsOptions()
        ];
    });


    $scope.sendTos = [];
    $scope.originalSendTos = [];

    var filteroptions = {};
    function updateFilters() {
        _.findWhere($scope.fields, {name: 'filter'}).value = null;
        filteroptions.info = $scope.info;
        filteroptions.datatype = _.findWhere($scope.fields, {name: 'datatype'}).value;
        _.findWhere($scope.fields, {name: 'period'}).value =  365;
    }

    function getPreparedSendTos() {
        $scope.sendTos = [];
        $scope.originalSendTos = [];
        var sendTos = propertyhelper.getExpandedProperties(filteroptions.info, filteroptions.datatype.id).filter(function(x) { return !x.xf && !x.primary && (x.id.includes('phone') || x.id.includes('mail')) && !x.id.includes('wrong_mail') && !x.id.includes('trainingcards') && !x.id.includes('oldphone'); });
        if (sendTos.length > 0) {
            sendTos.map(function(s) {
                if (Array.isArray(s.name)) {
                    var res = '';
                    s.name.forEach(function(n) {
                        if (res.length) {
                            res += ' > ';
                        }
                        res += $filter('translate')(n);
                    });
                    s.name = res;
                }
            });
            $scope.sendTos.push.apply($scope.sendTos, sendTos);
        }
        if (sendTos.length < 1) {
            sendTos.push({id: "mail", name: "E-mail"});
            sendTos.push({id: "phone", name: "Phone"});
            $scope.sendTos.push.apply($scope.sendTos, sendTos);
        }
        $scope.sendTos.push({id: "push", name: "Push notification"});
        $scope.originalSendTos = $scope.sendTos;
    }

    var showExampleTemplate = function() {
        $modal.open({
            templateUrl: 'views/exampletemplate.html',
            controller: 'GenericAutomaticMailingExampleCtrl',
        }).result.then(function(example) {
            _.findWhere($scope.fields, {name: 'name'}).value = example.description;
            _.findWhere($scope.fields, {name: 'datatype'}).value = _.findWhere($scope.info.datatypes, {id: example.rule.datatype});
            filteroptions.info = $scope.info;
            filteroptions.datatype = _.findWhere($scope.fields, {name: 'datatype'}).value;
            _.findWhere($scope.fields, {name: 'filter'}).resetInitView = true;
            _.findWhere($scope.fields, {name: 'filter'}).value = example.rule.filter;
            getPreparedSendTos();
        });
    };

    function dataTypeChange() {
        updateFilters();
        getPreparedSendTos();
    }

    var showFilter = function() { return _.findWhere($scope.fields, {name: 'datatype'}).value; };

    var showMailTemplate = function() {
        var sendAs = _.findWhere($scope.fields, {name: 'sendAs'}).value;
        if (sendAs && sendAs.id !== 'SMSOnly' && sendAs.id !== 'pushOnly') { return true; }
        else { return false; }
    };
    var showSMSTemplate = function() {
        var sendAs = _.findWhere($scope.fields, {name: 'sendAs'}).value;
        if (sendAs && sendAs.id !== 'emailOnly' && sendAs.id !== 'pushOnly' && !sendAs.addon_id) { return true; }
        else { return false; }
    };
    var showPushTemplate = function() {
        var sendAs = _.findWhere($scope.fields, {name: 'sendAs'}).value;
        return sendAs && sendAs.id === 'pushOnly';
    };
    var sendAsChanged = function() {
        var sendAs = _.findWhere($scope.fields, {name: 'sendAs'}).value;
        showMailTemplate();
        showSMSTemplate();
        $scope.sendTos = $scope.originalSendTos;
        if (sendAs.id === 'emailOnly') { $scope.sendTos = $scope.sendTos.filter(function(s) { return s.id.includes('mail'); }); }
        else if (sendAs.id === 'SMSOnly') { $scope.sendTos = $scope.sendTos.filter(function(s) { return s.id.includes('phone'); }); }
        else if (sendAs.id === 'pushOnly') { $scope.sendTos = $scope.sendTos.filter(function(s) { return s.id == 'push'; }); }

        if (sendAs.id !== 'pushOnly') { $scope.sendTos = $scope.sendTos.filter(function(s) { return s.id !== 'push'; }); }
    };

    var addTemplate = function(t) {
        var templateType = t.title.includes('email') ? 'mail' : 'sms';
        $modal.open({
            templateUrl: 'views/addmodal.html',
            windowClass: 'huge-modal-window',
            controller: 'NewTemplateModalCtrl',
            resolve: {
                templateType: function() {
                    return templateType;
                },
            }
        }).result.then(function(result) {
            var originalMailTemplate = _.findWhere($scope.fields, {name: 'emailTemplate'}).value;
            var originalSmsTemplate = _.findWhere($scope.fields, {name: 'SMSTemplate'}).value;
            var originalPushTemplate = _.findWhere($scope.fields, {name: 'pushTemplate'}).value;
            getMailingTemplates().then(function() {
                if (result.type === 'mail') {
                    _.findWhere($scope.fields, {name: 'emailTemplate'}).value = _.findWhere($scope.mailTemplates, {id: result.id});
                    _.findWhere($scope.fields, {name: 'SMSTemplate'}).value = originalSmsTemplate ? _.findWhere($scope.smsTemplates, {id: originalSmsTemplate.id}) : null;
                } else if (result.type === 'sms') {
                    _.findWhere($scope.fields, {name: 'SMSTemplate'}).value = _.findWhere($scope.smsTemplates, {id: result.id});
                    _.findWhere($scope.fields, {name: 'emailTemplate'}).value = originalMailTemplate ? _.findWhere($scope.mailTemplates, {id: originalMailTemplate.id}) : null;
                    _.findWhere($scope.fields, {name: 'pushTemplate'}).value = originalPushTemplate ? originalPushTemplate : _.findWhere($scope.smsTemplates, {id: result.data.id});
                }
            });
        });
    };

    function prependDatatype(datatype, r) {
        if (r.content) {
            r.content.forEach(function(r) {
                prependDatatype(datatype, r);
            });
        } else {
            r.lhs = datatype + '.' + r.lhs;
        }
    }

    $scope.getPreparedFilterItem = function() {
        var item = $scope.getSubmitItem();
        if (item.filter) {
            item.filter = angular.copy(item.filter);
            prependDatatype(item.datatype, item.filter);
            item.rule = {datatype: item.datatype, filter: item.filter};
        }
        if (item.sendTo) {
            item.sendTo = item.sendTo.join(',');
        }
        return item;
    };

    $scope.setFields = function() {
        $scope.fields = [
            { name: 'name', title: 'Name', type: 'text', required: true },
            { type: 'button', buttonTitle: 'Choose from example filter', buttonClass: 'btn btn-success', click: showExampleTemplate },
            { name: 'datatype', title: 'Data type', required: true, type: 'select', options: function() { return $scope.info.datatypes; }, useId: true, change: dataTypeChange, orderPredicate: 'translated' },
            { name: 'filter', title: 'Filter', required: true, type: 'filter', options: filteroptions, visible: showFilter },
            { hint: 'RESEND_PERIOD_HINT', hintClass: 'alert-info', visible: showFilter },
            { name: 'period', title: 'Period', required: true, type: 'infoNumber', info: 'days', value: 365, visible: showFilter, max: 9999 },
            { name: '_', hint: 'AUTOMAILINGS_SENDAS_HINT', hintClass: 'alert-info' },
            { name: 'sendAs', title: 'Send as', type: 'select', required: true, options: function() { return $scope.sendOptions; }, useId: true, change: sendAsChanged },
            { name: 'senderId', title: 'Sender', type: 'customer', required: false, itemTypes: ['staff'] },
            { name: 'sendTo', title: 'Send to', type: 'multiselect', required: true, options: function() { return $scope.sendTos; }, useId: true },
            { name: 'emailTemplate', title: 'Mailing template email', type: 'select', required: true, options: function() { return $scope.mailTemplates; }, visible: showMailTemplate, placeholder: 'No template', addButtonTitle: 'Create new template', addButtonClicked: addTemplate, useId: true },
            { name: 'SMSTemplate', title: 'Mailing template SMS', type: 'select', required: true, options: function() { return $scope.smsTemplates; }, visible: showSMSTemplate, placeholder: 'No template', addButtonTitle: 'Create new template', addButtonClicked: addTemplate, useId: true },
            { name: 'pushTemplate', title: 'Mailing template push', type: 'select', required: true, options: function() { return $scope.smsTemplates; }, visible: showPushTemplate, placeholder: 'No template', addButtonTitle: 'Create new template', addButtonClicked: addTemplate, useId: true }
        ];
    };

    $scope.submit = function() {
        var item = $scope.getPreparedFilterItem();
        $scope.loadingStatus.loading = true;
        item.email_tid = item.emailTemplate;
        item.sms_tid = item.SMSTemplate;
        item.push_tid = item.pushTemplate;
        delete item.filter;
        delete item.emailTemplate;
        delete item.SMSTemplate;
        delete item.pushTemplate;
        server.post($scope.postUrl, item, null, $scope.successTitle, $scope.failedTitle).then(function(result) {
            $scope.loadingStatus.loading = false;
            if (result.success) {
                $scope.sendTos = [];
                $scope.resetForm($scope);
                $scope.possiblyClose(result.data);
            }
        });
    };

}]);

app.controller('GenericAutomaticMailingExampleCtrl', ['$rootScope', '$scope', 'server', function ($rootScope, $scope, server) {
    $scope.examples = [];
    server.get('/api/mailing/automaticmailingexample/get').then(function(result) {
        $scope.examples.push.apply($scope.examples, result);
    });
    var setExample = function(example) {
        $scope.$close(example);
    };
    $scope.config = {
        getItems: function() {
            return $scope.examples;
        },
        rowClick: function(e) {
            $scope.$close(e);
        },
        searchDepth: 2,
        countSuffixList: ['example', 'examples'],
        columns: [
            {field: 'description', title: 'Description', format: 'translated'}
        ],
        buttons: [
            {title: 'Choose', buttonClass: 'btn-success', onClick: setExample }
        ]
    };
}]);

app.controller('GenericAutomaticMailingChangeCtrl', ['$rootScope', '$scope', 'server', '$controller', 'autoMailing', function ($rootScope, $scope, server, $controller, autoMailing) {
    $controller('NewGenericAutomaticMailingCtrl', {$scope: $scope});
    $controller('ChangeModalCtrl', {$scope: $scope});

    $scope.postUrl = '/api/automaticmailing/generic/change';

    $scope.titleSuffix = function() {
        return $scope.item.name;
    };

    var r = angular.copy(autoMailing);

    $scope.item = r;
    $scope.item.id = r.id;
    $scope.item.datatype = r.rule.datatype;
    $scope.item.filter = r.rule.filter;
    $scope.item.senderId = _.findWhere($rootScope.members, {id: r.senderId});
    $scope.item.sendTo = r.sendTo.split(',');
    $scope.item.emailTemplate = r.email_tid;
    $scope.item.SMSTemplate = r.sms_tid;
    $scope.item.pushTemplate = r.push_tid;

    $scope.$watch('info', function() {
        if ($scope.info) {
            $scope.setValues($scope.item, {dontSetInvisible: true, callChange: true});
        }
    });

    $scope.submit = function() {
        var item = $scope.getPreparedFilterItem();
        item.email_tid = item.emailTemplate;
        item.sms_tid = item.SMSTemplate;
        item.push_tid = item.pushTemplate;
        delete item.emailTemplate;
        delete item.SMSTemplate;
        delete item.pushTemplate;
        delete item.filter;

        $scope.loadingStatus.loading = true;
        server.post($scope.postUrl, item, null, $scope.successTitle, $scope.failedTitle).then(function(result) {
            $scope.loadingStatus.loading = false;
            if (result.success) {
                $scope.sendTos = [];
                $scope.resetForm($scope);
                $scope.possiblyClose(result.data);
            }
        });
    };

}]);

app.controller('orderSpecialAutomaticMailingCtrl', ['$rootScope', '$scope', '$controller', 'server', function ($rootScope, $scope, $controller, server) {
    $controller('AddCtrl', {$scope: $scope});

    $scope.title = 'Order special automatic mailing';
    $scope.submitTitle = 'Send order';
    $scope.loadingStatus = {};

    $scope.fields = [
        { name: '_', hint: 'ORDER_SPECIALMAILING_HINT', hintClass: 'alert-info' },
        { name: 'description', title: 'Description', required: true, type: 'htmleditor' }
    ];

    $scope.submit = function () {
        $scope.loadingStatus.loading = true;
        var message = 'From: ' + $rootScope.getHost() + '<br><br>' + $scope.getSubmitItem().description;
        var mail = { staffs: [$rootScope.superUserId], message: message, from: $rootScope.currentStaff.name, subject: 'Best\xE4llning av ny rapport', replyTo: $rootScope.currentStaff.mail };
        server.post('/api/mail/send', mail, null, 'Order sent', 'Failed to send order').then(function() {
            $scope.$close();
            $scope.loadingStatus.loading = false;
        });
    };
}]);

app.controller('AutomaticMailingChangeCtrl', ['$rootScope', '$scope', '$controller', '$filter', '$q', 'autoMailing', 'formatter', 'server', '$modal', function($rootScope, $scope, $controller, $filter, $q, autoMailing, formatter, server, $modal) {
    $controller('ChangeModalCtrl', { $scope: $scope });
    $scope.wideForm = true;
    $scope.item = autoMailing;

    $scope.currentSelection = '';
    $scope.sendOptionSelected = function() {
        var sendOption = $scope.getSubmitItem && $scope.getSubmitItem().sendAs;
        if (!_.findWhere($scope.sendOptions, { id: sendOption })) { return; }
        $scope.currentSelection = sendOption;
    };

    $scope.sendOptions = [];
    $scope.templates = '';
    $scope.templateAllOptions = '';
    function getMailingTemplates() {
        var deferred = $q.defer();
        server.get('/api/mailing/template/get/all').then(function(templates) {
            $scope.templates = templates;
            $scope.templateAllOptions = templates.map(function(t) { return { id: t.id, name: t.name, type: t.type, value: t.name }; });
            deferred.resolve();
        });
        return deferred.promise;
    }

    $scope.setInitialValues = function() {
        if ($rootScope.hasModule('SMS')) {
            $scope.sendOptions = [
                { id: 'emailAndSMS', name: 'Both mail and SMS' },
                { id: 'emailOnly', name: 'Only email' },
                { id: 'SMSOnly', name: 'Only SMS' },
                { id: 'emailFirst', name: 'First email and second SMS' },
                { id: 'SMSFirst', name: 'First SMS and second email' },
                { id: 'noMailing', name: 'No mailing' },
                { id: 'pushOnly', name: 'Only push' },
                ...$rootScope.getMailingHandlerSendAsOptions()
            ];
        } else {
            $scope.sendOptions = [
                { id: 'emailOnly', name: 'Only email' },
                { id: 'noMailing', name: 'No mailing' },
                { id: 'pushOnly', name: 'Only push' },
                ...$rootScope.getMailingHandlerSendAsOptions()
            ];
        }
        if (autoMailing.rule) {
            var index = $scope.sendOptions.indexOf({ id: 'noMailing', name: 'No mailing' });
            $scope.sendOptions.splice(index, 1);
        }
        $scope.currentSelection = $scope.item.sendAs;
        var promise = getMailingTemplates();
        promise.then(function() {
            if ($scope.item.email_tid) {
                var emailTemplate = _.findWhere($scope.templateAllOptions, { id: $scope.item.email_tid });
                emailTemplate.name = $filter('translate')(emailTemplate.name);  // format: 'translated' doesn't work
                _.findWhere($scope.fields, { name: 'emailTemplate' }).value = emailTemplate;
                $scope.item.emailTemplate = emailTemplate;  // Make 'Save change' button highlighted properly
            }
            if ($scope.item.sms_tid) {
                var smsTemplate = _.findWhere($scope.templateAllOptions, { id: $scope.item.sms_tid });
                smsTemplate.name = $filter('translate')(smsTemplate.name);
                _.findWhere($scope.fields, { name: 'SMSTemplate' }).value = smsTemplate;
                $scope.item.SMSTemplate = smsTemplate;
            }
            if ($scope.item.push_tid) {
                var pushTemplate = _.findWhere($scope.templateAllOptions, { id: $scope.item.push_tid });
                pushTemplate.name = $filter('translate')(pushTemplate.name);
                _.findWhere($scope.fields, { name: 'pushTemplate' }).value = pushTemplate;
                $scope.item.pushTemplate = pushTemplate;
            }
            $scope.item.name = $filter('translate')($scope.item.name);
            $scope.setValues($scope.item);
        });
    };

    var changeTemplate = function(autoMailing) {
        server.get('/api/mailing/template/get', {templateId: Number(autoMailing.value.id)}, null).then(function(result) {
            $modal.open({
                templateUrl: 'views/templateschange.html',
                windowClass: 'huge-modal-window',
                controller: 'TemplateChangeCtrl',
                resolve: {
                template: function() {
                        return result;
                    }
                }
            });
        });
    };

    $scope.fields = [
        { name: 'name', title: 'Name', type: 'label', required: true, readonly: true },
        { hint: 'AUTOMAILINGS_SENDAS_HINT', hintClass: 'alert-info' },
        { name: 'sendAs', title: 'Send as', type: 'select', required: true, options: function() { return $scope.sendOptions; }, change: $scope.sendOptionSelected, useId: true },
        { name: 'emailTemplate', title: 'Mailing template email', type: 'select', required: false, readonly: true, options: function() { return $scope.emailTemplateOptions; }, visible: function() { return $scope.currentSelection && ($scope.currentSelection !== 'SMSOnly' && $scope.currentSelection !== 'noMailing') && $scope.currentSelection !== 'pushOnly'; }, extraButtonTitle: 'Change template', extraButtonClicked: changeTemplate, extraButtonClass: 'btn-warning' },
        { name: 'SMSTemplate', title: 'Mailing template SMS', type: 'select', required: false, readonly: true, options: function() { return $scope.SMSTemplateOptions; }, visible: function() { return  $scope.currentSelection && ($scope.currentSelection !== 'emailOnly' && $scope.currentSelection !== 'noMailing') && $scope.currentSelection !== 'pushOnly' && !$scope.currentSelection.addon_id; }, extraButtonTitle: 'Change template', extraButtonClicked: changeTemplate, extraButtonClass: 'btn-warning' },
        { name: 'pushTemplate', title: 'Mailing template push', type: 'select', required: false, readonly: true, options: function() { return $scope.SMSTemplateOptions; }, visible: function() { return $scope.currentSelection && $scope.currentSelection == 'pushOnly'; }, extraButtonTitle: 'Change template', extraButtonClicked: changeTemplate, extraButtonClass: 'btn-warning' }
    ];
    $rootScope.waitFor(['mailinghandlers']).then(function() {
        $scope.setInitialValues();
    });

    $scope.postUrl = autoMailing.rule ? '/api/automaticmailing/generic/change' : '/api/mailing/automailing/change';
    $scope.callCloseOnSuccess = true;

    $scope.submit = function() {
        var item = $scope.getSubmitItem();
        var email_tid = _.findWhere($scope.fields, {name: 'emailTemplate'}) || {};
        var sms_tid = _.findWhere($scope.fields, {name: 'SMSTemplate'}) || {};
        item.email_tid = (email_tid.value === null ? null : email_tid.value.id);
        item.sms_tid = (sms_tid.value === null ? null : sms_tid.value.id);

        $scope.loadingStatus.loading = true;
        server.post($scope.postUrl, item, null, 'Saved changes', 'Failed to save changes').then(function(result) {
            if (result.success) {
                $scope.$close();
            }
            $scope.loadingStatus.loading = false;
        });
    };

}]);

app.controller('NewTemplateModalCtrl', ['$rootScope', '$scope', '$controller', 'templateType', function($rootScope, $scope, $controller, templateType) {
    $scope.item = {type: templateType};
    $controller('NewTemplateCtrl', {$scope: $scope});
    $scope.callCloseOnSuccess = true;
}]);

app.controller('SettingsCtrl', ['$rootScope', '$scope', '$controller', '$http', function($rootScope, $scope, $controller, $http) {
    $controller('ChangeCtrl', {$scope: $scope});

    $scope.successTitle = 'Settings saved';
    $scope.failedTitle = 'Failed to save settings';
    $scope.title = undefined;
    $scope.item = {};

    $scope.getButtonText = function() {
        return 'Save changes';
    };

    $scope.afterSubmit = function() {
        $scope.getSettings();
        $rootScope.refetchCurrentStaff();
    };

    $scope.getSettings = function() {
        if ($scope.getUrl) {
            $rootScope.waitFor(['staffs']).then(function() {
                return $http.get($scope.getUrl).success(function(data) {
                    $scope.item = data;
                    $scope.setValues(data);
                    $scope.loadingStatus.loading = false;
                });
            });
        } else {
            $scope.loadingStatus.loading = false;
        }
    };
}]);

app.controller('SettingsWorkoutBookingCtrl', ['$rootScope', '$scope', '$route', '$controller', function($rootScope, $scope,$route, $controller) {
    $controller('SettingsCtrl', {$scope: $scope});

    $scope.postUrl = '/api/workoutBooking/settings/set';

    var bookingsLimitIntervalTypes = [ { name: 'Per day', id: 'day' }, { name: 'Per week', id: 'week' } ];
    var bookingsLimitIntervalVisible = function(type) {
        var field = _.findWhere($scope.fields, { name: 'bookingsLimitIntervalType' });
        return field && field.value && field.value.id == type;
    };

    function showAllowCreateWorkoutType(){
        if($rootScope.currentStaff?.mail != 'info@korpen.se' && $rootScope.currentStaff.is_korpen){
            return false
        }
        else {
            return true
        }
    }

    $scope.fields = [
        {name: 'releasedAt', title: 'Workouts can be booked at', required: true, type: 'time', helpText: 'Decide what time of day the workouts will be available for booking.' },
        {name: 'deductOnBooking', title: 'Do not repay noshows', required: true, type: 'checkbox', helpText: 'No-shows are people who have booked workouts but do not show up. If the box is unchecked, the person gets their clip back despite their absence.' },
        {name: 'showBookingCount', title: 'Let members see number of booked', required: false, type: 'checkbox'}, /* TODO: fix this */
        {name: 'showInstructorPhoneNumber', title: "Show instructor's phone number", required: false, type: 'checkbox'},
        {name: 'sendInfoSmsToInstructors', title: 'Send SMS to instructors', info: 'hours before', required: false, type: 'infoText', visible: function() {return $rootScope.hasModule('SMS'); }},
        {name: 'bookingsLimit', title: 'Max number of concurrent bookings', type: 'number', placeholder: 'Unlimited'},
        {name: 'bookingsLimitIntervalType', title: 'Limit bookings by interval', type: 'select', required: false, placeholder: 'No limit', options: function() { return bookingsLimitIntervalTypes; }, useId: true },
        {name: 'bookingsLimitInterval', title: 'Max number of bookings per day', type: 'number', required: true, visible: function() { return bookingsLimitIntervalVisible('day'); }, min: 1 },
        {name: 'bookingsLimitInterval', title: 'Max number of bookings per week', type: 'number', required: true, visible: function() { return bookingsLimitIntervalVisible('week'); }, min: 1 },
        {name: 'allowCreateWorkoutType', title: 'Allow creation of workout types', required: false, type: 'checkbox',visible: function() { return showAllowCreateWorkoutType() }, helpText: 'Determines whether activity types can be added freely or whether the offer should be locked to existing activity types. Intended primarily for chain facilities that control the supply centrally.', placement: 'right' }
    ];

    $rootScope.waitFor(['workoutbookingsettings']).then(function() {
        $scope.item = $rootScope.workoutbookingsettings;
        $scope.setValues($scope.item);
    });
}]);

app.controller('SettingsLoyaltyPointsCtrl', ['$rootScope', '$scope', '$controller', '$modal', '$filter', 'modalUtils', 'confirm', 'server', function($rootScope, $scope, $controller, $modal, $filter, modalUtils, confirm, server) {
    $controller('SettingsCtrl', {$scope: $scope});

    $scope.getUrl = '/api/loyaltypoints/settings/get';
    $scope.postUrl = '/api/loyaltypoints/settings/set';

    $scope.fields = [
        {name: 'validDays', title: 'Points expire after', type: 'infoNumber', info: 'days'}
    ];

    var getActivityTypes = function() {
        var activities = [];
        if ($rootScope.workouttypes.length) {
            activities.push({id: 'workouttypes', name: 'Workouts', items: $rootScope.workouttypes, categories: $rootScope.workoutcategories });
        }
        if ($rootScope.resourcebookingservices.length) {
            activities.push({id: 'resourcebookingservices', name: 'Resources', items: $rootScope.resourcebookingservices, categories: $rootScope.resourcebookingcategories });
        }
        if ($rootScope.hasModule('Courses')) {
            var courses = {id: 'courses', name: 'Courses', items: undefined, categories: $rootScope.coursecategories };
            server.get('/api/course/get').then(function(result) {
                courses.items = result.filter(function(c) { return !Date.newFull(c.lastBookingTime).isPastDate(); });
                if (courses.items.length) {
                    activities.push(courses);
                }
            });
        }
        activities.push({id: 'trainingcardtypes', name: 'Training cards', items: _.filter($rootScope.trainingcardtypes, function(tc) {return $rootScope.isTrainingCard(tc) && tc.type !== 'resourcebooking';}) });
        return activities;
    };
    var activities = getActivityTypes();

    $scope.addTerms = function() {
        $modal.open({
            templateUrl: 'views/addmodal.html',
            controller: 'SettingsLoyaltyPointTermsAddCtrl',
            resolve: {
                activities: function() {
                    return activities;
                },
            }
        });
    };

    $scope.changeTerms = function(terms, fields, activate) {
        $modal.open({
            templateUrl: 'views/changemodal.html',
            controller: 'SettingsLoyaltyPointTermsChangeCtrl',
            resolve: {
                activities: function() {
                    return activities;
                },
                terms: function() {
                    return terms;
                },
                fields: function() {
                    return fields;
                },
                activate: function() {
                    return activate;
                }
            },
        });
    };

    $scope.removeTerms = function(terms) {
        confirm.show('REMOVE_TERMS_MESSAGE', {ladda: true}).then(function(resolve) {
            server.post('/api/loyaltypoints/settings/terms/remove', terms.id, null, '{0} was removed', 'Failed to remove {0}', 'Terms').then(resolve);
        });
    };

    $scope.activateTerms = function(terms) {
        if (terms.validTo && terms.validTo < Date.today()) {
            var fields = [
                { hint: 'Change valid to date to activate' },
                { name: 'validTo', title: 'Valid to', type: 'date' }
            ];
            $scope.changeTerms(terms, fields);
        } else if (terms.loyaltyPointActivities.some(function(lpa) { return _.keys(lpa).length == 0; })) {
            var activate = true;
            $scope.changeTerms(terms, undefined, activate);
        } else {
            modalUtils.activateModal(terms, terms.name, 'ACTIVATE_TERMS_MESSAGE', '/api/loyaltypoints/settings/terms/change');
        }
    };

    $scope.inactivateTerms = function(terms) {
        modalUtils.inactivateModal(terms, terms.name, 'INACTIVATE_TERMS_MESSAGE', '/api/loyaltypoints/settings/terms/change');
    };

    var getActivityNames = function(loyaltyPointActivities) {
        var res = [];
        _.each(loyaltyPointActivities, function(lpa) {
            _.each(lpa, function(activityType) {
                var names = activityType.map(function(a) { return a.name; });
                res = res.concat(names);
            });
        });
        return res;
    };

    $scope.loyaltyPointTermsConfig = {
        api: {
            url: '/api/loyaltypoints/settings/terms/get',
            triggers: [{ type: 'loyaltypointterms' }],
            transform: function(t) {
                if(t.validTo) {
                    t.validTo = new Date(t.validTo);
                }
            },
        },
        tabs: [
            {name: 'Active', badgeClass: 'badge-success', itemFilter: function(terms) { return terms.active && (!terms.validTo || (terms.validTo && terms.validTo >= Date.today())); }},
            {name: 'Inactive', itemFilter: function(terms) { return !terms.active || (terms.validTo && terms.validTo < Date.today()); }},
        ],
        countSuffix: function() {
            return $filter('translate')('Terms').toLowerCase();
        },
        rowClass: function(terms) {
            return terms.loyaltyPointActivities.some(function(lpa) { return _.isEmpty(lpa); }) ? 'danger' : '';
        },
        rowClick: $scope.changeTerms,
        orderColumn: 'created',
        columns: [
            {field: 'created', title: 'Created', format: 'datetime', visible: function() { return false; }},
            {field: 'name', title: 'Name'},
            {field: 'loyaltyPointActivities', title: 'Activity', format: 'commaList', getValue: function(data) { return getActivityNames(data.loyaltyPointActivities); }},
            {field: 'points', title: 'Points', format: 'number'},
            {field: 'validTo', title: 'Valid to', format: 'date' },
        ],
        buttons: [
            {title: 'Change', buttonClass: 'btn-warning', onClick: $scope.changeTerms },
            {title: 'Inactivate', buttonClass: 'btn-danger', visible: function(terms) { return terms.active && (!terms.validTo || (terms.validTo && terms.validTo >= Date.today())); }, onClick: $scope.inactivateTerms },
            {title: 'Activate', buttonClass: 'btn-success', visible: function(terms) { return !terms.active || (terms.validTo && terms.validTo < Date.today()); }, onClick: $scope.activateTerms },
            {title: 'Remove', buttonClass: 'btn-danger', onClick: $scope.removeTerms }
        ],
        searchButtons: [
            { title: 'Add terms', showOnEmpty: true, onClick: $scope.addTerms }
        ]
    };

    $scope.getSettings();
}]);

app.controller('SettingsLoyaltyPointTermsAddCtrl', ['$rootScope', '$scope', '$controller', '$modal', '$filter', 'activities', function($rootScope, $scope, $controller, $modal, $filter, activities) {
    $controller('AddCtrl', {$scope: $scope});

    $scope.callCloseOnSuccess = true;
    $scope.postUrl = '/api/loyaltypoints/settings/terms/add';

    $scope.titleSuffix = function() {
        return $filter('translate')('Terms').toLowerCase();
    };

    function selectActivity(field) {
        $modal.open({
            templateUrl: 'views/addmodal.html',
            controller: 'TermsBuilderCtrl',
            resolve: {
                activities: function() {
                    return activities;
                },
                selectedActivities: function() {
                    return field.value == $filter('translate')('None chosen') ? undefined : field.value;
                }
            }
        }).result.then(function(item) {
            field.value = item;
        });
    }

    var getActivityNames = function(field) {
        var type = _.keys(field)[0];
        if (field[type] && field[type].length) {
            return _.map(field[type], function(activity) { return activity.name; }).join(', ');
        }
    };

    var getActivityFields = function() {
        return _.filter($scope.fields, function(f) { return f.name.startsWith('activity'); });
    };

    var numberOfActivities = function() {
        return getActivityFields().length;
    };

    function addActivityField() {
        var field = {name: 'activity' + numberOfActivities(), title: 'Activity', type: 'customobject', buttonTitle: 'Choose activity', buttonClick: selectActivity };
        field.getName = function() {
            if (field.value == $filter('translate')('None chosen')) {
                return field.value;
            }
            return getActivityNames(field.value);
        };
        field.change = function() {
            if (field.value == null) {
                $scope.fields.splice($scope.fields.indexOf(field), 1);
            }
        };
        // To show delete button if value is null
        field.value = $filter('translate')('None chosen');

        var addButton = _.findWhere($scope.fields, {name: 'addActivity'});
        var index = $scope.fields.indexOf(addButton);
        $scope.fields.splice(index, 0, field);
    }

    $scope.fields = [
        {name: 'name', title: 'Name', type: 'text', required: true },
        {name: 'points', title: 'Points', type: 'number', required: true },
        {name: 'validTo', title: 'Valid to', type: 'date' },
        {name: 'hint', hint: 'LOYALTYPOINTS_TERMS_HINT', hintClass: 'alert-info', visible: function() {return numberOfActivities() > 1; }},
        {name: 'addActivity', type: 'button', buttonTitle: 'Add another activity', buttonClass: 'btn-success', click: addActivityField },
        {name: 'timeLimit', title: 'Must be fulfilled within', type: 'infoNumber', info: 'days', min: 1, required: true, visible: function() {return numberOfActivities() > 1; }}
    ];

    $scope.canSubmit = function() {
        if ($scope.fields.some(function(field) {return field.value == $filter('translate')('None chosen'); })) {
            return false;
        }
        return true;
    };

    var gs = $scope.getSubmitItem;
    $scope.getSubmitItem = function() {
        var item = gs();
        var loyaltyPointActivities = [];

        delete item.addActivity;
        // pick the ids from activity fields
        getActivityFields().forEach(function(field) {
            var type = _.keys(field.value)[0];
            var activities = {};
            activities[type] = _.pluck(field.value[type], 'id');
            loyaltyPointActivities.push(activities);
            delete item[field.name];
        });
        item.loyaltyPointActivities = loyaltyPointActivities;
        return item;
    };

    addActivityField();
}]);

app.controller('SettingsLoyaltyPointTermsChangeCtrl', ['$rootScope', '$scope', '$controller', '$modal', '$filter', 'terms', 'activities', 'fields', 'activate', function($rootScope, $scope, $controller, $modal, $filter, terms, activities, fields, activate) {
    $controller('ChangeModalCtrl', {$scope: $scope});

    $scope.item = terms;
    $scope.postUrl = '/api/loyaltypoints/settings/terms/change';

    $scope.titleSuffix = function() {
        return $filter('translate')('Terms').toLowerCase();
    };

    function selectActivity(field) {
        $modal.open({
            templateUrl: 'views/addmodal.html',
            controller: 'TermsBuilderCtrl',
            resolve: {
                activities: function() {
                    return activities;
                },
                selectedActivities: function() {
                    return field.value == $filter('translate')('None chosen') ? undefined : field.value;
                }
            }
        }).result.then(function(item) {
            field.value = item;
        });
    }

    var getActivityNames = function(field) {
        var type = _.keys(field)[0];
        if (field[type] && field[type].length) {
            return _.map(field[type], function(activity) { return activity.name || activity.product.name; }).join(', ');
        }
    };

    var getActivityFields = function() {
        return _.filter($scope.fields, function(f) { return f.name.startsWith('activity'); });
    };

    var numberOfActivities = function() {
        return getActivityFields().length;
    };

    function addActivityField() {
        var field = {name: 'activity' + numberOfActivities(), title: 'Activity', type: 'customobject', buttonTitle: 'Choose activity', buttonClick: selectActivity };
        field.getName = function() {
            if (field.value == $filter('translate')('None chosen')) {
                return field.value;
            }
            return getActivityNames(field.value);
        };
        field.change = function() {
            if (field.value == null) {
                $scope.fields.splice($scope.fields.indexOf(field), 1);
            }
        };
        // To show delete button if value is null
        field.value = $filter('translate')('None chosen');

        var addButton = _.findWhere($scope.fields, {name: 'addActivity'});
        var index = $scope.fields.indexOf(addButton);
        $scope.fields.splice(index, 0, field);
        return field;
    }

    var missingActivity = function() {
        return terms.loyaltyPointActivities.some(function(lpa) { return _.isEmpty(lpa); });
    };

    $scope.fields = [
        {name: 'name', title: 'Name', type: 'text', required: true },
        {name: 'points', title: 'Points', type: 'number', required: true },
        {name: 'validTo', title: 'Valid to', type: 'date' },
        {name: 'hint', hint: 'LOYALTYPOINTS_TERMS_HINT', hintClass: 'alert-info', visible: function() {return numberOfActivities() > 1; }},
        {name: 'warning', hint: 'LOYALTYPOINTS_TERMS_MISSING_ACTIVITY', hintClass: 'alert-danger', visible: missingActivity },
        {name: 'addActivity', type: 'button', buttonTitle: 'Add another activity', buttonClass: 'btn-success', click: addActivityField },
        {name: 'timeLimit', title: 'Must be fulfilled within', type: 'infoNumber', info: 'days', min: 1, required: true, visible: function() {return numberOfActivities() > 1; }}
    ];

    $scope.canSubmit = function() {
        if ($scope.fields.some(function(field) { return field.value == $filter('translate')('None chosen'); })) {
            return false;
        }
        return true;
    };

    var gs = $scope.getSubmitItem;
    $scope.getSubmitItem = function() {
        var item = gs();
        delete item.addActivity;

        var loyaltyPointActivities = [];
        // pick the ids from activity fields
        getActivityFields().forEach(function(field) {
            var type = _.keys(field.value)[0];
            var activities = {};
            activities[type] = _.pluck(field.value[type], 'id');
            loyaltyPointActivities.push(activities);
            delete item[field.name];
        });

        if (loyaltyPointActivities.length) {
            item.loyaltyPointActivities = loyaltyPointActivities;
        }
        if (activate) {
            item.active = true;
        }
        return item;
    };

    function init() {
        if (fields) {
            $scope.fields = fields;
            $scope.submitTitle = 'Activate';
            $scope.setValues($scope.item);
        } else {
            $scope.setValues($scope.item);
            $scope.item.loyaltyPointActivities.forEach(function(lpa) {
                var field = addActivityField();
                if (_.isEmpty(lpa)) {
                    field.value = $filter('translate')('None chosen');
                } else {
                    var type = _.keys(lpa)[0];
                    field.value = {};
                    field.value[type] = _.map(lpa[type], function(activity) {
                        var activityItems = _.findWhere(activities, {id: type}).items;
                        var item = _.findWhere(activityItems, {id: activity.id});
                        return item;
                    });
                }
            });
        }
    }
    init();
}]);

app.controller('TermsBuilderCtrl', ['$scope', '$controller', 'activities', 'selectedActivities', function($scope, $controller, activities, selectedActivities) {
    $controller('AddCtrl', {$scope: $scope});

    $scope.callCloseOnSuccess = true;

    var selectedActivity = function() {
        var activityType = _.findWhere($scope.fields, {name: 'activitytype'});
        return activityType && activityType.value;
    };

    var selectedCategory = function() {
        var category = _.findWhere($scope.fields, {name: 'category'});
        return category && category.value;
    };

    var clearItems = function() {
        var activityType = selectedActivity().id;
        _.findWhere($scope.fields, {name: activityType}).value = [];
    };

    var getItems = function() {
        var category = selectedCategory();
        var activityType = selectedActivity();

        if (!activityType || (activityType.categories && !category)) {
            return [];
        } else if (!activityType.categories) {
            return activityType.items;
        }

        var items = _.filter(activityType.items, function(item) { return item.category_id == category.id; });
        if (activityType.id == 'courses') {
            items.forEach(function(item) { item.name = item.product.name; });
        }
        return items;
    };

    $scope.fields = [
        {name: 'activitytype', title: 'Type of activity', type: 'select', required: true, options: function() {return activities; }},
        {name: 'category', title: 'Category', type: 'select', required: true, options: function() {return selectedActivity().categories;}, change: clearItems, visible: function() {return selectedActivity() && selectedActivity().categories; }},
        {name: 'workouttypes', title: 'Workout', type: 'multiselect', placeholder: 'All', options: getItems, visible: function() {return selectedActivity() && selectedActivity().id == 'workouttypes'; }},
        {name: 'resourcebookingservices', title: 'Service', type: 'multiselect', placeholder: 'All', options: getItems, visible: function() {return selectedActivity() && selectedActivity().id == 'resourcebookingservices'; }},
        {name: 'courses', title: 'Course', type: 'multiselect', placeholder: 'All', options: getItems, visible: function() {return selectedActivity() && selectedActivity().id == 'courses'; }},
        {name: 'trainingcardtypes', title: 'Training card', type: 'multiselect', required: true, options: getItems, visible: function() {return selectedActivity() && selectedActivity().id == 'trainingcardtypes'; }},
    ];

    $scope.submit = function() {
        var item = $scope.getSubmitItem();
        var type = item.activitytype.id;
        var data = {};
        if (item[type] && item[type].length) {
            // return the selected activities
            data[type] = _.isArray(item[type]) ? item[type] : [item[type]];
        } else {
            // no selected activities. Get all from the selected category
            data[type] = _.findWhere($scope.fields, {name: type}).options();
        }
        $scope.$close(data);
    };

    function init() {
        if (selectedActivities) {
            var type = _.keys(selectedActivities)[0];

            var activityType = _.findWhere($scope.fields, {name: 'activitytype'});
            activityType.value = _.findWhere(activities, {id: type});

            var items = _.findWhere($scope.fields, {name: type});
            items.value = selectedActivities[type];

            if (activityType.value.categories) {
                var category = _.findWhere($scope.fields, {name: 'category'});
                category.value = _.findWhere(activityType.value.categories, {id: items.value[0].category_id});
            }
        }
    }
    init();
}]);

app.controller('SettingsPaysonCtrl', ['$rootScope', '$scope', '$controller', function($rootScope, $scope, $controller) {
    $controller('SettingsCtrl', {$scope: $scope});

    $scope.getUrl = '/api/payment/payson/settings/get';
    $scope.postUrl = '/api/payment/payson/settings/set';

    $scope.fields = [
        {name: 'agentid', title: 'Agent ID', required: true, type: 'text'},
        {name: 'md5key', title: 'API-key', required: true, type: 'text'},
        {name: 'mail', title: 'E-mail', required: true, type: 'email'}
    ];

    $scope.getSettings();
}]);

app.controller('SettingsGymCtrl', ['$rootScope', '$scope', '$controller', '$filter', '$modal', 'server', 'util', 'live', function($rootScope, $scope, $controller, $filter, $modal, server, util, live) {
    $controller('SettingsCtrl', {$scope: $scope});

    $scope.getUrl = '/api/settings/get';
    $scope.postUrl = '/api/settings/change';

    var hasMemberCreate = function() {
        return _.findWhere($scope.fields, {name: 'memberCreate'}).value;
    };

    var hasMemberCancel = function() {
        return _.findWhere($scope.fields, {name: 'memberCancel'}).value;
    };

    function showSetting(field) {
        if ($scope.item && $scope.item.show_settings) {
            return $scope.item.show_settings[field.name];
        }
    }

    function showGroupList(field) {
        var group_toggle = _.findWhere($scope.fields, {
            name: 'economy_responsible_staff_group_toggle'
        });

        if (group_toggle.value) {
            if (field.name == 'economy_responsible_staff_id') {
                return false;
            } else {
                return showSetting(field);
            }
        } else {
            if (field.name == 'economy_responsible_staff_id') {
                return showSetting(field);
            } else {
                return false;
            }
        }
    }

    function setGroupToggle() {
        return !!$scope.item.economy_responsible_group_id;
    }

    function useVisitAddress() {
        return _.findWhere($scope.fields, {name: 'use_visit_address'}).value;
    }

    var openWelcomeMailTemplate = function(item) {
        server.get('/api/mailing/automailing/get', {autoType: 'WELCOME_MAIL'}).then(function(result) {
            if (item.name === 'welcomeMail') {
                result = result.emailTemplate;
            } else {
                result = result.SMSTemplate;
            }
            $modal.open({
                templateUrl: 'views/templateschange.html',
                windowClass: 'huge-modal-window',
                controller: 'TemplateChangeCtrl',
                resolve: {
                    template: function() {
                        return result;
                    }
                }
            });
        });
    };

    var openWelcomeMailAutomaticMailing = function() {
        server.get('/api/mailing/automailing/get', {autoType: 'WELCOME_MAIL'}).then(function(result) {
            $modal.open({
                templateUrl: 'views/automailingschange.html',
                windowClass: 'huge-modal-window',
                controller: 'AutomaticMailingChangeCtrl',
                resolve: {
                    autoMailing: function() {
                        return result;
                    }
                }
            });
        });
    };

    var myBusiness = [
        {id: 'disabled', name: 'Inte aktiverat'},
        {id: 'basic', name: 'Zoezi MyBusiness - kopierad grundmall'},
        {id: 'easy', name: 'Zoezi MyBusiness Easy'},
        {id: 'flex', name: 'Zoezi MyBusiness Flex'},
        {id: 'korpen-easy', name: 'Korpen Easy'},
        {id: 'korpen-easy-settings', name: 'Korpen Easy Advanced'}
    ];

    let validateSmsName = {
        badValue: (modelValue, viewValue) => {
            return !viewValue || viewValue.match(/^[a-zA-Z0-9]{3,11}$/);
        }
    };

    var primaryDomainOptions = [];
    server.get('/api/settings/domains/get').then(domains => {
        primaryDomainOptions = domains.map(domain => {
            return {
                id: domain,
                name: domain
            }
        });
    });

    $scope.fields = [
        {name: 'name', title: 'Name', required: true, type: 'text', visible: showSetting, helpText: 'The name is displayed as the sender for system mailings' },
        {name: 'companyname', title: 'Companyname', required: true, type: 'text', visible: showSetting },
        {name: 'companynumber', title: 'Corporate identity', required: true, type: 'corporateIdentity', visible: showSetting },
        {name: 'mail', title: 'Mail', required: true, type: 'email', visible: showSetting },
        {name: 'homepage', title: 'Homepage', required: false, type: 'text', visible: showSetting },
        {name: 'phone', title: 'Phone number', required: false, type: 'text', visible: showSetting },
        {name: 'address', title: 'Address', required: true, type: 'text', visible: showSetting },
        {name: 'zipCode', title: 'Zip code', required: true, type: 'zipCode', visible: showSetting },
        {name: 'city', title: 'City', required: true, type: 'text', visible: showSetting },
        {hint: 'INFO_ON_INVOICE_HINT', hintClass: 'alert-info'},
        {name: 'use_visit_address', title: 'Visit address different from address', required: false, type: 'checkbox', visible: showSetting },
        {name: 'visit_address', title: 'Address', required: true, type: 'text', visible: function(field) { return showSetting(field) && useVisitAddress(); } },
        {name: 'visit_zipCode', title: 'Zip code', required: true, type: 'text', visible: function(field) { return showSetting(field) && useVisitAddress(); } },
        {name: 'visit_city', title: 'City', required: true, type: 'text', visible: function(field) { return showSetting(field) && useVisitAddress(); } },
        {name: 'smsname', title: 'SMS sender name', required: false, type: 'alphadigits', maxlength: 11, visible: showSetting, validator: validateSmsName },
        {name: 'terms', title: 'Terms and conditions', required: false, type: 'url', visible: showSetting, helpText: 'Link to the general terms and conditions. Appears on the registration form' },
        {name: 'memberCreate', title: 'Anyone can create an account', required: false, type: 'checkbox', visible: showSetting },
        {name: 'confirmMemberCreate', title: 'Manually confirm customer accounts', required: false, type: 'checkbox', visible: function(field) { return showSetting(field) && hasMemberCreate(); }, helpText: 'Staff must approve new customer accounts' },
        {name: 'enableFacebook', title: 'Enable Facebook', required: false, type: 'checkbox', visible: showSetting },
        {name: 'mailOnMemberCreate', title: 'Notify staff on new account registration', required: false, type: 'checkbox', visible: showSetting, helpText: 'Sent to the e-mail address in the company information' },
        {name: 'memberCancel', title: 'Let customers cancel training cards', required: false, type: 'checkbox', visible: showSetting },
        {name: 'periodOfNotice', title: 'Period of notice', required: true, type: 'infoNumber', info:'months', visible: function(field) { return showSetting(field) && hasMemberCancel(); } },
        {name: 'mailOnPurchase', title: 'Notify staff on webshop purchase', required: false, type: 'checkbox', visible: showSetting, helpText: 'Sent to the e-mail address in the company information' },
        {name: 'logo', title: 'Large logo', required: false, type: 'imagenoselection', visible: showSetting, helpText: 'Displayed on the homepage when logging in and on invoices' },
        {name: 'logosmall', title: 'Small logo', required: false, type: 'imagenoselection', visible: showSetting, helpText: 'Displayed on the top of the system' },
        {name: 'backgroundColor', title: 'Main color', required: false, type: 'color', visible: showSetting},
        {name: 'textColor', title: 'Text color', required: false, type: 'color', visible: showSetting},
        {name: 'sendSmsOrMail', title: 'Type of mailing at registration confirmation', type: 'button', buttonTitle: 'CLICK_TO_MANAGE_INFO', click: openWelcomeMailAutomaticMailing, visible: showSetting },
        {name: 'welcomeMail', title: 'Message in registration confirmation', type: 'button', buttonTitle: 'CLICK_TO_MANAGE_INFO', click: openWelcomeMailTemplate, visible: showSetting },
        {name: 'welcomeSMS', title: 'Message in welcome SMS', type: 'button', buttonTitle: 'CLICK_TO_MANAGE_INFO', click: openWelcomeMailTemplate, visible: function(field) { return showSetting(field) && $rootScope.hasModule('SMS'); } },
        {name: 'keep_userdata_time', title: 'Minimum time to keep user data', type: 'infoNumber', info: 'months', min: 1, visible: showSetting, required: true},
        {name: 'auto_remove_users', title: 'Automatically remove customers', type: 'checkbox', visible: showSetting, helpText: 'Automatically remove an account if no activity occurred during the specified time' },
        {name: 'economy_responsible_staff_group_toggle', title: 'Economy responsible group', type: 'checkbox', visible:showSetting, setValue: setGroupToggle, skipChangedCheck: true},
        {
            name: 'economy_responsible_group_id',
            title: 'Economy responsible group',
            required: false,
            type: 'group',
            useId: true,
            visible: showGroupList,
            helpText: 'Persons within the selected group will receive system notifications about e.g. failed payments (requires service bureau)'
        },
        {
            name: 'economy_responsible_staff_id',
            title: 'Economy responsible staff',
            required: false,
            type: 'customer',
            itemTypes: ['staff'],
            useId: true,
            visible: showGroupList,
            helpText: 'The selected person will receive system notifications about e.g. failed payments (requires service bureau)'
        },
        {name: 'show_getstarted', title: 'Visa Kom igång', type: 'checkbox' },
        { name: 'zoeziMyBusiness', title: 'Zoezi MyBusiness', type: 'select', required: true, useId: true, options: function() { return myBusiness; }, visible:showSetting },
        { name: 'integration_domains', title: 'Allow integrations from domains', type: 'text', visible: showSetting},
        { name: 'primary_domain', title: 'Primary domain', type: 'select', required: true, useId: true, options: () => primaryDomainOptions, visible: showSetting}
    ].map(function(f) {
        if (f.helpText) { f.placement = 'right'; }
        return f;
    });

    var submitLogo = function(file, logoId) {
        server.postFile('/api/image/set?type=Logo&id=' + logoId, file, 'The image was uploaded correctly', 'The image could not be uploaded');
    };

    $scope.submit = function() {
        var logo = _.findWhere($scope.fields, {name: 'logo'});
        var smallLogo = _.findWhere($scope.fields, {name: 'logosmall'});

        var logoF = logo && logo.value;
        var smallLogoF = smallLogo && smallLogo.value;

        var item = $scope.getSubmitItem();
        delete item.logo;

        $("#form").scope().form.$setPristine();
        delete logo.value;
        delete smallLogo.value;

        $scope.loadingStatus.loading = true;
        server.post($scope.postUrl, item, null, 'Settings saved', 'Failed to save settings').then(function() {
            $scope.afterSubmit();
        });

        if (logoF) {
            submitLogo(logoF, 1);
        }

        if (smallLogoF) {
            submitLogo(smallLogoF, 2);
        }
    };

    util.waitFor($scope, () => primaryDomainOptions.length > 0).then($scope.getSettings);

    live.subscribe({
        type: 'legal_entity',
        scope: $scope,
        callback: $scope.getSettings
    });
}]);

app.controller('SettingsLoginCtrl', ['$rootScope', '$scope', '$controller', function($rootScope, $scope, $controller) {
    $controller('SettingsCtrl', {$scope: $scope});

    $scope.getUrl = '/api/settings/get';
    $scope.postUrl = '/api/settings/change';

    function showSetting(field) {
        if ($scope.item && $scope.item.show_settings) {
            return $scope.item.show_settings[field.name];
        }
    }

    $scope.fields = [
        {type: 'alert', class: 'alert-info', value: 'Choose which login options are available for customers and staff.' },
        {name: 'member', title: 'Customers', type: 'label', labelClass: 'xlargefont' },
        {name: 'login_member_mail', title: 'E-mail or user name', type: 'checkbox', visible: showSetting },
        {name: 'login_member_bankid', title: 'Mobile BankID', type: 'checkbox', visible: showSetting },
        {name: 'login_member_facebook', title: 'Facebook', type: 'checkbox', visible: showSetting },
        {name: 'login_member_google', title: 'Google', type: 'checkbox', visible: showSetting },
        {name: 'login_member_apple', title: 'Apple', type: 'checkbox', visible: showSetting, helpText: 'APPLE_SIGN_IN_INFO', placement: 'right' },
        {name: 'staff', title: 'Staffs', type: 'label', labelClass: 'xlargefont' },
        {name: 'login_staff_mail', title: 'E-mail or user name', type: 'checkbox', visible: showSetting },
        {name: 'login_staff_bankid', title: 'Mobile BankID', type: 'checkbox', visible: showSetting },
        {name: 'login_staff_facebook', title: 'Facebook', type: 'checkbox', visible: showSetting },
        {name: 'login_staff_google', title: 'Google', type: 'checkbox', visible: showSetting },
        {name: 'login_staff_apple', title: 'Apple', type: 'checkbox', visible: showSetting, helpText: 'APPLE_SIGN_IN_INFO', placement: 'right' }
    ];

    $scope.canSubmit = function() {
        return $scope.fields.filter(function(f) {
            return f.name && f.name.startsWith('login_staff') && f.visible(f) && f.value;
        }).length;
    };

    $scope.getSettings();
}]);


app.controller('MemberPageSettingsCtrl', ['$rootScope', '$scope', '$controller', function($rootScope, $scope, $controller) {
    $controller('SettingsCtrl', {$scope: $scope});

    $scope.title = "Member page settings";
    $scope.getUrl = '/api/settings/memberpage/get';
    $scope.postUrl = '/api/settings/memberpage/change';

    $scope.views = [ {id: 'calendar', name: 'Calendar view'}, {id: 'list', name: 'List view'} ];

    var getViews = function() {
        return $scope.views;
    };

    var setView = function(field, value) {
        return _.findWhere($scope.views, {id: value || 'calendar'});
    };

    var getView = function(field) {
        return field.value && field.value.id;
    };

    $scope.fields = [
        {name: 'view', title: 'Default view group workout', type: 'select', options: getViews, required: true, setValue: setView, getValue: getView },
        {name: 'workouts', title: 'Content above Group workout', type: 'htmleditor' },
        {name: 'trainingcards', title: 'Content above Shop', type: 'htmleditor' },
        {name: 'register', title: 'Content above registration form', type: 'htmleditor' },
        {name: 'giftcards', title: 'Can use gift cards', type: 'checkbox' },
        {name: 'discounts', title: 'Can use discounts', type: 'checkbox' },
        {name: 'statistics', title: 'Show statistics', type: 'checkbox' },
        {name: 'family', title: 'Show family', type: 'checkbox' },
        {name: 'google_code', title: 'Google analytics code', type: 'text' }
    ];

    $scope.getSettings();
}]);

app.controller('SettingsCardPaymentCtrl', ['$rootScope', '$scope', '$controller', 'formatter', 'accounts', function($rootScope, $scope, $controller, formatter, accounts) {
    $controller('SettingsCtrl', {$scope: $scope});

    $scope.getUrl = '/api/settings/cardpayment/get';
    $scope.postUrl = '/api/settings/cardpayment/set';


    $scope.getNiceBankgiroNumber = function() {
        return formatter.format('bankgiroNumber', $scope.item.bankgiroNumber);
    };

    $scope.accountingFieldsVisible = function() {
        var isActivated = _.findWhere($scope.fields, { name: 'automaticStripeAccounting' }).value;
        return isActivated && $rootScope.hasModule('Accounting');
    };

    $scope.fields = [
        {type: 'alert', class: 'alert-info', value: 'CARDPAYMENTSETTINGS_INFO' },
        {name: 'bankgiroNumber', title: 'Bankgiro number for payouts', type: 'bankgiroNumber', required: true, getValue: function(f) { return $rootScope.normalizeBankgiroNumber(f.value); }, setValue: $scope.getNiceBankgiroNumber },
        {name: 'automaticStripeAccounting', title: 'Automatic disbursement accounting', type: 'checkbox', value: true },
        accounts.getFieldsRow($scope, $scope.accountingFieldsVisible, null, 'assetsdebts', null, 'accountingAccount', 'Account for disbursement'),
        accounts.getFieldsRow($scope, $scope.accountingFieldsVisible, null, 'assetsdebts', null, 'transactionCostAccount', 'Account for transaction costs'),
        {name: 'testmode', title: 'Test mode', type: 'checkbox', visible: function() { return $rootScope.currentStaff.superUser; } }
    ];

    $scope.getSettings();

    // Reupdate fields once accounts has been loaded
    $scope.$watch(function() { return $scope.accounts; }, function() {
        $scope.setValues($scope.item);
    });
}]);

app.controller('AdyenOnboardingSettingsCtrl', ['$rootScope', '$scope', '$controller', 'accounts', 'server', 'util', 'confirm', '$timeout', function($rootScope, $scope, $controller, accounts, server, util, confirm, $timeout) {
    $controller('SettingsCtrl', {$scope: $scope});

    $scope.getUrl = '/api/adyen/onboarding/settings/get';

    $scope.getResetButtonText = () => {
        return 'Återställ Zoezi Pay onboarding data';
    };

    $scope.showTestButtons = () => {
        return $rootScope.currentStaff.superUser && $rootScope.isTestSystem;
    };

    $scope.onboardingLinkValid = false;

    //Onboarding link is only valid for 15 minutes
    var startOnboardingLinkTimer = function() {
        if ($scope.onboardingLinkTimer) return

        $scope.onboardingLinkTimer = $timeout(function() {
            $scope.onboardingLinkValid = false;
        }, 880000);
    };

    var openOnboarding = () => {
        // Immediately open a new tab
        var newTab = window.open('about:blank', '_blank');

        server.get('/api/adyen/onboarding/onboarding-link/get')
            .then(response => {
                //newTab could be undefined in case the browser blocks the popup
                if (newTab) {
                    newTab.location.href = response.url;
                }

                $scope.onboardingLinkValid = true;
                $scope.onboardingLink = response.url;
                startOnboardingLinkTimer();
            })
            .catch(() => {
                newTab?.close(); // Close the tab in case of error
            });
    };

    $scope.resetAdyenOnboarding = () => {
        confirm.show('Är du säker på att du vill återställa Zoezi Pay-onboardingen?').then(function() {
            $scope.loadingStatus.resetting = true;
            server.post('/api/admin/adyen/onboarding/reset', null, null, 'Onboardingen är återställd', 'Återställningen av onboardingen misslyckades').then(() => {
                $scope.getSettings()
                $scope.loadingStatus.resetting = false;
            });
        });
    }

    $scope.addTosEvent = () => {
        $scope.loadingStatus.addingTosEvent = true;
        server.post('/api/adyen/onboarding/tos_event/add', null, null, 'TOS event added', 'Failed to add TOS event').then(() => {
            $scope.getSettings()
            $scope.loadingStatus.addingTosEvent = false;
        });
    }

    $scope.acceptTosEvent = () => {
        $scope.loadingStatus.acceptingTosEvent = true;
        server.post('/api/adyen/onboarding/tos_event/accept', null, null, 'TOS event accepted', 'Failed to accept TOS event').then(() => {
            $scope.getSettings()
            $scope.loadingStatus.acceptingTosEvent = false;
        });
    }

    $scope.submit2 = async () => {
        $scope.loadingStatus.loading = true;
        var item = $scope.getSubmitItem();
        let response = null
        response = await server.post('/api/adyen/onboarding/settings/set', item, null, 'Settings saved', 'Failed to save settings');
        $scope.getSettings()
        let validResponse = response ? response?.success : true;
        if ($scope.showBusinessSettings() && validResponse) {
            openOnboarding();
        }
        $scope.loadingStatus.loading = false;
    }

    $scope.getButtonText2 = () => $scope.buttonText || 'Start onboarding';
    $scope.showBusinessSettings = () => !['pending', 'completed', 'rejected'].includes($scope.item.status);
    $scope.showButton2 = () => $scope.showBusinessSettings();
    $scope.hideSubmitButton = () => true;

    $scope.button2class = () => {
        let phoneField = _.findWhere($scope.fields, {name: 'phone'});
        if (phoneField?.value) {
            return 'btn-success btn-block-mobile';
        } else {
            return 'btn-success btn-block-mobile disabled';
        }
    }

    $scope.statusText = () => {
        switch ($scope.item.status) {
            case 'start_onboarding':
                $scope.buttonText = 'Start onboarding';
                $scope.statusClass = 'alert-warning';
                return 'Onboarding not started';
            case 'not_started':
                $scope.buttonText = 'Start onboarding';
                $scope.statusClass = 'alert-warning';
                return 'Onboarding not started';
            case 'not_finished':
                $scope.buttonText = 'Start onboarding';
                $scope.statusClass = 'alert-warning';
                return 'Onboarding not finished';
            case 'pending':
                $scope.statusClass = 'alert-info';
                $scope.buttonText = 'Save settings';
                return 'Processing onboarding verification, please note that this process may take a few days to complete';
            case 'invalid':
                $scope.buttonText = 'Complete the onboarding';
                $scope.statusClass = 'alert-danger';
                return 'Onboarding not finished';
            case 'rejected':
                $scope.buttonText = 'Onboarding rejected';
                $scope.statusClass = 'alert-danger';
                return 'Onboarding rejected';
            case 'completed':
                $scope.buttonText = 'Save settings';
                $scope.statusClass = 'alert-success';
                return 'Onboarding completed';
            case 'tos_updated':
                $scope.buttonText = 'Go to terms of service';
                $scope.statusClass = 'alert-danger';
                return 'Terms of service have been updated and need to be accepted';
        }
    }

    function getInfoText () {
        if ($scope.item.status === 'tos_updated') {
            return 'ADYEN_ONBOARDING_TOS_UPDATED_MESSAGE';
        } else {
            return 'ADYEN_ONBOARDING_INFO';
        }
    }

    $scope.fields = [
        { name: 'info', type: 'alert', class: 'alert-info', getValue: getInfoText, visible: () => $scope.item.status != 'completed' },
        { type: 'alert', getClass: () => $scope.statusClass, getValue: $scope.statusText, visible: () => true },
        { name: 'phone', title: 'Phone number', required: true, type: 'phone', visible: () => true, helpText: 'ADYEN_PHONE_HELPTEXT' },
    ];

    var origSetValue = $scope.setValues;
    $scope.setValues = function(data) {
        origSetValue(data);
        var phoneField = _.findWhere($scope.fields, {name: 'phone'});
        phoneField.readonly = data.phone;
    };

    $scope.getSettings()
}]);

app.controller('AdyenAccountingSettingsCtrl', ['$rootScope', '$scope', '$controller', 'accounts', 'server', 'util', function($rootScope, $scope, $controller, accounts) {
    $controller('SettingsCtrl', {$scope: $scope});

    $scope.getUrl = '/api/adyen/accounting/accounts/get';
    $scope.postUrl = '/api/adyen/accounting/accounts/set';

    $scope.accountingFieldsVisible = () => $rootScope.hasModule('Accounting');

    $scope.fields = [
        accounts.getFieldsRow($scope, () => $rootScope.hasModule('Accounting'), null, 'assets', null, 'accountingAccount', 'Account for disbursement'),
        accounts.getFieldsRow($scope, () => $rootScope.hasModule('Accounting'), null, 'cost', null, 'transactionCostAccount', 'Account for transaction costs'),
    ];

    $scope.getSettings();
}]);

app.controller('RolesListCtrl', ['$rootScope', '$scope', '$controller', '$filter', '$modal', 'server', 'confirm', function($rootScope, $scope, $controller, $filter, $modal, server, confirm) {
    function change(role) {
        $modal.open({
            templateUrl: 'views/changemodal.html',
            controller: 'RoleChangeModalCtrl',
            resolve: {
                role: function() {
                    return role;
                }
            }
        });
    }

    function remove(role) {
        confirm.show('Are you sure you want to remove the role?', {ladda: true}).then(function(resolve) {
            server.post('/api/staff/roles/remove', null, {role: role.id }, '{0} was removed', 'Failed to remove {0}', 'Role').then(resolve);
        });
    }

    $scope.add = function() {
        $modal.open({
            templateUrl: 'views/addmodal.html',
            controller: 'RoleAddModalCtrl',
            resolve: {
                role: function() {
                    return null;
                }
            }
        });
    };

    function copy(role) {
        $modal.open({
            templateUrl: 'views/addmodal.html',
            controller: 'RoleAddModalCtrl',
            resolve: {
                role: function() {
                    return role;
                }
            }
        });
    }

    $scope.config = {
        getItems: function() {
            return $rootScope.roles;
        },
        countSuffixList: ['Role', 'Roles'],
        rowClick: change,
        triggers: ['role'],
        columns: [
            {field: 'name', title: 'Name', format: 'translated'}
        ],
        buttons: [
            {title: 'Change', buttonClass: 'btn-warning', onClick: change },
            {title: 'Copy', buttonClass: 'btn-info', onClick: copy },
            {title: 'Remove', buttonClass: 'btn-danger', onClick: remove, visible: function(role) { return role.id != 1; } }
        ]
    };
}]);

app.controller('PaymentAddCtrl', ['$rootScope', '$scope', '$controller', 'server', function($rootScope, $scope, $controller, server) {
    $controller('TableCtrl', {$scope: $scope});

    $scope.title = 'Payments';

    var getInvoiceDays = function(whenDone) {
        if (!$scope.invoicedays && $rootScope.hasModule('Invoice')) {
            server.get('/api/invoice/settings/get').then(function(result) {
                $scope.invoicedays = result.days;
                whenDone(result.days);
            });
        } else {
            whenDone($scope.invoicedays);
        }
    };

    $scope.createPayments = function(card, validFromDate, price, method, join_payments, to_date, already_paid, discount, customer, onetime_fee, onetime_fee_override) {
        if ($rootScope.hasModule('Admin') && card.payWhatYouWant) {
            $scope.data.payments = [];
            return;
        }

        $scope.data.payments = null;
        $scope.data.feeProduct = null;
        if(method && validFromDate && validFromDate.getFullYear() >= 2000 && price) {
            server.post2('/api/payment/generate', {
                cardtype_id: card.id,
                price: price,
                method: method,
                from_date: new Date(validFromDate.getFullYear(), validFromDate.getMonth(), validFromDate.getDate()),
                to_date: to_date,
                join: Boolean(join_payments),
                discount_id: discount?.id,
                user_id: customer?.id
            }).then(function(response) {
                if (already_paid) {
                    response.forEach(function(p) {
                        if (already_paid) {
                            var already_paid_for_this = Math.min(p.amount, already_paid);
                            p.amount -= already_paid_for_this;
                            already_paid -= already_paid_for_this;
                        }
                    });
                }

                $scope.data.payments = response.map(function(payment) {
                    //payment.readOnly = true;
                    if(!payment.amount) {
                        payment.paid = true;
                    }
                    return payment;
                });

                var feeProduct = onetime_fee_override ? onetime_fee : (onetime_fee || ($rootScope.hasFlag('flag-one-time-fee') && card.onetime_fee_product));
                $scope.data.feeProduct = (feeProduct && feeProduct.price && feeProduct.price > 0) ? feeProduct : null;
            });
        }
    };

    $scope.columns = [
        {field: 'date', title: 'Due date', visible: function() {return true;}, getValue: function(p) { return p.date.yyyymmdd(); } },
        {field: 'period', title: 'Period', visible: function() {return $scope.showPeriod;} },
        {field: 'discount', title: 'Discount', visible: function() {return $scope.showDiscount;}, titleSuffix: '(kr)' },
        {field: 'amount', title: 'Amount', visible: function() {return true;} }
    ];

    $scope.remove = function(payment) {
        var i = $scope.data.payments.indexOf(payment);
        $scope.data.payments.splice(i, 1);
    };

    var removeListener = $rootScope.$on('selectedTrainingCardChanged', function (event, info) {
        getInvoiceDays(function() {
            $scope.createPayments(info.card, info.date, info.price, info.method, info.join_payments, info.to_date, info.already_paid, info.discount, info.customer, info.onetime_fee, info.onetime_fee_override);
        });
    });

    $scope.$on('$destroy', function () {
        removeListener();
    });
}]);

app.controller('AppCtrl', ['$scope', '$location', function($scope, $location) {
    $scope.isSpecificPage = function() {
        var path = $location.path();
        return path.indexOf('/pages/') === 0 || path === '/404';
    };
}]);

app.controller('WorkScheduleAddModalCtrl', ['$rootScope', '$scope', '$controller', '$filter', 'options', 'server', 'confirm', 'alertProvider', function($rootScope, $scope, $controller, $filter, options, server, confirm, alertProvider) {
    $scope.loadingStatus = {};
    $scope.staffs = options.staffs;

    $scope.ws = {};

    $scope.ws.startsAt = Date.newTime('09:00');
    $scope.ws.endsAt = Date.newTime('17:00');

    $scope.breaks = [
        {start: Date.newTime("12:00"), end: Date.newTime("13:00")}
    ];

    $scope.days = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];
    $scope.intervals = ['Every week', 'Every second week', 'Every third week', 'Every fourth week'];

    $scope.ws.selectedDays = $scope.days;
    $scope.ws.selectedInterval = $scope.intervals[0];
    $scope.ws.fromDate = options.fromDate || new Date();
    $scope.ws.toDate = options.toDate || new Date().addDays(69);

    $scope.addbreak = {start: null, end: null};

    $scope.ws.selectedStaffs = options.selected || options.staffs;
    if ($rootScope.speedy) {
        $scope.ws.selectedStaffs = $scope.ws.selectedStaffs?.map($rootScope.getMember);
        $scope.selectableStaffs = $scope.ws.selectedStaffs;
    } else {
        $scope.selectableStaffs = $scope.staffs;
    }

    $scope.fields = [
        {name: 'resources', title: 'Resources', type: 'customers', itemTypes: [options.type || 'resource'], useId: true, value: $scope.ws.selectedStaffs, change: () => $scope.ws.selectedStaffs = $scope.fields[0].value }
    ];

    if ($rootScope.speedy) {
        server.get('/api/resource/get', {site_id: $rootScope.hasModule('MultiSite') ? $rootScope.selectedSite.id : null}).then(resources => {
            $scope.resources = resources;
        });
    } else {
        $scope.resources = $rootScope.staffs.filter(function (r) {
            return r.type == 'resource' && r.resourceType != 'schedule';
        });
    }

    $scope.canChangeAdvancedResourcePlanning = function() {
        if($scope.ws.selectedStaffs.length != 1) {return false;}
        if($scope.ws.selectedStaffs[0].resource) {return false;}
        if(!$rootScope.advancedResourcePlanning) {return false;}
        if(!$rootScope.hasPermission('Change advanced resource planning')) {return false;}
        return true;
    };

    var intersectsWith = function(b, times) {
        var s = b.start.hhmm();
        var e = b.end.hhmm();

        for (var i=0; i < times.length; ++i) {
            var ts = times[i].start.hhmm();
            var te = times[i].end.hhmm();

            var overlap = s < te && e > ts;
            if (overlap) {
                return true;
            }
        }
    };

    var breakIsOk = function(b, breaks) {
        if (!$scope.ws.startsAt) {
            return false;
        }

        if (!b.start || !b.end) {
            return false;
        }

        var endOk = !$scope.ws.endsAt || b.end.hhmm() < $scope.ws.endsAt.hhmm();

        return b.start.hhmm() < b.end.hhmm() &&
             b.start.hhmm() > $scope.ws.startsAt.hhmm() &&
             endOk &&
             !intersectsWith(b, breaks);
    };

    $scope.addBreakIsOk = function() {
        return breakIsOk($scope.addbreak, $scope.breaks);
    };

    var getAllBut = function(list, index) {
        var res = [];
        for (var i=0; i < list.length; ++i) {
            if (i != index) {
                res.push(list[i]);
            }
        }
        return res;
    };

    $scope.scheduleIsOk = function() {
        if (!$scope.ws.startsAt) {
            return false;
        }

        if(!$scope.ws.fromDate) {
            return false;
        }

        // From date is less than to date
        if ($scope.ws.fromDate > $scope.ws.toDate) {
            return false;
        }

        // Start of day less than end of day?
        if ($scope.ws.endsAt && $scope.ws.startsAt.hhmm() >= $scope.ws.endsAt.hhmm()) {
            return false;
        }

        // Check breaks
        for (var i=0; i < $scope.breaks.length; ++i) {
            var b = $scope.breaks[i];
            var otherBreaks = getAllBut(i);
            if (!breakIsOk(b, otherBreaks)) {
                return false;
            }
        }

        return true;
    };

    function normalizeBreaks() {
        var fd = $scope.ws.fromDate.yyyymmdd() + ' ';
        $scope.breaks = $scope.breaks.map(function(b) {
            return {
                start: Date.newFull(fd + b.start.hhmm()),
                end: Date.newFull(fd + b.end.hhmm())
            };
        });
    }

    $scope.addBreak = function() {
        $scope.breaks.push({start: Date.newFull($scope.ws.fromDate.yyyymmdd() + ' ' + $scope.addbreak.start.hhmm()), end: Date.newFull($scope.ws.fromDate.yyyymmdd() + ' ' + $scope.addbreak.end.hhmm())});
        normalizeBreaks();
    };

    $scope.removeBreak = function(b) {
        var i = $scope.breaks.indexOf(b);
        $scope.breaks.splice(i, 1);
    };

    var isDaySelected = function(day) {
        day--;
        if (day == -1) {
            day = 6;
        }
        return $scope.ws.selectedDays.indexOf($scope.days[day]) != -1;
    };

    $scope.doSubmit = function() {
        var workitems = [];

        var breaks = $filter('orderBy')($scope.breaks, 'start');

        var d = $scope.ws.fromDate.clone().clearTime();
        while (d <= $scope.ws.toDate) {
            if (isDaySelected(d.getDay())) {
                var workblock = {};
                workblock.start = Date.newFull(d.yyyymmdd() + ' ' + $scope.ws.startsAt.hhmm()).dateTime();
                for (var i=0; i < breaks.length; ++i) {
                    var b = breaks[i];
                    workblock.end = Date.newFull(d.yyyymmdd() + ' ' + b.start.hhmm()).dateTime();
                    if (workblock.start != workblock.end) {
                        workitems.push(workblock);
                    }
                    workblock = {};
                    workblock.start = Date.newFull(d.yyyymmdd() + ' ' + b.end.hhmm()).dateTime();
                }
                if (!$scope.ws.endsAt) {
                    workblock.end = d.clone().addDays(1).dateTime();
                } else {
                    workblock.end = Date.newFull(d.yyyymmdd() + ' ' + $scope.ws.endsAt.hhmm()).dateTime();
                }
                if (workblock.start != workblock.end) {
                    workitems.push(workblock);
                }
            }

            if (d.getDay() == 0) {
                if ($scope.ws.selectedInterval == $scope.intervals[1]) {
                    d.addDays(7);
                } else if ($scope.ws.selectedInterval == $scope.intervals[2]) {
                    d.addDays(14);
                } else if ($scope.ws.selectedInterval == $scope.intervals[3]) {
                    d.addDays(21);
                }
            }

            d.addDays(1);
        }

        var args = {staffs: _.pluck($scope.ws.selectedStaffs, 'id'), fromDate: $scope.ws.fromDate.yyyymmdd(), toDate: $scope.ws.toDate.yyyymmdd(), overwrite: !!$scope.ws.overwrite };
        if($scope.canChangeAdvancedResourcePlanning()) {
            args.allocated_resource = $scope.ws.allocatedResource && $scope.ws.allocatedResource.id || 'no';
        }
        if($scope.force) { args.force = true; }

        var successTitle = options.successTitle || 'Work schedule was added';
        var failedTitle = options.failedTitle || 'Failed to add work schedule';

        $scope.loadingStatus.loading = true;
        server.post('/api/staff/workschedule/add', workitems, args, successTitle, null).then(function(result) {
            if (result.success) {
                $scope.$close();
            } else {
                if (result.data.type == 'resource_is_busy') {
                    var resourceName = $rootScope.getStaff(result.data.args).name;
                    var message = $filter('translate')('ONEBUSY').format(resourceName);
                    confirm.show(message).then(function() {
                        $scope.force = true;
                        $scope.doSubmit();
                    });
                } else {
                    alertProvider.show('error', failedTitle);
                }
            }

            $scope.loadingStatus.loading = false;
        });
    };

    $scope.doClear = function() {
        var workitemsToClear = [];

        var d = $scope.ws.fromDate.clone().clearTime();
        while (d <= $scope.ws.toDate) {
            if (isDaySelected(d.getDay())) {
                var workblock = {};
                workblock.start = Date.newFull(d.yyyymmdd() + ' ' + $scope.ws.startsAt.hhmm()).dateTime();
                workblock.end = Date.newFull(d.yyyymmdd() + ' ' + $scope.ws.endsAt.hhmm()).dateTime();
                workitemsToClear.push(workblock);
            }
            d.addDays(1);
        }

        var ids = _.pluck($scope.ws.selectedStaffs, 'id').join(',');
        var args = {staffs: ids, fromDate: $scope.ws.fromDate.yyyymmdd(), toDate: $scope.ws.toDate.yyyymmdd() };

        var successTitle = options.successTitle || 'Work schedule was changed';
        var failedTitle = options.failedTitle || 'Failed to change work schedule';

        $scope.loadingStatus.loading = true;
        server.post('/api/staff/workschedule/clear', workitemsToClear, args, successTitle, failedTitle).then(function(result) {
            if (result.success) {
                $scope.$close();
            }
            $scope.loadingStatus.loading = false;
        });
    };

    $scope.submit = function(action) {
        action = action || 'add';
        if(action == 'clear') {
            confirm.show('Are you sure you want to clear work schedule?', {ladda: true}).then(function(resolve) {
                resolve();
                $scope.doClear();
            });
        } else if (($scope.addbreak.start && $scope.addbreak.end) && $scope.addBreakIsOk()) {
            confirm.show('You have unsaved breaks. Are you sure you want to continue?', {ladda: true}).then(function(resolve) {
                resolve();
                $scope.doSubmit();
            });
        } else {
            $scope.doSubmit();
        }
    };
}]);

app.controller('WorkScheduleChangeModalCtrl', ['$scope', '$controller', '$filter', '$http', 'options', 'server', '$rootScope', function($scope, $controller, $filter, $http, options, server, $rootScope) {
    $controller('WorkScheduleAddModalCtrl', {$scope: $scope, options: options});

    $scope.ws.selectedDays = $scope.days;
    $scope.ws.allocatedResource = [];

    $scope.loadWorkSchedule = function() {
        if (!$scope.ws.fromDate || $scope.ws.fromDate.getFullYear() < 1900 || !$scope.ws.toDate || $scope.ws.toDate.getFullYear() < 1900) {
            return;
        }
        var staffId = $scope.ws.selectedStaffs[0].id;
        if (!staffId) return;
        var fromDate = $scope.ws.fromDate.yyyymmdd();
        $scope.ws.toDate = $scope.ws.fromDate;
        var toDate = fromDate;

        $http.get('/api/staff/workschedule/get?staffs=' + staffId + '&fromDate=' + fromDate + '&toDate=' + toDate + '&allocation=' + $scope.canChangeAdvancedResourcePlanning() + '&site_id=' + $rootScope.selectedSite.id).success(function(response) {
            var workschedule;
            if($scope.canChangeAdvancedResourcePlanning()) {
                workschedule = response.result;
                if(response.allocation && response.allocation.length > 0) {
                    $scope.ws.allocatedResource = $rootScope.getStaff(response.allocation[0]);
                }
            } else {
                workschedule = response;
            }

            angular.forEach(workschedule, function(t) {
                t.start = Date.newFull(t.start);
                t.end = Date.newFull(t.end);
            });

            if (workschedule.length) {
                $scope.ws.startsAt = workschedule[0].start;
                $scope.ws.endsAt = workschedule[workschedule.length-1].end;
                if ($scope.ws.endsAt.getHours() == 0) {
                    $scope.ws.endsAt = null;
                }
                $scope.breaks = [];

                for (var i=1; i < workschedule.length; ++i) {
                    var bstart = workschedule[i-1].end;
                    var bend = workschedule[i].start;
                    $scope.breaks.push({start: bstart, end: bend});
                }
            } else {
                $scope.ws.startsAt = null;
                $scope.ws.endsAt = null;
                $scope.breaks = [];
            }
        });
    };

    $scope.freeDay = function() {
        var ids = _.pluck($scope.ws.selectedStaffs, 'id').join(',');
        var args = {staffs: ids, fromDate: $scope.ws.fromDate.yyyymmdd(), toDate: $scope.ws.fromDate.yyyymmdd(), overwrite: true };
        if($scope.canChangeAdvancedResourcePlanning()) {
            args.allocated_resource = 'no';
        }

        var successTitle = options.successTitle || 'Work schedule was changed';
        var failedTitle = options.failedTitle || 'Failed to change work schedule';

        $scope.loadingStatus.loading = true;
        server.post('/api/staff/workschedule/add', [], args, successTitle, failedTitle).then(function(result) {
            if (result.success) {
                $scope.$close();
            }

            $scope.loadingStatus.loading = false;
        });
    };

    $scope.loadWorkSchedule();
}]);

app.controller('PaymentModalCtrl', ['$rootScope', '$scope', '$controller', '$filter', 'payment', 'paymentMethods', 'confirm', function($rootScope, $scope, $controller, $filter, payment, paymentMethods, confirm) {
    $controller('ChangeModalCtrl', {$scope: $scope});

    $scope.payment = payment;
    $scope.item = payment;
    $scope.postUrl = '/api/payment/change';
    var discounts = [];

    $scope.titleSuffix = function() {
        return $filter('translate')('payment');
    };

    $scope.setPaymentMethod = function() {
        return _.findWhere(paymentMethods.get(), {id: $scope.item.method});
    };

    $scope.setAmount = function() {
        return (Number($scope.item.amount) + Number($scope.item.discount)).toFixed(2);
    };

    function getAmount() {
        var amount = _.findWhere($scope.fields, {name: 'amount'}).value || '';
        if (amount && typeof amount === 'string') {
            return Number(amount.replace(',', '.'));
        }
        return amount;
    }

    function totalPriceChanged() {
        var amount = getAmount();
        if (isNaN(amount)) {
            return;
        }
        var discount = 0;
        discounts = [];
        var discount_products = _.findWhere($scope.fields, {name: 'discounts'})?.value || [];
        discount_products.forEach(function(d) {
            if (d.source === 'price_rule') {
                // Price-rule discounts carry their concrete amount (computed by
                // the engine at checkout). The form's product-config recompute
                // doesn't apply — use the stored amount directly.
                var pr_amount = Number(d.amount);
                if (!isNaN(pr_amount)) {
                    discount += pr_amount;
                }
            } else if(d.payWhatYouWant) {
                var d_amount = _.findWhere($scope.fields, {name: 'flexibleDiscount'}).value;
                var discount_amount =  Number(_.isString(d_amount) ? d_amount.replace(',', '.') : d_amount);
                if (discount_amount) {
                    discounts.push({id: d.id, amount: discount_amount});
                    discount += discount_amount;
                }
            } else {
                var discount_amount = Number(d.discount_fixed) + (amount * (d.discount_percent / 100));
                discounts.push({id: d.id, amount: discount_amount});
                discount += discount_amount;
            }
        });
        discount = Math.min(discount, amount);
        _.findWhere($scope.fields, {name: 'discount'}).value = discount;
        _.findWhere($scope.fields, {name: 'toPay'}).value = amount - discount;
    }

    $scope.getPaymentStatus = function() {
        var s = $scope.payment.status;
        return $filter('translate')(s.charAt(0).toUpperCase() + s.slice(1));
    };

    $scope.getClass = function() {
        var statuses = {'paid': 'text-success', 'pending': 'text-danger', 'sent': 'text-warning'};
        return statuses[$scope.payment.status];
    };

    $scope.getPayer = function(field) {
        return field.value.id;
    };

    $scope.setPayer = function() {
        return $scope.payment.payer;
    };

    $scope.canChangePayment = function() {
        return $scope.payment.status == 'pending';
    };

    $scope.amountIsZero = function() {
        return getAmount() == 0;
    };

    $scope.isValidAmount = function() {
        return !isNaN(getAmount());
    };

    var readonly = !$scope.canChangePayment();

    var isInvoice = function() {
        var method = _.findWhere($scope.fields, {name: 'method'});
        return method.value && (method.value.id == 'invoice' || method.value.id == 'einvoice');
    };

    var isNotInvoice = function() {
        return !isInvoice();
    };

    var sendDateChanged = function() {
        var origSendDate = $scope.payment.date.clone().addDays(-$scope.payment.days);
        var sendDate = _.findWhere($scope.fields, {name: 'sendDate'}).value;
        return !Date.dateEquals(origSendDate, sendDate);
    };

    function hasSavedCard() {
        return $rootScope.getMember(_.findWhere($scope.fields, {name: 'payer_id'}).value).hasSavedCardForSelectedLegalEntity();
    }

    // Depricated (?)
    function isDiscount() {
        var product = _.findWhere($rootScope.trainingcardtypes, {id: payment.cardtype_id});
        if (product && product.discount && Number(product.discount_fixed) > 0) {
            return true;
        }
    }

    function hasDiscounts() {
        return (_.findWhere($scope.fields, {name: 'discounts'}).value || []).length > 0;
    }

    $scope.canSubmit = function() {
        var method = _.findWhere($scope.fields, {name: 'method'}).value.id;
        return (method != 'stripe' || hasSavedCard()) && $scope.isValidAmount();
    };

    $scope.submit = function() {
        var item = $scope.getSubmitItem();
        item.discounts = discounts;
        if (item.method == 'invoice' || item.method == 'einvoice') {
            item.date = _.findWhere($scope.fields, {name: 'sendDate'}).value.clone().addDays(item.days).yyyymmdd();
        }
        if (hasDiscounts()) {
            item.amount = item.amount-Number(_.findWhere($scope.fields, {name: 'discount'}).value );
        }

        if (item.method == 'stripe' && Date.newFull(item.date).isPastDate(true)) {
            confirm.show('CHARGENOWCONFIRM').then(function() {
                $scope.doSubmit(item);
            });
        } else {
            $scope.doSubmit(item);
        }
    };

    function getDiscountProducts() {
        var products = $rootScope.trainingcardtypes.filter(function(p) { return p.active && p.type == 'discount'; });
        // Surface price-rule entries on this payment as multiselect options so the
        // readonly label and form binding can render them by name. They use the
        // PriceRule.id namespace; collisions with TrainingCardType ids are
        // possible in principle but unseen in practice for discount products.
        (payment.discounts || []).forEach(function(d) {
            if (d && d.source === 'price_rule') {
                products.push({id: d.id, name: d.name, source: 'price_rule', amount: d.amount});
            }
        });
        return products;
    }

    function hasFlexibleDiscount() {
        var discount_products = _.findWhere($scope.fields, {name: 'discounts'}).value || [];
        return discount_products.some(function(d) {
            return d.payWhatYouWant === true;
        });
    }

    $scope.fields = [
        {name: 'status', title: 'Payment status', required: true, type: 'label', getValue: $scope.getPaymentStatus, getClass: $scope.getClass },
        {name: 'site_id', title: 'Site', required: true, type: 'select', options: () => $rootScope.sites, useId: true, readonly: readonly, visible: function() { return $rootScope.hasModule('MultiSite'); } },
        {name: 'sendDate', title: 'Invoice date', required: true, type: 'date', readonly: readonly, visible: isInvoice, changed: sendDateChanged },
        {name: 'date', title: 'Due date', required: true, type: 'date', readonly: readonly, visible: isNotInvoice },
        {name: 'method', title: 'Payment method', required: true, type: 'paymentmethod', setValue: $scope.setPaymentMethod, readonly: readonly, hasSavedCard: hasSavedCard, options: {change: true} },
        {name: 'days', title: 'Payment terms', required: true, type: 'infoNumber', info: 'days', readonly: readonly, visible: isInvoice, min: 1 },
        {name: 'count', title: 'Count', required: true, type: 'number', readonly: readonly, min: 0.00001, allowDecimals: true, visible: function() {return !!$scope.item.trainingcard_id;} },
        {name: 'amount', title: 'Amount', required: true, type: 'price', setValue: $scope.setAmount, readonly: readonly, change: totalPriceChanged ,visible: function() { return !isDiscount(); } },
        {name: 'payer_id', title: 'Payer', required: true, type: 'customer', getValue: $scope.getPayer, setValue: $scope.setPayer, readonly: readonly },
        {name: 'comment', title: 'Comment', required: false, type: 'textarea', readonly: readonly },
        {name: 'discounts', title: 'Discounts', change: totalPriceChanged, type: 'multiselect', options: getDiscountProducts, useId: true, placeholder: 'No discount', readonly: readonly },
        {name: 'flexibleDiscount', title: 'Flexible discount', type: 'price', change: totalPriceChanged, visible: function() { return hasFlexibleDiscount(); }, readonly: readonly},
        {name: 'discount', title: 'Total discount', readonly: true, type: 'label', format: 'price', visible: hasDiscounts },
        {name: 'toPay', title: 'To pay', type: 'label', format: 'price' }
    ];


    var changeCtrlSetValues = $scope.setValues;
    $scope.setValues = function(item) {
        changeCtrlSetValues(item);
        var discounts_products = item.discounts || [];
        discounts_products.forEach(function(d) {
            var discount = _.findWhere($rootScope.trainingcardtypes, {id: d.id});
            if (discount.payWhatYouWant) {
                _.findWhere($scope.fields, {name: 'flexibleDiscount'}).value = d.amount;
            }
        });
    };
    $scope.setValues($scope.payment);
    totalPriceChanged();

    if ($scope.payment.method == 'invoice' || $scope.payment.method == 'einvoice') {
        _.findWhere($scope.fields, {name: 'sendDate'}).value = $scope.payment.date.clone().addDays(-$scope.payment.days);
    }
}]);

app.controller('PaymentAddModalCtrl', ['$rootScope', '$scope', '$controller', '$filter', 'customer', 'server', 'paymentMethods', 'confirm', 'util', function($rootScope, $scope, $controller, $filter, customer, server, paymentMethods, confirm, util) {
    $controller('AddCtrl', {$scope: $scope});

    $scope.postUrl = '/api/payment/add';
    $scope.title = 'Add payment';
    $scope.successTitle = 'Payment added';
    $scope.failedTitle = 'Failed to add payment';
    $scope.loadingStatus = {loading: false};
    var discounts = [];

    var getInvoiceDays = function(whenDone) {
        if (!$scope.invoicedays && $rootScope.hasModule('Invoice')) {
            server.get('/api/invoice/settings/get').then(function(result) {
                $scope.invoicedays = result.days;
                whenDone();
            });
        } else {
            whenDone();
        }
    };

    $scope.submit = function() {
        var item = $scope.getSubmitItem();
        item.member_id = customer.id;
        item.createTrainingCard = true;
        item.discounts = discounts;
        item.discount = Number((Number(item.amount) - Number(item.topay)).toFixed(2));
        item.amount = item.topay;
        delete item.topay;

        if (item.method == 'invoice' || item.method == 'einvoice') {
            item.date = _.findWhere($scope.fields, {name: 'sendDate'}).value.clone().addDays(item.days).yyyymmdd();
        }

        var doSubmit = function() {
            var items = [item];
            $scope.loadingStatus.loading = true;
            server.post($scope.postUrl, items, null, $scope.successTitle, $scope.failedTitle).then(function(result) {
                if (result.success) {
                    $scope.$close();
                } else {
                    $scope.loadingStatus.loading = false;
                }
            });
        };

        if (item.method == 'stripe') {
            confirm.show('CHARGENOWCONFIRM').then(doSubmit);
        } else {
            doSubmit();
        }
    };

    $scope.getPayer = function(field) {
        return field.value.id;
    };

    $scope.setInitialValues = function() {
        var payer = $rootScope.getMember(customer.paidBy || customer.id);
        var method = paymentMethods.getDefaultForCustomer(payer);

        var ddd = util.getBillingDate();

        _.findWhere($scope.fields, {name: 'sendDate'}).value = Date.today();
        _.findWhere($scope.fields, {name: 'date'}).value = (method.id == 'directdebit') ? ddd : Date.today();
        _.findWhere($scope.fields, {name: 'method'}).value = method;
        _.findWhere($scope.fields, {name: 'payer_id'}).value = payer;
        _.findWhere($scope.fields, {name: 'days'}).value = $scope.invoicedays;
        _.findWhere($scope.fields, {name: 'count'}).value = 1;
        _.findWhere($scope.fields, {name: 'site_id'}).value = $rootScope.sites.find(site => site.id == $rootScope.selectedSite.id);
    };

    var onMethodChange = function() {
        var method = _.findWhere($scope.fields, {name: 'method'}).value;
        var newDate = Date.today();
        if (method.id == 'directdebit') {
            newDate = util.getBillingDate();
        }

        _.findWhere($scope.fields, {name: 'date'}).value = newDate;
    };

    var isInvoice = function() {
        var method = _.findWhere($scope.fields, {name: 'method'});
        return method.value && (method.value.id == 'invoice' || method.value.id == 'einvoice');
    };

    var isNotInvoice = function() {
        return !isInvoice();
    };

    function getAmount() {
        var amount = _.findWhere($scope.fields, {name: 'amount'})?.value || '';
        if (amount && typeof amount === 'string') {
            return Number(amount.replace(',', '.'));
        }
        return amount;
    }

    $scope.canSubmit = function() {
        return !isNaN(getAmount());
    };

    function totalPriceChanged() {
        var amount = getAmount();
        if (isNaN(amount)) {
            return;
        }
        var discount = 0;
        discounts = [];
        var discount_products = _.findWhere($scope.fields, {name: 'discounts'}).value || [];
        discount_products.forEach(function(d) {
            if(d.payWhatYouWant) {
                var d_amount = _.findWhere($scope.fields, {name: 'flexibleDiscount'}).value;
                var discount_amount =  Number(_.isString(d_amount) ? d_amount.replace(',', '.') : d_amount);
                if (discount_amount) {
                    discounts.push({id: d.id, amount: discount_amount});
                    discount += discount_amount;
                }
            } else {
                var discount_amount = Number(d.discount_fixed) + (amount * (d.discount_percent / 100));
                discounts.push({id: d.id, amount: discount_amount});
                discount += discount_amount;
            }
        });
        discount = Math.min(discount, amount);
        _.findWhere($scope.fields, {name: 'discount'}).value = discount;
        _.findWhere($scope.fields, {name: 'topay'}).value = amount - discount;
    }

    function setPrice() {
        var cardtype =_.findWhere($scope.fields, {name: 'cardtype_id'}).value;
        if (!cardtype) { return; }
        var newAmount = _.findWhere($scope.fields, {name: 'count'}).value * cardtype.price;
        if (Number.isNaN(newAmount)) { return; }
        _.findWhere($scope.fields, {name: 'amount'}).value = newAmount;
        totalPriceChanged();
    }

    var variants;
    function setVariants() {
        var product = _.findWhere($scope.fields, {name: 'cardtype_id'}).value;
        var initial;
        variants = product.variants || [];
        variants.forEach(function(variant) {
            var stock = variant.stock;
            if (_.isNumber(stock)) {
                if (stock === 0) {
                    variant.title = variant.name + ' - ' + util.t('Sold out');
                    return;
                }
            }

            variant.title = variant.name;
            if (!initial) {
                initial = variant;
            }
        });
        _.findWhere($scope.fields, {name: 'variant'}).value = initial;
    }

    function getVariants() {
        return variants;
    }

    var onProductChange = function() {
        setVariants();
        setPrice();
        if (_.findWhere($scope.fields, {name: 'amount'}).value == "0") {
            _.findWhere($scope.fields, {name: 'amount'}).value = undefined;
        }
    };

    var getCardType = function(p) {
        return p.value.id;
    };

    var isNotValueCard = function(p) {
        return !p.valuecard && !p.giftcard;
    };

    var productFilter = function(p) {
        return isNotValueCard(p) && !p.membership;
    };

    var hasSavedCard = function() {
        var payer = _.findWhere($scope.fields, {name: 'payer_id'}).value;
        return payer.hasSavedCardForSelectedLegalEntity();
    };

    var hasMoney = function() {
        var payer = _.findWhere($scope.fields, {name: 'payer_id'}).value;
        var amount = util.parseDecimal(_.findWhere($scope.fields, {name: 'amount'}).value);
        if (isNaN(amount)) {
            return false;
        }
        return payer.getValueCardAmountForSelectedLegalEntity() >= amount;
    };

    var outOfStock = function() {
        var product = _.findWhere($scope.fields, {name: 'cardtype_id'});
        product = product && product.value;
        if (product && product.stock != null) {
            var count = _.findWhere($scope.fields, {name: 'count'}).value;

            if ($scope.hasVariants()) {
                var variant = _.findWhere($scope.fields, {name: 'variant'});
                if (variant && variant.value) {
                    return _.isNumber(variant.value.stock) && variant.value.stock < count;
                }
            } else {
                return product.stock < count;
            }
        }
    };

    $scope.additionalFormCheck = function() {
        if (outOfStock()) {
            return false;
        }

        var method = _.findWhere($scope.fields, {name: 'method'});
        if (method && method.value) {
            if (method.value.id == 'valuecard') {
                return hasMoney();
            } else if (method.value.id == 'stripe') {
                return hasSavedCard();
            }
            return true;
        }
    };

    $scope.hasVariants = function() {
        var product = _.findWhere($scope.fields, 'cardtype_id').value;
        if (product) {
            return product.needs_to_choose_variant();
        }

        return false;
    };

    function dateValid(d) {
        let f = Date.newFull(d.validFromDate);
        let t = Date.newFull(d.validToDate);
        return f && f.isPastDate(true) && (!t || t.isFutureDate(true));
    }

    function getDiscounts() {
        return $rootScope.trainingcardtypes.filter(function(t) { return t.discount && t.active && dateValid(t); });
    }

    function hasDiscounts() {
        return (_.findWhere($scope.fields, {name: 'discounts'}).value || []).length > 0;
    }

    function hasFlexibleDiscount() {
        var discount_products = _.findWhere($scope.fields, {name: 'discounts'}).value || [];
        return discount_products.some(d => d.payWhatYouWant);
    }

    function showInvoiceFreeText() {
        var payMethod = _.findWhere($scope.fields, {name: 'method'}).value;
        return payMethod && payMethod.id === 'invoice';
    }

    getInvoiceDays(function() {
        $scope.fields = [
            {name: 'cardtype_id', title: 'Product', required: true, type: 'select', options: $rootScope.getActiveProducts, optionsFilter: productFilter, change: onProductChange, getValue: getCardType },
            {name: 'site_id', title: 'Site', required: true, type: 'select', options: () => $rootScope.sites, useId: true, visible: function() { return $rootScope.hasModule('MultiSite'); } },
            {name: 'variant', title: 'Product variant', required: true, type: 'select', options: getVariants, visible: $scope.hasVariants, getValue: function(f) { return f.value.name; }, getName: function(f) { return f.title;} },
            {name: 'method', title: 'Payment method', required: true, type: 'paymentmethod', change: onMethodChange, options: {create: true}, hasSavedCard: hasSavedCard, hasMoney: hasMoney },
            {name: 'comment', title: 'Product comment', required: false, type: 'textarea' },
            {name: 'sendDate', title: 'Invoice date', required: true, type: 'date', visible: isInvoice },
            {name: 'days', title: 'Payment terms', required: true, type: 'infoNumber', info: 'days', visible: isInvoice, min: 1 },
            {name: 'date', title: 'Due date', required: true, type: 'date', visible: isNotInvoice },
            {name: 'count', title: 'Count', required: true, type: 'number', min: 0.00001, allowDecimals: true, change: setPrice },
            {name: 'amount', title: 'Amount', required: true, type: 'price', change: totalPriceChanged },
            {name: 'payer_id', title: 'Payer', required: true, type: 'customer', getValue: $scope.getPayer },
            {name: 'invoiceExtraInfo', title: 'Invoice comment (max 150 characters)', required: false, visible: showInvoiceFreeText, type: 'textarea', maxlength: 150 },
            {hint: 'Not enough products in stock', hintClass: 'alert-danger', visible: outOfStock},
            {name: 'discounts', title: 'Discount', type: 'multiselect', options: getDiscounts, useId: true, change: totalPriceChanged, visible: function() { return getDiscounts().length; }, placeholder: 'No discount' },
            {name: 'flexibleDiscount', title: 'Flexible discount', type: 'price', visible: hasFlexibleDiscount, change: totalPriceChanged},
            {name: 'discount', title: 'Total discount', readonly: true, type: 'label', format: 'price', visible: hasDiscounts},
            {name: 'topay', title: 'To pay', type: 'label', format: 'price'}
        ];
        $scope.setInitialValues();
    });
}]);

app.controller('RefillValueCardCtrl', ['$rootScope', '$scope', '$controller', '$filter', '$location', 'customer', 'server', 'cashiers', 'paymentMethods', function($rootScope, $scope, $controller, $filter, $location, customer, server, cashiers, paymentMethods) {
    $controller('AddCtrl', {$scope: $scope});
    $scope.loadingStatus = {};

    $scope.title = 'Refill value card';

    $scope.submit = function() {
        $scope.loadingStatus.loading = true;
        var item = $scope.getSubmitItem();
        var args = { member: customer.id,  payer: item.payer_id, method: item.method, amount: item.amount, site_id: $rootScope.selectedSite.id };
        server.post('/api/payment/refillValueCard', null, args, 'Payment added', 'Failed to add payment').then(function(result) {
            if (result.success) {
                $scope.$close();
            }
            $scope.loadingStatus.loading = false;
        });
    };

    $scope.refillInCheckout = function() {
        var item = $scope.getSubmitItem();
        var method = _.findWhere($scope.fields, {name: 'method'}).value;
        var valuecard = _.findWhere($rootScope.getActiveProducts(), {valuecard: true});
        cashiers.transfer({customer: customer, purchase: true, method: method, basket: [{product: valuecard, count: 1, payWhatYouWant: true, price: item.amount}] });
        // StaffNext hydration: customer + a single product line. The wire
        // format is the JSON-encoded `items=` from urlSync.ts.
        var search = {};
        if (customer && customer.id) search.customer_id = customer.id;
        search.items = JSON.stringify([{k: 'p', id: valuecard.id, c: 1, p: item.amount}]);
        $location.path('/checkout').search(search);
        $scope.$close();
    };

    $scope.getPayer = function(field) {
        return field.value.id;
    };

    $scope.setInitialValues = function() {
        var payer = $rootScope.getMember(customer.paidBy || customer.id);
        _.findWhere($scope.fields, {name: 'payer_id'}).value = payer;
        _.findWhere($scope.fields, {name: 'method'}).value = _.findWhere(paymentMethods.getRefillValueCard(), {id: 'bank'});
    };

    $scope.fields = [
        {name: 'amount', title: 'Amount', required: true, type: 'price' },
        {name: 'payer_id', title: 'Payer', required: true, type: 'customer', getValue: $scope.getPayer },
        {name: 'method', title: 'Payment method', required: true, type: 'paymentmethod', options: {refill: true} }
    ];

    $scope.setInitialValues();
}]);

app.controller('RepayValueCardCtrl', ['$rootScope', '$scope', '$controller', '$filter', '$location', 'customer', 'server', 'cashiers', 'paymentMethods', 'BankAccount', 'confirm', 'util', function($rootScope, $scope, $controller, $filter, $location, customer, server, cashiers, paymentMethods, BankAccount, confirm, util) {
    $controller('AddCtrl', {$scope: $scope});

    var firstDateAccounting;

    function isClosedDate() {
        if(firstDateAccounting) {
            return _.findWhere($scope.fields, {name: 'date'}).value < firstDateAccounting;
        }
    }

    const args = {legal_entity_id: $rootScope.selectedSite.legal_entity_id };
    server.get('/api/economy/accounting/next', args).then(function(response) {
        if(response.next) {
            firstDateAccounting = Date.newFull(response.next.substring(0, 10));
        }
    });

    $scope.title = 'Repay value card';
    $scope.loadingStatus = {};

    var getCustomer = function() {
        return _.findWhere($scope.fields, {name: 'customer'}).value;
    };

    $scope.submit = function() {
        $scope.loadingStatus.loading = true;
        var item = $scope.getSubmitItem();
        var args = {
            member: item.customer,
            method: item.method,
            date: item.date,
            amount: item.amount,
            bankaccount: item.bankaccount,
            nearest_date: item.nearest,
            site_id: $rootScope.selectedSite.id
        };

        function doSubmit() {
            server.post('/api/payment/repayValueCard', args, null, 'Payment added', 'Failed to add payment').then(function(result) {
                if (result.success) {
                    $scope.$close();
                }
                $scope.loadingStatus.loading = false;
            });
        }

        if(isClosedDate()) {
            confirm.show('MARKASPAID_ACCOUNTING_WARNING').then(function() {
                doSubmit();
            }).catch(function() {
                $scope.loadingStatus.loading = false;
            });
        } else {
            doSubmit();
        }
    };

    $scope.repayInCheckout = function() {
        var item = $scope.getSubmitItem();
        var method = _.findWhere($scope.fields, {name: 'method'}).value;
        var valuecard = _.findWhere($rootScope.getActiveProducts(), {valuecard: true});
        var c = getCustomer();
        cashiers.transfer({customer: c, purchase: false, method: method, basket: [{product: valuecard, count: 1, payWhatYouWant: true, price: item.amount}] });
        // StaffNext hydration. `purchase: false` opens the new checkout in
        // refund mode via the `refund=1` query param. Wire format is the
        // JSON-encoded `items=` from urlSync.ts.
        var search = { refund: '1' };
        if (c && c.id) search.customer_id = c.id;
        search.items = JSON.stringify([{k: 'p', id: valuecard.id, c: 1, p: item.amount}]);
        $location.path('/checkout').search(search);
        $scope.$close();
    };

    $scope.hasMoney = function() {
        var customer = getCustomer();
        var amount = util.parseDecimal(_.findWhere($scope.fields, {name: 'amount'}).value);
        if (isNaN(amount)) {
            return false;
        }
        // Check value card amount for current legal entity
        var valueCardAmount = 0;
        if (customer && customer.value_card_amounts && $rootScope.selectedSite) {
            valueCardAmount = customer.value_card_amounts[$rootScope.selectedSite.legal_entity_id] || 0;
        }
        return valueCardAmount >= amount && amount > 0;
    };

    function getField(name) {
        return _.findWhere($scope.fields, {name: name});
    }

    function isBankMethod() {
        var method = getField('method').value;
        return method && method.id == 'bank';
    }

    function visibleIfAutoPayouts() {
        return $rootScope.hasModule('Payout') && isBankMethod() && !$rootScope.isSettingMissing('Payout');
    }

    $scope.additionalFormCheck = function() {
        return $scope.hasMoney();
    };

    $scope.setInitialValues = function() {
        // Get value card amount for current legal entity
        var valueCardAmount = 0;
        if (customer && customer.value_card_amounts && $rootScope.selectedSite) {
            valueCardAmount = customer.value_card_amounts[$rootScope.selectedSite.legal_entity_id] || 0;
        }

        _.findWhere($scope.fields, {name: 'customer'}).value = customer;
        _.findWhere($scope.fields, {name: 'money'}).value = valueCardAmount;
        _.findWhere($scope.fields, {name: 'amount'}).value = valueCardAmount;
        _.findWhere($scope.fields, {name: 'method'}).value = _.findWhere(paymentMethods.getRefillValueCard(), {id: 'bank'});
    };

    function chooseBankAccount() {
        BankAccount.selectDialog(getCustomer()).then(function(account) {
            getField('bankaccount').value = account;
        });
    }

    $scope.fields = [
        {name: 'customer', title: 'Customer', required: true, type: 'customer' },
        {name: 'money', title: 'Value card', type: 'price', readonly: true},
        {name: 'amount', title: 'Amount', required: true, type: 'price' },
        {name: 'method', title: 'Payment method', required: true, type: 'paymentmethod', options: {refill: true} },
        {name: 'nearest', title: 'Nearest possible day', required: false, type: 'checkbox', visible: visibleIfAutoPayouts },
        {name: 'date', title: 'Payment date', required: true, type: 'date', value: Date.today(), visible: function() { return !getField('nearest').value; } },
        {name: 'bankaccount', title: 'Account', required: true, visible: visibleIfAutoPayouts, type: 'customobject', useId: true,
            getName: function() { return this.value.fullname; }, buttonClick: chooseBankAccount, buttonTitle: 'Choose' },
        {name: '_', hint: 'REPAY_VALUECARD_HINT', hintClass: 'alert-info', visible: function() { return !visibleIfAutoPayouts(); } },
        {name: '_', hint: 'REPAY_VALUECARD_BANK_HINT', hintClass: 'alert-info', visible: function() { return visibleIfAutoPayouts() && getField('nearest').value; } }
    ];

    $scope.setInitialValues();

    $scope.$watch(getCustomer, function(customer) {
        // Get value card amount for current legal entity
        var valueCardAmount = 0;
        if (customer && customer.value_card_amounts && $rootScope.selectedSite) {
            valueCardAmount = customer.value_card_amounts[$rootScope.selectedSite.legal_entity_id] || 0;
        }
        _.findWhere($scope.fields, {name: 'money'}).value = valueCardAmount;
        _.findWhere($scope.fields, {name: 'amount'}).value = valueCardAmount;
    });
}]);

app.controller('ProductAddModalCtrl', ['$rootScope', '$scope', '$controller', '$filter', 'image', 'server', 'paymentMethods', 'productCategoryService', 'accounts', 'modalUtils', 'options', function($rootScope, $scope, $controller, $filter, image, server, paymentMethods, productCategoryService, accounts, modalUtils, options) {
    $controller('ProductChangeModalCtrl', {$scope: $scope, product: options.product });
    $scope.postUrl = '/api/trainingcard/type/add';
    $scope.title = 'Add';
    $scope.skipPriceCheck = true;
    $scope.itemType = options.product.type;
    $scope.successMessage = "{0} was added";
    $scope.failMessage =  "Failed to add {0}";

    $scope.titleSuffix = function() {
        if(options.product.giftcard){
            return $filter('translate')('gift card');
        }
        if(options.product.membership){
            return $filter('translate')('membership');
        }
        if(options.product.punchcard){
            return $filter('translate')('punch card');
        }
        return $filter('translate')('product');
    };

    var isMembership = function() {
        return options.product.membership;
    };

    if (isMembership()) {
        $scope.$getGuide = function() {
            var gfe = function(name) { return _.findWhere($scope.fields, { name: name }).element; };
            var steps = [{
                element: gfe('name'),
                popover: {
                    title: 'Membership name',
                    description: 'Usually, "Membership" works just fine'
                }
            }, {
                element: gfe('price'),
                popover: {
                    title: 'Membership price'
                }
            }, {
                element: gfe('fixedTime'),
                popover: {
                    title: 'Is it a permanent annual membership or does it depend on when it is obtained?'
                }
            }, {
                element: gfe('auto'),
                popover: {
                    title: 'Automatically renews the customers\'s membership after the validity period has passed'
                }
            }, {
                element: gfe('account'),
                popover: {
                    title: 'Accounting account for membership'
                }
            }, {
                element: gfe('costcenter_id'),
                popover: {
                    title: 'Should the transactions be accounted against a specific unit?'
                }
            }, {
                element: gfe('customerCanBuy'),
                popover: {
                    title: 'Shows the membership in the web shop',
                    description: 'One can go in and buy a membership in the web shop with this activated'
                }
            }, {
                element: gfe('product_webshop_category_id'),
                popover: {
                    title: 'Where in the shop should the membership be displayed?',
                    description: 'The category you choose determines which heading the membership falls under in the web shop. We recommend the existing category "Membership", but you can also create your own in the settings and change later.'
                },
                visible: function() { return _.findWhere($scope.fields, { name: 'customerCanBuy' }).value; }
            }, {
                element: gfe('methods'),
                popover: {
                    title: 'Specify which payment methods can be used to obtain a membership'
                }
            }, {
                element: gfe('stockB'),
                popover: {
                    title: 'Do you have a fixed number of memberships?',
                    description: 'If this is filled in, the product will not be visible if the stock runs out.'
                }
            }, {
                element: gfe('separate_invoice'),
                popover: {
                    title: 'Makes the membership always end up on its own invoice, even if more products are bought at the same time.'
                }
            }, {
                element: gfe('product_category_id'),
                popover: {
                    title: 'Choose which category the membership should belong to at checkout',
                    description: 'You can create your own categories under Settings > General > Categories.'
                }
            }, {
                element: modalUtils.getModalElement('.modal-footer > button:first-of-type'),
                popover: {
                    title: 'Save'
                },
                skipStartOnClick: true
            }];
            return { steps: steps, onFinish: $rootScope.possiblyGoToGetStarted };
        };
    }
}]);

app.controller('DiscountDataCtrl', ['$rootScope', '$scope', 'productCategoryService', 'options', function($rootScope, $scope, productCategoryService, options) {

    function productFilter(product) {
        var categories = $scope.config.control.getField('discount_condition.product_categories').value.map(function(c) {
            return c.id || c;
        });
        return categories.length == 0 || categories.includes(product.product_webshop_category_id);
    }

    function serviceFilter(rb) {
        var categories = $scope.config.control.getField('discount_condition.service_categories').value.map(function(c) {
            return c.id || c;
        });
        return categories.length == 0 || categories.includes(rb.category_id);
    }

    var isStock = function() {
        return $scope.config.control.getField('stockB').value;
    };

    var setStock = function() {
        return options.item?.stock != null;
    };

    var getStock = function() {
        if (isStock()) {
            return $scope.config.control.getField('stock').value;
        } else {
            return null;
        }
    };

    function discountCodeAlreadyInUse() {
        var items = $rootScope.trainingcardtypes.filter(t => t.discount_code == $scope.config.control.getField('discount_code').value && $scope.config.control.getField('discount_code').value);
        if(items && options.item?.id && items.some(i => i.id == options.item?.id) && items.length == 1){
            return false;
        }else if(items.length > 0){
            return true;
        }else{
            return false;
        }
    }

    $scope.periodTypes = [
        {id: 'months', name: 'Certain number of months'},
        {id: 'date', name: 'Until a certain date'}
    ];

    $scope.config = _.deep_extend(options.config, {
        datatype: 'discount',
        url: {
            add: '/api/trainingcard/type/add',
            change: '/api/trainingcard/type/change',
            copy: '/api/trainingcard/type/add'
        },
        initCallChange: true,
        tabs: [
            {
                name: 'General',
                fields: [
                    {name: 'name', title: 'Name', required: true, type: 'text' },
                    {name: 'payWhatYouWant', title: 'Pay What You Want', required: false, type: 'checkbox', value: false },
                    {name: 'discount_fixed', title: 'Discount', required: true, type: 'price', value: 0, visible: '!payWhatYouWant' },
                    {name: 'discount_percent', title: 'Discount', required: true, type: 'percent', value: 0, min: 0, max: 100, visible: '!payWhatYouWant' },
                    {name: 'discount_code', title: 'Discount code', required: false, type: 'text', helpText: 'DISCOUNT_CODE_DESC' },
                    {name: 'discount_hint', hintClass: 'alert-danger', hint: 'Discount code already in use', visible: discountCodeAlreadyInUse},

                    productCategoryService.makeSelectField(),
                    {name: 'imagekey', title: 'Image', type: 'field', field: 'image-storage', option: {originType: 'product', imageOnly: true, squareThumbnail: true}},
                    {name: 'validFromDate', title: 'Valid from', required: false, type: 'date', value: Date.today() },
                    {name: 'validToDate', title: 'Valid to', required: false, type: 'date' }
                ]
            },
            {
                name: 'Limitations',
                fields: [
                    {value: 'The discount can be used on', type: 'label', wide: true, format: 'translated'},

                    {name: 'discount_condition.trainingcards', title: 'Training cards', required: false, type: 'checkbox'},
                    {name: 'discount_condition.trainingcard_list', title: 'Select training cards', required: false, type: 'multiselect', options: $rootScope.getActiveTrainingCards, optionsFilter: function(p) { return !p.trainingsessions; }, useId: true, placeholder: 'No limit', visible: 'discount_condition.trainingcards'},
                    {name: 'discount_condition.memberships', title: 'Memberships', required: false, type: 'checkbox'},
                    {name: 'discount_condition.membership_list', title: 'Select memberships', required: false, type: 'multiselect', options: function() { return $rootScope.trainingcardtypes;}, optionsFilter: function(p) { return p.active && p.membership; }, useId: true, placeholder: 'No limit', visible: 'discount_condition.memberships'},
                    {name: 'discount_condition.punchcards', title: 'Punch cards', required: false, type: 'checkbox'},
                    {name: 'discount_condition.punchcard_list', title: 'Select punch cards', required: false, type: 'multiselect', options: $rootScope.getActiveTrainingCards, optionsFilter: function(p) { return p.trainingsessions; }, useId: true, placeholder: 'No limit', visible: 'discount_condition.punchcards'},
                    {name: 'discount_condition.products', title: 'Products', required: false, type: 'checkbox'},
                    /*{name: 'discount_condition.product_categories', title: 'Filtrera på kategori', required: false, type: 'multiselect', options: $rootScope.getActiveTrainingCards, useId: true, placeholder: 'All categories', visible: 'discount_condition.products'},*/
                    productCategoryService.makeSelectField({name: 'discount_condition.product_categories', title: 'Filter on category', visible: function() { return $scope.config.control.getField('discount_condition.products').value; }, webshop: true, multiple: true, placeholder: 'All categories'}),
                    {name: 'discount_condition.product_list', title: 'Select products', required: false, type: 'multiselect', options: $rootScope.getActiveProducts, optionsFilter: productFilter, useId: true, placeholder: 'No limit', visible: 'discount_condition.products'},
                    {name: 'discount_condition.courses', title: 'Courses', required: false, type: 'checkbox'},
                    {name: 'discount_condition.course_categories', title: 'Filter on category', required: false, type: 'multiselect', options: function() { return $rootScope.coursecategories; }, optionsFilter: function(c) { return c.active; }, useId: true, placeholder: 'All categories', visible: 'discount_condition.courses'},
                    /*{name: 'discount_condition.course_list', title: 'Välj vilka kurser rabatten ska gälla på (funkar ej)', required: false, type: 'multiselect', options: $rootScope.getActiveTrainingCards, useId: true, placeholder: 'No limit', visible: 'discount_condition.courses'},*/
                    {name: 'discount_condition.services', title: 'Services', required: false, type: 'checkbox'},

                    {name: 'stockB', title: 'Limited amount', required: false, type: 'checkbox', setValue: setStock, skipChangedCheck: true },
                    {name: 'stock', title: 'Count', required: false, type: 'number', getValue: getStock, visible: isStock, invisibleValue: null, nullIsValue: true },
                    {name: 'discount_condition.service_categories', title: 'Filter on category', required: false, type: 'multiselect', options: function() { return $rootScope.resourcebookingcategories; }, optionsFilter: function(c) { return c.active; }, useId: true, placeholder: 'All categories', visible: 'discount_condition.services'},
                    {name: 'discount_condition.service_list', title: 'Choose which services the discount should apply to', required: false, type: 'multiselect', options: function() { return $rootScope.resourcebookingservices; }, optionsFilter: serviceFilter, useId: true, placeholder: 'No limit', visible: 'discount_condition.services'},

                    {
                        name: 'discount_condition.period_limit',
                        title: 'Which period',
                        required: false,
                        type: 'select',
                        options: () => $scope.periodTypes,
                        placeholder: 'The discount is valid for the whole period',
                        useId: true
                    },
                    {
                        name: 'discount_condition.period_months',
                        title: 'Number of months',
                        required: true,
                        type: 'number',
                        visible: () => $scope.config.control.getField('discount_condition.period_limit')?.value?.id == 'months'
                    },
                    {
                        name: 'discount_condition.period_date',
                        title: 'Applies to payments up to and including date',
                        required: true,
                        type: 'date',
                        visible: () => $scope.config.control.getField('discount_condition.period_limit')?.value?.id == 'date'
                    }
                ]
            },
            {
                name: 'Customer requirements',
                fields: [
                    {
                        name: 'discount_condition.user_status',
                        title: 'Customer status',
                        type: 'multiselect',
                        options: () => $rootScope.memberstatuses,
                        useId: true,
                        placeholder: 'No limit',
                        hint:'STATUS_INFO_HINT'
                    }
                ]
            }
        ],
        init: function() {
            if (!options.item) {
                return {
                    discount_fixed: 0,
                    discount_percent: 0,
                    validFromDate: Date.today(),
                    discount_condition: {
                        trainingcards: true,
                        memberships: true,
                        punchcards: true,
                        products: true,
                        courses: true,
                        services: true
                    }
                };
            }
        },
        getSubmitItem: function() {
            var item = $scope.config.control.getSubmitItem();
            if(!item.stockB) {item.stock = null;}
            delete item.stockB;
            item.discount = true;
            item.vat = 0;
            item.customerCanBuy = false;
            item.showSelfCheckout = false;
            return item;
        },
        canSubmit: () => {
            let from = $scope.config.control.getField('validFromDate').value;
            let to = $scope.config.control.getField('validToDate').value;
            return (!to || to >= from) && !discountCodeAlreadyInUse();
        }
    });
}]);

app.controller('ProductListCtrl', ['$rootScope', '$scope', '$modal', '$filter', '$timeout', 'server', 'formatter', 'modalUtils', 'util', function($rootScope, $scope, $modal, $filter, $timeout, server, formatter, modalUtils, util) {
    var getImage = function(product) {
        return $rootScope.image('Product', product, 100);
    };

    $scope.change = function(product) {
        if (!product.discount && $rootScope.isProduct(product) && !product.giftcard && !product.membership) {
            util.showDataDialog({controller: 'ProductDataCtrl', item: product});
        } else {
            if (product.discount) {
                util.showDataDialog({controller: 'DiscountDataCtrl', item: product});
            } else if (product.type == 'resourcebooking') {
                util.showDataDialog({controller: 'ResourceBookingCardDataCtrl', item: product});
            } else {
                $modal.open({
                    templateUrl: 'views/changemodal.html',
                    controller: ($rootScope.isProduct(product) ? 'ProductChangeModalCtrl': 'TrainingCardTypeChangeModalCtrl'),
                    resolve: {
                        product: function() {
                            return product;
                        },
                        trainingCardType: function() {
                            return product;
                        }
                    }
                });
            }
        }
    };

    $scope.addProduct = function() {
        util.showDataDialog({controller: 'ProductDataCtrl'});
    };

    $scope.copyProduct = function(p) {
        var copy = angular.copy(p)
        delete copy.id;
        copy.variants = copy.variants.map(({id, ...modifiedVariants}) => modifiedVariants);
        util.showDataDialog({controller: 'ProductDataCtrl', item: copy });
    };

    $scope.copyDiscount = function(d) {
        var copy = angular.copy(d)
        delete copy.id;
        delete copy.discount_code;
        util.showDataDialog({controller: 'DiscountDataCtrl', item: copy});
    };

    $scope.addPunchCard = function(){
        util.showDataDialog({controller: 'ResourceBookingCardDataCtrl'})
    };

    $scope.copyPunchCard = function(rb){
        var copy = angular.copy(rb);
        delete copy.id;
        util.showDataDialog({controller: 'ResourceBookingCardDataCtrl', item: copy})
    }

    $scope.addGiftCard = function() {
        $modal.open({
            templateUrl: 'views/addmodal.html',
            controller: 'ProductAddModalCtrl',
            resolve:  {
                options: function() {
                    return {product: {
                        giftcard: true,
                        validTime: 120,
                        type: 'giftcard'
                        }
                    };
                }
            }
        });
    };

    $scope.copyGiftCard = function(gf){
        $modal.open({
            templateUrl: 'views/addmodal.html',
            controller: 'ProductAddModalCtrl',
            resolve: {
                options: function() {
                    var copy = angular.copy(gf);
                    delete copy.id;
                    delete copy.barcode;
                    return { product: copy };
                }
            }
        })
    }

    $scope.addMembership = function() {
        $modal.open({
            templateUrl: 'views/addmodal.html',
            controller: 'ProductAddModalCtrl',
            resolve:  {
                options: function() {
                    return { product: {
                        membership: true,
                        mode: 'add',
                        vat: _.findWhere($rootScope.valueAddedTax, {id: '0'}),
                        type: 'membership'
                        }
                    };
                }
            }
        });
    };

    $scope.copyMembership = function(mb){
        $modal.open({
            templateUrl: 'views/addmodal.html',
            controller: 'ProductAddModalCtrl',
            resolve: {
                options: function(){
                    var copy = angular.copy(mb);
                    delete copy.id;
                    delete copy.barcode;
                    copy.membership = true;
                    copy.mode = 'copy';
                    return {membership: true, product: copy};
                }
            }
        })
    }

    $scope.addDiscount = function() {
        util.showDataDialog({controller: 'DiscountDataCtrl'});
    };

    $scope.addTrainingCard = function() {
        $modal.open({
            templateUrl: 'views/addmodal.html',
            controller: 'TrainingCardTypeAddCtrl',
            resolve: {
                trainingCardType: function() {
                    return {
                        vat: _.findWhere($rootScope.valueAddedTax, {id: '6'}),
                        validTime: 1,
                        validType: 'Year',
                        priceType: 'Month',
                        customerCanBuy: true,
                        showSelfCheckout: true,
                        workout: true,
                        entry: true
                    };
                }
            }
        });
    };

    $scope.copyTrainingCard = function(tc) {
        $modal.open({
            templateUrl: 'views/addmodal.html',
            controller: 'TrainingCardTypeAddCtrl',
            resolve: {
                trainingCardType: function() {
                    var copy = angular.copy(tc);
                    delete copy.id;
                    delete copy.barcode;
                    return copy;
                }
            }
        });
    };

    var getTrainingSessions = function(card) {
        if (!card.trainingsessions) {
            return $filter('translate')('Unlimited');
        }

        return card.trainingsessions;
    };

    var getValidTo = function(card) {
        var validTo = "";
        if (card.validType) {
            validTo = card.validTime + " " + $filter('translate')(card.validType + (card.validTime == 1 ? "" : "s"));
        } else if (card.period) {
            let periodDays = 0;
            let validFromDate = Date.newFull(card.periodValidFrom);
            let validToDate = Date.newFull(card.periodValidTo);
            if (!isNaN(validFromDate) && !isNaN(validToDate)) {
                periodDays = Math.floor((validToDate - validFromDate) / (1000 * 60 * 60 * 24));
            }
            validTo =  periodDays + " " + $filter('translate')("days");
        } else {
            validTo = $filter('translate')('Unlimited');
        }
        return validTo;
    };

    var getBoundTo = function(card) {
        var boundTo = "";
        if (card.boundType) {
            boundTo = card.boundTime + " " + $filter('translate')(card.boundType + (card.boundTime == 1 ? "" : "s"));
        } else {
            boundTo = $filter('translate')('No');
        }
        return boundTo;
    };

    var getPrice = function(p) {
        if (p.payWhatYouWant) {
            return $filter('translate')('Optional');
        } else {
            var suffix = '';
            if (p.priceType && p.priceType != 'OneTime') {
                suffix = ' / ' + $filter('translate')(p.priceType);
            }
            return formatter.format('price', p.price) + suffix;
        }
    };

    function visibleColumn(config, column) {
        if (config.context && config.context.columns) {
            return config.context.columns.indexOf(column.field) != -1 && !(column.field == 'vat' && $rootScope.vatexempt);
        }
    }

    function getDiscount(product) {
        var d = '';
        if (product.discount && Number(product.discount_percent) > 0) {
            d += product.discount_percent + ' %';
        }
        if (product.discount && Number(product.discount_fixed) > 0) {
            if (d.length) {
                d += ', ';
            }
            d += formatter.format('price', product.discount_fixed);
        }
        if (product.payWhatYouWant) {
            return $filter('translate')('Pay What You Want');
        }
        return d;
    }

    function canActivateCard(t, config) {
        if(config.name !== 'Inactive') {return false;}
        if(t.resourcebookingservice && !t.resourcebookingservice.active) {return false;}
        return true;
    }

    function getStockForSite(product, site_id) {
        var stock;
        (product.variants || []).forEach(function(v) {
            var ps = _.findWhere(v.stock_sites, {site_id: site_id});
            if (ps && ps.stock) {
                if (!stock) {
                    stock = 0;
                }
                stock += ps.stock;
            }
        });
        return stock;
    }

    function getStockForSelectedSite(product) {
        return getStockForSite(product, $rootScope.selectedSite.id);
    }

    function showStockPerSite(config, column) {
        return visibleColumn(config, column) && $rootScope.stockPerSite;
    }

    function getStock(product) {
        var stock;
        (product.variants || []).forEach(function(v) {
            v.stock_sites.forEach(function(ps) {
                if (ps && ps.stock && ($rootScope.stockPerSite || ps.site_id == 1)) {
                    if (!stock) {
                        stock = 0;
                    }
                    stock += ps.stock;
                }
            });
        });
        return stock;
    }

    var showAllProducts = false;
    function toggleShowAllProducts() {
        showAllProducts = !showAllProducts;
        $scope.productsConfig.control.update();
    }

    $scope.productsConfig = {
        getItems: function() {
            return $rootScope.trainingcardtypes;
        },
        triggers: ['trainingcardtype', 'image'],
        filter: $rootScope.hasModule('MultiSite') ? [
            {name: 'showAllProducts', title: 'Show products from all sites', required: false, type: 'checkbox', change: toggleShowAllProducts, visible: function() { var tab = $scope.productsConfig.control && $scope.productsConfig.control.getActiveTab(); return tab && tab.name == 'Products'; } }
        ] : undefined,
        tabs: [
            {name: 'Memberships', badgeClass: 'badge-success', visible: function() { return $rootScope.hasModule('Membership'); }, itemFilter: function(product) { return product.active && product.membership; }, context: { columns: ['image', 'name', 'price', 'vat', 'customerCanBuy'] } },
            {name: 'Training cards', badgeClass: 'badge-success', visible: function() { return $rootScope.main.brand != 'Lokalsystem'; }, itemFilter: function(product) { return product.active && $rootScope.isTrainingCard(product) && product.type !== 'resourcebooking'; }, context: { columns: ['image', 'name', 'price', 'vat', 'customerCanBuy', 'stock', 'trainingsessions', 'validTime', 'boundTime', 'trial'] } },
            {name: 'Products', badgeClass: 'badge-success', itemFilter: function(product) { return (product.active && $rootScope.isProduct(product) && !product.discount && !product.valuecard && !product.giftcard && !product.membership && (showAllProducts || $rootScope.productVisibleForSite(product))) || product.misc || product.reminderRate || product.reminderFee || product.invoiceFee; }, context: { columns: ['image', 'name', 'price', 'vat', 'customerCanBuy', 'stock', 'stock_per_site'] } },
            {name: 'Gift cards and value cards', badgeClass: 'badge-success', itemFilter: function(product) { return product.active && product.giftcard || product.valuecard; }, context: { columns: ['image', 'name', 'stock'] } },
            {name: 'Discounts', badgeClass: 'badge-success', itemFilter: function(product) { return product.active && product.discount; }, context: { columns: ['image', 'name', 'discount', 'stock'] } },
            {name: 'Resource booking', badgeClass: 'badge-success', itemFilter: function(product) { return product.active && product.resourcebookingservice && product.resourcebookingservice.active && product.resourcebookingservice.category.active; }, visible: function() { return $rootScope.hasPermission('Resource booking'); }, context: { columns: ['image', 'name', 'price', 'trainingsessionsrb'] } },
            {name: 'Inactive', itemFilter: function(product) { return !product.active; }, context: { columns: ['image', 'name'] } },
        ],
        countSuffix: function() {
            return 'products';
        },
        rowClick: $scope.change,
        columns: [
            {field: 'image', title: '', src: getImage, visible: visibleColumn },
            {field: 'name', title: 'Name', format: 'translated', visible: visibleColumn },
            {field: 'price', title: 'Price incl. VAT', getValue: getPrice, visible: visibleColumn },
            {field: 'vat', title: 'VAT', format: 'percentNoMult', visible: visibleColumn },
            {field: 'customerCanBuy', title: 'Show in web shop', format: 'bool', visible: visibleColumn },
            {field: 'trainingsessions', title: 'Training sessions', getValue: getTrainingSessions, visible: visibleColumn },
            {field: 'trainingsessionsrb', title: 'Sessions', getValue: getTrainingSessions, visible: visibleColumn },
            {field: 'validTime', title: 'Valid for', getValue: getValidTo, visible: visibleColumn },
            {field: 'boundTime', title: 'Bound for', getValue: getBoundTo, visible: visibleColumn },
            {field: 'trial', title: 'Trial card', format: 'bool', visible: visibleColumn },
            {field: 'discount', title: 'Discount', visible: visibleColumn, getValue: getDiscount },
            {field: 'stock', title: 'Count', visible: visibleColumn, getValue: getStock },
            {field: 'stock_per_site', title: 'Count this site', visible: showStockPerSite, getValue: getStockForSelectedSite }
        ],
        buttons: [
            { title: 'Copy', buttonClass: 'btn-info', onClick: $scope.copyMembership, visible: function(t, config) { return config.name == 'Memberships'}},
            { title: 'Copy', buttonClass: 'btn-info', onClick: $scope.copyTrainingCard, visible: function(t, config) { return config.name == 'Training cards'}},
            { title: 'Copy', buttonClass: 'btn-info', onClick: $scope.copyProduct, visible: function(t, config) { return config.name == 'Products'}},
            { title: 'Copy', buttonClass: 'btn-info', onClick: $scope.copyGiftCard, visible: function(t, config) { return config.name == 'Gift cards and value cards'}},
            { title: 'Copy', buttonClass: 'btn-info', onClick: $scope.copyPunchCard, visible: function(t, config) { return config.name == 'Resource booking'}},
            { title: 'Copy', buttonClass: 'btn-info', onClick: $scope.copyDiscount, visible: function(t, config) { return config.name == 'Discounts'}},
            { title: 'Change', buttonClass: 'btn-warning', onClick: $scope.change },
            { title: 'Activate', buttonClass: 'btn-success', visible: canActivateCard, onClick: function(t) { modalUtils.activateModal(t, t.name, 'ACTIVATE_PRODUCT_MESSAGE', '/api/trainingcard/type/change'); } },
            { title: 'Inactivate', buttonClass: 'btn-danger', visible: function(t, config) { return config.name == 'Training cards'; }, onClick: function(t) { modalUtils.inactivateModal(t, t.name, 'REMOVE_TRAININGCARD_MESSAGE', '/api/trainingcard/type/change'); } },
            { title: 'Inactivate', buttonClass: 'btn-danger', visible: function(t, config) { return (!t.resourcebookingservice_id || !t.service_base_product) && config.name != 'Training cards' && config.name != 'Inactive' && !t.reminderRate && !t.reminderFee && !t.misc && !t.rounding && !t.invoiceFee && !t.valuecard; }, onClick: function(t) { modalUtils.inactivateModal(t, t.name, 'REMOVE_PRODUCT_MESSAGE', '/api/trainingcard/type/change'); } }
        ],
        orderColumn: 'name',
        searchButtons: [
            { title: 'Add new membership', visible: function(config) { return config.name == 'Memberships'; }, onClick: $scope.addMembership, showOnEmpty: true },
            { title: 'Add new training card', visible: function(config) { return config.name == 'Training cards'; }, onClick: $scope.addTrainingCard, showOnEmpty: true },
            { title: 'Add new product', onClick: $scope.addProduct, visible: function(config) { return config.name == 'Products'; }, showOnEmpty: true },
            { title: 'Add new gift card', onClick: $scope.addGiftCard, visible: function(config) { return config.name == 'Gift cards and value cards'; }, showOnEmpty: true },
            { title: 'Add discount', onClick: $scope.addDiscount, visible: function(config) { return config.name == 'Discounts'; }, showOnEmpty: true },
            { title: 'Add new punch card', visible: function(config) { return config.name == 'Resource booking'; }, onClick: $scope.addPunchCard, showOnEmpty: true }
        ],
        onInit: function() {
            var tabname = $rootScope.hasModule('Membership') ? 'Memberships' : 'Training cards';
            var tab = _.findWhere($scope.productsConfig.tabs, {name: tabname});
            $scope.productsConfig.control.setActiveTab(tab);
        }
    };

    $scope.membershipsettings = function() {
        return [{
            element: $scope.productsConfig.control.getTab('Memberships').config.control.element.select('.searchFieldRow button'),
            popover: {
                title: 'Add new membership',
                closeBtnText: 'Next'
            },
            closeOnClick: true
        }];
    };

    $scope.gotomembershipsettings2 = function() {

        var startNext = function() {
            $scope.pubsub.publish('startGuide', true);
            if (!modalUtils.modalsExist()) {
                $scope.addMembership();
            }
        };

        $timeout(function() {
            $scope.$startGuide('membershipsettings').then(function() {
                $timeout(startNext);
            });
        }, 250);
    };

    var cancelGuideWatch = $scope.$watch('$registerGuide', function() {
        if (!$scope.$registerGuide) { return; }
        cancelGuideWatch();

        $scope.$registerGuide({ id: 'membershipsettings', title: 'Add new membership', tab: 'Memberships', steps: $scope.membershipsettings, hidden: true });
        $scope.$registerGuide({ id: 'gotomembershipsettings2', title: 'Add new membership', tab: 'Memberships', redirect: $scope.gotomembershipsettings2 });
    });

    $scope.pubsub('selectedSite', function() {
        if ($scope.productsConfig.control) {
            $scope.productsConfig.control.update();
        }
    });
}]);

app.controller('GetCustomerCtrl', ['$rootScope', '$scope', '$modal', '$filter', 'server', 'options', 'live', 'util', 'confirm', 'alertProvider', 'ApiDataLoader', function($rootScope, $scope, $modal, $filter, server, options, live, util, confirm, alertProvider, ApiDataLoader) {
    $scope.isGetCustomerCtrl = true;
    $scope.multiple = options.multiple;
    $scope.itemTypes = options.itemTypes || ['customer'];
    $scope.itemType = $scope.itemTypes[0];
    var loadingStatus = {report: []};
    if (options.multiple) {
        $scope.itemType += 's';
    }

    $scope.title = $filter('translate')('Choose') + ' ' + $filter('translate')($scope.itemType);
    $scope.selected = [];

    if (options.multiple && options.selected) {
        $scope.selected = [];
        options.selected.forEach(function(u) {
           u = $rootScope.getMember(u.id);
           if (u) {
                $scope.selected.push(u);
           }
        });
    }

    function setSelected(customer) {
        let i = $scope.selected.findIndex(x => x.id == customer.id);
        if (i == -1) {
            if (!$scope.primaryFilter(customer)) {
                return;
            }
            $scope.selected.push(customer);
            $scope.tableConfig.control.update();
            $scope.chosenConfig.control.update();
        }
    }

    function removeSelected(customer) {
        let i = $scope.selected.findIndex(x => x.id == customer.id);
        if (i != -1) {
            $scope.selected.splice(i, 1);
            $scope.tableConfig.control.update();
            $scope.chosenConfig.control.update();
        }
    }

    var onCustomerSelected = function(user) {
        if(options.multiple) {
            setSelected(user);
        } else {
            $scope.$close($rootScope.getMember(user));
        }
    };

    var waitForNewCustomer = function(customerId) {
        util.waitForNewObject(customerId, function(id) { return _.findWhere($rootScope.members, {id: id}); }, 'user').then(onCustomerSelected);
    };

    function isSelected(m) {
        return $scope.selected.some(x => x.id == m.id);
    }

    function isNotSelected(m) {
        return !isSelected(m);
    }

    function allInGroupNotSelected(g) {
        if ($rootScope.speedy) {
            return g.users.some(isNotSelected);
        } else {
            return g.users.some(id => isNotSelected({id}))
        }
    }

    function onGroupSelected(group) {
        group.users.forEach(function(u) {
            onCustomerSelected($rootScope.getMember(u));
        });
        var tab = $scope.tableConfig.tabs.find(x => x.name == 'Chose group');
        $scope.tableConfig.control.setActiveTab(tab);
    }

    function changeGroup(group) {
        util.showDataDialog({controller: 'UserGroupDataCtrl', item: group });
    }

    function onReportSelected(report) {
        loadingStatus.report[report.id] = true;
        server.post('/api/stats/generic', {report_id: report.id, include_id: false }).then((res) => {
            if(res?.data?.row_count > 0) {
                res?.data?.data?.forEach((u) => {
                    onCustomerSelected($rootScope.getMember(u.id));
                })
            } else {
                alertProvider.show('error', 'Report contains no customers');
            }
            loadingStatus.report[report.id] = false;
        })
    }

    $scope.selectAll = function() {
        if ($scope.tableConfig && $scope.tableConfig.control) {
            const visibleItems = $scope.tableConfig.control.getActiveTab().config.control.getFilteredItems();
            visibleItems.forEach(function(u) {
                if (isNotSelected(u)) {
                    onCustomerSelected(u);
                }
            });
        }
    };

    if (options.multiple && options.unsavedCheck !== false) {
        $scope.unsavedCheck = $scope.$on('modal.closing', function(event, reason, closed) {
            if (!closed && $scope.valuesChanged()) {
                event.preventDefault();
                confirm.show('You have unsaved changes. Are you sure you want to close?').then(function() {
                    $scope.unsavedCheck();
                    $scope.$dismiss();
                });
            }
        });
    }

    $scope.valuesChanged = function() {
        const old = (options.selected || []).map(x => x.id);
        const current = $scope.selected.map(x => x.id);
        return old.length != current.length || !old.every(id => current.includes(id));
    };

    var customerConfig;
    if ($rootScope.speedy) {
        customerConfig = {
            filter: [
                {name: 'sites', title: 'Sites', required: false, type: 'multiselect', visible: function() { return $rootScope.hasModule('MultiSite'); }, options: function() { return $rootScope.sites; }, useId: true, placeholder: 'All', value: $rootScope.limitStaffSiteAccess && $rootScope.selectedSite ? [$rootScope.selectedSite] : [] },
                {name: 'query', title: 'Search', required: true, type: 'text' },
            ],
            filterButtons: [
                { title: 'Add new customer', onClick: () => $rootScope.showCombo({callback: waitForNewCustomer})},
                { title: 'Select all', onClick: $scope.selectAll, visible: function() { return $scope.multiple } }
            ],
            hideSearch: true,
            api: {
                url: '/api/search',
                post: true,
                args: {
                    types: [{type: 'user', searchFields: ['name', 'mail', 'phone', 'firstname', 'lastname', 'personalCodeNumber', 'memberNumber', 'card.cardId', 'oldphone', 'city', 'address', 'zipCode'], resultFields: ['id', 'name', 'imageurl', 'imagekey', 'phone', 'mail', 'allowPush']}],
                    limit: 20
                },
                getItemsFromResponse: response => response.data.find(x => x.type == 'user').items,
                transform: i => {
                    i.type = 'user';
                }
            },
            hideSearchCount: true,
            countSuffixList: ['customer', 'customers'],
            showSum: false,
            columns: [
                { field: 'image', title: '' },
                { field: 'name', title: 'Name' },
                { field: 'mail', title: 'E-mail', visible: function(config) { return config.name != 'Choose resource' && !$rootScope.isSmallScreen(); } },
                { field: 'phone', title: 'Phone', visible: function(config) { return config.name != 'Choose resource' && $(window).width() >= 1200; } },
                { field: 'memberNumber', title: 'Member number', visible: function(config) { return $rootScope.hasMemberNumber && config.name != 'Choose resource'; } }
            ],
            rowClick: onCustomerSelected,
            orderColumn: 'name',
            buttons: [
                { title: 'Choose', onClick: onCustomerSelected, visible: isNotSelected },
                { title: 'Remove', buttonClass: 'btn-danger', onClick: removeSelected, visible: isSelected }
            ]
        };

        // Watch customerConfig.searchText
        $scope.$watch(() => customerConfig.searchText, function() {
            if (customerConfig.control) {
                customerConfig.control.updateApi();
            }
        });
    }

    var groupConfig = {
        getItems: function() {
            return $rootScope.usergroups;
        },
        triggers: ['usergroup'],
        countSuffixList: ['group', 'groups'],
        showSum: false,
        columns: [
            {field: 'name', title: 'Name'},
            {field: 'users', title: 'Number of persons', getValue: function(g) { return g.users.length; }, visible: () => !$rootScope.speedy},
            {field: 'user_count', title: 'Number of persons', visible: () => $rootScope.speedy},
            {field: 'change_permission', title: 'Access right', format: 'translated'}
        ],
        rowClick: onGroupSelected,
        orderColumn: 'name',
        buttons: [
            { title: 'Choose', onClick: onGroupSelected, visible: allInGroupNotSelected },
            { title: 'Change', buttonClass: 'btn-warning', onClick: changeGroup}
        ]
    };

    if ($rootScope.speedy) {
        delete groupConfig.triggers;
        delete groupConfig.getItems;
        groupConfig.api = {
            url: '/api/search',
            post: true,
            args: {
                types: [{type: 'usergroup', searchFields: ['name'], resultFields: ['id', 'name', 'imagekey', 'change_permission', 'user_count', 'users.id']}],
                limit: 20
            },
            getItemsFromResponse: response => response.data.find(x => x.type == 'usergroup').items
        };
        groupConfig.filter = [
            {name: 'query', title: 'Search', required: false, type: 'text', hint: 'A selection is shown below, search to find among multiple results' }
        ];
        groupConfig.hideSearch = true;
    }

    var reportConfig = {
        getItems: function() {
            return $rootScope.reports.filter((r) => r.data?.reporttype == 'list' && r.data?.datatype == 'user');
        },
        countSuffixList: ['report', 'reports'],
        showSum: false,
        columns: [
            {field: 'name', title: 'Report', getValue(r) { return $filter('translate')(r.data.name); }},
        ],
        rowClick: onReportSelected,
        orderColumn: 'name',
        buttons: [
            { title: 'Choose', onClick:  onReportSelected, loading: function(r) { return loadingStatus.report[r.id]} },
        ]
    };

    var itemFilters = [];
    if (!options.multiple && $scope.itemType != 'schedule') {
        itemFilters.push( function(u) { return u.type == 'user'; } );
    }
    if (options.itemFilter) {
        itemFilters.push(options.itemFilter);
    }

    if (!options.multiple) {
        if ($scope.itemTypes[0] == 'staff') {
            itemFilters.push( function(u) { return u.type == 'user' && u.active && u.staff; } );
        } else if ($scope.itemTypes[0] == 'resource') {
            itemFilters.push( function(u) { return u.type == 'resource' && u.active && u.staff; } );
        } else if ($scope.itemType == 'schedule') {
            itemFilters.push( function(u) { return u.resourceType == 'schedule' && u.active; } );
        }
    }

    function primaryFilter(u) {
        if (isSelected(u)) {
            return true;
        }

        for (var i=0; i < itemFilters.length; ++i) {
            if (!itemFilters[i](u)) {
                return false;
            }
        }

        return true;
    }
    $scope.primaryFilter = primaryFilter;

    var items = [];
    $rootScope.waitFor(['members']).then(function() {
        items = $rootScope.members.filter(primaryFilter);
    });

    if($scope.itemType == 'schedule') {
        $scope.getNumberOfMatches = undefined;
    }

    $scope.tableConfig = {
        tableLimit: 5,
        tableNumPages: 5,
        triggers: ['user', 'image'],
        getItems: function() {
            return items;
        },
        itemFilters: [primaryFilter],
        rowClick: onCustomerSelected,
        showSum: false,
        columns: [
            { field: 'image', title: '' },
            { field: 'name', title: 'Name' },
            { field: 'mail', title: 'E-mail', visible: function(config) { return config.name != 'Choose resource' && !$rootScope.isSmallScreen(); } },
            { field: 'phone', title: 'Phone', visible: function(config) { return config.name != 'Choose resource' && $(window).width() >= 1200; } },
            { field: 'memberNumber', title: 'Member number', visible: function(config) { return $rootScope.hasMemberNumber && config.name != 'Choose resource'; } }
        ],
        buttons: [
            { title: 'Choose', onClick: onCustomerSelected, visible: isNotSelected },
            { title: 'Remove', buttonClass: 'btn-danger', onClick: removeSelected, visible: isSelected }
        ],
        searchFields: $scope.itemType == 'schedule' ? null : $rootScope.getCustomerProperties(),
        hideSearchCount: true,
        customerSearch: true,
        searchButtons: [
            {
                title: 'Add new customer',
                showOnEmpty: true,
                onClick: function() { $rootScope.showCombo({callback: waitForNewCustomer }); },
                visible: function() {
                    // Single-select has no tabbed control (PROD-1724): show whenever customer is an
                    // allowed item type, without touching getActiveTab (which isn't a function here).
                    if (!$scope.multiple) {
                        return $scope.itemTypes.indexOf('customer') != -1;
                    }
                    var tab = $scope.tableConfig.control && typeof $scope.tableConfig.control.getActiveTab === 'function' && $scope.tableConfig.control.getActiveTab();
                    return $scope.itemTypes.indexOf('customer') != -1 && tab && tab.name == "Choose customer";
                },
            },
            { title: 'Add staff', showOnEmpty: true, visible: function() { var tab = $scope.tableConfig.control && typeof $scope.tableConfig.control.getActiveTab === 'function' && $scope.tableConfig.control.getActiveTab(); return $scope.itemTypes.indexOf('staff') != -1 && (!$scope.multiple || (tab && tab.name == "Choose staff")); }, onClick: function() {
                $rootScope.addStaff(false).then(waitForNewCustomer);
            } },
            { title: 'Add resource', showOnEmpty: true, visible: function() { return $scope.itemTypes.indexOf('resource') != -1; }, onClick: function() {
                $modal.open({
                    templateUrl: 'views/addmodal.html',
                    controller: 'ResourceBookingResourceAddModalCtrl',
                    resolve: {
                        options: function() {
                            return {};
                        }
                    }
                }).result.then(function(resource) {
                    waitForNewCustomer(resource.id);
                });
            } },
            { title: 'Select all', onClick: $scope.selectAll, visible: function() { var tab = $scope.tableConfig.control && typeof $scope.tableConfig.control.getActiveTab === 'function' && $scope.tableConfig.control.getActiveTab(); return $scope.multiple && tab && tab.config.control.getItems().length > 0 && tab.name != "Chosen"; } },
            { title: 'Remove all', buttonClass: 'btn-danger', onClick: function(config) {
                const filteredIds = config.control.getFilteredItems().map(item => item.id);
                $scope.selected = $scope.selected.filter(item => !filteredIds.includes(item.id));

                $scope.tableConfig.control.update();
                $scope.chosenConfig.control.update();
            }, visible: function() { var tab = $scope.tableConfig.control && typeof $scope.tableConfig.control.getActiveTab === 'function' && $scope.tableConfig.control.getActiveTab(); return $scope.selected.length > 0 && tab && tab.name == "Chosen"; } }
        ],
        onSearchFieldEnter: function(config) {
            var filtered = config.control.getFilteredItems();
            if (filtered.length == 1) {
                onCustomerSelected(filtered[0]);
            }
        },

        tabs: [
            { name: 'Choose customer', badgeClass: 'badge-info', itemFilter: function(u) { return u.type == 'user' && isNotSelected(u);}, visible: function() { return $scope.itemTypes.indexOf('customer') != -1; } },
            { name: 'Choose staff', badgeClass: 'badge-info', itemFilter: function(u) { return u.type == 'user' && u.active && u.staff && isNotSelected(u);}, visible: function() { return $scope.itemTypes.indexOf('staff') != -1; } },
            { name: 'Choose resource', badgeClass: 'badge-info', itemFilter: function(u) { return u.type == 'resource' && u.active && isNotSelected(u);}, visible: function() { return $scope.itemTypes.indexOf('resource') != -1; } },
            { name: 'Chose group', badgeClass: 'badge-info', configOverride: groupConfig, visible: function() { return !options.hideGroup && ($scope.itemTypes.indexOf('customer') != -1 || $scope.itemTypes.indexOf('staff') != -1); } },
            { name: 'Choose report', badgeClass: 'badge-info', configOverride: reportConfig, visible: function() { return $scope.itemTypes.indexOf('customer') != -1; } },
            { name: 'Chosen', badgeClass: 'badge-success', itemFilter: isSelected, visible: function() { return $(window).width() < 992; } }
        ],

        onInit: function() {
            if (options.multiple) {
                var tab = $scope.tableConfig.tabs[ {'customer': 0, 'staff': 1, 'resource': 2}[$scope.itemTypes[0]] ];
                $scope.tableConfig.control.setActiveTab(tab);
            }
        }
    };

    if ($rootScope.speedy) {
        let customerTab = $scope.tableConfig.tabs.find(x => x.name == 'Choose customer');
        if (!options.getItems) {
            customerTab.configOverride = customerConfig;
            delete customerTab.itemFilter;
            $scope.tableConfig.getItems = () => $scope.selected;
        } else {
            $scope.tableConfig.getItems = options.getItems;
        }

        let staffTab = $scope.tableConfig.tabs.find(x => x.name == 'Choose staff');
        staffTab.configOverride = {
            api: {
                url: '/api/staff/get',
                args: {
                    site_id: () => {
                        if ($rootScope.hasModule('MultiSite')) {
                            var filterSite = staffTab.configOverride.filterSite;
                            if (filterSite) {
                                return filterSite.value ? filterSite.value.id : null;
                            }
                            return $rootScope.selectedSite.id;
                        }
                        return null;
                    },
                    inactive: false,
                    compact: true,
                    fields: 'id,imagekey,imageurl,name,mail,phone,memberNumber'
                },
                triggers: [{type: 'user'}, {type: 'image'}, {type: 'selectedSite'}],
                transform: i => {
                    i.active = true;
                    i.type = 'user';
                    i.staff = true;
                }
            },
            itemFilters: [primaryFilter],
            countSuffixList: ['staff', 'staffs'],
            rowClick: onCustomerSelected,
            showSum: false,
            columns: [
                { field: 'image', title: '' },
                { field: 'name', title: 'Name' },
                { field: 'mail', title: 'E-mail', visible: function() { return !$rootScope.isSmallScreen(); } },
                { field: 'phone', title: 'Phone', visible: function() { return $(window).width() >= 1200; } }
            ],
            buttons: [
                { title: 'Choose', onClick: onCustomerSelected, visible: isNotSelected }
            ],
            searchButtons: [
                { title: 'Add staff', showOnEmpty: true, onClick: function() {
                    $rootScope.addStaff(false).then(waitForNewCustomer);
                } },
                { title: 'Select all', onClick: $scope.selectAll, visible: function() { return $scope.multiple } }
            ],
            tableLimit: 5,
            tableNumPages: 5,
        }
        if ($rootScope.hasModule('MultiSite') && $rootScope.sites.length > 1) {
            staffTab.configOverride.filterSite = {
                list: $rootScope.sites,
                value: $rootScope.selectedSite,
                onChange: function(site) {
                    staffTab.configOverride.filterSite.value = site;
                    if (staffTab.configOverride.control) {
                        staffTab.configOverride.control.updateApi();
                    }
                }
            };
        }
        let resourceTab = $scope.tableConfig.tabs.find(x => x.name == 'Choose resource');
        resourceTab.configOverride = {
            api: {
                url: '/api/resource/get',
                args: {
                    site_id: () => $rootScope.hasModule('MultiSite') ? $rootScope.selectedSite.id : null,
                    inactive: false,
                },
                triggers: [{type: 'user'}, {type: 'image'}, {type: 'selectedSite'}],
                transform: r => {
                    r.active = true;
                    r.resource = true;
                    r.sites = (r.sites || []).map(s => s?.id ?? s);
                }
            },
            itemFilters: [primaryFilter],
            countSuffixList: ['resource', 'resources'],
            rowClick: onCustomerSelected,
            showSum: false,
            columns: [
                { field: 'image', title: '' },
                { field: 'name', title: 'Name' }
            ],
            buttons: [
                { title: 'Choose', onClick: onCustomerSelected, visible: isNotSelected },
            ],
            searchButtons: [
                { title: 'Select all', onClick: $scope.selectAll, visible: function() { var tab = $scope.tableConfig.control && typeof $scope.tableConfig.control.getActiveTab === 'function' && $scope.tableConfig.control.getActiveTab(); return tab && tab.config.control.getItems().length > 0; } }
            ],
            tableLimit: 5,
            tableNumPages: 5,
        };
        let scheduleConfig = {
            api: {
                url: '/api/resource/get',
                args: {
                    site_id: () => $rootScope.hasModule('MultiSite') ? $rootScope.selectedSite.id : null,
                    inactive: false,
                },
                triggers: [{type: 'user'}, {type: 'image'}, {type: 'selectedSite'}],
                transform: r => {
                    r.active = true;
                    r.resource = true;
                    r.sites = (r.sites || []).map(s => s?.id ?? s);
                }
            },
            countSuffixList: ['schedule', 'schedules'],
            rowClick: onCustomerSelected,
            showSum: false,
            columns: [
                { field: 'image', title: '' },
                { field: 'name', title: 'Name' }
            ],
            buttons: [
                { title: 'Choose', onClick: onCustomerSelected, visible: isNotSelected},
            ],
            searchButtons: [],
            tableLimit: 5,
            tableNumPages: 5,
            itemFilters: [primaryFilter],
        };

        if (!options.multiple) {
            if ($scope.itemTypes[0] == 'staff') {
                $scope.tableConfig = staffTab.configOverride;
            } else if ($scope.itemTypes[0] == 'schedule') {
                $scope.tableConfig = scheduleConfig;
            } else if (!options.getItems) {
                $scope.tableConfig = customerConfig;
            }
        }
    } else if($rootScope.hasModule('MultiSite') && $rootScope.sites.length > 1) {
        $scope.tableConfig.filterSite = {
            list: $rootScope.sites,
            value: $rootScope.selectedSite,
            onChange: function(site) {
                $scope.tableConfig.filterSite.value = site;
                $scope.tableConfig.control.update();
            }
        };
        $scope.tableConfig.itemFilters.push(function(u) {
            var site = $scope.tableConfig.filterSite.value && $scope.tableConfig.filterSite.value.id;
            var sites = u.sites.concat(u.homesite_id).filter(function(x) { return !!x; });
            return !site || sites.indexOf(site) !== -1;
        });
    }

    $scope.chosenConfig = {
        tableLimit: 5,
        tableNumPages: 5,
        triggers: ['user', 'image'],
        getItems: function() {
            return $scope.selected;
        },
        rowClick: onCustomerSelected,
        showSum: false,
        giveFocus: function() { return false; },
        columns: [
            { field: 'image', title: '' },
            { field: 'name', title: 'Name' },
            { field: 'mail', title: 'E-mail', visible: function(config) { return config.name != 'Choose resource'; } },
            { field: 'phone', title: 'Phone', visible: function(config) { return config.name != 'Choose resource' && $(window).width() >= 1200; } },
            { field: 'memberNumber', title: 'Member number', visible: function(config) { return $rootScope.hasMemberNumber && config.name != 'Choose resource'; } }
        ],
        searchButtons: [
            { title: 'Remove all', buttonClass: 'btn-danger', onClick: function(config) {
                const filteredIds = config.control.getFilteredItems().map(item => item.id);
                $scope.selected = $scope.selected.filter(item => !filteredIds.includes(item.id));

                $scope.tableConfig.control.update();
                $scope.chosenConfig.control.update();
            }, visible: function() { return $scope.selected.length > 0; } }
        ],
        buttons: [
            { title: 'Remove', buttonClass: 'btn-danger', onClick: removeSelected, visible: isSelected }
        ],
        searchFields: $rootScope.getCustomerProperties(),
        hideSearchCount: true,
        onSearchFieldEnter: function(config) {
            var filtered = config.control.getFilteredItems();
            if (filtered.length == 1) {
                onCustomerSelected(filtered[0]);
            }
        },
        tabs: [
            { name: 'Chosen', badgeClass: 'badge-success' }
        ]
    };
}]);

app.controller('GetGroupCtrl', ['$rootScope', '$scope', 'util', 'options', function($rootScope, $scope, util, options) {
    $scope.title = util.t('Choose') + ' ' + util.t('group');

    function onGroupSelected(group) {
        $scope.$close(group);
    }

    function itemFilter(m) {
        return !options?.itemFilter || options.itemFilter(m);
    }

    function addGroup() {
        util.showDataDialog({controller: 'UserGroupDataCtrl'}).result.then(onGroupSelected);
    }

    var typeSpec = {type: 'usergroup', searchFields: ['name'], resultFields: ['id', 'name', 'imagekey', 'teamsport_id']};
    if (options?.searchFilters) {
        typeSpec.filters = options.searchFilters;
    }

    $scope.tableConfig = {
        filter: [
            {name: 'query', title: 'Search', required: false, type: 'text' },
        ],
        filterButtons: [
            { title: 'Add new group', onClick: addGroup }
        ],
        api: {
            url: '/api/search',
            post: true,
            args: {
                types: [typeSpec],
                limit: 20
            },
            getItemsFromResponse: response => {
                let ug = response.data.find(x => x.type == 'usergroup');
                $scope.count = ug.count;
                return ug.items;
            }
        },
        itemFilter: itemFilter,
        countSuffixList: ['group', 'groups'],
        showSum: false,
        tableLimit: 10,
        tableNumPages: 5,
        hideSearch: true,
        columns: [
            {field: 'image'},
            {field: 'name', title: 'Name'}
        ],
        rowClick: onGroupSelected,
        orderColumn: 'name',
        buttons: [
            { title: 'Choose', onClick: onGroupSelected },
            { title: 'Show', buttonClass: 'btn-info', onClick: $rootScope.showGroup }
        ]
    };
}]);

app.controller('GetGroupsCtrl', ['$rootScope', '$scope', 'util', 'options', function($rootScope, $scope, util, options) {
    $scope.title = util.t('Choose') + ' ' + util.t('group');

    function setSelected(group) {
        let i = $scope.selected.findIndex(x => x.id == group.id);
        if (i == -1) {
            $scope.selected.push(group);
            $scope.tableConfig.control.update();
            $scope.chosenConfig.control.update();
        }
    }

    function removeSelected(group) {
        let i = $scope.selected.findIndex(x => x.id == group.id);
        if (i != -1) {
            $scope.selected.splice(i, 1);
            $scope.tableConfig.control.update();
            $scope.chosenConfig.control.update();
        }
    }

    var onGroupSelected = function(group) {
        setSelected(group);
    };

    function isSelected(m) {
        return $scope.selected.find(x => x.id == m.id);
    }

    function isNotSelected(m) {
        return !isSelected(m);
    }

    $scope.tableConfig = {
        filter: [
            {name: 'query', title: 'Search', required: false, type: 'text' },
        ],
        api: {
            url: '/api/search',
            post: true,
            args: {
                types: [{type: 'usergroup', searchFields: ['name'], resultFields: ['id', 'name', 'imagekey']}],
                limit: 20
            },
            getItemsFromResponse: response => {
                let ug = response.data.find(x => x.type == 'usergroup');
                $scope.count = ug.count;
                return ug.items;
            }
        },
        itemFilter: isNotSelected,
        countSuffixList: ['group', 'groups'],
        showSum: false,
        tableLimit: 5,
        tableNumPages: 5,
        hideSearch: true,
        columns: [
            {field: 'image'},
            {field: 'name', title: 'Name'}
        ],
        rowClick: onGroupSelected,
        orderColumn: 'name',
        buttons: [
            { title: 'Choose', onClick: onGroupSelected },
            { title: 'Show', buttonClass: 'btn-info', onClick: $rootScope.showGroup }
        ]
    };

    $scope.selected = [];
    if (options?.selected) {
        options.selected.forEach(function(g) {
            $scope.selected.push($rootScope.getGroup(g));
        });
    }

    $scope.chosenConfig = {
        tableLimit: 5,
        tableNumPages: 5,
        getItems: function() {
            return $scope.selected;
        },
        rowClick: onGroupSelected,
        showSum: false,
        giveFocus: function() { return false; },
        columns: [
            { field: 'image', title: '' },
            { field: 'name', title: 'Name' }
        ],
        buttons: [
            { title: 'Remove', buttonClass: 'btn-danger', onClick: removeSelected, visible: isSelected }
        ],
        hideSearchCount: true
    };
}]);

app.controller('GetSupplierCtrl', ['$rootScope', '$scope', '$modal', '$filter', 'server', 'options', 'live', 'util', function($rootScope, $scope, $modal, $filter, server, options, live, util) {
    $scope.itemTypes = options.itemTypes || ['supplier', 'company', 'staff'];
    $scope.itemType = 'supplier';

    $scope.title = $filter('translate')('Choose') + ' ' + $filter('translate')($scope.itemType);

    var onCustomerSelected = function(user) {
        $scope.$close(user);
    };

    var waitForNewSupplier = function(user) {
        util.waitForNewObject(user.id, function(id) { return _.findWhere($rootScope.members, { id: id }); }, 'user').then(onCustomerSelected);
    };

    var itemFilters = [];
    itemFilters.push( function(u) { return u.type == 'user' && u.active; } );
    if (options.itemFilter) {
        itemFilters.push(options.itemFilter);
    }

    function primaryFilter(u) {
        for (var i=0; i < itemFilters.length; ++i) {
            if (!itemFilters[i](u)) {
                return false;
            }
        }
        return true;
    }

    var items = $rootScope.members.filter(primaryFilter);

    $scope.tableConfig = {
        tableLimit: 5,
        tableNumPages: 5,
        triggers: ['user', 'image'],
        getItems: function() {
            return items;
        },
        itemFilters: [primaryFilter],
        rowClick: onCustomerSelected,
        columns: [
            { field: 'image', title: '' },
            { field: 'name', title: 'Name' },
            { field: 'mail', title: 'E-mail', visible: function() { return !$rootScope.isSmallScreen(); } },
            { field: 'phone', title: 'Phone', visible: function() { return $(window).width() >= 1200; } },
        ],
        buttons: [
            { title: 'Choose', onClick: onCustomerSelected }
        ],
        searchFields: $rootScope.getCustomerProperties(),
        hideSearchCount: true,
        searchButtons: [
            { title: 'Add supplier', showOnEmpty: true, onClick: function() { $rootScope.showCombo({ company: true, supplier: true }).result.then(waitForNewSupplier); } },
        ],
        onSearchFieldEnter: function(config) {
            var filtered = config.control.getFilteredItems();
            if (filtered.length == 1) {
                onCustomerSelected(filtered[0]);
            }
        },
        tabs: [
            { name: 'Choose supplier', badgeClass: 'badge-info', itemFilter: function(u) { return u.supplier; } },
            { name: 'Choose company', badgeClass: 'badge-info', itemFilter: function(u) { return !u.supplier && u.company; }, visible: function() { return $scope.itemTypes.indexOf('company') != -1; } },
            { name: 'Choose staff', badgeClass: 'badge-info', itemFilter: function(u) { return !u.supplier && u.staff; }, visible: function() { return $scope.itemTypes.indexOf('staff') != -1; } }
        ]
    };

    if($rootScope.hasModule('MultiSite') && $rootScope.sites.length > 1) {
        $scope.tableConfig.filterSite = {
            list: $rootScope.sites,
            value: $rootScope.selectedSite,
            onChange: function(site) {
                $scope.tableConfig.filterSite.value = site;
                $scope.tableConfig.control.update();
            }
        };
        $scope.tableConfig.itemFilters.push(function(u) {
            var site = $scope.tableConfig.filterSite.value && $scope.tableConfig.filterSite.value.id;
            var sites = u.sites.concat(u.homesite_id).filter(function(x) { return !!x; });
            return !site || sites.indexOf(site) !== -1;
        });
    }

}]);

app.controller('MemberStatusListCtrl', ['$rootScope', '$scope', '$filter', '$modal', 'server', 'modal', 'Data', 'alertProvider', function($rootScope, $scope, $filter, $modal, server, modal, Data, alertProvider) {
    var change = function(item) {
        $modal.open({
            templateUrl: 'views/changemodal.html',
            controller: 'MemberStatusChangeModalCtrl',
            resolve: {
                status: function() {
                    return item;
                }
            }
        });
    };

    function canChange() {
        return $rootScope.hasPermission('Settings');
    }

    $scope.add = function() {
        $modal.open({
            templateUrl: 'views/addmodal.html',
            controller: 'MemberStatusAddModalCtrl'
        });
    };

    var remove = function(item) {
        modal.remove({item: item, itemTitle: item.name, content: 'REMOVE_STATUS_MESSAGE', postUrl: '/api/member/status/remove', showInactivate: false});
    };

    $scope.statusesConfig = {
        getItems: function() {
            return $rootScope.memberstatuses;
        },
        triggers: ['userstatus'],
        countSuffix: function() {
            return 'statuses';
        },
        rowClick: change,
        columns: [
            {field: 'name', title: 'Name', getValue: function(s) { return $filter('translate')(s.name);  } }
        ],
        orderColumn: 'name',
        buttons: [
            {title: 'Change', buttonClass: 'btn-warning', onClick: change, visible: canChange },
            {title: 'Remove', buttonClass: 'btn-danger', onClick: remove, visible: canChange }
        ],
        searchButtons: [
            {title: 'Add new status', onClick: $scope.add}
        ]
    };

    var interestList = [];
    function update(result) {
        interestList = result || Data.getList('interest');
        if($scope.interestConfig && $scope.interestConfig.control) {
            $scope.interestConfig.control.update();
        }
    }
    Data.load('interest').then(update);
    $scope.pubsub('data.interest', update);

    var addInterest = function() {
        $modal.open({
            templateUrl: 'views/addmodal.html',
            controller: 'InterestAddModalCtrl'
        });
    };

    var changeInterest = function(item) {
        $modal.open({
            templateUrl: 'views/changemodal.html',
            controller: 'InterestChangeModalCtrl',
            resolve: {
                item: function() { return item; }
            }
        });
    };

    var removeInterest = function(item) {
        var itemTitle = $filter('translate')(item.name);
        $modal.open({
            templateUrl: 'views/remove.html',
            controller: 'ModalCtrl',
            resolve: {
                options: function() {
                    return {itemTitle: itemTitle, content: 'REMOVE_INTEREST_MESSAGE'};
                }
            }
        }).result.then(function() {
            server.post2('/api/interest/remove', {id: item.id}).then(function() {
                var msg = $filter('translate')('{0} was removed');
                msg = msg.format(itemTitle);
                alertProvider.show('success', msg, true);
            }, function() {
                var msg = $filter('translate')('Failed to remove {0}');
                msg = msg.format(itemTitle.toLowerCase());
                alertProvider.show('error', msg, true);
            });
        });
    };

    $scope.interestConfig = {
        api: {
            url: '/api/memberapi/interest/get',
            triggers: [
                {
                    type: 'interest'
                }
            ]
        },
        countSuffix: function() {
            return $filter('translate')('Interest');
        },
        rowClick: changeInterest,
        columns: [
            {field: 'name', title: 'Name', getValue: function(i) { return $filter('translate')(i.name);  } },
            {field: 'top', title: 'Always visible', getValue: function(i) {return $filter('translate')(i.top?'Yes':'No');} }
        ],
        orderColumn: 'name',
        buttons: [
            {title: 'Change', buttonClass: 'btn-warning', onClick: changeInterest, visible: canChange },
            {title: 'Remove', buttonClass: 'btn-danger', onClick: removeInterest, visible: canChange }
        ],
        searchButtons: [
            {title: 'Add new interest', onClick: addInterest}
        ]
    };

}]);

app.controller('InterestAddModalCtrl', ['$scope', '$controller', function($scope, $controller) {
    $controller('AddCtrl', {$scope: $scope});

    $scope.postUrl = '/api/interest/add';
    $scope.callCloseOnSuccess = true;

    $scope.fields = [
        {name: 'name', title: 'Name', required: true, type: 'text'},
        {name: 'top', title: 'Always visible', required: true, type: 'checkbox'}
    ];
}]);

app.controller('InterestChangeModalCtrl', ['$scope', 'item', '$controller', '$filter', function($scope, item, $controller, $filter) {
    $controller('ChangeModalCtrl', {$scope: $scope});

    $scope.item = item;
    $scope.postUrl = '/api/interest/change';

    $scope.titleSuffix = function() {
        return $filter('translate')(item.name);
    };

    $scope.fields = [
        {name: 'name', title: 'Name', required: true, type: 'text'},
        {name: 'top', title: 'Always visible', required: true, type: 'checkbox'}
    ];

    $scope.setValues($scope.item);
}]);

app.controller('MemberStatusAddModalCtrl', ['$scope', '$controller', function($scope, $controller) {
    $controller('AddCtrl', {$scope: $scope});

    $scope.title = 'Add status';
    $scope.postUrl = '/api/member/status/add';
    $scope.callCloseOnSuccess = true;
    $scope.successTitle = '{0} was added';
    $scope.failedTitle = 'Failed to add {0}';
    $scope.itemTitle = 'Status';

    $scope.fields = [
        {name: 'name', title: 'Name', required: true, type: 'text' }
    ];
}]);

app.controller('MemberStatusChangeModalCtrl', ['$scope', 'status', '$controller', '$filter', function($scope, status, $controller, $filter) {
    $controller('ChangeModalCtrl', {$scope: $scope});

    $scope.item = status;
    $scope.postUrl = '/api/member/status/change';

    $scope.titleSuffix = function() {
        return $filter('translate')(status.name);
    };

    $scope.fields = [
        {name: 'name', title: 'Name', required: true, type: 'text'}
    ];

    $scope.setValues(status);
}]);

app.controller('SettingsInvoiceCtrl', ['$rootScope', '$scope', '$controller', '$modal', 'formatter', 'accounts', 'server', function($rootScope, $scope, $controller, $modal, formatter, accounts, server) {
    $controller('SettingsCtrl', {$scope: $scope});

    $scope.getUrl = '/api/invoice/settings/get';
    $scope.postUrl = '/api/invoice/settings/set';

    $scope.getNiceBankgiroNumber = function() {
        return formatter.format('bankgiroNumber', $scope.item.bankgiroNumber);
    };

    var openInvoiceTemplate = function(item) {
        server.get('/api/mailing/automailing/get', {autoType: 'INVOICE'}).then(function(result) {
            if (item.name === 'mailtext') {
                result = result.emailTemplate;
            } else {
                result = result.SMSTemplate;
            }
            $modal.open({
                templateUrl: 'views/templateschange.html',
                windowClass: 'huge-modal-window',
                controller: 'TemplateChangeCtrl',
                resolve: {
                    template: function() {
                        return result;
                    }
                }
            });
        });
    };

    var openInvoiceAutomaticMailing = function() {
        server.get('/api/mailing/automailing/get', {autoType: 'INVOICE'}).then(function(result) {
            $modal.open({
                templateUrl: 'views/automailingschange.html',
                windowClass: 'huge-modal-window',
                controller: 'AutomaticMailingChangeCtrl',
                resolve: {
                    autoMailing: function() {
                        return result;
                    }
                }
            });
        });
    };

    $scope.fields = [
        {name: 'days', title: 'Payment terms', required: true, type: 'infoNumber', info: 'days'},
        {name: 'bankgiroNumber', title: 'Bankgiro number', required: true, type: 'bankgiroNumber', getValue: function(f) { return $rootScope.normalizeBankgiroNumber(f.value); }, setValue: $scope.getNiceBankgiroNumber },
        {name: 'fee', title: 'Invoice fee', required: true, type: 'price' },
        {name: 'minAmount', title: 'Minimum invoice amount', required: false, type: 'price', placeholder: 'No limit', helpText: 'The system merges smaller amounts linked to a customer, until the total amount reaches the specified amount.' },
        {name: 'sendSmsOrMail', title: 'Send SMS or mail to customers', type: 'button', buttonTitle: 'CLICK_TO_MANAGE_INFO', click: openInvoiceAutomaticMailing, helpText: 'Decide how invoices are sent to customers.', placement: 'right' },
        {name: 'mailtext', title: 'Message in mail', type: 'button', buttonTitle: 'CLICK_TO_MANAGE_INFO', click: openInvoiceTemplate },
        {name: 'smstext', title: 'Message in SMS', type: 'button', buttonTitle: 'CLICK_TO_MANAGE_INFO', click: openInvoiceTemplate, visible: function() { return $rootScope.hasModule('SMS'); } },
        {name: 'autosend_webshop_invoice', title: 'Webshop invoices are automatically sent', required: true, type: 'checkbox', helpText: 'For invoice purchases in the webshop, the payment is sent directly without having to be confirmed.', placement: 'right' }
    ];

    $scope.getSettings();
}]);

app.controller('SettingsInvoiceReminderCtrl', ['$rootScope', '$scope', '$controller', '$modal', 'server', function($rootScope, $scope, $controller, $modal, server) {
    $controller('SettingsCtrl', {$scope: $scope});

    $scope.getUrl = '/api/invoice/reminder/settings/get';
    $scope.postUrl = '/api/invoice/reminder/settings/set';

    function sendSecondReminder() {
        return _.findWhere($scope.fields, {name: 'sendSecondReminder'}).value;
    }

    function sendToCollection() {
        return _.findWhere($scope.fields, {name: 'sendToCollection'}).value;
    }

    function updateMinValues() {
        var f = _.findWhere($scope.fields, {name: 'firstReminder'}).value;
        var s = _.findWhere($scope.fields, {name: 'secondReminder'});
        var c = _.findWhere($scope.fields, {name: 'collection'});
        s.min = f + 1;
        c.min = f + 1;
        if (s.value < s.min) {
            s.value = s.min;
        }
        if (c.value < c.min) {
            c.value = c.min;
        }
    }

    var changeCtrlGetSubmitItem = $scope.getSubmitItem;
    $scope.getSubmitItem = function() {
        var item = changeCtrlGetSubmitItem();
        if (!item.sendSecondReminder) {
            delete item.secondReminder;
        }
        if (!item.sendToCollection) {
            item.collection = 0;
        }
        delete item.sendSecondReminder;
        delete item.sendToCollection;
        return item;
    };

    var changeCtrlSetValues = $scope.setValues;
    $scope.setValues = function(item) {
        if (item.secondReminder) {
            item.sendSecondReminder = true;
        }

        if (item.collection) {
            item.sendToCollection = true;
        }
        changeCtrlSetValues(item);
        updateMinValues();
    };

    var openInvoiceReminderTemplate = function(item) {
        server.get('/api/mailing/automailing/get', {autoType: 'INVOICE_REMINDER'}).then(function(result) {
            if (item.name === 'reminderMailText') {
                result = result.emailTemplate;
            } else {
                result = result.SMSTemplate;
            }
            $modal.open({
                templateUrl: 'views/templateschange.html',
                windowClass: 'huge-modal-window',
                controller: 'TemplateChangeCtrl',
                resolve: {
                    template: function() {
                        return result;
                    }
                }
            });
        });
    };

    var openInvoiceReminderAutomaticMailing = function() {
        server.get('/api/mailing/automailing/get', {autoType: 'INVOICE_REMINDER'}).then(function(result) {
            $modal.open({
                templateUrl: 'views/automailingschange.html',
                windowClass: 'huge-modal-window',
                controller: 'AutomaticMailingChangeCtrl',
                resolve: {
                    autoMailing: function() {
                        return result;
                    }
                }
            });
        });
    };

    var adjustFeeMax = function() {
        var fee = _.findWhere($scope.fields, { name: 'fee' });
        if (fee.value && fee.value > 60) {
            fee.value = "60";
        }
    };

    $scope.fields = [
        {name: 'fee', title: 'Reminder fee', required: true, type: 'price', change: adjustFeeMax },
        {name: 'rate', title: 'Reminder rate', required: true, type: 'percent'},
        {name: 'firstReminder', title: 'Send first reminder', required: true, type: 'infoNumber', info: 'days after due date', change: updateMinValues},
        {name: 'sendSecondReminder', title: 'Send second reminder', required: true, type: 'checkbox', skipChangedCheck: false},
        {name: 'secondReminder', title: 'Send second reminder', required: true, type: 'infoNumber', info: 'days after due date', visible: sendSecondReminder },
        {name: 'sendToCollection', title: 'Send to collection', required: true, type: 'checkbox', skipChangedCheck: true, visible: function() { return false; }},
        {name: 'collection', title: 'Send to collection', required: true, type: 'infoNumber', info: 'days after due date', visible: sendToCollection, change: updateMinValues },
        {name: 'sendSmsOrMail', title: 'Send SMS or mail to customers', type: 'button', buttonTitle: 'CLICK_TO_MANAGE_INFO', click: openInvoiceReminderAutomaticMailing, helpText: 'Decide how invoices are sent to customers.', placement: 'right' },
        {name: 'reminderMailText', title: 'Reminder message in mail', type: 'button', buttonTitle: 'CLICK_TO_MANAGE_INFO', click: openInvoiceReminderTemplate },
        {name: 'reminderSmsText', title: 'Reminder message in SMS', type: 'button', buttonTitle: 'CLICK_TO_MANAGE_INFO', click: openInvoiceReminderTemplate, visible: function() { return $rootScope.hasModule('SMS'); } },
        {name: 'ignoreUnpaidReminders', title: 'Unpaid reminders are not required to be paid', required: true, type: 'checkbox', hint: 'UNPAID_INVOICEREMINDERS_SETTING_INFO' }
    ];

    $scope.getSettings();
}]);


app.controller('ChoosePaymentMethodCtrl', ['$rootScope', '$scope', 'paymentMethods', 'options', function($rootScope, $scope, paymentMethods, options) {
    var setMethods = function() {
        var methods = paymentMethods.get();
        if (options.checkout) {
            methods = methods.filter(paymentMethods.getFilter('checkout'));
        }
        if (options.create) {
            methods = methods.filter(paymentMethods.getFilter('create'));
        }
        if (options.change) {
            methods = methods.filter(paymentMethods.getFilter('change'));
        }
        if (options.refund) {
            methods = methods.filter(paymentMethods.getFilter('refund'));
        }
        if (options.markAsPaid) {
            methods = methods.filter(paymentMethods.getFilter('markAsPaid'));
        }
        if (options.refill) {
            methods = methods.filter(paymentMethods.getFilter('refill'));
        }
        if (options.filter) {
            methods = methods.filter(options.filter);
        }
        if (options.checkout || options.create || options.change || options.saved_card) {
            methods = angular.copy(methods);
            var stripe = _.findWhere(methods, {id: 'stripe'});
            if (stripe) {
                stripe.name = 'Saved payment card';
            }
        }
        return methods;
    };

    $scope.methods = setMethods();

    $scope.getMethods = function() {
        return $scope.methods;
    };
}]);

app.controller('DoorCtrl', ['$rootScope', '$scope', 'server', function($rootScope, $scope, server) {
    var open = function(door) {
        server.post('/api/door/open', null, {id: door.id});
    };

    $scope.tableConfig = {
        getItems: function() { return $rootScope.staffs; },
        itemFilter: function(i) { return i.active && i.type == 'resource' && i.resourceType == 'door'; },
        columns: [
            { field: 'image', src: $rootScope.staffImage },
            { field: 'name', title: 'Name' }
        ],
        buttons: [
            { title: 'Open', onClick: open }
        ]
    };
}]);

app.controller('TidomatDoorCtrl', ['$rootScope', '$scope', '$filter', 'server', 'live', 'alertProvider', function($rootScope, $scope, $filter, server, live, alertProvider) {
    var doors;

    var open = function(door) {
        live.pluginCommand('Tidomat', 'unlockDoor', {doorId: door.id}).then(function(result) {
            alertProvider.show('success', 'Door status: ' + result);
        });
    };

    var getDoors = function() {
        live.pluginCommand('Tidomat', 'getDoorList').then(function(result) {
            doors = result;
        }, function() {
            alertProvider.show('error', 'Failed to get door list');
        });
    };

    $scope.doorConfig = {
        getItems: function() { return doors; },
        countSuffix: function() {
            return $filter('translate')('doors');
        },
        columns: [
            { field: 'id', title: 'Id' },
            { field: 'name', title: 'Name' },
            { field: 'hw_type', title: 'hw_type' },
            { field: 'online', title: 'Online' },
            { field: 'controller.version', title: 'Controller version' },
            { field: 'controller.part', title: 'Controller part' }
        ],
        buttons: [
            { title: 'Open', onClick: open }
        ]
    };

    getDoors();
}]);

app.controller('JournalEntryDataCtrl', ['$scope', 'options', function($scope, options) {
    $scope.config = _.deep_extend(options.config, {
        url: {
            change: '/api/journal/change'
        },
        tabs: [
            {
                name: 'General',
                fields: [
                    {name: 'time', title: 'Time', type: 'datetime', required: true },
                    {name: 'text', title: 'Text', type: 'htmleditor', required: true }
                ]
            }
        ]
    });
}]);

app.controller('JournalCtrl', ['$rootScope', '$scope', '$routeParams', '$modal', '$filter', 'server', 'util', 'confirm', function($rootScope, $scope, $routeParams, $modal, $filter, server, util, confirm) {
    $scope.data = {};

    $scope.originalImageSrc = function(size) {
        return $rootScope.memberImage($scope.customer, size);
    };

    $scope.addNewJournalEntry = function() {
        server.post('/api/journal/add', { user_id: $scope.customer.id, text: $scope.data.newEntry, time: new Date().dateTime() }, null, '{0} was added', 'Failed to add {0}', 'Journal entry').then(function(result) {
            if (result.success) {
                $scope.data.newEntry = '';
            }
        });
    };

    var getJournal = function() {
        server.get('/api/journal/get', {customer: $routeParams.customerId}).then(function(data) {
            angular.forEach(data, function(jentry) {
                jentry.time = Date.newFull(jentry.time);
                jentry.performer = $rootScope.getPointerById(jentry.performer_id, $rootScope.staffs);
            });
            $scope.journal = data;
        });
    };

    var removeServerChange = $rootScope.$on('serverChange', function (event, message) {
        if (message.type == 'journal') {
            angular.forEach(message.data, function(m) {
                if (m.user_id == $routeParams.customerId) {
                    getJournal();
                }
            });
        } else if (message.type == 'todo') {
            $scope.getToDos();
        }
    });

    $scope.changeStatus = function() {
        var ids = _.pluck($scope.customer.status, 'id');
        var data = {id: $routeParams.customerId, status: ids};
        server.post('/api/member/change', data, null, 'Status changed', 'Failed to change status');
    };

    $scope.showTodoByObject = function(todo) {
        $modal.open({
            templateUrl: 'views/todomodal.html',
            controller: 'ToDoModalCtrl',
            resolve: {
                todo: function() {
                    return todo;
                }
            }
        });
    };

    $scope.showTodo = function(todo_id) {
        server.get('/api/todo/getById', {id: todo_id}).then(function(todo) {
            $rootScope.transformTodo(todo);
            $scope.showTodoByObject(todo);
        });
    };

    $scope.showSurvey = function(survey_id) {
        server.get('/api/mailing/survey/show', {survey_id: survey_id, user_id: $routeParams.customerId}).then(function(data) {
            var content = [];
            $modal.open({
                templateUrl: 'views/surveymodal.html',
                controller: ['$scope', function($scope) {
                    $scope.surveyContent = content;
                    $scope.isArray = function(value) {
                        return (value instanceof Array);
                    };
                    $scope.fields = [];
                    util.addQuestions($scope.fields, data.survey.questions, '');

                    $scope.fields.forEach(function(field) {
                        field.readonly = true;
                        if (field.type == 'text' || field.type == 'number') {
                            field.type = 'label';
                        }
                        var value = data.answers[field.name];
                        if (field.type == 'select') {
                            if (value) {
                                field.value = _.findWhere(field.options(), {id: value});
                            }
                        } else if (field.type == 'multiselect') {
                            if (value && Array.isArray(value)) {
                                field.value = value.map(function(item) {
                                    return _.findWhere(field.options(), {id: item});
                                });
                            }
                        } else if (field.type == 'date' || field.type == 'datetime') {
                            field.value = Date.newFull(value);
                        } else {
                            field.value = value;
                        }
                    });
                }],
            });
        }).catch(function(error){
            console.log(error);
        });
    };

    $scope.change = function(todo) {
        $modal.open({
            templateUrl: 'views/todoeditmodal.html',
            controller: 'ToDoChangeModalCtrl',
            resolve: {
                todo: function() {
                    return todo;
                }
            }
        });
    };

    $scope.changeJournalEntry = function(jentry) {
        util.showDataDialog({controller: 'JournalEntryDataCtrl', item: jentry});
    };

    $scope.removeJournalEntry = function(jentry) {
        confirm.show('Are you sure you want to remove the journal entry?').then(function() {
            server.post('/api/journal/remove', null, {id: jentry.id});
        });
    };

    $scope.completed = function(todo) {
        $modal.open({
            templateUrl: 'views/todoeditmodal.html',
            controller: 'ToDoCompletedModalCtrl',
            resolve: {
                todo: function() {
                    return todo;
                }
            }
        });
    };

    $scope.ToDoConfig = {
        getItems: function() {
            return $scope.todoList;
        },
        triggers: ['todo'],
        tabs: [
            {name: 'ToDo', badgeClass: 'badge-success', itemFilter: function(todo) { return !todo.performed && todo.dueDate &&  todo.dueDate.yyyymmdd() >= Date.today().yyyymmdd(); } },
            {name: 'Delayed', badgeClass: 'badge-danger', itemFilter: function(todo) { return !todo.performed && todo.dueDate && todo.dueDate.yyyymmdd() < Date.today().yyyymmdd(); } },
            {name: 'Unknown date', badgeClass: 'badge-warning', itemFilter: function(todo) { return !todo.performed && !todo.dueDate ; } },
            {name: 'History', itemFilter: function(todo) { return todo.performed; } }
        ],
        countSuffix: function(config) {
            return $filter('translate')(config.control.getNumberOfItems() == 1 ? 'todo' : 'todos');
        },
        hideEmptyTabs: true,
        rowClick: $scope.showTodoByObject,
        giveFocus: function() {
            return false;
        },
        columns: [
            {field: 'todo', title: 'ToDo' },
            {field: 'responsible.name', title: 'Responsible' },
            {field: 'dueDate', title: 'Due date', format: 'datetimeshort' }
        ],
        buttons: [
            { title: 'Change', buttonClass: 'btn-warning', onClick: $scope.change, visible: function(t) { return !t.performed; } },
            { title: 'Complete', buttonClass: 'btn-success', onClick: $scope.completed, visible: function(t) { return !t.performed; } },
        ],
        orderColumn: 'dueDate'
    };

    $scope.getToDos = function() {
        var args = { user: $routeParams.customerId };

        server.get('/api/todo/getForUser', args).then(function(todos) {
            angular.forEach(todos, function(t) {
                $rootScope.transformTodo(t);
            });
            $scope.todoList = todos;
        });
    };

    $scope.addTask = function() {
        $modal.open({
            templateUrl: 'views/addmodal.html',
            controller: 'ToDoModalAddCtrl',
            resolve: {
                options: function() {
                    return {
                        customer: $scope.customer
                    };
                }
            }
        });
    };

    $scope.$on('$destroy', function () {
        removeServerChange();
    });

    $scope.showMessageHistory = function() {
        $modal.open({
            templateUrl: 'views/membermessagehistorymodallist.html',
            controller: 'MemberMessageHistoryModalCtrl',
            windowClass: 'very-large-modal-window',
            resolve: {
                member: function() {
                    return $scope.customer;
                }
            }
        });
    };

    var waitingWatch = $rootScope.$watch('members', function() {
        $scope.customer = $rootScope.getMember(Number($routeParams.customerId));
        if ($scope.customer) {
            getJournal();
            $scope.getToDos();
            waitingWatch();
        }
    });
}]);

app.controller('LanguageSettingsCtrl', ['$rootScope', '$scope', '$translate', 'server', function($rootScope, $scope, $translate, server) {
    $scope.search = {};
    var getStrings = function() {
        server.get('/api/public/translation/get', {language: $translate.use()}).then(function(data) {
            var strings = [];
            angular.forEach(_.keys(data), function(key) {
                strings.push( {key: key, value: data[key] } );
            });
            $scope.strings = strings;
        });
    };

    $scope.save = function() {
        var strings = {};
        angular.forEach($scope.strings, function(o) {
            strings[o.key] = o.value;
        });

        server.post('/api/translation/set', strings, {language: $translate.use()}, 'Information saved', 'Failed to save information');
    };

    var removeTranslateChangeSuccess = $rootScope.$on('$translateChangeSuccess', function () {
        getStrings();
    });

    if ($translate.use()) {
        getStrings();
    }

    $scope.$on('$destroy', function () {
        removeTranslateChangeSuccess();
    });
}]);

app.controller('PaymentMethodChangeModalCtrl', ['$rootScope', '$scope', '$controller', '$filter', 'customer', 'server', 'confirm', function($rootScope, $scope, $controller, $filter, customer, server, confirm) {
    $scope.loadingStatus = {};
    var getPending = function() {
        $scope.loadingStatus.getting = true;
        server.get('/api/payment/pending/get', {payer: customer.id, legal_entity_id: $rootScope.selectedSite.legal_entity_id}).then(function(data) {
            $scope.pending = data;
            $scope.loadingStatus.getting = false;
        });
    };
    getPending();

    $scope.getPendingText = function() {
        return $filter('translate')('Change payment method for {0} pending payments').format($scope.pending.length);
    };

    var hasSavedCard = function() {
        return customer.hasSavedCardForSelectedLegalEntity();
    };

    $scope.fields = [
        {name: 'method', title: 'Payment method', required: true, type: 'paymentmethod', options: {change: true}, hasSavedCard: hasSavedCard }
    ];

    $scope.submit = function() {
        var method = _.findWhere($scope.fields, {name: 'method'}).value.id;
        var doSubmit = function() {
            $scope.loadingStatus.loading = true;
            var ids = _.pluck($scope.pending, 'id');
            server.post('/api/payment/method/change', {payments: ids, method: method}, null, 'Payment method changed', 'Failed to change payment method').then(function(result) {
                $scope.loadingStatus.loading = false;
                if (result.success) {
                    $scope.$close();
                }
            });
        };

        if (method == 'stripe' && $scope.pending.filter(function(p) { return Date.newFull(p.date).isPastDate(true); }).length) {
            confirm.show('CHARGENOWCONFIRM').then(doSubmit);
        } else {
            doSubmit();
        }
    };

    $scope.pubsub('selectedSite', function() {
        getPending();
    });
}]);

app.controller('TrialOverCtrl', ['$rootScope', '$scope', '$controller', 'server', function($rootScope, $scope, $controller, server) {
    $controller('SettingsCtrl', {$scope: $scope});

    $scope.getUrl = '/api/settings/get';
    $scope.postUrl = '/api/settings/change';

    $scope.fields = [
        {name: 'name', title: 'Name', required: true, type: 'text'},
        {name: 'companyname', title: 'Companyname', required: true, type: 'text'},
        {name: 'companynumber', title: 'Corporate identity', required: true, type: 'corporateIdentity'},
        {name: 'mail', title: 'Mail', required: true, type: 'email'},
        {name: 'phone', title: 'Phone', required: false, type: 'text'},
        {name: 'address', title: 'Address', required: true, type: 'text'},
        {name: 'zipCode', title: 'Zip code', required: true, type: 'zipCode'},
        {name: 'city', title: 'City', required: true, type: 'text'}
    ];

    $scope.submit = function() {
        server.post($scope.postUrl, $scope.getSubmitItem()).then(function(result) {
            if (result.success) {
                server.post('/api/settings/trialOver').then(function() {
                    $rootScope.trialEnds = null;
                    $scope.$dismiss();
                });
            }
        });
    };

    $scope.getSettings();
}]);

app.controller('CustomersRemoveCtrl', ['$rootScope', '$scope', '$window', '$timeout', 'confirm', 'server', function($rootScope, $scope, $window, $timeout, confirm, server) {
    $scope.remove = function() {
        confirm.show('Vill du verkligen ta bort alla ' + $rootScope.members.length + ' kunder, personal och resurser?').then(function() {
            confirm.show('Är du säker? Det blir inte mycket kvar. Det går inte att ångra sig...').then(function() {
                confirm.show('Bombsäker?').then(function() {
                    confirm.show('Ok. Då kör vi då?', {ladda: true}).then(function(resolve) {
                        server.post('/api/admin/test', {operation: 'remove_all_members'}, null, 'Samtliga kunder, personal och resurser borttagna. Laddar om.', 'Det gick inte att ta bort personerna').then(function(result) {
                            resolve();
                            if (result.success) {
                                $timeout(function() {
                                    $window.location.reload();
                                }, 1000);
                            }
                        });
                    });
                });
            });
        });
    };
}]);

app.controller('SettingsFreeTrainingCtrl', ['$rootScope', '$scope', '$controller', function($rootScope, $scope, $controller) {
    $controller('SettingsCtrl', {$scope: $scope});

    $scope.title = "Free training settings";
    $scope.getUrl = '/api/freetraining/settings/get';
    $scope.postUrl = '/api/freetraining/settings/set';

    $scope.fields = [
        {name: 'message', title: 'Message', required: false, type: 'text' },
        {name: 'freeAfter', title: 'Free after', required: false, type: 'infoNumber', info: 'entries' }
    ];

    $scope.getSettings();
}]);

var glyphicons = [
'asterisk',
'plus',
'euro',
'minus',
'cloud',
'envelope',
'pencil',
'glass',
'music',
'search',
'heart',
'star',
'star-empty',
'user',
'film',
'th-large',
'th',
'th-list',
'ok',
'remove',
'zoom-in',
'zoom-out',
'off',
'signal',
'cog',
'trash',
'home',
'file',
'time',
'road',
'download-alt',
'download',
'upload',
'inbox',
'play-circle',
'repeat',
'refresh',
'list-alt',
'lock',
'flag',
'headphones',
'volume-off',
'volume-down',
'volume-up',
'qrcode',
'barcode',
'tag',
'tags',
'book',
'bookmark',
'print',
'camera',
'font',
'bold',
'italic',
'text-height',
'text-width',
'align-left',
'align-center',
'align-right',
'align-justify',
'list',
'indent-left',
'indent-right',
'facetime-video',
'picture',
'map-marker',
'adjust',
'tint',
'edit',
'share',
'check',
'move',
'step-backward',
'fast-backward',
'backward',
'play',
'pause',
'stop',
'forward',
'fast-forward',
'step-forward',
'eject',
'chevron-left',
'chevron-right',
'plus-sign',
'minus-sign',
'remove-sign',
'ok-sign',
'question-sign',
'info-sign',
'screenshot',
'remove-circle',
'ok-circle',
'ban-circle',
'arrow-left',
'arrow-right',
'arrow-up',
'arrow-down',
'share-alt',
'resize-full',
'resize-small',
'exclamation-sign',
'gift',
'leaf',
'fire',
'eye-open',
'eye-close',
'warning-sign',
'plane',
'calendar',
'random',
'comment',
'magnet',
'chevron-up',
'chevron-down',
'retweet',
'shopping-cart',
'folder-close',
'folder-open',
'resize-vertical',
'resize-horizontal',
'hdd',
'bullhorn',
'bell',
'certificate',
'thumbs-up',
'thumbs-down',
'hand-right',
'hand-left',
'hand-up',
'hand-down',
'circle-arrow-right',
'circle-arrow-left',
'circle-arrow-up',
'circle-arrow-down',
'globe',
'wrench',
'tasks',
'filter',
'briefcase',
'fullscreen',
'dashboard',
'paperclip',
'heart-empty',
'link',
'phone',
'pushpin',
'usd',
'gbp',
'sort',
'sort-by-alphabet',
'sort-by-alphabet-alt',
'sort-by-order',
'sort-by-order-alt',
'sort-by-attributes',
'sort-by-attributes-alt',
'unchecked',
'expand',
'collapse-down',
'collapse-up',
'log-in',
'flash',
'log-out',
'new-window',
'record',
'save',
'open',
'saved',
'import',
'export',
'send',
'floppy-disk',
'floppy-saved',
'floppy-remove',
'floppy-save',
'floppy-open',
'credit-card',
'transfer',
'cutlery',
'header',
'compressed',
'earphone',
'phone-alt',
'tower',
'stats',
'sd-video',
'hd-video',
'subtitles',
'sound-stereo',
'sound-dolby',
'sound-5-1',
'sound-6-1',
'sound-7-1',
'copyright-mark',
'registration-mark',
'cloud-download',
'cloud-upload',
'tree-conifer',
'tree-deciduous'
];

app.controller('CustomerFieldsSettingsCtrl', ['$rootScope', '$scope', '$controller', '$modal', function($rootScope, $scope, $controller, $modal) {
    $controller('SettingsCtrl', {$scope: $scope});

    $scope.title = "Customer information";
    $scope.getUrl = '/api/settings/fields/get';
    $scope.postUrl = '/api/settings/fields/set';

    $scope.glyphicons = [];
    angular.forEach(glyphicons, function(g) {
        $scope.glyphicons.push('icon glyphicon glyphicon-' + g);
    });

    var typeMap = {
        'text': 'Text',
        'textarea': 'Longer text',
        'number': 'Number',
        'price': 'Price',
        'select': 'List',
        'multiselect': 'Multi choice list',
        'date': 'Date',
        'time': 'Time',
        'datetime': 'Date and time',
        'checkbox': 'Checkbox',
        'customers': 'Customers'
    };

    $scope.valuesChanged = function() {
        return !angular.equals($scope.original, $scope.item);
    };

    $scope.fieldsValid = function() {
        var valid = true;
        angular.forEach($scope.item.member, function(field) {
            if (!field.builtIn && !field.remove) {
                var b = (field.title && field.title.length && field.name && field.name.length && field.type && field.type.length) ? true : false;
                valid &= b;
            }
        });
        return valid;
    };

    $scope.getDisabled = function(field, box) {
        if (field.name == 'login_key') {
            return box == 'show';
        }

        if (field.name == 'firstname' || field.name == 'lastname') {
            return box != 'changeable_by_member';
        }

        if (field.name == 'password') {
            return box != 'changeable_by_member' && box != 'register';
        }

        if (field.name == 'image') {
            return box != 'show' && box != 'changeable_by_member';
        }

        if (field.name == 'created') {
            return box != 'show';
        }

        if (field.name == 'memberNumber' || field.name == 'position' || field.name == 'responsible') {
            return box != 'show' && box != 'required_for_staff';
        }

        return false;
    };

    $scope.setValues = function(data) {
        $scope.original = angular.copy(data);
    };

    $scope.getSubmitItem = function() {
        return $scope.item;
    };

    $scope.add = function() {
        var modalInstance = $modal.open({
            templateUrl: 'views/addmodal.html',
            controller: 'FieldBuilderCtrl',
            resolve: {
                options: function() {
                    return {};
                }
            }
        });

        modalInstance.result.then(function(item) {
            $scope.item.user.push( {name: item.name, title: item.name, type: item.type, data: item.data, show: true, required: item.required, builtIn: false, register: false, canwrite: true, icon: 'icon glyphicon glyphicon-info-sign', changeable_by_member: false, child: false, required_child: false});
        });
    };

    $scope.remove = function(field) {
        field.remove = true;
    };

    $scope.change = function(field) {
        var modalInstance = $modal.open({
            templateUrl: 'views/addmodal.html',
            controller: 'FieldBuilderCtrl',
            resolve: {
                options: function() {
                    return { field: { name: field.title, required: field.required, type: field.type, data: field.data } };
                }
            }
        });

        modalInstance.result.then(function(item) {
            field.title = item.name;
            field.type = item.type;
            field.data = item.data;
            field.required = item.required;
        });
    };

    $scope.visibleFields = function(field) {
        return !field.builtIn && !field.remove;
    };

    $scope.shortenIconName = function(g) {
        return g.substring(25);
    };

    $scope.typeName = function(t) {
        return typeMap[t];
    };

    $scope.getSettings();

    $scope.customerfieldsettings = function() {

        var getHeader = function(index) {
            return '.customerfields-builtin-fields thead > tr > th:nth-child('+index||1+')';
        };

        return [{
            element: '.page div > .panel-heading:first-of-type',
            popover: {
                title: 'What do you need to know about the members?',
                description: 'CUSTOMER_FIELDS_GUIDE_INFO'
            }
        }, {
            element: getHeader(2),
            popover: {
                description: 'These fields become available when staff manually adds new customers'
            }
        }, {
            element: getHeader(3),
            popover: {
                description: 'Make the task obligatory for staff when adding a new member'
            }
        }, {
            element: getHeader(4),
            popover: {
                description: 'Optional for customer to fill in'
            }
        }, {
            element: getHeader(5),
            popover: {
                description: 'Make the task obligatory for the member'
            }
        }, {
            element: getHeader(6),
            popover: {
                description: 'Allows the member to change the information themselves'
            }
        }];
    };

    var cancelGuideWatch = $scope.$watch('$registerGuide', function() {
        if (!$scope.$registerGuide) { return; }
        cancelGuideWatch();
        $scope.$registerGuide({ id: 'customerfieldsettings', title: 'Customer information', steps: $scope.customerfieldsettings, onFinish: $rootScope.possiblyGoToGetStarted });
    });

}]);

app.controller('MailChimpCtrl', ['$rootScope', '$scope', '$filter', '$interval', 'server', 'alertProvider', 'items', function($rootScope, $scope, $filter, $interval, server, alertProvider, items) {
    $scope.loadingStatus = {};

    $scope.items = [];
    angular.forEach(items, function(i) {
        if (i.mail) {
            $scope.items.push( {mail: i.mail, firstname: i.firstname, lastname: i.lastname} );
        }
    });

    $scope.getTitle = function() {
        var a = $filter('translate')($scope.items.length == 1 ? 'address' : 'addresses');
        return $filter('translate')('MailChimp sync of {0} {1}').format($scope.items.length, a);
    };

    server.get('/api/mailchimp/lists/get').then(function(lists) {
        $scope.lists = lists;
    });

    $scope.compare = function() {
        $scope.listresult = null;

        if ($scope.list) {
            server.post('/api/mailchimp/compare', {items: $scope.items}, {list: $scope.list.id}).then(function(result) {
                if (result.success) {
                    $scope.listresult = result.data;
                }
            });
        }
    };

    var checker;
    var batchid;
    var stopCheck = function() {
        if (checker) {
            $interval.cancel(checker);
            checker = undefined;
        }
    };

    var checkSync = function() {
        server.get('/api/mailchimp/checksync', {id: batchid}).then(function(result) {
            if (result.status == 'finished') {
                alertProvider.show('success', 'Synced with MailChimp');
                $scope.loadingStatus.loading = false;
                stopCheck();
                $scope.$close();
            }
        });
    };

    $scope.sync = function() {
        $scope.loadingStatus.loading = true;
        server.post('/api/mailchimp/sync', {items: $scope.items}, {list: $scope.list.id}).then(function(result) {
            if (result.success) {
                batchid = result.data.id;

                checker = $interval(checkSync, 500);
            } else {
                $scope.loadingStatus.loading = false;
                alertProvider.show('error', 'Failed to synch with MailChimp');
            }
        });
    };

    $scope.$on('$destroy', function() {
        stopCheck();
    });
}]);

app.controller('SettingsMailChimpCtrl', ['$rootScope', '$scope', '$controller', function($rootScope, $scope, $controller) {
    $controller('SettingsCtrl', {$scope: $scope});

    $scope.getUrl = '/api/settings/mailchimp/get';
    $scope.postUrl = '/api/settings/mailchimp/set';

    $scope.fields = [
        {name: 'key', title: 'API-key', required: true, type: 'text' }
    ];

    $scope.getSettings();
}]);

app.controller('SettingsTidomatCtrl', ['$rootScope', '$scope', '$controller', function($rootScope, $scope, $controller) {
    $controller('SettingsCtrl', {$scope: $scope});

    $scope.title = "Tidomat settings";
    $scope.getUrl = '/api/settings/tidomat/get';
    $scope.postUrl = '/api/settings/tidomat/set';
    $scope.rightPanel = '/views/tidomatcontrol.html';

    var getUrl = function() {
        var key = _.findWhere($scope.fields, {name: 'key'}).value;
        return 'https://' + window.location.host + '/api/entry/smartone?key=' + key;
    };

    $scope.fields = [
        {name: 'key', title: 'API-key', required: true, type: 'alphadigits' },
        {name: 'extended_integration', title: 'Extended integration', type: 'checkbox' },
        {name: 'url', title: 'URL', required: false, type: 'label', getValue: getUrl, getClass: function() { return 'label-oneline'; } },
        {name: 'canChangePin', title: 'Let member change PIN', required: false, type: 'checkbox'}
    ];

    $scope.getSettings();
}]);

app.controller('SettingsParakeyCtrl', ['$rootScope', '$scope', '$controller', 'confirm', 'server', function($rootScope, $scope, $controller, confirm, server) {
    $controller('SettingsCtrl', {$scope: $scope});

    $scope.title = "Parakey settings";
    $scope.getUrl = '/api/settings/parakey/get';
    $scope.postUrl = '/api/settings/parakey/set';

    $scope.fields = [
        {name: 'accessId', title: 'Access ID', required: true, type: 'alphadigits' },
        {name: 'domainId', title: 'Domain ID', required: true, type: 'alphadigits' }
    ];

    var oldAfterSubmit = $scope.afterSubmit;
    $scope.afterSubmit = function() {
        oldAfterSubmit();
        confirm.show('PARAKEY_SYNC_INFO', {ladda: true}).then(function(resolve) {
            server.post('/api/parakey/sync', null, null, 'PARAKEY_SYNC_SUCCESS', 'PARAKEY_SYNC_FAIL').then(resolve);
        });
    };

    $scope.getSettings();
}]);

app.controller('SettingsMetraCtrl', ['$rootScope', '$scope', '$controller', function($rootScope, $scope, $controller) {
    $controller('SettingsCtrl', {$scope: $scope});

    $scope.title = 'Metra settings';
    $scope.getUrl = '/api/settings/metra/get';
    $scope.postUrl = '/api/settings/metra/set';

    $scope.fields = [
        {name: 'host', title: 'Server address', required: true, type: 'text' },
        {name: 'port', title: 'Port', required: false, type: 'number' }
    ];

    $scope.getSettings();
}]);

app.controller('SettingsMetraSyncCtrl', ['$rootScope', '$scope', 'server', function($rootScope, $scope, server) {
    $scope.title = 'Sync metra settings';

    $scope.loadingStatus = {loading: false};
    $scope.syncResult = false;

    $scope.syncMetra = function() {
        $scope.loadingStatus.loading = true;
        server.post('/api/metra/locker/sync', null, null, 'Sync completed', 'Sync failed').then((result) => {
            result.data.zoezi.forEach(r => {
                r.zoezi_resource = $rootScope.getMember(r.zoezi_resource_id);
                r.user = $rootScope.getMember(r.user_id);
            });
            $scope.configZoezi = {
                getItems: () => result.data.zoezi,
                countSuffixList: ['Zoezi locker reservation', 'Zoezi locker reservations'],
                columns: [
                    {field: 'locker', title: 'Locker'},
                    {field: 'zoezi_resource.name', title: 'Location'},
                    {field: 'user.name', title: 'Customer'},
                    {field: 'user.id', title: 'Customer id'},
                ]
            };
            result.data.metra.forEach(r => {
                if (Array.isArray(r.cards?.card)){
                    r.cards.card = r.cards.card.join(', ')
                }
            });
            $scope.configMetra = {
                getItems: () => result.data.metra,
                countSuffixList: ['Metra locker reservation', 'Metra locker reservations'],
                columns: [
                    {field: 'number', title: 'Locker'},
                    {field: 'item.location.name', title: 'Location'},
                    {field: 'memberid', title: 'Metramember id'}
                ]
            };

            $scope.syncResult = true;
        }).finally(() => {
            $scope.loadingStatus.loading = false;
        });
    };
}]);

app.controller('SettingsSparCtrl', ['$rootScope', '$scope', '$controller', function($rootScope, $scope, $controller) {
    $controller('SettingsCtrl', {$scope:$scope});

    $scope.title = 'SPAR settings';
    $scope.getUrl = '/api/settings/spar/get';
    $scope.postUrl = '/api/settings/spar/set';

    var sparOptions = [
        { id: 'staff', name: 'Staff can retrieve through a button', staff: true },
        { id: 'member', name: 'Members can retrieve through a button', member: true },
        { id: 'automatic', name: 'Automatically on entering of personal number', staff: true, member: true },
        { id: 'off', name: 'SPAR not activated', staff: true, member: true }
    ];

    $scope.fields = [
        {name: 'sparOption', title: 'Get information from SPAR - staff', type: 'select', required: true, options: function() { return sparOptions.filter(function(o) { return o.staff; }); }, useId: true },
        {name: 'sparOptionMember', title: 'Get information from SPAR - member', type: 'select', required: true, options: function() { return sparOptions.filter(function(o) { return o.member; }); }, useId: true },
    ];

    $scope.getSettings();
}]);

app.controller('TidomatConnectionTestCtrl', ['$scope', '$interval', 'server', function($scope, $interval, server) {
    $scope.status = 'checking';
    var i = $interval(function() {
        server.get('/api/entry/tidomat/status').then(function(result) {
            $scope.status = result && result.status ? 'online' : 'offline';
        }, function() {
            $scope.status = 'offline';
        });
    }, 1000);

    $scope.$on('$destroy', function () {
        $interval.cancel(i);
    });
}]);

app.controller('SettingsSwishCtrl', ['$rootScope', '$scope', '$controller', 'fileManager', function($rootScope, $scope, $controller, fileManager) {
    $controller('SettingsCtrl', {$scope: $scope});

    $scope.getUrl = `/api/settings/swish/get?legal_entity_id=${$rootScope.selectedSite.legal_entity_id}`;
    $scope.postUrl = `/api/settings/swish/set?legal_entity_id=${$rootScope.selectedSite.legal_entity_id}`;

    $scope.fields = [
        {name: 'active', title: 'ACTIVE_ONE', type: 'checkbox' },
        {name: 'swishNumber', title: 'Swish number', required: true, type: 'number' },
        {name: 'message', title: 'Message on bank statements', required: false, type: 'textarea', visible: function() { return $rootScope.currentStaff.superUser; } },
        {type: 'button', title: 'Get certificate request', buttonTitle: 'Download', buttonClass: 'btn-info', loading: false, click: (field) => {
            field.loading = true;
            fileManager.downloadFileFromServer(`/api/settings/swish/csr?legal_entity_id=${$rootScope.selectedSite.legal_entity_id}`).finally(() => {
                field.loading = false;
            });
        }},
        {name: 'certFile', 'type': 'file', title: 'Upload certificate', getValue: function(f) {return f.src;} }
    ];

    var origSetValue = $scope.setValues;
    $scope.setValues = function(data) {
        origSetValue(data);
        var certFile = _.findWhere($scope.fields, {name: 'certFile'});
        certFile.src = certFile.value = null;
    };

    $scope.getSettings();
}]);

app.controller('SettingsPaymentMethodChangeModalCtrl', ['$rootScope', '$scope', 'method', '$controller', '$filter', 'accounts', function($rootScope, $scope, method, $controller, $filter, accounts) {
    $controller('ChangeModalCtrl', {$scope: $scope});

    $scope.item = method;
    $scope.method = method;
    $scope.postUrl = '/api/paymentmethod/change';

    $scope.titleSuffix = function() {
        return $filter('translate')(method.name);
    };

    function external() {
        return _.findWhere($scope.fields, {name: 'external'}).value;
    }

    function canSkipAccounting() {
        return $rootScope.hasModule('Accounting') && (!method.builtIn);
    }

    function isUnknow() {
        return (method.id == 'unknown');
    }

    function canChangeActive() {
        return !$rootScope.hasPermission('Accounting') || !external();
    }

    function showWebshop() {
        const validMethodIds = [
            'unknown',
            'directdebit',
            'stripe',
            'swishi',
            'payson',
            'valuecard',
            'invoice',
            'adyen-klarna',
            'adyen-klarna_paynow',
            'adyen-klarna_account',
            'adyen-trustly',
            'adyen-card'
        ];

        return $rootScope.hasModule('WebShop') && (!method.builtIn || validMethodIds.includes(method.id));
    }

    function showCreate() {
        return method.id == 'stripe';
    }

    function showChange() {
        return method.id == 'stripe';
    }

    function showMarkAsPaid() {
        return false;
    }

    function showCheckout() {
        return $rootScope.hasModule('Checkout') && method.id != 'giftcard';
    }

    $scope.fields = [
        {name: 'name', title: 'Name', required: true, type: 'text', readonly: method.builtIn},
        {name: 'external', title: 'Separate accounting', required: true, type: 'checkbox', visible: canSkipAccounting },
        accounts.getFieldsRow($scope, function() { return !external() && !isUnknow() && $rootScope.hasPermission('Accounting'); }, $scope.method, 'assetsdebts'),
        {name: 'active', title: 'ACTIVE_ONE', required: true, type: 'checkbox', readonly: $scope.method.setup_status == 'pending', visible: canChangeActive },
        { hint: 'This payment method will automatically be activated when the the required action has been taken.', visible: () => $scope.method.setup_status == 'pending'},
        {name: 'webshop', title: 'Webshop', required: false, type: 'checkbox', visible: showWebshop },
        {name: 'checkout', title: 'Checkout', required: false, type: 'checkbox', visible: showCheckout },
        {name: 'selfCheckout', title: 'Self checkout', required: false, type: 'checkbox', visible: showCheckout },
        {name: 'create', title: 'Add payment', required: false, type: 'checkbox', visible: showCreate },
        {name: 'change', title: 'Change payment', required: false, type: 'checkbox', visible: showChange },
        {name: 'markAsPaid', title: 'Mark as paid', required: false, type: 'checkbox', visible: showMarkAsPaid },
        {
            name: 'imagekey',
            title: 'Image',
            type: 'field',
            field: 'image-storage',
            option: {
                originType: "payment",
                imageOnly: true,
                squareThumbnail: true,
                defaultImage: '/assets/img/cash.png'
            }
        },
        {name: 'company_invoice', title: 'Allow customers to bill companies' , required: false, type: 'checkbox', visible: function() { return $scope.item.id == 'invoice'; } },
    ];

    $scope.setValues($scope.method);
}]);

app.controller('SettingsPaymentMethodAddModalCtrl', ['$rootScope', '$scope', '$controller', 'accounts', function($rootScope, $scope, $controller, accounts) {
    $controller('AddCtrl', {$scope: $scope});

    $scope.title = 'Add payment method';
    $scope.postUrl = '/api/paymentmethod/add';
    $scope.callCloseOnSuccess = true;
    $scope.successTitle = '{0} was added';
    $scope.failedTitle = 'Failed to add {0}';
    $scope.itemTitle = 'Payment method';

    function external() {
        return _.findWhere($scope.fields, {name: 'external'}).value;
    }

    function canSkipAccounting() {
        return true;
    }

    function showWebshop() {
        return $rootScope.hasModule('WebShop');
    }

    function showCheckout() {
        return $rootScope.hasModule('Checkout');
    }

    $scope.fields = [
        {name: 'name', title: 'Name', required: true, type: 'text' },
        {name: 'external', title: 'Not accounted in system', required: true, type: 'checkbox', visible: canSkipAccounting, helpText: 'With this selected, no transactions using this payment method will be accounted in the system. All accounting for this type of payment needs to be done externally.' },
        accounts.getFieldsRow($scope, function() { return !external() && $rootScope.hasPermission('Accounting'); }, null, 'assetsdebts', true),
        {
            name: 'imagekey',
            title: 'Image',
            type: 'field',
            field: 'image-storage',
            option: {
                originType: "payment",
                imageOnly: true,
                squareThumbnail: true,
                defaultImage: '/assets/img/cash.png'
            }
        },
        {title: 'Use the payment method in', type: 'label', labelClass: 'largefont' },
        {name: 'webshop', title: 'Webshop', required: false, type: 'checkbox', visible: showWebshop },
        {name: 'checkout', title: 'Checkout', required: false, type: 'checkbox', visible: showCheckout },
        {name: 'selfCheckout', title: 'Self checkout', required: false, type: 'checkbox', visible: showCheckout }
    ];

    $scope.$getGuide = function() {
        var gf = function(name) { return _.findWhere($scope.fields, { name: name }); };

        var steps = [{
            element: gf('name').element,
            popover: {
                title: 'Payment method name',
                description: 'Choose an appropriate name for the payment method.'
            }
        }, {
            element: gf('external').element,
            popover: {
                title: 'Should the transactions with this payment method be accounted?',
                description: 'By checking the box, no transactions that use this payment method will be accounted - you will instead handle this manually.'
            }
        }, {
            element: gf('account').element,
            popover: {
                title: 'Which account should the payments be accounted to?'
            }
        }, {
            element: gf('webshop').element,
            popover: {
                title: 'Should the payment method be visible to customers in the web shop?'
            }
        }];
        return { steps: steps, onFinish: $rootScope.possiblyGoToGetStarted };
    };

}]);

app.controller('SettingsPaymentMethodsCtrl', ['$rootScope', '$scope', '$filter', '$modal', 'accounts', 'live', 'paymentMethods', 'server', function($rootScope, $scope, $filter, $modal, accounts, live, paymentMethods, server) {
    $scope.title = 'Payment methods';

    var change = function(method) {
        $modal.open({
            templateUrl: 'views/changemodal.html',
            controller: 'SettingsPaymentMethodChangeModalCtrl',
            resolve: {
                method: function() {
                    return method;
                }
            }
        });
    };

    var add = function() {
        $modal.open({
            templateUrl: 'views/addmodal.html',
            controller: 'SettingsPaymentMethodAddModalCtrl'
        });
    };

    function getAccounts() {
        accounts.getAll().then(function(a) {
            $scope.accounts = a;
            if ($scope.config.control) {
                $scope.config.control.update();
            }
        });
    }
    getAccounts();

    var getAccountName = function(m) {
        if (m.external) {
            return $filter('translate')('Separate accounting');
        }
        if (m.id == 'unknown') {
            return $filter('translate')('No final payment method, no accounting');
        }
        var a = _.findWhere($scope.accounts, {id: m.account});
        if (a) {
            return a.name + ' (' + a.id + ')';
        }

        return m.account;
    };


    var saveDefaultPaymentMethod = function(method) {
        var data = { defaultMethod: method ? method.id : null };
        server.post('/api/settings/paymentmethod/set', data, null, 'Default payment method changed', 'Failed to change default payment method');
    };

    function syncDefaultMethodValue(){
        if(!$rootScope.paymentMethodSettings) { return; }
        _.findWhere($scope.config.filter, { name: 'defaultMethod' }).value = _.findWhere(paymentMethods.getCreate(), { id: $rootScope.paymentMethodSettings.defaultMethod });
    }

    $rootScope.waitFor(['paymentmethodsettings']).then(function() {
        syncDefaultMethodValue();
        $scope.$watch(function(){ return _.findWhere($scope.config.filter, { name:'defaultMethod'}).value; }, function(method){
            if (!$rootScope.paymentMethodSettings) { return; }
            var methodId = method && method.id;
            if ($rootScope.paymentMethodSettings.defaultMethod != methodId) {
                saveDefaultPaymentMethod(method);
            }
        });
    });

    $scope.$watch(function() { return $rootScope.paymentmethods; }, function() {
        syncDefaultMethodValue();
    });

    let doubleNames = {};
    $rootScope.waitFor(['paymentmethods']).then(function() {
        $rootScope.paymentmethods.forEach(m => {
            doubleNames[m.name] = doubleNames[m.name] == null ? false : true;
        });
    });

    function getMethodName(m) {
        // Display modules for payment methods with the same name
        let name = $filter('translate')(m.name);
        if (doubleNames[m.name] && m.modules) {
            name += m.modules == 'Adyen' ? ' (Zoezi Pay)' : ` (${m.modules})`;
        }
        return name;
    };

    function getActionText() {
        return $filter('translate')('WAITING_FOR_ACTION_KLARNA');
    }

    $scope.config = {
        triggers: ['paymentmethod'],
        getItems: function() {
            return $rootScope.paymentmethods;
        },
        tabs: [
            {name: 'Active', badgeClass: 'badge-success', itemFilter: function(pm) { return pm.active && pm.id != 'multi'; } },
            {name: 'Waiting for action', badgeClass: 'badge-info', itemFilter: function(pm) { return pm.setup_status == 'pending' && pm.id != 'multi'; }, helpText: getActionText},
            {name: 'Inactive', badgeClass: 'badge-warning', itemFilter: function(pm) { return !pm.active && pm.id && pm.setup_status != 'pending' && pm.id != 'multi'; }},
        ],
        filter: [
            { name: 'defaultMethod', title: 'Default payment method', required: false, type: 'select', options: paymentMethods.getCreate, useId: true, placeholder: 'The system selects the appropriate payment method' }
        ],
        countSuffix: function() {
            return $filter('translate')('Payment methods').toLowerCase();
        },
        giveFocus: function() {
            return false;
        },
        rowClick: change,
        columns: [
            {field: 'image', src: function(pm) { return pm.imageSrc; } },
            {field: 'name', title: 'Name', getValue: getMethodName},
            {field: 'account', title: 'Bookkeeping account', visible: function() { return $rootScope.hasModule('Accounting'); }, getValue: getAccountName }
        ],
        orderColumn: 'name',
        buttons: [
            { title: 'Change', buttonClass: 'btn-warning', onClick: change }
        ],
        searchButtons: [
            { title: 'Add payment method', onClick: add }
        ]
    };

    live.subscribe({
        type: 'account',
        scope: $scope,
        callback: getAccounts
    });
}]);

app.controller('CancelCardCtrl', ['$rootScope', '$scope', 'server', 'card', 'allTrainingCards', function($rootScope, $scope, server, card, allTrainingCards) {
    $scope.data = {};
    $scope.loadingStatus = {};

    $scope.includedCards = $rootScope.hasFlag('flag-package-trainingcard') ? allTrainingCards.filter(function(tc) {
        return tc.parent_trainingcard_id === card.id && (!tc.validToDate || tc.validToDate >= Date.today());
    }) : [];
    $scope.hasIncludedProducts = $scope.includedCards.length > 0;
    $scope.isIncludedCard = !!card.parent_trainingcard_id && $rootScope.hasFlag('flag-package-trainingcard');

    var createPayments = function() {
        var expiryDate = _.findWhere($scope.fields, {name: 'expiryDate'}).value;
        if (!expiryDate || expiryDate.getFullYear() < 2000) {
            return;
        }
        server.get('/api/trainingcard/expirypayments/get', {trainingcard_id: card.id, expiryDate: expiryDate.yyyymmdd()}).then(function(payments) {
            angular.forEach(payments, function(p) {
                p.date = Date.newFull(p.date);
                p.from_date = Date.newFull(p.from_date);
                p.to_date = Date.newFull(p.to_date);
            });
            if (!payments.length) {
                payments.push( {amount: 0, date: Date.today() } );
            }
            $scope.data.payments = payments;
        });
    };

    var getExpiryDate = function() {
        var d = card.boundToDate > Date.today() ? card.boundToDate : Date.today();
        if (card.validFromDate > d) d = card.validFromDate;
        return d;
    };

    $scope.fields = [
        {name: 'expiryDate', title: 'Expiry date', required: true, type: 'date', value: getExpiryDate(), min: card.validFromDate.yyyymmdd(), change: createPayments }
    ];

    $scope.cancelCard = function() {
        $scope.loadingStatus.loading = true;
        var expiryDate = _.findWhere($scope.fields, {name: 'expiryDate'}).value.yyyymmdd();
        var payments = angular.copy($scope.data.payments.filter(function(p){ return p.amount != 0; }));
        angular.forEach(payments, function(p) {
            p.date = p.date.yyyymmdd();
        });

        server.post('/api/trainingcard/cancel', payments, {trainingcard_id: card.id, expiryDate: expiryDate}, 'Card cancelled', 'Failed to cancel card').then(function(result) {
            if (result.success) {
                $scope.$close();
            }

            $scope.loadingStatus.loading = false;
        });
    };

    createPayments();
}]);

app.controller('FreezeCardCtrl', ['$rootScope', '$scope', 'server', 'util', 'card', 'allTrainingCards', function($rootScope, $scope, server, util, card, allTrainingCards) {
    $scope.data = {};
    $scope.loadingStatus = {};

    var childCards = $rootScope.hasFlag('flag-package-trainingcard') ? allTrainingCards.filter(function(tc) {
        return tc.parent_trainingcard_id === card.id;
    }) : [];

    var isOneTime = function() {
        return !card.cardtype.priceType || card.cardtype.priceType == 'OneTime';
    };

    var getComingFreeze = function() {
        var today = Date.today();
        if (card.freezes && card.freezes.length) {
            var freezes = card.freezes.filter(function(freeze) {
                return freeze.toDate >= today;
            });
            return freezes.length && freezes[0];
        }
    };

    var getDays = function() {
        const from = _.findWhere($scope.fields,{name:'fromDate'}).value;
        const to   = _.findWhere($scope.fields,{name:'toDate'}).value;

        if (!from || !to) {
            return 0;
        }

        [from, to].forEach(d => d.setHours(0,0,0,0));   // Reset time due to the datepicker returning UTC time which interferes with the daysUntil calculation

        return from.daysUntil(to) + 1;
    };

    var getNewBoundToDate = function() {
        var date = card.boundToDate;
        return date.clone().addDays(getDays()).yyyymmdd();
    };

    var showBoundToDate = function() {
        var date = _.findWhere($scope.fields, {name: 'fromDate'}).value;
        return card.boundToDate && date && card.boundToDate >= date;
    };

    var getNewValidToDate = function() {
        var date = card.validToDate;
        return date.clone().addDays(getDays()).yyyymmdd();
    };

    var showValidToDate = function() {
        var date = _.findWhere($scope.fields, {name: 'fromDate'}).value;
        return card.validToDate && date && card.validToDate >= date && isOneTime();
    };

    var updateMinToDate = function() {
        if (_.findWhere($scope.fields, {name: 'fromDate'}).value > _.findWhere($scope.fields, {name: 'toDate'}).value) {
            _.findWhere($scope.fields, {name: 'toDate'}).value = _.findWhere($scope.fields, {name: 'fromDate'}).value.clone();
        }
    };

    var hasPaidOrSentPayments = function() {
        var fromDate = _.findWhere($scope.fields, {name: 'fromDate'}).value;
        var toDate = _.findWhere($scope.fields, {name: 'toDate'}).value;

        // If form dates aren't set yet, return false
        if (!fromDate || !toDate) {
            return false;
        }

        let sentOrPaidPayments = card.payments.filter((payment) => payment.status == 'paid' || payment.status == 'sent')

        return sentOrPaidPayments.filter(function(payment) {
            return payment.from_date && payment.to_date && Date.rangeInside(fromDate, toDate, Date.newFull(payment.from_date), Date.newFull(payment.to_date));
        }).length > 0;
    };

    var isPeriodCard = function() {
        return !card.cardtype.auto
    };

    $scope.fields = [
        {name: 'fromDate', title: 'From', required: true, type: 'date', readonly: getComingFreeze(), change: updateMinToDate },
        {name: 'toDate', title: 'Frozen until', required: true, type: 'date' },
        {name: 'numDays', title: 'Number of days', type: 'label', getValue: getDays},
        {name: 'boundToDate', title: 'Bound to', type: 'label', getValue: getNewBoundToDate, visible: showBoundToDate },
        {name: 'validToDate', title: 'Valid to', type: 'label', getValue: getNewValidToDate, visible: showValidToDate },
        {hint: 'FREEZEPAYMENTHINT', hintClass: 'alert-danger', visible: hasPaidOrSentPayments},
        {hint: childCards.length > 0 ? util.t('FREEZE_CASCADE_HINT') + ' ' + childCards.map(function(c) { return c.cardtype_name; }).join(', ') : '', hintClass: 'alert-info', visible: function() { return childCards.length > 0; }},
    ];

    var setInitialValues = function() {
        const freeze = getComingFreeze();
        if (freeze) {
            const firstValidFreezeDate = freeze.toDate.clone().addDays(1);
            _.findWhere($scope.fields, {name: 'fromDate'}).value = firstValidFreezeDate;
            _.findWhere($scope.fields, {name: 'toDate'}).value = firstValidFreezeDate;
        } else {
            const fromDate = Date.today()
            _.findWhere($scope.fields, {name: 'fromDate'}).value = fromDate;
            _.findWhere($scope.fields, {name: 'toDate'}).value = fromDate.clone().addDays(30);
        }
    };

    $scope.canSubmit = function() {
        return _.findWhere($scope.fields, {name: 'toDate'}).value >= _.findWhere($scope.fields, {name: 'fromDate'}).value && getDays() > 0 && getDays() < 1000;
    };

    $scope.freezeCard = function() {
        $scope.loadingStatus.loading = true;
        var fromDate = _.findWhere($scope.fields, {name: 'fromDate'}).value.yyyymmdd();
        var toDate = _.findWhere($scope.fields, {name: 'toDate'}).value.yyyymmdd();
        var boundToDate = showBoundToDate() ? getNewBoundToDate() : null;
        var validToDate = showValidToDate() ? getNewValidToDate() : null;
        server.post('/api/trainingcard/freeze', null, {trainingcard_id: card.id, fromDate: fromDate, toDate: toDate, boundToDate: boundToDate, validToDate: validToDate}, 'Card frozen', 'Failed to freeze card').then(function(result) {
            if (result.success) {
                $scope.$close();
            }

            $scope.loadingStatus.loading = false;
        });
    };

    setInitialValues();
}]);

app.controller('UnfreezeCardCtrl', ['$rootScope', '$scope', 'server', 'util', 'card', 'allTrainingCards', function($rootScope, $scope, server, util, card, allTrainingCards) {

    $scope.loadingStatus = {};

    var childCards = $rootScope.hasFlag('flag-package-trainingcard') ? allTrainingCards.filter(function(tc) {
        return tc.parent_trainingcard_id === card.id;
    }) : [];

    var getActiveFreeze = function() {
        var today = Date.today();
        var activeFreezes = card.freezes.filter(function(freeze) {
                return freeze.toDate >= today;
            });
        if (activeFreezes.length) {
            return activeFreezes[0];
        }
    };

    var setInitialValues = function() {
        var d = getActiveFreeze().fromDate.clone().addDays(-1);
        if (d < Date.today()) {
            d = Date.today().clone().addDays(-1);
        }
        _.findWhere($scope.fields, {name: 'frozenUntil'}).value = d;
        _.findWhere($scope.fields, {name: 'frozenUntil'}).min = getActiveFreeze().fromDate.clone().addDays(-1).yyyymmdd();
        _.findWhere($scope.fields, {name: 'frozenUntil'}).max = getActiveFreeze().toDate.yyyymmdd();
    };

    var getDays = function () {
        const from = _.findWhere($scope.fields, { name: 'frozenUntil' }).value;
        const to   = getActiveFreeze().toDate;

        if (!from || !to) {
            return '0 ' + util.t('days');
        }

        // normalise to ensure time does not interfere with the daysUntil caclulation
        [from, to].forEach(d => d.setHours(12, 0, 0, 0));

        return from.daysUntil(to) + ' ' + util.t('days');
    };

    $scope.fields = [
        {name: 'frozenUntil', title: 'Frozen until', type: 'date', required: true },
        {name: 'numDays', title: 'Frysning förkortas med', type: 'label', getValue: getDays},
        {hint: childCards.length > 0 ? util.t('UNFREEZE_CASCADE_HINT') + ' ' + childCards.map(function(c) { return c.cardtype_name; }).join(', ') : '', hintClass: 'alert-info', visible: function() { return childCards.length > 0; }},
    ];

    $scope.unfreezeCard = function() {
        $scope.loadingStatus.loading = true;
        var toDate = _.findWhere($scope.fields, {name: 'frozenUntil'}).value.yyyymmdd();
        server.post('/api/trainingcard/unfreeze', null, {trainingcard_id: card.id, toDate: toDate}, 'Card unfrozen', 'Failed to unfreeze card').then(function(result) {
            if (result.success) {
                $scope.$close();
            }

            $scope.loadingStatus.loading = false;
        });
    };

    $scope.formInvalid = function() {
        var toDate = _.findWhere($scope.fields, {name: 'frozenUntil'}).value;
        return toDate >= getActiveFreeze().toDate;
    };

    setInitialValues();
}]);

app.controller('DocumentationCtrl', ['$rootScope', '$scope', '$location', 'section', 'server', 'formatter', 'modalUtils', function($rootScope, $scope, $location, section, server, formatter, modalUtils) {
    $scope.section = section;

    $scope.print = function() {
        var printContents = document.getElementById($scope.section).innerHTML;
        var popupWin = window.open('', '_blank', 'width=300,height=300');
        popupWin.document.open();
        popupWin.document.write('<html><head><link rel="stylesheet" type="text/css" href="styles/main.css" /></head><body onload="window.print()">' + printContents + '</body></html>');
        popupWin.document.close();
    };

    server.get('/api/settings/get').then(function(settings) {
        $scope.settings = settings;
    });

    $scope.getAccountingParts = function() {
        var parts = [
            { module: 'Checkout', name: 'Köp som sker i kassa'},
            { module: 'WebShop', name: 'Köp som sker i webbshop'},
            { module: 'CardPayment', name: 'Kortbetalning online'},
            { module: 'Invoice', name: 'Fakturering'},
            { module: 'DirectDebit', name: 'Autogiro'}
        ];

        return formatter.format('commaList', parts.filter(function(p){return $rootScope.hasModule(p.module);}));
    };

    function getAccounts() {
        server.get('/api/economy/accounts/get').then(function(accounts) {
            $scope.accounts = accounts;
        });
    }
    getAccounts();

    $scope.goto = function(link) {
        $location.path(link);
        modalUtils.closeAllModals();
    };

    function getLedgers() {
        server.get('/api/economy/ledger/get').then(function(ledgers) {
            $scope.ledgers = ledgers;
        });
    }
    getLedgers();

    $scope.getLedgerInfo = function() {
        if (!$scope.ledgers) {
            return;
        }
        var ledgers = $scope.ledgers;
        if (ledgers.length == 1) {
            var l = ledgers[0];
            return 'Här används verifikationsnummer {0} för både kassa och kundreskontra.'.format(l.prefix);
        } else {
            var res = '';
            var l = _.find(ledgers, function(l) { return l.types.indexOf('invoice') != -1; });
            var l2 = _.find(ledgers, function(l) { return l.types.indexOf('checkout') != -1; });
            var l3 = _.find(ledgers, function(l) { return l.types.indexOf('client') != -1; });
            if (l == l2) {
                res = 'Här används verifikationsnummer {0} för både kassa och kundreskontra.'.format(l.prefix);
            } else {
                res = 'Här används verifikationsnummer {0} för kassa och verifikationsnummer {1} för kundreskontra.'.format(l2.prefix, l.prefix);
            }
            if (l3) {
                res += ' För klientmedelskonto används verifikationsnummer {0}'.format(l3.prefix);
            }
            return res;
        }
    };
}]);

app.controller('SettingsLedgerAddModalCtrl', ['$rootScope', '$scope', '$controller', function($rootScope, $scope, $controller) {
    $controller('AddCtrl', {$scope: $scope});

    $scope.title = 'Add ledger';
    $scope.postUrl = '/api/economy/ledger/add';
    $scope.callCloseOnSuccess = true;
    $scope.successTitle = '{0} was added';
    $scope.failedTitle = 'Failed to add {0}';
    $scope.itemTitle = 'Ledger';

    $scope.fields = [
        {name: 'name', title: 'Name', required: true, type: 'text' },
        {name: 'prefix', title: 'Prefix', required: true, type: 'text', maxlength: 1 }
    ];
}]);

app.controller('SettingsLedgerChangeModalCtrl', ['$rootScope', '$scope', 'ledger', '$controller', function($rootScope, $scope, ledger, $controller) {
    $controller('ChangeModalCtrl', {$scope: $scope});

    $scope.item = ledger;
    $scope.ledger = ledger;
    $scope.postUrl = '/api/economy/ledger/change';

    $scope.titleSuffix = function() {
        return ledger.name;
    };

    $scope.fields = [
        {name: 'legal_entity.name', title: 'Legal entity', type: 'text', readonly: true },
        {name: 'name', title: 'Name', required: true, type: 'text' },
        {name: 'prefix', title: 'Prefix', required: true, type: 'text', maxlength: 1 }
    ];

    $scope.setValues($scope.ledger);
}]);

app.controller('SettingsLedgerCtrl', ['$rootScope', '$scope', '$filter', '$modal', 'server', 'live', function($rootScope, $scope, $filter, $modal, server, live) {

    function getLedgers() {
        server.get('/api/economy/ledger/get').then(function(ledgers) {
            $scope.ledgers = ledgers;
        });
    }

    var change = function(ledger) {
        $modal.open({
            templateUrl: 'views/changemodal.html',
            controller: 'SettingsLedgerChangeModalCtrl',
            resolve: {
                ledger: function() {
                    return ledger;
                }
            }
        });
    };

    var add = function() {
        $modal.open({
            templateUrl: 'views/addmodal.html',
            controller: 'SettingsLedgerAddModalCtrl'
        });
    };

    $scope.itemNames = ['ledger', 'ledgers'];

    $scope.config = {
        getItems: function() {
            return $scope.ledgers;
        },
        rowClick: change,
        giveFocus: function() { return false; },
        countSuffix: function() {
            return $filter('translate')($scope.itemNames[$scope.config.control.getFilteredItems().length == 1 ? 0 : 1]);
        },
        columns: [
            {field: 'name', title: 'Name' },
            {field: 'prefix', title: 'Prefix' },
            {field: 'legal_entity.name', title: 'Legal entity' }
        ],
        orderColumn: 'name',
        buttons: [
            { title: 'Change', buttonClass: 'btn-warning', onClick: change }
        ],
        searchButtons: [
            { title: 'Add ledger', onClick: add, visible: function() { return false; } }
        ]
    };

    live.subscribe({
        type: 'ledger',
        scope: $scope,
        callback: getLedgers
    });

    getLedgers();
}]);

app.controller('CostCenterDataCtrl', ['$rootScope', '$scope', '$filter', '$modal', 'server', 'teamsportutil', 'util', 'options', function($rootScope, $scope, $filter, $modal, server, teamsportutil, util, options) {
    $scope.config = _.deep_extend(options.config, {
        datatype: 'cost center',
        url: {
            add: '/api/economy/costcenter/add',
            change: '/api/economy/costcenter/change'
        },
        tabs: [
            {
                name: 'General',
                fields: [
                    {name: 'name', title: 'Name', type: 'text', required: true },
                    {name: 'code', title: 'Code', type: 'text', required: true }
                ]
            }
        ]
    });
}]);

app.controller('CostCenterSetDefaultModalCtrl', ['$rootScope', '$scope', '$controller', '$filter', 'server', function($rootScope, $scope, $controller, $filter, server) {
    $controller('ChangeModalCtrl', {$scope: $scope});

    $scope.item = {};
    $scope.postUrl = '/api/economy/costcenter/default/change';

    var costcenters = [];

    function buildFields() {
        var fields = [
            {type: 'alert', value: 'DEFAULT_COSTCENTER_INFO', class: 'alert-info'}
        ];
        angular.forEach($rootScope.sites, function(site) {
            fields.push({id: site.id, name: site.name, title: site.name, required: false, type: 'select', options: function() { return costcenters; }, useId: true });
        });
        $scope.fields = fields;
    }

    $scope.titleSuffix = function() {
        return $filter('translate')('default cost center');
    };

    $scope.getSubmitItem = function() {
        var fields = $scope.fields.filter(function(field) { return field.type == 'select'; });
        return fields.map(function(field) {
            return { id: field.id, costcenter_id: field.value ? field.value.id : null };
        });
    };

    $scope.afterSubmit = function() {
        angular.forEach($rootScope.sites, function(site) {
            var field = _.findWhere($scope.fields, { id: site.id });
            if (!field) { return; }
            site.costcenter = field.value;
            site.costcenter_id = field.value ? field.value.id : null;
        });
    };

    $rootScope.waitFor(['sites']).then(function() {
        angular.forEach($rootScope.sites, function(site) {
            $scope.item[site.name] = site.costcenter_id;
        });

        server.get('/api/economy/costcenter/get').then(function(data) {
            costcenters = data;
            buildFields();
            $scope.setValues($scope.item);
        });
    });

}]);

app.controller('SettingsCostCenterCtrl', ['$rootScope', '$scope', '$modal', 'util', 'confirm', 'server', function($rootScope, $scope, $modal, util, confirm, server) {
    function remove(cc) {
        confirm.show('Are you sure you want to remove the cost center?', {ladda: true}).then(function(resolve) {
            server.post('/api/economy/costcenter/remove', null, {id: cc.id}, 'Cost center removed', 'Failed to remove cost center').then(resolve);
        });
    }

    var setDefaultForSite = function() {
        $modal.open({
            templateUrl: 'views/changemodal.html',
            controller: 'CostCenterSetDefaultModalCtrl'
        });
    };

    $scope.config = {
        api: {
            url: '/api/economy/costcenter/get',
            triggers: [{type: 'costcenter'}]
        },
        countSuffixList: ['cost center', 'cost centers'],
        columns: [
            {field: 'name', title: 'Name'},
            {field: 'code', title: 'Code'}
        ],
        giveFocus: function() { return false; },
        orderColumn: 'name',
        buttons: [
            { title: 'Change', buttonClass: 'btn-warning', onClick: function(cc) { util.showDataDialog({controller: 'CostCenterDataCtrl', item: cc }); } },
            { title: 'Remove', buttonClass: 'btn-danger', onClick: remove }
        ],
        searchButtons: [
            { title: 'Add', showOnEmpty: true, onClick: function() { util.showDataDialog({controller: 'CostCenterDataCtrl' }); } },
            { title: 'Default cost center', onClick: setDefaultForSite }
        ]
    };
}]);

app.controller('SettingsAccountAddModalCtrl', ['$rootScope', '$scope', '$controller', 'options', 'server', 'modalUtils', function($rootScope, $scope, $controller, options, server, modalUtils) {
    $controller('AddCtrl', {$scope: $scope});

    $scope.title = 'Add account';
    $scope.postUrl = '/api/economy/account/add';
    $scope.callCloseOnSuccess = true;
    $scope.successTitle = '{0} was added';
    $scope.failedTitle = 'Failed to add {0}';
    $scope.itemTitle = 'Account';

    function getAccounts() {
        server.get('/api/economy/accounts/get').then(function(accounts) {
            $scope.accounts = accounts;
        });
    }
    getAccounts();

    $scope.additionalFormCheck = function() {
        var a = _.findWhere($scope.fields, {name: 'id'}).value;
        if (a && $scope.accounts) {
            return !_.findWhere($scope.accounts, {id: a});
        }
        return true;
    };

    var accessGlobalOption = function() {
        return $rootScope.currentStaff.exportObjects && $rootScope.hasPermission('Chain settings');
    };

    $scope.fields = [
        {name: 'name', title: 'Account name', required: true, type: 'text' },
        {name: 'id', title: 'Account', required: true, type: 'number', min: options.min, max: options.max },
        {name: 'is_global', title: 'Chain', type: 'checkbox', visible: accessGlobalOption}
    ];

    $scope.$getGuide = function() {
        var steps = [{
            element: _.findWhere($scope.fields, { name: 'name' }).element,
            popover: {
                title: 'What is the name of the account?'
            }
        }, {
            element: _.findWhere($scope.fields, { name: 'id' }).element,
            popover: {
                title: 'What account number does the account have?'
            }
        }, {
            element: modalUtils.getModalElement('.modal-footer > button:first-of-type'),
            popover: {
                title: 'Save'
            },
            skipStartOnClick: true
        }];

        return { steps: steps, onFinish: $rootScope.possiblyGoToGetStarted };
    };

}]);

app.controller('SettingsAccountChangeModalCtrl', ['$rootScope', '$scope', 'account', '$controller', function($rootScope, $scope, account, $controller) {
    $controller('ChangeModalCtrl', {$scope: $scope});

    $scope.item = account;
    $scope.account = account;
    $scope.postUrl = '/api/economy/account/change';

    $scope.titleSuffix = function() {
        return account.name;
    };

    var accessGlobalOption = function(field) {
        return (field && field.value) || $rootScope.currentStaff.exportObjects && $rootScope.hasPermission('Chain settings');
    };

    $scope.fields = [
        {name: 'name', title: 'Account name', required: true, type: 'text' },
        {name: 'id', title: 'Account', required: true, type: 'number', readonly: true},
        {name: 'is_global', title: 'Chain', type: 'checkbox', visible: accessGlobalOption}
    ];

    if($scope.account.is_global && !accessGlobalOption()) {
        $scope.fields.forEach(function(field) {field.readonly=true;});
    }

    $scope.setValues($scope.account);
}]);


app.controller('SettingsAccountsCtrl', ['$rootScope', '$scope', '$filter', '$modal', 'server', 'live', 'util', function($rootScope, $scope, $filter, $modal, server, live, util) {

    function getAccounts() {
        server.get('/api/economy/accounts/get').then(function(accounts) {
            $scope.accounts = accounts;
        });
    }

    function getExcel(config) {
        config.control.exportTo('excel').then(function(blob) {
            util.download(config.getTitle() + '.xlsx', null, null, blob);
        });
    }

    var change = function(account) {
        $modal.open({
            templateUrl: 'views/changemodal.html',
            controller: 'SettingsAccountChangeModalCtrl',
            resolve: {
                account: function() {
                    return account;
                }
            }
        });
    };

    var add = function() {
        $modal.open({
            templateUrl: 'views/addmodal.html',
            controller: 'SettingsAccountAddModalCtrl',
            resolve: {
                options: function() {
                    if ($rootScope.longaccounts) {
                        return {min: 1000, max: 99999};
                    } else {
                        return {min: 1000, max: 9999};
                    }
                }
            }
        });
    };

    $scope.itemNames = ['account', 'accounts'];

    $scope.config = {
        getItems: function() {
            return $scope.accounts;
        },
        countSuffix: function() {
            return $filter('translate')($scope.itemNames[$scope.config.control.getFilteredItems().length == 1 ? 0 : 1]);
        },
        rowClick: change,
        giveFocus: function() { return false; },
        showSum: false,
        getTitle: function() {
            return $filter('translate')('Account plan');
        },
        columns: [
            {field: 'id', title: 'Account' },
            {field: 'name', title: 'Account name' }
        ],
        orderColumn: 'id',
        buttons: [
            { title: 'Change', buttonClass: 'btn-warning', onClick: change }
        ],
        searchButtons: [
            { title: 'Add account', onClick: add },
            { title: 'Download as Excel', onClick: getExcel }
        ]
    };

    live.subscribe({
        type: 'account',
        scope: $scope,
        callback: getAccounts
    });

    getAccounts();
}]);

app.controller('SettingsAccountingTemplatesCtrl', ['$scope', 'util', function($scope, util) {
    var add = function(template) {
        template = template || {};
        var options = {};
        options.controller = 'AccountingTemplateDataCtrl';
        if (template) {
            options.initial = template;
        }
        util.showDataDialog(options);
    };
    var change = function(template) {
        var options = {};
        options.controller = 'AccountingTemplateDataCtrl';
        options.item = template;
        util.showDataDialog(options).result.then($scope.config.control.update);
    };

    $scope.config = {
        api: {
            url: '/api/economy/accountingtemplate/get',
            triggers: [{type: 'accountingtemplate'}]
        },
        giveFocus: function() { return false; },
        searchButtons: [
            { title: 'Add accounting template', onClick: add },
        ],
        rowClick: change,
        countSuffixList: ['template', 'templates'],
        columns: [
            { field: 'name', title: 'Account name' },
            { field: 'description', title: 'Description' }
        ],
        buttons: [
            { title: 'Change', buttonClass: 'btn-warning', onClick: change },
            { title: 'Copy', buttonClass: 'btn-info', onClick: add }
        ]
    };
}]);

app.controller('AccountingTemplateDataCtrl', ['$rootScope', '$scope', '$modal', '$timeout', 'util', 'accounts', 'server', 'options', function($rootScope, $scope, $modal, $timeout, util, accounts, server, options) {

    $scope.add = !options.item && !(options.initial && options.initial.accounts);

    var getFields = function() {
        return _.findWhere($scope.config.tabs, { name: 'General' }).fields;
    };

    var addTag = function() {
        $modal.open({
            templateUrl: 'views/addmodal.html',
            controller: 'AddAccountingTemplateTagModalCtrl'
        }).result.then(function(tag) {
            $scope.config.data.tags.push(tag);
        });
    };

    var allAccountsSet = function() {
        return !getFields().filter(function(f) { return f.name && f.name.startsWith('account') && !f.value; }).length;
    };

    var accountsValid = function() {
        var fields = getFields();
        var typeFields = fields.filter(function(f) { return f.name && f.name.startsWith('type_') && !!f.value; });
        if (!typeFields || !typeFields.length) { return false; }

        var kreditPercent = 0;
        var debetPercent = 0;
        angular.forEach(typeFields, function(f) {
            var rowNr = f.name.split('_')[1];
            var percent = _.findWhere(fields, { name: 'percent_'+rowNr }).value;
            var type = f.value.id;
            if (type == 'kredit') {
                kreditPercent += percent;
            } else {
                debetPercent += percent;
            }
        });

        return kreditPercent == debetPercent;
    };

    var types = [
        { id: 'kredit', name: 'Kredit' },
        { id: 'debet', name: 'Debet' },
    ];

    var addRow = function() {

        var fields = getFields();
        var rowCount = fields.filter(function(f) { return f.name && f.name.startsWith('account'); }).length;
        var rowNr = rowCount + 1;

        var setAccount = function(value) {
            _.findWhere(fields, { name: 'account_'+rowNr }).value = value;
        };

        var label = { name: 'label_'+rowNr, title: util.t('Account')+' '+rowNr, type: 'label' };
        var account = accounts.getFieldsRow($scope, function() { return $rootScope.hasPermission('Accounting'); }, null, 'cost', null, 'account_'+rowNr, util.t('Account'), null, null, 'accounts_'+rowNr, setAccount);
        var percent = { name: 'percent_'+rowNr, title: util.t('Percentage'), required: true, type: 'infoNumber', info: '%', min: 1, max: 100, decimal: true };
        var type = { name: 'type_'+rowNr, title: 'Type', type: 'select', required: true, options: function() { return types; }, useId: true };

        var buttonIndex = _.findIndex(fields, function(f) { return f.name == 'add_account'; });
        fields.splice(buttonIndex, 0, type);
        fields.splice(buttonIndex, 0, percent);
        fields.splice(buttonIndex, 0, account);
        fields.splice(buttonIndex, 0, label);

        if ($scope.add && rowNr == 1) {
            $timeout(function() {
                account.value = _.findWhere(account.options(), { id: 'auto' });
                account.readonly = true;

                _.findWhere(fields, { name: 'percent_1' }).value = 100;
                percent.readonly = true;

                type.value = _.findWhere(types, { id: 'kredit' });
                type.getName = function() { return _.findWhere(types, { id: 'kredit' }).name; };
                type.readonly = true;
            }, 500);
        }
    };

    $scope.config = _.deep_extend(options.config, {
        url: {
            add: '/api/economy/accountingtemplate/add',
            change: '/api/economy/accountingtemplate/change',
        },
        datatype: 'accountingtemplate',
        data: {
            tags: server.get('/api/economy/accountingtemplate/tag/get'),
        },
        tabs: [
            {
                name: 'General',
                fields: [
                    { name: 'name', title: 'Name', type: 'text', required: true },
                    { name: 'description', title: 'Description', type: 'textarea', required: false },
                    { name: 'tags', title: 'Tags', type: 'multiselect', required: true, options: function() { return $scope.config.data.tags; }, useId: true, addButtonClicked: addTag, addButtonTitle: 'Add tag' },
                    { name: 'add_account', type: 'button', buttonTitle: 'Add additional account links', buttonClass: 'btn-primary', click: addRow, visible: allAccountsSet },
                    { hint: 'ACCOUNTINGTEMPLATE_CALCULATION_INFO' },
                    { hint: 'ACCOUNTINGTEMPLATE_MISMATCH_WARNING', hintClass: 'alert-warning', visible: function() { return !accountsValid(); } }
                ],
            },
        ],
        titleSuffix: function() {
            return util.t('accounting template');
        },
        getSubmitItem: function(item) {
            var item = $scope.config.control.getSubmitItem();

            var accountList = [];
            angular.forEach(Object.keys(item), function(key) {
                if (!key.startsWith('account')) { return; }
                var rowNr = key.split('_')[1];
                var account = item[key];
                if (account) {
                    var percent = item['percent_'+rowNr] || 0;
                    var type = item['type_'+rowNr];
                    accountList.push({ account: account , percent: percent, type: type });
                }
                delete item[key];
                delete item['label_'+rowNr];
                delete item['percent_'+rowNr];
                delete item['type_'+rowNr];
            });
            item.accounts = accountList;

            return item;
        },
        canSubmit: accountsValid,
        init: function() {
            var item = options.item || options.initial || {};
            if (!item) { return; }

            if (item.accounts) {
                item.accounts.forEach(function(a, index) {
                    index++;
                    if (index > 1) { addRow(); }
                    item['account_'+index] = a.account;
                    item['percent_'+index] = a.percent;
                    item['type_'+index] = a.type;
                    if (a.account == 'auto') {
                        _.findWhere(getFields(), { name: 'account_'+index }).readonly = true;
                    }
                });
            }
            return item;
        },
        afterInit: function(item) {
            $timeout(function() {
                var accountRows = getFields().filter(function(row) { return row.name && row.name.startsWith('account_'); });
                accountRows.forEach(function(row) {
                    if (row.readonly) { return; }
                    row.value = _.findWhere(row.options(), { id: item[row.name] });
                });
            });
        }
    });
    addRow();
    if ($scope.add) {
        addRow();
    }

}]);

app.controller('AddAccountingTemplateTagModalCtrl', ['$scope', '$controller', function($scope, $controller) {
    $controller('AddCtrl', {$scope: $scope});

    $scope.postUrl = '/api/economy/accountingtemplate/tag/add';
    $scope.callCloseOnSuccess = true;

    $scope.fields = [
        { name: 'name', title: 'Name', type: 'accountingTemplateTag', required: true }
    ];
}]);

app.controller('GetAccountingTemplateModalCtrl', ['$scope', 'util', function($scope, util) {
    var add = function() {
        var options = {};
        options.controller = 'AccountingTemplateDataCtrl';
        util.showDataDialog(options);
    };

    var choose = function(template) {
        $scope.$close(template);
    };

    $scope.config = {
        api: {
            url: '/api/economy/accountingtemplate/get',
            triggers: [{type: 'accountingtemplate'}]
        },
        searchButtons: [
            { title: 'Add accounting template', onClick: add },
        ],
        rowClick: choose,
        countSuffixList: ['template', 'templates'],
        customSearch: function(item, searchText) {
            searchText = searchText.toLowerCase();

            if (item.name.toLowerCase().includes(searchText) || (item.description && item.description.toLowerCase().includes(searchText))) {
                return true;
            }

            for (var i=0; i < item.tags.length; i++) {
                var tag = item.tags[i];
                if (tag.name.toLowerCase().includes(searchText)) {
                    return true;
                }
            }

            return false;
        },
        columns: [
            { field: 'name', title: 'Account name' },
            { field: 'description', title: 'Description' },
            { field: 'tags', title: 'Tags', getValue: function(t) { return _.pluck(t.tags, 'name').join(', '); } }
        ],
        buttons: [
            { title: 'Choose', buttonClass: 'btn-success', onClick: choose },
        ]
    };
}]);

app.controller('TestCtrl', ['$rootScope', '$scope', 'alertProvider','server', 'confirm', function($rootScope, $scope, alertProvider, server, confirm) {
    $scope.loadingStatus = {};
    $scope.reset = function() {
        confirm.show('Är du säker på att du vill återställa datat?').then(function() {
            $scope.loadingStatus.loading = true;
            server.post('/api/admin/test', {operation: 'reset_test_data'});
        });
    };
    $scope.toggleMailingTest = function() {
        confirm.show('Är du säker på att du vill aktivera/avaktivera utskick?').then(function() {
            $scope.loadingStatus.mailingloading = true;
            server.post('/api/admin/test', {operation: 'toggle_mailing'}).then(async function(result) {
                $scope.loadingStatus.mailingloading = false;
                if (!result.success) {
                    alertProvider.show('error', 'Misslyckades att aktivera/avaktivera utskick');
                } else {
                    if (result.data == 'false') { // false means that mailing ban is inactive
                        alertProvider.show('success', 'Utskick aktiverat');
                    } else if (result.data == 'true') { // true means that mailing ban is active
                        alertProvider.show('success', 'Utskick avaktiverat');
                    }
                }
            });
        });
    };
}]);

app.controller('WarningsCtrl', ['$rootScope', '$scope', 'customer', '$modal', 'util', function($rootScope, $scope, customer, $modal, util) {
    $scope.customer = customer;
    $scope.loadingStatus = {};

    $scope.showWorkout = function(warning) {
        $modal.open({
            templateUrl: 'views/workout.html',
            controller: 'WorkoutModalCtrl',
            resolve: {
                workout: function() {
                    return warning.workout;
                }
            }
        });
    };

    $scope.deprecate = function(warning) {
        $modal.open({
            templateUrl: 'views/deprecatewarning.html',
            controller: 'DeprecateWarningCtrl',
            resolve: {
                warning: function() {
                    return warning;
                }
            }
        });
    };

    $scope.config = {
        filter: [
            {name: 'fromDate', title: 'From', required: false, type: 'date' },
            {name: 'toDate', title: 'To', required: false, type: 'date' },
            {name: 'deprecated', title: 'Include deprecated', required: false, type: 'checkbox' }
        ],
        api: {
            url: '/api/member/warning/get',
            args: {
                user_id: customer.id
            },
            transform: $rootScope.transformWarning,
            triggers: [
                {
                    type: 'user',
                    condition: function(user) {
                        return user.id == customer.id;
                    }
                 }
            ]
        },
        countSuffixList: ['warning', 'warnings'],
        hideSearch: true,
        tableLimit: 10,
        orderColumn: 'created',
        columns: [
            {field: 'created', title: 'Date', format: 'date' },
            {field: 'workout.workoutType.name', title: 'Workout' },
            {field: 'workout.startTime', title: 'Time', format: 'time' },
            {field: 'reason', title: 'Reason' },
            {field: 'deprecated', title: 'Deprecated', format: 'date' },
            {field: 'deprecate_reason', title: 'Reason' }
        ],
        buttons: [
            {title: 'Show workout', onClick: $scope.showWorkout, visible: function(warning) { return warning.workout; }  },
            {title: 'Deprecate', buttonClass: 'btn-danger', onClick: $scope.deprecate, visible: function(warning) { return !warning.deprecated; } }
        ]
    };

    $scope.add = function() {
        $modal.open({
            templateUrl: 'views/addmodal.html',
            controller: 'WarningAddCtrl',
            resolve: {
                customer: function() {
                    return customer;
                }
            }
        });
    };

    $scope.changeBlock = function() {
        $modal.open({
            templateUrl: '/views/blocks.html',
            controller: 'BlocksCtrl',
            windowClass: 'very-large-modal-window',
            resolve: {
                customer: () => customer
            }
        });
    };

    $scope.getBlockMessage = function() {
        if (Date.isMaxDate($scope.customer.warnedUntil)) {
            return util.t('WBBLOCK_UFN');
        } else {
            return util.t('WBBLOCK').format($scope.customer.warnedUntil.yyyymmdd());
        }
    };
}]);

app.factory('blockutil', ['$filter', function($filter) {
    let blockutil = {};

    blockutil.blocktypes = [
        {id: 'block_entry', name: 'Entry'},
        {id: 'block_autogiro', name: 'Sign direct debit'},
        {id: 'block_grouptraining', name: 'Group workout'},
        {id: 'block_course', name: 'Course booking'},
        {id: 'block_resourcebooking', name: 'Resource booking'},
        {id: 'block_teamsport', name: 'Competition'}
    ];
    blockutil.orderByTranslatedName = t => $filter('translate')(t.name);

    return blockutil;
}]);

app.controller('BlockDataCtrl', ['$rootScope', '$scope', 'blockutil', 'util', 'server', 'options', function($rootScope, $scope, blockutil, util, server, options) {
    function blocksChanged(field) {
        if (!options.item) {
            return true;
        }
        let initial = blockutil.blocktypes.filter(t => options.item[t.id]).map(t => t.id);
        let now = field.value.map(x => x.id)
        return !util.arraysEqual(initial, now);
    }

    let workouts =  [];

    function updateWorkouts() {
        if (!$scope.config.control.getField('cancel').value) {
            workouts = [];
            $scope.config.control.getField('workoutsToCancel').value = [];
        } else {
            let user_id = $scope.config.control.getField('user_id').value.id;
            server.get('/api/workoutBooking/getForMember', {member: user_id}).then(res => {
                workouts = res
                $scope.config.control.getField('workoutsToCancel').value = res.concat();
            });
        }
    }

    function workoutsInRange(workout) {
        let from = $scope.config.control.getField('fromDate').value
        let to = $scope.config.control.getField('toDate').value
        return !to || Date.newFull(workout.startTime).withinRange(from, to);
    }

    function displayWorkout(workout) {
        return workout.workoutType.name + ", " + workout.startTime;
    }

    function setToDate() {
        if (!$scope.config.control.getField('untilFurtherNotice').value) {
            $scope.config.control.getField('toDate').value = $scope.config.control.getField('fromDate').value.clone().addDays(30);
        }
    }

    $scope.config = _.deep_extend(options.config, {
        datatype: 'block',
        url: {
            add: '/api/block/add',
            change: '/api/block/change'
        },
        tabs: [
            {
                name: 'General',
                fields: [
                    {name: 'user_id', title: 'Customer', type: 'customer', required: true, useId: true, readonly: options.initial?.user_id || options.item, change: updateWorkouts },
                    {name: 'responsible_id', title: 'Responsible', type: 'customer', useId: true, itemTypes: ['staff'] },
                    {name: 'fromDate', title: 'From date', type: 'date', required: true },
                    {name: 'untilFurtherNotice', title: 'Until further notice', type: 'checkbox', changed: () => false, change: setToDate},
                    {name: 'toDate', title: 'To date', type: 'date', visible: '!untilFurtherNotice', required: true, invisibleValue: null },
                    {name: 'blocks', title: 'Block from', type: 'multiselect', required: true, useId: true, options: () => blockutil.blocktypes, orderPredicate: blockutil.orderByTranslatedName, changed: blocksChanged },
                    {name: 'note', title: 'Internal note', type: 'textarea', required: false },
                    {name: 'message', title: 'Message to customer', type: 'textarea', required: false, helpText: 'HELPTEXT_BLOCK_MESSAGE' }
                ]
            },
            {
                name: 'Workout bookings',
                visible: () => !options.item,
                fields: [
                    {name: 'cancel', title: 'Cancel workouts', type: 'checkbox', change: updateWorkouts},
                    {name: 'workoutsToCancel', title: 'Workouts', type: 'multiselect', options: () => workouts, optionsFilter: workoutsInRange, useId: true, visible: 'cancel', getName: displayWorkout, placeholder: 'Select workouts to cancel'}
                ]
            }
        ],
        getSubmitItem() {
            let item = $scope.config.control.getSubmitItem();
            blockutil.blocktypes.forEach(t => {
                item[t.id] = item.blocks.includes(t.id)
            })
            if (item.untilFurtherNotice) {
                item.toDate = null;
            }
            delete item.blocks;
            delete item.untilFurtherNotice;
            return item;
        },
        init() {
            if (options.item) {
                let item = Object.assign({}, options.item);
                item.blocks = blockutil.blocktypes.filter(t => item[t.id]);
                if (!item.toDate) {
                    item.untilFurtherNotice = true;
                }
                return item;
            }
        }
    });
}]);

app.controller('BlocksCtrl', ['$rootScope', '$scope', 'confirm', 'util', 'server', 'blockutil', 'cashiers', '$location', 'customer', function($rootScope, $scope, confirm, util, server, blockutil, cashiers, $location, customer) {
    $scope.customer = customer;

    function remove(block) {
        confirm.show('Are you sure you want to remove the block?', {ladda: true}).then((resolve) => {
            server.post('/api/block/remove', null, {id: block.id}, '{0} was removed', 'Failed to remove {0}', 'Block').then(resolve);
        })
    }

    function add() {
        util.showDataDialog({
            controller: 'BlockDataCtrl',
            initial: {
                user_id: customer.id,
                responsible_id: $rootScope.currentStaffId,
                fromDate: Date.today(),
                toDate: Date.today().addDays(30)
            }
        });
    }

    function change(item) {
        util.showDataDialog({controller: 'BlockDataCtrl', item})
    }

    function getBlockText(b) {
        return blockutil.blocktypes.filter(t => b[t.id]).map(t => util.t(t.name)).join(', ')
    }

    function getTypeString(b) {
        const types = {
            'manual': 'Manually created',
            'warning': 'Automatic on warnings',
            'debt': 'Automatic on debt'
        }
        return util.t(types[b.type])
    }

    function deprecate(block) {
        confirm.show('Are you sure you want to deprecate this block?', {ladda: true}).then(resolve => {
            server.post('/api/block/deprecate', null, {id: block.id}).then(resolve);
        });
    }

    function getDeprecatedText(b) {
        const types = {
            'fee': 'Fee paid',
            'staff': 'Deprecated by staff'
        }
        return util.t(types[b.deprecated]);
    }

    function canPay(b) {
        if (b.type != 'warning' || (b.toDate && b.toDate < Date.now())) {
            return false;
        }
        let blockFee = _.findWhere($rootScope.getActiveProducts(), {blockFee: true});
        return blockFee && $rootScope.hasPermission('Checkout handling');
    }

    function pay(b) {
        let blockFee = _.findWhere($rootScope.getActiveProducts(), {blockFee: true});
        cashiers.transfer({customer: b.user, purchase: true, basket: [{product: blockFee, count: 1, price: blockFee.price}] });
        var search = {};
        if (b.user && b.user.id) search.customer_id = b.user.id;
        search.items = JSON.stringify([{k: 'p', id: blockFee.id, c: 1, p: blockFee.price}]);
        $location.path('/checkout').search(search);
        $scope.$close();
    }

    function visibleColumn(config, column) {
        if (config.context && config.context.columns) {
            return config.context.columns.indexOf(column.field) != -1;
        }
    }

    function getToDate(b) {
        return b.toDate || util.t('Until further notice');
    }

    $scope.config = {
        api: {
            url: '/api/block/get',
            args: {
                user_id: customer.id
            },
            transform: $rootScope.transformBlock,
            triggers: [
                {
                    type: 'block',
                    condition: b => b.user_id == customer.id
                }
            ]
        },
        rowClick: change,
        countSuffixList: ['block', 'blocks'],
        tabs: [
            {
                name: 'Blocks',
                badgeClass: 'badge-success',
                itemFilter: b => !b.toDate || b.toDate >= Date.now(),
                context:
                {
                    columns: ['fromDate', 'toDate', 'type', 'blocks', 'responsible.name']
                }
            },
            {
                name: 'History',
                itemFilter: b => b.toDate && b.toDate < Date.now(),
                context:
                {
                    columns: ['fromDate', 'toDate', 'type', 'blocks', 'responsible.name', 'deprecated']
                }
            }
        ],
        columns: [
            {field: 'fromDate', title: 'From date', format: 'date', visible: visibleColumn },
            {field: 'toDate', title: 'To date', format: 'date', visible: visibleColumn, getValue: getToDate },
            {field: 'type', title: 'Type', getValue: getTypeString, visible: visibleColumn },
            {field: 'blocks', title: 'Block from', getValue: getBlockText, visible: visibleColumn},
            {field: 'responsible.name', title: 'Responsible', visible: visibleColumn},
            {field: 'deprecated', title: 'Deprecated', getValue: getDeprecatedText, visible: visibleColumn }
        ],
        buttons: [
            {title: 'Pay at checkout', buttonClass: 'btn-success', onClick: pay, visible: canPay},
            {title: 'Change', buttonClass: 'btn-warning', onClick: change},
            {title: 'Deprecate', buttonClass: 'btn-warning', onClick: deprecate, visible: b => (!b.toDate || b.toDate >= Date.now()) && b.type != 'debt' },
            {title: 'Remove', buttonClass: 'btn-danger', onClick: remove, visible: b => b.type != 'debt'}
        ],
        searchButtons: [
            { title: 'Add', showOnEmpty: true, onClick: add}
        ]
    };
}]);


app.controller('DeprecateWarningCtrl', ['$rootScope', '$scope', '$controller', 'warning', function($rootScope, $scope, $controller, warning) {
    $controller('ChangeModalCtrl', {$scope: $scope});

    $scope.item = warning;

    $scope.postUrl = '/api/member/warning/deprecate';
    $scope.successTitle = 'Warning was deprecated';
    $scope.failedTitle = 'Failed to deprecate warning';

    $scope.fields = [
        {name: 'reason', title: 'Reason', type: 'textarea', required: false }
    ];
}]);

app.controller('WarningAddCtrl', ['$rootScope', '$scope', '$controller', '$filter', 'customer', function($rootScope, $scope, $controller, $filter, customer) {
    $controller('AddCtrl', {$scope: $scope});

    $scope.postUrl = '/api/member/warning/add';

    $scope.callCloseOnSuccess = true;

    $scope.titleSuffix = function() {
        return $filter('translate')('warning') + ' ' + $filter('translate')('for') + ' ' + customer.name;
    };

    var oldGetSubmitItem = $scope.getSubmitItem;
    $scope.getSubmitItem = function() {
        var item = oldGetSubmitItem();
        item.member = customer.id;
        return item;
    };

    $scope.fields = [
        {name: 'reason', title: 'Reason', type: 'textarea', required: true }
    ];
}]);

app.controller('UserGroupDataCtrl', ['$rootScope', '$scope', 'server', '$modal', '$filter', 'options', '$q', function($rootScope, $scope, server, $modal, $filter, options, $q) {
    function getPermissions() {
        return server.get('/api/staff/permissions/get').then(function(permissions) {
            permissions.forEach(function(p) {
                p.name = $filter('translate')(p.id);
            });
            return permissions;
        });
    }

    function isGroupMember(u) {
        const users =  $scope.config.control.getField('users').value;
        const userIds = users.map(u => u.id);
        const userId = _.isObject(u) ? u.id : u;
        return userIds.includes(userId);
    }

    function usersChanged() {
        var users =  $scope.config.control.getField('users').value;
        var responsible =  $scope.config.control.getField('responsible').value;
        if (responsible.value) {
            responsible.value = responsible.value.filter(function(r) {
                return _.findWhere(users, {id: r.id});
            });
        }
    }

    if(options.config.item) {
        options.config.item.type = options.config.item.type === 'family'?'family':options.config.item.teamsport_id
    }

    function getGroups() {
        var defer = $q.defer();

        if ($rootScope.hasModule('TeamSports')) {
            server.get('/api/teamsport/get').then(function(data) {
                defer.resolve([{'id': 'family', name: 'Family'}, ...data]);
            });
        }
        else {
            defer.resolve([{'id': 'family', name: 'Family'}]);
        }

        return defer.promise;
    }

    function typeGrouping(g) {
        return g.id == 'family'?null:'Sport';
    }

    // The other options are sport names from customer data. Only 'Family' is a built-in option, so only it is translated.
    function getTypeName(option) {
        return option.id === 'family' ? $filter('translate')('Family') : option.name;
    }

    function isFamilyGroup() {
        var value = $scope.config.control.getField('type').value;
        return value && value.id === 'family';
    }

    $scope.config = _.deep_extend(options.config, {
        datatype: 'group',
        url: {
            add: '/api/usergroup/add',
            change: '/api/usergroup/change'
        },
        data: {
            permissions: getPermissions(),
            groups: getGroups()
        },
        tabs: [
            {
                name: 'General',
                fields: [
                    {name: 'name', title: 'Group name', type: 'text', required: true },
                    {name: 'change_permission', title: 'Access right required to change the group', required: false, type: 'select', options: function() { return $scope.config.data.permissions; }, useId: true, placeholder: 'No permission required', visible: function() {return !isFamilyGroup();}, helpText: 'HELPTEXT_CHANGE_PERMISSION' },
                    {name: 'users', title: 'Add people to the group', type: 'customers', required: false, useId: true, itemTypes: ['customer'], change: usersChanged },
                    {name: 'responsible', title: 'Responsible for the group', type: 'customers', required: false, useId: true, itemTypes: ['customer'], itemFilter: isGroupMember, options: {hideGroup: true, getItems: () => ($scope.config.control.getField('users').value || []).map($rootScope.getMember) }, helpText: 'HELPTEXT_RESPONSIBLE' },
                    {name: 'imagekey', title: 'Image', type: 'field', field: 'image-storage', option: {originType: 'usergroup', imageOnly: true, squareThumbnail: true}},
                    {name: 'type', title: 'Type of group', type: 'select', required: false, useId: true, options: function() { return $scope.config.data.groups; }, placeholder: 'Not connected to any sport', group: typeGrouping, skipTranslation: true, getName: getTypeName },
                    {name: 'show', title: 'Show for group members', type: 'checkbox', visible: function() {return !isFamilyGroup();}, helpText: 'HELPTEXT_SHOW_FOR_GROUP' }
                ]
            }
        ],
        canSubmit: function() {
            var users = $scope.config.control.getField('users').value;
            var responsible =  $scope.config.control.getField('responsible').value;
            if (responsible && responsible.length) {
                return _.every(responsible, function(r) {
                    return _.findWhere(users, {id: r.id});
                });
            }
            return true;
        },
        beforeSubmit: function(item) {
            return $q.promise(function(resolve) {
                item.teamsport_id = null;
                if(item.type) {
                    if(item.type === 'family') {
                        item.type = 'family';
                    } else {
                        item.teamsport_id = item.type;
                        item.type = 'teamsport';
                    }
                }
                resolve(item);
            });
        }
    });
}]);

app.controller('UserGroupCtrl', ['$rootScope', '$scope', '$modal', 'confirm', 'server', 'util', 'alertProvider', function($rootScope, $scope, $modal, confirm, server, util, alertProvider) {
    $scope.loadingStatus = {};
    $scope.add = function() {
        util.showDataDialog({controller: 'UserGroupDataCtrl' });
    };

    $scope.change = function(group) {
        $rootScope.getGroupAsync(group.id).then(fullGroup => {
            util.showDataDialog({controller: 'UserGroupDataCtrl', item: fullGroup });
        });
    };

    $scope.remove = function(group) {
        confirm.show('Are you sure you want to remove the group?').then(function() {
            server.post('/api/usergroup/remove', null, {usergroup_id: group.id}, '{0} was removed', 'Failed to remove {0}', 'Group');
        });
    };

    function canChange(group) {
        return $rootScope.hasPermission(group.change_permission);
    }

    function getExcel() {
        $scope.loadingStatus.getExcel = true;
        var tab = $scope.config.control.getActiveTab();
        tab.config.getItems().then(function(groups) {
            const filtered = tab.config.itemFilter ? groups.filter(tab.config.itemFilter) : groups;
            const ids = filtered.map(g => g.id);
            server.post('/api/usergroup/get_excel', {ids}, null, null, null, null, {responseType: 'blob'}).then(function(response) {
                if (response.success) {
                    util.download(util.t('Groups') + '.xlsx', null, null, response.data);
                } else {
                    alertProvider.show('error', 'Error');
                }

                $scope.loadingStatus.getExcel = false;
            });
        });
    }

    function sendMailing() {
        var tab = $scope.config.control.getActiveTab();
        var filtered = tab.config.control.getFilteredItems();
        $modal.open({
            templateUrl: 'views/groupsendmailingmodal.html',
            controller: 'GroupSendMailingModalCtrl',
            resolve: {
                groups: function() {
                    return filtered;
                }
            }
        });
    }

    function filterVisible() {
        if (!$scope.config.control) { return false; }
        var activeTab = $scope.config.control.getActiveTab();
        return activeTab.name === 'All';
    }

    function teamsportVisible() {
        return $rootScope.hasModule('TeamSports') && filterVisible();
    }

    var resulttypes = [{id: 'true', name: 'Yes'}, {id: 'false', name: 'No'}];
    var initialItems = $rootScope.speedy ? null : () => $rootScope.usergroups;

    function buildConfig() {
        $scope.config = {
            api: {
                initialItems,
                url: '/api/usergroup/search',
                triggers: [{ type: 'usergroup' }],
                transform: function(g) {
                    g.last_registration = Date.newFull(g.last_registration);
                    return g;
                },
                debounce: 'queue'
            },
            data: {
                teamsports: $scope.teamsports
            },
            tabs: $scope.tabs,
            countSuffixList: ['group', 'groups'],
            rowClick: $scope.showGroup,
            orderColumn: 'name',
            giveFocus: function() {
                return false;
            },
            searchButtons: [
                { title: 'Download as Excel', onClick: getExcel, loading: () => $scope.loadingStatus.getExcel },
                { title: 'Send mailing', onClick: sendMailing },
                { title: 'Add new group', onClick: $scope.add }
            ],
            filter: [
                { name: 'teamsports', title: 'Sport', required: false, type: 'multiselect', placeholder: 'Show all', options: function() { return $scope.teamsports; }, visible: teamsportVisible, skipTranslation: true, getValue: function(f) { return _.pluck(f.value, 'id').join(','); } },
                { name: 'registered', title: 'Registered on competition', required: false, type: 'select', placeholder: 'Show all', options: function() { return resulttypes; }, visible: teamsportVisible, useId: true },
                { name: 'fromDate', title: 'Participated in competition - From', required: false, type: 'date', visible: teamsportVisible },
                { name: 'toDate', title: 'Participated in competition - To', required: false, type: 'date', visible: teamsportVisible },
                { name: 'unpaid', title: 'Unpaid', required: false, type: 'select', placeholder: 'Show all', options: function() { return resulttypes; }, visible: teamsportVisible, useId: true },
                { name: 'visibleForCustomer', title: 'Show for customers', required: false, type: 'select', placeholder: 'Show all', options: function() { return resulttypes; }, visible: filterVisible, useId: true }
            ],
            columns: [
                {field: 'name', title: 'Name', format: 'image', text: function(g) { return g.name; }, src: function(g) { return $rootScope.image('usergroup', g, 50); } },
                {field: 'users', title: 'Number of persons', format: 'count'},
                {field: 'change_permission', title: 'Access right', format: 'translated'},
                {field: 'last_registration', title: 'Last registration', format: 'date', visible: function() { return $rootScope.hasModule('TeamSports'); }}
            ],
            buttons: [
                {title: 'Change', onClick: $scope.change, buttonClass: 'btn-warning', visible: canChange },
                {title: 'Show', onClick: $scope.showGroup, buttonClass: 'btn-success' },
                {title: 'Remove', buttonClass: 'btn-danger', onClick: $scope.remove, visible: canChange }
            ],
        };
    }

    function buildTabs() {
        var tabs = [
            { name: 'All', badgeClass: 'badge-success' },
            { name: 'Families', badgeClass: 'badge-success', itemFilter: function(group) {return group.type === 'family';} }
        ];

        function finishTabs() {
            $scope.tabs = tabs;
            buildConfig();
        }

        if ($rootScope.hasModule('TeamSports')) {
            server.get('/api/teamsport/get').then(function(teamsports) {
                $scope.teamsports = teamsports;
                tabs = _.union(tabs,
                    [{ name: 'Not connected to sport', itemFilter: function(group) { return !group.type && !group.teamsport_id; }, badgeClass: 'badge-success' }],
                    teamsports.map(function(t) { return { name: t.name, itemFilter: function(group) { return group.teamsport_id === t.id; }, badgeClass: 'badge-success' }; })
                );
                finishTabs();
            });
        } else {
            finishTabs();
        }
    }
    buildTabs();
}]);

app.controller('GroupModalCtrl', ['$rootScope', '$scope', '$modal', '$location', 'server', 'teamsportutil', 'confirm', '$filter', 'live', 'util', 'group',
    function($rootScope, $scope, $modal, $location, server, teamsportutil, confirm, $filter, live, util, group) {

    $scope.group = group;
    $scope.titleSuffix = group.name;

    $scope.loadingStatus = {};

    var transformGroup = function() {
        $rootScope.transformUserGroup($scope.group);
        if ($rootScope.hasModule('TeamSports')) {
            server.get('/api/teamsport/team/get_for_group', { group: $scope.group.id }).then(function(teams) {
                angular.forEach(teams, function(t) {
                    t.gameclass = teamsportutil.transformGameClass(t.gameclass);
                });
                $scope.group.teams = teams;
            });
        }
    };
    transformGroup();

    $scope.sendMailing = function() {
        var modalInstance = $modal.open({
            templateUrl: 'views/groupsendmailingmodal.html',
            controller: 'GroupSendMailingModalCtrl',
            resolve: {
                groups: function() {
                    return [$scope.group];
                }
            }
        });
        modalInstance.result.then($scope.$close);
    };

    $scope.change = function() {
        var modalInstance = util.showDataDialog({controller: 'UserGroupDataCtrl', item: $scope.group });
        modalInstance.result.then(function(changedGroup) {
            $scope.group = changedGroup;
            transformGroup();
        });
    };

    function goToGameClass(team) {
        $scope.$close();
        $location.path('/teamsports/gameclass/' + team.gameclass_id);
    }

    function isCardValid(card, date, trainings) {
        if (!trainings) {
            trainings = 1;
        }
        var validToDate = !card.validToDate || date < card.validToDate.clone().addDays(1);
        var notvalidFromDate = card.validFromDate > date;
        var validFromDate = !notvalidFromDate;
        var trainingsLeft = card.trainingsLeft >= trainings || card.trainingsLeft === null;
        if (validToDate && validFromDate && trainingsLeft) {
            return true;
        }
        return false;
    }

    $scope.addTrainingCard = function() {
        var modalInstance = $modal.open({
            templateUrl: 'views/getcustomermodal.html',
            controller: 'GetCustomerCtrl',
            windowClass: 'huge-modal-window',
            resolve: {
                options: function() {
                    return { itemFilter: function(u) { return _.findWhere($scope.group.users, { id: u.id }); } };
                }
            }
        });

        modalInstance.result.then(function (customer) {
            $rootScope.showCombo({customer: customer, group: $scope.group});
        });
    };

    function removeCompetition(team) {
        var message = $filter('translate')('Are you sure you want to unregister team "{0}" from competition "{1}"?').format(team.name, team.gameclass.competition.name);
        confirm.show(message, {ladda: true}).then(function(resolve) {
            server.post('/api/memberapi/teamsport/competition/unregister', null, { team_id: team.id }, 'Booking removed', 'Failed to remove booking').then(resolve);
        });
    }

    function canUnregister(team) {
        if (!team) { return false; }
        if (!team.gameclass.competition.lastCancellationDate) { return false; }
        return team.gameclass.competition.lastCancellationDate.isFuture();
    }

    $scope.trainingCardConfig = {
        getItems: function() {
            return $scope.group.trainingcards;
        },
        itemFilter: function(t) {
            return isCardValid(t, Date.today());
        },
        rowClick: function(t) {
            $scope.$close();
            $rootScope.gotoCustomer(t.user);
        },
        hideSearch: true,
        columns: [
            {field: 'cardtype_name', title: 'Name'},
            {field: 'user.name', title: 'Owner'},
            {field: 'validToDate', title: 'Valid to', getValue: function(tc) { return tc.validToDate && tc.validToDate.yyyymmdd(); }}
        ]
    };

    $scope.competitionConfig = {
        getItems: function() {
            return $scope.group.teams || [];
        },
        tabs: [
            {name: 'Active', itemFilter: function(team) { return team.gameclass.competition.endDate.isFuture(); }, badgeClass: 'badge-success' },
            {name: 'Inactive', itemFilter: function(team) { return !team.gameclass.competition.endDate.isFuture(); } }
        ],
        hideSearch: true,
        rowClick: goToGameClass,
        columns: [
            {field: 'gameclass.competition.name', title: 'Competition'},
            {field: 'gameclass.name', title: 'Game class'},
            {field: 'name', title: 'Team name'},
            {field: 'gameclass.competition.startDate', title: 'Start date', format: 'date'}
        ],
        buttons: [
            {title: 'Unregister', buttonClass: 'btn-danger', onClick: removeCompetition, visible: canUnregister }
        ]
    };

    live.subscribe({
        type: 'trainingcard',
        scope: $scope,
        callback: function(_tc, event) {
            event.data.forEach(function(tc) {
                if (tc.groups.indexOf($scope.group.id) == -1) { return; }

                var index = _.findIndex($scope.group.trainingcards, function(t) { return tc.id === t.id; });
                if (event.action == 'remove') {
                    if (index != -1) {
                        $scope.group.trainingcards.splice(index, 1);
                    }
                } else {
                    tc = $rootScope.transformTrainingCard(tc);
                    tc.user = $rootScope.getMember(tc.user_id);
                    if (event.action == 'add') {
                        $scope.group.trainingcards.push(tc);
                    } else {
                        $scope.group.trainingcards[index] = tc;
                    }
                }
            });
        }
    });

    live.subscribe({
        type: 'team',
        scope: $scope,
        callback: function(_team, event) {
            event.data.forEach(function(team) {
                if ($scope.group.id != team.group.id) { return; }

                var index = _.findIndex($scope.group.teams, function(t) { return team.id === t.id; });
                if (event.action == 'remove') {
                    if (index != -1) {
                        $scope.group.teams.splice(index, 1);
                    }
                } else {
                    server.get('/api/teamsport/gameclass/get', { id: team.gameclass_id }).then(function(gc) {
                        team.gameclass = teamsportutil.transformGameClass(gc);
                        if (index == -1) {
                            $scope.group.teams.push(team);
                        } else {
                            $scope.group.teams[index] = team;
                        }
                    });
                }
            });
        }
    });
}]);

app.controller('GroupSendMailingModalCtrl', ['$rootScope', '$scope', '$location', 'groups', function($rootScope, $scope, $location, groups) {
    $scope.title = 'Mailing';
    $scope.groups = groups;

    var sendMailing = function(receivers) {
        $scope.$close();
        $scope.pubsub.publish('newmailingdata', {
            isNewsOrAdvertising: false,
            sendOption: 'mail',
            receivers: receivers
        });
        $location.path('/mailings/new');
    };

    $scope.sendMailingToGroupMembers = function() {
        var receivers = _.uniq(_.flatten(_.map($scope.groups, function(group) {
            return _.map(group.users, $rootScope.getMember);
        })));
        sendMailing(receivers);
    };

    $scope.sendMailingToGroupResponsible = function() {
        var receivers = _.uniq(_.flatten(_.map($scope.groups, function(group) {
            return _.map(group.responsible, $rootScope.getMember);
        })));
        sendMailing(receivers);
    };

}]);

app.controller('AccessRightListCtrl', ['$rootScope', '$scope', '$controller', '$filter', '$modal', 'server', 'confirm', function($rootScope, $scope, $controller, $filter, $modal, server, confirm) {
    function remove(accessright) {
        confirm.show('Are you sure you want to remove the access right?', {ladda: true}).then(function(resolve) {
            server.post('/api/staff/permissions/remove', {id: accessright.id }, null, '{0} was removed', 'Failed to remove {0}', 'Access right').then(resolve);
        });
    }

    $scope.config = {
        api: {
            url: '/api/staff/permissions/get',
            triggers: [{type: 'permissiontask'}, {type: 'role'}],
            transform: function(p) {
                p.tname = $filter('translate')(p.id);
                return p;
            }
        },
        giveFocus: function() { return false; },
        orderColumn: 'id',
        countSuffixList: ['access right', 'access rights'],
        columns: [
            {field: 'id', title: 'Name', format: 'translated'},
            {field: 'roles', title: 'Roles', format: 'translatedCommaList'}
        ],
        buttons: [
            {title: 'Remove', buttonClass: 'btn-danger', onClick: remove, visible: function(p) { return !p.builtIn; } }
        ]
    };
}]);

app.controller('StaffAddModalCtrl', ['$scope', '$controller', function($scope, $controller) {
    $controller('StaffAddCtrl', {$scope: $scope});
    $scope.callCloseOnSuccess = true;
}]);


app.controller('GetAccountsCtrl', ['$rootScope', '$scope', '$modal', '$filter', '$controller', 'server', 'options', 'accounts', function($rootScope, $scope, $modal, $filter, $controller, server, options, accounts) {
    $controller('AddCtrl', {$scope: $scope});

    accounts.getAll().then(function(a) {
        $scope.accounts = [];
        a = a.filter(accounts.isSale).filter(function(ac) { return !accounts.isRounding(ac); });
        angular.forEach(a, function(ac) {
            ac = angular.copy(ac);
            ac.name = ac.name + ' (' + ac.id + ')';
            $scope.accounts.push(ac);
        });

        $scope.fields = [];
        [0,6,12,25].forEach(function(vat, idx) {
            var value;
            if (options.selected) {
                if (_.isArray(options.selected)) {
                    value = options.selected[idx];
                } else {
                    value = options.selected;
                }
                value = _.findWhere($scope.accounts, {id: Number(value)});
            }
            $scope.fields.push(
                {name: String(vat), title: vat + ' %', required: true, type: 'select', options: function() {return $scope.accounts; }, useId: true, orderPredicate: 'id', value: value }
            );
        });
    });

    $scope.submit = function() {
        var res;
        var item = $scope.getSubmitItem();
        if (item[0] == item[6] && item[6] == item[12] && item[12] == item[25]) {
            res = String(item[0]);
        } else {
            res = [item[0], item[6], item[12], item[25]];
        }

        $scope.$close(res);
    };
}]);

app.controller('SettingsPrinterCtrl', ['$rootScope', '$scope', '$modal', '$filter', 'server', 'confirm', function($rootScope, $scope, $modal, $filter, server, confirm) {
    $scope.printing = {};
    $scope.add = function() {
        $modal.open({
            templateUrl: 'views/addmodal.html',
            controller: 'PrinterAddCtrl'
        });
    };

    $scope.change = function(printer) {
        $modal.open({
            templateUrl: 'views/changemodal.html',
            controller: 'PrinterChangeCtrl',
            resolve: {
                printer: function() {
                    return printer;
                }
            }
        });
    };

    $scope.test = function(printer) {
        $scope.printing[printer.id] = true;
        server.post('/api/printer/test', null, {printer_id: printer.id}).then(function() {
            $scope.printing[printer.id] = false;
        });
    };

    function remove(printer) {
        confirm.show('Are you sure you want to remove the printer?', {ladda: true}).then(function(resolve) {
            server.post('/api/printer/remove', null, {id: printer.id }, '{0} was removed', 'Failed to remove {0}', 'Printer').then(resolve);
        });
    }

    $scope.config = {
        filter: [],
        api: {
            url: '/api/printer/get',
            transform: function(p) {
                p.created = Date.newFull(p.created);
            },
            triggers: [{ type: 'printer' }]
        },
        countSuffixList: ['printer', 'printers'],
        hideSearch: true,
        tableLimit: 10,
        orderColumn: 'name',
        columns: [
            {field: 'name', title: 'Name' },
            {field: 'type', title: 'Type', getValue: function(p) { return p.type == 'email' ? $filter('translate')('E-mail') : 'Star cloudPRNT'; } },
            {field: 'url', title: 'URL', getValue: function(p) { return p.type == 'cloud' ? 'https://' + window.location.host + '/api/printer/poll' : ''; } }
        ],
        buttons: [
            {title: 'Print test page', buttonClass: 'btn-success', onClick: $scope.test, loading: function(printer) { return $scope.printing[printer.id];} },
            {title: 'Change', buttonClass: 'btn-warning', onClick: $scope.change },
            {title: 'Remove', buttonClass: 'btn-danger', onClick: remove }
        ]
    };
}]);

app.controller('PrinterAddCtrl', ['$rootScope', '$scope', '$controller', '$filter', function($rootScope, $scope, $controller, $filter) {
    $controller('AddCtrl', {$scope: $scope});

    $scope.titleSuffix = function() {
        return $filter('translate')('printer');
    };

    $scope.postUrl = '/api/printer/add';

    $scope.callCloseOnSuccess = true;

    $scope.types = [
        {id: 'email', name: 'E-mail'},
        {id: 'cloud', name: 'Star cloudPRNT'}
    ];

    $scope.isMail = function() {
        var type = _.findWhere($scope.fields, {name: 'type'}).value;
        return type && type.id == 'email';
    };

    $scope.isCloud = function() {
        var type = _.findWhere($scope.fields, {name: 'type'}).value;
        return type && type.id == 'cloud';
    };

    $scope.fields = [
        {name: 'name', title: 'Name', type: 'text', required: true },
        {name: 'type', title: 'Type', type: 'select', required: true, options: function() { return $scope.types; }, useId: true },
        {name: 'mail', title: 'E-mail', type: 'email', required: true, visible: $scope.isMail }
    ];
}]);

app.controller('PrinterChangeCtrl', ['$rootScope', '$scope', '$controller', 'printer', function($rootScope, $scope, $controller, printer) {
    $controller('PrinterAddCtrl', {$scope: $scope});
    $controller('ChangeModalCtrl', {$scope: $scope});

    $scope.titleSuffix = function() {
        return printer.name;
    };

    $scope.item = printer;

    $scope.postUrl = '/api/printer/change';

    $scope.setValues($scope.item);
}]);

app.controller('InviteAddModalCtrl', ['$rootScope', '$scope', '$controller', 'util', 'workout', 'invites', '$filter', 'server', function($rootScope, $scope, $controller, util, workout, invites, $filter, server) {
    $controller('AddCtrl', {$scope: $scope});

    var alreadyInvitedOrBooked = [];
    workout.bookings.forEach(function(wb) {
        alreadyInvitedOrBooked.push(wb.user);
    });
    invites.forEach(function(i) {
        alreadyInvitedOrBooked.push(i.user);
    });

    var sendTypes = [{id: 'mail', name: 'E-mail'}];
    if ($rootScope.hasModule('SMS')) {
        sendTypes.push({id: 'sms', name: 'SMS'});
    }

    function notAlreadyInvitedOrBooked(u) {
        return !_.findWhere(alreadyInvitedOrBooked, {id: u.id});
    }

    function getSendType() {
        var s = _.findWhere($scope.fields, {name: 'sendtype'}).value;
        return s && s.id;
    }

    function getNumberOfReciptients() {
        var r = _.findWhere($scope.fields, {name: 'recipients'}).value;
        var res = r ? r.length : 0;
        if (getSendType() == 'sms') {
            return res;
        }

        var rn = _.findWhere($scope.fields, {name: 'recipients_nomembers'}).value;
        if (!rn) {
            return res;
        }

        return res + rn.split(/[\s,]+/).length;
    }

    function parseReciptients() {
        if (getSendType() == 'sms') {
            return true;
        }

        var rn = _.findWhere($scope.fields, {name: 'recipients_nomembers'}).value;
        if (!rn) {
            return true;
        }

        return _.all(rn.split(/[\s,]+/), util.isValidMail);
    }


    $scope.title = 'Send invitation';
    $scope.postUrl = '/api/workoutBooking/invites/add';
    $scope.callCloseOnSuccess = true;
    $scope.fields = [
        {name: 'sendtype', title: 'Send as', type: 'select', options: function() { return sendTypes; }, required: true, value: sendTypes[0], useId: true },
        {hint: 'INVITEHINT', visible: function() { return getSendType() == 'mail'; } },
        {name: 'recipients', title: 'Recipients', required: false, type: 'customers', useId: true, itemTypes: ['customer'], itemFilter: notAlreadyInvitedOrBooked },
        {name: 'recipients_nomembers', title: 'E-mail addresses no customers', type: 'textarea', required: false, visible: function() { return getSendType() == 'mail'; } },
        {name: 'message', title: 'Message', type: 'htmleditor', required: true, visible: function() { return getSendType() == 'mail'; } },
        {name: 'message_sms', title: 'Message', type: 'textarea', required: true, visible: function() { return getSendType() == 'sms'; }}
    ];

    var getTemplates = function(){
        server.get('/api/mailing/template/get/all').then(res => {
            var mailTemplate = res.find(t => $filter('translate')(t.name) == $filter('translate')('Inbjudan till pass - Till kunden'))
            var smsTemplate = res.find(t => $filter('translate')(t.name) == $filter('translate')('Inbjudan till pass - Till kunden (SMS)'))
            _.findWhere($scope.fields, {name: 'message'}).value = $filter('translate')(mailTemplate ? mailTemplate.templateText : 'INVITATION_MESSAGE')
            _.findWhere($scope.fields, {name: 'message_sms'}).value = $filter('translate')(smsTemplate ? smsTemplate.templateText : 'INVITATION_MESSAGE_SMS')
        })
    }
    getTemplates();

    $scope.canSubmit = function() {
        return getNumberOfReciptients() > 0 && parseReciptients();
    };

    var oldGetSubmitItem = $scope.getSubmitItem;
    $scope.getSubmitItem = function() {
        var item = oldGetSubmitItem();
        item.workout_id = workout.id;
        return item;
    };
}]);

app.controller('SettingsAccountingCtrl', ['$rootScope', '$scope', '$controller', '$filter', 'accounts', 'confirm', 'formatter', function($rootScope, $scope, $controller, $filter, accounts, confirm, formatter) {
    $controller('SettingsCtrl', {$scope: $scope});

    $scope.getUrl = '/api/settings/accounting/get';
    $scope.postUrl = '/api/settings/accounting/set';
    $scope.title = 'Settings for accounting';

    var isVatExempt = function() {
        return _.findWhere($scope.fields, { name: 'vatexempt' }).value;
    };

    function getNiceBankgiroNumber() {
        return formatter.format('bankgiroNumber', $scope.item.bgnumber_payout);
    }

    $scope.fields = [
        {name: 'longaccounts', title: 'Allow long account numbers', type: 'checkbox', visible: function() { return $rootScope.currentStaff.superUser; }},
        {name: 'vatexempt', title: 'VAT exempt association', type: 'checkbox'},
        {name: 'registered_for_ftax', title: 'Registered for F-tax', type: 'checkbox'},
        {name: 'bgnumber_payout', title: 'Bankgiro number for payouts', type: 'bankgiroNumber', required: true, visible: function() { return $rootScope.hasModule('Payout');}, getValue: function(f) { return $rootScope.normalizeBankgiroNumber(f.value); }, setValue: getNiceBankgiroNumber },
        accounts.getFieldsRow($scope, function() { return $rootScope.hasPermission('Accounting'); }, null, 'assets', null, null, null, $scope.getSettings, null, 'assetsaccounts', null, 'ACCOUNTING_ACCOUNT_INFO'),
        accounts.getFieldsRow($scope, function() { return $rootScope.hasPermission('Accounting') && !isVatExempt(); }, null, 'vat', null, 'vat6account', $filter('translate')('Outbound VAT ({0})').format('6 %'), $scope.getSettings),
        accounts.getFieldsRow($scope, function() { return $rootScope.hasPermission('Accounting') && !isVatExempt(); }, null, 'vat', null, 'vat12account', $filter('translate')('Outbound VAT ({0})').format('12 %'), $scope.getSettings),
        accounts.getFieldsRow($scope, function() { return $rootScope.hasPermission('Accounting') && !isVatExempt(); }, null, 'vat', null, 'vat25account', $filter('translate')('Outbound VAT ({0})').format('25 %'), $scope.getSettings),
        accounts.getFieldsRow($scope, function() { return $rootScope.hasPermission('Accounting') && !isVatExempt(); }, null, 'vat', null, 'vatinboundaccount', 'Inbound VAT', $scope.getSettings)
    ];

    var oldSubmit = $scope.submit;
    $scope.submit = function() {
        if ($scope.item.vatexempt == false && $scope.getSubmitItem().vatexempt) {
            confirm.show('VAT_EXEMPT_INFO_MESSAGE', { yesButtonText: 'Save and continue', noButtonText: 'Close' }).then(oldSubmit);
        }
        else { oldSubmit(); }
    };

    $rootScope.waitFor(['accounts']).then(function() {
        $scope.getSettings();
    });
}]);

app.controller('SettingsAccrualAccountingCtrl', ['$rootScope', '$scope', '$controller', 'util', function($rootScope, $scope, $controller, util) {
    $controller('SettingsCtrl', {$scope: $scope});

    $scope.getUrl = '/api/settings/accrualaccounting/get';
    $scope.postUrl = '/api/settings/accrualaccounting/set';
    $scope.title = 'Settings for accrual accounting';

    const accountOptions = [
        { id: 'default', name: util.t('Collection account') + ' 3090' },
        { id: 'product', name: 'Income account from product/service' },
        { id: 'vat', name: 'ACCOUNT_ACCRUAL_BALANCE_VAT_OPTION' },
    ];

    const balanceOptions = [
        { id: 'default', name: '2970 ' + util.t('all') },
        { id: 'vat', name: 'ACCRUAL_BALANCE_VAT_OPTION' }
    ];

    $scope.fields = [
        { name: 'accountType', title: 'Bookkeeping account', required: true, type: 'select', options: () => accountOptions, useId: true },
        { name: 'balanceAccountType', 'title': 'Balance account', required: true, type: 'select', options: () => balanceOptions, useId: true },
        { name: 'minAmount', title: 'Min amount', type: 'number', value: 5000, helpText: 'If the original amount for the period is less than this amount, it will not be included in the accrual.' },
        { title: 'Periodize', type: 'label' },
        { name: 'courses', title: 'Courses', type: 'checkbox', value: false },
        { name: 'resourcebookings', title: 'Resource bookings', type: 'checkbox', value: false },
        { name: 'trainingcards', title: 'Training cards', type: 'checkbox', value: false },
        { name: 'punchcards', title: 'Punch cards', type: 'checkbox', value: false },
    ];


    $rootScope.waitFor(['accounts']).then(function() {
        $scope.getSettings();
    });
}]);

app.controller('AccrualAccountingTestCtrl', ['$scope', 'server', function($scope, server) {
    $scope.title = 'Create accrual accounting';
    $scope.loadingStatus = {};
    $scope.getButtonText = () => $scope.title
    $scope.submit = function() {
        $scope.loadingStatus.loading = true;
        server.post('/api/admin/test', {operation: 'create_accrual_accounting'}).then(() => {
            $scope.loadingStatus.loading = false;
        });
    };
}]);

app.controller('SettingsPaymentConfirmationCtrl', ['$scope', '$controller', function($scope, $controller) {
    $controller('SettingsCtrl', {$scope: $scope});

    $scope.getUrl = '/api/settings/get';
    $scope.postUrl = '/api/settings/change';
    $scope.title = 'Settings for payment confirmations';

    $scope.fields = [
        {hint: 'AUTOMATICALLY_CONFIRM_PAYMENTS_INFO' },
        {name: 'autoconfirm', title: 'Automatically confirm payments', type: 'checkbox', required: false },
    ];

    $scope.getSettings();
}]);

app.controller('SettingsIncludedProductsCtrl', ['$scope', '$controller', function($scope, $controller) {
    $controller('SettingsCtrl', {$scope: $scope});

    $scope.getUrl = '/api/settings/get';
    $scope.postUrl = '/api/settings/change';
    $scope.title = 'Settings for included products on receipt';

    $scope.fields = [
        {name: 'show_included_products', title: 'Show included products on receipt/invoice', type: 'checkbox'}
    ];

    $scope.getSettings();
}]);

app.controller('MultiFieldBuilderCtrl', ['$rootScope', '$scope', '$controller', '$filter', 'options', function($rootScope, $scope, $controller, $filter, options) {
    $controller('AddCtrl', {$scope: $scope});

    if (options.fields) {
        $controller('ChangeModalCtrl', {$scope: $scope});
        $scope.title = 'Change';
    }

    $scope.titleSuffix = function(one) {
        return $filter('translate')( (options.itemTitle || 'field') + (one ? '' : 's') );
    };

    function addRow(fieldvalue) {
        var rownr = $scope.fields.length;
        var removeField = function(field) {
            $scope.fields.splice( $scope.fields.indexOf(field), 1);
            $scope.fields.forEach(function(f, i) {
                if (f.name.startsWith('field')) {
                    f.name = 'field' + (i+1);
                }
            });
        };
        var row = { name: 'field' + rownr, title: $filter('translate')( (options.itemTitle || 'field').capitalize()) + ' ' + rownr, type: 'fieldbuilder', required: true, value: fieldvalue, options: {itemTitle: options.itemTitle, remove: removeField, extra_fields: options.extra_fields } };
        $scope.fields.splice($scope.fields.length-1, 0, row);
        return row;
    }

    function addRowAndOpen() {
        var row = addRow();
        $rootScope.getFieldBuilderForField(row);
    }

    $scope.fields = [
        {name: 'addfield', type: 'button', buttonClass: 'btn-success', buttonTitle: $filter('translate')('Add') + ' ' + $scope.titleSuffix(true), click: addRowAndOpen }
    ];

    $scope.canSubmit = function() {
        return options.fields || $scope.fields.filter(function(f) { return f.name.startsWith('field'); }).length > 0;
    };

    $scope.submit = function() {
        var res = [];
        var data = $scope.getSubmitItem();
        _.keys(data).forEach(function(key) {
            if (key.startsWith('field')) {
                res.push(data[key]);
            }
        });
        $scope.$close(res);
    };

    if (options.fields) {
        $scope.item = {};
        options.fields.forEach(function(field) {
            addRow(field);
        });
    }
}]);

app.controller('FieldBuilderCtrl', ['$rootScope', '$scope', '$controller', '$filter', 'options', function($rootScope, $scope, $controller, $filter, options) {
    $controller('AddCtrl', {$scope: $scope});
    if (options.field) {
        $controller('ChangeModalCtrl', {$scope: $scope});
        $scope.title = 'Change';
    }

    $scope.titleSuffix = function() {
        return $filter('translate')(options.itemTitle || 'field');
    };

    var types = [
        {id: 'text', name: 'Text'},
        {id: 'textarea', name: 'Longer text'},
        {id: 'select', name: 'List'},
        {id: 'multiselect', name: 'Multi choice list'},
        {id: 'date', name: 'Date'},
        {id: 'time', name: 'Time'},
        {id: 'datetime', name: 'Date and time'},
        {id: 'price', name: 'Price'},
        {id: 'number', name: 'Number'},
        {id: 'checkbox', name: 'Checkbox'},
        {id: 'customers', name: 'Customers'}
    ];
    types.forEach(function(t) {
        t.translated = $filter('translate')(t.name);
    });

    function isList() {
        var t = _.findWhere($scope.fields, {name: 'type'});
        if (t.value) {
            return ['select', 'multiselect'].indexOf(t.value.id) != -1;
        }
    }

    function isCheckbox() {
        return $scope.fields.find(f => f.name == 'type')?.value?.id == 'checkbox';
    }

    function addChoice(value) {
        var c = {name: 'choice', title: 'Choice', type: 'text', required: true, visible: isList, addButtonTitle: 'Remove', addButtonClicked: function(field) { $scope.fields.splice($scope.fields.indexOf(field), 1); }, addButtonClass: 'btn-danger', value: value };
        $scope.fields.splice($scope.fields.length-1, 0, c);
    }

    function getChoices() {
        var choices = [];
        $scope.fields.filter(function(f) { return f.name == 'choice'; }).forEach(function(f) {
            choices.push(f.value);
        });
        return choices;
    }

    $scope.fields = [
        {name: 'name', title: 'Name', type: 'text', required: true},
        {name: 'required', title: 'Required', type: 'checkbox'},
        {name: 'type', title: 'Type', type: 'select', required: true, options: function() { return types; }, useId: true, orderPredicate: 'translated' },
        {name: 'addchoice', type: 'button', buttonClass: 'btn-success', buttonTitle: 'Add choice', click: function() { addChoice(); }, visible: isList },
        {name: 'html', title: 'Custom HTML Label', type: 'htmleditor', visible: isCheckbox, helpText: 'CUSTOM_HTML_LABEL_HELPTEXT'}
    ];

    if (options.extra_fields) {
        options.extra_fields.forEach(function(f) {
            $scope.fields.splice(2, 0, angular.copy(f));
        });
    }

    $scope.canSubmit = function() {
        if (isList()) {
            if (getChoices().length == 0) {
                return false;
            }
        }

        return true;
    };

    $scope.submit = function() {
        var data = $scope.getSubmitItem();
        if (isList()) {
            delete data.choice;
            data.data = getChoices();
        } else if (isCheckbox()) {
            data.data = {html: data.html};
            delete data.html;
        }

        $scope.$close(data);
    };

    var changeCtrlSetValues = $scope.setValues;
    $scope.setValues = function(item) {
        changeCtrlSetValues(item);

        if (['select', 'multiselect'].includes(item.type)) {
            _.values(item.data).forEach(function(choice) {
                addChoice(choice);
            });
        } else if (item.type == 'checkbox') {
            $scope.fields.find(f => f.name == 'html').value = item.data?.html;
        }
    };

    if (options.field) {
        $scope.item = options.field;
        $scope.setValues($scope.item);
    }
}]);

app.controller('NewMemberInvitationAddModalCtrl', ['$rootScope', '$scope', '$controller', '$filter', 'util', function($rootScope, $scope, $controller, $filter, util) {
    $controller('AddCtrl', {$scope: $scope});

    function getNumberOfReciptients() {
        var res = 0;
        var rn = _.findWhere($scope.fields, {name: 'recipients_nomembers'}).value;
        if (!rn) {
            return res;
        }

        return res + rn.split(/[\s,]+/).length;
    }

    function parseReciptients() {
        var rn = _.findWhere($scope.fields, {name: 'recipients_nomembers'}).value;
        if (!rn) {
            return true;
        }

        return _.all(rn.split(/[\s,]+/), util.isValidMail);
    }
    $scope.title = 'Send invitation';
    $scope.postUrl = '/api/member/invites/add';
    $scope.callCloseOnSuccess = true;
    $scope.fields = [
        {hint: 'INVITE_NEWMEMBER_HINT', hintClass: 'alert-success'},
        {name: 'recipients_nomembers', title: 'E-mail addresses no customers', type: 'textarea', required: true },
        {name: 'message', title: 'Message', type: 'htmleditor', required: true, value: $filter('translate')('INVITATION_GREETING') }
    ];

    $scope.canSubmit = function() {
        return getNumberOfReciptients() > 0 && parseReciptients();
    };
}]);

app.controller('GetProductsCtrl', ['$rootScope', '$scope', 'options', function($rootScope, $scope, options) {
    $scope.title = 'Choose products';

    function setSelected(p) {
        var i = $scope.selected.indexOf(p);
        if (i == -1) {
            $scope.selected.push(p);
            $scope.config.control.update();
        }
    }

    function isSelected(m) {
        return $scope.selected.indexOf(m) != -1;
    }

    function isNotSelected(m) {
        return $scope.selected.indexOf(m) == -1;
    }

    function removeSelected(customer) {
        var i = $scope.selected.indexOf(customer);
        if (i != -1) {
            $scope.selected.splice(i, 1);
            $scope.config.control.update();
        }
    }

    var onProductSelected = function(p) {
        if (options.multiple) {
            setSelected(p);
        } else {
            $scope.$close(p);
        }
    };

    var itemFilters = [];
    if (options.itemFilter) {
        itemFilters.push(options.itemFilter);
    }

    function primaryFilter(u) {
        if (isSelected(u)) {
            return true;
        }

        for (var i=0; i < itemFilters.length; ++i) {
            if (!itemFilters[i](u)) {
                return false;
            }
        }

        return true;
    }

    $scope.selected = [];

    $scope.config = {
        tableLimit: 5,
        tableNumPages: 5,
        getItems: function() {
            return $rootScope.trainingcardtypes;
        },
        countSuffixList: ['product', 'products'],
        rowClick: onProductSelected,
        itemFilters: [primaryFilter],
        columns: [
            { field: 'image', title: '' },
            { field: 'name', title: 'Name' },
            { field: 'active', title: 'ACTIVE_ONE', format: 'bool' }
        ],
        buttons: [
            { title: 'Choose', onClick: onProductSelected, visible: isNotSelected },
            { title: 'Remove', buttonClass: 'btn-danger', onClick: removeSelected, visible: isSelected }
        ],
        orderColumn: 'name',

        tabs: [
            { name: $scope.title, badgeClass: 'badge-info', itemFilter: function(u) { return isNotSelected(u);} },
            { name: 'Chosen', badgeClass: 'badge-success', itemFilter: isSelected, visible: function() { return options.multiple; } }

        ]
    };

    if (options.selected) {
        options.selected.forEach(function(p) {
            p = _.findWhere($scope.config.getItems(), {id: p.id});
            if (p) {
                $scope.selected.push(p);
            }
        });
    }
}]);

app.controller('SystemBlockedCtrl', ['$rootScope', '$scope', '$window', 'options', function($rootScope, $scope, $window, options) {
    $scope.title = 'Unpaid invoice';

    $scope.fields = [
        { hint: 'EXPIRED_INVOICE_MESSAGE', hintClass: 'alert-danger' }
    ];

    if (options.blocked) {
        window.shortcut.remove("ctrl+s");
    }

    $scope.canDismiss = options.blocked ? false : true;
}]);

app.controller('ResetPasswordModalCtrl', ['$rootScope', '$scope', '$controller', 'server', 'customer', 'isStaff', function($rootScope, $scope, $controller, server, customer, isStaff) {
    $controller('AddCtrl', {$scope: $scope});

    $scope.title = 'Change password';

    var how = [{id: 'mail', name: 'Send as mail'}, {id: 'sms', name: 'Send as SMS'}, {id: 'set', name: 'Change password'}].filter(function(h) {
        return (h.id == 'mail' && customer.mail) || (h.id == 'sms' && customer.phone && $rootScope.hasModule('SMS')) || h.id == 'set';
    });

    function setTitle() {
        var how = _.findWhere($scope.fields, {name: 'how'}).value;
        $scope.submitTitle = how.name;
    }

    $scope.fields = [
        {hint: 'RESETPWDHINT'},
        {name: 'how', title: 'How', type: 'select', options: function() { return how; }, useId: true, change: setTitle, required: true },
        {name: 'password', type: 'password', title: 'New password', required: true, minlength: 6, visible: function() { var how = _.findWhere($scope.fields, {name: 'how'}).value; return how.id == 'set'; }}
    ];

    $scope.setInitialValues = function() {
        _.findWhere($scope.fields, {name: 'how'}).value = how[0];
        setTitle();
    };

    function done(result) {
        if (result.success) {
            $scope.$close();
            return;
        }
        $scope.loadingStatus.loading = false;
    }

    $scope.submit = function() {
        var item = $scope.getSubmitItem();
        $scope.loadingStatus.loading = true;
        if (item.how == 'set') {
            server.post('/api/member/change', {id: customer.id, password: item.password}, null, 'Information saved', 'Failed to save information').then(done);
        } else {
            var success = item.how == 'mail' ? 'Mail sent' : 'SMS sent';
            var failed = item.how == 'mail' ? 'Failed to send mail' : 'Failed to send SMS';
            var page = isStaff ? '/staff#/pages/resetpassword/' : ($rootScope.zoeziMyBusiness ? '/resetpassword?hash=' : '/member#/resetpassword/');
            var link = 'https://{0}{1}'.format(window.location.hostname, page);
            server.post('/api/memberapi/requestResetPassword', null, {mail: item.how == 'mail' ? customer.mail : null, phone: item.how == 'sms' ? customer.phone : null, link: link}, null, success, failed).then(done);
        }
    };

    $scope.setInitialValues();
}]);

app.controller('ImageModalCtrl', ['$scope', 'customer', function($scope, customer) {
    $scope.customer = customer;
}]);

app.factory('recent', ['live', function(live) {
    var recent = {};
    recent.visits = [];

    recent.visit = function(customer) {
        if (customer.isRemoved) {
            return;
        }

        var v = _.find(recent.visits, function(v) { return v.customer.id == customer.id; });
        if (v) {
            v.time = new Date();
        } else {
            recent.visits.push({customer: customer, time: new Date()});
        }
    };

    recent.getLast = function(count) {
        var sorted_visits = Array.mergeSort(recent.visits, function(a, b) {
            return a.time < b.time ? 1 : -1;
        });

        return sorted_visits.slice(0, count).map(function(x) { return x.customer; });
    };

    live.subscribe({
        type: 'user',
        action: 'remove',
        callback: function(user) {
            var v = _.find(recent.visits, function(v) { return v.customer.id == user.id; });
            if (v) {
                var i = recent.visits.indexOf(v);
                recent.visits.splice(i, 1);
            }
        }
    });

    return recent;
}]);

app.controller('QuickSearchCtrl', ['$rootScope', '$scope', '$timeout', 'modalUtils', 'recent', function($rootScope, $scope, $timeout, modalUtils, recent) {

    var result = recent.getLast(5);
    $scope.showLast = result.length > 0;
    $scope.quicksearch = {};

    function preferNameMatch(a, b) {
        var search = ($scope.config.searchText || '').toLowerCase();
        var aval = (a.name || '').toLowerCase();
        var bval = (b.name || '').toLowerCase();

        var ina = aval.indexOf(search) != -1;
        var inb = bval.indexOf(search) != -1;

        if (ina != inb) {
            return ina ? -1 : 1;
        }

        var locale = $scope.config.orderOptions && $scope.config.orderOptions.locale;
        return aval.localeCompare(bval, locale, $scope.config.orderOptions);
    }

    var columns = [
        { field: 'image', title: '' },
        { field: 'name', title: 'Name', compare: preferNameMatch },
        { field: 'mail', title: 'E-mail'},
        { field: 'phone', title: 'Phone'},
        { field: 'memberNumber', title: 'Member number', visible: function() { return $rootScope.hasMemberNumber; } }
    ];

    var gotoCustomer = function(customer) {
        $rootScope.gotoCustomer(customer);
        $scope.searchVisible = false;
        $scope.quicksearch.text = '';
        $timeout(function() {
            $('#quicksearchinput').blur();
            $('#quicksearchinputmobile').blur();
        });
    };

    $scope.config = {
        getItems: function() {
            return result;
        },
        tableLimit: 5,
        hidePagination: true,
        hideSearch: true,
        showSum: false,
        columns: columns,
        rowMouseDown: gotoCustomer,
        orderColumn: 'name',
        customerSearch: true
    };

    $scope.update = function() {
        if (!$scope.quicksearch.text || $scope.quicksearch.text.length == 0) {
            result = recent.getLast(5);
            $scope.config.searchText = undefined;
            $scope.showLast = result.length > 0;
        } else {
            result = $rootScope.members.filter(function(user) {
                return user.type == 'user' && $rootScope.siteAccessFilter(user.homesite_id);
            });
            $scope.config.searchText = $scope.quicksearch.text;
            $scope.showLast = false;
        }
    };

    $scope.$watch('quicksearch.text', function(value, old) {
        if (value != old) {
            $scope.update();
        }
    });

    $scope.gotoFirst = function() {
        var filtered = $scope.config.control.getFilteredItems();
        if (filtered.length == 1) {
            gotoCustomer(filtered[0]);
        }
    };

    $scope.showSearch = function() {
        $scope.update();
        $scope.searchVisible = true;
        if ($(window).width() < 992) {
            var elements = $('.top-nav').children();
            elements.first().hide();
            elements.first().nextUntil('#quicksearchmenu').hide();
        }
        if ($rootScope.isSmallScreen()) {
            $timeout(function() {
                $('#quicksearchinputmobile').focus();
            });
        }
    };

    $scope.hideSearch = function() {
        $scope.searchVisible = false;
        $scope.quicksearch.text = '';
        $('.top-nav').children().show();
        $('#quicksearchinput').val('');
        $('#quicksearchinputmobile').val('');
    };

    $scope.getStyle = function() {
        var pos = $('#quicksearchmenu').position();
        return {
            'margin-left': pos.left + 'px'
        };
    };

    window.shortcut.add('esc', function() {
        $('#quicksearchinput').blur();
        $('#quicksearchinput').val('');
    });

    window.shortcut.add('ctrl+s', function() {
        modalUtils.closeAllModals();
        if ($rootScope.parentHandlesShortcuts) {
            $rootScope.handleShortcut('ctrl+s');
        } else {
            $('#quicksearchinput').focus();
        }
    });

    $rootScope.waitFor(['members']).then($scope.update);

    setTimeout(function() {  // move search-popup in body element
        var qspr = document.getElementById('quick-search-popup-root');
        if (qspr && qspr.nodeType === Node.ELEMENT_NODE) {
            document.body.appendChild(qspr);
        }
        var qsmpr = document.getElementById('quick-search-mobile-popup-root');
        if (qsmpr && qsmpr.nodeType === Node.ELEMENT_NODE){
            document.body.appendChild(qsmpr);
        }
    }, 10);
}]);

app.controller('LoyaltyPointsHistoryCtrl', ['$rootScope', '$scope', 'customer', function($rootScope, $scope, customer) {
    $scope.customer = customer;

    var getLoyaltyPointNames = function(points) {
        return points.type == 'earnedPoints' ? points.bookings : points.product;
    };

    $scope.config = {
        filter: [
            {name: 'fromDate', title: 'From', required: false, type: 'date' },
            {name: 'toDate', title: 'To', required: false, type: 'date' },
        ],
        api: {
            url: '/api/loyaltypoints/get/history',
            args: {
                user_id: customer.id
            },
            transform: function(points) {
                points.date = Date.newFull(points.date);
            },
            triggers: [
                {
                    type: 'user',
                    condition: function(user) {
                        return user.id == customer.id;
                    }
                 }
            ]
        },
        rowClass: function(points) { return points.points > 0 ? 'success' : 'danger'; },
        orderColumn: '-date',
        hideSearch: true,
        tableLimit: 10,
        columns: [
            {field: 'date', title: 'Date', format: 'date' },
            {field: 'name', title: 'Activity', format: 'commaList', getValue: getLoyaltyPointNames },
            {field: 'points', title: 'Points' },
            {field: 'status', title: 'Status', format: 'translated' }
        ],
    };
}]);

app.controller('InsuranceCheckCtrl', ['$rootScope', '$scope', '$controller', 'server', function($rootScope, $scope, $controller, server) {
    $controller('AddCtrl', {$scope:$scope});

    $scope.isMember = undefined;
    $scope.loadingStatus = {};

    $scope.getButtonText = function() {
        return 'Search';
    };

    $scope.fields = [
        {name: 'date', title: 'Date for membership', required: true, type: 'date'},
        {name: 'personalCodeNumber', title: 'Personal code number', required: true, type: 'personalCodeNumber'},
    ];

    $scope.submit = function() {
        $scope.loadingStatus.loading = true;
        var item = $scope.getSubmitItem();
        item.date = Date.newFull(item.date).dateTime();
        server.post('/api/korpen/insurance/check', item).then(function(result) {
            if (result.success) {
                $scope.isMember = result.data.isMember;
            }
            $scope.loadingStatus.loading = false;
        });
    };

}]);

app.controller('ProxyAppSettingsCtrl', ['$rootScope', '$scope', '$controller', function($rootScope, $scope, $controller) {
    $controller('SettingsCtrl', { $scope: $scope });

    $scope.item = {};
    $scope.getUrl = '/api/settings/proxyapp/get';
    $scope.postUrl = '/api/settings/proxyapp/set';

    $scope.showButton2 = function() {
        return true;
    };

    $scope.getButtonText2 = function() {
        return 'Download Gymsystem proxy app';
    };

    $scope.submit2 = function() {
        $rootScope.downloadElectron();
    };

    var readerTypes = [ { name: 'Mifare', id: 'mifare' }, { name: 'EM', id: 'em' } ];
    $scope.fields = [
        { name: 'readerType', title: 'Reader type', type: 'select', required: true, options: function() { return readerTypes; }, placeholder: 'Choose reader type', useId: true },
        { name: 'showNotifications', title: 'Show notifications', type: 'checkbox', required: true, value: true },
        { name: 'playAudio', title: 'Play audio', type: 'checkbox', required: true, value: true },
        { name: 'promagSearch', title: 'Search for Promag card reader', type: 'checkbox', required: true, value: false },
        { name: 'autoStart', title: 'Automatically start app', type: 'checkbox', required: true, value: false }
    ];

    $scope.getSettings();
}]);

app.controller('ProxyAppInputConfigCtrl', ['$scope', '$modal', '$filter', 'server', 'confirm', function($scope, $modal, $filter, server, confirm) {

    $scope.openNewConfigModal = function(item) {
        $modal.open({
            templateUrl: 'views/addmodal.html',
            controller: 'ProxyAppInputConfigModalCtrl',
            resolve: {
                options: function() {
                    var options = {};
                    if (item) { options.item = item; }
                    return options;
                }
            }
        });
    };

    $scope.removeConfig = function(item) {
        confirm.show('Are you sure you want to remove this configuration?', { ladda: true }).then(function(resolve) {
            server.post('/api/proxyapp/input/config/remove', null, { id: item.id }).then(resolve);
        });
    };

    var eventTypes = [
        { name: 'Schedule', value: 'schedule' },
        { name: 'Booking', value: 'booking' },
        { name: 'Entry', value: 'entry' },
        { name: 'Continuous booking', value: 'rbcheckin' },
    ];
    var getEventType = function(row) {
        if (!row.eventType) { return ''; }
        var item =  _.findWhere(eventTypes, { value: row.eventType });
        return item && $filter('translate')(item.name);
    };
    var formatActiveTime = function(row) {
        if (!row.activeTime) { return ''; }
        return row.activeTime + ' ' + $filter('translate')('seconds');
    };

    $scope.ruleConfig = {
        api: {
            url: '/api/proxyapp/input/config/get',
            triggers: [{type: 'proxyappinputconfig'}]
        },
        hideSearch: true,
        columns: [
            { field: 'name', title: 'Name' },
            { field: 'port', title: 'INPUTPORT' },
            { field: 'app', title: 'App resource', getValue: function(row) { return row.app.name; } },
            { field: 'resource', title: 'Resource', getValue: function(row) { return row.resource.name; } },
            { field: 'eventType', title: 'Type', getValue: getEventType },
            { field: 'activeTime', title: 'Active time', getValue: formatActiveTime }
        ],
        buttons: [
            { title: 'Change', buttonClass: 'btn-warning', onClick: $scope.openNewConfigModal },
            { title: 'Remove', buttonClass: 'btn-danger', onClick: $scope.removeConfig }
        ]
    };

}]);

app.controller('ProxyAppInputConfigModalCtrl', ['$rootScope', '$scope', '$controller', 'server', 'options', function($rootScope, $scope, $controller, server, options) {
    $controller('AddCtrl', {$scope: $scope});

    $scope.item = {};
    options = options || {};
    $scope.postUrl = '/api/proxyapp/input/config/add';
    $scope.callCloseOnSuccess = true;

    if ($rootScope.speedy) {
        $rootScope.loadActiveResourcesForSite();
    }

    if (options.item) {
        $controller('ChangeModalCtrl', {$scope: $scope});
        $scope.title = 'Change';
        $scope.postUrl = '/api/proxyapp/input/config/change';
    }

    var inputports = [
        { name: 7, value: 7 },
        { name: 11, value: 11 },
        { name: 12, value: 12 },
        { name: 13, value: 13 },
        { name: 15, value: 15 },
        { name: 16, value: 16 },
        { name: 18, value: 18 }
    ];
    var setInput = function(__, value) {
        return _.findWhere(inputports, { value: value });
    };

    var eventTypes = [
        { name: 'Schedule', value: 'schedule' },
        { name: 'Booking', value: 'booking' },
        { name: 'Entry', value: 'entry' },
        { name: 'Continuous booking', value: 'rbcheckin' },
    ];
    var getEventType = function(field) {
        return field.value.value;
    };
    var setEventType = function(__, value) {
        return _.findWhere(eventTypes, { value: value });
    };

    var genericGetValue = function(field) {
        return field.value && field.value.value;
    };

    var getAppResources = function() {
        return $rootScope.getActiveResources().filter(function(r) { return r && r.externaldoorid; });
    };

    var activeTimeVisible = function() {
        var et = _.findWhere($scope.fields, { name: 'eventType' }).value;
        return et && et.value === 'entry';
    };

    $scope.fields = [
        { name: 'name', title: 'Name', type: 'text', required: true },
        { name: 'port', title: 'INPUTPORT', required: true, type: 'select', hint: 'INPUTPORT_INFO', options: function() { return inputports; }, useId: true, getValue: genericGetValue, setValue: setInput },
        { name: 'app_id', title: 'App resource', required: true, type: 'select', options: getAppResources, useId: true },
        { name: 'resource_id', title: 'Resource', required: true, type: 'select', options: $rootScope.getActiveResources, useId: true },
        { name: 'eventType', title: 'Type', required: true, type: 'select', options: function() { return eventTypes; }, useId: true, getValue: getEventType, setValue: setEventType },
        { name: 'activeTime', title: 'Active time', required: false, type: 'infoNumber', info: 'seconds', placeholder: 'No limit', visible: activeTimeVisible, min: 1 }
    ];

    $scope.setInitialValues = function() {
        if (options.initial) {
            _.keys(options.initial).forEach(function(key) {
                _.findWhere($scope.fields, {name: key}).value = options.initial[key];
            });
        }
    };

    $scope.setInitialValues();

    if (options.item) {
        $scope.item = options.item;
        $scope.setValues($scope.item);
        $scope.canSubmit = $scope.valuesChanged;
    }
}]);

app.controller('ProxyAppInputCtrl', ['$scope', '$filter', 'server', function($scope, $filter, server) {

    $scope.loadingStatus = {};

    $scope.getInfo = function() {
        return $filter('translate')('ELECTRICAL_INPUTS_SETTING_INFO');
    };

    var formatActiveStateText = function(row) {
        return $filter('translate')(row.activeState ? 'On' : 'Off');
    };

    var toggleActiveState = function(input) {
        $scope.loadingStatus.loading = true;
        input.activeState = !input.activeState;
        server.post('/api/proxyapp/input/setting/change', input, null, 'Successfully updated active state', 'Failed to update input active state').then(function() {
            $scope.loadingStatus.loading = false;
        });
    };

    $scope.inputConfig = {
        api: {
            url: '/api/proxyapp/input/setting/get',
            triggers: [{type: 'proxyappinput'}]
        },
        hideSearch: true,
        columns: [
            { field: 'port', title: 'INPUTPORT' },
            { field: 'activeState', title: 'Active state', getValue: formatActiveStateText }
        ],
        buttons: [
            { title: 'Change', buttonClass: 'btn-warning', onClick: toggleActiveState, loading: function() { return $scope.loadingStatus.loading; } }
        ]
    };

}]);

app.controller('AppDataCtrl', ['$rootScope', '$scope', 'server', 'util', 'options', function($rootScope, $scope, server, util, options) {
    $scope.config = _.deep_extend(options.config, {
        datatype: 'app',
        url: {
            add: '/api/app/add',
            change: '/api/app/change'
        },
        data: {
            permissions: server.get('/api/staff/permissions/get').then(function(permissions) {
                permissions.forEach(function(p) {
                    p.name = util.t(p.id);
                });
                return permissions;
            })
        },
        tabs: [
            {
                name: 'General',
                fields: [
                    {name: 'name', title: 'Name', type: 'text', required: true },
                    {name: 'apikey', title: 'API key', type: 'text', readonly: true, placeholder: 'Shown after creation' },
                    {name: 'roles', title: 'Roles', required: false, type: 'multiselect', options: function() { return $rootScope.roles; }, useId: true },
                    {name: 'permissions', title: 'Access rights', required: false, type: 'multiselect', options: function() { return $scope.config.data.permissions; }, useId: true },
                    {name: 'active', title: 'ACTIVE_ONE', type: 'checkbox'}
                ]
            }
        ],
        init: function() {
            if (!options.item) {
                return {active: true};
            }
        }
    });
}]);

app.controller('WebhookDataCtrl', ['$rootScope', '$scope', '$filter', 'server', 'options', function($rootScope, $scope, $filter, server, options) {
    $scope.config = _.deep_extend(options.config, {
        datatype: 'webhook',
        url: {
            add: '/api/webhook/add',
            change: '/api/webhook/change'
        },
        data: {
            types: server.get('/api/webhook/datatypes/get').then(function(data) { data.forEach(function(d) { d.name = $filter('translate')(d.name) + ' (' + d.id + ')'; }); return data; }),
            actions: [{id: 'add', name: 'Addition'}, {id: 'update', name: 'AnUpdate'}, {id: 'delete', name: 'Removal'}]
        },
        tabs: [
            {
                name: 'General',
                fields: [
                    {name: 'name', title: 'Name', type: 'text', required: true },
                    {name: 'url', title: 'Url', type: 'url', required: true },
                    {name: 'secret', title: 'Key', type: 'text', required: true },
                    {name: 'active', title: 'ACTIVE_ONE', type: 'checkbox'},
                    {name: 'events', title: 'EVENTS_TEXT', type: 'multiselect', options: function() { return $scope.config.data.types; }, useId: true },
                    {name: 'actions', title: 'Action filter', type: 'multiselect', options: function() { return $scope.config.data.actions; }, useId: true, placeholder: 'All actions' }
                ]
            }
        ],
        init: function() {
            if (!options.item) {
                return {active: true, secret: '0'.repeat(64).replace(/0/g,function(){return (~~(Math.random()*16)).toString(16);}) };
            }
        }
    });
}]);

app.controller('SettingsIntegrationsCtrl', ['$rootScope', '$scope', '$controller', 'util', function($rootScope, $scope, $controller, util) {
    $controller('SettingsCtrl', {$scope:$scope});

    function addApp() {
        util.showDataDialog({ controller: 'AppDataCtrl'});
    }

    function changeApp(app) {
        util.showDataDialog({ controller: 'AppDataCtrl', item: app});
    }

    $rootScope.waitFor(['roles']).then(function() {
        $scope.appConfig = {
            api: {
                url: '/api/app/get',
                triggers: [{type: 'app'}],
                transform: function(app) {
                    $rootScope.updatePointersById(app.roles, $rootScope.roles);
                }
            },
            orderColumn: 'name',
            countSuffixList: ['App', 'Apps'],
            tabs: [
                { name: 'Active', badgeClass: 'badge-success', itemFilter: function(c) { return c.active; } },
                { name: 'Inactive', itemFilter: function(c) { return !c.active; } }
            ],
            columns: [
                {field: 'name', title: 'Name'},
                {field: 'apikey', title: 'API key'},
                {field: 'calls', title: 'Calls', format: 'number'},
                {field: 'last_call', title: 'Last call', format: 'datetime'}
            ],
            buttons: [
                { title: 'Change', showOnEmpty: true, onClick: changeApp, buttonClass: 'btn-warning', visible: function(app) {return !app.builtIn; }}
            ],
            searchButtons: [
                { title: 'Add', showOnEmpty: true, onClick: addApp}
            ]
        };
    });

    function addWebhook() {
        util.showDataDialog({ controller: 'WebhookDataCtrl' });
    }

    function changeWebhook(webhook) {
        util.showDataDialog({ controller: 'WebhookDataCtrl', item: webhook});
    }

    $scope.webhooksConfig = {
        api: {
            url: '/api/webhook/get',
            triggers: [{type: 'webhookendpoint'}]
        },
        orderColumn: 'name',
        countSuffixList: ['webhook', 'webhooks'],
        tabs: [
            { name: 'Active', badgeClass: 'badge-success', itemFilter: function(c) { return c.active; } },
            { name: 'Inactive', itemFilter: function(c) { return !c.active; } }
        ],
        columns: [
            {field: 'name', title: 'Name'},
            {field: 'calls', title: 'Calls', format: 'number'},
            {field: 'in_queue', title: 'Calls in queue', format: 'number'}
        ],
        buttons: [
            { title: 'Change', showOnEmpty: true, onClick: changeWebhook, buttonClass: 'btn-warning'}
        ],
        searchButtons: [
            { title: 'Add', showOnEmpty: true, onClick: addWebhook}
        ]
    };
}]);

app.controller('KorpenRoleCtrl', ['$scope', '$controller', '$filter', 'options', function($scope, $controller, $filter, options) {
    $controller('AddCtrl', {$scope: $scope});

    $scope.titleSuffix = function() {
        return $filter('translate')('Role').toLowerCase();
    };

    $scope.fields = [
        {name: 'role', title: 'Role', type: 'select', options: function() { return options.roles; }, group: function(role) { return role.group; }, required: true }
    ];

    $scope.submit = function() {
        $scope.$close($scope.fields[0].value);
    };
}]);

app.controller('SettingsKorpenAssociationCtrl', ['$rootScope', '$scope', '$controller', '$modal', 'server', 'util', function($rootScope, $scope, $controller, $modal, server, util) {
    $controller('SettingsCtrl', { $scope: $scope });

    $scope.title = 'För korpen.se';
    $scope.getUrl = '/api/korpen/settings/get';
    $scope.postUrl = '/api/korpen/settings/set';

    var roles = [];
    var visibility = {};
    server.get('/api/korpen/roles/get').then(function(res) {
        roles = res;
        roles.forEach(function(role) {
            var label = _.findWhere($scope.fields, {name: role.group, type: 'label'});
            if (!label) {
                $scope.fields.push( {name: role.group, type: 'label', title: role.group, labelClass: 'xlargefont label-oneline', visible: function() { return visibility[role.group]; } });
            }
            $scope.fields.push( { name: 'roles.' + role.name, title: role.name, required: role.required, type: role.multiple ? 'customers' : 'customer', itemTypes: ['customer', 'staff'], useId: true, visible: function() { return visibility[role.name]; } });
        });
    });

    $scope.showButtonLeft = function() {
        return true;
    };

    $scope.getButtonTextLeft = function() {
        return 'Add role';
    };

    function makeRoleVisible(role) {
        visibility[role.name] = true;
        visibility[role.group] = true;
    }

    $scope.submitLeft = function() {
        $modal.open({
            templateUrl: 'views/addmodal.html',
            controller: 'KorpenRoleCtrl',
            resolve: {
                options: function() {
                    var unused = roles.filter(function(role) { var rolef = _.findWhere($scope.fields, {name: 'roles.' + role.name}); return rolef && !rolef.visible(); });
                    return {roles: unused};
                }
            }
        }).result.then(makeRoleVisible);
    };

    $scope.fields = [];

    var parentSetValues = $scope.setValues;
    $scope.setValues = function(data) {
        visibility = {};
        roles.filter(function(role) {
            if (role.required) {
                return true;
            }
            var dr = data.roles && data.roles[role.name];
            if (dr) {
                if (_.isArray(dr)) {
                    return dr.length > 0;
                } else {
                    return !!dr;
                }
            }
            return false;
        }).forEach(makeRoleVisible);
        parentSetValues(data);
    };

    util.waitFor($scope, function() { return roles.length; }).then($scope.getSettings);
}]);

app.controller('NotificationModalCtrl', ['$rootScope', '$scope', '$filter', 'server', 'notification', function($rootScope, $scope, $filter, server, notification) {
    $scope.notification = $rootScope.transformUserPushNotification(notification);
    server.post('/api/mailing/pushnotification/markasread', [$scope.notification.id]);

    $scope.getSender = function() {
        return $scope.notification.sender ? $scope.notification.sender.name : $filter('translate')('Not specified');
    };

    $scope.getMailingTypeName = function() {
        var mailingType = $scope.notification.type;
        if (mailingType === 'push') { return 'Push notification'; }
        return mailingType.charAt(0).toUpperCase() + mailingType.slice(1);
    };
}]);

app.controller('PushNotificationHeaderCtrl', ['$rootScope', '$scope', '$filter', '$location', '$modal', 'server', 'live', function($rootScope, $scope, $filter, $location, $modal, server, live) {

    $scope.notifications = [];

    function getNotifications() {
        server.get('/api/mailing/pushnotification/get').then(function(notifications) {
            angular.forEach(notifications, $rootScope.transformUserPushNotification);
            $scope.notifications = notifications;
        });
    }
    getNotifications();

    $scope.getItems = function() {
        return $scope.notifications;
    };

    $scope.getActiveItems = function() {
        return $scope.notifications.filter(function(n) { return n.sent && !n.isArchived && !n.hasRead; });
    };

    $scope.itemFilter = function(n) {
        return n.sent && !n.isArchived;
    };

    $scope.getCreatorImage = function(n) {
        if (!n.sender) { return $rootScope.getEmptyImage(); }
        return $rootScope.staffImage(n.sender);
    };

    $scope.getCreator = function(n) {
        if (!n.sender) { return 'Not specified'; }
        return n.sender.id === $rootScope.currentStaffId ? 'You' : n.sender.name;
    };

    $scope.show = function(n) {
        $modal.open({
            templateUrl: 'views/member/notificationmodal.html',
            controller: 'NotificationModalCtrl',
            resolve: {
                notification: function() {
                    return n;
                }
            }
        });
    };

    $scope.markAllAsRead = function() {
        var items = $scope.getActiveItems();
        var ids = items.map(function(i) { return i.id; });
        server.post('/api/mailing/pushnotification/markasread', ids);
    };

    $scope.showList = function() {
        $location.path('/notifications');
    };

    live.subscribe({
        type: 'userpushnotification',
        scope: $scope,
        callback: function(__, event) {
            angular.forEach(event.data, $rootScope.transformUserPushNotification);
            angular.forEach(event.data, function(notification) {
                if (event.action === 'add') {
                    $scope.notifications.push(notification);
                } else if (event.action === 'change') {
                    var index = _.findIndex($scope.notifications, function(n) {return n.id === notification.id;});
                    $scope.notifications[index] = notification;
                } else if (event.action === 'remove') {
                    var index = _.findIndex($scope.notifications, function(n) {return n.id === notification.id;});
                    $scope.notifications.splice(index, 1);
                }
            });
        }
    });

    var notificationlistDropdown = angular.element(document.querySelector('#pushnotification-dropdown'));
    notificationlistDropdown.on('click', function() {
        if (!$(this).parent().hasClass('open')) {
            $(this).next().on('click', function(e){ e.stopPropagation(); });
        }
    });
}]);

app.controller('NotificationsCtrl', ['$rootScope', '$scope', '$filter', '$modal', 'confirm', 'server', function($rootScope, $scope, $filter, $modal, confirm, server) {

    $scope.allItemsChecked = function() {
        var items = $scope.config.control.getFilteredItems();
        if (!items.length) { return false; }
        for (var i=0; i < items.length ; ++i) {
            if (!items[i].checked) { return false; }
        }
        return true;
    };

    $scope.checkboxChecker = function(value) {
        var items = $scope.config.control.getFilteredItems();
        for (var i=0; i< items.length; ++i) {
            items[i].checked = value;
        }
    };
    $scope.markAll = function() {
        $scope.checkboxChecker(true);
    };
    $scope.clearMarked = function() {
        $scope.checkboxChecker(false);
    };

    $scope.archiveMarkedDisabled = function() {
        var items = $scope.config.control.getFilteredItems();
        return !_.findWhere(items, { checked: true });
    };
    $scope.archiveMarked = function() {
        var items = $scope.config.control.getFilteredItems();
        var marked = items.filter(function(item) { return item.checked; });
        var ids = _.pluck(marked, 'id');

        var message = $filter('translate')('You are about to archive {0} marked notifications. Do you want to continue?').format(marked.length);
        confirm.show(message, { ladda: true }).then(function(resolve) {
            server.post('/api/mailing/pushnotification/archive', ids).then(resolve);
        });
    };
    $scope.archive = function(notification) {
        var message = $filter('translate')('Are you sure you want to archive this notification?');
        confirm.show(message, { ladda: true }).then(function(resolve) {
            server.post('/api/mailing/pushnotification/archive', [notification.id]).then(resolve);
        });
    };

    $scope.show = function(notification) {
        $modal.open({
            templateUrl: 'views/member/notificationmodal.html',
            controller: 'NotificationModalCtrl',
            resolve: {
                notification: function() {
                    return notification;
                }
            }
        });
    };

    $scope.config = {
        api: {
            url: '/api/mailing/pushnotification/get',
            args: { limit: null },
            triggers: [{type: 'userpushnotification'}],
            transform: $rootScope.transformUserPushNotification,
        },
        countSuffixList: ['notification', 'notifications'],
        rowClick: $scope.show,
        filter: [
            { name: 'fromDate', title: 'From date', required: false, type: 'date' },
            { name: 'toDate', title: 'To date', required: false, type: 'date' },
            { name: 'includeArchived', title: 'Show archived', required: false, type: 'checkbox' }
        ],
        searchButtons: [
            { title: 'Clear all', buttonClass: 'btn-danger', onClick: $scope.clearMarked, visible: $scope.allItemsChecked },
            { title: 'Mark all', onClick: $scope.markAll, visible: function() { return !$scope.allItemsChecked(); } },
            { title: 'Archive', buttonClass: 'btn-warning', onClick: $scope.archiveMarked, disabled: $scope.archiveMarkedDisabled },
        ],
        columns: [
            { field: 'checked', format: 'checkbox' },
            { field: 'headline', title: 'Notification' },
            { field: 'sent', title: 'Date', format: 'date' },
        ],
        buttons: [
            { title: 'Show', buttonClass: 'btn-success', onClick: $scope.show },
            { title: 'Archive', buttonClass: 'btn-warning', onClick: $scope.archive, visible: function(n) { return !n.isArchived; } },
        ]
    };
}]);

app.controller('CriminalRecordExcerptCtrl', ['$rootScope', '$scope', '$modal', 'server', 'alertProvider', 'confirm', '$filter', 'util', 'live', function($rootScope, $scope, $modal, server, alertProvider, confirm, $filter, util, live) {

    $scope.itemFilter = function(c) {
        return !_.filter($rootScope.criminalRecordExcerpts, function(cre) { return cre.user.id === c.id; }).length;
    };

    $scope.getInfo = function() {
        return $filter('translate')('CRIMINAL_RECORD_EXCERPT_INFO');
    };


    var add = function() {
        var modalInstance = $modal.open({
            templateUrl: 'views/getcustomermodal.html',
            controller: 'GetCustomerCtrl',
            windowClass: 'huge-modal-window',
            resolve: {
                options: function() {
                    return _.extend({type: 'customers', multiple: true, itemTypes: ['customer', 'staff'], itemFilter: $scope.itemFilter}, {hideGroup: true});
                }
            }
        });

        modalInstance.result.then(function (customers) {
            customers = _.pluck(customers, 'id');
            server.post('/api/criminalrecordexcerpt/add', null, {ids: customers}).then(function(result) {
                if (result.success) {
                    alertProvider.show('success', 'Instructor was added');
                } else {
                    alertProvider.show('error', 'Failed to add instructor');
                }
            });
        });
    };

    var getExcel = function() {
        $scope.config.control.exportTo('excel').then(function(blob) {
            util.download($filter('translate')('Criminal record excerpt') + '.xlsx', null, null, blob);
        });
    };

    var certify = function(item) {
        $modal.open({
            templateUrl: 'views/addmodal.html',
            resolve: { item: function() { return item; } },
            controller: ['$scope', 'server', 'alertProvider', '$filter', 'item',
            function($scope, server, alertProvider, $filter, item) {
                $scope.loadingStatus = {};
                $scope.title = 'Criminal Record Excerpt';
                $scope.submitTitle = $filter('translate')('Save');
                $scope.getButtonClass = function() { return 'btn-success'; };

                $scope.fields = [
                    { hintClass: 'alert-info', hint: $filter('translate')('CRIMINAL_RECORD_EXCERPT_CERTIFY_HINT').format(item.user.name) },
                    {
                        name: 'certified_date',
                        title: 'Excerpt checked at',
                        type: 'date',
                        required: true,
                        value: item.certified_date || new Date()
                    }
                ];

                $scope.submit = function() {
                $scope.loadingStatus.loading = true;
                var dateField = $scope.fields.find(f => f.name === 'certified_date');
                var certDate = dateField.value.yyyymmdd();

                server.post('/api/criminalrecordexcerpt/certify', null, {
                    id: item.user.id,
                    certified_date: certDate
                }).then(function(result) {
                    $scope.loadingStatus.loading = false;
                    if (result.success) {
                        alertProvider.show('success', 'Criminal record excerpt was certified');
                        $scope.$close();
                    } else {
                        alertProvider.show('error', 'Failed to certify');
                    }
                }, function() {
                    $scope.loadingStatus.loading = false;
                    alertProvider.show('error', 'Failed to certify');
                });
                };
            }]
        });
    };

    var remove = function (item) {
        var creHint = $filter('translate')('CRIMINAL_RECORD_EXCERPT_REMOVE_HINT').format(item.user.name);
        confirm.show(creHint, {ladda: true}).then(function(resolve) {
            server.post('/api/criminalrecordexcerpt/remove', null, {id: item.user.id}).then(function(result) {
                resolve();
                if (result.success) {
                    alertProvider.show('success', 'Instructor was removed');
                } else {
                    alertProvider.show('error', 'Failed to remove instructor');
                }
            });
        });
    };

    $scope.config = {
        getItems: function() { return $rootScope.criminalRecordExcerpts; },
        getTitle: function() {
            return 'Criminal record excerpt';
        },
        countSuffixList: ['instructor', 'instructors'],
        searchDepth: 2,
        columns: [
            { field: 'image', src: function(c) { return $rootScope.smallMemberImage($rootScope.getMember(c.user.id)); } },
            { field: 'user.name', title: 'Name' },
            { field: 'certified_date', title: 'Excerpt checked at' },
            { field: 'certified_future', title: 'New excerpt is required', getValue: function(c) { return c.certified_future || $filter('translate')('Promptly'); } },
            { field: 'certified_by.name', title: 'Checked by' }
        ],
        searchButtons: [
            { title: 'Add person', buttonClass: 'btn-success', onClick: add },
            { title: 'Download as Excel', buttonClass: 'btn-success', onClick: getExcel }
        ],
        buttons: [
            { title: 'Certify', buttonClass: 'btn-success', onClick: certify },
            { title: 'Remove', buttonClass: 'btn-danger', onClick: remove }
        ]
    };

    live.subscribe({
        type: 'criminalrecordexcerpt',
        scope: $scope,
        callback: function() {
            $rootScope.getCriminalRecordExcerpts();
        }
    });
}]);

app.controller('SystemCostCtrl', ['$scope', 'server', function($scope, server) {
    var fromDate = Date.firstDayThisMonth().yyyymmdd();
    var toDate = Date.lastDayThisMonth().yyyymmdd();
    server.get('/api/systemcost/get', {fromDate: fromDate, toDate: toDate}).then(function(result) {
        $scope.systemcost = result;
    });

    $scope.nextInvoice = Date.firstDayNextMonth();
}]);

app.controller('MyServiceHoursCtrl', ['$rootScope', '$scope', '$controller', 'server', 'calendar', 'resourceBooking', '$filter', 'util', 'live', function($rootScope, $scope, $controller, server, calendar, resourceBooking, $filter, util, live) {
    $controller('WorkScheduleCtrl', {$scope: $scope});
    $controller('ResourceBookingBookCtrl', {$scope: $scope});

    var currentStaff = $rootScope.getStaff($rootScope.currentStaffId);
    $scope.data.selectedResource = currentStaff;
    $scope.calendarSources = [[], [], []];
    $scope.calendarConfig = calendar.getDefaultConfig($scope.smallCalendar);
    $scope.calendarConfig.showBottomWorkSchedule = true;
    $scope.services = $rootScope.resourcebookingservices.filter(function(r) { return r.active && _.findWhere(r.staffs, {id: currentStaff.id}); });

    function transformActivityForCalendar(activity) {
        if (activity.slot) {
            activity.title += ' - ' + $filter('translate')('Booked2');
        } else {
            var ao = activity.origin;
            activity.backgroundColor = ao.backgroundColor;
            activity.title = ao.workoutType.name + (ao.extra_title ? (' - ' + ao.extra_title) : '') + ' - ' + $filter('translate')('Booked2');
        }
        return activity;
    }

    function filterFreeSlots() {
        var visibleServiceIds = _.pluck($scope.services.filter(function(s) { return s.showOnCalendar === undefined || s.showOnCalendar; }), 'id');
        $scope.calendarSources[1] = $scope.allFreeSlots.filter(function(freeSlot) { return visibleServiceIds.indexOf(freeSlot.service_id) > -1; });
    }

    function loadServices() {
        if (!$scope.visStart || !$scope.visEnd) { return; }
        server.get('/api/resourcebooking/get/free', {staffs: currentStaff.id, startTime: $scope.visStart.yyyymmdd(), endTime: $scope.visEnd.yyyymmdd()}).then(function(response) {
            $scope.calendarSources[1] = response;
            $scope.allFreeSlots = response;
            var now = new Date();
            angular.forEach(response, function(slot) {
                slot.service = _.findWhere($rootScope.resourcebookingservices, {id: slot.service_id});
                slot.staffs = $rootScope.updatePointersById(slot.staffs, $rootScope.staffs);
                slot.start = Date.newFull(slot.start);
                slot.end = Date.newFull(slot.end);
                if (slot.start < now) {
                    slot.className = 'oldTime';
                }
            });
            filterFreeSlots();
            calendar.adjustMinMax($scope.calendarConfig, $scope.calendarSources);
        });
    }

    function loadResourceAllocation() {
        if (!$scope.visStart || !$scope.visEnd) { return; }
        server.post2('/api/resourcebooking/resource/get_resource_allocation', {
            resource_ids: [currentStaff.id],
            start: $scope.visStart,
            end: $scope.visEnd,
            mode: 'slots',
            site_id: $rootScope.selectedSite.id
        }).then(function(response) {
            $rootScope.waitFor(['staffs', 'resourcebookingcategories', 'resourcebookingservices', 'trainingcardtypes', 'members']).then(function() {
                var bookedSlots = [];
                response.forEach(function(data) {
                    if (data.slot) {
                        data.className = 'oldTime';
                        bookedSlots.push(transformActivityForCalendar(resourceBooking.slotForCalendar(data)));
                    } else {
                        data.className = 'oldTime';
                        $rootScope.transformWorkout(data.origin);
                        bookedSlots.push(transformActivityForCalendar(data));
                    }
                });
                $scope.calendarSources[2] = bookedSlots;
                calendar.adjustMinMax($scope.calendarConfig, $scope.calendarSources);
                $scope.calendarObject.fullCalendar('render');
                calendar.updateTranslation([$scope.calendarConfig]);
            });
        });
    }

    $scope.pubsub('tabChanged', function(tab) {
        if (tab == 'myServiceHours') {
            util.waitFor($scope, 'calendarObject').then(function() {
                util.waitForVisible($scope.calendarObject).then(function() {
                    $scope.calendarObject.fullCalendar('render');
                });
            });
        }
    }, true);

    $scope.pubsub('selectedSite', function() {
        loadResourceAllocation();
        loadServices();
    });

    $scope.calendarConfig = calendar.getDefaultConfig($scope.smallCalendar);
    $scope.calendarConfig.showBottomWorkSchedule = true;
    $scope.calendarConfig.viewRender = function(view) {
        if (calendar.viewChanged($scope, view, $scope.calendarConfig)) {
            if (view.name == "month"){
                $scope.calendarSources[0] = [];
            } else {
                $scope.getWorkSchedule();
            }
            loadServices();
            loadResourceAllocation();
        }
    };

    $scope.calendarConfig.dayClick = function(date) {
        var endTime = date.clone().addMinutes(60);
        util.showDataDialog({controller: 'WorkoutDataCtrl', initial: {date: date, startTime: date, endTime: endTime, Staffs: [$scope.staff] }});
    };

    $scope.calendarConfig.eventClick = function(calEvent) {
        if (calEvent.isAnnotation || calEvent.notClickable) {
            return;
        } else if (calEvent.origin_type === 'Workout') {
            $rootScope.showWorkout(calEvent.origin);
        } else if (calEvent.enableCapacity || (calEvent.resource_booking && calEvent.resource_booking.length != 1)) {
            resourceBooking.showBookingList(calEvent);
        } else if (calEvent.resource_booking && calEvent.resource_booking.length == 1) {
            resourceBooking.openById(calEvent.resource_booking_id[0]);
        } else {
            var readonlyService = true;
            $scope.book(calEvent, readonlyService);
        }
    };

    function toggleServices(service) {
        if (service === 'showAllServices') {
            _.map($scope.services, function(s) { s.showOnCalendar = true; });
            _.map($scope.actions, function(a) {
                a.opacity = (a.title === 'Show all' ? 0.5 : 1);
            });
        } else {
            var allShown = !_.findWhere($scope.services, { showOnCalendar: false });

            if (allShown) {
                angular.forEach($scope.services, function(s) {
                    if (s.id == service.id) { return; }
                    s.showOnCalendar = false;
                    var action = _.findWhere($scope.actions, { title: s.name });
                    action.opacity = 0.5;
                });
            } else {
                service.showOnCalendar = !service.showOnCalendar;
                var action = _.findWhere($scope.actions, {title: service.name});
                action.opacity = service.showOnCalendar ? 1 : 0.5;
            }

            var notShownServices = _.find($scope.services, {showOnCalendar: false});
            var showAllBtn = _.findWhere($scope.actions, {title: 'Show all'});
            if (showAllBtn) {
                showAllBtn.opacity = notShownServices ? 1 : 0.5;
            }
        }
        filterFreeSlots();
    }

    $scope.serviceButtonConfig = {
        title: 'Service actions',
        individualButtons: function() { return true; },
        actions: $scope.actions
    };

    function setServiceButtons() {
        $scope.actions = [];
        $scope.services.forEach(function(service) {
            service.showOnCalendar = true;
            $scope.actions.push({title: service.name, onClick: function() { toggleServices(service); }, backgroundColor: service.category.color});
        });
        if ($scope.services.length > 1) { $scope.actions.push({title: 'Show all', onClick: function() { toggleServices('showAllServices'); }, opacity: 0.5}); }
        $scope.serviceButtonConfig.actions = $scope.actions;
    }
    setServiceButtons();

    $scope.calendarConfig.changeWorkScheduleForDay = function(date) {
        $scope.changeWorkScheduleForDay(date);
    };

    live.subscribe({
        type: 'resourcebookingservice',
        scope: $scope,
        callback: function(data) {
            var service = _.findWhere($rootScope.resourcebookingservices, {id: data.id});
            $scope.services = $scope.services.filter(function(s) { return s.id != data.id; });
            if (data.active && _.findWhere(data.staffs, {id: currentStaff.id})) {
                $scope.services.unshift(service);
            }
            setServiceButtons();
            loadResourceAllocation();
            loadServices();
        }
    });

    live.subscribe({
        type: 'resourcebooking',
        scope: $scope,
        callback: function() {
            loadResourceAllocation();
            loadServices();
        }
    });

    live.subscribe({
        type: 'workout',
        scope: $scope,
        callback: function() {
            loadResourceAllocation();
            loadServices();
        }
    });

    live.subscribe({
        type: 'workschedule',
        scope: $scope,
        callback: function() {
            loadServices();
        }
    });
}]);

app.controller('PandemicInfoCtrl', ['$scope', '$controller', function($scope, $controller) {
    $scope.skipQuittingConfirmation = true;
    $controller('SettingsCtrl', {$scope: $scope});

    $scope.getUrl = '/api/settings/pandemicinfo/get';
    $scope.postUrl = '/api/settings/pandemicinfo/set';

    $scope.fields = [
        { title: 'Visitor status', type: 'label', readonly: true },
        { name: 'area', title: 'Your total area', required: true, type: 'infoNumber', info: 'square meter' },
        { name: 'averageVisitorTime', title: 'How long do you estimate your visitors will stay?', required: true, type: 'infoNumber', info: 'minutes', value: 60, helpText: 'We calculate the number of visitors on site based on entries and how long you estimate your visitors to stay.', placement: 'right' },
        { hintClass: 'alert-info', hint: 'On the start page, there is now a dashboard called "Visitor status". Go to the start page and select it from the list of dashboards to see your status live.' }
    ];

    $scope.getSettings();
}]);

app.controller('SystemTagSettingsCtrl', ['$rootScope', '$scope', '$modal', function($rootScope, $scope, $modal) {

    $scope.loadingStatus = {};

    var change = function(tag) {
        $modal.open({
            templateUrl: 'views/changemodal.html',
            resolve: { tag: function() { return tag; } },
            controller: ['$scope', '$controller', '$filter', 'tag', function($scope, $controller, $filter, tag) {
                $controller('ChangeModalCtrl', {$scope: $scope});
                $scope.postUrl = '/api/systemtag/change';
                $scope.callCloseOnSuccess = true;
                $scope.item = tag;
                $scope.titleSuffix = function() {
                    return $filter('translate')('tag');
                };

                $scope.fields = [
                    { type: 'alert', class: 'alert-info', value: 'Changes to the tag are applied to all places where the tag is used' },
                    { title: 'Tag', type: 'label', value: tag.name },
                    { name: 'name', title: 'Change to', type: 'text', required: true, value: tag.name }
                ];
            }]
        });
    };

    var remove = function(tag) {
        $scope.loadingStatus[tag.id] = true;

        var stopLoading = function() {
            $scope.loadingStatus[tag.id] = false;
        };

        $modal.open({
            templateUrl: 'views/addmodal.html',
            resolve: { tag: function() { return tag; } },
            controller: ['$scope', 'server', 'tag', function($scope, server, tag) {
                $scope.loadingStatus = {};
                $scope.title = 'Confirm';
                $scope.submitTitle = 'Remove';
                $scope.getButtonClass = function() { return 'btn-danger'; };
                $scope.submit = function() {
                    $scope.loadingStatus.loading = true;
                    server.post('/api/systemtag/remove', null, { id: tag.id }, 'Tag removed successfully', 'Failed to remove tag').then($scope.$close, function() {
                        $scope.loadingStatus.loading = false;
                    });
                };

                $scope.fields = [
                    { title: 'Do you really want to remove the tag?', type: 'label' },
                    { title: 'Tag', type: 'label', value: tag.name },
                    { type: 'alert', class: 'alert-info', value: 'The tag is removed from all activities / products that it is currently being used on. If the tag has been used for historical activities, it will remain there and can thus still be found in statistics and reports.' }
                ];
            }]
        }).result.then(stopLoading, stopLoading);
    };

    var buttonsVisible = function() {
        return $rootScope.hasPermission('System tag handling');
    };

    $scope.config = {
        getItems: function() {
            return $rootScope.systemtags.filter(function(tag) { return !tag.removed; });
        },
        triggers: ['systemtag'],
        countSuffixList: ['tag', 'tags'],
        orderColumn: 'name',
        searchButtons: [
            {title: 'Add tag', onClick: $rootScope.addSystemTag, visible: buttonsVisible, showOnEmpty: true }
        ],
        columns: [
            { field: 'name', title: 'Name' }
        ],
        buttons: [
            { title: 'Change', buttonClass: 'btn-warning', onClick: change, loading: function(tag) { return tag && $scope.loadingStatus[tag.id]; }, visible: buttonsVisible },
            { title: 'Remove', buttonClass: 'btn-danger', onClick: remove, loading: function(tag) { return tag && $scope.loadingStatus[tag.id]; }, visible: buttonsVisible }
        ]
    };
}]);

app.controller('SettingsBlocksCtrl', ['$rootScope', '$scope', '$controller', 'blockutil', function($rootScope, $scope, $controller, blockutil) {
    $controller('SettingsCtrl', {$scope: $scope});

    $scope.getUrl = '/api/settings/block/get';
    $scope.postUrl = '/api/settings/block/set';

    let automaticWarning = () => $scope.fields.find(x => x.name == 'automaticWarning').value
    let automaticDebt = () => $scope.fields.find(x => x.name == 'automaticDebt').value
    $scope.fields = [
        {name: 'automaticWarning', title: 'Automatic block in case of warnings', required: true, type: 'checkbox' },
        {name: 'warningLimit', title: 'Number of warnings before locked', required: true, type: 'number', visible: automaticWarning },
        {name: 'warningDuration', title: 'Temporary ban time', required: true, info: 'days', type: 'infoNumber', visible: automaticWarning },
        {name: 'warningPeriod', title: 'Warnings gets deprecated after', required: true, info: 'days', type: 'infoNumber', visible: automaticWarning },
        {name: 'warningLateCancellations', title: 'Allow late unbookings', required: false, type: 'checkbox', visible: automaticWarning, helpText: 'HELPTEXT_LATECANCEL'},
        {name: 'warningBlocks', title: 'Block from', type: 'multiselect', required: true, useId: true, options: () => blockutil.blocktypes, orderPredicate: blockutil.orderByTranslatedName, visible: automaticWarning},
        {divider: true},
        {name: 'automaticDebt', title: 'Automatic block in case of debt', required: true, type: 'checkbox' },
        {name: 'debtAmount', title: 'Debt exceeds', required: true, type: 'price', visible: automaticDebt },
        {name: 'debtDays', title: 'Debt unpaid for', required: true, info: 'days', type: 'infoNumber', visible: automaticDebt },
        {name: 'debtBlocks', title: 'Block from', type: 'multiselect', required: true, useId: true, options: () => blockutil.blocktypes, orderPredicate: blockutil.orderByTranslatedName, visible: automaticDebt},
        {divider: true},
        {name: 'responsible_is_group', title: 'Responsible is group', type: 'checkbox'},
        {name: 'responsible_staff_id', title: 'Responsible', type: 'customer', itemTypes: ['staff'], visible: () => !$scope.fields.find(x => x.name == 'responsible_is_group').value, useId: true, includeInvisible: true, helpText: 'HELPTEXT_BLOCK_RESPONSIBLE'},
        {name: 'responsible_group_id', title: 'Responsible', type: 'select', options: () => $rootScope.usergroups, visible: () => $scope.fields.find(x => x.name == 'responsible_is_group').value, useId: true, includeInvisible: true, helpText: 'HELPTEXT_BLOCK_RESPONSIBLE'}
    ];
    $scope.fields.forEach(x => x.includeInvisible = true);

    $scope.getSettings();
}]);
